webpackJsonp([15],Array(65).concat([
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generatePDFRechnungToLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__ = __webpack_require__(2);






var generatePDFRechnungToLink = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(item, kasse, bbr, settings, verbindung) {
    var rechnung, doc, pageHeight, pageWidth, marginLeft, zeile, pages, drawHeader, drawFooter, addPage, lines1, i, pos, summe, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, position, totalPages, _i, year, refPath;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            drawHeader = function drawHeader() {
              var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

              doc.setFont("Times");

              if (page === 1) {
                doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
                doc.rect(0, 90, 210, 1, "F");

                doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
                doc.rect(0, 91, 210, 1, "F");

                doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
                doc.rect(0, 92, 210, 1, "F");

                var img = new Image();
                img.src = verbindung === "cp" ? "/static/cp/wappen_256.png" : "/static/wappen_256.png";
                doc.addImage(img, 125, 30, 75, 75);

                doc.setFontSize(9);
                doc.text(settings.name + " | " + settings.strasse + " " + settings.hausnummer + " | " + settings.plz + " " + settings.ort, 25, 51);

                doc.setFontSize(11);
                doc.text("" + bbr.anrede + (bbr.titel ? " " + bbr.titel : ""), 25, 61);
                doc.text((bbr.vorname || "-") + " " + (bbr.nachname || "-"), 25, 66);
                doc.text(bbr.adresse || "-", 25, 71);
                doc.text((bbr.plz || "-") + " " + (bbr.ort || "-"), 25, 76);
                doc.text(bbr.land || "-", 25, 81);

                doc.setFont("Times", "bold");
                doc.text("Rechnungsnr.", 20, 110);
                doc.text("Datum", 70, 110);
                doc.text(rechnung.rechnung_art === "SEPA" ? "Einzug am" : "Zahlbar bis", 120, 110);
                doc.text("Kasse", 170, 110);

                doc.setFont("Times", "normal");
                doc.text(rechnung.rechnungsnummer, 20, 115);
                doc.text(new Date(rechnung.rechnung_datum).toLocaleDateString("de-DE"), 70, 115);
                doc.text(new Date(rechnung.rechnung_zahlbar_bis).toLocaleDateString("de-DE"), 120, 115);
                doc.text(rechnung.kasse, 170, 115);
              } else {
                doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
                doc.rect(0, 30, 210, 1, "F");

                doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
                doc.rect(0, 31, 210, 1, "F");

                doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
                doc.rect(0, 32, 210, 1, "F");

                var _img = new Image();
                _img.src = verbindung === "cp" ? "/static/cp/wappen_256.png" : "/static/wappen_256.png";
                doc.addImage(_img, 160, 8, 37.5, 37.5);
              }
            };

            rechnung = item;
            doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf__["default"]({ orientation: "p", unit: "mm", format: "a4" });
            pageHeight = doc.internal.pageSize.getHeight();
            pageWidth = doc.internal.pageSize.getWidth();
            marginLeft = 20;
            zeile = 130;
            pages = [];

            drawFooter = function drawFooter(page, totalPages) {
              doc.setFontSize(9);
              doc.setTextColor(150);
              if (totalPages > 1) {
                if (page < totalPages) {
                  doc.text("Seite " + page + " von " + totalPages, pageWidth - marginLeft, pageHeight - 25, { align: "right" });
                } else {
                  doc.text("Seite " + page + " von " + totalPages, pageWidth - marginLeft, pageHeight - 35, { align: "right" });
                }
              }
            };

            addPage = function addPage() {
              if (doc.internal.getNumberOfPages() > 0) doc.addPage();
              drawHeader(2);
              zeile = 50;
            };

            drawHeader(1);

            lines1 = doc.splitTextToSize(rechnung.rechnung_freitext, 168);

            for (i = 0; i < lines1.length; i++) {
              if (zeile >= pageHeight - 35) {
                pages.push(doc.internal.getCurrentPageInfo().pageNumber);
                addPage();
              }
              doc.text(lines1[i], marginLeft, zeile);
              zeile += 6;
            }

            zeile += 6;
            doc.setFont("Times", "bold");
            doc.text("Pos", 20, zeile);
            doc.text("Beschreibung", 31, zeile);
            doc.text("Betrag", 190, zeile, { align: "right" });
            zeile += 2;
            doc.setFont("Times", "normal");
            doc.line(20, zeile, 190, zeile);
            zeile += 6;

            pos = 1;
            summe = 0;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 27;


            for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(rechnung.positionen); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              position = _step.value;

              if (zeile >= pageHeight - 30) {
                pages.push(doc.internal.getCurrentPageInfo().pageNumber);
                addPage();
              }
              doc.text(String(pos), 20, zeile);
              doc.text(position.was, 31, zeile);
              doc.text(parseFloat(position.betrag).toFixed(2) + " \u20AC", 190, zeile, { align: "right" });
              summe += parseFloat(position.betrag);
              zeile += 10;
              pos++;
            }

            _context.next = 35;
            break;

          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](27);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 35:
            _context.prev = 35;
            _context.prev = 36;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 38:
            _context.prev = 38;

            if (!_didIteratorError) {
              _context.next = 41;
              break;
            }

            throw _iteratorError;

          case 41:
            return _context.finish(38);

          case 42:
            return _context.finish(35);

          case 43:
            doc.line(20, zeile - 4, 190, zeile - 4);
            doc.setFont("Times", "bold");
            doc.text("Summe " + summe.toFixed(2) + " \u20AC", 190, zeile, { align: "right" });

            doc.setFontSize(10);
            doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
            doc.rect(0, 265, 210, 32, "F");
            doc.setFont("Times", "bold");
            doc.setTextColor(230, 230, 230);
            doc.text(settings.name, 60, 272, { align: "center" });
            doc.setFont("Times", "normal");
            doc.text(rechnung.kasse, 60, 280, { align: "center" });
            doc.text(settings.strasse + " " + settings.hausnummer, 60, 285, { align: "center" });
            doc.text(settings.plz + " " + settings.ort, 60, 290, { align: "center" });
            doc.setFont("Times", "bold");
            doc.text("Bankverbindung", 150, 272, { align: "center" });
            doc.setFont("Times", "normal");
            doc.text(kasse.kontoname, 150, 280, { align: "center" });
            doc.text(kasse.IBAN, 150, 285, { align: "center" });
            doc.text(kasse.BIC, 150, 290, { align: "center" });

            totalPages = doc.internal.getNumberOfPages();

            for (_i = 1; _i <= totalPages; _i++) {
              doc.setPage(_i);
              drawFooter(_i, totalPages);
            }

            console.log("Create PDF Rechnung " + rechnung.rechnungsnummer);
            year = rechnung.rechnungsnummer.split("-")[0];
            refPath = "rechnungen/" + verbindung + "/" + year + "/" + rechnung.rechnungsnummer;
            return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].storage().ref(refPath).put(doc.output("blob")).then(function (snapshot) {
              return snapshot.ref.getDownloadURL();
            }));

          case 68:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[27, 31, 35, 43], [36,, 38, 42]]);
  }));

  return function generatePDFRechnungToLink(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  "data-v-498f9206",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_bbrbbr_alt__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_bearbeitungen_alt__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_bierlieferungen_alt__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dateien_alt__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_couleurstrafen_alt__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dokumente_alt__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_einstellungen_alt__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_getranke_alt__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_getrankeStand_alt__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_kassenbucher_alt__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_kontobucher_alt__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_mails_alt__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_news_alt__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_rechnungen_alt__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_sepa_alt__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_statistiken_alt__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_striche_alt__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_user_alt__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_veranstaltungen_alt__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_verein_alt__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_wirtschaftsplane_alt__ = __webpack_require__(362);

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    bbrbbr: __WEBPACK_IMPORTED_MODULE_2__modules_bbrbbr_alt__["a" /* default */],
    bearbeitungen: __WEBPACK_IMPORTED_MODULE_3__modules_bearbeitungen_alt__["a" /* default */],
    bierlieferungen: __WEBPACK_IMPORTED_MODULE_4__modules_bierlieferungen_alt__["a" /* default */],
    dateien: __WEBPACK_IMPORTED_MODULE_5__modules_dateien_alt__["a" /* default */],
    couleurstrafen: __WEBPACK_IMPORTED_MODULE_6__modules_couleurstrafen_alt__["a" /* default */],
    dokumente: __WEBPACK_IMPORTED_MODULE_7__modules_dokumente_alt__["a" /* default */],
    einstellungen: __WEBPACK_IMPORTED_MODULE_8__modules_einstellungen_alt__["a" /* default */],
    getranke: __WEBPACK_IMPORTED_MODULE_9__modules_getranke_alt__["a" /* default */],
    getrankeStand: __WEBPACK_IMPORTED_MODULE_10__modules_getrankeStand_alt__["a" /* default */],
    kassenbucher: __WEBPACK_IMPORTED_MODULE_11__modules_kassenbucher_alt__["a" /* default */],
    kontobucher: __WEBPACK_IMPORTED_MODULE_12__modules_kontobucher_alt__["a" /* default */],
    mails: __WEBPACK_IMPORTED_MODULE_13__modules_mails_alt__["a" /* default */],
    news: __WEBPACK_IMPORTED_MODULE_14__modules_news_alt__["a" /* default */],
    rechnungen: __WEBPACK_IMPORTED_MODULE_15__modules_rechnungen_alt__["a" /* default */],
    sepa: __WEBPACK_IMPORTED_MODULE_16__modules_sepa_alt__["a" /* default */],
    statistiken: __WEBPACK_IMPORTED_MODULE_17__modules_statistiken_alt__["a" /* default */],
    striche: __WEBPACK_IMPORTED_MODULE_18__modules_striche_alt__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_19__modules_user_alt__["a" /* default */],
    veranstaltungen: __WEBPACK_IMPORTED_MODULE_20__modules_veranstaltungen_alt__["a" /* default */],
    vereine: __WEBPACK_IMPORTED_MODULE_21__modules_verein_alt__["a" /* default */],
    wirtschaftsplane: __WEBPACK_IMPORTED_MODULE_22__modules_wirtschaftsplane_alt__["a" /* default */]
  },
  state: {
    nachricht: {
      titel: '',
      typ: '',
      nachricht: '',
      error: '',
      show: false
    },
    snackbar: {
      show: false,
      nachricht: '123'
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  "data-v-fd613cc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  "data-v-44d43206",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  "data-v-b830ecd6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  "data-v-55ddbfa8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-472e71fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  "data-v-87efbe1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  "data-v-1d4b0236",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  "data-v-3a0499ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  "data-v-088a9384",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  "data-v-cd6572ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  "data-v-39886eac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  "data-v-ccb35ca4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_compat_auth__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_analytics__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_storage__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_compat_functions__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_compat_messaging__ = __webpack_require__(580);








var firebaseConfig = {
  apiKey: 'AIzaSyC6Swg9H5SoioL2ixvT5mgmM9P0blsmUuI',
  authDomain: 'rbo-system.firebaseapp.com',
  databaseURL: 'https://rbo-system.firebaseio.com',
  projectId: 'rbo-system',
  storageBucket: 'rbo-system.appspot.com',
  messagingSenderId: '461253343272',
  appId: '1:461253343272:web:492f4de37341567b',
  measurementId: 'G-VTNQX0EQ1X'
}

__WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].initializeApp(firebaseConfig)

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */]);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value, format) {
  var date = void 0;
  if (value) {
    if (value.seconds) {
      date = new Date(value.seconds * 1000);
    } else {
      date = new Date(new Date(value).getTime());
    }
    if (date) {
      var options = {
        weekday: format.includes("TT") ? "long" : format.includes("T") ? "short" : undefined,
        year: format.includes("YYYY") ? "numeric" : format.includes("YY") ? "2-digit" : undefined,
        month: format.includes("MMM") ? "long" : format.includes("MM") ? "short" : format.includes("M") ? "numeric" : undefined,
        day: format.includes("DD") ? "2-digit" : format.includes("D") ? "numeric" : undefined,
        hour: format.includes("hh") ? "2-digit" : format.includes("h") ? "numeric" : undefined,
        minute: format.includes("mm") ? "2-digit" : format.includes("m") ? "numeric" : undefined,
        second: format.includes("ss") ? "2-digit" : format.includes("s") ? "numeric" : undefined
      };
      return date.toLocaleString("de-DE", options);
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var formatter = Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });

  return formatter.format(value);
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value, bbrbbr) {
  if (value) {
    var bundesbruder = 'Kein Kontakt gefunden';
    var bbr = bbrbbr.find(function (bbr) {
      return bbr.id === value;
    });
    if (bbr) {
      bundesbruder = bbr.nachname + ', ' + bbr.vorname;
    }
    return bundesbruder;
  } else {
    return;
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sumArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentBbr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectLeibvater; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__ = __webpack_require__(2);





var sumArray = function sumArray(obj) {
  if (obj) {
    var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(obj);
    return values.reduce(function (accumulator, currentValue) {
      return accumulator + parseFloat(currentValue);
    }, 0);
  } else {
    return 0;
  }
};

var getCurrentBbr = function getCurrentBbr() {
  var bbr = '';
  if (__WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].auth().currentUser) {
    this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
      if (item.anmeldeID === __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].auth().currentUser.uid) {
        bbr = item.id;
      }
    });
  }
  return bbr;
};

var selectLeibvater = function selectLeibvater() {
  var selectLeibvater = [];
  this.$store.getters['bbrbbr/nurBbrbbr'].forEach(function (bbr) {
    selectLeibvater.push({
      id: bbr.id,
      value: bbr.id,
      name: bbr.nachname + ', ' + bbr.vorname,
      text: bbr.nachname + ', ' + bbr.vorname
    });
  });
  return selectLeibvater;
};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  error: {
    show: false,
    nachricht: '',
    error: ''
  },
  beta: false,
  version: 'v.1.0.33',
  versionDatum: '2023-04-01',
  verbindung: '',
  loading: false,
  settings: {}
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_guard__ = __webpack_require__(340);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/ripuaria",
    redirect: "/"
  }, {
    path: "/",
    name: "Korpodesk",
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 865));
    },
    hash: "main",
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Home"
    }
  }, {
    path: "/sommerfest",
    name: "Sommerfest",
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 871));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Sommerfest"
    }
  }, {
    path: "/event/:id",
    name: "Veranstaltung",
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 868));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Veranstaltung"
    }
  }, {
    path: "/ripuarentage",
    name: "Ripuarentage",
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 870));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Ripuarentage"
    }
  }, {
    path: "/veranstaltungen",
    name: "Veranstaltungen",
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 869));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Veranstaltungen"
    }
  }, {
    path: "/bbrbbr",
    name: "Mitglieder",
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 862));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Mitglieder"
    }
  }, {
    path: "/rechnungen",
    name: "Rechnungen",
    props: true,
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 197));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Rechnungen"
    }
  }, {
    path: "/daten",
    name: "Daten",
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 863));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Daten"
    }
  }, {
    path: "/download",
    name: "Download",
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 864));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Download"
    }
  }, {
    path: "/semester",
    name: "Semester",
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 867));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Semester"
    }
  }, {
    path: "/modul/:seite/:modul",
    name: "Modul",
    props: true,
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 866));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      key: "modul",
      title: function title(route) {
        return "" + route.params.seite;
      }
    }
  }, {
    path: "/stammbaum/home",
    name: "Stammbaum",
    props: true,
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 189));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Stammbaum"
    }
  }, {
    path: "/stammbaum/daten",
    name: "Stammbaum - Daten",
    props: true,
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 188));
    },
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */],
    meta: {
      title: "Stammbaum - Daten"
    }
  }, {
    path: "/registrieren",
    name: "Registrieren",
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 77));
    },
    meta: {
      title: "Registrieren"
    }
  }, {
    path: "/setup",
    name: "Setup",
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 858));
    },
    meta: {
      title: "Setup Verein"
    }
  }, {
    path: "/anmelden",
    name: "Anmelden",
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 77));
    },
    meta: {
      title: "Anmelden"
    }
  }, {
    path: "/passwortvergessen",
    name: "Passwort vergessen",
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 77));
    },
    meta: {
      title: "Passwort vergessen"
    }
  }, {
    path: "/verifizieremail",
    name: "Mailadresse verifizieren",
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 195));
    },
    meta: {
      title: "Mailadresse verifizieren"
    }
  }, {
    path: "/updateMail",
    name: "Mailadresse ändern",
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 194));
    },
    meta: {
      title: "Mailadresse ändern"
    }
  }, {
    path: "/anleitungen",
    name: "Anleitungen",
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 190));
    },
    meta: {
      title: "Anleitungen"
    }
  }],
  mode: "history",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.meta.key === "modul") {
      var pageTitle = to.meta.title(to);
      document.title = "" + (pageTitle || "Korpodesk");
    } else {
      document.title = "" + (to.meta.title || "Korpodesk");
    }
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(807),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  "data-v-aa25d264",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  "data-v-c65f2006",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  "data-v-e532a29e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  "data-v-aa695846",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  "data-v-00ccb0de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  "data-v-3d679d28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  "data-v-445e00a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-7179690c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  "data-v-86f6d84c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(750),
  /* scopeId */
  "data-v-2d2f6cb0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  "data-v-fccf3452",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  "data-v-63664551",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  "data-v-3034763f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-7fbaf873",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  "data-v-bf796ad4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-7982ceb1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  "data-v-0bbdfcbb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  "data-v-7b599a90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(756),
  /* scopeId */
  "data-v-369ac867",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-28701196",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  "data-v-41c30736",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  "data-v-2ea7ea86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(754),
  /* scopeId */
  "data-v-316ede81",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  "data-v-d93701aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  "data-v-105ab2d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  "data-v-4bcdc7d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-55052073",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-82ce9096",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  "data-v-2ce451c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  "data-v-83ee6818",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-3eff6675",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-7d960487",
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  "data-v-05cbc66e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(748),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Stammbaum/Daten.vue": 188,
	"./Stammbaum/Uebersicht.vue": 189,
	"./User/Anleitungen.vue": 190,
	"./User/Signin.vue": 77,
	"./User/SigninCard.vue": 191,
	"./User/SigninForm.vue": 192,
	"./User/SignupForm.vue": 193,
	"./User/UpdateMail.vue": 194,
	"./User/VerifiziereMail.vue": 195,
	"./User/updatePasswordForm.vue": 196,
	"./button/rechnungDownload.vue": 119,
	"./button/rechnungSenden.vue": 120,
	"./card/home/cardHomeBirthday.vue": 707,
	"./card/home/cardHomeKeilliste.vue": 708,
	"./card/test.vue": 709,
	"./navigation/navigationMain.vue": 710,
	"./ui/kontaktfield.vue": 121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 276;

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_editor_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_apexcharts__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mdi_font_css_materialdesignicons_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters_date__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_user__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filters_money__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__module_uebersicht_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__module_uebersicht_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__module_uebersicht_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__module_veranstaltungen_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__module_veranstaltungen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__module_veranstaltungen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__module_todo_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__module_todo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__module_todo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__module_rechnungen_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__module_rechnungen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__module_rechnungen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__module_kassenbuch_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__module_kassenbuch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__module_kassenbuch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__module_kontobuch_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__module_kontobuch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__module_kontobuch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__module_dateien_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__module_dateien_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__module_dateien_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__module_kontakte_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__module_kontakte_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__module_kontakte_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__module_lexikon_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__module_lexikon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__module_lexikon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__module_ahnengalerie_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__module_ahnengalerie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__module_ahnengalerie_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__module_wirtschaftsplan_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__module_wirtschaftsplan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__module_wirtschaftsplan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__module_couleurstrafen_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__module_couleurstrafen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__module_couleurstrafen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__module_mail_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__module_mail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__module_mail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__module_dokumente_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__module_dokumente_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__module_dokumente_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__module_zirkel_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__module_zirkel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__module_zirkel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__module_bierwartBierlieferungen_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__module_bierwartBierlieferungen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__module_bierwartBierlieferungen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__module_bierwartGetranke_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__module_bierwartGetranke_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__module_bierwartGetranke_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__module_bierwartGetrankeZahlen_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__module_bierwartGetrankeZahlen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__module_bierwartGetrankeZahlen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__module_bierwartSchankverlust_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__module_bierwartSchankverlust_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__module_bierwartSchankverlust_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__module_bierwartStriche_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__module_bierwartStriche_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__module_bierwartStriche_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__module_bierwartVeranstaltung_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__module_bierwartVeranstaltung_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__module_bierwartVeranstaltung_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__module_bierwartVeranstaltungAbrechnen_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__module_bierwartVeranstaltungAbrechnen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__module_bierwartVeranstaltungAbrechnen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__module_einstellungenComponents_einstellungen_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__module_einstellungenComponents_einstellungen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__module_einstellungenComponents_einstellungen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__module_submodule_todoSeite_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__module_submodule_todoSeite_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__module_submodule_todoSeite_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__module_submodule_stricheNeu_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__module_submodule_stricheNeu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__module_submodule_stricheNeu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__module_submodule_dialogRechnung_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__module_submodule_dialogRechnung_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__module_submodule_dialogRechnung_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__module_submodule_dialogRechnungenVersenden_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__module_submodule_dialogRechnungenVersenden_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__module_submodule_dialogRechnungenVersenden_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__module_submodule_dialogVeranstaltung_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__module_submodule_dialogVeranstaltung_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__module_submodule_dialogVeranstaltung_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__module_submodule_dialogVeranstaltungEdit_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__module_submodule_dialogVeranstaltungEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__module_submodule_dialogVeranstaltungEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__module_submodule_dialogDelete_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__module_submodule_dialogDelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__module_submodule_dialogDelete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__module_submodule_dialogKontakt_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__module_submodule_dialogKontakt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__module_submodule_dialogKontakt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__module_submodule_dialogKontaktCreate_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__module_submodule_dialogKontaktCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__module_submodule_dialogKontaktCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__module_submodule_dialogKontaktEdit_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__module_submodule_dialogKontaktEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__module_submodule_dialogKontaktEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__module_submodule_dialogKontaktEditMultiple_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__module_submodule_dialogKontaktEditMultiple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__module_submodule_dialogKontaktEditMultiple_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__module_submodule_dialogMail_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__module_submodule_dialogMail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__module_submodule_dialogMail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__module_submodule_dialogMailNeu_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__module_submodule_dialogMailNeu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__module_submodule_dialogMailNeu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__module_submodule_dialogSendKontaktData_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__module_submodule_dialogSendKontaktData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__module_submodule_dialogSendKontaktData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__module_submodule_rechnungenListe_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__module_submodule_rechnungenListe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__module_submodule_rechnungenListe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__module_submodule_rowWirtschaftsplan_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__module_submodule_rowWirtschaftsplan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__module_submodule_rowWirtschaftsplan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__module_klein_chargen_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__module_klein_chargen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__module_klein_chargen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__module_klein_geburtstage_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__module_klein_geburtstage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__module_klein_geburtstage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__module_klein_jubilaum_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__module_klein_jubilaum_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__module_klein_jubilaum_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__module_klein_kontakteStatus_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__module_klein_kontakteStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__module_klein_kontakteStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__module_klein_mailsListe_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__module_klein_mailsListe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__module_klein_mailsListe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__module_klein_rechnungenEigene_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__module_klein_rechnungenEigene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__module_klein_rechnungenEigene_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__module_klein_rechnungenStatus_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__module_klein_rechnungenStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__module_klein_rechnungenStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__module_klein_ripuaren_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__module_klein_ripuaren_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__module_klein_ripuaren_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__module_klein_todosEigene_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__module_klein_todosEigene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__module_klein_todosEigene_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__module_klein_veranstaltungenListe_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__module_klein_veranstaltungenListe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__module_klein_veranstaltungenListe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__module_klein_bundesbruderSuche_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__module_klein_bundesbruderSuche_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__module_klein_bundesbruderSuche_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__module_klein_bundesbruderSucheShort_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__module_klein_bundesbruderSucheShort_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__module_klein_bundesbruderSucheShort_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__module_klein_bierranking_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__module_klein_bierranking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__module_klein_bierranking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__module_klein_schankverlust_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__module_klein_schankverlust_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__module_klein_schankverlust_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__module_klein_rechnungSuche_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__module_klein_rechnungSuche_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__module_klein_rechnungSuche_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__module_klein_keilkandidaten_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__module_klein_keilkandidaten_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__module_klein_keilkandidaten_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_button_rechnungDownload_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_button_rechnungDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_button_rechnungDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_button_rechnungSenden_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_button_rechnungSenden_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_button_rechnungSenden_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_ui_kontaktfield_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_ui_kontaktfield_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_ui_kontaktfield_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__main_funktionen_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__main_variablen_js__ = __webpack_require__(212);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$firebase = __WEBPACK_IMPORTED_MODULE_5__firebase_js__["a" /* default */];












































































var opts = {
  defaults: {
    VBtn: {
      style: "text-transform: none;"
    }
  },
  theme: {
    icons: {
      iconfont: "mdi"
    },
    themes: {
      light: {
        primary: "#254fb3",
        secondary: "#DB1F29",
        accent: "#ce122c" },
      dark: {
        primary: "#254fb3",
        secondary: "#DB1F29",
        accent: "#ce122c" }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_editor_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_jspdf__);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__, {
  load: {
    key: "AIzaSyC6Swg9H5SoioL2ixvT5mgmM9P0blsmUuI",

    region: "DE",
    language: "de"
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("date", __WEBPACK_IMPORTED_MODULE_12__filters_date__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("user", __WEBPACK_IMPORTED_MODULE_13__filters_user__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("money", __WEBPACK_IMPORTED_MODULE_14__filters_money__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("apexchart", __WEBPACK_IMPORTED_MODULE_9_vue_apexcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("einstellungen", __WEBPACK_IMPORTED_MODULE_37__module_einstellungenComponents_einstellungen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("uebersicht", __WEBPACK_IMPORTED_MODULE_15__module_uebersicht_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("veranstaltungen", __WEBPACK_IMPORTED_MODULE_16__module_veranstaltungen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("todo", __WEBPACK_IMPORTED_MODULE_17__module_todo_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("rechnungen", __WEBPACK_IMPORTED_MODULE_18__module_rechnungen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("kassenbuch", __WEBPACK_IMPORTED_MODULE_19__module_kassenbuch_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("kontobuch", __WEBPACK_IMPORTED_MODULE_20__module_kontobuch_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dateien", __WEBPACK_IMPORTED_MODULE_21__module_dateien_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("kontakte", __WEBPACK_IMPORTED_MODULE_22__module_kontakte_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("lexikon", __WEBPACK_IMPORTED_MODULE_23__module_lexikon_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("ahnengalerie", __WEBPACK_IMPORTED_MODULE_24__module_ahnengalerie_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("wirtschaftsplan", __WEBPACK_IMPORTED_MODULE_25__module_wirtschaftsplan_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("couleurstrafen", __WEBPACK_IMPORTED_MODULE_26__module_couleurstrafen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("mail", __WEBPACK_IMPORTED_MODULE_27__module_mail_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dokumente", __WEBPACK_IMPORTED_MODULE_28__module_dokumente_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("zirkel", __WEBPACK_IMPORTED_MODULE_29__module_zirkel_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartBierlieferungen", __WEBPACK_IMPORTED_MODULE_30__module_bierwartBierlieferungen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartGetranke", __WEBPACK_IMPORTED_MODULE_31__module_bierwartGetranke_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartGetrankeZahlen", __WEBPACK_IMPORTED_MODULE_32__module_bierwartGetrankeZahlen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartSchankverlust", __WEBPACK_IMPORTED_MODULE_33__module_bierwartSchankverlust_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartStriche", __WEBPACK_IMPORTED_MODULE_34__module_bierwartStriche_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartVeranstaltung", __WEBPACK_IMPORTED_MODULE_35__module_bierwartVeranstaltung_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierwartVeranstaltungAbrechnen", __WEBPACK_IMPORTED_MODULE_36__module_bierwartVeranstaltungAbrechnen_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("todoSeite", __WEBPACK_IMPORTED_MODULE_38__module_submodule_todoSeite_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("stricheNeu", __WEBPACK_IMPORTED_MODULE_39__module_submodule_stricheNeu_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogRechnung", __WEBPACK_IMPORTED_MODULE_40__module_submodule_dialogRechnung_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogRechnungenVersenden", __WEBPACK_IMPORTED_MODULE_41__module_submodule_dialogRechnungenVersenden_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogVeranstaltung", __WEBPACK_IMPORTED_MODULE_42__module_submodule_dialogVeranstaltung_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogVeranstaltungEdit", __WEBPACK_IMPORTED_MODULE_43__module_submodule_dialogVeranstaltungEdit_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogDelete", __WEBPACK_IMPORTED_MODULE_44__module_submodule_dialogDelete_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogKontakt", __WEBPACK_IMPORTED_MODULE_45__module_submodule_dialogKontakt_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogKontaktCreate", __WEBPACK_IMPORTED_MODULE_46__module_submodule_dialogKontaktCreate_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogKontaktEdit", __WEBPACK_IMPORTED_MODULE_47__module_submodule_dialogKontaktEdit_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogKontaktEditMultiple", __WEBPACK_IMPORTED_MODULE_48__module_submodule_dialogKontaktEditMultiple_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogMail", __WEBPACK_IMPORTED_MODULE_49__module_submodule_dialogMail_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogMailNeu", __WEBPACK_IMPORTED_MODULE_50__module_submodule_dialogMailNeu_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dialogSendKontaktData", __WEBPACK_IMPORTED_MODULE_51__module_submodule_dialogSendKontaktData_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("rechnungen-liste", __WEBPACK_IMPORTED_MODULE_52__module_submodule_rechnungenListe_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("rowWirtschaftsplan", __WEBPACK_IMPORTED_MODULE_53__module_submodule_rowWirtschaftsplan_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("chargen", __WEBPACK_IMPORTED_MODULE_54__module_klein_chargen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("geburtstage", __WEBPACK_IMPORTED_MODULE_55__module_klein_geburtstage_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("jubilaum", __WEBPACK_IMPORTED_MODULE_56__module_klein_jubilaum_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("kontakteStatus", __WEBPACK_IMPORTED_MODULE_57__module_klein_kontakteStatus_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("mailsListe", __WEBPACK_IMPORTED_MODULE_58__module_klein_mailsListe_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("rechnungenEigene", __WEBPACK_IMPORTED_MODULE_59__module_klein_rechnungenEigene_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("rechnungenStatus", __WEBPACK_IMPORTED_MODULE_60__module_klein_rechnungenStatus_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("ripuaren", __WEBPACK_IMPORTED_MODULE_61__module_klein_ripuaren_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("todosEigene", __WEBPACK_IMPORTED_MODULE_62__module_klein_todosEigene_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("veranstaltungenListe", __WEBPACK_IMPORTED_MODULE_63__module_klein_veranstaltungenListe_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bundesbruderSuche", __WEBPACK_IMPORTED_MODULE_64__module_klein_bundesbruderSuche_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bundesbruderSucheShort", __WEBPACK_IMPORTED_MODULE_65__module_klein_bundesbruderSucheShort_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("bierranking", __WEBPACK_IMPORTED_MODULE_66__module_klein_bierranking_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("schankverlust", __WEBPACK_IMPORTED_MODULE_67__module_klein_schankverlust_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("rechnungSuche", __WEBPACK_IMPORTED_MODULE_68__module_klein_rechnungSuche_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("keilkandidaten", __WEBPACK_IMPORTED_MODULE_69__module_klein_keilkandidaten_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("buttonRechnungDownload", __WEBPACK_IMPORTED_MODULE_70__components_button_rechnungDownload_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("buttonRechnungSenden", __WEBPACK_IMPORTED_MODULE_71__components_button_rechnungSenden_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("uiKontaktField", __WEBPACK_IMPORTED_MODULE_72__components_ui_kontaktfield_vue___default.a);

var requireComponent = __webpack_require__(276);

requireComponent.keys().forEach(function (fileName) {
  var componentConfig = requireComponent(fileName);
  var componentName = fileName.split("/").pop().replace(/\.\w+$/, "");

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(componentName, componentConfig.default || componentConfig);
});

window.bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$sumArray = __WEBPACK_IMPORTED_MODULE_73__main_funktionen_js__["a" /* sumArray */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$getCurrentBbr = __WEBPACK_IMPORTED_MODULE_73__main_funktionen_js__["b" /* getCurrentBbr */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$selectLeibvater = __WEBPACK_IMPORTED_MODULE_73__main_funktionen_js__["c" /* selectLeibvater */];


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$vars = __WEBPACK_IMPORTED_MODULE_74__main_variablen_js__["a" /* default */];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  vuetify: new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a(opts),
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__firebase_js__["a" /* default */].auth().onAuthStateChanged(function (user) {
      if (user) {
        if (_this.$vars.beta) {}
        _this.$store.dispatch("user/autoSignIn", user);
      }
      if (__WEBPACK_IMPORTED_MODULE_5__firebase_js__["a" /* default */].auth().currentUser.emailVerified) {
        _this.$store.dispatch("bbrbbr/loadBbrBbr");
        _this.$store.dispatch("bbrbbr/loadEinstellungen");
        _this.$store.dispatch("mails/loadKassen");
        _this.$store.dispatch("mails/loadBbrBbr");
        _this.$store.dispatch("mails/loadVeranstaltungen");
        _this.$store.dispatch("mails/loadEinstellungen");
        _this.$store.dispatch("news/loadNews");
        _this.$store.dispatch("einstellungen/loadEinstellungen");
        _this.$store.dispatch("vereine/loadVereine");
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$messaging = __WEBPACK_IMPORTED_MODULE_5__firebase_js__["a" /* default */].messaging();

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$filters = {
      money: function money(value) {
        var formatter = Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR"
        });
        return formatter.format(value);
      },
      user: function user(contact, contacts) {
        var a = contacts.find(function (item) {
          return item.id === contact;
        });
        return a ? a.nachname + ", " + a.vorname : contact;
      },
      date: function date(value) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "DD.MM.YYYY hh:mm:ss";

        var date = new Date(value);
        if (isNaN(date)) {
          return "-";
        }

        var day = String(date.getDate());
        var month = String(date.getMonth() + 1);
        var year = String(date.getFullYear());
        var shortYear = String(date.getFullYear()).slice(2);

        var hours = String(date.getHours()).padStart(2, "0");
        var minutes = String(date.getMinutes()).padStart(2, "0");
        var seconds = String(date.getSeconds()).padStart(2, "0");

        var weekdaysShort = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
        var weekdaysLong = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
        var monthsShort = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
        var monthsLong = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

        var weekdayIndex = date.getDay();
        var monthIndex = date.getMonth();

        return format.replace("DDDD", weekdaysLong[weekdayIndex]).replace("DDD", weekdaysShort[weekdayIndex]).replace("DD", day.padStart(2, "0")).replace("MMMM", monthsLong[monthIndex]).replace("MMM", monthsShort[monthIndex]).replace("MM", month.padStart(2, "0")).replace("YYYY", year).replace("YY", shortYear).replace("hh", hours).replace("mm", minutes).replace("ss", seconds);
      }
    };
  }
}).$mount("#app");

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_auth__ = __webpack_require__(160);




/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].state.user.user) {
    if (!__WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].auth().currentUser.emailVerified) {
      next('/verifizieremail');
    } else {
      next();
    }
  } else {
    next('/anmelden?link=' + to.path);
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__ = __webpack_require__(2);






var korpodeskApi = {
  request: function request(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _this = this;

    var customHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var responseType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "json";
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var baseUrl, jwtToken, organization, config, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("📡 Korpodesk API Request:", { endpoint: endpoint, method: method, data: data });

              _context.prev = 1;
              baseUrl = void 0;

              if (!window.location.hostname.includes("korpodesk.de")) {
                _context.next = 7;
                break;
              }

              baseUrl = "https://us-central1-korpodesk.cloudfunctions.net";
              _context.next = 13;
              break;

            case 7:
              if (!window.location.hostname.includes("localhost")) {
                _context.next = 11;
                break;
              }

              baseUrl = "https://us-central1-korpodesk.cloudfunctions.net";
              _context.next = 13;
              break;

            case 11:
              console.error("❌ API Fehler: Falsche baseUrl");
              return _context.abrupt("return", {
                data: null,
                error: "❌ API Fehler: Falsche baseUrl"
              });

            case 13:
              _context.next = 15;
              return __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].auth.currentUser.getIdToken();

            case 15:
              jwtToken = _context.sent;
              organization = window.location.hostname.split(".")[0];
              config = {
                method: method,
                url: "" + baseUrl + endpoint,
                headers: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  Authorization: jwtToken ? "Bearer " + jwtToken : "",
                  "Content-Type": "application/json",
                  "x-organization": organization || "default" }, customHeaders),
                data: data,
                responseType: responseType
              };
              _context.next = 20;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_axios__["a" /* default */])(config);

            case 20:
              response = _context.sent;

              if (!(responseType === "blob")) {
                _context.next = 23;
                break;
              }

              return _context.abrupt("return", { data: response.data, error: null });

            case 23:
              console.log("📡 Korpodesk API Response:", response.data);

              if (!response.data.success) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return", {
                data: response.data.data,
                success: response.data.success,
                error: null
              });

            case 28:
              console.warn("⚠ API Warning:", response);
              throw new Error(response.data.message || "Unbekannter Fehler.");

            case 30:
              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](1);

              console.error("❌ API Fehler:", _context.t0);
              return _context.abrupt("return", {
                data: null,
                error: _context.t0.response.data || _context.t0.message
              });

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 32]]);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (korpodeskApi);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  bbrbbr: [],
  einstellungen: [],
  loading: false,
  error: null
};

var getters = {
  bbr: function bbr(state) {
    return function (id) {
      return state.bbrbbr.find(function (bbr) {
        return bbr.id === id;
      });
    };
  },
  bbrStatus: function bbrStatus(state) {
    return function (status) {
      if (status === 'home') {
        return state.bbrbbr;
      } else {
        var items = [];
        state.bbrbbr.forEach(function (bbr) {
          if (bbr.status === status) {
            items.push(bbr);
          }
        });
        return items;
      }
    };
  },
  nurBbrbbr: function nurBbrbbr(state) {
    var bbrbbr = [];
    var allowedStatus = void 0;
    if (state.einstellungen.find(function (item) {
      return item.id === 'mitgliederstatus';
    })) {
      allowedStatus = state.einstellungen.find(function (item) {
        return item.id === 'mitgliederstatus';
      }).status.filter(function (item) {
        return item.mitglied === true;
      }).map(function (item) {
        return item.status;
      });
    }
    if (allowedStatus) {
      state.bbrbbr.forEach(function (bbr) {
        if (allowedStatus.includes(bbr.status)) {
          bbrbbr.push(bbr);
        }
      });
    }
    return bbrbbr;
  },
  nurBbrbbrUndVerstorben: function nurBbrbbrUndVerstorben(state) {
    var bbrbbr = [];
    var allowedStatus = void 0;
    if (state.einstellungen.find(function (item) {
      return item.id === 'mitgliederstatus';
    })) {
      allowedStatus = state.einstellungen.find(function (item) {
        return item.id === 'mitgliederstatus';
      }).status.filter(function (item) {
        return item.mitglied === true;
      }).map(function (item) {
        return item.status;
      });
    }
    if (allowedStatus) {
      state.bbrbbr.forEach(function (bbr) {
        if (allowedStatus.includes(bbr.status) || bbr.status === 'Verstorben') {
          bbrbbr.push(bbr);
        }
      });
    }
    return bbrbbr;
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadBbrBbr: function loadBbrBbr(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Bundesbrüder laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontakte').orderBy('nachname').onSnapshot(function (snapshot) {
      var bbrbbr = [];
      snapshot.forEach(function (doc) {
        if (!doc.data().delete) {
          bbrbbr.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        }
        commit('setLoadedBbrBbr', bbrbbr);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createBbr: function createBbr(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontakte').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteBbrData: function deleteBbrData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontakte').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteBbr', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateBbrData: function updateBbrData(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state;

    console.log(payload);
    commit('setLoading', true);
    payload.zuletztGeaendertVon = state.bbrbbr.find(function (bbr) {
      return bbr.anmeldeID === __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].auth().currentUser.uid;
    }).id;
    payload.zuletztGeaendertAm = new Date().toISOString();
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontakte').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  loadEinstellungen: function loadEinstellungen(_ref5) {
    var commit = _ref5.commit;

    commit('setLoading', true);
    console.log('Einstellungen laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('einstellungen').onSnapshot(function (snapshot) {
      var einstellungen = [];
      snapshot.forEach(function (doc) {
        einstellungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedEinstellungen', einstellungen);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedBbrBbr: function setLoadedBbrBbr(state, payload) {
    state.bbrbbr = payload;
  },
  createBbr: function createBbr(state, payload) {
    state.bbrbbr.push(payload);
  },
  updateBbr: function updateBbr(state, payload) {
    var bbr = state.bbrbbr.find(function (bbr) {
      return bbr.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        bbr[key] = payload[key];
      }
    });
  },
  deleteBbr: function deleteBbr(state, payload) {
    var array = state.bbrbbr;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.bbrbbr = array;
  },
  setLoadedEinstellungen: function setLoadedEinstellungen(state, payload) {
    state.einstellungen = payload;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  bearbeitungen: [],
  loading: false,
  error: null
};

var getters = {
  bearbeitung: function bearbeitung(state) {
    return function (id) {
      return state.bearbeitungen.find(function (bearbeitung) {
        return bearbeitung.id === id;
      });
    };
  },
  bearbeitungVonBbr: function bearbeitungVonBbr(state) {
    return function (elementId) {
      var items = [];
      state.bearbeitungen.forEach(function (bearbeitung) {
        if (bearbeitung.elementId === elementId) {
          items.push(bearbeitung);
        }
      });
      return items;
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadBearbeitungen: function loadBearbeitungen(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Bearbeitungen laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bearbeitungen').orderBy('datum', 'desc').onSnapshot(function (snapshot) {
      var bearbeitungen = [];
      snapshot.forEach(function (doc) {
        if (!doc.data().delete) {
          bearbeitungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        }
        commit('setLoadedBearbeitungen', bearbeitungen);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createBearbeitung: function createBearbeitung(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bearbeitungen').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteBearbeitungData: function deleteBearbeitungData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bearbeitungen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteBearbeitung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateBearbeitungData: function updateBearbeitungData(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bearbeitungen').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedBearbeitungen: function setLoadedBearbeitungen(state, payload) {
    state.bearbeitungen = payload;
  },
  createBearbeitung: function createBearbeitung(state, payload) {
    state.bearbeitungen.push(payload);
  },
  updateBearbeitung: function updateBearbeitung(state, payload) {
    var bearbeitung = state.bearbeitungen.find(function (bearbeitung) {
      return bearbeitung.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        bearbeitung[key] = payload[key];
      }
    });
  },
  deleteBearbeitung: function deleteBearbeitung(state, payload) {
    var array = state.bearbeitungen;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.bearbeitungen = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  bierlieferungen: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  bierlieferungen: function bierlieferungen(state) {
    return state.bierlieferungen;
  },

  bierlieferung: function bierlieferung(state) {
    return function (id) {
      return state.bierlieferungen.find(function (bierlieferung) {
        return bierlieferung.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadBierlieferungen: function loadBierlieferungen(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Bierlieferungen laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bierlieferungen').orderBy('datum', 'desc').onSnapshot(function (snapshot) {
      var bierlieferungen = [];
      snapshot.forEach(function (doc) {
        bierlieferungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedBierlieferungen', bierlieferungen);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createBierlieferung: function createBierlieferung(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bierlieferungen').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteBierlieferungData: function deleteBierlieferungData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bierlieferungen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteBierlieferung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateBierlieferungData: function updateBierlieferungData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('bierlieferungen').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateBierlieferung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedBierlieferungen: function setLoadedBierlieferungen(state, payload) {
    state.bierlieferungen = payload;
  },
  createBierlieferung: function createBierlieferung(state, payload) {
    state.bierlieferungen.push(payload);
  },
  updateBierlieferung: function updateBierlieferung(state, payload) {
    var bierlieferung = state.bierlieferungen.find(function (bierlieferung) {
      return bierlieferung.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        bierlieferung[key] = payload[key];
      }
    });
  },
  deleteBierlieferung: function deleteBierlieferung(state, payload) {
    var array = state.bierlieferungen;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.bierlieferungen = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  couleurstrafen: [],
  loading: false,
  error: null
};

var getters = {
  couleurstrafen: function couleurstrafen(state) {
    return state.couleurstrafen;
  },

  couleurstrafenKasse: function couleurstrafenKasse(state) {
    return function (kasse) {
      var couleurstrafen = [];
      state.couleurstrafen.forEach(function (couleurstraf) {
        if (couleurstraf.kasse === kasse) {
          couleurstrafen.push(couleurstraf);
        }
      });
      return couleurstrafen;
    };
  },
  couleurstraf: function couleurstraf(state) {
    return function (id) {
      return state.couleurstrafen.find(function (couleurstraf) {
        return couleurstraf.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadCouleurstrafen: function loadCouleurstrafen(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Couleurstrafen laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('couleurstrafen').orderBy('datum', 'desc').get().then(function (snapshot) {
      var couleurstrafen = [];
      snapshot.forEach(function (doc) {
        couleurstrafen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedCouleurstrafen', couleurstrafen);
        commit('setLoading', false);
      });
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createCouleurstraf: function createCouleurstraf(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('couleurstrafen').add(payload).then(function (key) {
      commit('createCouleurstraf', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
        id: key.id
      }));
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteCouleurstrafData: function deleteCouleurstrafData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('couleurstrafen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteCouleurstraf', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateCouleurstrafData: function updateCouleurstrafData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('couleurstrafen').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateCouleurstraf', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedCouleurstrafen: function setLoadedCouleurstrafen(state, payload) {
    state.couleurstrafen = payload;
  },
  createCouleurstraf: function createCouleurstraf(state, payload) {
    state.couleurstrafen.push(payload);
  },
  updateCouleurstraf: function updateCouleurstraf(state, payload) {
    var couleurstraf = state.couleurstrafen.find(function (couleurstraf) {
      return couleurstraf.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        couleurstraf[key] = payload[key];
      }
    });
  },
  deleteCouleurstraf: function deleteCouleurstraf(state, payload) {
    var array = state.couleurstrafen;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.couleurstrafen = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  dateien: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  dateien: function dateien(state) {
    return state.dateien;
  },

  datei: function datei(state) {
    return function (id) {
      return state.dateien.find(function (datei) {
        return datei.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadDateien: function loadDateien(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Dateien laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dateien').onSnapshot(function (snapshot) {
      var dateien = [];
      snapshot.forEach(function (doc) {
        if (!doc.data().delete) {
          dateien.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        }
        commit('setLoadedDateien', dateien);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createDatei: function createDatei(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dateien').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteDateiData: function deleteDateiData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dateien').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteDatei', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateDateiData: function updateDateiData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dateien').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateDatei', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedDateien: function setLoadedDateien(state, payload) {
    state.dateien = payload;
  },
  createDatei: function createDatei(state, payload) {
    state.dateien.push(payload);
  },
  updateDatei: function updateDatei(state, payload) {
    var datei = state.dateien.find(function (datei) {
      return datei.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        datei[key] = payload[key];
      }
    });
  },
  deleteDatei: function deleteDatei(state, payload) {
    var array = state.dateien;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.dateien = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  dokumente: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  dokumente: function dokumente(state) {
    return state.dokumente;
  },

  dokument: function dokument(state) {
    return function (id) {
      return state.dokumente.find(function (dokument) {
        return dokument.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadDokumente: function loadDokumente(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Dokumente laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dokumente').onSnapshot(function (snapshot) {
      var dokumente = [];
      snapshot.forEach(function (doc) {
        if (!doc.data().delete) {
          dokumente.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        }
        commit('setLoadedDokumente', dokumente);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createDokument: function createDokument(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dokumente').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteDokumentData: function deleteDokumentData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dokumente').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteDokument', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateDokumentData: function updateDokumentData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('dokumente').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateDokument', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedDokumente: function setLoadedDokumente(state, payload) {
    state.dokumente = payload;
  },
  createDokument: function createDokument(state, payload) {
    state.dokumente.push(payload);
  },
  updateDokument: function updateDokument(state, payload) {
    var dokument = state.dokumente.find(function (dokument) {
      return dokument.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        dokument[key] = payload[key];
      }
    });
  },
  deleteDokument: function deleteDokument(state, payload) {
    var array = state.dokumente;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.dokumente = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(4);








var state = {
  einstellungen: [],
  loading: false,
  error: null
};

var getters = {
  einstellungen: function einstellungen(state) {
    return state.einstellungen;
  },

  einstellung: function einstellung(state) {
    return function (value) {
      switch (value) {
        case 'kalender':
          var kalender = state.einstellungen.find(function (einstellung) {
            return einstellung.id === 'kalender';
          });
          if (kalender) {
            kalender = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(kalender);
            kalender = kalender.filter(function (kal) {
              return kal.isPublic === true;
            });
          }
          return kalender;

        case 'alleKalender':
          var _state$einstellungen$ = state.einstellungen.find(function (einstellung) {
            return einstellung.id === 'kalender';
          }),
              id = _state$einstellungen$.id,
              kalenderOhneId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_state$einstellungen$, ['id']);

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(kalenderOhneId);

        default:
          return state.einstellungen.find(function (einstellung) {
            return einstellung.id === value;
          });
      }
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadEinstellungen: function loadEinstellungen(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Einstellungen laden...');
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$vars.verbindung).collection('einstellungen').onSnapshot(function (snapshot) {
      var einstellungen = [];
      snapshot.forEach(function (doc) {
        einstellungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedEinstellungen', einstellungen);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createEinstellung: function createEinstellung(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$vars.verbindung).collection('einstellungen').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteEinstellungData: function deleteEinstellungData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$vars.verbindung).collection('einstellungen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteEinstellung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateEinstellungData: function updateEinstellungData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$vars.verbindung).collection('einstellungen').doc(payload.id).update(payload).then(function () {
      commit('setLoading', false);
      commit('updateEinstellung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedEinstellungen: function setLoadedEinstellungen(state, payload) {
    state.einstellungen = payload;
  },
  createEinstellung: function createEinstellung(state, payload) {
    state.einstellungen.push(payload);
  },
  updateEinstellung: function updateEinstellung(state, payload) {
    var einstellung = state.einstellungen.find(function (einstellung) {
      return einstellung.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        einstellung[key] = payload[key];
      }
    });
  },
  deleteEinstellung: function deleteEinstellung(state, payload) {
    var array = state.einstellungen;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.einstellungen = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  getrankeStande: [],
  loading: false,
  error: null
};

var getters = {
  getrankeStande: function getrankeStande(state) {
    return state.getrankeStande;
  },

  getrankeStand: function getrankeStand(state) {
    return function (id) {
      return state.getrankeStande.find(function (getrankeStand) {
        return getrankeStand.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadGetrankeStande: function loadGetrankeStande(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Getränkestände laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke_zahlen').orderBy('datum', 'desc').onSnapshot(function (snapshot) {
      var getrankeStande = [];
      snapshot.forEach(function (doc) {
        getrankeStande.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedGetrankeStande', getrankeStande);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createGetrankeStand: function createGetrankeStand(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke_zahlen').add(payload).then(function (key) {
      commit('createGetrankeStand', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
        id: key.id
      }));
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteGetrankeStandeData: function deleteGetrankeStandeData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke_zahlen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteGetrankeStand', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateGetrankeStandData: function updateGetrankeStandData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke_zahlen').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateGetrankeStand', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedGetrankeStande: function setLoadedGetrankeStande(state, payload) {
    state.getrankeStande = payload;
  },
  createGetrankeStand: function createGetrankeStand(state, payload) {
    state.getrankeStande.push(payload);
  },
  updateGetrankeStand: function updateGetrankeStand(state, payload) {
    var getrankeStand = state.getrankeStande.find(function (getrankeStand) {
      return getrankeStand.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        getrankeStand[key] = payload[key];
      }
    });
  },
  deleteGetrankeStand: function deleteGetrankeStand(state, payload) {
    var array = state.getrankeStande;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.getrankeStande = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  getranke: [],
  loaded: false,
  loading: false,
  error: null
};

var getters = {
  getranke: function getranke(state) {
    return state.getranke;
  },

  getrank: function getrank(state) {
    return function (id) {
      return state.getranke.find(function (getrank) {
        return getrank.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadGetranke: function loadGetranke(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Getränke laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke').orderBy('bezeichnung').get().then(function (snapshot) {
      var getranke = [];
      snapshot.forEach(function (doc) {
        if (!doc.data().delete) {
          getranke.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        }
        commit('setLoadedGetranke', getranke);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createGetrank: function createGetrank(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteGetrankData: function deleteGetrankData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteGetrank', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateGetrankData: function updateGetrankData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('getranke').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateGetrank', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedGetranke: function setLoadedGetranke(state, payload) {
    state.getranke = payload;
  },
  createGetrank: function createGetrank(state, payload) {
    state.getranke.push(payload);
  },
  updateGetrank: function updateGetrank(state, payload) {
    var getrank = state.getranke.find(function (getrank) {
      return getrank.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        getrank[key] = payload[key];
      }
    });
  },
  deleteGetrank: function deleteGetrank(state, payload) {
    var array = state.getranke;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.getranke = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  kassenbucher: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  kassenbucher: function kassenbucher(state) {
    return state.kassenbucher;
  },

  kassenbucherKasse: function kassenbucherKasse(state) {
    return function (kasse) {
      var kassenbucher = [];
      state.kassenbucher.forEach(function (kassenbuch) {
        if (kassenbuch.kasse === kasse) {
          kassenbucher.push(kassenbuch);
        }
      });
      return kassenbucher;
    };
  },
  kassenbuch: function kassenbuch(state) {
    return function (id) {
      return state.kassenbucher.find(function (kassenbuch) {
        return kassenbuch.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadKassenbucher: function loadKassenbucher(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Kassenbücher laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kassenbucher').orderBy('datum', 'desc').onSnapshot(function (snapshot) {
      var kassenbucher = [];
      snapshot.forEach(function (doc) {
        kassenbucher.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedKassenbucher', kassenbucher);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createKassenbuch: function createKassenbuch(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kassenbucher').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteKassenbuchData: function deleteKassenbuchData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kassenbucher').doc(payload).delete().catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateKassenbuchData: function updateKassenbuchData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kassenbucher').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateKassenbuch', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedKassenbucher: function setLoadedKassenbucher(state, payload) {
    state.kassenbucher = payload;
  },
  createKassenbuch: function createKassenbuch(state, payload) {
    state.kassenbucher.push(payload);
  },
  updateKassenbuch: function updateKassenbuch(state, payload) {
    var kassenbuch = state.kassenbucher.find(function (kassenbuch) {
      return kassenbuch.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        kassenbuch[key] = payload[key];
      }
    });
  },
  deleteKassenbuch: function deleteKassenbuch(state, payload) {
    var array = state.kassenbucher;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.kassenbucher = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  kontobucher: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  kontobucher: function kontobucher(state) {
    return state.kontobucher;
  },

  kontobucherKasse: function kontobucherKasse(state) {
    return function (kasse) {
      var kontobucher = [];
      state.kontobucher.forEach(function (kontobuch) {
        if (kontobuch.kasse === kasse) {
          kontobucher.push(kontobuch);
        }
      });
      return kontobucher;
    };
  },
  kontobuch: function kontobuch(state) {
    return function (id) {
      return state.kontobucher.find(function (kontobuch) {
        return kontobuch.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadKontobucher: function loadKontobucher(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Kontobücher laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontobucher').onSnapshot(function (snapshot) {
      var kontobucher = [];
      snapshot.forEach(function (doc) {
        kontobucher.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedKontobucher', kontobucher);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createKontobuch: function createKontobuch(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontobucher').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteKontobuchData: function deleteKontobuchData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontobucher').doc(payload).delete().catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateKontobuchData: function updateKontobuchData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('kontobucher').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateKontobuch', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedKontobucher: function setLoadedKontobucher(state, payload) {
    state.kontobucher = payload;
  },
  createKontobuch: function createKontobuch(state, payload) {
    state.kontobucher.push(payload);
  },
  updateKontobuch: function updateKontobuch(state, payload) {
    var kontobuch = state.kontobucher.find(function (kontobuch) {
      return kontobuch.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        kontobuch[key] = payload[key];
      }
    });
  },
  deleteKontobuch: function deleteKontobuch(state, payload) {
    var array = state.kontobucher;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.kontobucher = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funktionen_generatePDFRechnungToLink_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(4);









var state = {
  mails: [],
  kassen: [],
  veranstaltungen: [],
  bbrbbr: [],
  einstellungen: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  mails: function mails(state) {
    return state.mails;
  },

  eigeneMails: function eigeneMails(state) {
    return function (id) {
      var items = [];
      state.mails.forEach(function (item) {
        if (item.an) {
          if (item.an.indexOf(id) !== -1) {
            if (items.indexOf(item) === -1) {
              items.push(item);
            }
          }
        }
        if (item.an_cc) {
          if (item.an_cc.indexOf(id) !== -1) {
            if (items.indexOf(item) === -1) {
              items.push(item);
            }
          }
        }
        if (item.an_bcc) {
          if (item.an_bcc.indexOf(id) !== -1) {
            if (items.indexOf(item) === -1) {
              items.push(item);
            }
          }
        }
        if (item.an_gruppen) {
          if (item.an_gruppen.indexOf(id) !== -1) {
            if (items.indexOf(item) === -1) {
              items.push(item);
            }
          }
        }
      });
      return items;
    };
  },
  gesendeteMails: function gesendeteMails(state) {
    return function (id) {
      var items = [];
      state.mails.forEach(function (item) {
        if (item.von) {
          if (item.von.indexOf(id) !== -1) {
            items.push(item);
          }
        }
      });
      return items;
    };
  },
  entwurfAndErrorMails: function entwurfAndErrorMails(state) {
    return state.mails.filter(function (item) {
      return item.status === "Entwurf" || item.status === "Error";
    });
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadMails: function loadMails(_ref) {
    var commit = _ref.commit;

    commit("setLoading", true);
    console.log("Mails laden...");
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("mails").orderBy("datum", "desc").onSnapshot(function (snapshot) {
      var mails = [];
      snapshot.forEach(function (doc) {
        mails.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit("setLoadedMails", mails);
        commit("setLoading", false);
        commit("setLoaded", true);
      });
    }, function (error) {
      console.log(error);
      commit("setLoading", false);
    });
  },
  loadKassen: function loadKassen(_ref2) {
    var commit = _ref2.commit;

    commit("setLoading", true);
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("einstellungen").doc("kassen").get().then(function (doc) {
      if (doc.exists) {
        commit("setLoadedKassen", doc.data());
        commit("setLoading", false);
      } else {
        console.log("No such document!");
      }
    }).catch(function (error) {
      console.log("Error getting document:", error);
      commit("setLoading", false);
    });
  },
  loadBbrBbr: function loadBbrBbr(_ref3) {
    var commit = _ref3.commit;

    commit("setLoading", true);
    console.log("Bundesbrüder laden...");
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("kontakte").orderBy("nachname").onSnapshot(function (snapshot) {
      var bbrbbr = [];
      snapshot.forEach(function (doc) {
        if (!doc.data().delete) {
          bbrbbr.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        }
        commit("setLoadedBbrBbr", bbrbbr);
        commit("setLoading", false);
      });
    }, function (error) {
      console.log(error);
      commit("setLoading", false);
    });
  },
  loadEinstellungen: function loadEinstellungen(_ref4) {
    var commit = _ref4.commit;

    commit("setLoading", true);
    console.log("Mails/Einstellungen laden...");
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("einstellungen").onSnapshot(function (snapshot) {
      var einstellungen = [];
      snapshot.forEach(function (doc) {
        einstellungen.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit("setLoadedEinstellungen", einstellungen);
        commit("setLoading", false);
      });
    }, function (error) {
      console.log(error);
      commit("setLoading", false);
    });
  },
  loadVeranstaltungen: function loadVeranstaltungen(_ref5) {
    var commit = _ref5.commit;

    commit("setLoading", true);
    var today = new Date().toISOString().substr(0, 10);
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("veranstaltungen").where("vonDatum", ">=", today).orderBy("vonDatum", "asc").limit(3).onSnapshot(function (snapshot) {
      var veranstaltungen = [];
      snapshot.forEach(function (doc) {
        veranstaltungen.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit("setLoadedVeranstaltungen", veranstaltungen);
        commit("setLoading", false);
      });
    }, function (error) {
      console.log(error);
      commit("setLoading", false);
    });
  },
  createEinMails: function createEinMails(_ref6, payload) {
    var _this = this;

    var commit = _ref6.commit,
        getters = _ref6.getters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var html, settings, veranstaltung1, veranstaltung2, veranstaltung3, veranstaltungen, kasse, bbr, positionsliste, nummer, _veranstaltung, _veranstaltung2, _veranstaltung3, _veranstaltungen, url;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              html = void 0;
              settings = state.einstellungen.find(function (item) {
                return item.id === "allgemein";
              });

              if (payload.art === "mail") {
                payload.from = payload.absender.position;
                if (payload.template) {
                  html = payload.template;
                } else {
                  html = payload.message.text;
                }
                html = html.replace(/<<nachricht.inhalt>>/g, payload.message.text);
                html = html.replace(/<<nachricht.titel>>/g, payload.message.subject);
                html = html.replace(/<<nachricht.datum>>/g, new Date(payload.datum).toISOString());
                html = html.replace(/<<absender.vorname>>/g, payload.absender.vorname);
                html = html.replace(/<<absender.nachname>>/g, payload.absender.nachname);
                html = html.replace(/<<absender.name>>/g, payload.absender.vorname + " " + payload.absender.nachname);
                html = html.replace(/<<absender.adresse>>/g, payload.absender.adresse);
                html = html.replace(/<<absender.plz>>/g, payload.absender.plz);
                html = html.replace(/<<absender.ort>>/g, payload.absender.ort);
                html = html.replace(/<<absender.email>>/g, payload.absender.email);
                html = html.replace(/<<absender.handy>>/g, payload.absender.handy);
                html = html.replace(/<<absender.telefon>>/g, payload.absender.telefon);
                html = html.replace(/<<absender.position>>/g, payload.absender.position);
                veranstaltung1 = void 0;
                veranstaltung2 = void 0;
                veranstaltung3 = void 0;

                if (state.veranstaltungen.length > 0) {
                  veranstaltung1 = state.veranstaltungen[0].vonDatum.substr(8, 2) + "." + state.veranstaltungen[0].vonDatum.substr(5, 2) + ". " + state.veranstaltungen[0].titel;
                } else {
                  veranstaltung1 = "";
                }
                if (state.veranstaltungen.length > 1) {
                  veranstaltung2 = state.veranstaltungen[1].vonDatum.substr(8, 2) + "." + state.veranstaltungen[1].vonDatum.substr(5, 2) + ". " + state.veranstaltungen[1].titel;
                } else {
                  veranstaltung2 = "";
                }
                if (state.veranstaltungen.length > 2) {
                  veranstaltung3 = state.veranstaltungen[2].vonDatum.substr(8, 2) + "." + state.veranstaltungen[2].vonDatum.substr(5, 2) + ". " + state.veranstaltungen[2].titel;
                } else {
                  veranstaltung3 = "";
                }
                veranstaltungen = "<h4>Veranstaltungen</h4>" + veranstaltung1 + "<br>" + veranstaltung2 + "<br>" + veranstaltung3 + "<br>";

                html = html.replace("<<Veranstaltungen>>", veranstaltungen);
              }

              if (!(payload.art === "rechnung")) {
                _context.next = 42;
                break;
              }

              kasse = state.kassen[payload.rechnung.kasse];
              bbr = state.bbrbbr.find(function (bbr) {
                return bbr.id === payload.rechnung.bbrID;
              });

              payload.from = kasse.absender;
              if (kasse.template) {
                html = kasse.template;
              } else {
                html = payload.message.text;
              }
              positionsliste = "";
              nummer = 1;

              payload.rechnung.positionen.forEach(function (position) {
                positionsliste = positionsliste + '<tr style="height: 36px;">';
                positionsliste = positionsliste + '<td style="border-bottom: 1px solid black; text-align:center;">';
                positionsliste = positionsliste + nummer;
                positionsliste = positionsliste + '</td><td style="border-bottom: 1px solid black;">';
                positionsliste = positionsliste + position.was;
                positionsliste = positionsliste + '</td><td style="border-bottom: 1px solid black;text-align:right;">';
                if (typeof position.betrag === "string") {
                  positionsliste = positionsliste + parseFloat(position.betrag.replace(",", ".")).toFixed(2);
                } else {
                  positionsliste = positionsliste + parseFloat(position.betrag).toFixed(2);
                }
                positionsliste = positionsliste + " €</td></tr>";
                nummer = nummer + 1;
              });
              html = html.replace(/<<nachricht.inhalt>>/g, payload.message.text);
              html = html.replace(/<<nachricht.titel>>/g, payload.message.subject);
              html = html.replace(/<<nachricht.datum>>/g, new Date(payload.datum).toISOString());
              html = html.replace(/<<absender.vorname>>/g, payload.absender.vorname);
              html = html.replace(/<<absender.nachname>>/g, payload.absender.nachname);
              html = html.replace(/<<absender.name>>/g, payload.absender.name);
              html = html.replace(/<<absender.adresse>>/g, payload.absender.adresse);
              html = html.replace(/<<absender.plz>>/g, payload.absender.plz);
              html = html.replace(/<<absender.ort>>/g, payload.absender.ort);
              html = html.replace(/<<absender.email>>/g, payload.absender.email);
              html = html.replace(/<<absender.handy>>/g, payload.absender.handy);
              html = html.replace(/<<absender.telefon>>/g, payload.absender.telefon);
              html = html.replace(/<<absender.position>>/g, payload.absender.position);
              html = html.replace(/<<positionsliste>>/g, positionsliste);
              html = html.replace(/<<summe>>/g, parseFloat(payload.rechnung.summe).toFixed(2));
              html = html.replace(/<<kasse.kontoname>>/g, kasse.kontoname);
              html = html.replace(/<<kasse.bank>>/g, kasse.bank);
              html = html.replace(/<<kasse.iban>>/g, kasse.IBAN);
              html = html.replace(/<<kasse.bic>>/g, kasse.BIC);
              _veranstaltung = void 0;
              _veranstaltung2 = void 0;
              _veranstaltung3 = void 0;

              if (state.veranstaltungen.length > 0) {
                _veranstaltung = state.veranstaltungen[0].vonDatum.substr(8, 2) + "." + state.veranstaltungen[0].vonDatum.substr(5, 2) + ". " + state.veranstaltungen[0].titel;
              } else {
                _veranstaltung = "";
              }
              if (state.veranstaltungen.length > 1) {
                _veranstaltung2 = state.veranstaltungen[1].vonDatum.substr(8, 2) + "." + state.veranstaltungen[1].vonDatum.substr(5, 2) + ". " + state.veranstaltungen[1].titel;
              } else {
                _veranstaltung2 = "";
              }
              if (state.veranstaltungen.length > 2) {
                _veranstaltung3 = state.veranstaltungen[2].vonDatum.substr(8, 2) + "." + state.veranstaltungen[2].vonDatum.substr(5, 2) + ". " + state.veranstaltungen[2].titel;
              } else {
                _veranstaltung3 = "";
              }
              _veranstaltungen = "<h4>Veranstaltungen</h4>" + _veranstaltung + "<br>" + _veranstaltung2 + "<br>" + _veranstaltung3 + "<br>";

              html = html.replace("<<Veranstaltungen>>", _veranstaltungen);
              _context.next = 40;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__funktionen_generatePDFRechnungToLink_js__["a" /* generatePDFRechnungToLink */])(payload.rechnung, kasse, bbr, settings, __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung);

            case 40:
              url = _context.sent;

              payload.attachments = [{
                filename: payload.rechnung.rechnungsnummer + ".pdf",
                path: url
              }];

            case 42:
              if (payload.absender.position === null) {
                payload.absender.position = "";
              }
              payload.message.html = html;
              payload.log = [{
                status: "Postausgang",
                time: new Date()
              }];
              console.log(payload);

              __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("mails").add(payload).then(function () {
                console.log("Queued email for delivery!");
              }).catch(function (error) {
                console.error("An error occurred:", error);
              });

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  deleteEinMailsData: function deleteEinMailsData(_ref7, payload) {
    var commit = _ref7.commit;

    commit("setLoading", true);
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("mails").doc(payload).delete().then(function () {
      commit("setLoading", false);
      commit("deleteEinMails", payload);
    }).catch(function (error) {
      console.log(error);
      commit("setLoading", false);
    });
    commit("setLoading", false);
  },
  updateEinMailsData: function updateEinMailsData(_ref8, payload) {
    var commit = _ref8.commit;

    commit("setLoading", true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_4_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$vars.verbindung).collection("mails").doc(payload.id).update(updateObj).then(function () {
      commit("setLoading", false);
      commit("updateEinMails", payload);
    }).catch(function (error) {
      console.log(error);
      commit("setLoading", false);
    });
  }
};

var mutations = {
  setLoadedMails: function setLoadedMails(state, payload) {
    state.mails = payload;
  },
  setLoadedKassen: function setLoadedKassen(state, payload) {
    state.kassen = payload;
  },
  setLoadedEinstellungen: function setLoadedEinstellungen(state, payload) {
    state.einstellungen = payload;
  },
  setLoadedVeranstaltungen: function setLoadedVeranstaltungen(state, payload) {
    state.veranstaltungen = payload;
  },
  setLoadedBbrBbr: function setLoadedBbrBbr(state, payload) {
    state.bbrbbr = payload;
  },
  createEinMails: function createEinMails(state, payload) {
    state.mails.push(payload);
  },
  updateEinMails: function updateEinMails(state, payload) {
    var einMails = state.mails.find(function (einMails) {
      return einMails.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        einMails[key] = payload[key];
      }
    });
  },
  deleteEinMails: function deleteEinMails(state, payload) {
    var array = state.mails;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.mails = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  news: [],
  loading: false,
  error: null
};

var getters = {
  news: function news(state) {
    return state.news;
  },

  eigeneNews: function eigeneNews(state) {
    return function (id) {
      var items = [];
      state.news.forEach(function (item) {
        if (item.an) {
          if (item.an.indexOf(id) !== -1) {
            items.push(item);
          }
        }
        if (item.cc) {
          if (item.cc.indexOf(id) !== -1) {
            items.push(item);
          }
        }
        if (item.bcc) {
          if (item.bcc.indexOf(id) !== -1) {
            items.push(item);
          }
        }
      });
      return items;
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadNews: function loadNews(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('News laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('news').orderBy('datum', 'desc').onSnapshot(function (snapshot) {
      var news = [];
      snapshot.forEach(function (doc) {
        news.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedNews', news);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createEinNews: function createEinNews(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('news').add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteEinNewsData: function deleteEinNewsData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('news').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteEinNews', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateEinNewsData: function updateEinNewsData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('news').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateEinNews', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedNews: function setLoadedNews(state, payload) {
    state.news = payload;
  },
  createEinNews: function createEinNews(state, payload) {
    state.news.unshift(payload);
  },
  updateEinNews: function updateEinNews(state, payload) {
    var einNews = state.news.find(function (einNews) {
      return einNews.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        einNews[key] = payload[key];
      }
    });
  },
  deleteEinNews: function deleteEinNews(state, payload) {
    var array = state.news;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.news = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  rechnungen: [],
  eigeneRechnungen: [],
  loading: false,
  loaded: false,
  loadedEigene: false,
  error: null
};

var getters = {
  rechnungen: function rechnungen(state) {
    return state.rechnungen;
  },

  nutzerRechnungen: function nutzerRechnungen(state) {
    return function (user) {
      var rechnungen = [];
      if (state.rechnungen.length > 0) {
        state.rechnungen.forEach(function (rechnung) {
          if (rechnung.bbrID === user) {
            rechnungen.push(rechnung);
          }
        });
      } else {
        state.eigeneRechnungen.forEach(function (rechnung) {
          if (rechnung.bbrID === user) {
            rechnungen.push(rechnung);
          }
        });
      }
      return rechnungen;
    };
  },
  nutzerRechnungenOffen: function nutzerRechnungenOffen(state) {
    return function (user) {
      var rechnungen = [];
      state.eigeneRechnungen.forEach(function (rechnung) {
        if (rechnung.bbrID === user && (rechnung.status === 'Offen' || rechnung.status === 'Überfällig')) {
          rechnungen.push(rechnung);
        }
      });
      return rechnungen;
    };
  },
  statusRechnungenKasse: function statusRechnungenKasse(state) {
    return function (status, kasse) {
      var rechnungen = [];
      state.rechnungen.forEach(function (rechnung) {
        if (rechnung.status === status && rechnung.kasse === kasse) {
          rechnungen.push(rechnung);
        }
      });
      return rechnungen;
    };
  },
  statusRechnungenLetztesDatum: function statusRechnungenLetztesDatum(state) {
    return function (kasse) {
      var rechnungen = [];
      if (state.rechnungen.length > 0) {
        var datum = state.rechnungen[0].rechnung_datum;
        state.rechnungen.forEach(function (rechnung) {
          if (rechnung.rechnung_datum) {
            if (rechnung.rechnung_datum === datum && rechnung.kasse === kasse) {
              rechnungen.push(rechnung);
            }
          } else {
            console.log(rechnung);
          }
        });
      }
      return rechnungen;
    };
  },
  rechnungenKasse: function rechnungenKasse(state) {
    return function (kasse) {
      var rechnungen = [];
      state.rechnungen.forEach(function (rechnung) {
        if (rechnung.kasse === kasse) {
          rechnungen.push(rechnung);
        }
      });
      return rechnungen;
    };
  },
  statusRechnungen: function statusRechnungen(state) {
    return function (status) {
      var rechnungen = [];
      state.rechnungen.forEach(function (rechnung) {
        if (rechnung.status === status) {
          rechnungen.push(rechnung);
        }
      });
      return rechnungen;
    };
  },
  nutzerRechnung: function nutzerRechnung(state) {
    return function (id) {
      return state.eigeneRechnungen.find(function (rechnung) {
        return rechnung.id === id;
      });
    };
  },
  rechnung: function rechnung(state) {
    return function (id) {
      return state.rechnungen.find(function (rechnung) {
        return rechnung.id === id;
      });
    };
  },
  rechnungNummer: function rechnungNummer(state) {
    return function (nummer) {
      return state.rechnungen.find(function (rechnung) {
        return rechnung.rechnungsnummer === nummer;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadRechnungen: function loadRechnungen(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Rechnungen laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('rechnungen').orderBy('rechnung_datum', 'desc').onSnapshot(function (snapshot) {
      var rechnungen = [];
      snapshot.forEach(function (doc) {
        rechnungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedRechnungen', rechnungen);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  loadEigeneRechnungen: function loadEigeneRechnungen(_ref2, user) {
    var commit = _ref2.commit;

    commit('setLoading', true);
    console.log('Eigene Rechnungen laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('rechnungen').where('bbrID', '==', user.user).onSnapshot(function (snapshot) {
      var rechnungen = [];
      snapshot.forEach(function (doc) {
        rechnungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedEigeneRechnungen', rechnungen);
        commit('setLoading', false);
        commit('setLoadedEigene', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createRechnung: function createRechnung(_ref3, payload) {
    var commit = _ref3.commit,
        getters = _ref3.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('rechnungen').add(payload).then(function (key) {}).catch(function (error) {
      console.log(error);
    });
  },
  deleteRechnungData: function deleteRechnungData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('rechnungen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteRechnung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateRechnungData: function updateRechnungData(_ref5, payload) {
    var commit = _ref5.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('rechnungen').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateRechnung', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedRechnungen: function setLoadedRechnungen(state, payload) {
    state.rechnungen = payload;
  },
  setLoadedEigeneRechnungen: function setLoadedEigeneRechnungen(state, payload) {
    state.eigeneRechnungen = payload;
  },
  createRechnung: function createRechnung(state, payload) {
    state.rechnungen.push(payload);
  },
  updateRechnung: function updateRechnung(state, payload) {
    var rechnung = state.rechnungen.find(function (rechnung) {
      return rechnung.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        rechnung[key] = payload[key];
      }
    });
  },
  deleteRechnung: function deleteRechnung(state, payload) {
    var array = state.rechnungen;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.rechnungen = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setLoadedEigene: function setLoadedEigene(state, payload) {
    state.loadedEigene = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  sepa: [],
  loading: false,
  error: null
};

var getters = {
  sepa: function sepa(state) {
    return state.sepa;
  },

  einSepa: function einSepa(state) {
    return function (id) {
      return state.sepa.find(function (einSepa) {
        return einSepa.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadSepa: function loadSepa(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Sepa laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('sepa').get().then(function (snapshot) {
      var sepa = [];
      snapshot.forEach(function (doc) {
        sepa.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedSepa', sepa);
        commit('setLoading', false);
      });
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createEinSepa: function createEinSepa(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('sepa').add(payload).then(function (key) {
      commit('createEinSepa', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
        id: key.id
      }));
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteEinSepaData: function deleteEinSepaData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('sepa').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteEinSepa', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateEinSepaData: function updateEinSepaData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('sepa').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateEinSepa', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedSepa: function setLoadedSepa(state, payload) {
    state.sepa = payload;
  },
  createEinSepa: function createEinSepa(state, payload) {
    state.sepa.push(payload);
  },
  updateEinSepa: function updateEinSepa(state, payload) {
    var einSepa = state.sepa.find(function (einSepa) {
      return einSepa.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        einSepa[key] = payload[key];
      }
    });
  },
  deleteEinSepa: function deleteEinSepa(state, payload) {
    var array = state.sepa;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.sepa = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  statistiken: [],
  loading: false,
  error: null
};

var getters = {
  statistiken: function statistiken(state) {
    return state.statistiken;
  },

  statistik: function statistik(state) {
    return function (id) {
      return state.statistiken.find(function (statistiken) {
        return statistiken.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadStatistiken: function loadStatistiken(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Statistiken laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('statistik').orderBy('monat').onSnapshot(function (snapshot) {
      var statistiken = [];
      snapshot.forEach(function (doc) {
        statistiken.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedStatistiken', statistiken);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createStatistiken: function createStatistiken(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('statistik').add(payload).then(function (key) {
      commit('createStatistiken', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
        id: key.id
      }));
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteStatistikenData: function deleteStatistikenData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('statistik').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteStatistiken', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateStatistikenData: function updateStatistikenData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('statistik').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateStatistiken', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedStatistiken: function setLoadedStatistiken(state, payload) {
    state.statistiken = payload;
  },
  createStatistiken: function createStatistiken(state, payload) {
    state.statistiken.push(payload);
  },
  updateStatistiken: function updateStatistiken(state, payload) {
    var statistiken = state.statistiken.find(function (statistiken) {
      return statistiken.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        statistiken[key] = payload[key];
      }
    });
  },
  deleteStatistiken: function deleteStatistiken(state, payload) {
    var array = state.statistiken;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.statistiken = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  striche: [],
  alleStriche: [],
  loading: false,
  loaded: false,
  loadedAlle: false,
  error: null
};

var getters = {
  alleStriche: function alleStriche(state) {
    return state.striche;
  },
  striche: function striche(state) {
    var striche = [];
    state.striche.forEach(function (strich) {
      if (strich.status === '') {
        striche.push(strich);
      }
    });
    return striche;
  },

  userStriche: function userStriche(state) {
    return function (user) {
      var striche = [];
      state.striche.forEach(function (strich) {
        if (strich.bbrID === user) {
          striche.push(strich);
        }
      });
      return striche;
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadStriche: function loadStriche(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Striche laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('striche').where('status', '==', '').onSnapshot(function (snapshot) {
      var striche = [];
      snapshot.forEach(function (doc) {
        striche.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedStriche', striche);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  loadAlleStriche: function loadAlleStriche(_ref2, datum) {
    var commit = _ref2.commit;

    commit('setLoading', true);
    console.log('Alle Striche laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('striche').where('date', '>=', datum.von).where('date', '<=', datum.bis).get().then(function (snapshot) {
      var striche = [];
      snapshot.forEach(function (doc) {
        striche.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedAlleStriche', striche);
        commit('setLoading', false);
        commit('setLoadedAlle', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createStrich: function createStrich(_ref3, payload) {
    var commit = _ref3.commit,
        getters = _ref3.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('striche').add(payload).then(function (key) {
      payload.date.seconds = payload.date.getTime() / 1000;
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteStrichData: function deleteStrichData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('striche').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteStrich', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateStrichData: function updateStrichData(_ref5, payload) {
    var commit = _ref5.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('striche').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      if (payload.status === '' || payload.status === undefined) {
        commit('updateStrich', payload);
      } else {
        commit('deleteStrich', payload.id);
      }
    }).catch(function (error) {
      console.log('error');
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedStriche: function setLoadedStriche(state, payload) {
    state.striche = payload;
  },
  setLoadedAlleStriche: function setLoadedAlleStriche(state, payload) {
    state.alleStriche = payload;
  },
  createStrich: function createStrich(state, payload) {
    state.striche.push(payload);
  },
  updateStrich: function updateStrich(state, payload) {
    var strich = state.striche.find(function (strich) {
      return strich.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        strich[key] = payload[key];
      }
    });
  },
  deleteStrich: function deleteStrich(state, payload) {
    var array = state.striche;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.striche = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setLoadedAlle: function setLoadedAlle(state, payload) {
    state.loadedAlle = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);




var state = {
  user: null,
  userAccount: null,
  loading: false,
  error: null
};

var getters = {
  user: function user(state) {
    return state.user;
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  signUserUp: function signUserUp(_ref, payload) {
    var commit = _ref.commit;

    commit('setLoading', true);
    commit('clearError');
    __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
      commit('setLoading', false);
      __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$vars.verbindung).collection('kontakte').where('email', '==', payload.email).get().then(function (doc) {
        doc.forEach(function (item) {
          var updateObj = {
            anmeldeID: user.user.uid
          };
          __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$vars.verbindung).collection('kontakte').doc(item.id).update(updateObj).then(function () {
            __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().currentUser.sendEmailVerification();
          }).catch(function (error) {
            commit('setError', error);
          });
        });
      }).catch(function (err) {
        commit('setError', err);
      });
      var newUser = {
        id: user.uid
      };
      commit('setUser', newUser);
      return newUser;
    }).catch(function (error) {
      commit('setLoading', false);
      commit('setError', error);
      console.log(error);
    });
  },
  signUserIn: function signUserIn(_ref2, payload) {
    var commit = _ref2.commit;

    commit('setLoading', true);
    commit('clearError');
    console.log('signUserIn');
    __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
      commit('setLoading', false);
      var newUser = {
        id: user.user.uid,
        registeredBbrBbr: []
      };
      commit('setUser', newUser);
    }).catch(function (error) {
      commit('setLoading', false);
      commit('setError', error);
      console.log(error);
    });
  },
  autoSignIn: function autoSignIn(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setUser', { id: payload.uid, registeredBbrBbr: [] });
  },
  logout: function logout(_ref4) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().signOut();
    commit('setUser', null);
  },
  clearError: function clearError(_ref5) {
    var commit = _ref5.commit;

    commit('clearError');
  }
};

var mutations = {
  setUser: function setUser(state, payload) {
    state.user = payload;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(4);







var state = {
  einstellungen: [],
  veranstaltungen: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  veranstaltung: function veranstaltung(state) {
    return function (id) {
      return state.veranstaltungen.find(function (bbr) {
        return bbr.id === id;
      });
    };
  },
  einstellung: function einstellung(state) {
    return function (id) {
      switch (id) {
        case 'kalender':
          var kalender = state.einstellungen.find(function (einstellung) {
            return einstellung.id === 'kalender';
          });
          if (kalender) {
            kalender = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(kalender);
            kalender = kalender.filter(function (kal) {
              return kal.isPublic === true;
            });
          }
          return kalender;

        case 'alleKalender':
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(state.einstellungen.find(function (einstellung) {
            return einstellung.id === 'kalender';
          }));

        default:
          return state.einstellungen.find(function (einstellung) {
            return einstellung.id === id;
          });
      }
    };
  },
  nachsteVeranstaltungen: function nachsteVeranstaltungen(state) {
    var today = new Date().toISOString().substr(0, 10);
    var veranstaltungen = [];
    state.veranstaltungen.forEach(function (item) {
      if (today <= item.vonDatum) {
        veranstaltungen.push(item);
      }
    });
    return veranstaltungen;
  },
  vergangeneVeranstaltungen: function vergangeneVeranstaltungen(state) {
    var today = new Date().toISOString().substr(0, 10);
    var lastSemester = new Date(new Date().getTime() - 180 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10);
    var veranstaltungen = [];
    state.veranstaltungen.forEach(function (item) {
      if (today >= item.vonDatum && lastSemester <= item.vonDatum) {
        veranstaltungen.push(item);
      }
    });
    return veranstaltungen;
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadVeranstaltungen: function loadVeranstaltungen(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Veranstaltungen laden...');
    __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$vars.verbindung).collection('veranstaltungen').orderBy('vonDatum').orderBy('vonZeit').onSnapshot(function (snapshot) {
      var veranstaltungen = [];
      snapshot.forEach(function (doc) {
        veranstaltungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedVeranstaltungen', veranstaltungen);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', true);
    console.log('Einstellungen laden...');
    __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$vars.verbindung).collection('einstellungen').onSnapshot(function (snapshot) {
      var einstellungen = [];
      snapshot.forEach(function (doc) {
        einstellungen.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedEinstellungen', einstellungen);
        commit('setLoading', false);
      });
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createVeranstaltung: function createVeranstaltung(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    if (payload.anmeldungen === undefined) {
      payload.anmeldungen = [];
    }
    __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$vars.verbindung).collection('veranstaltungen').add(payload).then(function (key) {
      commit('updateVeranstaltungIcalFeed');
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteVeranstaltungData: function deleteVeranstaltungData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$vars.verbindung).collection('veranstaltungen').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteVeranstaltung', payload);
      commit('updateVeranstaltungIcalFeed');
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateVeranstaltungData: function updateVeranstaltungData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$vars.verbindung).collection('veranstaltungen').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateVeranstaltung', payload);
      commit('updateVeranstaltungIcalFeed');
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedVeranstaltungen: function setLoadedVeranstaltungen(state, payload) {
    state.veranstaltungen = payload;
  },
  setLoadedEinstellungen: function setLoadedEinstellungen(state, payload) {
    state.einstellungen = payload;
  },
  createVeranstaltung: function createVeranstaltung(state, payload) {
    state.veranstaltungen.push(payload);
  },
  updateVeranstaltung: function updateVeranstaltung(state, payload) {
    var veranstaltung = state.veranstaltungen.find(function (veranstaltung) {
      return veranstaltung.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        veranstaltung[key] = payload[key];
      }
    });
  },
  updateVeranstaltungIcalFeed: function updateVeranstaltungIcalFeed(state) {
    var ics = __webpack_require__(583);
    var eventsByCalendar = {};
    eventsByCalendar['Alle'] = [];

    state.veranstaltungen.forEach(function (item) {
      var a = item.vonDatum.split('-');
      var b = item.vonZeit.split(':');
      var c = item.bisDatum.split('-');
      var d = item.bisZeit.split(':');
      var anmeldungen = item.anmeldungen.length + item.weitereAnmeldungen.length;
      var bemerkung = item.bemerkung ? item.bemerkung : '';
      var anmeldungenText = anmeldungen.length > 0 ? '(mindestens ' + anmeldungen + ' Anmeldungen)' : '';
      var event = {
        start: [parseInt(a[0]), parseInt(a[1]), parseInt(a[2]), parseInt(b[0]), parseInt(b[1])],
        end: [parseInt(c[0]), parseInt(c[1]), parseInt(c[2]), parseInt(d[0]), parseInt(d[1])],
        title: item.titel,
        description: bemerkung + ' ' + anmeldungenText,
        location: item.ort,
        calName: item.kalender
      };

      if (!eventsByCalendar[item.kalender]) {
        eventsByCalendar[item.kalender] = [];
      }
      eventsByCalendar[item.kalender].push(event);
      var kalender = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(state.einstellungen.find(function (item) {
        return item.id === 'kalender';
      })).filter(function (kal) {
        return kal.isPublic === true;
      });
      kalender.forEach(function (kal) {
        if (kal.name === item.kalender) {
          eventsByCalendar['Alle'].push(event);
        }
      });
    });

    console.log(eventsByCalendar['Alle'].filter(function (item) {
      return item.title === 'Abschlusskneipe';
    }));

    var _loop = function _loop(calendarName) {
      var events = eventsByCalendar[calendarName];
      var icaltext = ics.createEvents(events).value;
      var filename = calendarName + '.ics';
      var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].storage().ref('/kalender/' + __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$vars.verbindung + '/' + filename);
      var bb = new Blob([icaltext], { type: 'text/calendar' });

      storageRef.put(bb).then(function () {
        console.log(filename + ' updated');
      }).catch(function (error) {
        console.log(error.message);
      });
    };

    for (var calendarName in eventsByCalendar) {
      _loop(calendarName);
    }
  },
  deleteVeranstaltung: function deleteVeranstaltung(state, payload) {
    var array = state.veranstaltungen;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.veranstaltungen = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(4);





var state = {
  vereine: [],
  loading: false,
  loaded: false,
  error: null
};

var getters = {
  vereine: function vereine(state) {
    return state.vereine;
  },

  verein: function verein(state) {
    return function (id) {
      return state.vereine.find(function (verein) {
        return verein.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadVereine: function loadVereine(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Vereine laden...');
    __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$vars.verbindung).onSnapshot(function (snapshot) {
      var vereine = snapshot.data();
      commit('setLoadedVereine', vereine);
      commit('setLoading', false);
      commit('setLoaded', true);
    }, function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createVerein: function createVerein(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$vars.verbindung).add(payload).catch(function (error) {
      console.log(error);
    });
  },
  deleteVereinData: function deleteVereinData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$vars.verbindung).doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteVerein', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateVereinData: function updateVereinData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_1_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$vars.verbindung).doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateVerein', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedVereine: function setLoadedVereine(state, payload) {
    state.vereine = payload;
  },
  createVerein: function createVerein(state, payload) {
    state.vereine.push(payload);
  },
  updateVerein: function updateVerein(state, payload) {
    var verein = state.vereine.find(function (verein) {
      return verein.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        verein[key] = payload[key];
      }
    });
  },
  deleteVerein: function deleteVerein(state, payload) {
    var array = state.vereine;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.vereine = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);






var state = {
  wirtschaftsplane: [],
  loaded: false,
  loading: false,
  error: null
};

var getters = {
  wirtschaftsplane: function wirtschaftsplane(state) {
    return state.wirtschaftsplane;
  },

  wirtschaftsplan: function wirtschaftsplan(state) {
    return function (id) {
      return state.wirtschaftsplane.find(function (wirtschaftsplan) {
        return wirtschaftsplan.id === id;
      });
    };
  },
  loading: function loading(state) {
    return state.loading;
  },
  error: function error(state) {
    return state.error;
  }
};

var actions = {
  loadWirtschaftsplane: function loadWirtschaftsplane(_ref) {
    var commit = _ref.commit;

    commit('setLoading', true);
    console.log('Wirtschaftsplan laden...');
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('wirtschaftsplane').orderBy('datum', 'desc').get().then(function (snapshot) {
      var wirtschaftsplane = [];
      snapshot.forEach(function (doc) {
        wirtschaftsplane.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc.data(), {
          id: doc.id
        }));
        commit('setLoadedWirtschaftsplane', wirtschaftsplane);
        commit('setLoading', false);
        commit('setLoaded', true);
      });
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  },
  createWirtschaftsplan: function createWirtschaftsplan(_ref2, payload) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('wirtschaftsplane').add(payload).then(function (key) {
      commit('createWirtschaftsplan', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
        id: key.id
      }));
    }).catch(function (error) {
      console.log(error);
    });
  },
  deleteWirtschaftsplanData: function deleteWirtschaftsplanData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('wirtschaftsplane').doc(payload).delete().then(function () {
      commit('setLoading', false);
      commit('deleteWirtschaftsplan', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
    commit('setLoading', false);
  },
  updateWirtschaftsplanData: function updateWirtschaftsplanData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setLoading', true);
    var updateObj = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].firestore().collection('vereine').doc(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$vars.verbindung).collection('wirtschaftsplane').doc(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateWirtschaftsplan', payload);
    }).catch(function (error) {
      console.log(error);
      commit('setLoading', false);
    });
  }
};

var mutations = {
  setLoadedWirtschaftsplane: function setLoadedWirtschaftsplane(state, payload) {
    state.wirtschaftsplane = payload;
  },
  createWirtschaftsplan: function createWirtschaftsplan(state, payload) {
    state.wirtschaftsplane.push(payload);
  },
  setLoaded: function setLoaded(state, payload) {
    state.loaded = payload;
  },
  updateWirtschaftsplan: function updateWirtschaftsplan(state, payload) {
    var wirtschaftsplan = state.wirtschaftsplane.find(function (wirtschaftsplan) {
      return wirtschaftsplan.id === payload.id;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
      if (payload[key]) {
        wirtschaftsplan[key] = payload[key];
      }
    });
  },
  deleteWirtschaftsplan: function deleteWirtschaftsplan(state, payload) {
    var array = state.wirtschaftsplane;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1);
      }
    }
    state.wirtschaftsplane = array;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  clearError: function clearError(state) {
    state.error = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(828)));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(830)));

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(831)));

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(836)));

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_submodule_dialogNachricht__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_submodule_dialogNachricht___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_submodule_dialogNachricht__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_submodule_snackbar__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_submodule_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_submodule_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_submodule_dialogError__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_submodule_dialogError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_submodule_dialogError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_compat_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_compat_firestore__ = __webpack_require__(5);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    dialogNachricht: __WEBPACK_IMPORTED_MODULE_3__module_submodule_dialogNachricht___default.a,
    snackbar: __WEBPACK_IMPORTED_MODULE_4__module_submodule_snackbar___default.a,
    dialogError: __WEBPACK_IMPORTED_MODULE_5__module_submodule_dialogError___default.a
  },
  data: function data() {
    return {
      loadingValue: 0,
      showLoadingDialog: true,
      showSuche: false,
      showEinstellungen: false,
      suche: "",
      showMenu: false,
      showChargenUndAemter: false,
      showMenuMobile: false,
      showNeueNachricht: false,
      sucheAnzeigen: false,
      showStartDialog: false,
      menuItems: [],
      showHelp: false,
      fehler: [],
      name: "",
      message: {
        titel: "",
        body: ""
      },
      subMenu: [],
      sideNavItem: true,
      sideNav: false,
      footerMenu: [],
      kontakte: [],
      bild: ""
    };
  },

  computed: {
    x: function x() {
      if (this.$vuetify.breakpoint.name === "sm" || this.$vuetify.breakpoint.name === "xs") {
        return (window.innerWidth - 367) / 2;
      } else {
        return window.innerWidth - 367 - 16;
      }
    },
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    einstellungen: function einstellungen() {
      return this.$store.state.einstellungen.einstellungen;
    },
    mainMenu: function mainMenu() {
      var mitglieder = "";
      if (this.$store.getters["einstellungen/einstellung"]("allgemein")) {
        mitglieder = this.$store.getters["einstellungen/einstellung"]("allgemein").bezMitglieder;
      }
      var allgemein = this.$store.getters["einstellungen/einstellung"]("allgemein");
      var menu = [{ icon: "home", beta: false, title: "Home", link: "/" }];

      if (allgemein) {
        this.showLoadingDialog = false;
        if (allgemein.showMenuVeranstaltungen) {
          menu.push({ icon: "event", beta: false, title: "Veranstaltungen", link: "/veranstaltungen" });
        }
        if (allgemein.showMenuKontakte) {
          menu.push({ icon: "groups", beta: false, title: mitglieder, link: "/bbrbbr" });
        }
        if (allgemein.showMenuRechnungen) {
          menu.push({ icon: "receipt_long", beta: false, title: "Rechnungen", link: "/rechnungen" });
        }
        if (allgemein.showMenuKontaktdaten) {
          menu.push({ icon: "person", beta: false, title: "Kontaktdaten", link: "/daten" });
        }
        if (allgemein.showMenuDownload) {
          menu.push({ icon: "download", beta: false, title: "Download", link: "/download" });
        }
        if (allgemein.showMenuSemester) {
          menu.push({ icon: "event_repeat", beta: true, title: "Semester", link: "/semester" });
        }
        if (allgemein.showMenuStammbaum) {
          menu.push({ icon: "diversity_3", beta: false, title: "Stammbaum", link: "/stammbaum/home" });
        }
      }
      return menu;
    },
    headerImage: function headerImage() {
      var allgemeinEinstellung = this.$store.getters["einstellungen/einstellung"]("allgemein");
      return allgemeinEinstellung ? allgemeinEinstellung.header : null;
    },
    seiten: function seiten() {
      var seiten = [];
      if (this.$store.state.einstellungen.einstellungen.length > 0) {
        var items = this.$store.getters["einstellungen/einstellung"]("rollen");
        if (items !== undefined) {
          items.seiten.forEach(function (item) {
            seiten.push({
              text: item.titel,
              bild: item.bild,
              link: "/modul/" + item.titel + "/uebersicht",
              berechtigt: item.berechtigt,
              module: item.module
            });
          });
        }
      }
      return seiten;
    },
    sideMenu: function sideMenu() {
      var menu = [];
      var link = this.$route.params.seite;
      if (link && this.seiten.length > 0) {
        var seite = this.seiten.find(function (modul) {
          return modul.text === link;
        });
        seite.module.forEach(function (modul) {
          menu.push({ icon: modul.icon, title: modul.name, link: "/modul/" + seite.text + "/" + modul.value });
        });
      }
      return menu;
    },
    extensionHeight: function extensionHeight() {
      if (this.userIsAuthenticated) {
        if (this.isHomePage) {
          if (this.$vuetify.breakpoint.name === "md" || this.$vuetify.breakpoint.name === "sm") {
            return 32;
          } else {
            if (this.$vuetify.breakpoint.name === "xs") {
              return 0;
            } else {
              return 68;
            }
          }
        } else {
          if (this.$vuetify.breakpoint.name === "md" || this.$vuetify.breakpoint.name === "sm") {
            return 0;
          } else {
            if (this.$vuetify.breakpoint.name === "xs") {
              return 0;
            } else {
              return 48;
            }
          }
        }
      } else {
        return 0;
      }
    },
    isLogin: function isLogin() {
      return this.$route.name === "Anmelden" || this.$route.name === "Registrieren" || this.$route.name === "Passwort vergessen";
    },
    isHomePage: function isHomePage() {
      return this.$route.name === "Ripuaria" || this.$route.name === "Korpodesk" || this.$route.name === "160. Stiftungsfest" || this.$route.name === "Ripuarentage";
    },
    route: function route() {
      var nichtAnzeigen = ["160. Stiftungsfest", "Sommerfest", "Korpodesk", "Ripuarentage", "Anmelden", "Registrieren", "Passwort vergessen", "Home", "Mitglieder", "Ripuaria", "Veranstaltungen", "Mail", "Forum", "Rechnungen", "Download", "Bundesbrüder", "Daten", "Stammbaum", "Stammbaum - Daten", "Semester", "Mailadresse verifizieren", "Mailadresse ändern", "Anleitungen", "Setup"];
      if (nichtAnzeigen.indexOf(this.$route.name) > -1) {
        this.sideNav = false;
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            this.sideNav = false;
            break;
          case "sm":
            this.sideNav = false;
            break;
          case "md":
            this.sideNav = false;
            break;
          case "lg":
            this.sideNav = true;
            break;
          case "xl":
            this.sideNav = true;
            break;
        }
      }
      if (this.$route.params.seite === undefined) {
        if (this.$route.name === "Ripuaria" || this.$route.name === "Korpodesk" || this.$route.name === "160. Stiftungsfest" || this.$route.name === "Ripuarentage") {
          return;
        } else {
          return this.$route.name;
        }
      } else {
        return this.$route.params.seite;
      }
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.state.user.user !== null && this.$store.state.user.user !== undefined && this.$firebase.auth().currentUser.emailVerified;
    },
    getAdmins: function getAdmins() {
      return this.$store.getters["einstellungen/einstellung"]("allgemein").admins;
    }
  },
  methods: {
    userIsVerified: function userIsVerified() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user, token;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                user = _this.$firebase.auth().currentUser;
                _context.next = 3;
                return user.getIdToken();

              case 3:
                token = _context.sent;

                console.log(token);
                return _context.abrupt("return", _this.$firebase.auth().currentUser ? _this.$firebase.auth().currentUser.emailVerified : false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeData: function changeData() {
      console.log("Change Data");
      var collection = "einstellungen";
      __WEBPACK_IMPORTED_MODULE_6_firebase_compat_app__["a" /* default */].firestore().collection(collection).onSnapshot(function (snapshot) {
        var items = [];
        snapshot.forEach(function (doc) {
          items.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, doc.data(), {
            id: doc.id
          }));
        });
        console.log(items);
      }, function (error) {
        console.log(error);
      });
    },
    test: function test() {
      __WEBPACK_IMPORTED_MODULE_6_firebase_compat_app__["a" /* default */].firestore().collection("vereine").doc("rbo").collection("kontakte").onSnapshot(function (snapshot) {
        var items = [];
        snapshot.forEach(function (doc) {
          if (doc.data().anmeldeID) {
            items.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, doc.data(), {
              id: doc.id
            }));
          }
        });
        items.forEach(function (item) {
          var field = {
            email: item.email,
            id: item.anmeldeID,
            vereine: ["rbo"]
          };
          console.log(field);
          __WEBPACK_IMPORTED_MODULE_6_firebase_compat_app__["a" /* default */].firestore().collection("user").doc(item.anmeldeID).set(field).then(function () {
            console.log("success");
          }).catch(function (error) {
            console.log(error);
          });
        });
        console.log(items);
      }, function (error) {
        console.log(error);
      });
    },
    getToken: function getToken() {
      var _this2 = this;

      this.$messaging.getToken({
        vapidKey: "AAAAa2TXeCg:APA91bF-Ybz-2aMOpR74NdfD-X1Ks3PFvB5eX7OsKku0HG0XUSeQt6J-VwUzsJAaOyeMOXWPmjdLu8U3pcsXvBgBC57jCJtcHJKtXblqsyz6ZxX4taLenR10zX7x2P2oXgCNi9iQbbKk"
      }).then(function (currentToken) {
        if (currentToken) {
          console.log(currentToken);
          _this2.getCurrentBbr();
          var bbr = _this2.$store.getters["bbrbbr/bbr"](_this2.currentBbr);
          console.log(_this2.currentBbr);
          console.log(bbr);
          if (!bbr.notificationToken) {
            bbr.notificationToken = [];
          }
          console.log(bbr.notificationToken.indexOf(currentToken));
          if (bbr.notificationToken.indexOf(currentToken) === -1) {
            bbr.notificationToken.push(currentToken);
            _this2.$store.dispatch("bbrbbr/updateBbrData", bbr);
          }
        } else {
          console.log("No registration token available. Request permission to generate one.");
        }
      }).catch(function (err) {
        console.log("Test: An error occurred while retrieving token. ", err);
      });
    },
    getSubMenu: function getSubMenu() {
      var _this3 = this;

      var menu = [];
      this.seiten.forEach(function (item) {
        if (item.berechtigt.indexOf(_this3.$getCurrentBbr()) >= 0 || _this3.$getCurrentBbr() === "PBChUyAy7HWowQR4HlP3") {
          menu.push({ icon: "group", title: item.text, link: item.link, bild: item.bild });
        }
      });
      this.subMenu = menu;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    sendFehler: function sendFehler() {
      var betreff = "Fehler/Problem auf Korpodesk";
      var text = this.fehler.beschreibung.replace(/(?:\r\n|\r|\n)/g, "<br>");
      var absender = this.$store.getters["bbrbbr/bbr"](this.$getCurrentBbr());
      console.log(this.$getCurrentBbr());
      var to = [];
      to.push("breuerbe@gmail.com");
      this.$store.dispatch("mails/createEinMails", {
        art: "mail",
        to: to,
        an: "Benedikt Breuer",
        absender: {
          position: "" || "",
          name: absender.vorname || "" + " " + absender.nachname || "",
          adresse: absender.adresse || "",
          plz: absender.plz || "",
          ort: absender.ort || "",
          email: absender.email || "",
          telefon: absender.handy || ""
        },
        message: {
          subject: betreff,
          text: text
        },
        datum: new Date()
      });
      this.showFehler = false;
      this.fehler = [];
    },
    toggleSideNav: function toggleSideNav() {
      this.sideNav = !this.sideNav;
    },
    toggleSideNavRight: function toggleSideNavRight() {
      this.showMenuMobile = !this.showMenuMobile;
    },
    goTo: function goTo(link) {
      this.showMenu = false;
      this.showMenuMobile = false;
      link ? this.$router.push(link) : this.$router.push("/");
    },
    onLogout: function onLogout() {
      this.menuItems = [{ icon: "lock_open", bild: "mitglieder.png", title: "Anmelden", link: "/anmelden" }];
      this.$store.dispatch("user/logout");
      this.$router.push("/anmelden");
    },
    onResize: function onResize() {
      this.showMenu = false;
    }
  },
  updated: function updated() {
    var _this4 = this;

    if (this.$firebase.auth().currentUser && this.userIsAuthenticated) {
      var name = void 0;
      var bild = void 0;
      this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
        if (item.anmeldeID === _this4.$firebase.auth().currentUser.uid) {
          name = item.nachname + ", " + item.vorname;
          bild = item.bildAhnengalerie;
        }
      });
      this.name = name;
      this.bild = bild;
    }
    var settings = this.$store.getters["einstellungen/einstellung"]("allgemein");

    if (settings) {
      if (typeof settings.primary === "string") {
        this.$vuetify.theme.themes.light.primary = settings.primary;
      } else {
        this.$vuetify.theme.themes.light.primary = settings.primary.hex;
      }

      if (typeof settings.secondary === "string") {
        this.$vuetify.theme.themes.light.secondary = settings.secondary;
      } else {
        this.$vuetify.theme.themes.light.secondary = settings.secondary.hex;
      }

      if (typeof settings.tertiary === "string") {
        this.$vuetify.theme.themes.light.tertiary = settings.tertiary;
      } else {
        this.$vuetify.theme.themes.light.tertiary = settings.tertiary.hex;
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var sub;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (window.location.hostname === "rbo-system.web.app") {
                window.location.href = "https://rbo.korpodesk.de";
              }
              sub = window.location.hostname.split(".")[0];

              _this5.$vars.verbindung = sub;
              _this5.$vars.beta = false;
              if (sub === "localhost" || sub === "beta") {
                _this5.$vars.beta = true;
                _this5.$vars.verbindung = "rbo";
              }
              if (window.location.hostname.split(".")[1] === "localhost") {
                _this5.$vars.beta = true;
              }
              if (sub === "test") {
                _this5.$vars.beta = true;
              }
              window.addEventListener("resize", _this5.onResize);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  beforeMount: function beforeMount() {
    var _this6 = this;

    function randomInterval(min, max) {
      return Math.random() * (max - min) + min;
    }
    setInterval(function () {
      if (_this6.loadingValue < 100) {
        _this6.loadingValue = Math.min(_this6.loadingValue + parseInt((Math.random(0, 1) * 10).toFixed(0)), 100);
      } else {
        _this6.loadingValue = 100;
        _this6.showLoadingDialog = false;
      }
    }, randomInterval(150, 250));
    this.getSubMenu();
    if (this.$firebase.auth().currentUser) {
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("einstellungen").doc("mitgliederstatus").get().then(function (doc) {
        var alleStatus = doc.data().status;
        alleStatus.forEach(function (status) {
          _this6.kontakte.push({ icon: "group", title: status.status, link: "/bbrbbr/" + status.status });
        });
      }).catch(function (err) {
        console.log("Error getting document", err);
      });
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      modal: false,
      leibvater: '',
      bbr: [],
      sidenav: false,
      counter: {
        mitLeibvater: 0,
        ohneLeibvater: 0
      }
    };
  },

  computed: {
    bundesbruder: function bundesbruder() {
      var bundesbruder = [];
      var bbrbbr = this.$store.getters['bbrbbr/nurBbrbbr'];
      bbrbbr.forEach(function (item) {
        bundesbruder.push({
          value: item.id,
          text: item.nachname + ', ' + item.vorname
        });
      });
      return bundesbruder;
    },
    semester: function semester() {
      var _this = this;

      var semester = [];
      var art = '1';
      var semesterID = 1;

      var _loop = function _loop(_i) {
        if (art === '1') {
          var receptionen = [];
          var bundesbruder = _this.$store.getters['bbrbbr/nurBbrbbr'];
          _this.counter.mitLeibvater = 0;
          _this.counter.ohneLeibvater = 0;
          bundesbruder.forEach(function (bbr) {
            if (bbr.leibvater) {
              _this.counter.mitLeibvater++;
            } else {
              _this.counter.ohneLeibvater++;
            }
            if (bbr.receptionsdatum) {
              if (parseInt(bbr.receptionsdatum.slice(0, 4)) === _i) {
                var was = bbr.receptionsdatum.slice(5, 7);
                if (was >= 10 && was <= 12) {
                  receptionen.push({
                    id: bbr.id,
                    name: bbr.nachname + ', ' + bbr.vorname,
                    leibvater: bbr.leibvater
                  });
                }
              } else if (parseInt(bbr.receptionsdatum.slice(0, 4)) === _i + 1) {
                var _was = bbr.receptionsdatum.slice(5, 7);
                if (_was >= 1 && _was <= 3) {
                  receptionen.push({
                    id: bbr.id,
                    name: bbr.nachname + ', ' + bbr.vorname,
                    leibvater: bbr.leibvater
                  });
                }
              }
            }
          });
          semester.push({
            semesterID: semesterID,
            semestername: 'WS ' + _i,
            xxx: '',
            xx: '',
            x: '',
            FM: 'green',
            xxxx: '',
            receptionen: receptionen
          });
          art = '0';
        } else {
          var _receptionen = [];
          var _bundesbruder = _this.$store.getters['bbrbbr/nurBbrbbr'];
          _bundesbruder.forEach(function (bbr) {
            if (bbr.receptionsdatum) {
              if (parseInt(bbr.receptionsdatum.slice(0, 4)) === _i) {
                var was = bbr.receptionsdatum.slice(5, 7);
                if (was >= 4 && was <= 9) {
                  _receptionen.push({
                    id: bbr.id,
                    name: bbr.nachname + ', ' + bbr.vorname,
                    leibvater: bbr.leibvater
                  });
                }
              }
            }
          });
          semester.push({
            semesterID: semesterID,
            semestername: 'SS ' + _i,
            xxx: '',
            xx: '',
            x: '',
            FM: 'green',
            xxxx: '',
            receptionen: _receptionen
          });
          _i--;
          art = '1';
        }
        semesterID++;
        i = _i;
      };

      for (var i = 1945; i <= 2023; i++) {
        _loop(i);
      }
      return semester;
    }
  },
  methods: {
    showModal: function showModal(id, leibvater) {
      var _this2 = this;

      this.leibvater = '';
      var bbrbbr = this.$store.getters['bbrbbr/nurBbrbbr'];
      bbrbbr.forEach(function (item) {
        if (item.id === id) {
          _this2.bbr = item;
        }
        if (item.id === leibvater) {
          _this2.leibvater = item.id;
        }
      });
      this.modal = true;
    },
    save: function save() {
      var changes = {
        id: this.bbr.id,
        leibvater: this.leibvater
      };
      this.$store.dispatch('bbrbbr/updateBbrData', changes);
      this.modal = false;
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    stammbaum: __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum___default.a
  },
  data: function data() {
    return {
      screenWidth: this.$vuetify.breakpoint.width,
      screenHeight: this.$vuetify.breakpoint.height,
      search: '',
      bundesbruder: '',
      denseStammbaum: true,
      bbrbbr: [],
      leibfamilienGrunder: [],
      sidenav: false,
      collapse: false
    };
  },

  computed: {
    currentbundesbruder: function currentbundesbruder() {
      var _this = this;

      if (this.bundesbruder.id) {
        return this.$store.getters['bbrbbr/bbr'](this.bundesbruder.id);
      } else {
        var bbr = '';
        if (this.$firebase.auth().currentUser) {
          this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
            if (item.anmeldeID === _this.$firebase.auth().currentUser.uid) {
              bbr = item;
            }
          });
        }
        return bbr;
      }
    }
  },
  methods: {
    test: function test() {}
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.bbrbbr = [];
    this.leibfamilienGrunder = [];
    var bbrbbr = this.$store.getters['bbrbbr/nurBbrbbr'];
    bbrbbr.forEach(function (item) {
      _this2.bbrbbr.push({
        value: {
          id: item.id,
          text: item.nachname + ', ' + item.vorname
        },
        text: item.nachname + ', ' + item.vorname
      });
      if (!item.leibvater) {
        _this2.leibfamilienGrunder.push({
          value: {
            id: item.id,
            text: item.nachname + ', ' + item.vorname
          },
          text: 'Leibfamilie ' + item.nachname + ' (' + item.vorname + ')'
        });
      }
    });
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      panel: [0, 0],
      videos: [{ title: 'Wie registriere ich mich für die Ripuaren-App?', link: 'https://youtu.be/XyG28SgIxU0' }, { title: 'Was kann die Ripuaren-App?', link: '' }, { title: 'Wie melde ich mich zu einer Veranstaltung an?', link: '' }, { title: 'Windows: Wie erstelle ich eine Verknüpfung auf dem Desktop?', link: '' }, { title: 'Android: Wie erstelle ich eine Verknüpfung auf dem Homescreen?', link: '' }, { title: 'iOS/iPadOS: Wie für ich die App dem Homescreen hinzu?', link: '' }, { title: 'MacOS: Wie erstelle ich eine Verknüpfung im Dock?', link: '' }]
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.getters.allBbrBbr;
    }
  },
  methods: {
    onLoadBbrBbr: function onLoadBbrBbr(id) {
      this.$router.push('/bbr/' + id);
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SigninCard__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SigninCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SigninCard__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    signinCard: __WEBPACK_IMPORTED_MODULE_3__SigninCard___default.a
  },
  data: function data() {
    return {
      email: '',
      password: '',
      showAbout: false,
      showLoginInfo: false,
      checkMailValue: { status: null },
      test: false,
      loading: false,
      logoUrl: null,
      backgroundUrl: null,
      canvas: {},
      ctx: null
    };
  },
  mounted: function mounted() {
    this.loadBackground();
    this.loadLogo();
    this.initializeCanvas();
    this.drawCanvas();
    this.addEventListeners();
  },

  computed: {
    backgroundVariant: function backgroundVariant() {
      return this.backgroundUrl ? 'image' : 'canvas1';
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        if (this.$route.query !== '') {
          this.$router.push(this.$route.query.link);
        } else {
          this.$router.push('/');
        }
      }
    }
  },
  methods: {
    addEventListeners: function addEventListeners() {
      window.addEventListener('resize', this.resizeCanvas);
    },
    resizeCanvas: function resizeCanvas() {
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
      this.drawBackground();
      this.drawCanvas();
    },
    drawBackground: function drawBackground() {
      this.ctx.fillStyle = '#E3F2FD';
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    },
    initializeCanvas: function initializeCanvas() {
      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext('2d');
      this.resizeCanvas();
    },
    drawBadge: function drawBadge(x, w, color) {
      this.ctx.save();

      this.ctx.beginPath();
      this.ctx.moveTo(0, x);
      this.ctx.lineTo(0, x + w);
      this.ctx.lineTo(x + w, 0);
      this.ctx.lineTo(x, 0);
      this.ctx.closePath();

      this.ctx.fillStyle = color;
      this.ctx.shadowBlur = 10;
      this.ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
      this.ctx.fill();

      this.ctx.restore();
    },
    drawTriangle: function drawTriangle(x1, y1, x2, y2, x3, y3, color) {
      this.ctx.save();

      this.ctx.beginPath();
      this.ctx.moveTo(x1, y1);
      this.ctx.lineTo(x2, y2);
      this.ctx.lineTo(x3, y3);
      this.ctx.closePath();

      this.ctx.fillStyle = color;
      this.ctx.shadowBlur = 10;
      this.ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
      this.ctx.fill();

      this.ctx.restore();
    },
    drawCircle: function drawCircle(x, y, r, color) {
      this.ctx.save();

      this.ctx.beginPath();
      this.ctx.arc(x, y, r, 0, 2 * Math.PI);
      this.ctx.closePath();

      this.ctx.fillStyle = color;
      this.ctx.shadowBlur = 20;
      this.ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
      this.ctx.fill();

      this.ctx.restore();
    },
    drawCanvas: function drawCanvas() {
      var h = this.canvas.height;

      if (this.backgroundVariant === 'canvas1') {
        this.drawTriangle(0, 0, 0, h, h, 0, this.hexToRgba('#E3F2FD', 1));
        this.drawTriangle(0, 0.2 * h, 0, h, 0.8 * h, h, this.hexToRgba('#E3F2FD', 1));
      }
      if (this.backgroundVariant === 'canvas2') {
        for (var i = 0; i < 10; i++) {
          var x = Math.random() * this.canvas.width;
          var y = Math.random() * this.canvas.height;
          var radius = Math.random() * 200 + 30;
          var transparency = Math.random() * 0.3 + 0.2;
          var color = this.hexToRgba(this.$vuetify.theme.themes.light.primary, transparency);
          this.drawCircle(x, y, radius, color);
        }
      }
    },
    hexToRgba: function hexToRgba(hex, alpha) {
      if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        throw new Error('Ungültiges Hex-Format für Farbe');
      }

      var _hex$match$map = hex.match(/\w{2}/g).map(function (value) {
        return parseInt(value, 16) * (hex.length === 4 ? 17 : 1);
      }),
          _hex$match$map2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_hex$match$map, 3),
          r = _hex$match$map2[0],
          g = _hex$match$map2[1],
          b = _hex$match$map2[2];

      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    },
    loadLogo: function loadLogo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.logoImage();

              case 3:
                url = _context.sent;

                _this.logoUrl = url;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error('Error loading logo:', _context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    logoImage: function logoImage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                storagePath = '/design/logo/' + _this2.$vars.verbindung;
                _context2.next = 4;
                return _this2.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context2.sent;
                return _context2.abrupt('return', url);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    loadBackground: function loadBackground() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.backgroundImage();

              case 3:
                url = _context3.sent;

                _this3.backgroundUrl = url;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                _this3.backgroundUrl = null;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    backgroundImage: function backgroundImage() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                storagePath = '/design/background/' + _this4.$vars.verbindung;
                _context4.next = 4;
                return _this4.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context4.sent;
                return _context4.abrupt('return', url);

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8]]);
      }))();
    },
    goToRegistrierung: function goToRegistrierung() {
      this.onDismissed();
      this.$router.push('/registrieren');
    },
    checkMail: function checkMail() {
      var _this5 = this;

      this.loading = true;
      this.checkMailValue = { status: null };
      var functions = this.$firebase.functions();
      if (this.email) {
        functions.httpsCallable('userLoginAllowed')({ email: this.email.toLowerCase(), sub: this.$vars.verbindung }).then(function (_ref) {
          var data = _ref.data;

          _this5.checkMailValue = data;
          _this5.loading = false;
        }).catch(function (error) {
          _this5.error = error;
          _this5.loading = false;
        });
      } else {
        this.checkMailValue = { status: null };
        this.loading = false;
      }
    },
    onSignin: function onSignin() {
      this.test = true;
      this.$store.dispatch('user/signUserIn', { email: this.email, password: this.password });
      this.$router.push('/');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('user/clearError');
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas);
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SigninForm__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SigninForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SigninForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignupForm__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignupForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SignupForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__updatePasswordForm__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__updatePasswordForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__updatePasswordForm__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    signinForm: __WEBPACK_IMPORTED_MODULE_2__SigninForm___default.a,
    signupForm: __WEBPACK_IMPORTED_MODULE_3__SignupForm___default.a,
    updatePasswordForm: __WEBPACK_IMPORTED_MODULE_4__updatePasswordForm___default.a
  },
  data: function data() {
    return {
      logoUrl: null
    };
  },
  mounted: function mounted() {
    this.loadLogo();
  },

  computed: {
    route: function route() {
      return this.$route.name;
    }
  },
  methods: {
    loadLogo: function loadLogo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.logoImage();

              case 3:
                url = _context.sent;

                _this.logoUrl = url;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error('Error loading logo:', _context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    logoImage: function logoImage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                storagePath = '/design/logo/' + _this2.$vars.verbindung;
                _context2.next = 4;
                return _this2.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context2.sent;
                return _context2.abrupt('return', url);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(116);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      checkMailValue: { status: null },
      loading: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.user.user;
    },
    error: function error(state) {
      return state.user.error;
    }
  }),
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        if (this.$route.query !== '') {
          this.$router.push(this.$route.query.link);
        } else {
          this.$router.push('/');
        }
      }
    }
  },
  methods: {
    goToRegistrierung: function goToRegistrierung() {
      this.onDismissed();
      this.$router.push('/registrieren');
    },
    checkMail: function checkMail() {
      var _this = this;

      this.loading = true;
      this.checkMailValue = { status: null };
      var functions = this.$firebase.functions();
      if (this.email) {
        functions.httpsCallable('userLoginAllowed')({ email: this.email.toLowerCase(), sub: this.$vars.verbindung }).then(function (_ref) {
          var data = _ref.data;

          _this.checkMailValue = data;
          _this.loading = false;
        }).catch(function (error) {
          _this.error = error;
          _this.loading = false;
        });
      } else {
        this.checkMailValue = { status: null };
        this.loading = false;
      }
    },
    onSignin: function onSignin() {
      this.test = true;
      this.$store.dispatch('user/signUserIn', { email: this.email, password: this.password });
      this.$router.push('/');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('user/clearError');
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      loadingBtn: false,
      email: '',
      password: '',
      confirmPassword: '',
      checkMailValue: { status: null },
      error: {},
      mailVorhanden: false
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwörter stimmen nicht überein' : '';
    },
    user: function user() {
      return this.$store.state.user.user;
    },
    errorMessage: function errorMessage() {
      return this.$store.state.user.error;
    }
  },
  watch: {
    user: function user(value) {
      if (this.$firebase.auth().currentUser) {
        this.$router.push('/verifizieremail');
      }
    }
  },
  methods: {
    checkMail: function checkMail() {
      var _this = this;

      this.loading = true;
      this.checkMailValue = { status: null };
      var functions = this.$firebase.functions();
      if (this.email) {
        functions.httpsCallable('existMail')({ email: this.email.toLowerCase(), sub: this.$vars.verbindung }).then(function (_ref) {
          var data = _ref.data;

          _this.checkMailValue = data;
          _this.loading = false;
        }).catch(function (error) {
          _this.error = error;
          _this.loading = false;
        });
      } else {
        this.checkMailValue = { status: null };
        this.loading = false;
      }
    },
    onSignup: function onSignup() {
      this.loadingBtn = true;
      this.$store.dispatch('user/signUserUp', { email: this.email, password: this.password });
      this.loadingBtn = false;
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      neueEmail: '',
      hinweis: '',
      logoUrl: null
    };
  },
  mounted: function mounted() {
    this.loadLogo();
  },

  computed: {
    user: function user() {
      if (this.$firebase.auth().currentUser) {
        return this.$firebase.auth().currentUser;
      }
    },
    mail: function mail() {
      if (this.$firebase.auth().currentUser) {
        return this.$firebase.auth().currentUser.email;
      }
    },
    mailStatus: function mailStatus() {
      if (this.$firebase.auth().currentUser) {
        return this.$firebase.auth().currentUser.emailVerified;
      }
    }
  },
  methods: {
    loadLogo: function loadLogo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.logoImage();

              case 3:
                url = _context.sent;

                console.log(url);
                _this.logoUrl = url;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error('Error loading logo:', _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    logoImage: function logoImage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                storagePath = '/design/logo/' + _this2.$vars.verbindung;
                _context2.next = 4;
                return _this2.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context2.sent;
                return _context2.abrupt('return', url);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    updateEmail: function updateEmail() {
      var user = this.$firebase.auth().currentUser;
      user.updateEmail(this.neueEmail).then(function () {
        user.sendEmailVerification().then(function () {
          this.hinweis = 'Es wurde eine E-Mail gesendet. In dieser musst du deine Adresse bestätigen.';
          this.neueEmail = '';
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      logoUrl: null
    };
  },
  mounted: function mounted() {
    this.loadLogo();
  },

  computed: {
    mail: function mail() {
      if (this.$firebase.auth().currentUser) {
        return this.$firebase.auth().currentUser.email;
      }
    },
    mailStatus: function mailStatus() {
      if (this.$firebase.auth().currentUser) {
        if (this.$firebase.auth().currentUser.emailVerified) {
          this.$router.push('/');
          return this.$firebase.auth().currentUser.emailVerified;
        }
      }
    }
  },
  watch: {
    mailStatus: function mailStatus(value) {
      if (value) {
        this.$router.push('/');
      }
    },
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/registrieren');
      }
    }
  },
  methods: {
    loadLogo: function loadLogo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.logoImage();

              case 3:
                url = _context.sent;

                console.log(url);
                _this.logoUrl = url;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error('Error loading logo:', _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    logoImage: function logoImage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                storagePath = '/design/logo/' + _this2.$vars.verbindung;
                _context2.next = 4;
                return _this2.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context2.sent;
                return _context2.abrupt('return', url);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    sendVerifizierungsMail: function sendVerifizierungsMail() {
      var user = this.$firebase.auth().currentUser;
      if (!this.$firebase.auth().currentUser.emailVerified) {
        user.sendEmailVerification().then(function () {
          this.$store.state.snackbar = {
            show: true,
            nachricht: 'Dir wurde eine neue Mail zugesandt.'
          };
          console.log('Verification Mail send');
        }).catch(function (error) {
          console.log(error);
        });
      }
      return user;
    },
    reload: function reload() {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(116);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: ''
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.user.user;
    },
    error: function error(state) {
      return state.user.error;
    }
  }),
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      var auth = this.$firebase.auth();
      var emailAddress = this.email;
      auth.sendPasswordResetEmail(emailAddress).then(function () {
        console.log('Mail send');
      }).catch(function (error) {
        console.log(error);
      });
      this.$store.state.snackbar = {
        show: true,
        nachricht: 'Wenn ein Account mit dieser Mailadresse existiert, wurde eine Mail zum zurücksetzen des Passworts wurde versendet. Schau bitte auch in deinem Spam-Ordner nach.'
      };
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('user/clearError');
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funktionen_generatePDFRechnungToLink_js__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["small", "icon", "text", "rechnung", "type"],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {},
  methods: {
    downloadRechnung: function downloadRechnung() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var rechnung, url, kasse, year, storagePath, file, bbr, settings, link;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                rechnung = _this.rechnung;
                _context.prev = 2;
                url = void 0;
                kasse = _this.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
                year = rechnung.rechnungsnummer.split("-")[0];
                storagePath = "rechnungen/" + _this.$vars.verbindung + "/" + year + "/" + rechnung.rechnungsnummer;
                _context.next = 9;
                return _this.$firebase.functions().httpsCallable("existsPDF")({
                  path: storagePath,
                  rechnung: rechnung,
                  kasse: kasse,
                  verein: _this.$vars.verbindung
                });

              case 9:
                file = _context.sent;

                if (!file.data) {
                  _context.next = 14;
                  break;
                }

                url = file.data.url;
                _context.next = 19;
                break;

              case 14:
                bbr = _this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
                settings = _this.$store.getters["einstellungen/einstellung"]("allgemein");
                _context.next = 18;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__funktionen_generatePDFRechnungToLink_js__["a" /* generatePDFRechnungToLink */])(rechnung, kasse, bbr, settings, _this.$vars.verbindung);

              case 18:
                url = _context.sent;

              case 19:
                console.log(url);
                link = document.createElement("a");

                link.setAttribute("href", url);
                link.setAttribute("download", rechnung.rechnungsnummer + ".pdf");
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener noreferrer");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                _context.next = 33;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](2);

                console.log(_context.t0);

              case 33:
                _this.loading = false;

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 30]]);
      }))();
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funktionen_generatePDFRechnungToLink_js__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['small', 'icon', 'text', 'rechnung'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {},
  methods: {
    rechnungVersenden: function rechnungVersenden(rechnung) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var kasse, year, storagePath, file, bbr, settings, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(rechnung);
                _this.loading = true;
                _context.prev = 2;
                kasse = _this.$store.getters['einstellungen/einstellung']('kassen')[rechnung.kasse];
                year = rechnung.rechnungsnummer.split('-')[0];
                storagePath = 'rechnungen/' + _this.$vars.verbindung + '/' + year + '/' + rechnung.rechnungsnummer;
                _context.next = 8;
                return _this.$firebase.functions().httpsCallable('existsPDF')({ path: storagePath, rechnung: rechnung, kasse: kasse, verein: _this.$vars.verbindung });

              case 8:
                file = _context.sent;

                if (file.data) {
                  _context.next = 14;
                  break;
                }

                bbr = _this.$store.getters['bbrbbr/bbr'](rechnung.bbrID);
                settings = _this.$store.getters['einstellungen/einstellung']('allgemein');
                _context.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__funktionen_generatePDFRechnungToLink_js__["a" /* generatePDFRechnungToLink */])(rechnung, kasse, bbr, settings, _this.$vars.verbindung);

              case 14:
                _context.next = 16;
                return _this.$firebase.functions().httpsCallable('sendRechnungen')({
                  rechnungen: [rechnung],
                  verein: _this.$vars.verbindung
                });

              case 16:
                result = _context.sent;

                console.log(result);

                if (!result.data[0].error) {
                  _context.next = 23;
                  break;
                }

                console.log('error');
                throw new Error('Unbekannter Fehler.');

              case 23:
                _this.$store.state.snackbar = {
                  show: true,
                  nachricht: 'Rechnung wurde gesendet!'
                };

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);
                _this.$store.state.snackbar = {
                  show: true,
                  nachricht: 'Fehler beim Versenden der Rechnung:' + _context.t0
                };

              case 30:
                _this.loading = false;

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 26]]);
      }))();
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: ""
    };
  },

  computed: {
    spefuxe: function spefuxe() {
      return this.$store.state.bbrbbr.bbrbbr.filter(function (item) {
        return item.status === "Spefux";
      });
    },
    fuxe: function fuxe() {
      return this.$store.state.bbrbbr.bbrbbr.filter(function (item) {
        return item.status === "Fux";
      });
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["feld", "value"],
  data: function data() {
    return {
      loading: false,
      menuFeldVar: false,
      date: "",
      selectVerbindung: ["V.K.Th. Burgundia im Albertinum", "AV Alania Stuttgart", "AV Alsatia Münster", "AV Cheruscia Münster", "AV Cheruskia Tübingen", "AV Frisia Hannover", "AV Glückauf-Salia Clausthal-Zellerfeld", "AV Guestfalia Tübingen", "AV Hansea (Berlin) Köln", "AV Palatia Göttingen", "AV Rheinstein Köln", "AV Rheno-Guestfalia Kiel", "AV Salia-Silesia Gleiwitz", "AV Silesia (Halle, Bonn) Bochum", "AV Sparrenberg Bielefeld", "AV Suebo-Danubia Ulm", "AV Tuisconia (Königsberg, Bonn) Landshut", "AV Widukind Osnabrück", "AV Zollern Münster", "CV-Verbindung Rheno-Palatia (Breslau) Mainz", "FAV Rheno-Guestfalia (Hann. Münden) Göttingen", "KAV Capitolina Rom", "KAV Suevia Berlin", "KDStV Adolphiana Fulda", "KDStV Aenania München", "KDStV Agilolfia Freising", "KDStV Alania Bonn", "KDStV Alcimonia Eichstätt", "KDStV Alemannia Greifswald und Münster", "KDStV Algovia Augsburg", "KDStV Angrivaria (Sarstedt, Hannover) Dortmund", "KDStV Arminia Freiburg im Breisgau", "KDStV Arminia Heidelberg", "KDStV Ascania Bonn", "KDStV Asgard (Düsseldorf) Köln", "KDStV Aureo-Danubia Ingolstadt", "KDStV Badenia (Straßburg) Frankfurt am Main", "KDStV Baltia (Danzig) Aachen", "KDStV Bavaria Berlin", "KDStV Bavaria Bonn", "KDStV Bergisch-Thuringia Wuppertal", "KDStV Bergland (Freiberg) Aachen", "KDStV Bodensee Konstanz", "KDStV Borusso-Saxonia Berlin", "KDStV Borusso-Westfalia Bonn", "KDStV Burgundia (Leipzig) Düsseldorf", "KDStV Burgundia München", "KDStV Carolingia Hohenheim", "KDStV Carolus Magnus Saarbrücken", "KDStV Cheruscia Würzburg", "KDStV Churpfalz Mannheim", "KDStV Chursachsen Dresden", "KDStV Churtrier Trier", "KDStV Elbmark (Tetschen-Liebwerd) Duisburg", "KDStV Falkenstein Freiburg im Breisgau", "KDStV Ferdinandea (Prag) Heidelberg", "KDStV Franco-Raetia Würzburg", "KDStV Franconia Aachen", "KDStV Frankonia (Czernowitz) Erlangen", "KDStV Fredericia Bamberg", "KDStV Germania Leipzig", "KDStV Gothia Erlangen", "KDStV Gothia Würzburg", "KDStV Greiffenstein (Breslau) Frankfurt", "KDStV Guestfalo-Silesia Paderborn", "KDStV Hasso-Nassovia Frankfurt am Main", "KDStV Hercynia Freiburg im Breisgau", "KDStV Hohenstaufen Freiburg im Breisgau", "KDStV Kaiserpfalz Aachen", "KDStV Langobardia (München) Bayreuth", "KDStV Makaria (Berlin) Aachen", "KDStV Marchia (Breslau) Aachen", "KDStV Markomannia Würzburg", "KDStV Merowingia Kaiserslautern", "KDStV Moenania München", "KDStV Moeno-Franconia Frankfurt am Main", "KDStV Nassovia Darmstadt", "KDStV Nibelungia (Brünn) Darmstadt", "KDStV Niedersachsen Braunschweig", "KDStV Norbertina Magdeburg", "KDStV Nordgau (Prag, Stuttgart) Koblenz", "KDStV Nordmark (Rostock, Karlsruhe) Essen", "KDStV Normannia Karlsruhe", "KDStV Novesia Bonn", "KDStV Oeno-Danubia Passau", "KDStV Ostmark Nürnberg", "KDStV Palatia Marburg", "KDStV Palatina Amberg/Weiden", "KDStV Radaspona (Regensburg) München", "KDStV Rappoltstein (Straßburg) Köln", "KDStV Rheinland Köln", "KDStV Rheinpfalz Darmstadt", "KDStV Rhenania-Moguntia Mainz", "KDStV Rheno-Baltia Köln", "KDStV Rheno-Franconia München", "KDStV Rheno-Saxonia (Köthen) Halle", "KDStV Ripuaria Aachen", "KDStV Ripuaria Bonn", "KDStV Ripuaria Freiburg im Breisgau", "KDStV Rupertia Regensburg", "KDStV Saarland (Saarbrücken) Jena", "KDStV Sauerlandia Münster", "KDStV Saxo-Silesia Hannover", "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum", "KDStV Schwarzwald Karlsruhe", "KDStV Seraphina Lippstadt", "KDStV Staufia Bonn", "KDStV Sugambria (Jena) Göttingen", "KDStV Teuto-Rhenania Hannover", "KDStV Teutonia Freiburg im Üechtland", "KDStV Thuringia Würzburg", "KDStV Trifels München", "KDStV Tuiskonia München", "KDStV Vandalia (Prag) München", "KDStV Vasgovia Landau", "KDStV Vindelicia München", "KDStV Welfia Weingarten", "KDStV Wiking Hamburg", "KDStV Wildenstein Freiburg im Breisgau", "KDStV Winfridia (Breslau) Münster", "KStV Thuringia Coburg", "KTV Visurgis Bremen", "VKDSt Hasso-Rhenania Gießen", "VKDSt Hasso-Rhenania Mainz", "VKDSt Rhenania Marburg", "VKDSt Saxonia Münster"],
      itemsAnrede: ["Herr", "Frau", "Familie"],
      itemsBriefanrede: ["Lieber Bundesbruder", "Sehr geehrter Cartellbruder", "Sehr geehrter Farbenbruder", "Sehr geehrter Herr", "Sehr geehrte Frau", "Sehr geehrte Damen und Herren", "Liebe", "Lieber"],
      itemsZirkel: ["Aachen", "Berlin", "Bonn/Köln", "Düsseldorf/Neuss", "Essen", "Koblenz", "München", "Niederrhein"],
      itemsGruppen: ["HBV-Mitglieder", "HBV-Beirat", "Vorstände", "AHV-Vorstand", "HBV-Vorstand", "Aktive Chargen", "80er"],
      rules: {
        required: function required(value) {
          return !!value || false;
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return value === "" || pattern.test(value) || "Flasches E-Mail-Format";
        },
        telefonnummer: function telefonnummer(value) {
          var pattern = /^\+([0-9]){2}[ ][1-9]([0-9]){2}[0-9]?[ ]([0-9]?){12}$/g;
          return value === "" || pattern.test(value) || "Flasches Telefonnummern-Format. Es muss +49 123 456789123 entsprechen";
        },
        geld: function geld(value) {
          var pattern = /^[0-9]([0-9]?){10}([.]([0-9]?){2})?$/g;
          return value === "" || pattern.test(value) || "Flasches Format. Es muss 13.45 entsprechen";
        }
      }
    };
  },

  computed: {
    formatDate: function formatDate() {
      if (this.feld.type !== "Date") return null;
      if (!this.value) return null;
      return new Date(this.value).toLocaleString(["de-de"], { month: "long", day: "numeric", year: "numeric" });
    },
    itemsStatus: function itemsStatus() {
      var status = [];
      this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach(function (item) {
        status.push(item.status);
      });
      return status;
    }
  },
  methods: {
    clearValue: function clearValue() {
      this.value = "";
      this.sendDataBack();
    },
    formatMoney: function formatMoney() {
      var moneyValue = this.value.trim().replace(/\s+/g, "");
      moneyValue = moneyValue.replace(",", ".").replace(/[^0-9.]/g, "");

      var parts = moneyValue.split(".");
      if (parts.length > 2) {
        moneyValue = parts[0] + "." + parts.slice(1).join("");
      }

      if (moneyValue.includes(".")) {
        var _moneyValue$split = moneyValue.split("."),
            _moneyValue$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_moneyValue$split, 2),
            integerPart = _moneyValue$split2[0],
            decimalPart = _moneyValue$split2[1];

        moneyValue = integerPart + "." + decimalPart.substring(0, 2);
      }
      this.value = moneyValue;
    },
    formatPhoneNumber: function formatPhoneNumber() {
      var phoneNumber = this.value.trim().replace(/\s+/g, "");
      if (phoneNumber.startsWith("+")) {
        phoneNumber = "+" + phoneNumber.substring(1).replace(/[^0-9]/g, "");
      } else if (phoneNumber.startsWith("0")) {
        phoneNumber = "+49" + phoneNumber.substring(1).replace(/[^0-9]/g, "");
      }
      if (phoneNumber.length >= 3) {
        phoneNumber = phoneNumber.replace(/(\d{2})(\d{3})(\d{1,})/, "$1 $2 $3");
      }
      this.value = phoneNumber;
    },
    sendDataBack: function sendDataBack() {
      this.$emit("dataChange", this.value, this.feld);
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["kontakt"],
  data: function data() {
    return {
      headers: [{ text: "", align: "left", value: "index" }, { text: "Rechnungsnummer", align: "left", value: "rechnungsnummer" }, { text: "Titel", align: "left", value: "rechnung_titel" }, { text: "Kasse", align: "left", value: "kasse" }, { text: "Rechnungsdatum", align: "right", value: "rechnung_datum" }, { text: "Zahlbar bis", align: "right", value: "rechnung_zahlbar_bis" }, { text: "Summe", align: "right", value: "summe" }, { text: "", align: "left", value: "status" }],
      search: "",
      showRechnung: false,
      rechnungid: "",
      selectRechnung: [],
      selected: [],
      tabs: 0
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      if (this.kontakt) {
        return this.kontakt;
      } else {
        return this.$getCurrentBbr();
      }
    },
    rechnungen: function rechnungen() {
      this.$vars.loading = true;
      if (this.kontakt) {
        if (this.$store.state.rechnungen.loaded === false) {
          this.$store.dispatch("rechnungen/loadRechnungen");
        }
      } else {
        if (this.$store.state.rechnungen.loadedEigene === false) {
          if (this.currentBbr != null) {
            this.$store.dispatch("rechnungen/loadEigeneRechnungen", { user: this.currentBbr });
          }
        }
      }
      var rechnungen = this.$store.getters["rechnungen/nutzerRechnungen"](this.currentBbr);
      rechnungen.forEach(function (rechnung) {
        if (rechnung.status === "Entwurf" || rechnung.status === "Entwurf SEPA") {
          rechnungen.splice(rechnungen.indexOf(rechnung), 1);
        }
        rechnung.jahr = rechnung.rechnung_datum.split("-")[0];
      });
      var key = "jahr";
      var result = {};
      var tabs = 0;
      rechnungen.forEach(function (item) {
        if (!result[item[key]]) {
          result[item[key]] = [];
          tabs++;
        }
        result[item[key]].push(item);
      });
      this.tabs = tabs - 1;
      this.$vars.loading = false;
      return result;
    },
    sideHeight: function sideHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "calc(100vh - 249px)";
        case "sm":
          return "calc(100vh - 249px)";
        case "md":
          return "calc(100vh - 249px)";
        case "lg":
          return "calc(100vh - 249px)";
        case "xl":
          return "calc(100vh - 249px)";
      }
    }
  },
  methods: {
    showRechnungMethod: function showRechnungMethod() {
      this.showRechnung = true;
      this.$firebase.analytics().logEvent("showRechnung", {
        currentBbr: this.currentBbr,
        rechnungID: this.selectRechnung.id,
        name: this.currentBbr
      });
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      sideNav: false,
      singleSelect: false,
      selected: [],
      expanded: [],
      bbr: {},
      showKontakt: false,
      menu: '',
      date: '',
      headers: [{ number: '0', text: '0', align: 'left', value: 'bild', type: 'fix' }, { number: '1', text: '200', align: 'left', value: 'bild200', type: 'fix' }, { number: '2', text: '500', align: 'left', value: 'bild500', type: 'fix' }, { number: '3', text: 'Nummer', align: 'left', value: 'rbonummer' }, { number: '4', text: 'Nachname', align: 'left', value: 'nachname' }, { number: '5', text: 'Vorname', align: 'left', value: 'vorname' }],
      sortBy: 'Nachname'
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.getters['bbrbbr/nurBbrbbr'];
    },
    sideHeight: function sideHeight() {
      if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'calc(100vh - 191px)';
          case 'sm':
            return 'calc(100vh - 169px)';
          case 'md':
            return 'calc(100vh - 199px)';
          case 'lg':
            return 'calc(100vh - 191px)';
          case 'xl':
            return 'calc(100vh - 191px)';
        }
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'calc(100vh - 189px)';
          case 'sm':
            return 'calc(100vh - 189px)';
          case 'md':
            return 'calc(100vh - 189px)';
          case 'lg':
            return 'calc(100vh - 189px)';
          case 'xl':
            return 'calc(100vh - 189px)';
        }
      }
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["on"],
  data: function data() {
    return {
      selected: [],
      search: "",
      headers: [{ text: "Datum", value: "datum" }, { text: "Lieferant", value: "lieferant" }, { text: "Rechnungsnummer", value: "rechnungsnummer" }, { text: "Rechnungsbetrag", align: "right", value: "gesamt" }, { text: "Status", value: "status" }, { text: "", value: "download" }, { text: "", sortable: false, value: "" }],
      file: [],
      menu: false,
      getrank: "",
      pfand: "",
      anzahlGetrank: 0,
      anzahlPfand: 0,
      item: "",
      dialogUploadFile: false,
      showLieferung: false,
      tabs: 0,
      neuLieferung: false,
      lieferung: {},
      neueLieferung: {
        datum: new Date().toISOString().substr(0, 10),
        rechnungsnummer: "",
        positionen: [],
        positionenPfand: [],
        rabatt: 0,
        zahlungsdatum: ""
      },
      handler: ["Bier Schneider", "Oettinger", "Metro", "Getränke Vendel", "Rewe", "Vinos"],
      showDeleteLieferung: false
    };
  },

  computed: {
    bierlieferungen: function bierlieferungen() {
      if (this.$store.state.bierlieferungen.bierlieferungen.length === 0) {
        this.$store.dispatch("bierlieferungen/loadBierlieferungen");
      }
      var lieferungen = this.$store.state.bierlieferungen.bierlieferungen;
      lieferungen.forEach(function (lieferung) {
        lieferung.jahr = lieferung.datum.split("-")[0];
      });
      var key = "jahr";
      var result = {};
      var tabs = 0;
      lieferungen.forEach(function (item) {
        if (!result[item[key]]) {
          result[item[key]] = [];
          tabs++;
        }
        result[item[key]].push(item);
      });
      this.tabs = tabs - 1;
      return result;
    },
    getranke: function getranke() {
      var getranke = [];
      if (this.$store.state.getranke.getranke.length === 0) {
        this.$store.dispatch("getranke/loadGetranke");
      }
      var alleGetranke = [];
      this.$store.state.getranke.getranke.forEach(function (item) {
        if (item.switchBestellung) {
          alleGetranke.push(item);
        }
      });
      alleGetranke = alleGetranke.sort(function (a, b) {
        return a.nummer - b.nummer;
      });
      alleGetranke.forEach(function (item) {
        getranke.push({
          id: item.id,
          text: item.bezeichnung,
          nummer: item.nummer,
          value: {
            item: item,
            id: item.id
          }
        });
      });
      return getranke;
    },
    summe: function summe() {
      var summe = 0;
      if (this.lieferung.positionen) {
        this.lieferung.positionen.forEach(function (position) {
          summe = summe + parseFloat(position.summe);
        });
      }
      if (this.lieferung.rabatt) {
        summe = summe - this.lieferung.rabatt;
      }
      return summe.toFixed(2);
    },
    summePfand: function summePfand() {
      var summe = 0;
      if (this.lieferung.positionen) {
        this.lieferung.positionen.forEach(function (position) {
          summe = summe + parseFloat(position.pfand);
        });
      }
      if (this.lieferung.positionenPfand) {
        this.lieferung.positionenPfand.forEach(function (position) {
          summe = summe - parseFloat(position.pfand);
        });
      }
      return summe;
    },
    summeMwst: function summeMwst() {
      return (parseFloat(this.summe) + parseFloat(this.summePfand)) * 0.19;
    },
    summeGesamt: function summeGesamt() {
      return parseFloat(this.summe) + parseFloat(this.summePfand) + parseFloat(this.summeMwst);
    },
    hideHeader: function hideHeader() {
      return this.$vuetify.breakpoint.name === "xs";
    }
  },
  methods: {
    showDialogUploadFile: function showDialogUploadFile(item) {
      this.dialogUploadFile = true;
      this.item = item;
    },
    downloadFile: function downloadFile(id) {
      this.$firebase.storage().ref("bierrechnungen/" + id).getDownloadURL().then(function (url) {
        window.open(url);
      }).catch(function (error) {
        console.log(error);
      });
    },
    uploadFile: function uploadFile() {
      var id = this.item.id;
      this.$firebase.storage().ref("bierrechnungen/" + id).put(this.file).then(function (snapshot) {
        this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("bierlieferungen").doc(id).update({ download: snapshot.ref.fullPath });
        (function (err) {
          console.log("Encountered error: " + err);
        });
      });
      this.file = [];
      this.dialogUploadFile = false;
    },
    delGetrank: function delGetrank(item) {
      this.lieferung.positionen.splice(this.lieferung.positionen.indexOf(item), 1);
      this.$forceUpdate;
    },
    delPfand: function delPfand(item) {
      this.lieferung.positionenPfand.splice(this.lieferung.positionenPfand.indexOf(item), 1);
      this.$forceUpdate;
    },
    addGetrank: function addGetrank() {
      if (!this.lieferung.positionen) {
        this.lieferung.positionen = [];
      }
      this.lieferung.positionen.push({
        id: this.getrank.id,
        bezeichnung: this.getrank.item.bezeichnung,
        anzahl: this.anzahlGetrank,
        netto: (this.getrank.item.preis / 1.19).toFixed(2),
        pfand: (this.getrank.item.pfand * this.anzahlGetrank).toFixed(2),
        summe: (this.getrank.item.preis / 1.19 * this.anzahlGetrank).toFixed(2)
      });
      this.getrank = "";
      this.anzahlGetrank = 0;
      this.$forceUpdate;
    },
    addPfand: function addPfand() {
      if (!this.lieferung.positionenPfand) {
        this.lieferung.positionenPfand = [];
      }
      this.lieferung.positionenPfand.push({
        id: this.pfand.id,
        bezeichnung: this.pfand.item.bezeichnung,
        anzahl: this.anzahlPfand,
        pfand: this.pfand.item.pfand * this.anzahlPfand
      });
      this.pfand = "";
      this.anzahlPfand = 0;
      this.$forceUpdate;
    },
    updateDate: function updateDate(value) {
      this.lieferung.datum = new Date(this.lieferung.datum);
      this.lieferung.datum = new Date(this.lieferung.datum.setDate(this.lieferung.datum.getDate() + value)).toISOString().substr(0, 10);
    },
    updateLieferung: function updateLieferung() {
      this.lieferung.betrag = this.summe;
      this.lieferung.pfand = this.summePfand;
      this.lieferung.mwst = this.summeMwst;
      this.lieferung.gesamt = this.summeGesamt;
      this.$store.dispatch("bierlieferungen/updateBierlieferungData", this.lieferung);
      this.showLieferung = false;
      this.lieferung = [];
    },
    saveLieferung: function saveLieferung() {
      this.lieferung.betrag = this.summe;
      this.lieferung.pfand = this.summePfand;
      this.lieferung.mwst = this.summeMwst;
      this.lieferung.gesamt = this.summeGesamt;
      this.lieferung.status = "Erstellt";
      this.$store.dispatch("bierlieferungen/createBierlieferung", this.lieferung);
      this.showLieferung = false;
      this.lieferung = [];
    },
    deleteLieferung: function deleteLieferung() {
      this.$store.dispatch("bierlieferungen/deleteBierlieferungData", this.lieferung.id);
      this.showLieferung = false;
      this.lieferung = [];
      this.showDeleteLieferung = false;
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["on"],
  data: function data() {
    return {
      headers: [{ text: "Bezeichnung", align: "left", value: "bezeichnung" }, { text: "Preis", align: "right", value: "preis" }, { text: "Gebinde", align: "right", value: "gebinde" }, { text: "Verkauf 1", align: "right", value: "verkauf1" }, { text: "Verkauf 2", align: "right", value: "verkauf2" }, { text: "Verkauf 3", align: "right", value: "verkauf3" }],
      kategorien: ["Bier", "Softdrinks", "Wein & Schnaps"],
      selected: [],
      search: "",
      showGetrank: false,
      getrank: [],
      neuGetrank: false,
      showDeleteGetrank: false,
      num: 0,
      anzahl: 12
    };
  },

  computed: {
    sideHeight: function sideHeight() {
      if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 191px)";
          case "sm":
            return "calc(100vh - 169px)";
          case "md":
            return "calc(100vh - 199px)";
          case "lg":
            return "calc(100vh - 191px)";
          case "xl":
            return "calc(100vh - 191px)";
        }
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 189px)";
          case "sm":
            return "calc(100vh - 189px)";
          case "md":
            return "calc(100vh - 189px)";
          case "lg":
            return "calc(100vh - 189px)";
          case "xl":
            return "calc(100vh - 189px)";
        }
      }
    },
    getranke: function getranke() {
      if (this.$store.state.getranke.getranke.length === 0) {
        this.$store.dispatch("getranke/loadGetranke");
      }
      return this.$store.state.getranke.getranke;
    },
    statistiken: function statistiken() {
      var _this = this;

      if (this.$store.state.statistiken.statistiken.length === 0) {
        this.$store.dispatch("statistiken/loadStatistiken");
      }
      var currentMonat = new Date(new Date().setMonth(new Date().getMonth() - this.anzahl)).toISOString().substr(0, 7);
      var monate = [];
      this.$store.state.statistiken.statistiken.forEach(function (monat) {
        if (monat.monat >= currentMonat) {
          monate.push(monat);
        }
      });
      var ergebnis = {
        eingekauft: { data: [], summe: 0, max: 0 },
        ekp: { data: [], summe: 0, max: 0 },
        verbraucht: { data: [], summe: 0, max: 0 },
        anfang: { data: [] },
        ende: { data: [] },
        monate: []
      };
      if (this.getrank.bezeichnung) {
        var kategorie = "";
        if (this.getrank.kategorie === "Bier") {
          kategorie = "verbrauchBier";
        }
        if (this.getrank.kategorie === "Softdrinks") {
          kategorie = "verbrauchSoftdrinks";
        }
        if (this.getrank.kategorie === "Wein & Schnaps") {
          kategorie = "verbrauchWeinSchnaps";
        }
        monate.forEach(function (monat) {
          var elemente = monat[kategorie].find(function (item) {
            return item.bezeichnung === _this.getrank.bezeichnung;
          });
          if (elemente) {
            ergebnis.eingekauft.data.push(elemente.eingekauft);
            ergebnis.eingekauft.summe += parseInt(elemente.eingekauft);
            if (ergebnis.eingekauft.max < parseInt(elemente.eingekauft)) {
              ergebnis.eingekauft.max === parseInt(elemente.eingekauft);
            }
            ergebnis.ekp.data.push(elemente.ekp);
            ergebnis.ekp.summe += parseInt(elemente.ekp);
            if (ergebnis.ekp.max < parseInt(elemente.ekp)) {
              ergebnis.ekp.max === parseInt(elemente.ekp);
            }
            ergebnis.verbraucht.data.push(elemente.verbraucht);
            ergebnis.verbraucht.summe += parseInt(elemente.verbraucht);
            if (ergebnis.verbraucht.max < parseInt(elemente.verbraucht)) {
              ergebnis.verbraucht.max === parseInt(elemente.verbraucht);
            }
            ergebnis.anfang.data.push(elemente.anfang);
            ergebnis.ende.data.push(elemente.ende);
            ergebnis.monate.push(monat.monat);
          }
        });
      }
      return ergebnis;
    },
    preisexcl: function preisexcl() {
      if (this.getrank.preis) {
        return (this.getrank.preis.replace(",", ".") / 119 * 100).toFixed(2);
      } else {
        return;
      }
    }
  },
  methods: {
    createGetrank: function createGetrank() {
      var getrank = {
        bezeichnung: this.getrank.bezeichnung,
        kategorie: this.getrank.kategorie,
        striche: this.getrank.striche,
        switchBestellung: this.getrank.switchBestellung,
        switchEkp: this.getrank.switchEkp,
        switchPfand: this.getrank.switchPfand,
        switchZahlung: this.getrank.switchZahlung,
        verkaufseinheit: this.getrank.verkaufseinheit,
        volumen: parseFloat(this.getrank.volumen.replace(",", ".")).toFixed(2),
        preis: parseFloat(this.getrank.preis.replace(",", ".")).toFixed(2),
        pfand: parseFloat(this.getrank.pfand.replace(",", ".")).toFixed(2),
        verkauf1: parseFloat(this.getrank.verkauf1.replace(",", ".")).toFixed(2),
        verkauf2: parseFloat(this.getrank.verkauf2.replace(",", ".")).toFixed(2),
        verkauf3: parseFloat(this.getrank.verkauf3.replace(",", ".")).toFixed(2)
      };
      console.log(getrank);
      this.$store.dispatch("getranke/createGetrank", getrank);
      this.showGetrank = false;
      this.getrank = [];
    },
    updateGetrank: function updateGetrank() {
      this.getrank.volumen = parseFloat(this.getrank.volumen.replace(",", ".")).toFixed(2);
      this.getrank.preis = parseFloat(this.getrank.preis.replace(",", ".")).toFixed(2);
      this.getrank.pfand = parseFloat(this.getrank.pfand.replace(",", ".")).toFixed(2);
      this.getrank.verkauf1 = parseFloat(this.getrank.verkauf1.replace(",", ".")).toFixed(2);
      this.getrank.verkauf2 = parseFloat(this.getrank.verkauf2.replace(",", ".")).toFixed(2);
      this.getrank.verkauf3 = parseFloat(this.getrank.verkauf3.replace(",", ".")).toFixed(2);
      this.$store.dispatch("getranke/updateGetrankData", this.getrank);
      this.showGetrank = false;
      this.getrank = [];
    },
    deleteGetrank: function deleteGetrank() {
      this.$store.dispatch("getranke/deleteGetrankData", this.getrank.id);
      this.showGetrank = false;
      this.getrank = [];
      this.showDeleteGetrank = false;
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["on"],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
  },
  data: function data() {
    return {
      anzahlGetrank: 0,
      anzahlPfand: 0,
      getrank: "",
      getranke_zahlen: [],
      headers: [{ text: "Datum", align: "left", value: "datum" }, { text: "Gezählt von", value: "zahler" }, { text: "Volumen", value: "volumen" }, { text: "Wert", value: "gesamt" }, { text: "", sortable: false, value: "" }],
      headersTabelleGetranke: [{ text: "", align: "left", value: "nummer" }, { text: "Bezeichnung", align: "left", value: "bezeichnung" }, { text: "Anzahl", align: "left", value: "anzahl" }],
      menu: false,
      neueZahlung: {
        datum: new Date().toISOString().substr(0, 10),
        rechnungsnummer: "",
        positionen: [],
        positionenPfand: [],
        rabatt: 0,
        zahlungsdatum: ""
      },
      neuZahlung: false,
      pfand: "",
      tabs: 0,
      search: "",
      selected: [],
      showDeleteZahlung: false,
      showGetrankeStand: false,
      showSpeedInsert: false,
      zahlung: {},
      tabelleGetranke: [],
      rules: {
        number: function number(value) {
          var pattern = /^[0-9]*$/;
          return pattern.test(value) || "Nur Zahlen erlaubt";
        }
      }
    };
  },

  computed: {
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    getrankestande: function getrankestande() {
      var _this = this;

      if (this.$store.state.getrankeStand.getrankeStande.length === 0) {
        this.$store.dispatch("getrankeStand/loadGetrankeStande");
      }
      var zahlungen = this.$store.state.getrankeStand.getrankeStande;
      zahlungen.forEach(function (zahlung) {
        zahlung.jahr = zahlung.datum.split("-")[0];
        zahlung.volumen = 0;
        zahlung.positionen.forEach(function (pos) {
          var getrank = _this.$store.getters["getranke/getrank"](pos.id);
          zahlung.volumen += pos.anzahl * getrank.volumen;
        });
      });
      var key = "jahr";
      var result = {};
      var tabs = 0;
      zahlungen.forEach(function (item) {
        if (!result[item[key]]) {
          result[item[key]] = [];
          tabs++;
        }
        result[item[key]].push(item);
      });
      this.tabs = tabs - 1;
      return result;
    },
    hideHeader: function hideHeader() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    getranke: function getranke() {
      var getranke = [];
      if (this.$store.state.getranke.getranke.length === 0) {
        this.$store.dispatch("getranke/loadGetranke");
      }
      var alleGetranke = [];
      this.$store.state.getranke.getranke.forEach(function (item) {
        if (item.switchZahlung) {
          alleGetranke.push(item);
        }
      });
      alleGetranke = alleGetranke.sort(function (a, b) {
        return a.nummer - b.nummer;
      });
      alleGetranke.forEach(function (item) {
        getranke.push({
          id: item.id,
          text: item.bezeichnung,
          nummer: item.nummer,
          value: {
            item: item,
            id: item.id
          }
        });
      });
      return getranke;
    },
    summe: function summe() {
      var summe = 0;
      if (this.zahlung.positionen) {
        this.zahlung.positionen.forEach(function (position) {
          summe = summe + parseFloat(position.summe);
        });
      }
      return summe;
    },
    summePfand: function summePfand() {
      var summe = 0;
      if (this.zahlung.positionen) {
        this.zahlung.positionen.forEach(function (position) {
          summe = summe + parseFloat(position.pfand);
        });
      }
      if (this.zahlung.positionenPfand) {
        this.zahlung.positionenPfand.forEach(function (position) {
          summe = summe + parseFloat(position.pfand);
        });
      }
      return summe;
    },
    summeMwst: function summeMwst() {
      return parseFloat(((parseFloat(this.summe) + parseFloat(this.summePfand)) * 0.19).toFixed(2));
    },
    summeGesamt: function summeGesamt() {
      return (parseFloat(this.summe) + parseFloat(this.summePfand) + parseFloat(this.summeMwst)).toFixed(2);
    }
  },
  methods: {
    delGetrank: function delGetrank(item) {
      this.zahlung.positionen.splice(this.zahlung.positionen.indexOf(item), 1);
    },
    delPfand: function delPfand(item) {
      this.zahlung.positionenPfand.splice(this.zahlung.positionenPfand.indexOf(item), 1);
    },
    addGetrank: function addGetrank() {
      this.zahlung.positionen.push({
        id: this.getrank.id,
        bezeichnung: this.getrank.item.bezeichnung,
        anzahl: this.anzahlGetrank,
        netto: (this.getrank.item.preis / this.getrank.item.verkaufseinheit / 1.19).toFixed(2),
        pfand: (this.getrank.item.pfand * this.anzahlGetrank / this.getrank.item.verkaufseinheit).toFixed(2),
        summe: (this.getrank.item.preis / this.getrank.item.verkaufseinheit / 1.19 * this.anzahlGetrank).toFixed(2)
      });
      this.getrank = "";
      this.anzahlGetrank = 0;
    },
    addPfand: function addPfand() {
      this.zahlung.positionenPfand.push({
        id: this.pfand.id,
        bezeichnung: this.pfand.item.bezeichnung,
        anzahl: this.anzahlPfand,
        pfand: this.pfand.item.pfand * this.anzahlPfand
      });
      this.pfand = "";
      this.anzahlPfand = "";
    },
    updateDate: function updateDate(value) {
      this.zahlung.datum = new Date(this.zahlung.datum);
      this.zahlung.datum = new Date(this.zahlung.datum.setDate(this.zahlung.datum.getDate() + value)).toISOString().substr(0, 10);
    },
    updateZahlung: function updateZahlung() {
      this.zahlung.betrag = this.summe;
      this.zahlung.pfand = this.summePfand;
      this.zahlung.mwst = this.summeMwst;
      this.zahlung.gesamt = this.summeGesamt;
      this.$store.dispatch("getrankeStand/updateGetrankeStandData", this.zahlung);
      this.showGetrankeStand = false;
      this.zahlung = [];
    },
    saveZahlung: function saveZahlung() {
      this.zahlung.betrag = this.summe;
      this.zahlung.pfand = this.summePfand;
      this.zahlung.mwst = this.summeMwst;
      this.zahlung.gesamt = this.summeGesamt;
      this.zahlung.zahler = this.currentBbr;
      this.$store.dispatch("getrankeStand/createGetrankeStand", this.zahlung);
      this.showGetrankeStand = false;
      this.zahlung = [];
    },
    deleteZahlung: function deleteZahlung() {
      this.$store.dispatch("getrankeStand/deleteGetrankeStandeData", this.zahlung.id);
      this.showGetrankeStand = false;
      this.zahlung = [];
      this.showDeleteZahlung = false;
    },
    calcTabelleGetranke: function calcTabelleGetranke() {
      var tabelleGetranke = [];
      this.getranke.forEach(function (item) {
        tabelleGetranke.push({
          id: item.id,
          nummer: item.nummer,
          getrank: item,
          bezeichnung: item.text,
          anzahl: ""
        });
      });
      tabelleGetranke = tabelleGetranke.sort(function (a, b) {
        return a.nummer - b.nummer;
      });
      this.tabelleGetranke[0] = tabelleGetranke.slice(0, Math.ceil(tabelleGetranke.length / 4));
      this.tabelleGetranke[1] = tabelleGetranke.slice(Math.ceil(tabelleGetranke.length / 4), Math.ceil(tabelleGetranke.length / 4 * 2));
      this.tabelleGetranke[2] = tabelleGetranke.slice(Math.ceil(tabelleGetranke.length / 4 * 2), Math.ceil(tabelleGetranke.length / 4 * 3));
      this.tabelleGetranke[3] = tabelleGetranke.slice(Math.ceil(tabelleGetranke.length / 4 * 3), tabelleGetranke.length);
    },
    savereihenfolge: function savereihenfolge() {
      var _this2 = this;

      var nummer = 1;
      this.tabelleGetranke.forEach(function (value) {
        value.forEach(function (item) {
          var update = {
            id: item.id,
            nummer: nummer
          };
          _this2.$store.dispatch("getranke/updateGetrankData", update);
          nummer++;
        });
      });
    },
    insertGertranke: function insertGertranke() {
      var _this3 = this;

      this.tabelleGetranke.forEach(function (value) {
        value.forEach(function (item) {
          if (parseInt(item.anzahl) > 0) {
            _this3.zahlung.positionen.push({
              id: item.getrank.value.item.id,
              bezeichnung: item.getrank.value.item.bezeichnung,
              anzahl: parseInt(item.anzahl),
              netto: parseFloat(item.getrank.value.item.preis / item.getrank.value.item.verkaufseinheit / 1.19).toFixed(2),
              pfand: parseFloat(item.getrank.value.item.pfand * item.anzahl / item.getrank.value.item.verkaufseinheit).toFixed(2),
              summe: parseFloat(item.getrank.value.item.preis / item.getrank.value.item.verkaufseinheit / 1.19 * item.anzahl).toFixed(2)
            });
            item.anzahl = "";
          }
        });
      });
      this.showSpeedInsert = false;
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ekpInSchankverlust: false,
      showSchankverlustData: false,
      showNurBbrBbr: true,
      showArray: "schankverlust",
      showDebug: false,
      monate: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      monatSelect: "",
      jahrSelect: "",
      filterVon: "2022-02-01",
      filterBis: "2022-03-01",
      series: [{ name: "" }],
      gesamtvermogen: {},
      errorMessage: "Error",
      options: {
        chart: {
          toolbar: {
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          },
          type: "bar",
          stacked: true
        },
        dataLabels: { enabled: false },
        colors: ["#254fb3", "#EF5350", "#FFC107"],
        stroke: { width: 0 },
        tooltip: {
          y: {
            formatter: function formatter(val, index) {
              return val.toFixed(0);
            }
          }
        },
        yaxis: {
          min: 0,
          tickAmount: 5,
          title: { text: undefined },
          labels: {
            formatter: function formatter(val, index) {
              return val.toFixed(0);
            }
          }
        },
        xaxis: {
          title: { text: undefined }
        },
        fill: {
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          opacity: 1,
          type: "solid"
        },
        legend: { show: false }
      },
      options2: {
        chart: {
          width: "100%",
          toolbar: {
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          }
        },
        dataLabels: { enabled: false },
        stroke: { width: 0 },
        yaxis: {
          min: 0,
          labels: { show: false }
        },
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          xaxis: { lines: { show: false } },
          yaxis: { lines: { show: false } }
        },
        xaxis: {
          labels: { show: false },
          axisTicks: { show: false },
          axisBorder: { show: false }
        },
        tooltip: { enabled: false },
        fill: {
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          opacity: 1,
          type: "solid"
        },
        legend: { show: false }
      },
      options3: {
        chart: {
          width: "100%",
          toolbar: {
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          }
        },
        dataLabels: { enabled: false },
        stroke: { width: 0 },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            show: false
          }
        },
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          xaxis: { lines: { show: false } },
          yaxis: { lines: { show: false } }
        },
        xaxis: {
          labels: { show: false },
          axisTicks: { show: false },
          axisBorder: { show: false }
        },
        tooltip: { enabled: false },
        fill: {
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          opacity: 1,
          type: "solid"
        },
        legend: { show: false }
      },
      options4: {
        chart: {
          toolbar: {
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          },
          type: "bar",
          stacked: false
        },
        dataLabels: { enabled: false },
        tooltip: {
          y: {
            formatter: function formatter(val, index) {
              return val.toFixed(2) + "%";
            }
          }
        },
        stroke: { width: 0 },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
          title: { text: undefined },
          labels: {
            formatter: function formatter(val, index) {
              return val.toFixed(0) + "%";
            }
          }
        },
        fill: {
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          opacity: 1,
          type: "solid"
        },
        legend: { show: false }
      }
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    nurbbrbbr: function nurbbrbbr() {
      return this.$store.getters["bbrbbr/nurBbrbbr"];
    },
    strichpreis: function strichpreis() {
      var strichpreis = this.$store.getters["einstellungen/einstellung"]("strichpreis");
      if (strichpreis) {
        return strichpreis.strichpreis;
      } else {
        return "";
      }
    },
    jahre: function jahre() {
      var jahre = [];
      var min = Infinity;
      if (this.daten.length > 0) {
        this.daten.forEach(function (datum) {
          if (min > datum.substr(0, 4)) {
            min = datum.substr(0, 4);
          }
        });

        min = 2021;
        for (var i = min; i <= new Date().getFullYear(); i++) {
          jahre.push(parseInt(i));
        }
      } else {
        jahre.push(new Date().getFullYear());
      }
      if (new Date().getMonth() === 0) {
        this.jahrSelect = jahre.indexOf(new Date().getFullYear()) - 1;
        this.monatSelect = 11;
      } else {
        this.jahrSelect = jahre.indexOf(new Date().getFullYear());
        this.monatSelect = new Date().getMonth() - 1;
      }
      return jahre;
    },
    lieferungen: function lieferungen() {
      if (this.$store.state.bierlieferungen.bierlieferungen.loaded === false) {
        this.$store.dispatch("bierlieferungen/loadBierlieferungen");
      }
      return this.$store.state.bierlieferungen.bierlieferungen;
    },
    zahlungen: function zahlungen() {
      if (this.$store.state.getrankeStand.getrankeStande.length === 0) {
        this.$store.dispatch("getrankeStand/loadGetrankeStande");
      }
      return this.$store.state.getrankeStand.getrankeStande;
    },
    getranke: function getranke() {
      if (this.$store.state.getranke.getranke.length === 0) {
        this.$store.dispatch("getranke/loadGetranke");
      }
      return this.$store.state.getranke.getranke;
    },
    daten: function daten() {
      var daten = [];
      this.zahlungen.forEach(function (zahlung) {
        daten.push(zahlung.datum);
      });
      return daten;
    },
    statistiken: function statistiken() {
      if (this.$store.state.statistiken.statistiken.length === 0) {
        this.$store.dispatch("statistiken/loadStatistiken");
      }
      return this.$store.state.statistiken.statistiken;
    },
    statistik: function statistik() {
      var monat = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect];
      var selectStatistik = this.statistiken.find(function (statistik) {
        return statistik.monat === monat;
      });
      if (selectStatistik !== undefined) {
        selectStatistik.stricheProBbrSortiert = [];
        selectStatistik.stricheProStatus = {};
        selectStatistik.stricheProStatusSortiert = [];
        selectStatistik.stricheBbrAnzahl = 0;
        for (var item in selectStatistik.stricheProBbr) {
          var bbr = this.$store.getters["bbrbbr/bbr"](item);
          if (bbr) {
            if (selectStatistik.stricheProStatus[bbr.status] === undefined) {
              selectStatistik.stricheProStatus[bbr.status] = parseInt([selectStatistik.stricheProBbr[item]]);
            } else {
              selectStatistik.stricheProStatus[bbr.status] += parseInt(selectStatistik.stricheProBbr[item]);
            }
            if (bbr.status !== "Chargen & Ämter") {
              selectStatistik.stricheProBbrSortiert.push([item, selectStatistik.stricheProBbr[item]]);
            }
            selectStatistik.stricheBbrAnzahl += parseInt(selectStatistik.stricheProBbr[item]);
          }
        }
        for (var item2 in selectStatistik.stricheProStatus) {
          if (item2 !== "Chargen & Ämter") {
            selectStatistik.stricheProStatusSortiert.push([item2, selectStatistik.stricheProStatus[item2]]);
          }
        }
        if (selectStatistik.stricheProBbrSortiert.length > 0) {
          selectStatistik.stricheProBbrSortiert.sort(function (a, b) {
            return b[1] - a[1];
          });
          selectStatistik.stricheProStatusSortiert.sort(function (a, b) {
            return b[1] - a[1];
          });
          selectStatistik.stricheProBbrCount = selectStatistik.stricheProBbrSortiert.length;
          selectStatistik.stricheProBbrSortiert = selectStatistik.stricheProBbrSortiert.slice(0, 5);
          selectStatistik.stricheProStatusSortiert = selectStatistik.stricheProStatusSortiert.slice(0, 5);
          selectStatistik.stricheProTagBest = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(selectStatistik.stricheProTag).reduce(function (a, b) {
            return selectStatistik.stricheProTag[a] > selectStatistik.stricheProTag[b] ? a : b;
          });
        }
        selectStatistik.stricheProTagBest = [selectStatistik.stricheProTagBest, selectStatistik.stricheProTag[selectStatistik.stricheProTagBest]];
        this.series = this.jahresStatistik.schankverlust;
        return selectStatistik;
      } else {
        return null;
      }
    },
    zahlungExist: function zahlungExist() {
      this.errorMessage = [];
      var error = false;
      var start = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect] + "-01";
      var ende = void 0;
      if (this.monate[this.monatSelect] === "12") {
        ende = parseInt(this.jahre[this.jahrSelect]) + 1 + "-01-01";
      } else {
        ende = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect + 1] + "-01";
      }
      if (this.zahlungen.find(function (zahlung) {
        return zahlung.datum === start;
      }) === undefined) {
        start = new Date(new Date(start).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
        this.errorMessage.push(["error", "Für den Monat " + start + " ist keine Getränkezählung vorhanden."]);
        error = true;
      } else {
        start = new Date(new Date(start).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
        this.errorMessage.push(["success", "Für den Monat " + start + " ist eine Getränkezählung vorhanden."]);
      }
      if (this.zahlungen.find(function (zahlung) {
        return zahlung.datum === ende;
      }) === undefined) {
        ende = new Date(new Date(ende).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
        this.errorMessage.push(["error", "Für den Monat " + ende + " ist keine Getränkezählung vorhanden."]);
        error = true;
      } else {
        start = new Date(new Date(start).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
        this.errorMessage.push(["success", "Für den Monat " + ende + " ist eine Getränkezählung vorhanden."]);
      }
      if (error) {
        return false;
      } else {
        return true;
      }
    },
    jahrStatistik: function jahrStatistik() {
      var _this = this;

      try {
        var jahrStatistik = {
          monat: [],
          gesamtStricheTheorie: { data: [], name: "gesamtStricheTheorie", summe: 0 },
          gesamtStrichePraxis: { data: [], name: "gesamtStrichePraxis", summe: 0 },
          gesamtStriche: { data: [], name: "gesamtStriche", summe: 0 },
          umsatz: {
            striche: 0,
            ekp: 0,
            pauschal: 0,
            summe: 0,
            bierkasse: 0,
            aktivenkasse: 0,
            ahv: 0,
            hbv: 0,
            fuxia: 0,
            couleur: 0
          },
          einkauf: { bierschneider: 0, metro: 0, oettinger: 0, rewe: 0, vendel: 0, vinos: 0, summe: 0 },
          tageAnDerTheke: 0,
          couleurstriche: 0,
          couleurstrichePreis: 0,
          verbrauchBier: [],
          verbrauchBierSorte: [],
          verbrauchSoftdrinks: [],
          verbrauchWeinSchnaps: [],
          besterTag: { datum: "", anzahl: 0 },
          schankverlust: { data: [], name: "schankverlust", gesamt: 0, preis: 0 },
          oettingerKisten: { data: [], name: "oettingerKisten", summe: 0, preis: 0 },
          volumen: [{ data: [], name: "Bier", summe: 0 }, { data: [], name: "Softdrinks", summe: 0 }, { data: [], name: "Wein & Schnaps", summe: 0 }],
          bestenliste: [],
          vermogen: [],
          stricheProTag: [],
          stricheProTagMax: 0
        };
        if (this.$store.state.rechnungen.loaded === false) {
          this.$store.dispatch("rechnungen/loadRechnungen");
        }
        this.$store.getters["rechnungen/rechnungenKasse"]("Bierkasse").forEach(function (item) {
          if (item.rechnung_datum >= _this.jahre[_this.jahrSelect] + "-00-01" && item.rechnung_datum <= _this.jahre[_this.jahrSelect] + "-12-31") {
            item.positionen.forEach(function (pos) {
              if (pos.was === "Striche") {
                jahrStatistik.umsatz.striche += parseFloat(pos.betrag);
              }
              if (pos.was === "EKP") {
                jahrStatistik.umsatz.ekp += parseFloat(pos.betrag);
              }
              if (pos.was === "Pauschal") {
                jahrStatistik.umsatz.pauschal += parseFloat(pos.betrag);
              }
            });
            if (item.bbrID === "uOxOwxMlxii8wP36HTQN") {
              jahrStatistik.umsatz.bierkasse += parseFloat(item.summe);
            }
            if (item.bbrID === "G93SCUDovOqQxC57OcLD") {
              jahrStatistik.umsatz.aktivenkasse += parseFloat(item.summe);
            }
            if (item.bbrID === "qYxK7eWD49Z3rSNadrty") {
              jahrStatistik.umsatz.ahv += parseFloat(item.summe);
            }
            if (item.bbrID === "vHLz8vyb6bwfwzQd0hRP") {
              jahrStatistik.umsatz.hbv += parseFloat(item.summe);
            }
            if (item.bbrID === "1VHmwi95sFWuvyhLjR9I") {
              jahrStatistik.umsatz.fuxia += parseFloat(item.summe);
            }
            if (item.bbrID === "n5Iw2noJm7jRUutEoNb5") {
              jahrStatistik.umsatz.couleur += parseFloat(item.summe);
            }
            jahrStatistik.umsatz.summe += parseFloat(item.summe);
          }
        });
        if (this.$store.state.bierlieferungen.bierlieferungen.length === 0) {
          this.$store.dispatch("bierlieferungen/loadBierlieferungen");
        }
        this.$store.state.bierlieferungen.bierlieferungen.forEach(function (item) {
          if (item.datum >= _this.jahre[_this.jahrSelect] + "-00-01" && item.datum <= _this.jahre[_this.jahrSelect] + "-12-31") {
            if (item.lieferant === "Bier Schneider") {
              jahrStatistik.einkauf.bierschneider += parseFloat(item.gesamt);
            }
            if (item.lieferant === "Metro") {
              jahrStatistik.einkauf.metro += parseFloat(item.gesamt);
            }
            if (item.lieferant === "Oettinger") {
              jahrStatistik.einkauf.oettinger += parseFloat(item.gesamt);
            }
            if (item.lieferant === "Rewe") {
              jahrStatistik.einkauf.rewe += parseFloat(item.gesamt);
            }
            if (item.lieferant === "Getränke Vendel") {
              jahrStatistik.einkauf.vendel += parseFloat(item.gesamt);
            }
            if (item.lieferant === "Vinos") {
              jahrStatistik.einkauf.vinos += parseFloat(item.gesamt);
            }
            jahrStatistik.einkauf.summe += parseFloat(item.gesamt);
          }
        });
        this.statistiken.forEach(function (monat) {
          if (monat.monat >= _this.jahre[_this.jahrSelect] + "-00" && monat.monat <= _this.jahre[_this.jahrSelect] + "-12") {
            jahrStatistik.monat.push(new Date(monat.monat).toLocaleString(["de-de"], { month: "short", year: "2-digit" }));
            jahrStatistik.gesamtStricheTheorie.data.push(monat.gesamtStricheTheorie);
            jahrStatistik.gesamtStricheTheorie.summe += parseFloat(monat.gesamtStricheTheorie);
            jahrStatistik.gesamtStrichePraxis.data.push(monat.gesamtStrichePraxis);
            jahrStatistik.gesamtStrichePraxis.summe += parseFloat(monat.gesamtStrichePraxis);
            jahrStatistik.gesamtStriche.data.push(0);
            jahrStatistik.schankverlust.data.push(monat.schankverlust);
            jahrStatistik.schankverlust.preis += (monat.gesamtStricheTheorie - monat.gesamtStrichePraxis) * monat.durchschnittsStrichPreis;
            jahrStatistik.oettingerKisten.data.push(monat.oettingerKisten);
            jahrStatistik.oettingerKisten.summe += parseFloat(monat.oettingerKisten);
            jahrStatistik.oettingerKisten.preis += parseFloat(monat.oettingerKistenPreis);
            jahrStatistik.couleurstriche += parseInt(monat.couleurstricheAnzahl);
            jahrStatistik.couleurstrichePreis += parseFloat(monat.couleurstrichePreis);
            jahrStatistik.volumen[0].data.push(monat.verbrauchBierSumme);
            jahrStatistik.volumen[0].summe += parseFloat(monat.verbrauchBierSumme);
            jahrStatistik.volumen[1].data.push(monat.verbrauchSoftdrinksSumme);
            jahrStatistik.volumen[1].summe += parseFloat(monat.verbrauchSoftdrinksSumme);
            jahrStatistik.volumen[2].data.push(monat.verbrauchWeinSchnapsSumme);
            jahrStatistik.volumen[2].summe += parseFloat(monat.verbrauchWeinSchnapsSumme);
            jahrStatistik.vermogen.push(_this.$sumArray(monat.gesamtvermogen));

            jahrStatistik.stricheProTag.push({
              tage: [],
              summe: 0
            });
            var month = parseInt(monat.monat.split("-")[1]) - 1;
            var date = new Date(_this.jahre[_this.jahrSelect], month, 1);
            while (date.getMonth() === month) {
              jahrStatistik.stricheProTag[month].tage.push(0);
              date.setDate(date.getDate() + 1);
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(monat.stricheProTag)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                var _date = key.split("-");
                jahrStatistik.stricheProTag[_date[1] - 1].tage[_date[2] - 1] = value;
                jahrStatistik.stricheProTag[_date[1] - 1].summe += parseInt(value);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (jahrStatistik.stricheProTag[month].summe > jahrStatistik.stricheProTagMax) {
              jahrStatistik.stricheProTagMax = jahrStatistik.stricheProTag[month].summe;
            }
            for (var item in monat.stricheProBbr) {
              jahrStatistik.gesamtStriche.summe += monat.stricheProBbr[item];
              jahrStatistik.gesamtStriche.data[month] += monat.stricheProBbr[item];
              if (jahrStatistik.bestenliste.find(function (element) {
                return element.bbr === item;
              })) {
                jahrStatistik.bestenliste[jahrStatistik.bestenliste.indexOf(jahrStatistik.bestenliste.find(function (element) {
                  return element.bbr === item;
                }))].anzahl += parseInt(monat.stricheProBbr[item]);
              } else {
                if (monat.stricheProBbr[item] > 0) {
                  if (_this.showNurBbrBbr) {
                    if (_this.$store.getters["bbrbbr/nurBbrbbr"].find(function (bbr) {
                      return bbr.id === item;
                    }) !== undefined) {
                      jahrStatistik.bestenliste.push({ bbr: item, anzahl: monat.stricheProBbr[item] });
                    }
                  } else {
                    jahrStatistik.bestenliste.push({ bbr: item, anzahl: monat.stricheProBbr[item] });
                  }
                }
              }
            }
            for (var item2 in monat.stricheProTag) {
              jahrStatistik.tageAnDerTheke++;
              if (jahrStatistik.besterTag.anzahl < monat.stricheProTag[item2]) {
                jahrStatistik.besterTag = { datum: item2, anzahl: monat.stricheProTag[item2] };
              }
            }
            for (var item3 in monat.verbrauchBier) {
              if (jahrStatistik.verbrauchBier.find(function (element) {
                return element.bezeichnung === monat.verbrauchBier[item3].bezeichnung;
              })) {
                jahrStatistik.verbrauchBier[jahrStatistik.verbrauchBier.indexOf(jahrStatistik.verbrauchBier.find(function (element) {
                  return element.bezeichnung === monat.verbrauchBier[item3].bezeichnung;
                }))].anzahl += parseInt(monat.verbrauchBier[item3].verbraucht);
                jahrStatistik.verbrauchBier[jahrStatistik.verbrauchBier.indexOf(jahrStatistik.verbrauchBier.find(function (element) {
                  return element.bezeichnung === monat.verbrauchBier[item3].bezeichnung;
                }))].ekp += parseInt(monat.verbrauchBier[item3].ekp);
              } else {
                var getrank = _this.getranke.find(function (getrank) {
                  return getrank.bezeichnung === monat.verbrauchBier[item3].bezeichnung;
                });
                jahrStatistik.verbrauchBier.push({
                  bezeichnung: monat.verbrauchBier[item3].bezeichnung,
                  anzahl: monat.verbrauchBier[item3].verbraucht,
                  ekp: monat.verbrauchBier[item3].ekp,
                  getrank: getrank
                });
              }
            }
            for (var item4 in monat.verbrauchSoftdrinks) {
              if (jahrStatistik.verbrauchSoftdrinks.find(function (element) {
                return element.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung;
              })) {
                jahrStatistik.verbrauchSoftdrinks[jahrStatistik.verbrauchSoftdrinks.indexOf(jahrStatistik.verbrauchSoftdrinks.find(function (element) {
                  return element.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung;
                }))].anzahl += parseInt(monat.verbrauchSoftdrinks[item4].verbraucht);
                jahrStatistik.verbrauchSoftdrinks[jahrStatistik.verbrauchSoftdrinks.indexOf(jahrStatistik.verbrauchSoftdrinks.find(function (element) {
                  return element.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung;
                }))].ekp += parseInt(monat.verbrauchSoftdrinks[item4].ekp);
              } else {
                var getrank2 = _this.getranke.find(function (getrank) {
                  return getrank.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung;
                });
                if (monat.verbrauchSoftdrinks[item4].verbraucht > 0) {
                  jahrStatistik.verbrauchSoftdrinks.push({
                    bezeichnung: monat.verbrauchSoftdrinks[item4].bezeichnung,
                    anzahl: monat.verbrauchSoftdrinks[item4].verbraucht,
                    ekp: monat.verbrauchSoftdrinks[item4].ekp,
                    getrank: getrank2
                  });
                }
              }
            }
            for (var item5 in monat.verbrauchWeinSchnaps) {
              if (jahrStatistik.verbrauchWeinSchnaps.find(function (element) {
                return element.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung;
              })) {
                jahrStatistik.verbrauchWeinSchnaps[jahrStatistik.verbrauchWeinSchnaps.indexOf(jahrStatistik.verbrauchWeinSchnaps.find(function (element) {
                  return element.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung;
                }))].anzahl += parseInt(monat.verbrauchWeinSchnaps[item5].verbraucht);
                jahrStatistik.verbrauchWeinSchnaps[jahrStatistik.verbrauchWeinSchnaps.indexOf(jahrStatistik.verbrauchWeinSchnaps.find(function (element) {
                  return element.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung;
                }))].ekp += parseInt(monat.verbrauchWeinSchnaps[item5].ekp);
              } else {
                var _getrank = _this.getranke.find(function (getrank) {
                  return getrank.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung;
                });
                jahrStatistik.verbrauchWeinSchnaps.push({
                  bezeichnung: monat.verbrauchWeinSchnaps[item5].bezeichnung,
                  anzahl: monat.verbrauchWeinSchnaps[item5].verbraucht,
                  ekp: monat.verbrauchWeinSchnaps[item5].ekp,
                  getrank: _getrank
                });
              }
            }
          }
        });
        jahrStatistik.verbrauchBier.forEach(function (eintrag) {
          var getrank = _this.getranke.find(function (element) {
            return element.bezeichnung === eintrag.bezeichnung;
          });
          if (getrank !== undefined) {
            eintrag.liter = (getrank.volumen * eintrag.anzahl).toFixed(0);
          }
        });
        jahrStatistik.verbrauchBier.reduce(function (res, value) {
          value.Id = value.bezeichnung.split(" ")[0];
          if (!res[value.Id]) {
            res[value.Id] = { Id: value.Id, liter: 0 };
            jahrStatistik.verbrauchBierSorte.push(res[value.Id]);
          }
          if (value.liter) {
            res[value.Id].liter += parseFloat(value.liter);
          }
          return res;
        }, {});
        jahrStatistik.verbrauchSoftdrinks.forEach(function (eintrag) {
          if (eintrag.getrank !== undefined) {
            eintrag.liter = (eintrag.getrank.volumen * eintrag.anzahl).toFixed(0);
          }
          if (eintrag.liter === undefined) {
            eintrag.liter = 0;
          }
        });
        jahrStatistik.verbrauchWeinSchnaps.forEach(function (eintrag) {
          var getrank = _this.getranke.find(function (element) {
            return element.bezeichnung === eintrag.bezeichnung;
          });
          if (getrank !== undefined) {
            eintrag.liter = (getrank.volumen * eintrag.anzahl).toFixed(0);
          }
        });
        jahrStatistik.verbrauchBier.sort(function (a, b) {
          return b.liter - a.liter;
        });
        jahrStatistik.verbrauchBierSorte.sort(function (a, b) {
          return b.liter - a.liter;
        });
        jahrStatistik.verbrauchSoftdrinks.sort(function (a, b) {
          return b.liter - a.liter;
        });
        jahrStatistik.verbrauchWeinSchnaps.sort(function (a, b) {
          return b.liter - a.liter;
        });
        jahrStatistik.bestenliste.sort(function (a, b) {
          return b.anzahl - a.anzahl;
        });
        jahrStatistik.volumen[0].summe = jahrStatistik.volumen[0].summe.toFixed(0);
        jahrStatistik.volumen[1].summe = jahrStatistik.volumen[1].summe.toFixed(0);
        jahrStatistik.volumen[2].summe = jahrStatistik.volumen[2].summe.toFixed(0);
        jahrStatistik.volumen.donut = {
          series: [parseInt(jahrStatistik.volumen[0].summe), parseInt(jahrStatistik.volumen[1].summe), parseInt(jahrStatistik.volumen[2].summe)]
        };
        jahrStatistik.volumen.chartOptions = {
          labels: ["Bier", "Softdrinks", "Wein & Schnaps"],
          legend: { show: false },
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          tooltip: {
            y: {
              formatter: function formatter(val) {
                return val + " Liter";
              }
            }
          },
          plotOptions: {
            pie: {
              donut: {
                size: "65%",
                labels: {
                  show: true,
                  value: {
                    fontSize: "1.25rem",
                    fontFamily: "Roboto, Arial",
                    fontWeight: 500
                  },
                  total: {
                    show: true,
                    showAlways: true,
                    label: "SUMME",
                    fontSize: "0.75rem",
                    fontFamily: "Roboto, Arial",
                    fontWeight: 500
                  }
                }
              }
            }
          }
        };
        jahrStatistik.verbrauchBier.donut = { series: [] };
        jahrStatistik.verbrauchBier.chartOptions = {
          labels: [],
          legend: { show: false },
          colors: ["#254fb3", "#EF5350", "#FFC107", "#009688", "#CDDC39", "#FF9800", "#03A9F4"],
          tooltip: {
            y: {
              formatter: function formatter(val) {
                return val + " Liter";
              }
            }
          },
          plotOptions: {
            radialBar: {
              offsetY: 0,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 0,
                size: "40%",
                background: "transparent"
              }
            },
            pie: {
              donut: {
                size: "65%"
              }
            }
          }
        };
        jahrStatistik.verbrauchBierSorte.forEach(function (sorte) {
          jahrStatistik.verbrauchBier.donut.series.push((sorte.liter / jahrStatistik.volumen[0].summe * 100).toFixed(1));
          jahrStatistik.verbrauchBier.chartOptions.labels.push(sorte.Id);
        });
        jahrStatistik.schankverlust.gesamt = (100 - jahrStatistik.gesamtStrichePraxis.summe / jahrStatistik.gesamtStricheTheorie.summe * 100).toFixed(1);
        return jahrStatistik;
      } catch (error) {
        console.log("Fehler beim Berechnen der Jahresstatistik");
        console.log(error);
      }
    },
    jahresStatistik: function jahresStatistik() {
      var jahresStatistik = {
        monat: [],
        gesamtStriche: [{ data: [], name: "Striche Theorie" }, { data: [], name: "Striche Praxis" }],
        gesamtStricheTheorie: [{ data: [], name: "gesamtStricheTheorie" }],
        gesamtStrichePraxis: [{ data: [], name: "gesamtStrichePraxis" }],
        schankverlust: [{ data: [], name: "schankverlust" }],
        oettingerKisten: [{ data: [], name: "oettingerKisten" }],
        volumen: [{ data: [], name: "Bier" }, { data: [], name: "Softdrinks" }, { data: [], name: "Wein & Schnaps" }],
        verbrauchBier: [{ data: [], name: "verbrauchBier" }],
        verbrauchSoftdrinks: [{ data: [], name: "verbrauchSoftdrinks" }],
        verbrauchWeinSchnaps: [{ data: [], name: "verbrauchWeinSchnaps" }],
        verbrauchBierSumme: [{ data: [], name: "verbrauchBierSumme" }],
        verbrauchSoftdrinksSumme: [{ data: [], name: "verbrauchSoftdrinksSumme" }],
        verbrauchWeinSchnapsSumme: [{ data: [], name: "verbrauchWeinSchnapsSumme" }]
      };
      this.statistiken.forEach(function (monat) {
        if (monat.monat > "2021-00") {
          jahresStatistik.monat.push(new Date(monat.monat).toLocaleString(["de-de"], { month: "short", year: "2-digit" }));
          jahresStatistik.gesamtStriche[0].data.push(monat.gesamtStricheTheorie);
          jahresStatistik.gesamtStriche[1].data.push(monat.gesamtStrichePraxis);
          jahresStatistik.gesamtStricheTheorie[0].data.push(monat.gesamtStricheTheorie);
          jahresStatistik.gesamtStrichePraxis[0].data.push(monat.gesamtStrichePraxis);
          jahresStatistik.schankverlust[0].data.push(monat.schankverlust);
          jahresStatistik.oettingerKisten[0].data.push(monat.oettingerKisten);

          jahresStatistik.volumen[0].data.push(monat.verbrauchBierSumme);
          jahresStatistik.volumen[1].data.push(monat.verbrauchSoftdrinksSumme);
          jahresStatistik.volumen[2].data.push(monat.verbrauchWeinSchnapsSumme);
          jahresStatistik.verbrauchBier[0].data.push(monat.verbrauchBierSumme);
          jahresStatistik.verbrauchSoftdrinks[0].data.push(monat.verbrauchSoftdrinksSumme);
          jahresStatistik.verbrauchWeinSchnaps[0].data.push(monat.verbrauchWeinSchnapsSumme);
          jahresStatistik.verbrauchBierSumme[0].data.push(monat.verbrauchBierSumme);
          jahresStatistik.verbrauchSoftdrinksSumme[0].data.push(monat.verbrauchSoftdrinksSumme);
          jahresStatistik.verbrauchWeinSchnapsSumme[0].data.push(monat.verbrauchWeinSchnapsSumme);
        }
      });
      this.options.xaxis.categories = jahresStatistik.monat;
      console.log(jahresStatistik);
      return jahresStatistik;
    },
    preiskalkulation: function preiskalkulation() {
      var ergebnis = {};
      var stricheKostenGesamt = 0;
      var ekpKostenGesamt = 0;
      var ekpEinnahmenGesamt = 0;
      var strichpreis = 1.2;
      console.log(this.jahrStatistik);
      this.jahrStatistik.verbrauchBier.forEach(function (item) {
        if (item.getrank) {
          stricheKostenGesamt += (item.anzahl - item.ekp) / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.preis);
          ekpKostenGesamt += item.ekp / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.preis);
          ekpEinnahmenGesamt += item.ekp / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.verkauf1);
        }
      });
      this.jahrStatistik.verbrauchSoftdrinks.forEach(function (item) {
        if (item.getrank) {
          stricheKostenGesamt += (item.anzahl - item.ekp) / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.preis);
          ekpKostenGesamt += item.ekp / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.preis);
          ekpEinnahmenGesamt += item.ekp / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.verkauf1);
        }
      });
      this.jahrStatistik.verbrauchWeinSchnaps.forEach(function (item) {
        if (item.getrank) {
          ekpKostenGesamt += item.anzahl / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.preis);
          ekpEinnahmenGesamt += item.ekp / parseInt(item.getrank.verkaufseinheit) * parseFloat(item.getrank.verkauf1);
        }
      });
      console.log(ekpEinnahmenGesamt);
      ergebnis.kostenStriche = stricheKostenGesamt / (this.jahrStatistik.gesamtStriche.summe + this.jahrStatistik.gesamtStricheTheorie.summe - this.jahrStatistik.gesamtStrichePraxis.summe);
      ergebnis.kostenEKP = ekpKostenGesamt / (this.jahrStatistik.gesamtStrichePraxis.summe - this.jahrStatistik.gesamtStriche.summe);
      ergebnis.kostenSchankverlust = ergebnis.kostenStriche;
      ergebnis.einnahmenStriche = strichpreis;
      ergebnis.einnahmenEKP = ekpEinnahmenGesamt / (this.jahrStatistik.gesamtStrichePraxis.summe - this.jahrStatistik.gesamtStriche.summe);
      ergebnis.einnahmenSchankverlust = 0;
      ergebnis.gewinnStriche = ergebnis.einnahmenStriche - ergebnis.kostenStriche;
      ergebnis.gewinnEKP = ergebnis.einnahmenEKP - ergebnis.kostenEKP;
      ergebnis.gewinnSchankverlust = ergebnis.einnahmenSchankverlust - ergebnis.kostenSchankverlust;
      return ergebnis;
    }
  },
  methods: {
    saveGesamtvermogen: function saveGesamtvermogen() {
      this.$store.dispatch("statistiken/updateStatistikenData", this.statistik);
    },
    showVermogen: function showVermogen() {
      if (!this.statistik.gesamtvermogen) {
        this.statistik.gesamtvermogen = {};
      }
      this.showArray = "vermogen";
    },
    show: function show(array) {
      var max = 0;
      array.forEach(function (data) {
        data.data.forEach(function (item) {
          if (parseInt(item) > max) {
            max = parseInt(item);
          }
        });
      });
      this.options.yaxis.max = Math.ceil(max / Math.pow(10, max.toString().length - 1)) * Math.pow(10, max.toString().length - 1);
      this.series = array;
    },
    addMonat: function addMonat(neuerMonat) {
      var _this2 = this;

      this.filterVon = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect] + "-01";
      if (this.monate[this.monatSelect] === "12") {
        this.filterBis = parseInt(this.jahre[this.jahrSelect]) + 1 + "-01-01";
      } else {
        this.filterBis = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect + 1] + "-01";
      }
      var von = new Date(this.filterVon);
      if (von.getTimezoneOffset() === -60) {
        von = new Date(von.setHours(von.getHours() - 2));
      }
      var bis = new Date(this.filterBis);
      console.log(bis.getTimezoneOffset());
      if (bis.getTimezoneOffset() === -60) {
        bis = new Date(bis.setHours(bis.getHours() - 2));
      }
      if (bis.getTimezoneOffset() === -120) {
        bis = new Date(bis.setHours(bis.getHours() - 4));
      }
      var datum = {
        von: von,
        bis: bis
      };
      console.log(datum.von);
      console.log(datum.bis);
      var gesamtStricheTheorie = 0;
      var gesamtStrichePraxis = 0;
      var verbrauchBierSumme = 0;
      var verbrauchSoftdrinksSumme = 0;
      var verbrauchWeinSchnapsSumme = 0;
      var oettingerKisten = 0;
      var oettingerKistenPreis = 0;
      var volumen = 0;
      var couleurstricheAnzahl = 0;
      var couleurstrichePreis = 0;
      var durchschnittsStrichPreis = 0;
      var stricheAnzahl = 0;
      var strichePreis = 0;

      this.$store.dispatch("striche/loadAlleStriche", datum);
      var striche = [];
      var result = {};
      var resultDate = {};
      var array = {};
      var arrayDate = {};
      this.$store.state.striche.alleStriche.forEach(function (strich) {
        var art = void 0;
        if (!result[strich["bbrID"]]) {
          result[strich["bbrID"]] = [];
          array[strich["bbrID"]] = 0;
        }
        var tzoffset = new Date().getTimezoneOffset() * 60000;
        var date = new Date(strich.date.seconds * 1000 - tzoffset).toISOString().substr(0, 10);
        if (!resultDate[date]) {
          resultDate[date] = [];
          arrayDate[date] = 0;
        }
        result[strich["bbrID"]].push(strich);
        resultDate[date].push(strich);
        if (strich.art === "strich") {
          stricheAnzahl += parseInt(strich.anzahl);
          strichePreis += parseInt(strich.anzahl) * parseFloat(strich.preis);
          array[strich["bbrID"]] += parseInt(strich.anzahl);
          arrayDate[date] += parseInt(strich.anzahl);
          if (strich.bbrID === "n5Iw2noJm7jRUutEoNb5") {
            couleurstricheAnzahl += parseInt(strich.anzahl);
            couleurstrichePreis += parseFloat(strich.preis * strich.anzahl);
          }
          if (strich.bbrID === "G93SCUDovOqQxC57OcLD") {
            couleurstricheAnzahl += parseInt(strich.anzahl);
            couleurstrichePreis += parseFloat(strich.preis * strich.anzahl);
          }
          if (strich.bbrID === "uOxOwxMlxii8wP36HTQN") {
            couleurstricheAnzahl += parseInt(strich.anzahl);
            couleurstrichePreis += parseFloat(strich.preis * strich.anzahl);
          }
        }
        if (strich.ekp) {
          if (strich.ekp.id) {
            art = strich.ekp.id;
          } else {
            art = strich.ekp[0].id;
          }
        } else {
          if (strich.grund) {
            art = strich.grund;
          } else {
            art = "";
          }
        }
        striche.push({
          id: strich.id,
          bbr: strich.bbrID,
          art: art,
          anzahl: strich.anzahl,
          datum: date,
          preis: strich.preis
        });
      });
      durchschnittsStrichPreis = parseFloat(strichePreis / stricheAnzahl).toFixed(2);

      var verbrauch = [];
      verbrauch["Bier"] = [];
      verbrauch["Softdrinks"] = [];
      verbrauch["Wein & Schnaps"] = [];

      var anfang = void 0;
      var ende = void 0;

      if (this.zahlungen.find(function (zahlung) {
        return zahlung.datum === _this2.filterVon;
      }) === undefined) {
        var _statistik = {
          error: "Für diesen Monat ist keine Statistik verfügbar, da zum Monatsanfang keine Zählung durchgeführt wurde."
        };
        console.log(_statistik);
        this.$store.dispatch("statistiken/createStatistiken", _statistik);
        return;
      } else {
        anfang = this.zahlungen.find(function (zahlung) {
          return zahlung.datum === _this2.filterVon;
        }).positionen;
      }

      if (this.zahlungen.find(function (zahlung) {
        return zahlung.datum === _this2.filterBis;
      }) === undefined) {
        var _statistik2 = {
          error: "Für diesen Monat ist keine Statistik verfügbar, da zum Monatsende noch keine Zählung durchgeführt wurde."
        };
        console.log(_statistik2);
        this.$store.dispatch("statistiken/createStatistiken", _statistik2);
        return;
      } else {
        ende = this.zahlungen.find(function (zahlung) {
          return zahlung.datum === _this2.filterBis;
        }).positionen;
      }

      var einkaufMwStGesamt = 0;
      this.lieferungen.forEach(function (lieferung) {
        if (new Date(lieferung.datum).toISOString().substr(0, 10) >= _this2.filterVon) {
          if (new Date(lieferung.datum).toISOString().substr(0, 10) <= _this2.filterBis) {
            console.log(lieferung);
            einkaufMwStGesamt += parseFloat(lieferung.mwst);
          }
        }
      });
      this.getranke.forEach(function (item) {
        var eingekauft = 0;

        _this2.lieferungen.forEach(function (lieferung) {
          if (new Date(lieferung.datum).toISOString().substr(0, 10) >= _this2.filterVon) {
            if (new Date(lieferung.datum).toISOString().substr(0, 10) <= _this2.filterBis) {
              lieferung.positionen.forEach(function (position) {
                if (position.id === item.id) {
                  eingekauft = eingekauft + parseFloat(position.anzahl) * item.verkaufseinheit;
                }
              });
            }
          }
        });

        var anfangsposition = 0;
        anfang.forEach(function (position) {
          if (position.id === item.id) {
            anfangsposition = anfangsposition + parseInt(position.anzahl);
          }
        });

        var endposition = 0;
        ende.forEach(function (position) {
          if (position.id === item.id) {
            endposition = endposition + parseInt(position.anzahl);
          }
        });

        var ekp = 0;
        striche.forEach(function (strich) {
          if (strich.art === item.id) {
            var date = new Date(strich.datum).toISOString().substr(0, 10);
            if (date >= _this2.filterVon && date <= _this2.filterBis) {
              ekp++;
            }
          }
        });

        var verbraucht = anfangsposition + eingekauft - endposition;
        if (item.kategorie === "Bier") {
          verbrauchBierSumme = parseFloat(verbrauchBierSumme) + parseFloat(verbraucht) * parseFloat(item.volumen);
          verbrauchBierSumme = verbrauchBierSumme.toFixed(1);
          if (item.bezeichnung.includes("Oettinger Kiste")) {
            oettingerKisten += verbraucht;
            oettingerKistenPreis += item.preis * verbraucht;
          }
        }
        if (item.kategorie === "Softdrinks") {
          verbrauchSoftdrinksSumme = parseFloat(verbrauchSoftdrinksSumme) + parseFloat(verbraucht) * parseFloat(item.volumen);
          verbrauchSoftdrinksSumme = verbrauchSoftdrinksSumme.toFixed(1);
          if (item.bezeichnung.includes("Oettinger Kiste")) {
            oettingerKisten += verbraucht;
            oettingerKistenPreis += item.preis * verbraucht;
          }
        }
        if (item.kategorie === "Wein & Schnaps") {
          verbrauchWeinSchnapsSumme = parseFloat(verbrauchWeinSchnapsSumme) + parseFloat(verbraucht) * parseFloat(item.volumen);
          verbrauchWeinSchnapsSumme = verbrauchWeinSchnapsSumme.toFixed(1);
        }
        volumen = (parseFloat(verbrauchBierSumme) + parseFloat(verbrauchSoftdrinksSumme) + parseFloat(verbrauchWeinSchnapsSumme)).toFixed(1);

        var stricheTheorie = void 0;
        stricheTheorie = verbraucht * item.striche;
        gesamtStricheTheorie = parseFloat(gesamtStricheTheorie) + parseFloat(stricheTheorie);

        if (eingekauft >= 0 && verbraucht !== 0) {
          verbrauch[item.kategorie].push({
            bezeichnung: item.bezeichnung,
            kategorie: item.kategorie,
            eingekauft: eingekauft,
            anfang: anfangsposition,
            ende: endposition,
            ekp: ekp,
            verbraucht: verbraucht,
            stricheTheorie: stricheTheorie
          });
        }
      });

      striche.forEach(function (strich) {
        var date = new Date(strich.datum).toISOString().substr(0, 10);
        if (date >= _this2.filterVon && date < _this2.filterBis) {
          if (strich.art === "" || strich.art === "strich" || strich.art === "Strich") {
            gesamtStrichePraxis = gesamtStrichePraxis + parseInt(strich.anzahl);
          }
          if (strich.art !== "") {
            if (_this2.$store.state.getranke.getranke.length === 0) {
              _this2.$store.dispatch("getranke/loadGetranke");
            }
            var getrank = _this2.$store.getters["getranke/getrank"](strich.art);
            if (getrank) {
              gesamtStrichePraxis = gesamtStrichePraxis + parseInt(strich.anzahl * getrank.striche);
            }
          }
        }
      });

      var schankverlust = parseFloat(100 - gesamtStrichePraxis / gesamtStricheTheorie * 100).toFixed(2);

      var steuerlast = einkaufMwStGesamt;
      var statistik = {
        id: this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect],
        aktualisiert: new Date(),
        monat: this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect],
        gesamtStricheTheorie: gesamtStricheTheorie,
        gesamtStrichePraxis: gesamtStrichePraxis,
        schankverlust: schankverlust,
        oettingerKisten: oettingerKisten,
        oettingerKistenPreis: oettingerKistenPreis,
        volumen: volumen,
        steuerlast: steuerlast,
        verbrauchBier: verbrauch["Bier"],
        verbrauchSoftdrinks: verbrauch["Softdrinks"],
        verbrauchWeinSchnaps: verbrauch["Wein & Schnaps"],
        verbrauchBierSumme: verbrauchBierSumme,
        verbrauchSoftdrinksSumme: verbrauchSoftdrinksSumme,
        verbrauchWeinSchnapsSumme: verbrauchWeinSchnapsSumme,
        durchschnittsStrichPreis: durchschnittsStrichPreis,
        couleurstricheAnzahl: couleurstricheAnzahl,
        couleurstrichePreis: couleurstrichePreis.toFixed(2),
        stricheProBbr: array,
        stricheProTag: arrayDate
      };
      console.log(statistik);
      if (neuerMonat) {
        this.$store.dispatch("statistiken/createStatistiken", statistik);
      } else {
        statistik.id = this.statistik.id;
        this.$store.dispatch("statistiken/updateStatistikenData", statistik);
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filterVon: new Date().toISOString().substr(0, 10),
      menu1: false,
      filterBis: new Date().toISOString().substr(0, 10),
      menu2: false,
      filterBbr: "",
      filterStatus: "",
      filterArt: "",
      search: "",
      showStatistik: false,
      showFilter: false,
      itemsArt: ["Alle", "Striche", "EKP", "Pauschal"],
      itemsStatus: ["Alle", "Berechnet", "Nicht Berechnet"],
      showRechnungenGenerieren: false,
      e1: 1,
      headers: [{ text: "Name", value: "bbr" }, { text: "Datum", value: "date" }, { text: "Anzahl", value: "anzahl" }, { text: "Preis", value: "preis" }, { text: "Was", value: "grund" }, { text: "", value: "", sortable: false }],
      rechnung_alle: true,
      rechnung_von: new Date().toISOString().substr(0, 10),
      rechnung_bis: new Date().toISOString().substr(0, 10),
      rechnung_titel: "Rechnung",
      rechnung_datum: new Date().toISOString().substr(0, 10),
      rechnung_zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 10)).toISOString().substr(0, 10),
      rechnung_freitext: "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart",
      rechnung_freitext_sepa: "<<Briefanrede>> <<Nachname>>, \n\nhiermit informiere ich Dich, dass die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ am <<Zahlbar_bis>> von Deinem Konto abgebucht wird. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart",
      rechnung_positionen: [],
      rechnung_anzahl: "",
      rechnung_summe: 0,
      rechnung_summe_sepa: 0,
      rechnung_summe_striche: 0,
      rechnung_summe_ekp: 0,
      rechnung_summe_pauschal: 0,
      rechnungStriche: [],
      rechnungen: [],
      rechnungsnummer: "",
      fortschritt: 0,
      summe: 0,
      loading: false,
      index: 0,
      anzahl: 0,
      showNeueStriche: false,
      options: {
        chart: {
          toolbar: {
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          },
          type: "area",
          stacked: false
        },
        annotations: {
          xaxis: []
        },
        dataLabels: { enabled: false },
        colors: ["#254fb3", "#EF5350", "#FFC107"],
        stroke: { width: 0 },
        tooltip: {
          y: {
            formatter: function formatter(val, index) {
              return val.toFixed(0);
            }
          }
        },
        yaxis: {
          min: 0,
          tickAmount: 5,
          title: { text: undefined },
          labels: {
            formatter: function formatter(val, index) {
              return val.toFixed(0);
            }
          }
        },
        xaxis: {
          title: { text: undefined },
          categories: []
        },
        fill: {
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          opacity: 1,
          type: "solid"
        },
        legend: { show: false }
      }
    };
  },

  computed: {
    statistik: function statistik() {
      var statistik = {};
      statistik.anzahlStriche = 0;
      statistik.anzahlEKP = 0;
      statistik.anzahlPauschal = 0;

      statistik.umsatzStriche = 0;
      statistik.umsatzEKP = 0;
      statistik.umsatzPauschal = 0;
      statistik.umsatzGesamt = 0;
      statistik.bestenliste = {};
      statistik.anzahlRechnungen = 0;
      this.striche.forEach(function (strich) {
        if (statistik.bestenliste[strich.bbrID] === undefined) {
          statistik.anzahlRechnungen++;
          statistik.bestenliste[strich.bbrID] = {
            id: strich.bbrID,
            striche: 0,
            ekp: 0,
            pauschal: 0
          };
        }
        if (strich.art === "strich") {
          statistik.anzahlStriche = parseFloat(statistik.anzahlStriche) + parseFloat(strich.anzahl);
          statistik.umsatzStriche = parseFloat(statistik.umsatzStriche) + parseFloat(strich.preis * strich.anzahl);
          statistik.bestenliste[strich.bbrID].striche = statistik.bestenliste[strich.bbrID].striche + parseFloat(strich.anzahl);
        }
        if (strich.art === "ekp") {
          statistik.anzahlEKP = parseFloat(statistik.anzahlEKP) + parseFloat(strich.anzahl);
          statistik.umsatzEKP = parseFloat(statistik.umsatzEKP) + parseFloat(strich.preis * strich.anzahl);
          statistik.bestenliste[strich.bbrID].ekp = statistik.bestenliste[strich.bbrID].ekp + parseFloat(strich.preis * strich.anzahl);
        }
        if (strich.art === "pauschal") {
          statistik.anzahlPauschal = parseFloat(statistik.anzahlPauschal) + parseFloat(strich.anzahl);
          statistik.umsatzPauschal = parseFloat(statistik.umsatzPauschal) + parseFloat(strich.preis * strich.anzahl);
          statistik.bestenliste[strich.bbrID].pauschal = statistik.bestenliste[strich.bbrID].pauschal + parseFloat(strich.preis * strich.anzahl);
        }
      });
      statistik.umsatzGesamt = statistik.umsatzPauschal + statistik.umsatzStriche + statistik.umsatzEKP;
      var sortable = [];
      for (var item in statistik.bestenliste) {
        sortable.push(statistik.bestenliste[item]);
      }
      sortable.sort(function (a, b) {
        return b["striche"] - a["striche"];
      });
      statistik.bestenliste = sortable;

      return statistik;
    },
    striche: function striche() {
      var _this = this;

      if (this.$store.state.striche.loaded === false) {
        this.$store.dispatch("striche/loadStriche");
      }
      var striche = [];
      this.summe = 0;
      this.anzahl = 0;
      this.$store.getters["striche/striche"].forEach(function (strich) {
        strich.grund = strich.grund === "Strich" ? "" : strich.grund;
        striche.push(strich);
        if (strich.art === "strich" || strich.art === "Strich") {
          _this.summe = parseFloat(_this.summe) + parseFloat(strich.preis * strich.anzahl);
          _this.anzahl = parseFloat(_this.anzahl) + parseFloat(strich.anzahl);
        } else {
          _this.summe = parseFloat(_this.summe) + parseFloat(strich.preis);
        }
      });
      this.$vars.loading = false;
      return striche;
    },
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    series: function series() {
      var _this2 = this;

      var striche = this.striche;
      var minDatum = new Date(8640000000000000).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      });
      var maxDatum = new Date(0).toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" });
      var result = [];
      var series = [{
        data: [],
        name: "Striche"
      }];
      striche.forEach(function (strich) {
        var datum = new Date(strich.date.seconds * 1000).toLocaleString(["de-de"], {
          month: "short",
          day: "2-digit",
          year: "numeric"
        });
        if (datum < minDatum) {
          minDatum = datum;
        }
        if (datum > maxDatum) {
          maxDatum = datum;
        }
      });
      for (var dt = new Date(minDatum); dt <= new Date(maxDatum); dt.setDate(dt.getDate() + 1)) {
        var datum = new Date(dt).toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" });
        result.push({ datum: datum, anzahl: 0 });
      }
      striche.forEach(function (strich) {
        var datum = new Date(strich.date.seconds * 1000).toLocaleString(["de-de"], {
          month: "short",
          day: "2-digit",
          year: "numeric"
        });
        if (strich.art === "strich") {
          var index = result.map(function (object) {
            return object.datum;
          }).indexOf(datum);
          result[index].anzahl += parseInt(strich.anzahl);
        }
      });
      var max = 0;
      result.forEach(function (item) {
        if (item.anzahl > max) {
          max = item.anzahl;
        }
        series[0].data.push(item.anzahl);
        var datum = new Date(item.datum).toLocaleString(["de-de"], { month: "short", day: "2-digit" });
        _this2.options.xaxis.categories.push(datum);
      });
      this.options.yaxis.max = Math.ceil(max / Math.pow(10, max.toString().length - 1)) * Math.pow(10, max.toString().length - 1);
      return series;
    },
    sideHeight: function sideHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "calc(100vh - 289px)";
        case "sm":
          return "calc(100vh - 289px)";
        case "md":
          return "calc(100vh - 289px)";
        case "lg":
          return "calc(100vh - 289px)";
        case "xl":
          return "calc(100vh - 289px)";
      }
    }
  },
  methods: {
    rechnungVorbereiten: function rechnungVorbereiten() {
      var _this3 = this;

      this.$vars.loading = !this.$vars.loading;
      this.rechnung_anzahl = "";
      this.rechnung_positionen = [];
      this.rechnung_summe = 0;
      this.rechnung_summe_sepa = 0;
      this.rechnung_summe_striche = 0;
      this.rechnung_summe_ekp = 0;
      this.rechnung_summe_pauschal = 0;
      this.rechnungStriche = [];
      this.rechnungen = [];
      if (this.rechnung_alle) {
        this.rechnungStriche = this.striche;
      } else {
        this.rechnungStriche = [];
        this.striche.forEach(function (strich) {
          var date = new Date(new Date(strich.date.seconds * 1000).setHours(2)).toISOString().substr(0, 10);
          if (_this3.rechnung_von <= date && date <= _this3.rechnung_bis) {
            _this3.rechnungStriche.push(strich);
          }
        });
      }

      var bbrbbr = [];
      this.rechnungStriche.forEach(function (strich) {
        if (bbrbbr.indexOf(strich.bbrID) === -1) {
          bbrbbr.push(strich.bbrID);
        }
      });
      var result = {};
      var key = "bbrID";
      this.rechnungStriche.forEach(function (item) {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push({
          id: item[key],
          item: item
        });
      });
      bbrbbr.forEach(function (bbr) {
        var sepaInfo = false;
        var user = _this3.$store.getters["bbrbbr/bbr"](bbr);
        console.log(bbr);
        if (user.sepa) {
          if (user.sepa["Bierkasse"] && user.iban !== "" && user.bic !== "" && user.kontoinhaber !== "" && user.mandatsreferenz !== "") {
            sepaInfo = true;
          }
        }
        var rechnungPositionen = [];
        var posStriche = [];
        var posEkp = [];
        var posPauschal = [];
        var sumStriche = 0;
        var sumEkp = 0;
        var sumPauschal = 0;
        for (var i = 0; i < result[bbr].length; i++) {
          switch (result[bbr][i].item.art) {
            case "strich":
              sumStriche = parseFloat(sumStriche) + parseFloat(result[bbr][i].item.preis * result[bbr][i].item.anzahl);
              _this3.rechnung_summe_striche = parseFloat(_this3.rechnung_summe_striche) + parseFloat(result[bbr][i].item.preis * result[bbr][i].item.anzahl);
              if (sepaInfo) {
                _this3.rechnung_summe_sepa = _this3.rechnung_summe_sepa + parseFloat(result[bbr][i].item.preis * result[bbr][i].item.anzahl);
              }
              posStriche.push({
                id: result[bbr][i].item.id,
                datum: result[bbr][i].item.date,
                preis: result[bbr][i].item.preis * result[bbr][i].item.anzahl,
                anzahl: result[bbr][i].item.anzahl
              });
              break;
            case "ekp":
              sumEkp = parseFloat(sumEkp) + parseFloat(result[bbr][i].item.preis);
              _this3.rechnung_summe_ekp = parseFloat(_this3.rechnung_summe_ekp) + parseFloat(result[bbr][i].item.preis);
              if (sepaInfo) {
                _this3.rechnung_summe_sepa = _this3.rechnung_summe_sepa + parseFloat(result[bbr][i].item.preis);
              }
              posEkp.push({
                id: result[bbr][i].item.id,
                datum: result[bbr][i].item.date,
                preis: result[bbr][i].item.preis,
                was: result[bbr][i].item.grund
              });
              break;
            case "pauschal":
              sumPauschal = parseFloat(sumPauschal) + parseFloat(result[bbr][i].item.preis);
              _this3.rechnung_summe_pauschal = parseFloat(_this3.rechnung_summe_pauschal) + parseFloat(result[bbr][i].item.preis);
              if (sepaInfo) {
                _this3.rechnung_summe_sepa = _this3.rechnung_summe_sepa + parseFloat(result[bbr][i].item.preis);
              }
              posPauschal.push({
                id: result[bbr][i].item.id,
                datum: result[bbr][i].item.date,
                preis: result[bbr][i].item.preis,
                was: result[bbr][i].item.grund
              });
              break;
            default:
              console.log("Fehler");
          }
        }
        var a = "0000" + _this3.rechnungsnummer[2]++;
        var b = a.substr(a.length - 4, 4);
        var rechnungsnummer = _this3.rechnungsnummer[0] + "-" + b;
        if (sumStriche !== 0) {
          rechnungPositionen.push({
            was: "Striche",
            betrag: sumStriche.toFixed(2),
            positionen: posStriche
          });
        }
        if (sumEkp !== 0) {
          rechnungPositionen.push({
            was: "EKP",
            betrag: sumEkp.toFixed(2),
            positionen: posEkp
          });
        }
        if (sumPauschal !== 0) {
          rechnungPositionen.push({
            was: "Pauschal",
            betrag: sumPauschal.toFixed(2),
            positionen: posPauschal
          });
        }
        if (sepaInfo) {
          _this3.rechnungen.push({
            bbr: _this3.$store.getters["bbrbbr/bbr"](bbr).nachname + ", " + _this3.$store.getters["bbrbbr/bbr"](bbr).vorname,
            bbrID: bbr,
            rechnung_art: "SEPA",
            gezahlt_Datum: _this3.rechnung_zahlbar_bis,
            rechnung_titel: _this3.rechnung_titel,
            rechnung_datum: _this3.rechnung_datum,
            rechnung_zahlbar_bis: _this3.rechnung_zahlbar_bis,
            rechnung_freitext: _this3.rechnung_freitext_sepa,
            positionen: rechnungPositionen,
            status: "Entwurf SEPA",
            rechnungsnummer: rechnungsnummer
          });
        } else {
          _this3.rechnungen.push({
            bbr: _this3.$store.getters["bbrbbr/bbr"](bbr).nachname + ", " + _this3.$store.getters["bbrbbr/bbr"](bbr).vorname,
            bbrID: bbr,
            rechnung_art: "Überweisung",
            rechnung_titel: _this3.rechnung_titel,
            rechnung_datum: _this3.rechnung_datum,
            rechnung_zahlbar_bis: _this3.rechnung_zahlbar_bis,
            rechnung_freitext: _this3.rechnung_freitext,
            positionen: rechnungPositionen,
            status: "Entwurf",
            rechnungsnummer: rechnungsnummer
          });
        }
      });
      this.rechnung_anzahl = this.rechnungen.length;
      this.rechnung_summe = parseFloat(this.rechnung_summe_striche) + parseFloat(this.rechnung_summe_ekp) + parseFloat(this.rechnung_summe_pauschal);
      this.$vars.loading = !this.$vars.loading;
      this.e1 = 3;
    },
    ersetzeText: function ersetzeText(text, rechnung) {
      var summe = 0;
      rechnung.positionen.forEach(function (position) {
        summe = parseFloat(summe) + parseFloat(position.betrag);
      });

      var name = rechnung.bbr.split(", ");
      text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
      text = text.replace("<<Rechnungsdatum>>", new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
      text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
      text = text.replace("<<Vorname>>", name[1]);
      text = text.replace("<<Nachname>>", name[0]);
      text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
      text = text.replace("<<Zahlbar_bis>>", new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      return text;
    },
    rechnungErstellen: function rechnungErstellen() {
      var _this4 = this;

      this.loading = true;
      this.e1 = 4;
      var fortschrittMax = this.rechnungen.length + this.rechnungStriche.length + 1;
      var fortschritt = 0;
      this.fortschritt = fortschritt / fortschrittMax * 100;
      this.rechnungen.forEach(function (rechnung) {
        rechnung.rechnung_freitext = _this4.ersetzeText(rechnung.rechnung_freitext, rechnung);
        rechnung.rechnung_freitext_code = rechnung.rechnung_freitext.replace(/(?:\r\n|\r|\n)/g, "<br>");
        rechnung.kasse = "Bierkasse";

        _this4.$store.dispatch("rechnungen/createRechnung", rechnung);
        fortschritt++;
        _this4.fortschritt = fortschritt / fortschrittMax * 100;
      });

      this.rechnungStriche.forEach(function (strich) {
        var value = {
          id: strich.id,
          status: "berechnet"
        };
        _this4.$store.dispatch("striche/updateStrichData", value);
        fortschritt++;
        _this4.fortschritt = fortschritt / fortschrittMax * 100;
      });
      var rechnungsnummer = {
        rechnungsnummer: [this.rechnungsnummer[0], this.rechnungsnummer[1], this.rechnungsnummer[2]]
      };
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("einstellungen").doc("rechnungsnummer").update(rechnungsnummer).then(function () {
        _this4.loading = false;
        _this4.fortschritt = 100;
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteStrich: function deleteStrich(value) {
      this.$store.dispatch("striche/deleteStrichData", value);
    }
  },
  beforeMount: function beforeMount() {
    var _this5 = this;

    this.$vars.loading = false;
    this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("einstellungen").doc("rechnungsnummer").get().then(function (doc) {
      if (!doc.exists) {
        console.log("Dokument existiert nicht");
        _this5.$vars.loading = false;
      } else {
        if (doc.data().rechnungsnummer) {
          _this5.rechnungsnummer = [doc.data().rechnungsnummer[0], doc.data().rechnungsnummer[1], doc.data().rechnungsnummer[2]];
        }
        _this5.$vars.loading = false;
      }
    }).catch(function (err) {
      console.log("Error getting document", err);
    });
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["props"],
  data: function data() {
    return {
      date: new Date(),
      datepicker: new Date().toISOString().substr(0, 10),
      pauschal: "",
      getrankeselect: [],
      striche: "",
      items: [],
      grund: "",
      bbrID: "",
      ekp: "",
      ekp_anzahl: "",
      stricheheute: [],
      menu: false
    };
  },

  computed: {
    summe: function summe() {
      var summe = 0;
      this.items.forEach(function (item) {
        summe = parseFloat(summe) + parseFloat(item.preis);
      });
      return summe;
    },
    bundesbruderselect: function bundesbruderselect() {
      var items = this.$store.state.bbrbbr.bbrbbr;
      var bbrbbr = [];
      items.forEach(function (item) {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")"
          });
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname
          });
        }
      });
      return bbrbbr;
    }
  },
  methods: {
    addItem: function addItem() {
      if (this.pauschal) {
        this.items.push({
          art: "pauschal",
          was: this.grund,
          anzahl: "pauschal",
          grund: this.grund,
          preis: this.pauschal,
          status: ""
        });
      }
      if (this.ekp) {
        this.items.push({
          art: "ekp",
          was: this.ekp[0].bezeichnung,
          ekp: this.ekp,
          anzahl: this.ekp_anzahl,
          preis: this.ekp[0].preis * this.ekp_anzahl,
          status: ""
        });
      }
      this.ekp = "";
      this.ekp_anzahl = "";
      this.pauschal = "";
      this.grund = "";
    },
    saveItem: function saveItem() {
      var _this = this;

      this.items.forEach(function (item) {
        var eintrag = void 0;
        if (item.art === "ekp") {
          eintrag = {
            bbrID: _this.bbrID,
            art: "ekp",
            ekp: item.ekp,
            date: _this.date,
            preis: item.ekp[0].preis,
            anzahl: 1,
            status: "",
            grund: item.ekp[0].bezeichnung
          };
          for (var i = 1; i <= item.anzahl; i++) {
            _this.$store.dispatch("striche/createStrich", eintrag);
          }
        }
        if (item.art === "pauschal") {
          eintrag = {
            bbrID: _this.bbrID,
            art: "pauschal",
            preis: item.preis,
            date: _this.date,
            grund: item.grund,
            anzahl: 1,
            status: ""
          };
          _this.$store.dispatch("striche/createStrich", eintrag);
        }
      });
      this.ekp = "";
      this.ekp_anzahl = "";
      this.pauschal = "";
      this.grund = "";
      this.items = [];
    },
    deleteStrich: function deleteStrich(value) {
      this.items.splice(this.items.indexOf(value), 1);
    },
    getDatepicker: function getDatepicker() {
      this.date = new Date(this.datepicker);
      this.datepicker = new Date(this.date).toISOString().substr(0, 10);
      this.menu = false;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("getranke").orderBy("bezeichnung").onSnapshot(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        _this2.getrankeselect.push({
          value: [{
            id: doc.id,
            preis: doc.data().verkauf1,
            bezeichnung: doc.data().bezeichnung
          }],
          text: doc.data().bezeichnung
        });
      });
    }, function (err) {
      console.log("Encountered error: " + err);
    });
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['props'],
  data: function data() {
    return {
      neueRechnung: {
        bbrbbr: [],
        titel: '',
        datum: new Date().toISOString().substr(0, 10),
        zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
        freitext: '<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart',
        freitext_Sepa: '<<Briefanrede>> <<Nachname>>, \n\nhiermit informiere ich Dich, dass die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ am <<Zahlbar_bis>> von Deinem Konto abgebucht wird. \n \nMit bundesbrüderlichen Grüßen  \nThomas Wieczorek \nBierwart',
        positionen: [],
        kasse: 'Bierkasse',
        status: 'Entwurf'
      },
      menu1: '',
      menu2: '',
      date: new Date(),
      datepicker: new Date().toISOString().substr(0, 10),
      pauschal: '',
      getrankeselect: [],
      striche: '',
      items: [],
      grund: '',
      bbrID: '',
      ekp: '',
      ekp_anzahl: '',
      stricheheute: [],
      menu: false
    };
  },

  computed: {
    formatDatum: function formatDatum() {
      if (!this.neueRechnung.datum) return null;
      return new Date(this.neueRechnung.datum).toLocaleString(['de-de'], { month: 'short', weekday: 'short', day: 'numeric', year: '2-digit' });
    },
    formatZahlbar_bis: function formatZahlbar_bis() {
      if (!this.neueRechnung.zahlbar_bis) return null;
      return new Date(this.neueRechnung.zahlbar_bis).toLocaleString(['de-de'], { month: 'short', weekday: 'short', day: 'numeric', year: '2-digit' });
    },
    summe: function summe() {
      var summe = 0;
      this.items.forEach(function (item) {
        summe = parseFloat(summe) + parseFloat(item.preis);
      });
      return summe;
    },
    bundesbruderselect: function bundesbruderselect() {
      var items = this.$store.state.bbrbbr.bbrbbr;
      var bbrbbr = [];
      items.forEach(function (item) {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname + ' (' + item.vulgo + ')'
          });
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname
          });
        }
      });
      return bbrbbr;
    }
  },
  methods: {
    addItem: function addItem() {
      if (this.pauschal) {
        this.items.push({
          art: 'pauschal',
          was: this.grund,
          anzahl: 'pauschal',
          grund: this.grund,
          preis: this.pauschal,
          status: ''
        });
      }
      if (this.ekp) {
        this.items.push({
          art: 'ekp',
          was: this.ekp[0].bezeichnung,
          ekp: this.ekp,
          anzahl: this.ekp_anzahl,
          preis: this.ekp[0].preis * this.ekp_anzahl,
          status: ''
        });
      }
      this.ekp = '';
      this.ekp_anzahl = '';
      this.pauschal = '';
      this.grund = '';
    },
    saveItem: function saveItem() {
      var _this = this;

      this.items.forEach(function (item) {
        var eintrag = void 0;
        if (item.art === 'ekp') {
          eintrag = {
            bbrID: _this.bbrID,
            art: 'ekp',
            ekp: item.ekp,
            date: _this.date,
            preis: item.ekp[0].preis,
            anzahl: 1,
            status: 'berechnet',
            grund: item.ekp[0].bezeichnung
          };
          for (var i = 1; i <= item.anzahl; i++) {
            _this.$store.dispatch('striche/createStrich', eintrag);
          }
        }
        if (item.art === 'pauschal') {
          eintrag = {
            bbrID: _this.bbrID,
            art: 'pauschal',
            preis: item.preis,
            date: _this.date,
            grund: item.grund,
            anzahl: 1,
            status: 'berechnet'
          };
          _this.$store.dispatch('striche/createStrich', eintrag);
        }
      });
      this.ekp = '';
      this.ekp_anzahl = '';
      this.pauschal = '';
      this.grund = '';
      this.items = [];
    },
    deleteStrich: function deleteStrich(value) {
      this.items.splice(this.items.indexOf(value), 1);
    },
    getDatepicker: function getDatepicker() {
      this.date = new Date(this.datepicker);
      this.datepicker = new Date(this.date).toISOString().substr(0, 10);
      this.menu = false;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('getranke').orderBy('bezeichnung').onSnapshot(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        _this2.getrankeselect.push({
          value: [{
            id: doc.id,
            preis: doc.data().verkauf1,
            bezeichnung: doc.data().bezeichnung
          }],
          text: doc.data().bezeichnung
        });
      });
    }, function (err) {
      console.log('Encountered error: ' + err);
    });
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["on"],
  data: function data() {
    return {
      headers: [{ text: "Datum", value: "datum" }, { text: "Titel", value: "titel" }, { text: "Anzahl", value: "strafen.length" }, { text: "", value: "" }],
      selected: [],
      search: "",
      menu1: "",
      showCouleurstrafe: false,
      couleurstrafe: {
        datum: "",
        titel: "",
        strafen: []
      },
      neuCouleurstrafe: false,
      newEintragCouleurstrafe: {},
      showDeleteCouleurstrafe: false,
      couleurstrafeVorlage: {
        datum: "",
        titel: "",
        strafen: []
      }
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    formatDatum: function formatDatum() {
      if (!this.couleurstrafe.datum) return null;
      return new Date(this.couleurstrafe.datum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    sideHeight: function sideHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "calc(100vh - 239px)";
        case "sm":
          return "calc(100vh - 239px)";
        case "md":
          return "calc(100vh - 239px)";
        case "lg":
          return "calc(100vh - 239px)";
        case "xl":
          return "calc(100vh - 239px)";
      }
    },
    selectBbrbbr: function selectBbrbbr() {
      var selectBbrbbr = [];
      this.$store.getters["bbrbbr/nurBbrbbr"].forEach(function (bbr) {
        selectBbrbbr.push({
          id: bbr.id,
          value: bbr.id,
          name: bbr.nachname + ", " + bbr.vorname,
          text: bbr.nachname + ", " + bbr.vorname
        });
      });
      return selectBbrbbr;
    },
    couleurstrafen: function couleurstrafen() {
      if (this.$store.state.couleurstrafen.couleurstrafen.length === 0) {
        this.$store.dispatch("couleurstrafen/loadCouleurstrafen");
      }

      return this.$store.state.couleurstrafen.couleurstrafen.sort(function (a, b) {
        if (a.datum < b.datum) return 1;
        if (a.datum > b.datum) return -1;
        return 0;
      });
    },
    summe: function summe() {
      var summe = 0;
      if (this.couleurstrafen) {
        this.couleurstrafen.forEach(function (item) {
          if (item.strafen) {
            item.strafen.forEach(function (strafe) {
              if (!strafe.bezahlt) {
                summe += parseFloat(strafe.betrag);
              }
            });
          }
        });
      }
      return summe;
    }
  },
  methods: {
    addEintragCouleurstrafe: function addEintragCouleurstrafe() {
      if (this.newEintragCouleurstrafe.wer && this.newEintragCouleurstrafe.betrag > 0) {
        if (!this.couleurstrafe.strafen) {
          this.couleurstrafe.strafen = [];
        }
        this.couleurstrafe.strafen.push({
          id: new Date().getTime(),
          wer: this.newEintragCouleurstrafe.wer,
          betrag: this.newEintragCouleurstrafe.betrag,
          bezahlt: false
        });
        this.newEintragCouleurstrafe = {};
      }
    },
    deleteEintragCouleurstrafe: function deleteEintragCouleurstrafe(index) {
      this.couleurstrafe.strafen.splice(index, 1);
    },
    createCouleurstrafe: function createCouleurstrafe() {
      console.log(this.couleurstrafe);
      this.$store.dispatch("couleurstrafen/createCouleurstraf", this.couleurstrafe);
      this.showCouleurstrafe = false;
      this.couleurstrafe = this.couleurstrafeVorlage;
    },
    updateCouleurstrafe: function updateCouleurstrafe() {
      this.$store.dispatch("couleurstrafen/updateCouleurstrafData", this.couleurstrafe);
      this.showCouleurstrafe = false;
      this.couleurstrafe = this.couleurstrafeVorlage;
    },
    deleteCouleurstrafe: function deleteCouleurstrafe() {
      this.$store.dispatch("couleurstrafen/deleteCouleurstrafData", this.couleurstrafe.id);
      this.showCouleurstrafe = false;
      this.couleurstrafe = this.couleurstrafeVorlage;
      this.showDeleteCouleurstrafe = false;
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tree2: null,
      search: null,
      tree: [{}],
      selectFile: {},
      test: [],
      showVerzeichnisse: true,
      showNeuesVerzeichnis: false,
      showNeuerOrdner: false,
      showRenameFile: false,
      showUploadFiles: false,
      neu: {
        uploadFiles: [],
        uploadStatus: []
      },
      loading: false,
      showDeleteFile: false,
      uploadValue: 0,
      deleteFileData: {},
      info: "",
      showDownloadLog: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    sideHeight: function sideHeight() {
      this.dateien;
      this.verzeichnisse;
      if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 191px)";
          case "sm":
            return "calc(100vh - 179px)";
          case "md":
            return "calc(100vh - 199px)";
          case "lg":
            return "calc(100vh - 191px)";
          case "xl":
            return "calc(100vh - 191px)";
        }
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 199px)";
          case "sm":
            return "calc(100vh - 199px)";
          case "md":
            return "calc(100vh - 199px)";
          case "lg":
            return "calc(100vh - 199px)";
          case "xl":
            return "calc(100vh - 199px)";
        }
      }
    },
    items: function items() {
      var _this = this;

      if (this.$store.state.dateien.loaded === false) {
        this.$store.dispatch("dateien/loadDateien");
      }
      var verzeichnisse = [];
      this.$store.state.dateien.dateien.forEach(function (item) {
        if (_this.search !== null) {
          if (item.name.includes(_this.search)) {
            verzeichnisse.push(item);
          }
        } else {
          if (item.art === "Verzeichnis") {
            verzeichnisse.push({
              id: item.id,
              art: item.art,
              name: item.name,
              icon: item.icon,
              children: _this.getChildren(item.id),
              size: item.size,
              type: item.type,
              path: item.path,
              url: item.url,
              zuletztbearbeitet: item.zuletztbearbeitet,
              zuletztbearbeitetvon: item.zuletztbearbeitetvon
            });
          }
        }
      });
      console.log(Array.isArray(verzeichnisse));
      return verzeichnisse;
    },
    deleteFileDataAll: function deleteFileDataAll() {
      var data = [];
      data.push(this.deleteFileData);
      data = data.concat(this.getFileChilds(this.deleteFileData.id));
      return data;
    }
  },
  methods: {
    getFileChilds: function getFileChilds(id) {
      var _this2 = this;

      var files = [];
      this.$store.state.dateien.dateien.forEach(function (item) {
        if (item.parent === id) {
          files.push(item);
          files = files.concat(_this2.getFileChilds(item.id));
        }
      });
      return files;
    },
    formatSize: function formatSize(bytes) {
      if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(2) + " GB";
      } else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + " MB";
      } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + " KB";
      } else if (bytes > 1) {
        bytes = bytes + " bytes";
      } else if (bytes === 1) {
        bytes = bytes + " byte";
      } else {
        bytes = "";
      }
      return bytes;
    },
    getChildren: function getChildren(id) {
      var _this3 = this;

      var children = [];
      this.$store.state.dateien.dateien.forEach(function (item) {
        if (item.parent === id && item.art === "Ordner") {
          children.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            children: _this3.getChildren(item.id)
          }));
        }
      });
      return children;
    },
    getAllChildren: function getAllChildren(id) {
      var _this4 = this;

      var children = [];
      this.$store.state.dateien.dateien.forEach(function (item) {
        if (item.parent === id) {
          children.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            children: _this4.getChildren(item.id)
          }));
        }
      });
      return children;
    },
    createVerzeichnis: function createVerzeichnis() {
      var neuesVerzeichnis = {
        name: this.neu.name,
        icon: "dns",
        art: "Verzeichnis",
        zuletztbearbeitet: new Date(),
        zuletztbearbeitetvon: this.currentBbr
      };
      this.$store.dispatch("dateien/createDatei", neuesVerzeichnis);
      this.neu = {};
      this.showNeuesVerzeichnis = false;
    },
    createOrdner: function createOrdner() {
      var neuerOrdner = {
        name: this.neu.name,
        icon: "folder",
        art: "Ordner",
        parent: this.tree[0].id,
        zuletztbearbeitet: new Date(),
        zuletztbearbeitetvon: this.currentBbr
      };
      console.log(neuerOrdner);
      this.$store.dispatch("dateien/createDatei", neuerOrdner);
      this.neu = {};
      this.showNeuerOrdner = false;
    },
    uploadFiles: function uploadFiles() {
      var _this5 = this;

      var id = this.tree[0].id;
      this.loading = true;
      var counter = 0;
      this.neu.uploadStatus = Array(this.neu.dateien.length).fill(0);
      this.neu.dateien.forEach(function (file) {
        var name = new Date().getTime() + file.name;
        var storageRef = _this5.$firebase.storage().ref("dateien/" + name).put(file);
        storageRef.on("state_changed", function (snapshot) {
          _this5.neu.uploadStatus[_this5.neu.dateien.indexOf(file)] = snapshot.bytesTransferred / snapshot.totalBytes * 100;
          _this5.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        }, function (error) {
          _this5.uploadStatus.error = error.message;
        }, function () {
          storageRef.snapshot.ref.getDownloadURL().then(function (url) {
            if (file.type.includes("image") && file.type !== "image/svg+xml") {
              _this5.info = "Da Du auch Bilder hochlädst, kann es nach dem Upload noch einige Sekunden dauern bis der Prozess abgeschlossen ist. Bitte schließe das Fenester während des Prozesses nicht";
              setTimeout(function () {
                var pathParts = storageRef.snapshot.ref.fullPath.split(".");
                var path200 = pathParts.slice(0, -1).join(".") + "_200x200." + pathParts.slice(-1);
                _this5.$firebase.storage().ref(path200).getDownloadURL().then(function (url) {
                  var img2 = url;
                  var path500 = pathParts.slice(0, -1).join(".") + "_500x500." + pathParts.slice(-1);
                  _this5.$firebase.storage().ref(path500).getDownloadURL().then(function (url) {
                    var img3 = url;
                    var fileData = {
                      name: file.name,
                      size: file.size,
                      type: file.type,
                      path: storageRef.snapshot.ref.fullPath,
                      path200: path200,
                      path500: path500,
                      url: url,
                      url200: img2,
                      url500: img3,
                      icon: "description",
                      art: "Datei",
                      parent: id,
                      zuletztbearbeitet: new Date(file.lastModified),
                      zuletztbearbeitetvon: _this5.currentBbr
                    };
                    _this5.$store.dispatch("dateien/createDatei", fileData);
                    counter++;
                    if (counter === _this5.neu.dateien.length) {
                      _this5.neu = {};
                      _this5.showUploadFiles = false;
                      _this5.loading = false;
                      _this5.uploadValue = 0;
                      _this5.info = "";
                    }
                  }).catch(function (error) {
                    console.log(error);
                  });
                }).catch(function (error) {
                  console.log(error);
                });
              }, 5000);
            } else {
              var fileData = {
                name: file.name,
                size: file.size,
                type: file.type,
                path: storageRef.snapshot.ref.fullPath,
                url: url,
                icon: "description",
                art: "Datei",
                parent: id,
                zuletztbearbeitet: new Date(file.lastModified),
                zuletztbearbeitetvon: _this5.currentBbr
              };
              _this5.$store.dispatch("dateien/createDatei", fileData);
              counter++;
              if (counter === _this5.neu.dateien.length) {
                _this5.neu = {};
                _this5.showUploadFiles = false;
                _this5.loading = false;
                _this5.uploadValue = 0;
              }
            }
          });
        });
      });
    },
    downloadFile: function downloadFile(file) {
      var link = document.createElement("a");
      link.setAttribute("href", file.url);
      link.setAttribute("download", file.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    renameFile: function renameFile() {
      this.$store.dispatch("dateien/updateDateiData", this.selectFile);
      this.showRenameFile = false;
    },
    deleteFiles: function deleteFiles() {
      var _this6 = this;

      this.loading = true;
      console.log(this.deleteFileData);
      console.log(this.deleteFileDataAll);
      this.deleteFileDataAll.forEach(function (item) {
        console.log(item);
        if (item.art === "Ordner") {
          _this6.$store.dispatch("dateien/deleteDateiData", item.id);
        }
        if (item.art === "Datei") {
          if (item.type.includes("image") && item.type !== "image/svg+xml") {
            _this6.$firebase.storage().ref(item.path).delete().catch(function (error) {
              return console.log("Fehler beim Löschen der Datei: ", error);
            });
            _this6.$firebase.storage().ref(item.path200).delete().catch(function (error) {
              return console.log("Fehler beim Löschen der Datei: ", error);
            });
            _this6.$firebase.storage().ref(item.path500).delete().then(function () {
              _this6.$store.dispatch("dateien/deleteDateiData", item.id);
            }).catch(function (error) {
              return console.log("Fehler beim Löschen der Datei: ", error);
            });
          } else {
            _this6.$firebase.storage().ref(item.path).delete().then(function () {
              _this6.$store.dispatch("dateien/deleteDateiData", item.id);
            }).catch(function (error) {
              return console.log("Fehler beim Löschen der Datei: ", error);
            });
          }
        }
      });
      this.loading = false;
      this.showDeleteFile = false;
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jspdf__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: null,
      isNew: null,
      neuesDokumentDefault: {
        datum: new Date(),
        data: {
          tops: []
        }
      },
      neuesDokument: {
        datum: new Date(),
        data: {
          tops: []
        }
      },
      dokumentArten: [{
        titel: 'Rundbrief (ohne persönliche Ansprache)',
        beschreibung: 'DIN A4',
        text: 'Rundbrief, DIN A4',
        value: 'rundbriefohneansprache'
      }, {
        titel: 'Kommerseinladung Faltkarte',
        beschreibung: 'DIN-Lang, 4-Seitig, Vorschau und Druckversion',
        text: 'Kommerseinladung, DIN-Lang, 4-Seitig, Vorschau und Druckversion',
        value: 'kommerseinladung'
      }, {
        titel: 'Tagesordnung',
        beschreibung: 'DIN A4, für alle Convente',
        text: 'Tagesordnung, DIN A4, für alle Convente',
        value: 'tagesordnung'
      }, {
        titel: 'Rundbrief 160 Stiftungsfest',
        beschreibung: 'DIN A4',
        text: 'Rundbrief, DIN A4',
        value: 'rundbrief160'
      }],
      showNeuesDokument: false
    };
  },

  computed: {
    dokumente: function dokumente() {
      if (this.$store.state.dokumente.loaded === false) {
        this.$store.dispatch('dokumente/loadDokumente');
      }
      return this.$store.state.dokumente.dokumente;
    },
    selectBbrBbr: function selectBbrBbr() {
      var selectBbrBbr = [];
      this.$store.getters['bbrbbr/nurBbrbbr'].forEach(function (bbr) {
        selectBbrBbr.push({
          id: bbr.id,
          value: bbr.id,
          name: bbr.nachname + ', ' + bbr.vorname,
          text: bbr.nachname + ', ' + bbr.vorname
        });
      });
      return selectBbrBbr;
    }
  },
  methods: {
    createDokument: function createDokument() {
      this.$store.dispatch('dokumente/createDokument', this.neuesDokument);
      this.neuesDokument = this.neuesDokumentDefault;
      this.showNeuesDokument = false;
    },
    updateDokument: function updateDokument() {
      this.$store.dispatch('dokumente/updateDokumentData', this.neuesDokument);
      this.neuesDokument = this.neuesDokumentDefault;
      this.showNeuesDokument = false;
    },
    printDokument: function printDokument() {
      if (this.neuesDokument.art === 'kommerseinladung') {
        this.printKommerseinladung();
      }
      if (this.neuesDokument.art === 'tagesordnung') {
        this.printTagesordnung();
      }
      if (this.neuesDokument.art === 'rundbriefohneansprache') {
        this.printRundbriefohneansprache();
      }
      if (this.neuesDokument.art === 'rundbrief160') {
        this.printBrief160();
      }
    },
    printKommerseinladung: function printKommerseinladung() {
      var doc = new __WEBPACK_IMPORTED_MODULE_0_jspdf__["default"]('p', 'mm', [204, 216]);
      doc.setFont('Times');
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 195, 204, 3, 'F');
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 195, 204, 3, 'F');
      doc.setFillColor(219, 31, 41);
      doc.rect(0, 201, 204, 3, 'F');
      var img = new Image();
      img.src = '/static/wappen.png';
      doc.addImage(img, 111.5, 52, 80, 80);
      var img2 = new Image();
      img2.src = '/static/zirkel.png';
      doc.addImage(img2, 21, 50, 58, 96);
      doc.setFontSize(36);
      this.neuesDokument.data.titel1 ? doc.text(this.neuesDokument.data.titel1, 151.5, 25, null, null, 'center') : '';
      this.neuesDokument.data.titel2 ? doc.text(this.neuesDokument.data.titel2, 151.5, 40, null, null, 'center') : '';
      this.neuesDokument.data.titel3 ? doc.text(this.neuesDokument.data.titel3, 151.5, 150, null, null, 'center') : '';
      this.neuesDokument.data.titel4 ? doc.text(this.neuesDokument.data.titel4, 151.5, 165, null, null, 'center') : '';
      doc.setFontSize(18);
      this.neuesDokument.data.titel5 ? doc.text(this.neuesDokument.data.titel5, 151.5, 180, null, null, 'center') : '';
      doc.addPage();
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 195, 204, 3, 'F');
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 195, 204, 3, 'F');
      doc.setFillColor(219, 31, 41);
      doc.rect(0, 201, 204, 3, 'F');
      doc.setFontSize(14);
      var lines1 = doc.splitTextToSize(this.neuesDokument.data.anschreiben, 79);
      var zeile = 99 - 0.5 * (parseInt(parseInt(6) * lines1.length / 2) + 12 + 30);
      doc.text(lines1, 52.5, zeile, null, null, 'center');
      zeile = 99 + 0.5 * (parseInt(parseInt(6) * lines1.length / 2) + 12 + 30);
      doc.text('für die Aktivitas', 27.75, zeile, null, null, 'center');
      this.neuesDokument.data.senior ? doc.text(this.neuesDokument.data.senior, 27.75, zeile + 6, null, null, 'center') : '';
      doc.text('Senior', 27.75, zeile + 12, null, null, 'center');
      doc.text('für den AHV', 77.25, zeile, null, null, 'center');
      this.neuesDokument.data.philsenior ? doc.text(this.neuesDokument.data.philsenior, 77.25, zeile + 6, null, null, 'center') : '';
      doc.text('Philistersenior', 77.25, zeile + 12, null, null, 'center');
      zeile = 13;
      doc.lineHeightProportion = 1.5;
      doc.setFont('Times', 'bold');
      this.neuesDokument.data.tag1 ? doc.text(this.neuesDokument.data.tag1, 151.5, zeile, null, null, 'center') : '';
      doc.setFont('Times', 'normal');
      var lines2 = this.neuesDokument.data.tag1programm ? doc.splitTextToSize(this.neuesDokument.data.tag1programm, 79) : '';
      doc.text(lines2, 151.5, zeile + 10, { lineHeightFactor: 1.5, align: 'center' });
      zeile += parseInt(parseInt(7) * lines2.length) + 15;
      doc.setFont('Times', 'bold');
      this.neuesDokument.data.tag2 ? doc.text(this.neuesDokument.data.tag2, 151.5, zeile, null, null, 'center') : '';
      doc.setFont('Times', 'normal');
      var lines3 = this.neuesDokument.data.tag2programm ? doc.splitTextToSize(this.neuesDokument.data.tag2programm, 79) : '';
      doc.text(lines3, 151.5, zeile + 10, { lineHeightFactor: 1.5, align: 'center' });
      zeile += parseInt(parseInt(7) * lines3.length) + 15;
      doc.setFont('Times', 'bold');
      this.neuesDokument.data.tag3 ? doc.text(this.neuesDokument.data.tag3, 151.5, zeile, null, null, 'center') : '';
      doc.setFont('Times', 'normal');
      var lines4 = this.neuesDokument.data.tag3programm ? doc.splitTextToSize(this.neuesDokument.data.tag3programm, 79) : '';
      doc.text(lines4, 151.5, zeile + 10, { lineHeightFactor: 1.7, align: 'center' });
      doc.setFontSize(9);
      var lines5 = this.neuesDokument.data.anmerkung ? doc.splitTextToSize(this.neuesDokument.data.anmerkung, 79) : '';
      zeile = 195 - parseInt(parseInt(3) * lines5.length);
      doc.text(lines5, 151.5, zeile, null, null, 'center');
      doc.save('Einadung' + '.pdf');
    },
    printTagesordnung: function printTagesordnung() {
      var doc = new __WEBPACK_IMPORTED_MODULE_0_jspdf__["default"]({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('Times');
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 90, 210, 1, 'F');
      doc.setFillColor(219, 31, 41);
      doc.rect(0, 92, 210, 1, 'F');
      var img = new Image();
      img.src = '/static/wappen.png';
      doc.addImage(img, 125, 30, 75, 75);
      doc.setFontSize(9);
      doc.text('K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn', 25, 87);
      doc.setFontSize(14);
      doc.setFont('Times', 'bold');
      this.neuesDokument.data.ueberschrift ? doc.text(this.neuesDokument.data.ueberschrift, 25, 115, null, null, 'left') : '';
      doc.setFont('Times', 'normal');
      doc.setFontSize(11);
      var zeile = 125;
      var lines1 = this.neuesDokument.data.freitext1 ? doc.splitTextToSize(this.neuesDokument.data.freitext1, 160) : '';
      doc.text(lines1, 25, zeile);
      zeile += parseInt(parseInt(7) * lines1.length);
      var counter = 1;
      doc.setFontSize(14);
      this.neuesDokument.data.tops.forEach(function (top) {
        doc.text('TOP ' + counter + ': ' + top, 25, zeile);
        zeile += 9;
        counter++;
      });
      zeile += 8;
      doc.setFontSize(11);
      var lines2 = this.neuesDokument.data.freitext2 ? doc.splitTextToSize(this.neuesDokument.data.freitext2, 160) : '';
      doc.text(lines2, 25, zeile);
      doc.save('Tagesordnung.pdf');
    },
    printRundbriefohneansprache: function printRundbriefohneansprache() {
      var doc = new __WEBPACK_IMPORTED_MODULE_0_jspdf__["default"]({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('Times');
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 90, 210, 1, 'F');
      doc.setFillColor(219, 31, 41);
      doc.rect(0, 92, 210, 1, 'F');
      var img = new Image();
      img.src = '/static/wappen.png';
      doc.addImage(img, 125, 30, 75, 75);
      doc.setFontSize(9);
      doc.text('K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn', 25, 87);
      doc.setFontSize(14);
      doc.setFont('Times', 'bold');
      this.neuesDokument.data.ueberschrift ? doc.text(this.neuesDokument.data.ueberschrift, 25, 115, null, null, 'left') : '';
      doc.setFont('Times', 'normal');
      doc.setFontSize(11);
      var zeile = 125;
      var lines1 = this.neuesDokument.data.freitext ? doc.splitTextToSize(this.neuesDokument.data.freitext, 160) : '';
      for (var i = 0; i < lines1.length; i++) {
        if (zeile > 280) {
          zeile = 25;
          doc.addPage();
        }
        doc.text(25, zeile, lines1[i]);
        zeile += 6;
      }
      doc.save('Rundbrief.pdf');
    },
    printBrief160: function printBrief160() {
      var doc = new __WEBPACK_IMPORTED_MODULE_0_jspdf__["default"]({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('Times');
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 90, 210, 1, 'F');
      doc.setFillColor(219, 31, 41);
      doc.rect(0, 92, 210, 1, 'F');
      var img = new Image();
      img.src = '/static/logo160wappen.png';
      doc.addImage(img, 40, 18, 130, 58.32);
      doc.setFontSize(9);
      doc.text('K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn', 25, 87);
      doc.setFontSize(14);
      doc.setFont('Times', 'bold');
      this.neuesDokument.data.ueberschrift ? doc.text(this.neuesDokument.data.ueberschrift, 25, 115, null, null, 'left') : '';
      doc.setFont('Times', 'normal');
      doc.setFontSize(11);
      var zeile = 125;
      var lines1 = this.neuesDokument.data.freitext ? doc.splitTextToSize(this.neuesDokument.data.freitext, 160) : '';
      for (var i = 0; i < lines1.length; i++) {
        if (zeile > 280) {
          zeile = 25;
          doc.addPage();
        }
        doc.text(25, zeile, lines1[i]);
        zeile += 6;
      }
      doc.save('Rundbrief.pdf');
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectPicture: {},
      loading: {
        header: false,
        logo: false
      }
    };
  },

  computed: {
    settings: function settings() {
      return this.$store.getters['einstellungen/einstellung']('allgemein');
    },
    bundesbruderselect: function bundesbruderselect() {
      var items = this.$store.state.bbrbbr.bbrbbr;
      var bbrbbr = [];
      items.forEach(function (item) {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname + ' (' + item.vulgo + ')'
          });
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname
          });
        }
      });
      return bbrbbr;
    }
  },
  methods: {
    removeBerechtigung: function removeBerechtigung(item) {
      var index = this.settings.admins.indexOf(item);
      if (index >= 0) this.settings.admins.splice(index, 1);
    },
    uploadLogo: function uploadLogo() {
      var _this = this;

      this.loading.logo = true;
      this.settings.logo = null;
      var storageRef = this.$firebase.storage().ref('/design/logo/' + this.$vars.verbindung).put(this.selectPicture.logo);
      storageRef.on('state_changed', function (snapshot) {
        _this.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this.uploadStatus.error = error.message;
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this.settings.logo = url;
          _this.loading.logo = false;
        });
      });
    },
    uploadHeader: function uploadHeader() {
      var _this2 = this;

      this.loading.header = true;
      this.settings.header = null;
      var storageRef = this.$firebase.storage().ref('/design/header/' + this.$vars.verbindung).put(this.selectPicture.header);
      storageRef.on('state_changed', function (snapshot) {
        _this2.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this2.uploadStatus.error = error.message;
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this2.settings.header = url;
          _this2.loading.header = false;
        });
      });
    },
    uploadBackground: function uploadBackground() {
      var _this3 = this;

      this.loading.background = true;
      this.settings.background = null;
      var storageRef = this.$firebase.storage().ref('/design/background/' + this.$vars.verbindung).put(this.selectPicture.background);
      storageRef.on('state_changed', function (snapshot) {
        _this3.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this3.uploadStatus.error = error.message;
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this3.settings.background = url;
          _this3.loading.background = false;
        });
      });
    },
    save: function save() {
      this.$store.dispatch('einstellungen/updateEinstellungData', this.settings);
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectPicture: {},
      loading: {
        header: false,
        logo: false
      }
    };
  },

  computed: {
    settings: function settings() {
      return this.$store.getters['einstellungen/einstellung']('allgemein');
    }
  },
  methods: {
    uploadLogo: function uploadLogo() {
      var _this = this;

      this.loading.logo = true;
      this.settings.logo = null;
      var storageRef = this.$firebase.storage().ref('/design/logo/' + this.$vars.verbindung).put(this.selectPicture.logo);
      storageRef.on('state_changed', function (snapshot) {
        _this.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this.uploadStatus.error = error.message;
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this.settings.logo = url;
          _this.loading.logo = false;
        });
      });
    },
    uploadHeader: function uploadHeader() {
      var _this2 = this;

      this.loading.header = true;
      this.settings.header = null;
      var storageRef = this.$firebase.storage().ref('/design/header/' + this.$vars.verbindung).put(this.selectPicture.header);
      storageRef.on('state_changed', function (snapshot) {
        _this2.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this2.uploadStatus.error = error.message;
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this2.settings.header = url;
          _this2.loading.header = false;
        });
      });
    },
    uploadBackground: function uploadBackground() {
      var _this3 = this;

      this.loading.background = true;
      this.settings.background = null;
      var storageRef = this.$firebase.storage().ref('/design/background/' + this.$vars.verbindung).put(this.selectPicture.background);
      storageRef.on('state_changed', function (snapshot) {
        _this3.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this3.uploadStatus.error = error.message;
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this3.settings.background = url;
          _this3.loading.background = false;
        });
      });
    },
    save: function save() {
      this.$store.dispatch('einstellungen/updateEinstellungData', this.settings);
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: ''
    };
  },

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
  },
  computed: {
    gruppen: function gruppen() {
      return this.$store.getters['einstellungen/einstellung']('gruppen');
    },
    kontaktfelder_system: function kontaktfelder_system() {
      var items = [];
      this.$store.getters['einstellungen/einstellung']('kontaktfelder').neuFelder.forEach(function (item) {
        items.push({
          text: item.label,
          value: item.value
        });
      });
      return items;
    }
  },
  methods: {
    saveGruppen: function saveGruppen() {
      this.$store.dispatch('einstellungen/updateEinstellungData', this.gruppen);
    },
    addBedingung: function addBedingung(item) {
      item.bedingungen.push({
        feld: '',
        wert: []
      });
    },
    deleteBedingung: function deleteBedingung(item, bedingung) {
      item.bedingungen.splice(item.bedingungen.indexOf(bedingung), 1);
    },
    addGruppe: function addGruppe(index) {
      this.gruppen.gruppen[index].gruppen.push({
        bedingungen: [],
        text: 'Neue Gruppe'
      });
    },
    deleteGruppe: function deleteGruppe(index, item) {
      this.gruppen.gruppen[index].gruppen.splice(this.gruppen.gruppen[index].gruppen.indexOf(item), 1);
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jszip__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_papaparse__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showTemplate: false,
      template: {},
      istNeu: false,
      templateKategorien: ['Mail', 'Rechnung', 'Brief']
    };
  },

  computed: {
    templates: function templates() {
      return this.$store.getters['einstellungen/einstellung']('templates').templates;
    }
  },
  methods: {
    backupData: function backupData() {
      var tabellenData = [];
      var zip = new __WEBPACK_IMPORTED_MODULE_0_jszip___default.a();
      tabellenData.push({
        name: 'bbrbbr',
        data: this.$store.getters['bbrbbr/nurBbrbbr']
      });
      tabellenData.push({
        name: 'bierlieferungen',
        data: this.$store.state.bierlieferungen.bierlieferungen
      });
      tabellenData.push({
        name: 'getränke',
        data: this.$store.state.getranke.getranke
      });
      tabellenData.push({
        name: 'getränkestände',
        data: this.$store.state.getrankeStand.getrankeStande
      });
      tabellenData.push({
        name: 'rechnungen',
        data: this.$store.state.rechnungen.rechnungen
      });
      tabellenData.push({
        name: 'veranstaltungen',
        data: this.$store.state.veranstaltungen.veranstaltungen
      });
      tabellenData.forEach(function (item) {
        var csv = __WEBPACK_IMPORTED_MODULE_2_papaparse___default.a.unparse(item.data);
        var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        zip.file(item.name + '.csv', csvData);
      });
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(content, 'example.zip');
      });
    },
    adressExportData: function adressExportData() {
      var groups = {
        bbrbbr_deutschland: { name: 'bbrbbr_deutschland', data: [] },
        bbrbbr_ausland: { name: 'bbrbbr_ausland', data: [] },
        ahah: { name: 'ahah', data: [] },
        aktive: { name: 'aktive', data: [] },
        hbv_mitglieder: { name: 'hbv_mitglieder', data: [] },
        witwen: { name: 'witwen', data: [] },
        freundinnen_und_damen: { name: 'freundinnen_und_damen', data: [] },
        spefux_und_gast: { name: 'spefux_und_gast', data: [] },
        cv_verbindungen: { name: 'cv_verbindungen', data: [] }
      };
      this.$store.state.bbrbbr.bbrbbr.forEach(function (bbr) {
        switch (bbr.status) {
          case 'Spefux':
            groups.spefux_und_gast.data.push(bbr);
            break;
          case 'Fux':
          case 'Aktiver':
          case 'Inaktiver in loco':
          case 'Inaktiver extra locum':
            groups.aktive.data.push(bbr);
            if (bbr.land === 'Deutschland') {
              groups.bbrbbr_deutschland.data.push(bbr);
            } else {
              groups.bbrbbr_ausland.data.push(bbr);
            }
            break;
          case 'Alter Herr':
            groups.ahah.data.push(bbr);
            if (bbr.land === 'Deutschland') {
              groups.bbrbbr_deutschland.data.push(bbr);
            } else {
              groups.bbrbbr_ausland.data.push(bbr);
            }
            if (bbr.hbvBeitrag > 0) {
              groups.hbv_mitglieder.data.push(bbr);
            }
            break;
          case 'Ehrenmitglieder':
            groups.ahah.data.push(bbr);
            if (bbr.land === 'Deutschland') {
              groups.bbrbbr_deutschland.data.push(bbr);
            } else {
              groups.bbrbbr_ausland.data.push(bbr);
            }
            break;
          case 'Aktive Damen':
            groups.freundinnen_und_damen.data.push(bbr);
            break;
          case 'Witwen':
            groups.witwen.data.push(bbr);
            break;
          case 'CV-Verbindungen':
            groups.cv_verbindungen.data.push(bbr);
            break;
          case 'Gast':
            groups.spefux_und_gast.data.push(bbr);
            break;
        }
      });
      var tabellenData = [];
      tabellenData.push(groups.bbrbbr_deutschland);
      tabellenData.push(groups.bbrbbr_ausland);
      tabellenData.push(groups.ahah);
      tabellenData.push(groups.aktive);
      tabellenData.push(groups.hbv_mitglieder);
      tabellenData.push(groups.witwen);
      tabellenData.push(groups.freundinnen_und_damen);
      tabellenData.push(groups.spefux_und_gast);
      tabellenData.push(groups.cv_verbindungen);
      var zip = new __WEBPACK_IMPORTED_MODULE_0_jszip___default.a();
      tabellenData.forEach(function (item) {
        var csv = __WEBPACK_IMPORTED_MODULE_2_papaparse___default.a.unparse(item.data);
        var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        zip.file(item.name + '.csv', csvData);
      });
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(content, 'ripuaria_kontaktdaten.zip');
      });
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      neuerKalender: {},
      istNeu: true,
      swatches: [['#FF0000', '#AA0000', '#550000'], ['#FFFF00', '#AAAA00', '#555500'], ['#00FF00', '#00AA00', '#005500'], ['#00FFFF', '#00AAAA', '#005555'], ['#0000FF', '#0000AA', '#000055']]
    };
  },

  computed: {
    kalender: function kalender() {
      var kalenderObj = this.$store.getters['einstellungen/einstellung']('alleKalender');
      console.log();
      var kalender = kalenderObj.filter(function (key) {
        return key !== 'kalender';
      }).sort(function (a, b) {
        return a.nummer - b.nummer;
      });
      return kalender;
    }
  },
  methods: {
    addKalender: function addKalender() {
      if (this.neuerKalender.name && this.neuerKalender.farbe && this.neuerKalender.nummer) {
        var kalender = this.$store.getters['einstellungen/einstellung']('kalender');
        kalender[this.neuerKalender.name] = this.neuerKalender;
        this.$store.dispatch('einstellungen/updateEinstellungData', kalender);
        this.istNeu = true;
        this.neuerKalender = [];
      } else {
        console.log('Nicht alle Felder ausgefüllt.');
      }
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      neueKasse: {},
      istNeu: true
    };
  },

  computed: {
    kassen: function kassen() {
      return this.$store.getters['einstellungen/einstellung']('kassen');
    },
    templates: function templates() {
      var templates = this.$store.getters['einstellungen/einstellung']('templates').templates;
      return templates.map(function (item) {
        return {
          text: item.name,
          value: item.html
        };
      });
    }
  },
  methods: {
    addKasse: function addKasse() {
      if (this.neueKasse.name && this.neueKasse.kontoname && this.neueKasse.IBAN && this.neueKasse.BIC && this.neueKasse.bank) {
        var kassen = this.$store.getters['einstellungen/einstellung']('kassen');
        kassen[this.neueKasse.name] = this.neueKasse;
        this.$store.dispatch('einstellungen/updateEinstellungData', kassen);
        this.istNeu = true;
        this.neueKasse = [];
      } else {
        console.log('Nicht alle Felder ausgefüllt.');
      }
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
  },
  data: function data() {
    return {
      status: '',
      finanzBeitrag: '',
      kontaktfeld: '',
      alleStatus: [],
      kontaktfelder: [],
      deletedFelder: [],
      pflichtFelder: [{ default: true, required: true, breite: 6, show: false, label: 'Briefanrede', value: 'briefanrede', type: 'Briefanrede' }, { default: true, required: true, breite: 6, show: false, label: 'Vorname', value: 'vorname', type: 'String' }, { default: true, required: true, breite: 6, show: false, label: 'Nachname', value: 'nachname', type: 'String' }, { default: true, required: true, breite: 12, show: false, label: 'Adresse', value: 'adresse', type: 'String' }, { default: true, required: true, breite: 4, show: false, label: 'PLZ', value: 'plz', type: 'String' }, { default: true, required: true, breite: 4, show: false, label: 'Ort', value: 'ort', type: 'String' }, { default: true, required: true, breite: 4, show: false, label: 'Land', value: 'land', type: 'String' }, { default: true, required: true, breite: 12, show: false, label: 'Email', value: 'email', type: 'String' }, { default: true, required: true, breite: 12, show: false, label: 'Status', value: 'status', type: 'Status' }],
      standardFelder: [{ default: true, required: false, breite: 3, show: false, label: 'Anrede', value: 'anrede', type: 'Anrede' }, { default: true, required: false, breite: 3, show: false, label: 'Titel', value: 'titel', type: 'String' }, { default: true, required: false, breite: 4, show: false, label: 'Vulgo', value: 'vulgo', type: 'String' }, { default: true, required: false, breite: 6, show: false, label: 'Geburtsdatum', value: 'geburtsdatum', type: 'Date' }, { default: true, required: false, breite: 6, show: false, label: 'Hochzeitsdatum', value: 'hochzeitsdatum', type: 'Date' }, { default: true, required: false, breite: 6, show: false, label: 'Todesdatum', value: 'todesdatum', type: 'Date' }, { default: true, required: false, breite: 12, show: false, label: 'Studiengang', value: 'studiengang', type: 'String' }, { default: true, required: false, breite: 6, show: false, label: 'Telefon', value: 'telefon', type: 'Telefon' }, { default: true, required: false, breite: 6, show: false, label: 'Handy', value: 'handy', type: 'Telefon' }, { default: true, required: false, breite: 6, show: false, label: 'Leibvater', value: 'leibvater', type: 'Leibvater' }, { default: true, required: false, breite: 6, show: false, label: 'Receptionsdatum', value: 'receptionsdatum', type: 'Date' }, { default: true, required: false, breite: 6, show: false, label: 'Philistrierungsdatum', value: 'philistrierungsdatum', type: 'Date' }, { default: true, required: false, breite: 6, show: false, label: 'Urverbindung', value: 'urverbindung', type: 'Verbindung' }, { default: true, required: false, breite: 6, show: false, label: 'ZM/Bandverbindung', value: 'zm', type: 'Verbindungen' }, { default: true, required: false, breite: 6, show: false, label: 'Zirkel', value: 'zirkel', type: 'Zirkel' }, { default: true, required: false, breite: 12, show: false, label: 'Gruppen', value: 'gruppen', type: 'Gruppen' }],
      defaultFinanzFelder: {
        beitrage: [],
        showSepaMandat: true,
        showBankdaten: true
      },
      finanzFelder: [],
      defaultKontaktfelder: [{ default: true, required: true, breite: 6, show: false, label: 'Briefanrede', value: 'briefanrede', type: 'Briefanrede' }, { default: true, required: true, breite: 6, show: false, label: 'Vorname', value: 'vorname', type: 'String' }, { default: true, required: true, breite: 6, show: false, label: 'Nachname', value: 'nachname', type: 'String' }, { default: true, required: true, breite: 12, show: false, label: 'Adresse', value: 'adresse', type: 'String' }, { default: true, required: true, breite: 4, show: false, label: 'PLZ', value: 'plz', type: 'String' }, { default: true, required: true, breite: 4, show: false, label: 'Ort', value: 'ort', type: 'String' }, { default: true, required: true, breite: 4, show: false, label: 'Land', value: 'land', type: 'String' }, { default: true, required: true, breite: 12, show: false, label: 'Email', value: 'email', type: 'String' }, { default: true, required: true, breite: 12, show: false, label: 'Status', value: 'status', type: 'Status' }],
      alleKontaktfelder: [],
      types: ['String', 'Number', 'Date', 'Select']
    };
  },

  methods: {
    close: function close() {
      this.$emit('close', false);
    },
    addStatus: function addStatus() {
      this.alleStatus.push({
        status: this.status,
        mitglied: false
      });
      this.status = '';
      this.updateStatus();
    },
    dropStatus: function dropStatus(item) {
      this.alleStatus.splice(this.alleStatus.indexOf(item), 1);
      this.updateStatus();
    },
    toggleMitglied: function toggleMitglied(item) {
      this.alleStatus[this.alleStatus.indexOf(item)].mitglied = !this.alleStatus[this.alleStatus.indexOf(item)].mitglied;
      this.updateStatus();
    },
    addBeitrag: function addBeitrag() {
      this.finanzFelder.beitrage.push({ default: true, required: false, breite: 6, show: false, label: this.finanzBeitrag, value: this.finanzBeitrag.toLowerCase().replace(' ', ''), type: 'money' });
      this.finanzBeitrag = '';
      this.updateKontaktfelder();
    },
    dropBeitrag: function dropBeitrag(item) {
      this.finanzFelder.beitrage.splice(this.finanzFelder.beitrage.indexOf(item), 1);
      this.updateKontaktfelder();
    },
    updateStatus: function updateStatus() {
      var object = {
        status: this.alleStatus
      };
      this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('mitgliederstatus').update(object).then(function () {}).catch(function (error) {
        console.log(error);
      });
    },
    addKontaktfeld: function addKontaktfeld() {
      this.alleKontaktfelder.push({
        label: this.kontaktfeld,
        value: this.kontaktfeld.toLowerCase().replace(/\s+/g, ''),
        type: 'String',
        options: [],
        show: false
      });
      this.kontaktfelder.push({
        default: false,
        required: false,
        label: this.kontaktfeld,
        value: this.kontaktfeld.toLowerCase().replace(/\s+/g, ''),
        type: 'String',
        breite: 6,
        options: [],
        show: false
      });
      this.kontaktfeld = '';
      this.updateKontaktfelder();
    },
    addStandardfeld: function addStandardfeld(item) {
      if (!this.kontaktfelder.find(function (val) {
        return val.value === item.value;
      })) {
        this.kontaktfelder.push(item);
      }
    },
    dropKontaktfeld: function dropKontaktfeld(item) {
      this.alleKontaktfelder.splice(this.alleKontaktfelder.indexOf(item), 1);
      this.kontaktfelder.splice(this.kontaktfelder.indexOf(item), 1);
      this.updateKontaktfelder();
    },
    updateKontaktfelder: function updateKontaktfelder() {
      var object = {
        felder: this.alleKontaktfelder,
        neuFelder: this.kontaktfelder,
        finanzFelder: this.finanzFelder
      };
      this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').update(object).then(function () {}).catch(function (error) {
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('mitgliederstatus').get().then(function (doc) {
      if (!doc.exists) {
        _this.$firebase.firestore().collection('vereine').doc(_this.$vars.verbindung).collection('einstellungen').doc('mitgliederstatus').set({
          was: 'mitgliederstatus',
          status: []
        });
      } else {
        _this.alleStatus = doc.data().status;
      }
    }).catch(function (err) {
      console.log('Error getting document', err);
    });
    this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').get().then(function (doc) {
      if (!doc.exists) {
        _this.$firebase.firestore().collection('vereine').doc(_this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').set({
          id: 'kontaktfelder',
          felder: [],
          neuFelder: [],
          finanzFelder: {}
        });
        _this.kontaktfelder = _this.defaultKontaktfelder;
        _this.finanzFelder = _this.defaultFinanzFelder;
      } else {
        console.log(doc.data());
        _this.alleKontaktfelder = doc.data().felder || [];
        _this.kontaktfelder = doc.data().neuFelder || _this.defaultKontaktfelder;
        _this.finanzFelder = doc.data().finanzFelder || _this.defaultFinanzFelder;
      }
    }).catch(function (err) {
      console.log('Error getting document', err);
    });
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      response: [],
      headers: [{ number: '1', text: '', align: 'left', value: 'index' }, { number: '3', text: 'Name', align: 'left', value: 'nachname' }, { number: '4', text: 'ID', align: 'left', value: 'id' }, { number: '5', text: 'Anmelde ID', align: 'left', value: 'anmeldeID' }, { number: '6', text: 'Mail', align: 'left', value: 'email' }]
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr.filter(function (bbr) {
        return bbr.anmeldeID;
      });
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      domainSettings: null,
      showModule: false,
      showSubModule: false,
      selectedSeite: {
        titel: "",
        berechtigt: [],
        module: [],
        mobil: false,
        bild: "wappen",
        admin: false,
        checkbox: false,
        sendMail: {},
        gruppe: ""
      },
      module: [{ id: 1, value: "uebersicht", icon: "dashboard", name: "Übersicht", submodule: [] }, {
        id: 2,
        value: "veranstaltungen",
        icon: "event",
        name: "Veranstaltungen",
        props: [{ name: "Kalender", wert: "", hint: "Standardkalender zum erstellen neuer Termine." }]
      }, {
        id: 3,
        value: "rechnungen",
        icon: "receipt_long",
        name: "Rechnungen",
        props: [{ name: "Kasse", wert: "", hint: "Nur Rechnungen aus dieser Kasse werden angezeigt." }]
      }, { id: 4, value: "todo", icon: "playlist_add_check", name: "ToDo", props: [] }, { id: 5, value: "kontakte", icon: "group", name: "Kontakte", props: [] }, { id: 6, value: "bierwart", icon: "person", name: "Bierwart", props: [] }, { id: 7, value: "mail", icon: "mail", name: "Mail", props: [] }, { id: 8, value: "dokumente", icon: "auto_awesome", name: "Dokumente", props: [] }, { id: 9, value: "bierwartBierlieferungen", icon: "local_shipping", name: "BW Bierlieferungen", props: [] }, { id: 10, value: "bierwartGetranke", icon: "sports_bar", name: "BW Getränke", props: [] }, {
        id: 11,
        value: "bierwartGetrankeZahlen",
        icon: "format_list_numbered",
        name: "BW Getränkestand",
        props: []
      }, { id: 12, value: "bierwartSchankverlust", icon: "trending_up", name: "BW Schankverlust", props: [] }, { id: 13, value: "bierwartStriche", icon: "list", name: "BW Striche", props: [] }, { id: 14, value: "bierwartVeranstaltung", icon: "event", name: "BW Veranstaltung", props: [] }, { id: 15, value: "bierwartVeranstaltungAbrechnen", icon: "event", name: "BW Veranstaltung Neu", props: [] }, { id: 16, value: "lexikon", icon: "menu_book", name: "Lexikon", props: [] }, { id: 17, value: "ahnengalerie", icon: "menu_book", name: "Ahnengalerie", props: [] }, {
        id: 18,
        value: "kassenbuch",
        icon: "menu_book",
        name: "Kassenbuch",
        props: [{ name: "Kasse", wert: "", hint: "Für welche Kasse soll das Kassenbuch angezeigt werden." }]
      }, {
        id: 19,
        value: "kontobuch",
        icon: "menu_book",
        name: "Kontobuch",
        props: [{ name: "Konto", wert: "", hint: "Für welche Kasse soll das Kontobuch angezeigt werden." }]
      }, { id: 20, value: "wirtschaftsplan", icon: "menu_book", name: "Wirtschaftsplan", props: [] }, { id: 21, value: "couleurstrafen", icon: "receipt_long", name: "Couleurstrafen", props: [] }, { id: 22, value: "dateien", icon: "folder", name: "Dateien", props: [] }, {
        id: 22,
        value: "zirkel",
        icon: "groups",
        name: "Zirkel",
        props: [{ name: "Zirkel", wert: "", hint: "In welcher Stadt ist der Zirkel." }]
      }],
      subModule: [{
        id: 1,
        value: "chargen",
        icon: "person",
        name: "Chargenliste",
        props: [{ name: "Vorstand", wert: "", hint: "Die Mitglieder dieses Vorstands werden angezeigt." }]
      }, { id: 2, value: "geburtstage", icon: "cake", name: "Geburtstagsliste", props: [] }, {
        id: 3,
        value: "jubilaum",
        icon: "cake",
        name: "Jubiläumsliste",
        props: [{ name: "Semester", wert: "", hint: "Welche Jubel-Semester sollen angezeigt werden? zB 50 oder 100" }]
      }, {
        id: 4,
        value: "kontakteStatus",
        icon: "group",
        name: "Kontaktliste nach Status",
        props: [{ name: "Status", wert: "", hint: "Nur Kontakte mit diesem Status werden angezeigt." }]
      }, { id: 5, value: "mailsListe", icon: "list", name: "Mailsliste", props: [] }, {
        id: 6,
        value: "rechnungenEigene",
        icon: "receipt_long",
        name: "Eigene Rechnungen",
        props: [{ name: "Status", wert: "", hint: "Nur Rechnungen mit diesem Status werden angezeigt." }]
      }, {
        id: 7,
        value: "rechnungenStatus",
        icon: "receipt_long",
        name: "Rechnungen nach Status",
        props: [{ name: "Kasse", wert: "", hint: "Nur Rechnungen aus dieser Kasse werden angezeigt." }, { name: "Status", wert: "", hint: "Nur Rechnungen mit diesem Status werden angezeigt." }]
      }, { id: 8, value: "ripuaren", icon: "group", name: "Ripuaren", props: [] }, { id: 9, value: "todosEigene", icon: "playlist_add_check", name: "Liste ToDos", props: [] }, { id: 10, value: "veranstaltungenListe", icon: "event", name: "Kommende Veranstaltungen", props: [] }, { id: 11, value: "bundesbruderSuche", icon: "search", name: "Suche für Bundesbrüder", props: [] }, { id: 12, value: "bierranking", icon: "list", name: "Bierranking", props: [] }, { id: 13, value: "schankverlust", icon: "list", name: "Schankverlust (Steuer)", props: [] }, { id: 14, value: "rechnungSuche", icon: "list", name: "Rechnung Suche", props: [] }, { id: 15, value: "keilkandidaten", icon: "group", name: "Keilkandidaten" }]
    };
  },

  computed: {
    rollenGruppe: function rollenGruppe() {
      return this.rollen.seiten.reduce(function (gruppen, seite) {
        if (!gruppen[seite.gruppe]) {
          gruppen[seite.gruppe] = [];
        }
        gruppen[seite.gruppe].push(seite);
        return gruppen;
      }, {});
    },
    rollen: function rollen() {
      if (this.$store.getters["einstellungen/einstellung"]("rollen")) {
        var rollen = this.$store.getters["einstellungen/einstellung"]("rollen");
        rollen.seiten.forEach(function (item) {
          if (!item.sendMail) {
            item.sendMail = {};
          }
        });
        console.log(rollen);
        return rollen;
      } else {
        return [];
      }
    },
    kassen: function kassen() {
      var _this = this;

      var kassen = [];
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.$store.getters["einstellungen/einstellung"]("kassen")).forEach(function (key) {
        if (key !== "id") {
          kassen.push({
            value: _this.$store.getters["einstellungen/einstellung"]("kassen")[key].name,
            text: _this.$store.getters["einstellungen/einstellung"]("kassen")[key].name
          });
        }
      });
      return kassen;
    },
    kalender: function kalender() {
      var kalender = [];
      this.$store.getters["einstellungen/einstellung"]("alleKalender").forEach(function (key) {
        kalender.push({
          value: key.name,
          text: key.name
        });
      });
      return kalender;
    },
    bundesbruderselect: function bundesbruderselect() {
      var items = this.$store.state.bbrbbr.bbrbbr;
      var bbrbbr = [];
      items.forEach(function (item) {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")"
          });
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname
          });
        }
      });
      return bbrbbr;
    }
  },
  methods: {
    getDomainSettings: function getDomainSettings() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.$firebase.functions().httpsCallable("getDomain")({
                  domain_id: "2p0347z5jq7lzdrn"
                });

              case 3:
                res = _context.sent;

                _this2.domainSettings = res.data.body.data;
                return _context.abrupt("return");

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);
                return _context.abrupt("return");

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    },
    addRolle: function addRolle() {
      var rollen = this.rollen;
      rollen.seiten.push({
        titel: "Neu",
        berechtigt: [],
        module: [],
        mobil: false,
        bild: "wappen",
        admin: false,
        checkbox: false,
        sendMail: {},
        gruppe: "Ämter"
      });
      this.selectedSeite = {
        titel: "Neu",
        berechtigt: [],
        module: [],
        mobil: false,
        bild: "wappen",
        admin: false,
        checkbox: false,
        sendMail: {},
        gruppe: "Ämter"
      };
      this.$store.dispatch("einstellungen/updateEinstellungData", rollen);
    },
    deleteRolle: function deleteRolle(item) {
      var index = this.rollen.seiten.indexOf(this.selectedSeite);
      if (index >= 0) this.rollen.seiten.splice(index, 1);
      this.$store.dispatch("einstellungen/updateEinstellungData", this.rollen);
      this.selectedSeite = this.rollen.seite[0];
    },
    addModul: function addModul(item) {
      this.selectedSeite.module.push(item);
      this.showModule = false;
    },
    removeModul: function removeModul(item) {
      var index = this.selectedSeite.module.indexOf(item);
      if (index >= 0) this.selectedSeite.module.splice(index, 1);
    },
    addSubModul: function addSubModul(item) {
      this.selectedSeite.module[0].submodule.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
        index: this.selectedSeite.module[0].submodule.length + 1
      }));
      this.showSubModule = false;
    },
    removeSubModul: function removeSubModul(item) {
      var index = this.selectedSeite.module[0].submodule.indexOf(item);
      if (index >= 0) this.selectedSeite.module[0].submodule.splice(index, 1);
    },
    removeBerechtigung: function removeBerechtigung(item) {
      var index = this.selectedSeite.berechtigt.indexOf(item);
      if (index >= 0) this.selectedSeite.berechtigt.splice(index, 1);
    },
    saveRollen: function saveRollen() {
      console.log(this.rollen);
      this.$store.dispatch("einstellungen/updateEinstellungData", this.rollen);
    }
  },
  mounted: function mounted() {
    this.getDomainSettings();
  },

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showTemplate: false,
      template: {},
      istNeu: false,
      templateKategorien: ["Mail", "Rechnung", "Brief"]
    };
  },

  computed: {
    templates: function templates() {
      return this.$store.getters["einstellungen/einstellung"]("templates").templates;
    }
  },
  methods: {
    deleteTemplate: function deleteTemplate() {
      var templates = this.$store.getters["einstellungen/einstellung"]("templates");
      templates.templates.splice(templates.templates.indexOf(this.template), 1);
      this.$store.dispatch("einstellungen/updateEinstellungData", templates);
      this.showTemplate = false;
      this.template = {};
    },
    updateTemplates: function updateTemplates() {
      var templates = this.$store.getters["einstellungen/einstellung"]("templates");
      if (!templates.templates) {
        templates.templates = [];
      }
      if (this.istNeu) {
        var id = 1;
        templates.templates.forEach(function (item) {
          if (parseInt(item.id) >= id) {
            id = parseInt(item.id) + 1;
          }
        });
        this.template.id = id;
        templates.templates.push(this.template);
      }
      this.$store.dispatch("einstellungen/updateEinstellungData", templates);
      this.showTemplate = false;
      this.template = {};
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Allgemein_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Allgemein_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Allgemein_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Design_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Design_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Design_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Kontakte_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Kontakte_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Kontakte_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Rollen_vue__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Rollen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Rollen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Kassen_vue__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Kassen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Kassen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Kalender_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Kalender_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Kalender_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Templates_vue__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Templates_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Templates_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ImExport_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ImExport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ImExport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nutzerverwaltung_vue__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nutzerverwaltung_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Nutzerverwaltung_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Gruppen_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Gruppen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Gruppen_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['visible'],
  components: {
    Allgemein: __WEBPACK_IMPORTED_MODULE_0__Allgemein_vue___default.a,
    Design: __WEBPACK_IMPORTED_MODULE_1__Design_vue___default.a,
    Kontakte: __WEBPACK_IMPORTED_MODULE_2__Kontakte_vue___default.a,
    Rollen: __WEBPACK_IMPORTED_MODULE_3__Rollen_vue___default.a,
    Kassen: __WEBPACK_IMPORTED_MODULE_4__Kassen_vue___default.a,
    Kalender: __WEBPACK_IMPORTED_MODULE_5__Kalender_vue___default.a,
    Templates: __WEBPACK_IMPORTED_MODULE_6__Templates_vue___default.a,
    ImExport: __WEBPACK_IMPORTED_MODULE_7__ImExport_vue___default.a,
    Nutzerverwaltung: __WEBPACK_IMPORTED_MODULE_8__Nutzerverwaltung_vue___default.a,
    Gruppen: __WEBPACK_IMPORTED_MODULE_9__Gruppen_vue___default.a
  },
  data: function data() {
    return {
      select: 'nutzerverwaltung',
      navPoints: [{ value: 'nutzerverwaltung', bezeichnung: 'Nutzerverwaltung', icon: 'groups' }, { value: 'allgemein', bezeichnung: 'Allgemein', icon: 'settings' }, { value: 'design', bezeichnung: 'Design', icon: 'brush' }, { value: 'kontakte', bezeichnung: 'Kontakte', icon: 'group' }, { value: 'gruppen', bezeichnung: 'Gruppen', icon: 'group' }, { value: 'kassen', bezeichnung: 'Kassen', icon: 'group' }, { value: 'kalender', bezeichnung: 'Kalender', icon: 'today' }, { value: 'rollen', bezeichnung: 'Rollen', icon: 'description' }, { value: 'templates', bezeichnung: 'Templates', icon: 'today' }, { value: 'imexport', bezeichnung: 'Im-/Export', icon: 'import_export' }]
    };
  },

  computed: {
    sideHeight: function sideHeight() {
      if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'calc(100vh - 191px)';
          case 'sm':
            return 'calc(100vh - 179px)';
          case 'md':
            return 'calc(100vh - 199px)';
          case 'lg':
            return 'calc(100vh - 191px)';
          case 'xl':
            return 'calc(100vh - 191px)';
        }
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'calc(100vh - 199px)';
          case 'sm':
            return 'calc(100vh - 199px)';
          case 'md':
            return 'calc(100vh - 199px)';
          case 'lg':
            return 'calc(100vh - 199px)';
          case 'xl':
            return 'calc(100vh - 199px)';
        }
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('close', false);
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["kasse"],
  data: function data() {
    return {
      neuerEintrag: {},
      heute: new Date().toISOString().substr(0, 10),
      eintragIstNeu: false,
      showNewEintrag: false,
      date: "",
      menu1: "",
      item: "",
      headers: [{ text: "Betrag", value: "betrag" }, { text: "Titel", value: "titel" }, { text: "Datum", value: "datum" }, { text: "", value: "" }],
      expanded: []
    };
  },

  computed: {
    summe: function summe() {
      var summe = 0;
      this.kassenbuch.forEach(function (eintrag) {
        summe += parseFloat(eintrag.betrag);
      });
      return summe;
    },
    formatDatum: function formatDatum() {
      if (!this.neuerEintrag.datum) return null;
      return new Date(this.neuerEintrag.datum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    kassenbuch: function kassenbuch() {
      if (this.$store.state.kassenbucher.loaded === false) {
        this.$store.dispatch("kassenbucher/loadKassenbucher");
      }
      return this.$store.getters["kassenbucher/kassenbucherKasse"](this.kasse);
    }
  },
  methods: {
    itembearbeiten: function itembearbeiten(item) {
      console.log(item);
      this.showNewEintrag = true;
      this.eintragIstNeu = false;
      this.neuerEintrag = item;
    },
    saveNeuEintrag: function saveNeuEintrag() {
      this.neuerEintrag.kasse = this.kasse;
      this.neuerEintrag.betrag = parseFloat(this.neuerEintrag.betrag);
      this.$store.dispatch("kassenbucher/createKassenbuch", this.neuerEintrag);
      this.neuerEintrag = {};
      this.showNewEintrag = false;
    },
    saveEintrag: function saveEintrag(eintrag) {
      this.$store.dispatch("kassenbucher/updateKassenbuchData", eintrag);
      this.neuerEintrag = {};
      this.showNewEintrag = false;
    },
    deleteEintrag: function deleteEintrag(id) {
      this.$store.dispatch("kassenbucher/deleteKassenbuchData", id);
      this.neuerEintrag = {};
      this.showNewEintrag = false;
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jspdf__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_papaparse__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__submodule_dialogImportKontakte__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__submodule_dialogImportKontakte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__submodule_dialogImportKontakte__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["filterStatus"],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a,
    dialogImportKontakte: __WEBPACK_IMPORTED_MODULE_10__submodule_dialogImportKontakte___default.a
  },
  data: function data() {
    return {
      search: "",
      updatedItems: 0,
      allItems: 0,
      sideNav: true,
      singleSelect: false,
      selected: [],
      e1: 1,
      monatSelect: "",
      jahrSelect: "",
      jahre: [],
      updateData: { error: [] },
      monate: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      bundesbruder: [],
      showKontaktNeu: false,
      showDeleteKontakt: false,
      bbrNeu: [],
      fehlerSepa: "",
      bbrImport: [],
      bbrUpdate: [],
      bbrNichtImport: [],
      bbrImportDoppelt: [],
      bbrNeuFelder: [],
      übernahmeItems: ["Nicht importieren", "Original updaten", "Neuer Kontakt"],
      csvDatei: [],
      json: [],
      showUpdate: false,
      showFilterSpalten: false,
      showGruppenLeiste: false,
      showVarGruppenLeiste: true,
      selectedGruppe: null,
      showImportExport: false,
      showAenderungen: false,
      bearbeiteteFelder: {
        sepa: {}
      },
      showMehrereBearbeiten: false,
      selectHeaders: ["nachname", "vorname", "status", "ort"],
      itemsZirkel: ["Aachen", "Berlin", "Bonn/Köln", "Düsseldorf/Neuss", "Essen", "Koblenz", "München", "Niederrhein"],
      kontaktfelder: [],
      selectVerbindung: ["V.K.Th. Burgundia im Albertinum", "AV Alania Stuttgart", "AV Alsatia Münster", "AV Cheruscia Münster", "AV Cheruskia Tübingen", "AV Frisia Hannover", "AV Glückauf-Salia Clausthal-Zellerfeld", "AV Guestfalia Tübingen", "AV Hansea (Berlin) Köln", "AV Palatia Göttingen", "AV Rheinstein Köln", "AV Rheno-Guestfalia Kiel", "AV Salia-Silesia Gleiwitz", "AV Silesia (Halle, Bonn) Bochum", "AV Sparrenberg Bielefeld", "AV Suebo-Danubia Ulm", "AV Tuisconia (Königsberg, Bonn) Landshut", "AV Widukind Osnabrück", "AV Zollern Münster", "CV-Verbindung Rheno-Palatia (Breslau) Mainz", "FAV Rheno-Guestfalia (Hann. Münden) Göttingen", "KAV Capitolina Rom", "KAV Suevia Berlin", "KDStV Adolphiana Fulda", "KDStV Aenania München", "KDStV Agilolfia Freising", "KDStV Alania Bonn", "KDStV Alcimonia Eichstätt", "KDStV Alemannia Greifswald und Münster", "KDStV Algovia Augsburg", "KDStV Angrivaria (Sarstedt, Hannover) Dortmund", "KDStV Arminia Freiburg im Breisgau", "KDStV Arminia Heidelberg", "KDStV Ascania Bonn", "KDStV Asgard (Düsseldorf) Köln", "KDStV Aureo-Danubia Ingolstadt", "KDStV Badenia (Straßburg) Frankfurt am Main", "KDStV Baltia (Danzig) Aachen", "KDStV Bavaria Berlin", "KDStV Bavaria Bonn", "KDStV Bergisch-Thuringia Wuppertal", "KDStV Bergland (Freiberg) Aachen", "KDStV Bodensee Konstanz", "KDStV Borusso-Saxonia Berlin", "KDStV Borusso-Westfalia Bonn", "KDStV Burgundia (Leipzig) Düsseldorf", "KDStV Burgundia München", "KDStV Carolingia Hohenheim", "KDStV Carolus Magnus Saarbrücken", "KDStV Cheruscia Würzburg", "KDStV Churpfalz Mannheim", "KDStV Chursachsen Dresden", "KDStV Churtrier Trier", "KDStV Elbmark (Tetschen-Liebwerd) Duisburg", "KDStV Falkenstein Freiburg im Breisgau", "KDStV Ferdinandea (Prag) Heidelberg", "KDStV Franco-Raetia Würzburg", "KDStV Franconia Aachen", "KDStV Frankonia (Czernowitz) Erlangen", "KDStV Fredericia Bamberg", "KDStV Germania Leipzig", "KDStV Gothia Erlangen", "KDStV Gothia Würzburg", "KDStV Greiffenstein (Breslau) Frankfurt", "KDStV Guestfalo-Silesia Paderborn", "KDStV Hasso-Nassovia Frankfurt am Main", "KDStV Hercynia Freiburg im Breisgau", "KDStV Hohenstaufen Freiburg im Breisgau", "KDStV Kaiserpfalz Aachen", "KDStV Langobardia (München) Bayreuth", "KDStV Makaria (Berlin) Aachen", "KDStV Marchia (Breslau) Aachen", "KDStV Markomannia Würzburg", "KDStV Merowingia Kaiserslautern", "KDStV Moenania München", "KDStV Moeno-Franconia Frankfurt am Main", "KDStV Nassovia Darmstadt", "KDStV Nibelungia (Brünn) Darmstadt", "KDStV Niedersachsen Braunschweig", "KDStV Norbertina Magdeburg", "KDStV Nordgau (Prag, Stuttgart) Koblenz", "KDStV Nordmark (Rostock, Karlsruhe) Essen", "KDStV Normannia Karlsruhe", "KDStV Novesia Bonn", "KDStV Oeno-Danubia Passau", "KDStV Ostmark Nürnberg", "KDStV Palatia Marburg", "KDStV Palatina Amberg/Weiden", "KDStV Radaspona (Regensburg) München", "KDStV Rappoltstein (Straßburg) Köln", "KDStV Rheinland Köln", "KDStV Rheinpfalz Darmstadt", "KDStV Rhenania-Moguntia Mainz", "KDStV Rheno-Baltia Köln", "KDStV Rheno-Franconia München", "KDStV Rheno-Saxonia (Köthen) Halle", "KDStV Ripuaria Aachen", "KDStV Ripuaria Bonn", "KDStV Ripuaria Freiburg im Breisgau", "KDStV Rupertia Regensburg", "KDStV Saarland (Saarbrücken) Jena", "KDStV Sauerlandia Münster", "KDStV Saxo-Silesia Hannover", "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum", "KDStV Schwarzwald Karlsruhe", "KDStV Seraphina Lippstadt", "KDStV Staufia Bonn", "KDStV Sugambria (Jena) Göttingen", "KDStV Teuto-Rhenania Hannover", "KDStV Teutonia Freiburg im Üechtland", "KDStV Thuringia Würzburg", "KDStV Trifels München", "KDStV Tuiskonia München", "KDStV Vandalia (Prag) München", "KDStV Vasgovia Landau", "KDStV Vindelicia München", "KDStV Welfia Weingarten", "KDStV Wiking Hamburg", "KDStV Wildenstein Freiburg im Breisgau", "KDStV Winfridia (Breslau) Münster", "KStV Thuringia Coburg", "KTV Visurgis Bremen", "VKDSt Hasso-Rhenania Gießen", "VKDSt Hasso-Rhenania Mainz", "VKDSt Rhenania Marburg", "VKDSt Saxonia Münster"],
      showBbr: false,
      bbr: "",
      itemsBriefanrede: ["Lieber Bundesbruder", "Sehr geehrter Cartellbruder", "Sehr geehrter Farbenbruder", "Sehr geehrter Herr", "Sehr geehrte Frau", "Sehr geehrte Damen und Herren"],
      itemsAnrede: ["Herr", "Frau", "Familie"],
      active: 0,
      date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      showBbrRechnung: false,
      selectRechnung: "",
      showBbrNachricht: false,
      selectNachricht: "",
      showPrintDialog: false,
      printData: {},
      showAnschreiben: false
    };
  },

  computed: {
    bbrbbr2: function bbrbbr2() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    bezMitglieder: function bezMitglieder() {
      return this.$store.getters["einstellungen/einstellung"]("allgemein").bezMitglieder;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    gruppen: function gruppen() {
      return this.$store.getters["einstellungen/einstellung"]("gruppen");
    },
    kassen: function kassen() {
      return this.$store.state.einstellungen.einstellungen.find(function (item) {
        return item.id === "kassen";
      });
    },
    headers: function headers() {
      var _this = this;

      var header = [];
      var saveHeader = this.$store.getters["einstellungen/einstellung"]("kontaktspalten");
      if (saveHeader && saveHeader[this.currentBbr]) {
        this.selectHeaders = saveHeader[this.currentBbr];
        saveHeader[this.currentBbr].forEach(function (item) {
          header.push(_this.kontaktfelder_system.find(function (feld) {
            return feld.value === item;
          }));
        });
        return header;
      } else {
        return [{ item: { type: "String" }, text: "Vorname", align: "start", value: "vorname" }, { item: { type: "String" }, text: "Nachname", align: "start", value: "nachname" }, { item: { type: "String" }, text: "Ort", align: "start", value: "ort" }, { item: { type: "String" }, text: "Status", align: "start", value: "status" }];
      }
    },
    kontaktfelder_system: function kontaktfelder_system() {
      var items = [];
      this.$store.getters["einstellungen/einstellung"]("kontaktfelder").neuFelder.forEach(function (item) {
        items.push({
          text: item.label,
          value: item.value,
          item: item
        });
      });
      items.push({
        text: "IBAN",
        value: "iban",
        item: {
          breite: 6,
          default: true,
          label: "IBAN",
          required: true,
          show: false,
          type: "String",
          value: "iban"
        }
      });
      return items;
    },
    bbrbbrKontaktImport: function bbrbbrKontaktImport() {
      var bbrbbr = [];
      this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
        bbrbbr.push({
          text: item.nachname + ", " + item.vorname,
          value: item
        });
      });
      return bbrbbr;
    },
    hideHeader: function hideHeader() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    itemsStatus: function itemsStatus() {
      var status = [];
      this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach(function (item) {
        status.push(item.status);
      });
      return status;
    },
    bbrbbr: function bbrbbr() {
      if (!this.selectedGruppe) {
        return this.$store.state.bbrbbr.bbrbbr;
      }

      var bedingungen = this.selectedGruppe.bedingungen;

      var bbrbbrSet = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();

      this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
        bedingungen.forEach(function (_ref) {
          var feld = _ref.feld,
              wert = _ref.wert;

          var feldPfad = feld.split(".");
          var itemValue = item;

          feldPfad.forEach(function (key) {
            if (itemValue && (typeof itemValue === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(itemValue)) === "object") {
              itemValue = itemValue[key];
            } else {
              itemValue = undefined;
            }
          });

          if (!itemValue) return;

          var itemValues = Array.isArray(itemValue) ? itemValue : [itemValue];
          if (wert.some(function (value) {
            return itemValues.includes(value);
          })) {
            bbrbbrSet.add(item);
          }
        });
      });

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(bbrbbrSet);
    },
    bearbeitungen: function bearbeitungen() {
      var _this2 = this;

      if (this.$store.state.bearbeitungen.bearbeitungen.length === 0) {
        this.$store.dispatch("bearbeitungen/loadBearbeitungen");
      }
      var bearbeitungen = [];
      this.$store.state.bearbeitungen.bearbeitungen.forEach(function (item, index) {
        var diff = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(item.dataNeu)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;

            var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 1);

            var key = _ref3[0];

            if (["bildAhnengalerie200", "bildAhnengalerie500", "chargen", "geburtsjahr", "geburtsmonat", "geburtstag", "receptionsjahr", "receptionsmonat", "receptionstag", "x", "y", "alter", "anmeldeID", "id", "einstellungen", "notificationToken", "zuletztGeaendertAm", "zuletztGeaendertVon"].indexOf(key) === -1) {
              var val1 = item.dataNeu[key];
              var val2 = item.dataAlt[key];
              if ((typeof val1 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(val1)) === "object" && (typeof val2 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(val2)) === "object") {
                if (_this2.istGleichesObjekt(val1, val2)) {
                  diff.push(key);
                }
              } else {
                if (val1 !== val2) {
                  diff.push(key);
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        item.anders = diff;
        if (item.dataNeu.zuletztGeaendertAm !== undefined) {
          bearbeitungen.push(item);
        }
      });
      var jahre = [];
      var ergebnis = {};
      var firstDate = Infinity;
      bearbeitungen.forEach(function (item) {
        if (new Date(item.datum) < firstDate) {
          firstDate = new Date(item.datum);
        }
      });
      bearbeitungen.forEach(function (item) {
        var jahr = new Date(item.datum).getFullYear();
        var monat = (new Date(item.datum).getMonth() + 1).toString().padStart(2, "0");
        if (ergebnis[jahr] === undefined) {
          ergebnis[jahr] = {};
          jahre.push(jahr);
        }
        if (ergebnis[jahr][monat] === undefined) {
          ergebnis[jahr][monat] = [];
        }
        if (item.anders.length > 0) {
          ergebnis[jahr][monat].push(item);
        }
      });
      this.jahre = jahre.sort(function (a, b) {
        return a - b;
      });
      this.jahrSelect = jahre.indexOf(new Date().getFullYear());
      this.monatSelect = new Date().getMonth();
      return ergebnis;
    }
  },
  methods: {
    setSelectedGruppeBbrBbr: function setSelectedGruppeBbrBbr() {
      var wert = [];
      this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach(function (item) {
        if (item.mitglied) {
          wert.push(item.status);
        }
      });
      this.selectedGruppe = {
        bedingungen: [{
          feld: "status",
          wert: wert
        }],
        text: "Alle " + this.bezMitglieder
      };
    },
    istGleichesObjekt: function istGleichesObjekt(obj1, obj2) {
      if (obj1 === null) {
        return false;
      }
      if (obj2 === null) {
        return false;
      }
      if ((typeof obj1 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj1)) !== (typeof obj2 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj2))) {
        return false;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj1).length === 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj2).length === 0) {
        return false;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj1).length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj2).length) {
        return true;
      }

      for (var prop in obj1) {
        if (obj1[prop] === obj2[prop]) {
          return false;
        }
      }
      return true;
    },
    bearbeiteMehrere: function bearbeiteMehrere() {
      var _this3 = this;

      this.showUpdate = true;
      var functions = this.$firebase.functions();
      var items = [];
      if (this.bearbeiteteFelder.alleBearbeiten === "true") {
        this.bbrbbr2.forEach(function (bbr) {
          items.push(bbr.id);
        });
      } else {
        items = this.selected;
      }
      this.updatedItems = 0;
      this.allItems = items.length;
      items.forEach(function (id) {
        var bbr = _this3.$store.getters["bbrbbr/bbr"](id);
        if (_this3.bearbeiteteFelder.anrede) {
          bbr.anrede = _this3.bearbeiteteFelder.anrede;
        }
        if (_this3.bearbeiteteFelder.briefanrede) {
          bbr.briefanrede = _this3.bearbeiteteFelder.briefanrede;
        }
        if (_this3.bearbeiteteFelder.urverbindung) {
          bbr.urverbindung = _this3.bearbeiteteFelder.urverbindung;
        }
        if (_this3.bearbeiteteFelder.zirkel) {
          bbr.zirkel = _this3.bearbeiteteFelder.zirkel;
        }
        if (_this3.bearbeiteteFelder.status) {
          bbr.status = _this3.bearbeiteteFelder.status;
        }
        if (_this3.bearbeiteteFelder.aktivenBeitrag) {
          bbr.aktivenBeitrag = _this3.bearbeiteteFelder.aktivenBeitrag;
        }
        if (_this3.bearbeiteteFelder.cvBeitrag) {
          bbr.cvBeitrag = _this3.bearbeiteteFelder.cvBeitrag;
        }
        if (_this3.bearbeiteteFelder.ahvBeitrag) {
          bbr.ahvBeitrag = _this3.bearbeiteteFelder.ahvBeitrag;
        }
        if (_this3.bearbeiteteFelder.hbvBeitrag) {
          bbr.hbvBeitrag = _this3.bearbeiteteFelder.hbvBeitrag;
        }
        if (_this3.bearbeiteteFelder.sepa_bearbeiten) {
          if (bbr.sepa === undefined) {
            bbr.sepa = {};
          }
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.bearbeiteteFelder.sepa).forEach(function (key) {
            if (_this3.bearbeiteteFelder.sepa[key] !== null) {
              bbr.sepa[key] = _this3.bearbeiteteFelder.sepa[key];
            }
          });
        }
        functions.httpsCallable("updateUser")({ user: bbr, verein: _this3.$vars.verbindung }).then(function (result) {
          if (result.data.status) {
            _this3.updatedItems++;
            if (_this3.updatedItems === _this3.allItems) {
              _this3.showUpdate = false;
            }
          } else {
            _this3.updateData.error.push(result.data);
          }
        }).catch(function (error) {
          console.log(error);
        });
      });
      this.showMehrereBearbeiten = false;
    },
    checkIndex: function checkIndex(id) {
      if (this.selected.indexOf(id) >= 0) {
        return false;
      } else {
        return true;
      }
    },
    addSelect: function addSelect(id) {
      var _this4 = this;

      if (id === "alle" || id === "keine") {
        this.selected = [];
        if (id === "alle") {
          this.bbrbbr.forEach(function (bbr) {
            _this4.selected.push(bbr.id);
          });
        }
      } else {
        if (this.selected.indexOf(id) >= 0) {
          this.selected.splice(this.selected.indexOf(id), 1);
        } else {
          this.selected.push(id);
        }
      }
    },
    importInNeueBbr: function importInNeueBbr() {
      var fileToLoad = this.csvDatei;
      var reader = new FileReader();
      var bbrNeuFelder = [];
      var bbrNeu = [];
      var kontaktfelder = this.kontaktfelder;
      reader.onload = function (fileLoadedEvent) {
        __WEBPACK_IMPORTED_MODULE_9_papaparse___default.a.parse(fileLoadedEvent.target.result, {
          header: false,
          encoding: "ISO-8859-1",
          complete: function complete(results) {
            results.data[0].forEach(function (item) {
              bbrNeuFelder.push(item);
            });
            bbrNeuFelder.forEach(function (item) {
              kontaktfelder.forEach(function (feld) {
                if (feld.system === item) {
                  feld.importiert = item;
                }
                if (feld.text === item) {
                  feld.importiert = item;
                }
              });
            });
          },
          error: function error(errors) {
            console.log("error", errors);
          }
        });
        __WEBPACK_IMPORTED_MODULE_9_papaparse___default.a.parse(fileLoadedEvent.target.result, {
          header: true,
          encoding: "ISO-8859-1",
          complete: function complete(results) {
            results.data.forEach(function (item) {
              bbrNeu.push(item);
            });
          },
          error: function error(errors) {
            console.log("error", errors);
          }
        });
      };
      reader.readAsText(fileToLoad);
      this.e1 = 2;
      this.bbrNeuFelder = bbrNeuFelder;
      this.bbrNeu = bbrNeu;
    },
    wechselHeader: function wechselHeader() {
      var _this5 = this;

      var bbrImport = [];
      this.bbrNeu.forEach(function (item) {
        var bbr = [];
        _this5.kontaktfelder.forEach(function (feld) {
          if (item[feld.importiert]) {
            bbr[feld.system] = item[feld.importiert];
          } else {
            bbr[feld.system] = "";
          }
        });
        bbrImport.push(bbr);
      });

      var bbrbbr = this.bbrbbr;
      this.bbrImportDoppelt = [];
      bbrImport.forEach(function (item) {
        bbrbbr.forEach(function (bbr) {
          if (_this5.similarity(item.nachname, bbr.nachname) > 0.85 && _this5.similarity(item.vorname, bbr.vorname) > 0.85) {
            _this5.bbrImportDoppelt.push({
              original: bbr,
              importiert: item,
              übereinstimmung: ((_this5.similarity(item.nachname, bbr.nachname) + _this5.similarity(item.vorname, bbr.vorname)) / 2 * 100).toFixed(2) + "%",
              übernehmen: "Nicht importieren"
            });
            console.log({
              original: bbr,
              importiert: item,
              übereinstimmung: ((_this5.similarity(item.nachname, bbr.nachname) + _this5.similarity(item.vorname, bbr.vorname)) / 2 * 100).toFixed(2) + "%",
              übernehmen: "Nicht importieren"
            });
          }
        });
      });
      this.bbrImport = bbrImport;
      this.e1 = 3;
    },
    updateImportStatus: function updateImportStatus(status) {
      this.bbrImportDoppelt.forEach(function (item) {
        item.übernehmen = status;
      });
    },
    updateDoppelt: function updateDoppelt() {
      var _this6 = this;

      this.bbrNichtImport = [];
      this.bbrUpdate = [];
      this.bbrImportDoppelt.forEach(function (item) {
        if (item.übernehmen === "Nicht importieren") {
          _this6.bbrImport.splice(_this6.bbrImport.indexOf(item.importiert), 1);
          _this6.bbrNichtImport.push({
            item: item.importiert,
            id: item.original.id
          });
        } else if (item.übernehmen === "Original updaten") {
          _this6.bbrImport.splice(_this6.bbrImport.indexOf(item.importiert), 1);
          _this6.bbrUpdate.push({
            item: item.importiert,
            id: item.original.id
          });
        }
      });
      this.e1 = 4;
    },
    exportData: function exportData() {
      var csv = __WEBPACK_IMPORTED_MODULE_9_papaparse___default.a.unparse(this.bbrbbr, { header: true, encoding: "UTF-8" });
      var anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = this.selectedGruppe.text + ".csv";
      anchor.click();
    },
    similarity: function similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength === 0) {
        return 1.0;
      }
      return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
    },
    editDistance: function editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      var costs = [];
      for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else {
            if (j > 0) {
              var newValue = costs[j - 1];
              if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              }
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) {
          costs[s2.length] = lastValue;
        }
      }
      return costs[s2.length];
    },
    saveNeueBbr: function saveNeueBbr() {
      var _this7 = this;

      this.bbrImport.forEach(function (item) {
        if (item.aktivenBeitrag) {
          item.aktivenBeitrag = parseFloat(item.aktivenBeitrag.replace(",", ".")).toFixed(2);
        }
        if (item.cvBeitrag) {
          item.cvBeitrag = parseFloat(item.cvBeitrag.replace(",", ".")).toFixed(2);
        }
        if (item.ahvBeitrag) {
          item.ahvBeitrag = parseFloat(item.ahvBeitrag.replace(",", ".")).toFixed(2);
        }
        if (item.hbvBeitrag) {
          item.hbvBeitrag = parseFloat(item.hbvBeitrag.replace(",", ".")).toFixed(2);
        }
        if (!item.kontoinhaber) {
          item.kontoinhaber = item.vorname + " " + item.nachname;
        }
        if (item.receptionsdatum) {
          if (isNaN(item.receptionsdatum)) {
            var date = item.receptionsdatum;
            var parts = date.split(".");
            item.receptionsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
          }
        }
        if (item.geburtsdatum) {
          if (isNaN(item.geburtsdatum)) {
            var _date = item.geburtsdatum;
            var _parts = _date.split(".");
            item.geburtsdatum = _parts[2] + "-" + _parts[1] + "-" + _parts[0];
          }
        }
        if (item.philistrierungsdatum) {
          if (isNaN(item.philistrierungsdatum)) {
            var _date2 = item.philistrierungsdatum;
            var _parts2 = _date2.split(".");
            item.philistrierungsdatum = _parts2[2] + "-" + _parts2[1] + "-" + _parts2[0];
          }
        }
        if (item.mandatUnterschriftsdatum) {
          if (isNaN(item.mandatUnterschriftsdatum)) {
            var _date3 = item.mandatUnterschriftsdatum;
            var _parts3 = _date3.split(".");
            item.mandatUnterschriftsdatum = _parts3[2] + "-" + _parts3[1] + "-" + _parts3[0];
          }
        }
        if (item.letzterLastschrifteinzug) {
          if (isNaN(item.letzterLastschrifteinzug)) {
            var _date4 = item.letzterLastschrifteinzug;
            var _parts4 = _date4.split(".");
            item.letzterLastschrifteinzug = _parts4[2] + "-" + _parts4[1] + "-" + _parts4[0];
          }
        }
        var object = {
          anrede: item.anrede,
          briefanrede: item.briefanrede,
          titel: item.titel,
          nachname: item.nachname,
          vorname: item.vorname,
          geburtsdatum: item.geburtsdatum,
          studiengang: item.studiengang,
          adresse: item.adresse,
          plz: item.plz,
          ort: item.ort,
          land: item.land,
          telefon: item.telefon,
          handy: item.handy,
          email: item.email,
          urverbindung: item.urverbindung,
          zm: item.zm,
          receptionsdatum: item.receptionsdatum,
          philistrierungsdatum: item.philistrierungsdatum,
          status: item.status,
          leibvater: item.leibvater,
          rbonummer: item.rbonummer,
          chargen: item.chargen,
          aktivenBeitrag: item.aktivenBeitrag,
          cvBeitrag: item.cvBeitrag,
          hbvBeitrag: item.hbvBeitrag,
          ahvBeitrag: item.ahvBeitrag,
          iban: item.iban,
          bic: item.bic,
          kontoinhaber: item.kontoinhaber,
          mandatsreferenz: item.mandatsreferenz
        };
        _this7.$firebase.firestore().collection("vereine").doc(_this7.$vars.verbindung).collection("kontakte").add(object).then(function (key) {
          console.log("erstellt");
        }).catch(function (error) {
          console.log(error);
        });
      });
      this.bbrUpdate.forEach(function (item) {
        if (item.item.aktivenBeitrag) {
          item.item.aktivenBeitrag = parseFloat(item.item.aktivenBeitrag.replace(",", ".")).toFixed(2);
        }
        if (item.item.cvBeitrag) {
          item.item.cvBeitrag = parseFloat(item.item.cvBeitrag.replace(",", ".")).toFixed(2);
        }
        if (item.item.ahvBeitrag) {
          item.item.ahvBeitrag = parseFloat(item.item.ahvBeitrag.replace(",", ".")).toFixed(2);
        }
        if (item.item.hbvBeitrag) {
          item.item.hbvBeitrag = parseFloat(item.item.hbvBeitrag.replace(",", ".")).toFixed(2);
        }
        if (!item.item.kontoinhaber) {
          item.item.kontoinhaber = item.item.vorname + " " + item.item.nachname;
        }
        if (item.item.receptionsdatum) {
          if (item.item.receptionsdatum.indexOf(".") !== -1) {
            var date = item.item.receptionsdatum;
            var parts = date.split(".");
            item.item.receptionsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
          }
        }
        if (item.item.geburtsdatum) {
          if (isNaN(item.item.geburtsdatum)) {
            var _date5 = item.item.geburtsdatum;
            var _parts5 = _date5.split(".");
            item.item.geburtsdatum = _parts5[2] + "-" + _parts5[1] + "-" + _parts5[0];
          }
        }
        if (item.item.philistrierungsdatum) {
          if (isNaN(item.item.philistrierungsdatum)) {
            var _date6 = item.item.philistrierungsdatum;
            var _parts6 = _date6.split(".");
            item.item.philistrierungsdatum = _parts6[2] + "-" + _parts6[1] + "-" + _parts6[0];
          }
        }
        console.log(item);
        if (item.item.mandatUnterschriftsdatum) {
          console.log(item.item.mandatUnterschriftsdatum);
          if (isNaN(item.item.mandatUnterschriftsdatum)) {
            var _date7 = item.item.mandatUnterschriftsdatum;
            var _parts7 = _date7.split(".");
            item.item.mandatUnterschriftsdatum = _parts7[2] + "-" + _parts7[1] + "-" + _parts7[0];
          }
          console.log(item.item.mandatUnterschriftsdatum);
        }
        if (item.item.letzterLastschrifteinzug) {
          if (isNaN(item.item.letzterLastschrifteinzug)) {
            var _date8 = item.item.letzterLastschrifteinzug;
            var _parts8 = _date8.split(".");
            item.item.letzterLastschrifteinzug = _parts8[2] + "-" + _parts8[1] + "-" + _parts8[0];
          }
        }
        var updateObj = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.item).forEach(function (key) {
          if (item.item[key] !== undefined && item.item[key] !== "") {
            updateObj[key] = item.item[key];
          }
        });
        updateObj.id = item.id;
        _this7.$store.dispatch("bbrbbr/updateBbrData", updateObj);
        _this7.bbrNeu = [];
        _this7.showImportExport = false;
      });
    },
    close: function close() {
      this.e1 = 1;
      this.bbrNeu = [];
      this.kontaktfelder = [];
      this.showImportExport = !this.showImportExport;
    },
    print: function print() {
      var _this8 = this;

      this.$vars.loading = true;
      switch (this.printData.radioKontakte) {
        case "allSelected":
          this.printData.kontakte = [];
          this.selected.forEach(function (item) {
            _this8.printData.kontakte.push(_this8.$store.getters["bbrbbr/bbr"](item));
          });
          break;
        case "allStatus":
          this.printData.kontakte = [];
          this.printData.gruppen.forEach(function (gruppe) {
            _this8.$store.getters["bbrbbr/bbrStatus"](gruppe).forEach(function (bbr) {
              _this8.printData.kontakte.push(bbr);
            });
          });
          break;
        case "allBbrBbr":
          this.printData.kontakte = this.$store.getters["bbrbbr/nurBbrbbr"];
          break;
        case "all":
          this.printData.kontakte = this.$store.state.bbrbbr.bbrbbr;
          break;
      }
      switch (this.printData.druckelement) {
        case "mitgliederverzeichnis":
          this.printMitgliederverzeichnis();
          break;
        case "geburtstagsliste":
          this.printGeburtstagsliste();
          break;
        case "versandadressendina4":
          this.printVersanddressendina4();
          break;
        case "versandadressendina4mitAnschreiben":
          this.versandadressendina4mitAnschreiben();
          break;
        case "versandadressendinlang":
          this.printVersanddressendinlang();
          break;
      }
    },
    printMitgliederverzeichnis: function printMitgliederverzeichnis() {
      var geburtstage = [{ monat: "Januar", geburtstage: [] }, { monat: "Februar", geburtstage: [] }, { monat: "März", geburtstage: [] }, { monat: "April", geburtstage: [] }, { monat: "Mai", geburtstage: [] }, { monat: "Juni", geburtstage: [] }, { monat: "Juli", geburtstage: [] }, { monat: "August", geburtstage: [] }, { monat: "September", geburtstage: [] }, { monat: "Oktober", geburtstage: [] }, { monat: "November", geburtstage: [] }, { monat: "Dezember", geburtstage: [] }];
      this.printData.kontakte.forEach(function (bbr) {
        if (bbr.geburtsdatum) {
          bbr.geburtsmonat = bbr.geburtsdatum.split("-")[1].padStart(2, "0");
          bbr.geburtstag = bbr.geburtsdatum.split("-")[2].padStart(2, "0");
          geburtstage[bbr.geburtsmonat - 1].geburtstage.push({ tag: bbr.geburtstag, bbr: bbr });
        }
      });
      geburtstage.forEach(function (item) {
        item.geburtstage.sort(function (a, b) {
          return a.tag > b.tag ? 1 : -1;
        });
      });

      var doc = new __WEBPACK_IMPORTED_MODULE_7_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a5"
      });
      doc.setFont("Times");
      var settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
      doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
      doc.rect(0, 167, 210, 3, "F");
      doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
      doc.rect(0, 170, 210, 3, "F");
      doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
      doc.rect(0, 173, 210, 3, "F");
      var img = new Image();
      img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
      doc.addImage(img, 30, 28, 88, 88);
      doc.setFontSize(24);
      doc.text(settings.name, 74, 130, null, null, "center");
      doc.text("Mitgliederverzeichnis", 74, 145, null, null, "center");
      doc.setFontSize(11);
      doc.text("Stand: " + new Date().toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" }), 74, 155, null, null, "center");
      doc.addPage();
      var zeile = 15;
      doc.setFontSize(20);
      doc.text("Geburtstagsliste", 74, zeile, null, null, "center");
      doc.setFontSize(11);
      zeile = zeile + 15;
      geburtstage.forEach(function (item) {
        if (zeile > 190) {
          zeile = 15;
          doc.addPage();
        }
        doc.setFontSize(20);
        doc.text(item.monat, 12, zeile);
        doc.setFontSize(11);
        zeile = zeile + 8;
        item.geburtstage.forEach(function (bbr) {
          if (zeile > 190) {
            zeile = 15;
            doc.addPage();
          }
          doc.text(new Date(bbr.bbr.geburtsdatum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric"
          }), 12, zeile);
          if (bbr.bbr.titel) {
            doc.text(bbr.bbr.titel + " " + bbr.bbr.vorname + " " + bbr.bbr.nachname, 45, zeile);
          } else {
            doc.text(bbr.bbr.vorname + " " + bbr.bbr.nachname, 45, zeile);
          }
          zeile = zeile + 5;
        });
        zeile = zeile + 16;
      });
      doc.addPage();
      zeile = 15;
      doc.setFontSize(20);
      doc.text("Kontaktliste", 74, zeile, null, null, "center");
      doc.setFontSize(11);
      zeile = zeile + 15;
      this.printData.kontakte.forEach(function (bbr) {
        if (zeile > 180) {
          zeile = 15;
          doc.addPage();
        }
        doc.setFontSize(11);
        doc.setFont("Times", "bold");
        if (bbr.titel) {
          doc.text(bbr.titel + " " + bbr.vorname + " " + bbr.nachname, 12, zeile);
        } else {
          doc.text(bbr.vorname + " " + bbr.nachname, 12, zeile);
        }
        doc.setFont("Times", "normal");
        doc.text(bbr.status, 12, zeile + 5);
        doc.text(bbr.adresse + " " + bbr.plz + " " + bbr.ort, 12, zeile + 10);
        if (bbr.telefon) {
          doc.text(bbr.telefon, 12, zeile + 15);
        }
        if (bbr.handy) {
          doc.text(bbr.handy, 12, zeile + 20);
        }
        if (bbr.email) {
          doc.text(bbr.email, 12, zeile + 25);
        }
        doc.setFontSize(9);
        if (bbr.geburtsdatum) {
          doc.text("Geburtsdatum: " + new Date(bbr.geburtsdatum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric"
          }), 136, zeile + 5, null, null, "right");
        }
        if (bbr.receptionsdatum) {
          doc.text("Receptionsdatum: " + new Date(bbr.receptionsdatum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric"
          }), 136, zeile + 10, null, null, "right");
        }
        if (bbr.philistrierungsdatum) {
          doc.text("Philistrierungsdatum: " + new Date(bbr.philistrierungsdatum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric"
          }), 136, zeile + 15, null, null, "right");
        }

        zeile = zeile + 40;
      });
      doc.addPage();
      doc.setFontSize(11);
      doc.text("Der Inhalt dieser Publikation ist nur für Angehörige der", 74, 110, null, null, "center");
      doc.text(settings.name, 74, 115, null, null, "center");
      doc.text("bestimmt und Dritten nicht zugänglich zu machen.", 74, 120, null, null, "center");
      doc.text("Bei fehlerhaften Daten bitten wir um eine kurze Nachricht", 74, 130, null, null, "center");
      doc.text("an den Schriftführer unter xxx@kdstv-ripuaria.de.", 74, 135, null, null, "center");
      doc.addPage();
      doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
      doc.rect(0, 167, 210, 3, "F");
      doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
      doc.rect(0, 170, 210, 3, "F");
      doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
      doc.rect(0, 173, 210, 3, "F");
      doc.save("Mitgliederverzeichnis " + new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) + ".pdf");
      this.$vars.loading = false;
    },
    printGeburtstagsliste: function printGeburtstagsliste() {
      var geburtstage = [{ monat: "Januar", geburtstage: [] }, { monat: "Februar", geburtstage: [] }, { monat: "März", geburtstage: [] }, { monat: "April", geburtstage: [] }, { monat: "Mai", geburtstage: [] }, { monat: "Juni", geburtstage: [] }, { monat: "Juli", geburtstage: [] }, { monat: "August", geburtstage: [] }, { monat: "September", geburtstage: [] }, { monat: "Oktober", geburtstage: [] }, { monat: "November", geburtstage: [] }, { monat: "Dezember", geburtstage: [] }];
      this.printData.kontakte.forEach(function (bbr) {
        if (bbr.geburtsdatum) {
          bbr.geburtsmonat = bbr.geburtsdatum.split("-")[1].padStart(2, "0");
          bbr.geburtstag = bbr.geburtsdatum.split("-")[2].padStart(2, "0");
          geburtstage[bbr.geburtsmonat - 1].geburtstage.push({ tag: bbr.geburtstag, bbr: bbr });
        }
      });
      geburtstage.forEach(function (item) {
        item.geburtstage.sort(function (a, b) {
          return a.tag > b.tag ? 1 : -1;
        });
      });
      var wintersemester = [];
      wintersemester = wintersemester.concat(geburtstage[9].geburtstage);
      wintersemester = wintersemester.concat(geburtstage[10].geburtstage);
      wintersemester = wintersemester.concat(geburtstage[11].geburtstage);
      wintersemester = wintersemester.concat(geburtstage[0].geburtstage);
      wintersemester = wintersemester.concat(geburtstage[1].geburtstage);
      wintersemester = wintersemester.concat(geburtstage[2].geburtstage);
      var sommersemester = [];
      sommersemester = sommersemester.concat(geburtstage[3].geburtstage);
      sommersemester = sommersemester.concat(geburtstage[4].geburtstage);
      sommersemester = sommersemester.concat(geburtstage[5].geburtstage);
      sommersemester = sommersemester.concat(geburtstage[6].geburtstage);
      sommersemester = sommersemester.concat(geburtstage[7].geburtstage);
      sommersemester = sommersemester.concat(geburtstage[8].geburtstage);
      var doc = new __WEBPACK_IMPORTED_MODULE_7_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      var settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
      doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
      doc.rect(0, 90, 210, 1, "F");
      doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
      doc.rect(0, 91, 210, 1, "F");
      doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
      doc.rect(0, 92, 210, 1, "F");
      var img = new Image();
      img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
      doc.addImage(img, 125, 30, 75, 75);
      doc.setFontSize(9);
      doc.text(settings.name, 25, 87);
      doc.setFontSize(20);
      doc.text("Geburtstagsliste Wintersemester " + new Date().toLocaleString(["de-de"], { year: "numeric" }), 25, 120);
      doc.setFontSize(11);
      doc.text("Stand: " + new Date().toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" }), 185, 110, null, null, "right");
      var zeile = 130;
      doc.setFontSize(11);
      wintersemester.forEach(function (bbr) {
        if (zeile > 272) {
          zeile = 25;
          doc.addPage();
        }
        doc.text(new Date(bbr.bbr.geburtsdatum).toLocaleString(["de-de"], {
          month: "short",
          day: "2-digit",
          year: "numeric"
        }), 25, zeile);
        if (bbr.bbr.titel) {
          doc.text(bbr.bbr.titel + " " + bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
        } else {
          doc.text(bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
        }
        zeile = zeile + 5;
      });
      doc.addPage();
      doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
      doc.rect(0, 90, 210, 1, "F");
      doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
      doc.rect(0, 91, 210, 1, "F");
      doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
      doc.rect(0, 92, 210, 1, "F");
      img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
      doc.addImage(img, 125, 30, 75, 75);
      doc.setFontSize(9);
      doc.text(settings.name, 25, 87);
      doc.setFontSize(20);
      doc.text("Geburtstagsliste Sommersemester " + new Date().toLocaleString(["de-de"], { year: "numeric" }), 25, 120);
      doc.setFontSize(11);
      doc.text("Stand: " + new Date().toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" }), 185, 110, null, null, "right");
      zeile = 130;
      doc.setFontSize(11);
      sommersemester.forEach(function (bbr) {
        if (zeile > 272) {
          zeile = 25;
          doc.addPage();
        }
        doc.text(new Date(bbr.bbr.geburtsdatum).toLocaleString(["de-de"], {
          month: "short",
          day: "2-digit",
          year: "numeric"
        }), 25, zeile);
        if (bbr.bbr.titel) {
          doc.text(bbr.bbr.titel + " " + bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
        } else {
          doc.text(bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
        }
        zeile = zeile + 5;
      });
      var year = new Date().toLocaleString(["de-de"], { year: "numeric" });
      doc.save("Geburtstagsliste WS + SS " + year + ".pdf");

      this.$vars.loading = false;
    },
    printVersanddressendina4: function printVersanddressendina4() {
      var _this9 = this;

      var doc = new __WEBPACK_IMPORTED_MODULE_7_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      this.printData.kontakte.forEach(function (bbr) {
        doc.setFillColor(0, 0, 0);
        doc.rect(0, 104.9, 3, 0.2, "F");
        doc.rect(0, 148.4, 5, 0.2, "F");
        doc.rect(0, 209.9, 3, 0.2, "F");
        var settings = _this9.$store.getters["einstellungen/einstellung"]("allgemein");
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, 90, 210, 1, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, 91, 210, 1, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, 92, 210, 1, "F");
        var img = new Image();
        img.src = "/static/" + _this9.$vars.verbindung + "/wappen_256.png";
        doc.addImage(img, 125, 30, 75, 75);
        doc.setFontSize(9);
        doc.text(settings.name + " | " + settings.strasse + " " + settings.hausnummer + " | " + settings.plz + " " + settings.ort, 25, 51);
        doc.setFontSize(11);
        var anrede = bbr.anrede === "Herr" ? "Herrn" : bbr.anrede || "";
        if (bbr.titel) {
          doc.text(anrede + " " + bbr.titel, 25, 61);
        } else {
          doc.text(anrede, 25, 61);
        }
        doc.text((bbr.vorname || "") + " " + (bbr.nachname || ""), 25, 66);
        doc.text(bbr.adresse || "", 25, 71);
        doc.text((bbr.plz || "") + " " + (bbr.ort || ""), 25, 76);
        doc.text(bbr.land || "", 25, 81);
        doc.addPage();
      });
      doc.save("Versandadressen DIN A4 Brief " + new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) + ".pdf");
      this.$vars.loading = false;
    },
    versandadressendina4mitAnschreiben: function versandadressendina4mitAnschreiben() {
      var _this10 = this;

      var doc = new __WEBPACK_IMPORTED_MODULE_7_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      this.printData.kontakte.forEach(function (bbr, index) {
        doc.setFillColor(0, 0, 0);
        doc.rect(0, 104.9, 3, 0.2, "F");
        doc.rect(0, 148.4, 5, 0.2, "F");
        doc.rect(0, 209.9, 3, 0.2, "F");
        var settings = _this10.$store.getters["einstellungen/einstellung"]("allgemein");
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, 90, 210, 1, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, 91, 210, 1, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, 92, 210, 1, "F");
        var img = new Image();
        img.src = "/static/" + _this10.$vars.verbindung + "/wappen_256.png";
        doc.addImage(img, 125, 30, 75, 75);
        doc.setFontSize(9);
        doc.text(settings.name + " | " + settings.strasse + " " + settings.hausnummer + " | " + settings.plz + " " + settings.ort, 25, 51);
        doc.setFontSize(11);
        var anrede = bbr.anrede === "Herr" ? "Herrn" : bbr.anrede || "";
        if (bbr.titel) {
          doc.text(anrede + " " + bbr.titel, 25, 61);
        } else {
          doc.text(anrede, 25, 61);
        }
        doc.text((bbr.vorname || "") + " " + (bbr.nachname || ""), 25, 66);
        doc.text(bbr.adresse || "", 25, 71);
        doc.text((bbr.plz || "") + " " + (bbr.ort || ""), 25, 76);
        doc.text(bbr.land || "", 25, 81);
        doc.setFont("Times", "bold");
        if (_this10.printData.anschreibenTitel) {
          doc.text(_this10.printData.anschreibenTitel, 25, 110);
        }
        doc.setFont("Times", "normal");

        var maxLinesPerPage = _this10.printData.anschreibenTitel ? 35 : 38;
        var lines = doc.splitTextToSize(_this10.printData.anschreiben, 160);
        var lines1 = lines.slice(0, maxLinesPerPage);
        var lines2 = lines.slice(maxLinesPerPage);

        doc.setFont("Times", "normal");

        doc.text(lines1, 25, _this10.printData.anschreibenTitel ? 125 : 110);

        if (lines2.length > 0) {
          doc.addPage();
          doc.setFont("Times", "normal");
          doc.text(lines2, 25, 30);
        }
        if (index + 1 < _this10.printData.kontakte.length) {
          doc.addPage();
        }
      });
      doc.save("Versandadressen DIN A4 Brief " + new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) + ".pdf");
      this.$vars.loading = false;
    },
    printVersanddressendinlang: function printVersanddressendinlang() {
      var _this11 = this;

      var doc = new __WEBPACK_IMPORTED_MODULE_7_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      var zeile = -20;
      doc.setFillColor(0, 0, 0);
      doc.rect(0, 98.9, 3, 0.2, "F");
      doc.rect(0, 197.9, 3, 0.2, "F");
      var settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
      this.printData.kontakte.forEach(function (bbr) {
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, zeile + 90, 210, 1, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, zeile + 91, 210, 1, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, zeile + 92, 210, 1, "F");
        var img = new Image();
        img.src = "/static/" + _this11.$vars.verbindung + "/wappen_256.png";
        doc.addImage(img, 125, zeile + 30, 75, 75);
        doc.setFontSize(9);
        doc.text(settings.name + " | " + settings.strasse + " " + settings.hausnummer + " | " + settings.plz + " " + settings.ort, 25, zeile + 51);
        doc.setFontSize(11);
        var anrede = bbr.anrede === "Herr" ? "Herrn" : bbr.anrede;
        if (bbr.titel) {
          doc.text(anrede + " " + bbr.titel, 25, zeile + 61);
        } else {
          doc.text(anrede, 25, zeile + 61);
        }
        doc.text(bbr.vorname + " " + bbr.nachname, 25, zeile + 66);
        doc.text(bbr.adresse, 25, zeile + 71);
        doc.text((bbr.plz || "") + " " + (bbr.ort || ""), 25, zeile + 76);
        doc.text(bbr.land, 25, zeile + 81);
        zeile = zeile + 99;
        if (zeile === 277) {
          zeile = -20;
          doc.addPage();
          doc.setFillColor(0, 0, 0);
          doc.rect(0, 98.9, 3, 0.2, "F");
          doc.rect(0, 197.9, 3, 0.2, "F");
        }
      });
      doc.save("Versandadressen DIN Lang Brief " + new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) + ".pdf");
      this.$vars.loading = false;
    },
    savereihenfolge: function savereihenfolge() {
      var saveheaders = this.$store.getters["einstellungen/einstellung"]("kontaktspalten");
      saveheaders[this.currentBbr] = this.selectHeaders;
      this.$store.dispatch("einstellungen/updateEinstellungData", saveheaders);
    }
  },
  mounted: function mounted() {
    this.setSelectedGruppeBbrBbr();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_papaparse__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_papaparse__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["konto"],
  data: function data() {
    return {
      artItems: ["Keine Angabe", "Rechnung Interne Veranstaltung", "Rechnung Externe Veranstaltung", "Bierrechnung", "Semesterbeitrag", "Mitgliedsbeitrag", "Bankgebühr", "Thekenmiete", "Spotify", "Pizza bestellen", "Deko", "Versand Semesterprogramm", "Versand Einladungen", "Damenprogramm", "Getränkeeinkauf"],
      bbr: "",
      bbrGefunden: "",
      csvDatei: "",
      date: "",
      eintrage: [],
      expanded: [],
      headers: [{ text: "Buchungstag", value: "Buchungstag" }, { text: "Verwendungszweck", value: "Verwendungszweck" }, { text: "Begünstigter", value: "Beguenstigter/Zahlungspflichtiger" }, { text: "Betrag", value: "Betrag" }, { text: "", value: "" }],
      heute: new Date().toISOString().substr(0, 10),
      kasse: "",
      menu1: "",
      monat: new Date(),
      rechnungGefunden: "",
      search: "",
      selectedEintrag: {
        Buchungstag: {}
      },
      selectRechnung: [],
      showAnleitung: false,
      showImport: false,
      showKontakt: false,
      showRechnung: false,
      showUpload: false,
      file: ""
    };
  },

  computed: {
    kontobuch: function kontobuch() {
      var _this = this;

      if (this.$store.state.kontobucher.loaded === false) {
        this.$store.dispatch("kontobucher/loadKontobucher");
      }
      if (this.$store.state.rechnungen.loaded === false) {
        this.$store.dispatch("rechnungen/loadRechnungen");
      }
      var kontobuch = this.$store.getters["kontobucher/kontobucherKasse"](this.konto);
      var ergebnis = {
        buchungen: []
      };
      kontobuch.forEach(function (item) {
        if (item.monat === new Date(_this.monat).getFullYear() + "-" + parseInt(new Date(_this.monat).getMonth() + 1)) {
          ergebnis = item;
        }
      });
      return ergebnis;
    }
  },
  methods: {
    buchungClick: function buchungClick() {
      var text = this.selectedEintrag.Verwendungszweck;
      var rechnung = "";
      this.selectRechnung = "";
      try {
        rechnung = this.$store.getters["rechnungen/rechnungNummer"](text.match(/(\d{4})*-.*(\d{4})/)[0]);
        this.bbrGefunden = rechnung.bbrID;
        this.selectRechnung = rechnung;
      } catch (e) {}
      if (this.selectedEintrag.Betrag1 === undefined) {
        this.selectedEintrag.Betrag1 = this.selectedEintrag.Betrag;
        this.selectedEintrag.MwSt1 = "Keine Angabe";
      }
    },
    setAbgeschlossen: function setAbgeschlossen() {
      if (this.selectedEintrag.Betreff && this.selectedEintrag.Art && this.selectedEintrag.Betrag1 && this.selectedEintrag.MwSt1) {
        this.selectedEintrag.Abgeschlossen = true;
        this.$store.dispatch("kontobucher/updateKontobuchData", this.kontobuch);
        this.$store.state.snackbar = {
          show: true,
          nachricht: "Daten wurden gespeichert."
        };
        if (this.file) {
          var id = this.konto + "-" + this.kontobuch.id + "-" + this.kontobuch.buchungen.indexOf(this.selectedEintrag);
          var selectedEintrag = this.selectedEintrag;
          var kontobuch = this.kontobuch;
          this.$firebase.storage().ref("kontobuch/" + id).put(this.file).then(function (snapshot) {
            var index = kontobuch.buchungen.indexOf(selectedEintrag);
            kontobuch.buchungen[index].file = snapshot.ref.fullPath;
            this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("kontobucher").doc(kontobuch.id).update(kontobuch);
            this.file = [];
            (function (err) {
              console.log("Encountered error: " + err);
            });
          });
        }
      } else {
        this.$store.state.snackbar = {
          show: true,
          nachricht: "Vor Abschluss müssen alle Felder ausgefüllt sein."
        };
      }
    },
    uploadData: function uploadData() {
      var monat = this.monat;
      var fileToLoad = this.csvDatei;
      var reader = new FileReader();
      var eintrage = [];
      reader.onload = function (fileLoadedEvent) {
        __WEBPACK_IMPORTED_MODULE_0_papaparse___default.a.parse(fileLoadedEvent.target.result, {
          header: true,
          encoding: "ISO-8859-1",
          complete: function complete(results) {
            results.data.forEach(function (item) {
              item.Betrag = parseFloat(item.Betrag.replace(",", ".")).toFixed(2);
              var parts = item.Buchungstag.match(/(\d+)/g);
              item.Buchungstag = new Date("20" + parts[2], parts[1] - 1, parts[0]);
              if (new Date(monat).getFullYear() === parseInt("20" + parts[2]) && new Date(monat).getMonth() === parseInt(parts[1] - 1)) {
                eintrage.push(item);
              }
            });
          },
          error: function error(errors) {
            console.log("error", errors);
          }
        });
      };
      reader.readAsText(fileToLoad);
      this.eintrage = eintrage;
      this.showImport = true;
      this.showUpload = false;
      this.csvDatei = "";
    },
    importData: function importData() {
      var summe = 0;
      this.eintrage.forEach(function (eintrag) {
        summe += parseFloat(eintrag.Betrag);
      });
      var item = {
        buchungen: this.eintrage,
        monat: new Date(this.monat).getFullYear() + "-" + parseInt(new Date(this.monat).getMonth() + 1),
        summe: summe.toFixed(2),
        kasse: this.konto,
        geaendertAm: new Date()
      };
      this.$store.dispatch("kontobucher/createKontobuch", item);
      this.showImport = false;
      this.showUpload = false;
    },
    deleteEintrag: function deleteEintrag(item) {
      this.$store.dispatch("kontobucher/deleteKontobuchData", item.id);
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      eintrage: [{
        id: 1,
        titel: 'Maiparty',
        beschreibung: 'Informationen zum Aufbau und Ablauf der Maiparty',
        tags: ['Veranstaltung', 'Party', 'Aufbau', 'Sommersemester'],
        kommentare: [],
        zuletzt_bearbeitet: '2020-10-03'
      }, {
        id: 2,
        titel: 'Fahnenhissung',
        beschreibung: 'Aufbau, Essen Ablauf der Fahnenhissung',
        tags: ['Veranstaltung', 'Aufbau', 'Wintersemester'],
        kommentare: [],
        zuletzt_bearbeitet: '2020-06-28'
      }, {
        id: 3,
        titel: 'Semesterprogramm',
        beschreibung: 'Versandinformationen Semesterprogramm',
        tags: ['Versand', 'Porto'],
        kommentare: [],
        zuletzt_bearbeitet: '2020-09-11'
      }]
    };
  },

  computed: {
    test: function test() {
      return 'kategorien';
    }
  },
  methods: {
    test: function test() {
      return 'text';
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_korpodeskApi__ = __webpack_require__(341);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      emails: [],
      search: "",
      filter: null,
      showNachricht: false,
      showNachrichtenInfo: false,
      showOnlyError: true,
      loading: {
        mailAnalytics: false,
        stats: false
      },
      neuNachricht: false,
      showVersandMenu: false,
      response: "",
      headers: [{ text: "Betreff", align: "left", value: "betreff" }],
      nachricht: {
        an: [],
        cc: [],
        bcc: [],
        gruppen: [],
        message: {},
        absender: {}
      },
      stats: null,
      fehler: null,
      cardHeight: 0,
      sheetHeight: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.addEventListener("resize", _this.handleResize);
              _this.handleResize();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    bundesbruder: function bundesbruder() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    nachrichten: function nachrichten() {
      if (this.$store.state.mails.loaded === false) {
        this.$store.dispatch("mails/loadMails");
      }
      if (this.filter === 0) {
        return this.$store.getters["mails/eigeneMails"](this.currentBbr);
      } else {
        return this.$store.getters["mails/gesendeteMails"](this.currentBbr);
      }
    },
    versand: function versand() {
      if (this.$store.state.mails.loaded) {
        return this.$store.getters["mails/entwurfAndErrorMails"];
      }
    },
    totalRecipients: function totalRecipients() {
      return this.nachricht.to.length + this.nachricht.cc.length + this.nachricht.bcc.length || 1;
    }
  },
  methods: {
    getAnalytics: function getAnalytics() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var today, sixMonthsAgo, res, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading.mailAnalytics = true;
                _context2.prev = 1;
                today = Math.floor(Date.now() / 1000);
                sixMonthsAgo = today - 6 * 30 * 24 * 60 * 60;
                _context2.next = 6;
                return _this2.$firebase.functions().httpsCallable("getAnalytics")({
                  domain_id: "xkjn41m20j54z781",
                  from: sixMonthsAgo,
                  to: today,
                  group: "years",
                  tags: [_this2.nachricht.id]
                });

              case 6:
                res = _context2.sent;
                data = res.data.body.data.stats.reduce(function (acc, curr) {
                  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(curr).forEach(function (key) {
                    if (key !== "date") {
                      acc[key] = (acc[key] || 0) + curr[key];
                    }
                  });
                  return acc;
                }, {});


                _this2.stats = [{
                  label: "Versendet",
                  value: data.sent,
                  color: "green",
                  hint: "Die Mail wurde erfolgreich versendet. Das heißt noch nicht, dass sie auch angekommen ist."
                }, {
                  label: "Zugestellt",
                  value: data.delivered,
                  color: "green",
                  hint: "Die Mail wurde erfolgreich zugestellt."
                }, {
                  label: "Soft Bounced",
                  value: data.soft_bounced,
                  color: "orange",
                  hint: "Die Mail konnte nicht zugestellt werden, weil der Empfänger-Server die Mail abgelehng hat. Das kann an temporären Problemen wie z.B. einem vollen Postfach oder einer falschen Adresse liegen. Eventuell wurde die Mail auch als Spam markiert."
                }, {
                  label: "Hard Bounced",
                  value: data.hard_bounced,
                  color: "red",
                  hint: "Die Mail konnte nicht zugestellt werden und wird nicht erneut versucht."
                }, {
                  label: "Geöffnet",
                  value: data.opened,
                  color: "green",
                  hint: "Die Mail wurde geöffnet. Die Zahl kann über der Gesamtzahl liegen, da ein Empfänger mehrfach öffnen kann."
                }];
                _this2.loading.mailAnalytics = false;
                return _context2.abrupt("return");

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](1);

                console.log(_context2.t0);
                _this2.loading.mailAnalytics = false;
                return _context2.abrupt("return");

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13]]);
      }))();
    },
    getEmailStats: function getEmailStats(email) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var endpoint, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.loading.stats = true;

                endpoint = "/api/v1/email/getEmailStats?bulk_email_id=" + email.bulk_email_id + "&email_id=" + email.id;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_korpodeskApi__["a" /* default */].request(endpoint, "GET");

              case 5:
                response = _context3.sent;


                console.log("📊 E-Mail-Statistik:", response);

                if (response.success) {
                  _this3.stats = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response.data);
                } else {
                  _this3.fehler = response.error || "Unbekannter Fehler beim Abrufen der Statistiken.";
                  console.error("❌ Fehler beim Abrufen der Stats:", _this3.fehler);
                }
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                _this3.fehler = _context3.t0.message || "Ein unerwarteter Fehler ist aufgetreten.";
                console.error("❌ API-Fehler:", _context3.t0);

              case 14:
                _context3.prev = 14;

                _this3.loading.stats = false;
                return _context3.finish(14);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10, 14, 17]]);
      }))();
    },
    mailErrors: function mailErrors(log) {
      var _this4 = this;

      var errormails = [];
      if (log && Array.isArray(log)) {
        log.forEach(function (item) {
          if (item.error) {
            errormails.push.apply(errormails, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(item.recipients));
          }
        });
      }
      var uniqueEmails = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(errormails)));
      var finalEmails = [];
      uniqueEmails.forEach(function (mail) {
        var kontakt = _this4.bundesbruder.find(function (kontakt) {
          return kontakt.email === mail;
        });
        if (kontakt) {
          finalEmails.push({ kontakt: kontakt.id, mail: mail });
        } else {
          finalEmails.push({ kontakt: mail, mail: mail });
        }
      });
      return finalEmails;
    },
    test: function test() {
      console.log("GetMails()");
    },
    duplicateMail: function duplicateMail(item) {
      this.copynachricht = item;
      console.log(this.copynachricht);
      this.showNachricht = true;
      this.neuNachricht = true;
    },
    handleResize: function handleResize() {
      this.cardHeight = window.innerHeight - this.$refs.card.offsetTop - 186;
      if (this.nachricht.id && this.$refs.cardText) {
        this.sheetHeight = window.innerHeight - this.$refs.cardText.$el.offsetTop - 186;
      }
    },
    alleErneutVersenden: function alleErneutVersenden() {
      var _this5 = this;

      var length = this.versand.length;
      this.versand.forEach(function (item, index) {
        setTimeout(function () {
          console.log("send Mail (" + (index + 1) + "/" + length + ")");
          _this5.erneutVersenden(item);
        }, 5000 * index);
      });
    },
    erneutVersenden: function erneutVersenden(mail) {
      mail.datum = new Date();
      mail.status = "Warte auf Versand..";
      mail.queue = mail.bcc ? mail.bcc.length + 1 : 1;
      this.$store.dispatch("mails/createEinMails", mail);
      this.$store.state.snackbar = {
        show: true,
        nachricht: "Mail wurde für den Versand übermittelt. Der Versand kann mehrere Minuten dauern."
      };
      this.deleteMail(mail.id);
    },
    deleteMail: function deleteMail(id) {
      this.nachricht = {
        an: [],
        message: {},
        absender: {}
      };
      this.$store.dispatch("mails/deleteEinMailsData", id);
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_papaparse__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_papaparse__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["kasse", "on"],
  data: function data() {
    return {
      showSepaDateien: false,
      showRechnungenVersenden: false,
      rechnungen: [],
      indexRechnung: 0,
      menu1: "",
      menu2: "",
      menu3: "",
      menu4: "",
      showExport: "",
      showStatistik: false,
      filter: {
        von: new Date(new Date().setDate(1)).toISOString().substr(0, 10),
        bis: new Date(new Date(new Date().setDate(1)).setMonth(new Date().getMonth() + 1)).toISOString().substr(0, 10)
      },
      showRechnungerstellen: false,
      showRechnungerstellenPositionAdd: false,
      showRechnungerstellenVeranstaltungAdd: false,
      showRechnungerstellenCouleurstrafenAdd: false,
      rechnungErstellenData: {
        bbrbbr: [],
        datum: new Date().toISOString().substr(0, 10),
        zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
        positionen: [],
        rechnungen: [{
          positionen: []
        }]
      },
      rechnungErstellenDataMaske: {
        bbrbbr: [],
        datum: new Date().toISOString().substr(0, 10),
        zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
        freitext: "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \n<<Absender Name>>",
        freitext_Sepa: "<<Briefanrede>> <<Nachname>>, \n\nhiermit informiere ich Dich, dass die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ am <<Zahlbar_bis>> von Deinem Konto abgebucht wird. \n \nMit bundesbrüderlichen Grüßen  \n<<Absender Name>>",
        positionen: [],
        rechnungen: []
      },
      switchTabelle: {
        positionen: true,
        rechnungen: true
      },
      headersData: [{
        text: "",
        sortable: false,
        value: "id"
      }, { text: "Bbr", value: "bbr" }, { text: "Betrag", value: "betrag" }, { text: "", value: "" }],
      rechnungErstellenPositionAddData: {
        betragArray: []
      },
      rechnungerstellenVeranstaltungAddData: {
        betragArray: []
      },
      rechnungerstellenCouleurstrafenAddData: {
        betragArray: []
      },
      e1: 1,
      showNeueRechnung: false,
      showNeuePosition: false,
      berechneteStrafen: [],
      neueRechnung: {
        bbrbbr: [],
        titel: "",
        datum: new Date().toISOString().substr(0, 10),
        zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
        freitext: "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \n<<Absender Name>>",
        positionen: [],
        kasse: this.kasse,
        status: "Entwurf"
      },
      saveNeueRechnung: {
        bbrbbr: [],
        titel: "",
        datum: new Date().toISOString().substr(0, 10),
        zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
        freitext: "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \n<<Absender Name>>",
        positionen: [],
        kasse: this.kasse,
        status: "Entwurf"
      },
      headers: [{ text: "Was", value: "was", align: "left" }, { text: "Anzahl", value: "anzahl", align: "right" }, { text: "Betrag", value: "betrag", align: "right" }],
      neuePosition: {},
      neuePositionGruppe: {},
      search: "",
      date: "",
      tab: null,
      tabJahre: null,
      rechnungsJahre: [],
      BbrToData: ""
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    gruppen: function gruppen() {
      return this.$store.state.einstellungen.einstellungen.find(function (item) {
        return item.id === "mitgliederstatus";
      }).status;
    },
    alleRechnungen: function alleRechnungen() {
      return this.$store.getters["rechnungen/rechnungenKasse"](this.kasse);
    },
    kontaktfelder: function kontaktfelder() {
      var felder = [];
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("einstellungen").doc("kontaktfelder").get().then(function (doc) {
        if (!doc.exists) {
          console.log("Fehler beim Laden der Kontaktfelder.");
          return ["Fehler beim Laden der Kontaktfelder."];
        } else {
          doc.data().finanzFelder.beitrage.forEach(function (item) {
            felder.push({
              value: item.value,
              text: item.label
            });
          });
        }
      }).catch(function (err) {
        console.log("Error getting document", err);
      });
      return felder;
    },
    veranstaltungen: function veranstaltungen() {
      var veranstaltungen = [];
      var sortable = [];
      this.$store.getters["veranstaltungen/vergangeneVeranstaltungen"].forEach(function (item) {
        sortable.push([item, new Date(item.vonDatum)]);
      });
      sortable.sort(function (a, b) {
        return b[1] - a[1];
      });
      sortable.forEach(function (item) {
        var text = new Date(item[0].vonDatum).toLocaleString(["de-de"], {
          weekday: "short",
          day: "numeric",
          month: "numeric"
        }) + ": " + item[0].titel;
        veranstaltungen.push({
          value: item[0],
          text: text
        });
      });
      return veranstaltungen;
    },
    sepaDateien: function sepaDateien() {
      if (this.$store.state.sepa.sepa.length === 0) {
        this.$store.dispatch("sepa/loadSepa");
      }
      var sepaDateien = this.$store.state.sepa.sepa;
      sepaDateien = sepaDateien.sort(function (a, b) {
        var dateA = new Date(a.date.seconds * 1000);
        var dateB = new Date(b.date.seconds * 1000);
        return dateB - dateA;
      });
      return sepaDateien;
    },
    kontrolleRechnungen: function kontrolleRechnungen() {
      if (this.rechnungErstellenData.rechnungen.length > 0) {
        return this.rechnungErstellenData.rechnungen;
      } else {
        return [{ positionen: [] }];
      }
    },
    bundesbruder: function bundesbruder() {
      var bbrbbr = [];
      this.$store.state.bbrbbr.bbrbbr.forEach(function (bbr) {
        if (bbr.vulgo) {
          bbrbbr.push({
            id: bbr.id,
            value: bbr.id,
            name: bbr.nachname + ", " + bbr.vorname + " (" + bbr.vulgo + ")",
            text: bbr.nachname + ", " + bbr.vorname + " (" + bbr.vulgo + ")"
          });
        } else {
          bbrbbr.push({
            id: bbr.id,
            value: bbr.id,
            name: bbr.nachname + ", " + bbr.vorname,
            text: bbr.nachname + ", " + bbr.vorname
          });
        }
      });
      return bbrbbr;
    },
    rechnungErstellenPositionAddDataSumme: function rechnungErstellenPositionAddDataSumme() {
      var _this = this;

      var summe = 0;
      this.rechnungErstellenPositionAddData.betragArray.forEach(function (item) {
        summe = parseFloat(summe) + parseFloat(item.betrag) * parseFloat(_this.rechnungErstellenPositionAddData.anzahl);
      });
      this.rechnungerstellenVeranstaltungAddData.betragArray.forEach(function (item) {
        summe = parseFloat(summe) + parseFloat(item.betrag);
      });
      this.rechnungerstellenCouleurstrafenAddData.betragArray.forEach(function (item) {
        summe = parseFloat(summe) + parseFloat(item.betrag);
      });
      return summe;
    },
    rechnungErstellenDataSumme: function rechnungErstellenDataSumme() {
      var summe = 0;
      this.rechnungErstellenData.rechnungen.forEach(function (item) {
        summe = parseFloat(summe) + parseFloat(item.summe);
      });
      return summe;
    },
    summe: function summe() {
      var _this2 = this;

      var summe = 0;
      this.neueRechnung.positionen.forEach(function (position) {
        if (position.wer === "gruppe") {
          summe = summe + parseFloat(position.betrag, 2);
        } else {
          summe = summe + parseFloat(position.betrag, 2) * parseInt(position.anzahl, 0) * _this2.neueRechnung.bbrbbr.length;
        }
      });
      return summe;
    },
    formatDatum: function formatDatum() {
      if (!this.rechnungErstellenData.datum) return null;
      return new Date(this.rechnungErstellenData.datum).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    formatDatumVon: function formatDatumVon() {
      if (!this.filter.von) return null;
      return new Date(this.filter.von).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    formatDatumBis: function formatDatumBis() {
      if (!this.filter.bis) return null;
      return new Date(this.filter.bis).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    formatZahlbar_bis: function formatZahlbar_bis() {
      if (!this.rechnungErstellenData.zahlbar_bis) return null;
      return new Date(this.rechnungErstellenData.zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    rechnungsKategorienen: function rechnungsKategorienen() {
      var _this3 = this;

      var kategorien = [{
        status: "Entwurf",
        anzahl: 0
      }, {
        status: "Entwurf SEPA",
        anzahl: 0
      }, {
        status: "Offen",
        anzahl: 0
      }, {
        status: "Versendet",
        anzahl: 0
      }, {
        status: "Überfällig",
        anzahl: 0
      }, {
        status: "Mahnung",
        anzahl: 0
      }, {
        status: "Gemahnt überfällig",
        anzahl: 0
      }, {
        status: "Gezahlt",
        anzahl: 0
      }, {
        status: "Alle",
        anzahl: 0
      }];
      var laufvariable = ["Entwurf", "Entwurf SEPA", "Offen", "Versendet", "Überfällig", "Mahnung", "Gemahnt überfällig", "Gezahlt", "Alle"];
      if (this.$store.state.rechnungen.loaded === false) {
        this.$store.dispatch("rechnungen/loadRechnungen");
      }
      this.$store.getters["rechnungen/rechnungenKasse"](this.kasse).forEach(function (item) {
        if (_this3.rechnungsJahre.indexOf(item.rechnung_datum.split("-")[0]) === -1) {
          _this3.rechnungsJahre.push(item.rechnung_datum.split("-")[0]);
        }
        kategorien[laufvariable.indexOf(item.status)].anzahl++;
        kategorien[laufvariable.indexOf("Alle")].anzahl++;
      });
      kategorien.forEach(function (item) {
        if (item.anzahl === 0) {
          kategorien.splice(kategorien.indexOf(item), 1);
        }
      });
      return kategorien;
    },
    positionen: function positionen() {
      var _this4 = this;

      var positionen = {
        sepa: {},
        normal: {},
        sepa_summe: 0,
        normal_summe: 0
      };
      this.$store.getters["rechnungen/rechnungenKasse"](this.kasse).forEach(function (item) {
        if (item.gezahlt_datum) {
          var rechnungsDate = new Date(item.gezahlt_datum.seconds * 1000);
          var von = new Date(_this4.filter.von);
          var bis = new Date(_this4.filter.bis);
          if (von <= rechnungsDate && bis >= rechnungsDate) {
            if (item.rechnung_art === "SEPA") {
              item.positionen.forEach(function (pos) {
                if (positionen.sepa[pos.was] === undefined) {
                  positionen.sepa[pos.was] = {
                    bezeichnung: pos.was,
                    betrag: parseFloat(pos.betrag)
                  };
                  positionen.sepa_summe = positionen.sepa_summe + parseFloat(pos.betrag);
                } else {
                  positionen.sepa[pos.was].betrag += parseFloat(pos.betrag);
                  positionen.sepa_summe = positionen.sepa_summe + parseFloat(pos.betrag);
                }
              });
            } else {
              item.positionen.forEach(function (pos) {
                if (positionen.normal[pos.was] === undefined) {
                  positionen.normal[pos.was] = {
                    bezeichnung: pos.was,
                    betrag: parseFloat(pos.betrag)
                  };
                  positionen.normal_summe = positionen.normal_summe + parseFloat(pos.betrag);
                } else {
                  positionen.normal[pos.was].betrag += parseFloat(pos.betrag);
                  positionen.normal_summe = positionen.normal_summe + parseFloat(pos.betrag);
                }
              });
            }
          }
        }
      });
      return positionen;
    }
  },
  methods: {
    gruppeAdd: function gruppeAdd(bezeichnung) {
      var _this5 = this;

      if (this.rechnungErstellenData.bbrbbr === undefined) {
        this.rechnungErstellenData.bbrbbr = [];
      }
      if (bezeichnung === "Alle") {
        this.bbrbbr.forEach(function (bbr) {
          _this5.rechnungErstellenData.bbrbbr.push(bbr.id);
        });
      } else {
        this.bbrbbr.forEach(function (bbr) {
          if (bbr.status === bezeichnung) {
            _this5.rechnungErstellenData.bbrbbr.push(bbr.id);
          }
        });
      }
    },
    rechnungErstellenPositionAdd: function rechnungErstellenPositionAdd() {
      var _this6 = this;

      var value = {};
      if (this.rechnungErstellenPositionAddData.betragArray.length > 0) {
        value = this.rechnungErstellenPositionAddData;
      }
      if (this.rechnungerstellenVeranstaltungAddData.betragArray.length > 0) {
        value = this.rechnungerstellenVeranstaltungAddData;
        value.bezeichnung = this.rechnungerstellenVeranstaltungAddData.veranstaltung.titel;
      }
      if (this.rechnungerstellenCouleurstrafenAddData.betragArray.length > 0) {
        value = this.rechnungerstellenCouleurstrafenAddData;
        this.berechneteStrafen.forEach(function (strafe) {
          _this6.$store.dispatch("couleurstrafen/updateCouleurstrafData", strafe);
        });
        this.berechneteStrafen = [];
      }
      var posID = void 0;
      if (this.rechnungErstellenData.positionen.length === 0) {
        posID = 1;
      } else {
        posID = this.rechnungErstellenData.positionen[this.rechnungErstellenData.positionen.length - 1].id + 1;
      }
      this.rechnungErstellenData.positionen.push({
        id: posID,
        bezeichnung: value.bezeichnung,
        art: value.art,
        rechnungen: [],
        anzahl: value.anzahl,
        kontaktfeld: value.kontaktfeld,
        min: Infinity,
        max: 0,
        summe: 0
      });
      var posIndex = this.rechnungErstellenData.positionen.findIndex(function (el) {
        return el.id === posID;
      });
      value.betragArray.forEach(function (beitrag) {
        if (beitrag.betrag > 0) {
          var beitragData = {
            id: posID,
            bbr: beitrag.bbr,
            bezeichnung: value.bezeichnung,
            anzahl: value.anzahl,
            betrag: beitrag.betrag,
            summe: parseFloat(value.anzahl) * parseFloat(beitrag.betrag)
          };

          _this6.rechnungErstellenData.positionen[posIndex].rechnungen.push(beitragData);
          _this6.rechnungErstellenData.positionen[posIndex].summe = parseFloat(_this6.rechnungErstellenData.positionen[posIndex].summe) + parseFloat(beitragData.summe);
          if (beitragData.summe < _this6.rechnungErstellenData.positionen[posIndex].min) {
            _this6.rechnungErstellenData.positionen[posIndex].min = beitragData.summe;
          }
          if (beitragData.summe > _this6.rechnungErstellenData.positionen[posIndex].max) {
            _this6.rechnungErstellenData.positionen[posIndex].max = beitragData.summe;
          }

          var rechnungIndex = _this6.rechnungErstellenData.rechnungen.findIndex(function (el) {
            return el.bbrID === beitragData.bbr;
          });
          if (rechnungIndex === -1) {
            _this6.rechnungErstellenData.rechnungen.push({
              bbrID: beitragData.bbr,
              summe: 0,
              positionen: []
            });
            rechnungIndex = _this6.rechnungErstellenData.rechnungen.findIndex(function (el) {
              return el.bbrID === beitragData.bbr;
            });
          }
          _this6.rechnungErstellenData.rechnungen[rechnungIndex].positionen.push(beitragData);
          _this6.rechnungErstellenData.rechnungen[rechnungIndex].summe = parseFloat(_this6.rechnungErstellenData.rechnungen[rechnungIndex].summe) + parseFloat(beitragData.summe);
        }
      });
      this.showRechnungerstellenPositionAdd = false;
      this.showRechnungerstellenVeranstaltungAdd = false;
      this.showRechnungerstellenCouleurstrafenAdd = false;
      this.rechnungErstellenPositionAddData = { betragArray: [] };
      this.rechnungerstellenVeranstaltungAddData = { betragArray: [] };
      this.rechnungerstellenCouleurstrafenAddData = { betragArray: [] };
    },
    addBbrToData: function addBbrToData() {
      this.rechnungErstellenData.bbrbbr.push(this.BbrToData);
      this.BbrToData = "";
    },
    changePositionDataInput: function changePositionDataInput(art) {
      var _this7 = this;

      var betrag = void 0;
      var value = this.rechnungErstellenPositionAddData.kontaktfeld;
      this.rechnungErstellenPositionAddData.betragArray = [];
      var id = 0;
      this.rechnungErstellenData.bbrbbr.forEach(function (bbr) {
        if (art === "kontaktfeld") {
          betrag = parseFloat(_this7.$store.getters["bbrbbr/bbr"](bbr)[value]);
        }
        if (art === "betrag") {
          betrag = _this7.rechnungErstellenPositionAddData.betrag;
        }
        if (art === "null") {
          betrag = 0;
        }
        if (!betrag) {
          betrag = 0;
        }
        _this7.rechnungErstellenPositionAddData.betragArray.push({
          id: id,
          bbr: bbr,
          betrag: betrag
        });
        id++;
      });
    },
    changeVeranstaltungDataInput: function changeVeranstaltungDataInput() {
      var _this8 = this;

      this.rechnungerstellenVeranstaltungAddData.betragArray = [];
      var id = 0;
      var betragFuxenkasse = 0;
      this.rechnungerstellenVeranstaltungAddData.veranstaltung.anmeldungen.forEach(function (anmeldung) {
        var bbr = _this8.$store.getters["bbrbbr/bbr"](anmeldung);
        var betrag = _this8.rechnungerstellenVeranstaltungAddData.betrag;
        if (bbr.status === "Fux") {
          if (_this8.rechnungerstellenVeranstaltungAddData.fuxe) {
            betragFuxenkasse = parseFloat(betragFuxenkasse) + parseFloat(betrag);
            betrag = 0;
          }
        }
        if (!_this8.rechnungerstellenVeranstaltungAddData.begleitungen) {
          _this8.rechnungerstellenVeranstaltungAddData.veranstaltung.weitereAnmeldungen.forEach(function (weitereAnmeldung) {
            if (weitereAnmeldung.angemeldetVon === anmeldung) {
              betrag = parseFloat(betrag) + parseFloat(_this8.rechnungerstellenVeranstaltungAddData.betragBegleitung);
            }
          });
        }
        if (betrag > 0) {
          _this8.rechnungerstellenVeranstaltungAddData.betragArray.push({
            id: id,
            bbr: anmeldung,
            betrag: betrag
          });
        }
        id++;
      });
      if (betragFuxenkasse > 0) {
        this.rechnungerstellenVeranstaltungAddData.betragArray.push({
          id: id,
          bbr: "1VHmwi95sFWuvyhLjR9I",
          betrag: betragFuxenkasse
        });
      }
    },
    changeCouleurstrafenDataInput: function changeCouleurstrafenDataInput() {
      var _this9 = this;

      if (this.$store.state.couleurstrafen.couleurstrafen.length === 0) {
        this.$store.dispatch("couleurstrafen/loadCouleurstrafen");
      }
      this.rechnungerstellenCouleurstrafenAddData.betragArray = [];
      var id = 0;
      this.berechnteStrafen = [];
      this.rechnungErstellenData.bbrbbr.forEach(function (bbr) {
        var betrag = 0;
        _this9.$store.state.couleurstrafen.couleurstrafen.forEach(function (item) {
          item.strafen.forEach(function (strafe) {
            if (strafe.wer === bbr && strafe.bezahlt === false) {
              betrag += parseFloat(strafe.betrag);
              strafe.bezahlt = true;
              _this9.berechneteStrafen.push(item);
            }
          });
        });
        _this9.rechnungerstellenCouleurstrafenAddData.betragArray.push({
          id: id,
          bbr: bbr,
          betrag: betrag
        });
        id++;
      });
    },
    deleteRechnungErstellenPosition: function deleteRechnungErstellenPosition(item) {
      var index = this.rechnungErstellenData.positionen.indexOf(item);
      this.rechnungErstellenData.positionen.splice(index, 11);
      this.rechnungErstellenData.rechnungen.forEach(function (rechnung) {
        rechnung.positionen.forEach(function (position) {
          if (position.id === item.id) {
            rechnung.summe = parseFloat(rechnung.summe) - parseFloat(position.anzahl) * parseFloat(position.betrag);
            rechnung.positionen.splice(rechnung.positionen.indexOf(position), 1);
          }
        });
      });
    },
    deleteRechnungErstellenRechnung: function deleteRechnungErstellenRechnung(item) {
      var _this10 = this;

      var index = this.rechnungErstellenData.rechnungen.indexOf(item);
      this.rechnungErstellenData.rechnungen.splice(index, 1);
      item.positionen.forEach(function (itemPosition) {
        var posIndex = _this10.rechnungErstellenData.positionen.findIndex(function (el) {
          return el.id === itemPosition.id;
        });
        _this10.rechnungErstellenData.positionen[posIndex].rechnungen.splice(_this10.rechnungErstellenData.positionen[posIndex].rechnungen.indexOf(itemPosition), 1);
        var posBetrag = parseFloat(itemPosition.anzahl) * parseFloat(itemPosition.betrag);
        _this10.rechnungErstellenData.positionen[posIndex].summe = parseFloat(_this10.rechnungErstellenData.positionen[posIndex].summe) - parseFloat(posBetrag);
        if (posBetrag === _this10.rechnungErstellenData.positionen[posIndex].min || posBetrag === _this10.rechnungErstellenData.positionen[posIndex].max) {
          var min = Infinity;
          var max = 0;
          _this10.rechnungErstellenData.positionen[posIndex].rechnungen.forEach(function (rechnung) {
            if (rechnung.anzahl * rechnung.betrag < min) {
              min = rechnung.anzahl * rechnung.betrag;
            }
            if (rechnung.anzahl * rechnung.betrag > max) {
              max = rechnung.anzahl * rechnung.betrag;
            }
          });
        }
      });
    },
    downloadSepa: function downloadSepa(item) {
      var xmltext = item.xml;
      var filename = item.filename;

      var pom = document.createElement("a");
      pom = document.createElement("a");
      var bb = new Blob([xmltext], { type: "text/plain" });
      pom.setAttribute("href", window.URL.createObjectURL(bb));
      pom.setAttribute("download", filename);
      pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
      pom.draggable = true;
      pom.classList.add("dragout");
      pom.click();
    },
    exportData: function exportData() {
      var csv = __WEBPACK_IMPORTED_MODULE_0_papaparse___default.a.unparse(this.$store.getters["rechnungen/rechnungenKasse"](this.kasse), {
        header: true,
        encoding: "UTF-8"
      });
      var anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Export-Rechnungen-Bierkasse.csv";
      anchor.click();
    },
    addGruppe: function addGruppe(item) {
      var _this11 = this;

      if (item === "Aktive") {
        this.$store.getters["bbrbbr/bbrStatus"]("Fux").forEach(function (bbr) {
          _this11.neueRechnung.bbrbbr.push(bbr.id);
        });
        this.$store.getters["bbrbbr/bbrStatus"]("Aktiver").forEach(function (bbr) {
          _this11.neueRechnung.bbrbbr.push(bbr.id);
        });
        this.$store.getters["bbrbbr/bbrStatus"]("Inaktiver in locum").forEach(function (bbr) {
          _this11.neueRechnung.bbrbbr.push(bbr.id);
        });
        this.$store.getters["bbrbbr/bbrStatus"]("Inaktiver extra locum").forEach(function (bbr) {
          _this11.neueRechnung.bbrbbr.push(bbr.id);
        });
      }
      if (item === "AHAH") {
        this.$store.getters["bbrbbr/bbrStatus"]("Alter Herr").forEach(function (bbr) {
          _this11.neueRechnung.bbrbbr.push(bbr.id);
        });
      }
    },
    ersetzeText: function ersetzeText(text, rechnung) {
      var summe = 0;
      rechnung.positionen.forEach(function (position) {
        summe = parseFloat(summe) + parseFloat(position.betrag);
      });
      text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
      text = text.replace("<<Rechnungsdatum>>", new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
      text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
      text = text.replace("<<Vorname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).vorname);
      text = text.replace("<<Nachname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).nachname);
      text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
      text = text.replace("<<Absender Name>>", this.$store.getters["bbrbbr/bbr"](this.currentBbr).vorname + " " + this.$store.getters["bbrbbr/bbr"](this.currentBbr).nachname);
      text = text.replace("<<Zahlbar_bis>>", new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      return text;
    },
    rechnungErstellen: function rechnungErstellen() {
      var _this12 = this;

      console.log("rechnung stellen");
      var rechnungen = [];
      this.rechnungErstellenData.rechnungen.forEach(function (rechnung) {
        var bbr = _this12.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
        var positionen = [];
        rechnung.positionen.forEach(function (item) {
          positionen.push({
            betrag: item.summe,
            positionen: [],
            was: item.bezeichnung
          });
        });
        console.log(_this12.kasse);
        if (bbr.sepa === undefined) {
          console.log(bbr);
        }
        var kasseCorrect = void 0;
        if (bbr.sepa) {
          kasseCorrect = bbr.sepa[_this12.kasse];
        }
        console.log(kasseCorrect);
        if (kasseCorrect && bbr.iban !== "" && bbr.bic !== "" && bbr.mandatsreferenz !== "" && bbr.mandatUnterschriftsdatum !== "" && bbr.kontoinhaber !== "") {
          rechnungen.push({
            bbrID: bbr.id,
            rechnung_art: "SEPA",
            rechnung_titel: _this12.rechnungErstellenData.titel,
            rechnung_datum: _this12.rechnungErstellenData.datum,
            rechnung_zahlbar_bis: _this12.rechnungErstellenData.zahlbar_bis,
            rechnung_freitext: _this12.rechnungErstellenData.freitext_Sepa,
            positionen: positionen,
            kasse: _this12.kasse,
            status: "Entwurf SEPA"
          });
        } else {
          rechnungen.push({
            bbrID: bbr.id,
            rechnung_art: "Normal",
            rechnung_titel: _this12.rechnungErstellenData.titel,
            rechnung_datum: _this12.rechnungErstellenData.datum,
            rechnung_zahlbar_bis: _this12.rechnungErstellenData.zahlbar_bis,
            rechnung_freitext: _this12.rechnungErstellenData.freitext,
            positionen: positionen,
            kasse: _this12.kasse,
            status: "Entwurf"
          });
        }
      });
      var rechnungsnummerData = void 0;
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("einstellungen").doc("rechnungsnummer").get().then(function (snapshot) {
        rechnungsnummerData = snapshot.data();
      }).then(function () {
        rechnungen.forEach(function (neueRechnung) {
          var a = "0000" + rechnungsnummerData.rechnungsnummer[2]++;
          var b = a.substr(a.length - 4, 4);
          rechnungsnummerData.rechnungsnummer[0] = new Date().getFullYear();
          neueRechnung.rechnungsnummer = rechnungsnummerData.rechnungsnummer[0] + "-" + b;
          neueRechnung.rechnung_freitext = _this12.ersetzeText(neueRechnung.rechnung_freitext, neueRechnung);
          _this12.$store.dispatch("rechnungen/createRechnung", neueRechnung);
        });
      }).then(function () {
        var rechnungsnummerNeu = {
          rechnungsnummer: [rechnungsnummerData.rechnungsnummer[0], rechnungsnummerData.rechnungsnummer[1], rechnungsnummerData.rechnungsnummer[2]]
        };
        _this12.$firebase.firestore().collection("vereine").doc(_this12.$vars.verbindung).collection("einstellungen").doc("rechnungsnummer").update(rechnungsnummerNeu).then(function () {
          _this12.$vars.loading = false;
          _this12.fortschritt = 100;
          _this12.showRechnungenGenerieren = false;
        }).catch(function (error) {
          console.log(error);
        });
      }).then(function () {
        _this12.showRechnungerstellen = false;
        _this12.e1 = 1;
        _this12.rechnungErstellenData = _this12.rechnungErstellenDataMaske;
      });
    },
    addPosition: function addPosition() {
      this.neuePosition.wer = "alle";
      this.neueRechnung.positionen.push(this.neuePosition);
      this.neuePosition = {};
    },
    addGroupPosition: function addGroupPosition() {
      var summe = 0;
      var min = Infinity;
      var max = 0;
      this.neuePositionGruppe.positionen.forEach(function (position) {
        summe += position.anzahl * position.betrag;
        if (min > position.betrag) {
          min = position.betrag;
        }
        if (max < position.betrag) {
          max = position.betrag;
        }
      });
      var neuePosition = {
        wer: "gruppe",
        anzahl: this.neuePositionGruppe.positionen[0].anzahl,
        was: this.neuePositionGruppe.was,
        betrag: summe,
        positionen: this.neuePositionGruppe.positionen,
        min: min,
        max: max
      };
      this.neueRechnung.positionen.push(neuePosition);
      this.neuePositionGruppe = {};
      this.showNeuePosition = false;
    },
    addPositionGruppe: function addPositionGruppe() {
      var _this13 = this;

      this.neuePositionGruppe.positionen = [];
      this.neueRechnung.bbrbbr.forEach(function (bbr) {
        var betrag = void 0;
        if (_this13.$store.getters["bbrbbr/bbr"](bbr)[_this13.neuePositionGruppe.kontaktfeld]) {
          betrag = parseFloat(_this13.$store.getters["bbrbbr/bbr"](bbr)[_this13.neuePositionGruppe.kontaktfeld]);
        } else {
          betrag = 0;
        }
        _this13.neuePositionGruppe.positionen.push({
          was: _this13.neuePositionGruppe.was,
          anzahl: _this13.neuePositionGruppe.anzahl,
          wer: bbr,
          betrag: betrag
        });
      });
      this.$forceUpdate();
    },
    removePosition: function removePosition() {
      this.neueRechnung.positionen.splice(this.neueRechnung.positionen.indexOf(this.neuePosition), 1);
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'message', 'abbrechen', 'weiter', 'visible'],
  data: function data() {
    return {
      loading: ''
    };
  },

  methods: {
    closeTrue: function closeTrue() {
      this.$emit('closeTrue');
    },
    closeFalse: function closeFalse() {
      this.$emit('closeFalse');
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, exports) {



/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_papaparse__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_papaparse__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['visible'],
  data: function data() {
    return {
      step: 1,
      csvDatei: [],
      kontaktfelder: [],
      bbrImport: [],
      bbrUpdate: [],
      bbrNichtImport: [],
      bbrImportDoppelt: [],
      bbrNeuFelder: [],
      übernahmeItems: ['Nicht importieren', 'Original updaten', 'Neuer Kontakt'],
      loading: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    }
  },
  methods: {
    importInNeueBbr: function importInNeueBbr() {
      var fileToLoad = this.csvDatei;
      var reader = new FileReader();
      var bbrNeuFelder = [];
      var bbrNeu = [];
      var kontaktfelder = this.kontaktfelder;
      reader.onload = function (fileLoadedEvent) {
        __WEBPACK_IMPORTED_MODULE_1_papaparse___default.a.parse(fileLoadedEvent.target.result, {
          header: false,
          encoding: 'ISO-8859-1',
          complete: function complete(results) {
            results.data[0].forEach(function (item) {
              bbrNeuFelder.push(item);
            });
            bbrNeuFelder.forEach(function (item) {
              kontaktfelder.forEach(function (feld) {
                if (feld.system === item) {
                  feld.importiert = item;
                }
                if (feld.text === item) {
                  feld.importiert = item;
                }
              });
            });
          },
          error: function error(errors) {
            console.log('error', errors);
          }
        });
        __WEBPACK_IMPORTED_MODULE_1_papaparse___default.a.parse(fileLoadedEvent.target.result, {
          header: true,
          encoding: 'ISO-8859-1',
          complete: function complete(results) {
            results.data.forEach(function (item) {
              bbrNeu.push(item);
            });
          },
          error: function error(errors) {
            console.log('error', errors);
          }
        });
      };
      reader.readAsText(fileToLoad);
      this.step = 2;
      this.bbrNeuFelder = bbrNeuFelder;
      this.bbrNeu = bbrNeu;
    },
    wechselHeader: function wechselHeader() {
      var _this = this;

      var bbrImport = [];
      this.bbrNeu.forEach(function (item) {
        var bbr = {};
        _this.kontaktfelder.forEach(function (feld) {
          if (item[feld.importiert]) {
            bbr[feld.system] = item[feld.importiert];
          } else {
            bbr[feld.system] = '';
          }
        });
        bbrImport.push(bbr);
      });

      var bbrbbr = this.bbrbbr;
      this.bbrImportDoppelt = [];
      bbrImport.forEach(function (item) {
        bbrbbr.forEach(function (bbr) {
          if (_this.similarity(item.nachname, bbr.nachname) > 0.85 && _this.similarity(item.vorname, bbr.vorname) > 0.85) {
            _this.bbrImportDoppelt.push({
              original: bbr,
              importiert: item,
              übereinstimmung: ((_this.similarity(item.nachname, bbr.nachname) + _this.similarity(item.vorname, bbr.vorname)) / 2 * 100).toFixed(2) + '%',
              übernehmen: 'Nicht importieren'
            });
            console.log({
              original: bbr,
              importiert: item,
              übereinstimmung: ((_this.similarity(item.nachname, bbr.nachname) + _this.similarity(item.vorname, bbr.vorname)) / 2 * 100).toFixed(2) + '%',
              übernehmen: 'Nicht importieren'
            });
          }
        });
      });
      this.bbrImport = bbrImport;
      this.step = 3;
    },
    updateImportStatus: function updateImportStatus(status) {
      this.bbrImportDoppelt.forEach(function (item) {
        item.übernehmen = status;
      });
    },
    updateDoppelt: function updateDoppelt() {
      var _this2 = this;

      this.bbrNichtImport = [];
      this.bbrUpdate = [];
      this.bbrImportDoppelt.forEach(function (item) {
        if (item.übernehmen === 'Nicht importieren') {
          _this2.bbrImport.splice(_this2.bbrImport.indexOf(item.importiert), 1);
          _this2.bbrNichtImport.push({
            item: item.importiert,
            id: item.original.id
          });
        } else if (item.übernehmen === 'Original updaten') {
          _this2.bbrImport.splice(_this2.bbrImport.indexOf(item.importiert), 1);
          _this2.bbrUpdate.push({
            item: item.importiert,
            id: item.original.id
          });
        }
      });
      this.step = 4;
    },
    similarity: function similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength === 0) {
        return 1.0;
      }
      return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
    },
    editDistance: function editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      var costs = [];
      for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else {
            if (j > 0) {
              var newValue = costs[j - 1];
              if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              }
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) {
          costs[s2.length] = lastValue;
        }
      }
      return costs[s2.length];
    },
    saveNeueBbr: function saveNeueBbr() {
      var _this3 = this;

      this.loading = true;
      this.bbrImport.forEach(function (item) {
        if (item.aktivenBeitrag) {
          item.aktivenBeitrag = parseFloat(item.aktivenBeitrag.replace(',', '.')).toFixed(2);
        }
        if (item.cvBeitrag) {
          item.cvBeitrag = parseFloat(item.cvBeitrag.replace(',', '.')).toFixed(2);
        }
        if (item.ahvBeitrag) {
          item.ahvBeitrag = parseFloat(item.ahvBeitrag.replace(',', '.')).toFixed(2);
        }
        if (item.hbvBeitrag) {
          item.hbvBeitrag = parseFloat(item.hbvBeitrag.replace(',', '.')).toFixed(2);
        }
        if (!item.kontoinhaber) {
          item.kontoinhaber = item.vorname + ' ' + item.nachname;
        }
        if (item.receptionsdatum) {
          if (isNaN(item.receptionsdatum)) {
            var date = item.receptionsdatum;
            var parts = date.split('.');
            item.receptionsdatum = parts[2] + '-' + parts[1] + '-' + parts[0];
          }
        }
        if (item.geburtsdatum) {
          if (isNaN(item.geburtsdatum)) {
            var _date = item.geburtsdatum;
            var _parts = _date.split('.');
            item.geburtsdatum = _parts[2] + '-' + _parts[1] + '-' + _parts[0];
          }
        }
        if (item.philistrierungsdatum) {
          if (isNaN(item.philistrierungsdatum)) {
            var _date2 = item.philistrierungsdatum;
            var _parts2 = _date2.split('.');
            item.philistrierungsdatum = _parts2[2] + '-' + _parts2[1] + '-' + _parts2[0];
          }
        }
        if (item.mandatUnterschriftsdatum) {
          if (isNaN(item.mandatUnterschriftsdatum)) {
            var _date3 = item.mandatUnterschriftsdatum;
            var _parts3 = _date3.split('.');
            item.mandatUnterschriftsdatum = _parts3[2] + '-' + _parts3[1] + '-' + _parts3[0];
          }
        }
        if (item.letzterLastschrifteinzug) {
          if (isNaN(item.letzterLastschrifteinzug)) {
            var _date4 = item.letzterLastschrifteinzug;
            var _parts4 = _date4.split('.');
            item.letzterLastschrifteinzug = _parts4[2] + '-' + _parts4[1] + '-' + _parts4[0];
          }
        }
        _this3.$firebase.firestore().collection('vereine').doc(_this3.$vars.verbindung).collection('kontakte').add(item).then(function (key) {
          console.log('erstellt');
        }).catch(function (error) {
          console.log(error);
        });
      });
      this.bbrUpdate.forEach(function (item) {
        if (item.item.aktivenBeitrag) {
          item.item.aktivenBeitrag = parseFloat(item.item.aktivenBeitrag.replace(',', '.')).toFixed(2);
        }
        if (item.item.cvBeitrag) {
          item.item.cvBeitrag = parseFloat(item.item.cvBeitrag.replace(',', '.')).toFixed(2);
        }
        if (item.item.ahvBeitrag) {
          item.item.ahvBeitrag = parseFloat(item.item.ahvBeitrag.replace(',', '.')).toFixed(2);
        }
        if (item.item.hbvBeitrag) {
          item.item.hbvBeitrag = parseFloat(item.item.hbvBeitrag.replace(',', '.')).toFixed(2);
        }
        if (!item.item.kontoinhaber) {
          item.item.kontoinhaber = item.item.vorname + ' ' + item.item.nachname;
        }
        if (item.item.receptionsdatum) {
          if (item.item.receptionsdatum.indexOf('.') !== -1) {
            var date = item.item.receptionsdatum;
            var parts = date.split('.');
            item.item.receptionsdatum = parts[2] + '-' + parts[1] + '-' + parts[0];
          }
        }
        if (item.item.geburtsdatum) {
          if (isNaN(item.item.geburtsdatum)) {
            var _date5 = item.item.geburtsdatum;
            var _parts5 = _date5.split('.');
            item.item.geburtsdatum = _parts5[2] + '-' + _parts5[1] + '-' + _parts5[0];
          }
        }
        if (item.item.philistrierungsdatum) {
          if (isNaN(item.item.philistrierungsdatum)) {
            var _date6 = item.item.philistrierungsdatum;
            var _parts6 = _date6.split('.');
            item.item.philistrierungsdatum = _parts6[2] + '-' + _parts6[1] + '-' + _parts6[0];
          }
        }
        console.log(item);
        if (item.item.mandatUnterschriftsdatum) {
          console.log(item.item.mandatUnterschriftsdatum);
          if (isNaN(item.item.mandatUnterschriftsdatum)) {
            var _date7 = item.item.mandatUnterschriftsdatum;
            var _parts7 = _date7.split('.');
            item.item.mandatUnterschriftsdatum = _parts7[2] + '-' + _parts7[1] + '-' + _parts7[0];
          }
          console.log(item.item.mandatUnterschriftsdatum);
        }
        if (item.item.letzterLastschrifteinzug) {
          if (isNaN(item.item.letzterLastschrifteinzug)) {
            var _date8 = item.item.letzterLastschrifteinzug;
            var _parts8 = _date8.split('.');
            item.item.letzterLastschrifteinzug = _parts8[2] + '-' + _parts8[1] + '-' + _parts8[0];
          }
        }
        var updateObj = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.item).forEach(function (key) {
          if (item.item[key] !== undefined && item.item[key] !== '') {
            updateObj[key] = item.item[key];
          }
        });
        updateObj.id = item.id;
        _this3.$store.dispatch('bbrbbr/updateBbrData', updateObj);
        _this3.bbrNeu = [];
        _this3.loading = false;
        _this3.close();
      });
    },
    close: function close() {
      this.step = 1;
      this.bbrNeu = [];
      this.kontaktfelder = [];
      this.$emit('close', false);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').get().then(function (doc) {
      if (doc.exists) {
        var id = 0;
        console.log(doc.data().neuFelder);
        doc.data().neuFelder.forEach(function (item) {
          _this4.kontaktfelder.push({
            id: id++,
            text: item.label,
            system: item.value,
            value: item.value,
            importiert: ''
          });
        });
      }
    });
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    stammbaum: __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaum___default.a
  },
  props: ["bbr", "visible"],
  data: function data() {
    return {
      date: "",
      menu1: "",
      menu2: "",
      menu3: "",
      showStammbaum: false,
      denseStammbaum: true,
      selectPicture: "",
      uploadValue: "",
      img1: "",
      imageData: "",
      showBbrEdit: false,
      message: "",
      showHelp: true,
      showImage: false
    };
  },

  computed: {
    felder: function felder() {
      var kontaktfelder = this.$store.getters["einstellungen/einstellung"]("kontaktfelder");
      var neuFelder = void 0;
      if (kontaktfelder === undefined) {
        neuFelder = {};
      } else {
        neuFelder = kontaktfelder.neuFelder.filter(function (item) {
          return item.show;
        });
      }
      return neuFelder;
    },
    bundesbruder: function bundesbruder() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    leibfamilie: function leibfamilie() {
      var grunder = void 0;
      var bbr = this.bbr;
      while (!grunder) {
        if (bbr.leibvater) {
          bbr = this.$store.getters["bbrbbr/bbr"](bbr.leibvater);
          console.log(bbr.nachname);
        } else {
          grunder = bbr;
        }
      }
      var leibfamilie = {
        bbr: grunder,
        sohn: this.getLeibsohn(bbr.id)
      };
      console.log(leibfamilie);
      return leibfamilie;
    },
    allowEdit: function allowEdit() {
      var _this = this;

      var seiten = this.$store.getters["einstellungen/einstellung"]("rollen");
      var bbr = this.$store.state.bbrbbr.bbrbbr.find(function (d) {
        return d.anmeldeID === _this.$firebase.auth().currentUser.uid;
      });
      var variable = false;
      if (seiten !== undefined) {
        seiten.seiten.forEach(function (item) {
          if (item.gruppe === "Chargen" || item.gruppe === "AHV" || item.gruppe === "HBV") {
            if (item.berechtigt.indexOf(bbr.id) >= 0 || bbr.id === "PBChUyAy7HWowQR4HlP3") {
              variable = true;
            }
          }
        });
      }
      return variable;
    },
    getAlter: function getAlter() {
      var birthDate = new Date(this.bbr.geburtsdatum);
      var today = new Date();
      var age = today.getFullYear() - birthDate.getFullYear();
      var month = today.getMonth() - birthDate.getMonth();
      if (month < 0 || month === 0 && today.getDate() < birthDate.getDate()) {
        age--;
      }
      return age;
    },
    getCouleurAlter: function getCouleurAlter() {
      var birthDate = new Date(this.bbr.receptionsdatum);
      var today = new Date();
      var age = today.getFullYear() - birthDate.getFullYear();
      var month = today.getMonth() - birthDate.getMonth();
      if (month < 0 || month === 0 && today.getDate() < birthDate.getDate()) {
        age--;
      }
      return age * 2;
    }
  },
  methods: {
    calculateAge: function calculateAge(birthDate) {
      var today = new Date();
      var birth = new Date(birthDate);
      var age = today.getFullYear() - birth.getFullYear();
      var m = today.getMonth() - birth.getMonth();
      if (m < 0 || m === 0 && today.getDate() < birth.getDate()) {
        age--;
      }
      return age;
    },
    getLeibsohn: function getLeibsohn(bbrID) {
      var _this2 = this;

      var leibsohn = [];
      this.$store.getters["bbrbbr/nurBbrbbr"].forEach(function (bbr) {
        if (bbr.leibvater === bbrID) {
          leibsohn.push({
            bbr: bbr,
            sohn: _this2.getLeibsohn(bbr.id)
          });
        }
      });
      return leibsohn;
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(82);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["status", "visible"],
  data: function data() {
    return {
      bbr: {},
      sepa: {},
      itemsAnrede: ["Herr", "Frau", "Familie"],
      selectVerbindung: ["AV Alania Stuttgart", "AV Alsatia Münster", "AV Cheruscia Münster", "AV Cheruskia Tübingen", "AV Frisia Hannover", "AV Glückauf-Salia Clausthal-Zellerfeld", "AV Guestfalia Tübingen", "AV Hansea (Berlin) Köln", "AV Palatia Göttingen", "AV Rheinstein Köln", "AV Rheno-Guestfalia Kiel", "AV Salia-Silesia Gleiwitz", "AV Silesia (Halle, Bonn) Bochum", "AV Sparrenberg Bielefeld", "AV Suebo-Danubia Ulm", "AV Tuisconia (Königsberg, Bonn) Landshut", "AV Widukind Osnabrück", "AV Zollern Münster", "CV-Verbindung Rheno-Palatia (Breslau) Mainz", "FAV Rheno-Guestfalia (Hann. Münden) Göttingen", "KAV Capitolina Rom", "KAV Suevia Berlin", "KDStV Adolphiana Fulda", "KDStV Aenania München", "KDStV Agilolfia Freising", "KDStV Alania Bonn", "KDStV Alcimonia Eichstätt", "KDStV Alemannia Greifswald und Münster", "KDStV Algovia Augsburg", "KDStV Angrivaria (Sarstedt, Hannover) Dortmund", "KDStV Arminia Freiburg im Breisgau", "KDStV Arminia Heidelberg", "KDStV Ascania Bonn", "KDStV Asgard (Düsseldorf) Köln", "KDStV Aureo-Danubia Ingolstadt", "KDStV Badenia (Straßburg) Frankfurt am Main", "KDStV Baltia (Danzig) Aachen", "KDStV Bavaria Berlin", "KDStV Bavaria Bonn", "KDStV Bergisch-Thuringia Wuppertal", "KDStV Bergland (Freiberg) Aachen", "KDStV Bodensee Konstanz", "KDStV Borusso-Saxonia Berlin", "KDStV Borusso-Westfalia Bonn", "KDStV Burgundia (Leipzig) Düsseldorf", "KDStV Burgundia München", "KDStV Carolingia Hohenheim", "KDStV Carolus Magnus Saarbrücken", "KDStV Cheruscia Würzburg", "KDStV Churpfalz Mannheim", "KDStV Chursachsen Dresden", "KDStV Churtrier Trier", "KDStV Elbmark (Tetschen-Liebwerd) Duisburg", "KDStV Falkenstein Freiburg im Breisgau", "KDStV Ferdinandea (Prag) Heidelberg", "KDStV Franco-Raetia Würzburg", "KDStV Franconia Aachen", "KDStV Frankonia (Czernowitz) Erlangen", "KDStV Fredericia Bamberg", "KDStV Germania Leipzig", "KDStV Gothia Erlangen", "KDStV Gothia Würzburg", "KDStV Greiffenstein (Breslau) Frankfurt", "KDStV Guestfalo-Silesia Paderborn", "KDStV Hasso-Nassovia Frankfurt am Main", "KDStV Hercynia Freiburg im Breisgau", "KDStV Hohenstaufen Freiburg im Breisgau", "KDStV Kaiserpfalz Aachen", "KDStV Langobardia (München) Bayreuth", "KDStV Makaria (Berlin) Aachen", "KDStV Marchia (Breslau) Aachen", "KDStV Markomannia Würzburg", "KDStV Merowingia Kaiserslautern", "KDStV Moenania München", "KDStV Moeno-Franconia Frankfurt am Main", "KDStV Nassovia Darmstadt", "KDStV Nibelungia (Brünn) Darmstadt", "KDStV Niedersachsen Braunschweig", "KDStV Norbertina Magdeburg", "KDStV Nordgau (Prag, Stuttgart) Koblenz", "KDStV Nordmark (Rostock, Karlsruhe) Essen", "KDStV Normannia Karlsruhe", "KDStV Novesia Bonn", "KDStV Oeno-Danubia Passau", "KDStV Ostmark Nürnberg", "KDStV Palatia Marburg", "KDStV Palatina Amberg/Weiden", "KDStV Radaspona (Regensburg) München", "KDStV Rappoltstein (Straßburg) Köln", "KDStV Rheinland Köln", "KDStV Rheinpfalz Darmstadt", "KDStV Rhenania-Moguntia Mainz", "KDStV Rheno-Baltia Köln", "KDStV Rheno-Franconia München", "KDStV Rheno-Saxonia (Köthen) Halle", "KDStV Ripuaria Aachen", "KDStV Ripuaria Bonn", "KDStV Ripuaria Freiburg im Breisgau", "KDStV Rupertia Regensburg", "KDStV Saarland (Saarbrücken) Jena", "KDStV Sauerlandia Münster", "KDStV Saxo-Silesia Hannover", "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum", "KDStV Schwarzwald Karlsruhe", "KDStV Seraphina Lippstadt", "KDStV Staufia Bonn", "KDStV Sugambria (Jena) Göttingen", "KDStV Teuto-Rhenania Hannover", "KDStV Teutonia Freiburg im Üechtland", "KDStV Thuringia Würzburg", "KDStV Trifels München", "KDStV Tuiskonia München", "KDStV Vandalia (Prag) München", "KDStV Vasgovia Landau", "KDStV Vindelicia München", "KDStV Welfia Weingarten", "KDStV Wiking Hamburg", "KDStV Wildenstein Freiburg im Breisgau", "KDStV Winfridia (Breslau) Münster", "KStV Thuringia Coburg", "KTV Visurgis Bremen", "VKDSt Hasso-Rhenania Gießen", "VKDSt Hasso-Rhenania Mainz", "VKDSt Rhenania Marburg", "VKDSt Saxonia Münster"],
      itemsBriefanrede: ["Lieber Bundesbruder", "Sehr geehrter Cartellbruder", "Sehr geehrter Farbenbruder", "Sehr geehrter Herr", "Sehr geehrte Frau", "Sehr geehrte Damen und Herren", "Liebe", "Lieber"],
      date: "",
      menu1: "",
      menu2: "",
      menu3: "",
      menu4: "",
      menu5: "",
      menu6: "",
      menu7: "",
      menu8: "",
      pflichtfelder: [],
      menuFeldVar: "",
      loading_checkIban: false,
      selectedFile: null,
      loadingLaschriftmandatHochladen: false,
      selectPicture: "",
      showPicture: false,
      uploadValue: "",
      fehlerSepa: {},
      img1: "",
      imageData: "",
      message: "",
      rules: {
        required: function required(value) {
          return !!value || "";
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Flasches E-Mail-Format";
        },
        telefonnummer: function telefonnummer(value) {
          var pattern = /^\+([0-9]){2}[ ][1-9]([0-9]){2}[0-9]?[ ]([0-9]?){12}$/g;
          return pattern.test(value) || "Flasches Telefonnummern-Format. Es muss +49 123 456789123 entsprechen";
        },
        geld: function geld(value) {
          var pattern = /^[0-9]([0-9]?){10}([.]([0-9]?){2})?$/g;
          return pattern.test(value) || "Flasches Format. Es muss 13.45 entsprechen";
        }
      }
    };
  },

  computed: {
    itemsStatus: function itemsStatus() {
      var status = [];
      this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach(function (item) {
        status.push(item.status);
      });
      return status;
    },
    felder: function felder() {
      var kontaktfelder = this.$store.getters["einstellungen/einstellung"]("kontaktfelder");
      return kontaktfelder === undefined ? {} : kontaktfelder;
    },
    isBilderwart: function isBilderwart() {
      return this.$route.params.seite === "Bilderwart";
    },
    kassen: function kassen() {
      return this.$store.state.einstellungen.einstellungen.find(function (item) {
        return item.id === "kassen";
      });
    },
    disableSEPA: function disableSEPA() {
      return !this.bbr.bic || !this.bbr.kontoinhaber || !this.bbr.mandatsreferenz || !this.bbr.mandatUnterschriftsdatum || !this.bbr.letzterLastschrifteinzug;
    },
    formatGeburtstagDatum: function formatGeburtstagDatum() {
      if (!this.bbr.geburtsdatum) return null;
      return new Date(this.bbr.geburtsdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatReceptionsDatum: function formatReceptionsDatum() {
      if (!this.bbr.receptionsdatum) return null;
      return new Date(this.bbr.receptionsdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatPhilistrierungsDatum: function formatPhilistrierungsDatum() {
      if (!this.bbr.philistrierungsdatum) return null;
      return new Date(this.bbr.philistrierungsdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatHochzeitsDatum: function formatHochzeitsDatum() {
      if (!this.bbr.hochzeitsdatum) return null;
      return new Date(this.bbr.hochzeitsdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatTodesDatum: function formatTodesDatum() {
      if (!this.bbr.todesdatum) return null;
      return new Date(this.bbr.todesdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatletzterLastschrifteinzug: function formatletzterLastschrifteinzug() {
      if (!this.bbr.letzterLastschrifteinzug) return null;
      return new Date(this.bbr.letzterLastschrifteinzug).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatmandatUnterschriftsdatum: function formatmandatUnterschriftsdatum() {
      if (!this.bbr.mandatUnterschriftsdatum) return null;
      return new Date(this.bbr.mandatUnterschriftsdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    }
  },
  methods: {
    saveData: function saveData(value, feld) {
      var _this = this;

      this.bbr[feld.value] = value;

      var fields = [{ field: "anrede", label: "Anrede" }, { field: "vorname", label: "Vorname" }, { field: "nachname", label: "Nachname" }, { field: "adresse", label: "Adresse" }, { field: "plz", label: "PLZ" }, { field: "ort", label: "Ort" }, { field: "status", label: "Status" }];
      this.pflichtfelder = fields.filter(function (_ref) {
        var field = _ref.field,
            rule = _ref.rule;

        var value = _this.bbr[field];
        return !value || rule && rule(value) !== true;
      }).map(function (_ref2) {
        var label = _ref2.label;
        return label;
      });
    },
    save: function save() {
      console.log(this.bbr);
      this.$store.dispatch("bbrbbr/createBbr", this.bbr);
      this.bbr = {};
      this.close();
    },
    clickHochladenLastschriftmandat: function clickHochladenLastschriftmandat() {
      console.log("clickHochladenLastschriftmandat");
      this.loadingLaschriftmandatHochladen = true;
      window.addEventListener("focus", function () {}, { once: true });

      this.$refs.uploader.click();
    },
    onFileChanged: function onFileChanged(e) {
      var _this2 = this;

      this.selectedFile = e.target.files[0];
      var fileName = new Date().getSeconds();
      var storagePath = "/sepaLastschriftmandat/" + this.$vars.verbindung + "/";
      var storageRef = this.$firebase.storage().ref(storagePath + fileName).put(this.selectedFile);
      storageRef.on("state_changed", function (snapshot) {
        console.log(snapshot.bytesTransferred / snapshot.totalBytes * 100);
      }, function (error) {
        console.log(error.message);
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this2.bbr.sepaLastschriftmandat = {
            url: url,
            date: new Date(),
            name: "SEPA-Lastschrift-" + new Date().getSeconds()
          };
          _this2.loadingLaschriftmandatHochladen = false;
        });
      });
    },
    downloadLastschrift: function downloadLastschrift(file) {
      var link = document.createElement("a");
      link.setAttribute("href", file.url);
      link.setAttribute("download", file.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    previewImage: function previewImage(event) {
      this.message = "";
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event;
      this.onUpload();
    },
    checkIban: function checkIban() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.bbr.iban) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 1;

                _this3.loading_checkIban = true;
                url = "https://openiban.com/validate/" + _this3.bbr.iban + "?getBIC=true&validateBankCode=true";
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios__["a" /* default */].get(url);

              case 6:
                response = _context.sent;

                if (response.data.valid) {
                  _this3.bbr.bic = response.data.bankData.bic;
                  _this3.bbr.kontoinhaber = _this3.bbr.vorname + " " + _this3.bbr.nachname;
                  _this3.bbr.mandatsreferenz = (_this3.bbr.vorname.slice(0, 3) + _this3.bbr.nachname.slice(0, 3) + Math.floor(Math.random() * 90000000 + 10000000)).toUpperCase();
                  _this3.bbr.mandatUnterschriftsdatum = new Date().toISOString().substr(0, 10);
                  console.log(new Date().toISOString().substr(0, 10));
                  _this3.bbr.letzterLastschrifteinzug = new Date().toISOString().substr(0, 10);
                  _this3.fehlerSepa.sepa = null;
                } else {
                  _this3.bbr.bic = "";
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.sepa).forEach(function (key) {
                    _this3.sepa[key] = false;
                  });
                  _this3.fehlerSepa.sepa = "Die IBAN ist nicht korrekt.";
                }
                _this3.loading_checkIban = false;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                console.error("Fehler beim Abrufen der IBAN:", _context.t0);
                _this3.loading_checkIban = false;

              case 15:
                _context.next = 18;
                break;

              case 17:
                _this3.bbr.bic = "";

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 11]]);
      }))();
    },
    addKontoinhaber: function addKontoinhaber() {
      this.bbr.kontoinhaber = this.bbr.vorname + " " + this.bbr.nachname;
    },
    onUpload: function onUpload() {
      var _this4 = this;

      this.img1 = null;
      var storageRef = this.$firebase.storage().ref("/ahnengalerie/" + (this.bbr.nachname + this.bbr.vorname)).put(this.imageData);
      storageRef.on("state_changed", function (snapshot) {
        _this4.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        console.log(error.message);
      }, function () {
        _this4.uploadValue = 100;
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this4.img1 = url;
          _this4.bbr.bildAhnengalerie = _this4.img1;
          _this4.$store.dispatch("bbrbbr/updateBbrData", _this4.bbr);
          _this4.message = "Upload erfolgreich";
          _this4.selectPicture = "";
        });
      });
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_Rechnungen_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_Rechnungen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main_Rechnungen_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["bbr", "visibleEdit"],
  components: {
    Rechnungen: __WEBPACK_IMPORTED_MODULE_7__main_Rechnungen_vue___default.a
  },
  data: function data() {
    return {
      localBbr: this.bbr,
      loading: false,
      loading_checkIban: false,
      checkMailValue: {},
      active: 0,
      date: "",
      menu5: "",
      menu6: "",
      sepa: this.bbr.sepa ? this.bbr.sepa : {},
      fehlerSepa: {},
      selectPicture: "",
      uploadStatus: {
        img_upload: null,
        img_url1: null,
        img_url2: null,
        img_url3: null
      },
      showPicture: false,
      uploadValue: "",
      img1: "",
      imageData: "",
      message: undefined,
      rules: {
        required: function required(value) {
          return !!value || false;
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Flasches E-Mail-Format";
        },
        telefonnummer: function telefonnummer(value) {
          var pattern = /^\+([0-9]){2}[ ][1-9]([0-9]){2}[0-9]?[ ]([0-9]?){12}$/g;
          return pattern.test(value) || "Flasches Telefonnummern-Format. Es muss +49 123 456789123 entsprechen";
        },
        geld: function geld(value) {
          var pattern = /^[0-9]([0-9]?){10}([.]([0-9]?){2})?$/g;
          return pattern.test(value) || "Flasches Format. Es muss 13.45 entsprechen";
        }
      },
      showBbrRechnung: false,
      selectRechnung: "",
      showBbrNachricht: false,
      selectNachricht: "",
      showDeleteKontakt: false,
      selectedFile: null,
      loadingLaschriftmandatHochladen: false,
      today: new Date().toISOString().substr(0, 10)
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.loading = true;
    this.checkMailValue = { status: null };
    var functions = this.$firebase.functions();
    if (this.localBbr.email) {
      functions.httpsCallable("userLoginAllowed")({ email: this.localBbr.email.toLowerCase(), sub: this.$vars.verbindung }).then(function (_ref) {
        var data = _ref.data;

        _this.loading = false;
        _this.checkMailValue = data;
      }).catch(function (error) {
        console.log(error);
        _this.error = error;
        _this.loading = false;
      });
    } else {
      this.loading = false;
      this.checkMailValue = { status: null };
    }
  },

  computed: {
    bbrbbr2: function bbrbbr2() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    felder: function felder() {
      var kontaktfelder = this.$store.getters["einstellungen/einstellung"]("kontaktfelder");
      return kontaktfelder === undefined ? {} : kontaktfelder;
    },
    kassen: function kassen() {
      return this.$store.state.einstellungen.einstellungen.find(function (item) {
        return item.id === "kassen";
      });
    },
    disableSEPA: function disableSEPA() {
      return !this.localBbr.bic || !this.localBbr.kontoinhaber || !this.localBbr.mandatsreferenz || !this.localBbr.mandatUnterschriftsdatum;
    },
    bearbeitungen: function bearbeitungen() {
      console.log("Lade Bearbeitugne Edit Contact");
      if (this.$store.state.bearbeitungen.bearbeitungen.length === 0) {
        this.$store.dispatch("bearbeitungen/loadBearbeitungen");
      }
      var bearbeitungen = [];
      this.$store.getters["bearbeitungen/bearbeitungVonBbr"](this.localBbr.id).forEach(function (item) {
        var diff = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(item.dataNeu)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;

            var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 1);

            var key = _ref3[0];

            if (["zm", "chargen", "einstellungen", "notificationToken", "zuletztGeaendertAm", "zuletztGeaendertVon"].indexOf(key) === -1) {
              if (item.dataNeu[key] !== item.dataAlt[key]) {
                diff.push(key);
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        item.anders = diff;
        bearbeitungen.push(item);
      });
      return bearbeitungen;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    nachrichten: function nachrichten() {
      if (this.$store.state.mails.loaded === false) {
        this.$store.dispatch("mails/loadMails");
      }
      return this.$store.getters["mails/eigeneMails"](this.localBbr.id);
    },
    formatletzterLastschrifteinzug: function formatletzterLastschrifteinzug() {
      if (!this.localBbr.letzterLastschrifteinzug) return null;
      return new Date(this.localBbr.letzterLastschrifteinzug).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    formatmandatUnterschriftsdatum: function formatmandatUnterschriftsdatum() {
      if (!this.localBbr.mandatUnterschriftsdatum) return null;
      return new Date(this.localBbr.mandatUnterschriftsdatum).toLocaleString(["de-de"], {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    }
  },
  methods: {
    saveData: function saveData(value, feld) {
      console.log("saveData", feld, value);
      console.log(feld.value);
      console.log(this.bbr[feld.value]);
      this.bbr[feld.value] = value;
    },
    clickHochladenLastschriftmandat: function clickHochladenLastschriftmandat() {
      console.log("clickHochladenLastschriftmandat");
      this.loadingLaschriftmandatHochladen = true;
      window.addEventListener("focus", function () {}, { once: true });

      this.$refs.uploader.click();
    },
    onFileChanged: function onFileChanged(e) {
      var _this2 = this;

      this.selectedFile = e.target.files[0];
      var fileName = this.localBbr.id;
      var storagePath = "/sepaLastschriftmandat/" + this.$vars.verbindung + "/";
      var storageRef = this.$firebase.storage().ref(storagePath + fileName).put(this.selectedFile);
      storageRef.on("state_changed", function (snapshot) {
        console.log(snapshot.bytesTransferred / snapshot.totalBytes * 100);
      }, function (error) {
        console.log(error.message);
      }, function () {
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this2.localBbr.sepaLastschriftmandat = {
            url: url,
            date: new Date(),
            name: "SEPA-Lastschrift-" + _this2.localBbr.nachname + "-" + _this2.localBbr.vorname
          };
          _this2.loadingLaschriftmandatHochladen = false;
        });
      });
    },
    downloadLastschrift: function downloadLastschrift(file) {
      var link = document.createElement("a");
      link.setAttribute("href", file.url);
      link.setAttribute("download", file.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    changeLoginAllow: function changeLoginAllow() {
      var _this3 = this;

      console.log("changeLoginAllow");
      this.loading = true;
      this.checkMailValue = { status: null };
      var functions = this.$firebase.functions();
      functions.httpsCallable("changeLoginAllow")({ email: this.localBbr.email.toLowerCase(), sub: this.$vars.verbindung }).then(function (_ref4) {
        var data = _ref4.data;

        _this3.loading = false;
        _this3.checkMailValue = data;
      }).catch(function (error) {
        console.log(error);
        _this3.error = error;
        _this3.loading = false;
      });
    },
    previewImage: function previewImage(event) {
      this.message = "";
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event;
      this.onUpload();
    },
    deleteKontakt: function deleteKontakt() {
      this.localBbr.delete = true;
      this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
      this.showDeleteKontakt = false;
      this.showBbr = false;
      this.localBbr = [];
    },
    calcMandatsreferenz: function calcMandatsreferenz() {
      this.localBbr.mandatsreferenz = (this.localBbr.vorname.slice(0, 3) + this.localBbr.nachname.slice(0, 3) + Math.floor(Math.random() * 90000000 + 10000000)).toUpperCase();
      this.localBbr.mandatsreferenz = this.localBbr.mandatsreferenz.replace(/[^A-Z0-9]/g, "");
    },
    saveBbr: function saveBbr() {
      var _this4 = this;

      this.localBbr.sepa = this.sepa;
      console.log(this.localBbr);
      if (this.localBbr.adresse) {
        var link = "https://nominatim.openstreetmap.org/search.php?q=";
        if (this.localBbr.adresse) {
          link = link + this.localBbr.adresse.replaceAll(" ", "%20") + "+";
        }
        if (this.localBbr.ort) {
          link = link + this.localBbr.ort.replaceAll(" ", "%20") + "+";
        }
        if (this.localBbr.plz) {
          link = link + String(this.localBbr.plz).replaceAll(" ", "%20") + "+";
        }
        if (this.localBbr.land) {
          link = link + this.localBbr.land.replaceAll(" ", "%20") + "+";
        }
        link = link + "&format=jsonv2";
        fetch(link).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data[0].lat) {
            _this4.localBbr.x = data[0].lat;
          }
          if (data[0].lon) {
            _this4.localBbr.y = data[0].lon;
          }
          _this4.$store.dispatch("bbrbbr/updateBbrData", _this4.localBbr);
          _this4.$emit("close", false);
          _this4.showBbr = false;
          _this4.localBbr = [];
        }).catch(function () {
          _this4.$store.dispatch("bbrbbr/updateBbrData", _this4.localBbr);
          _this4.$emit("close", false);
          _this4.showBbr = false;
          _this4.localBbr = [];
        });
      } else {
        this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
        this.$emit("close", false);
        this.showBbr = false;
        this.localBbr = [];
      }
    },
    checkIban: function checkIban() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this5.localBbr.iban) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 1;

                _this5.loading_checkIban = true;
                url = "https://openiban.com/validate/" + _this5.localBbr.iban + "?getBIC=true&validateBankCode=true";
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios__["a" /* default */].get(url);

              case 6:
                response = _context.sent;

                if (response.data.valid) {
                  _this5.localBbr.bic = response.data.bankData.bic;
                  _this5.fehlerSepa.sepa = null;
                } else {
                  _this5.localBbr.bic = "";
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.sepa).forEach(function (key) {
                    _this5.sepa[key] = false;
                  });
                  _this5.fehlerSepa.sepa = "Die IBAN ist nicht korrekt.";
                }
                _this5.loading_checkIban = false;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                console.error("Fehler beim Abrufen der IBAN:", _context.t0);
                _this5.loading_checkIban = false;

              case 15:
                _context.next = 18;
                break;

              case 17:
                _this5.localBbr.bic = "";

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5, [[1, 11]]);
      }))();
    },
    onUpload: function onUpload() {
      var _this6 = this;

      this.uploadStatus = {
        img_upload: false,
        img_url1: null,
        img_url2: null,
        img_url3: null,
        error: ""
      };
      this.img1 = null;
      var img2 = null;
      var img3 = null;
      var storageRef = this.$firebase.storage().ref("/ahnengalerie/" + (this.localBbr.rbonummer + this.localBbr.nachname + this.localBbr.vorname)).put(this.imageData);
      storageRef.on("state_changed", function (snapshot) {
        _this6.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      }, function (error) {
        _this6.uploadStatus.error = error.message;
      }, function () {
        _this6.uploadStatus.img_upload = true;
        _this6.uploadValue = 100;
        _this6.uploadStatus.img_url1 = false;
        storageRef.snapshot.ref.getDownloadURL().then(function (url) {
          _this6.img1 = url;
          _this6.localBbr.bildAhnengalerie = _this6.img1;
          _this6.uploadStatus.img_url1 = true;
          _this6.uploadStatus.img_url2 = false;
          setTimeout(function () {
            console.log(storageRef.snapshot.ref.fullPath);

            _this6.$firebase.storage().ref(storageRef.snapshot.ref.fullPath + "_200x200").getDownloadURL().then(function (url) {
              _this6.uploadStatus.img_url2 = true;
              _this6.uploadStatus.img_url3 = false;
              img2 = url;
              _this6.localBbr.bildAhnengalerie200 = img2;
              _this6.$firebase.storage().ref(storageRef.snapshot.ref.fullPath + "_500x500").getDownloadURL().then(function (url) {
                _this6.uploadStatus.img_url3 = true;
                img3 = url;
                _this6.localBbr.bildAhnengalerie500 = img3;
                _this6.$store.dispatch("bbrbbr/updateBbrData", _this6.localBbr);
                _this6.message = "Upload erfolgreich";
                _this6.selectPicture = "";
              }).catch(function (error) {
                _this6.uploadStatus.error = error;
              });
            }).catch(function (error) {
              _this6.uploadStatus.error = error;
            });
          }, 2000);
        });
      });
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["visible", "selectedKontakte"],
  data: function data() {
    return {
      loading: false,
      showUpdate: false,
      updatedItems: 0,
      allItems: 0,
      error: [],
      itemsBriefanrede: ["Lieber Bundesbruder", "Sehr geehrter Cartellbruder", "Sehr geehrter Farbenbruder", "Sehr geehrter Herr", "Sehr geehrte Frau", "Sehr geehrte Damen und Herren"],
      itemsAnrede: ["Herr", "Frau", "Familie"],
      selectVerbindung: ["V.K.Th. Burgundia im Albertinum", "AV Alania Stuttgart", "AV Alsatia Münster", "AV Cheruscia Münster", "AV Cheruskia Tübingen", "AV Frisia Hannover", "AV Glückauf-Salia Clausthal-Zellerfeld", "AV Guestfalia Tübingen", "AV Hansea (Berlin) Köln", "AV Palatia Göttingen", "AV Rheinstein Köln", "AV Rheno-Guestfalia Kiel", "AV Salia-Silesia Gleiwitz", "AV Silesia (Halle, Bonn) Bochum", "AV Sparrenberg Bielefeld", "AV Suebo-Danubia Ulm", "AV Tuisconia (Königsberg, Bonn) Landshut", "AV Widukind Osnabrück", "AV Zollern Münster", "CV-Verbindung Rheno-Palatia (Breslau) Mainz", "FAV Rheno-Guestfalia (Hann. Münden) Göttingen", "KAV Capitolina Rom", "KAV Suevia Berlin", "KDStV Adolphiana Fulda", "KDStV Aenania München", "KDStV Agilolfia Freising", "KDStV Alania Bonn", "KDStV Alcimonia Eichstätt", "KDStV Alemannia Greifswald und Münster", "KDStV Algovia Augsburg", "KDStV Angrivaria (Sarstedt, Hannover) Dortmund", "KDStV Arminia Freiburg im Breisgau", "KDStV Arminia Heidelberg", "KDStV Ascania Bonn", "KDStV Asgard (Düsseldorf) Köln", "KDStV Aureo-Danubia Ingolstadt", "KDStV Badenia (Straßburg) Frankfurt am Main", "KDStV Baltia (Danzig) Aachen", "KDStV Bavaria Berlin", "KDStV Bavaria Bonn", "KDStV Bergisch-Thuringia Wuppertal", "KDStV Bergland (Freiberg) Aachen", "KDStV Bodensee Konstanz", "KDStV Borusso-Saxonia Berlin", "KDStV Borusso-Westfalia Bonn", "KDStV Burgundia (Leipzig) Düsseldorf", "KDStV Burgundia München", "KDStV Carolingia Hohenheim", "KDStV Carolus Magnus Saarbrücken", "KDStV Cheruscia Würzburg", "KDStV Churpfalz Mannheim", "KDStV Chursachsen Dresden", "KDStV Churtrier Trier", "KDStV Elbmark (Tetschen-Liebwerd) Duisburg", "KDStV Falkenstein Freiburg im Breisgau", "KDStV Ferdinandea (Prag) Heidelberg", "KDStV Franco-Raetia Würzburg", "KDStV Franconia Aachen", "KDStV Frankonia (Czernowitz) Erlangen", "KDStV Fredericia Bamberg", "KDStV Germania Leipzig", "KDStV Gothia Erlangen", "KDStV Gothia Würzburg", "KDStV Greiffenstein (Breslau) Frankfurt", "KDStV Guestfalo-Silesia Paderborn", "KDStV Hasso-Nassovia Frankfurt am Main", "KDStV Hercynia Freiburg im Breisgau", "KDStV Hohenstaufen Freiburg im Breisgau", "KDStV Kaiserpfalz Aachen", "KDStV Langobardia (München) Bayreuth", "KDStV Makaria (Berlin) Aachen", "KDStV Marchia (Breslau) Aachen", "KDStV Markomannia Würzburg", "KDStV Merowingia Kaiserslautern", "KDStV Moenania München", "KDStV Moeno-Franconia Frankfurt am Main", "KDStV Nassovia Darmstadt", "KDStV Nibelungia (Brünn) Darmstadt", "KDStV Niedersachsen Braunschweig", "KDStV Norbertina Magdeburg", "KDStV Nordgau (Prag, Stuttgart) Koblenz", "KDStV Nordmark (Rostock, Karlsruhe) Essen", "KDStV Normannia Karlsruhe", "KDStV Novesia Bonn", "KDStV Oeno-Danubia Passau", "KDStV Ostmark Nürnberg", "KDStV Palatia Marburg", "KDStV Palatina Amberg/Weiden", "KDStV Radaspona (Regensburg) München", "KDStV Rappoltstein (Straßburg) Köln", "KDStV Rheinland Köln", "KDStV Rheinpfalz Darmstadt", "KDStV Rhenania-Moguntia Mainz", "KDStV Rheno-Baltia Köln", "KDStV Rheno-Franconia München", "KDStV Rheno-Saxonia (Köthen) Halle", "KDStV Ripuaria Aachen", "KDStV Ripuaria Bonn", "KDStV Ripuaria Freiburg im Breisgau", "KDStV Rupertia Regensburg", "KDStV Saarland (Saarbrücken) Jena", "KDStV Sauerlandia Münster", "KDStV Saxo-Silesia Hannover", "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum", "KDStV Schwarzwald Karlsruhe", "KDStV Seraphina Lippstadt", "KDStV Staufia Bonn", "KDStV Sugambria (Jena) Göttingen", "KDStV Teuto-Rhenania Hannover", "KDStV Teutonia Freiburg im Üechtland", "KDStV Thuringia Würzburg", "KDStV Trifels München", "KDStV Tuiskonia München", "KDStV Vandalia (Prag) München", "KDStV Vasgovia Landau", "KDStV Vindelicia München", "KDStV Welfia Weingarten", "KDStV Wiking Hamburg", "KDStV Wildenstein Freiburg im Breisgau", "KDStV Winfridia (Breslau) Münster", "KStV Thuringia Coburg", "KTV Visurgis Bremen", "VKDSt Hasso-Rhenania Gießen", "VKDSt Hasso-Rhenania Mainz", "VKDSt Rhenania Marburg", "VKDSt Saxonia Münster"],
      itemsZirkel: ["Aachen", "Berlin", "Bonn/Köln", "Düsseldorf/Neuss", "Essen", "Koblenz", "München", "Niederrhein"],
      bearbeiteteFelder: {
        sepa: {}
      }
    };
  },

  computed: {
    kontakte: function kontakte() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    bezMitglieder: function bezMitglieder() {
      return this.$store.getters["einstellungen/einstellung"]("allgemein").bezMitglieder;
    },
    kassen: function kassen() {
      return this.$store.state.einstellungen.einstellungen.find(function (item) {
        return item.id === "kassen";
      });
    },
    itemsStatus: function itemsStatus() {
      var status = [];
      this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach(function (item) {
        status.push(item.status);
      });
      return status;
    }
  },
  methods: {
    updateData: function updateData() {
      var _this = this;

      this.showUpdate = true;
      var functions = this.$firebase.functions();
      var items = [];
      if (this.bearbeiteteFelder.alleBearbeiten === "true") {
        this.kontakte.forEach(function (kontakt) {
          items.push(kontakt.id);
        });
      } else {
        items = this.selectedKontakte;
      }
      this.updatedItems = 0;
      this.allItems = items.length;
      items.forEach(function (id) {
        var bbr = _this.$store.getters["bbrbbr/bbr"](id);
        if (_this.bearbeiteteFelder.anrede) {
          bbr.anrede = _this.bearbeiteteFelder.anrede;
        }
        if (_this.bearbeiteteFelder.briefanrede) {
          bbr.briefanrede = _this.bearbeiteteFelder.briefanrede;
        }
        if (_this.bearbeiteteFelder.urverbindung) {
          bbr.urverbindung = _this.bearbeiteteFelder.urverbindung;
        }
        if (_this.bearbeiteteFelder.zirkel) {
          bbr.zirkel = _this.bearbeiteteFelder.zirkel;
        }
        if (_this.bearbeiteteFelder.status) {
          bbr.status = _this.bearbeiteteFelder.status;
        }
        if (_this.bearbeiteteFelder.aktivenBeitrag) {
          bbr.aktivenBeitrag = _this.bearbeiteteFelder.aktivenBeitrag;
        }
        if (_this.bearbeiteteFelder.cvBeitrag) {
          bbr.cvBeitrag = _this.bearbeiteteFelder.cvBeitrag;
        }
        if (_this.bearbeiteteFelder.ahvBeitrag) {
          bbr.ahvBeitrag = _this.bearbeiteteFelder.ahvBeitrag;
        }
        if (_this.bearbeiteteFelder.hbvBeitrag) {
          bbr.hbvBeitrag = _this.bearbeiteteFelder.hbvBeitrag;
        }
        if (_this.bearbeiteteFelder.sepa_bearbeiten) {
          if (bbr.sepa === undefined) {
            bbr.sepa = {};
          }
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.bearbeiteteFelder.sepa).forEach(function (key) {
            if (_this.bearbeiteteFelder.sepa[key] !== null) {
              bbr.sepa[key] = _this.bearbeiteteFelder.sepa[key];
            }
          });
        }
        functions.httpsCallable("updateUser")({ user: bbr, verein: _this.$vars.verbindung }).then(function (result) {
          if (result.data.status) {
            _this.updatedItems++;
            if (_this.updatedItems === _this.allItems) {
              _this.showUpdate = false;
              _this.close();
            }
          } else {
            _this.error.push(result.data);
          }
        }).catch(function (error) {
          console.log(error);
        });
      });
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["nachricht", "visible"],
  data: function data() {
    return {
      attachments: []
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    }
  },
  methods: {
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["bbr", "visible", "copynachricht"],
  data: function data() {
    return {
      apiSettings: "Schreibe eine ausführliche Einladungsmail der nächsten Veranstaltung der Studentenverbindung Ripuaria, unserer Abkneipe, am 27. Januar 2022. Duze den Empfänger und schreibe ihn mit Lieber Bundesbruder an.",
      attachments: [],
      showAPISettings: false,
      showcc: false,
      showbcc: false,
      showan_adresse: false,
      showVorschau: false,
      uploadStatus: [],
      anhange: [],
      imgFile: null,
      loading: false,
      isSelecting: false,
      uploadedFiles: [],
      isSendDisabled: true,
      nachricht: {
        an: [],
        cc: [],
        bcc: [],
        an_adresse: [],
        gruppen: [],
        message: {},
        absender: {},
        anhang: []
      }
    };
  },

  watch: {
    copynachricht: {
      handler: function handler(newValue) {
        this.nachricht.an = newValue.message.an ? newValue.message.an : "";
        this.nachricht.cc = newValue.message.cc ? newValue.message.cc : "";
        this.nachricht.bcc = newValue.message.bcc ? newValue.message.bcc : "";
        this.nachricht.gruppen = newValue.message.gruppen ? newValue.message.gruppen : "";
        this.attachments = newValue.message.attachments ? newValue.message.attachments : "";
        this.nachricht.absender = newValue.message.absender ? newValue.message.absender : "";
        this.nachricht.betreff = newValue.message.subject ? newValue.message.subject : "";
        this.nachricht.template = newValue.template ? newValue.template : "";
        this.nachricht.text = newValue.message.text ? newValue.message.text.replace(/<br>/g, "\n") : "";
      },
      deep: true
    }
  },
  computed: {
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    absenderData: function absenderData() {
      return this.$store.getters["bbrbbr/bbr"](this.currentBbr);
    },
    bundesbruder: function bundesbruder() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    bbrbbr: function bbrbbr() {
      var bbrbbr = [];
      this.$store.state.bbrbbr.bbrbbr.forEach(function (bbr) {
        bbrbbr.push({
          id: bbr.id,
          value: bbr.id,
          name: bbr.nachname + ", " + bbr.vorname,
          text: bbr.nachname + ", " + bbr.vorname
        });
      });
      return bbrbbr;
    },
    replyTo: function replyTo() {
      var _this = this;

      if (this.nachricht.absenderPosition) {
        return this.$store.getters["einstellungen/einstellung"]("rollen").seiten.find(function (item) {
          return item.titel === _this.nachricht.absenderPosition;
        }).sendMail.replyTo;
      }
    },
    replyToMail: function replyToMail() {
      var _this2 = this;

      if (this.nachricht.absenderPosition) {
        if (this.replyTo === "absender") {
          return this.absenderData.email;
        }
        if (this.replyTo === "from") {
          return this.$store.getters["einstellungen/einstellung"]("rollen").seiten.find(function (item) {
            return item.titel === _this2.nachricht.absenderPosition;
          }).sendMail.adresse;
        }
      }
    },
    absender: function absender() {
      var _this3 = this;

      var absender = [];
      var rollen = this.$store.getters["einstellungen/einstellung"]("rollen");
      rollen.seiten.forEach(function (rolle) {
        if (rolle.berechtigt.indexOf(_this3.currentBbr) !== -1) {
          if (rolle.sendMail.adresse && rolle.sendMail.passwort) {
            absender.push(rolle.titel);
          }
        }
      });
      if (absender.length === 1) {
        this.nachricht.absenderPosition = absender[0];
      }
      return absender;
    },
    nachrichtVorschau: function nachrichtVorschau() {
      if (this.showVorschau) {
        var template = this.nachricht.template;
        var absenderData = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
        var absender = {
          vorname: absenderData.vorname || "",
          nachname: absenderData.nachname || "",
          adresse: absenderData.adresse || "",
          plz: absenderData.plz || "",
          ort: absenderData.ort || "",
          email: this.replyToMail || "",
          handy: absenderData.handy || "",
          telefon: absenderData.telefon || ""
        };
        absender.position = this.nachricht.absenderPosition;

        template = template.replace(/<<nachricht.titel>>/g, this.nachricht.betreff);
        template = template.replace(/<<nachricht.inhalt>>/g, this.nachricht.text.replace(/(?:\r\n|\r|\n)/g, "<br>"));
        template = template.replace(/<<absender.vorname>>/g, absender.vorname);
        template = template.replace(/<<absender.nachname>>/g, absender.nachname);
        template = template.replace(/<<absender.name>>/g, absender.vorname + " " + absender.nachname);
        template = template.replace(/<<absender.adresse>>/g, absender.adresse);
        template = template.replace(/<<absender.plz>>/g, absender.plz);
        template = template.replace(/<<absender.ort>>/g, absender.ort);
        template = template.replace(/<<absender.email>>/g, absender.email);
        template = template.replace(/<<absender.handy>>/g, absender.handy);
        template = template.replace(/<<absender.telefon>>/g, absender.telefon);
        template = template.replace(/<<absender.position>>/g, absender.position);
        template = template.replace(/<<Veranstaltungen>>/g, "Beim Versenden werden hier die kommenden drei Veranstaltungen eingefügt.");

        return template;
      }
    },
    templates: function templates() {
      var templates = [];
      var items = this.$store.getters["einstellungen/einstellung"]("templates");
      if (items.templates) {
        items.templates.forEach(function (item) {
          if (item.kategorie === "Mail") {
            templates.push({
              text: item.name,
              value: item.html
            });
          }
        });
      }
      return templates;
    },
    gruppen: function gruppen() {
      var gruppen = [];
      var id = 0;
      var items = this.$store.getters["einstellungen/einstellung"]("gruppen");
      if (items.gruppen) {
        items.gruppen.forEach(function (item) {
          item.gruppen.forEach(function (gruppe) {
            gruppen.push({
              id: id,
              bedingungen: gruppe.bedingungen,
              value: gruppe.text,
              name: gruppe.text,
              text: gruppe.text
            });
            id++;
          });
        });
      }
      return gruppen;
    },
    kontakteAusGruppen: function kontakteAusGruppen() {
      var _this4 = this;

      var bbrbbr = [];
      if (this.nachricht.gruppen) {
        this.nachricht.gruppen.forEach(function (gruppenname) {
          var bedingungen = _this4.gruppen.find(function (gruppe) {
            return gruppenname === gruppe.text;
          }).bedingungen;
          _this4.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
            bedingungen.forEach(function (val) {
              console.log(val);
              if (typeof val.wert === "string") {
                val.wert = val.wert.split(",");
              }
              val.wert.forEach(function (valueWert) {
                if (Array.isArray(item[val.feld])) {
                  if (item[val.feld].indexOf(valueWert) !== -1) {
                    if (bbrbbr.indexOf(item) === -1) {
                      bbrbbr.push(item);
                    }
                  }
                } else {
                  if (valueWert === item[val.feld]) {
                    if (bbrbbr.indexOf(item) === -1) {
                      bbrbbr.push(item);
                    }
                  }
                }
              });
            });
          });
        });
      }
      return bbrbbr;
    }
  },
  methods: {
    makeTest: function makeTest() {
      this.nachricht.betreff = "Testmail + " + new Date().getTime();
      this.nachricht.text = "Testmail + " + new Date().getTime();
      this.nachricht.an_adresse = [];

      this.nachricht.an_adresse.push("benediktbreuer@t-online.de");
      this.nachricht.an_adresse.push("benediktbreuer@arcor.de");
      this.nachricht.an_adresse.push("breuerbe@gmail.com");
      this.nachricht.an_adresse.push("benedikt.breuer@gfsm-bonn.de");
    },
    handleFileImport: function handleFileImport() {
      var _this5 = this;

      this.isSelecting = true;
      window.addEventListener("focus", function () {
        _this5.isSelecting = false;
      }, { once: true });
      this.$refs.uploader.click();
      this.imgFile = null;
    },
    onFileChanged: function onFileChanged(e) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.uploadData(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(e.target.files));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    formatEmails: function formatEmails() {
      if (!this.nachricht.an_adresse) return;

      var rawInput = this.nachricht.an_adresse.join(",");

      rawInput = rawInput.replace(/[^a-zA-Z0-9@._%+-;, ]/g, "");

      var emails = rawInput.split(/[\s,;]+/).map(function (email) {
        return email.trim();
      }).filter(function (email) {
        return email.length > 0;
      }).filter(function (email, index, self) {
        return self.indexOf(email) === index;
      });
      emails = emails.filter(function (email) {
        return (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
        );
      });

      this.nachricht.an_adresse = emails;
    },
    checkIsSendDisabled: function checkIsSendDisabled() {
      this.isSendDisabled = !this.nachricht.text || !this.nachricht.betreff || !this.nachricht.absenderPosition || (!this.nachricht.an || this.nachricht.an.length === 0) && (!this.nachricht.an_adresse || this.nachricht.an_adresse.length === 0) && (!this.nachricht.cc || this.nachricht.cc.length === 0) && (!this.nachricht.bcc || this.nachricht.bcc.length === 0) && (!this.nachricht.gruppen || this.nachricht.gruppen.length === 0);
    },
    uploadData: function uploadData(files) {
      var _this7 = this;

      console.log("uploadData");
      console.log(files);
      var attachments = [];
      this.loading = true;
      this.uploadedFiles = files;
      console.log(this.loading);
      this.uploadStatus = Array(files.length).fill(0);

      files.forEach(function (file, index) {
        var fileName = file.name;
        var name = new Date().getTime() + file.name;
        var storageRef = _this7.$firebase.storage().ref("mailAnhange/" + name).put(file);

        storageRef.on("state_changed", function (snapshot) {
          var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;

          _this7.$set(_this7.uploadStatus, index, progress);

          _this7.uploadValue = progress;
          console.log(_this7.uploadStatus);
        }, function (error) {
          _this7.$set(_this7.uploadStatus, index, { error: error.message });
        }, function () {
          storageRef.snapshot.ref.getDownloadURL().then(function (url) {
            attachments.push({
              name: fileName,
              filename: fileName,
              path: url
            });

            if (_this7.uploadStatus.every(function (status) {
              return status === 100;
            })) {
              _this7.uploadedFiles = [];
              if (!Array.isArray(_this7.attachments)) {
                _this7.attachments = [];
              }
              while (attachments.length > 0) {
                var attachment = attachments.shift();
                _this7.attachments.push(attachment);
              }
              _this7.loading = false;
              console.log(_this7.loading);
              _this7.uploadValue = 0;
            }
          });
        });
      });
    },
    deleteFile: function deleteFile(index) {
      this.attachments.splice(index, 1);
    },
    sendMail: function sendMail() {
      var _this8 = this;

      console.log("sendMail");
      try {
        var betreff = this.nachricht.betreff;
        var text = this.nachricht.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        var from = this.$store.getters["bbrbbr/bbr"](this.currentBbr).email;
        var to = [];
        var cc = [];
        var bcc = [];
        var anGruppen = [];
        var absenderData = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
        var absender = {
          vorname: absenderData.vorname || "",
          nachname: absenderData.nachname || "",
          adresse: absenderData.adresse || "",
          plz: absenderData.plz || "",
          ort: absenderData.ort || "",
          email: this.replyToMail || "",
          handy: absenderData.handy || "",
          telefon: absenderData.telefon || ""
        };
        absender.position = this.nachricht.absenderPosition;
        if (this.nachricht.gruppen) {
          this.kontakteAusGruppen.forEach(function (item) {
            if (item.email) {
              bcc.push(item.email);

              anGruppen.push(item.id);
            }
          });
        }
        if (this.nachricht.an) {
          this.nachricht.an.forEach(function (item) {
            to.push(_this8.$store.getters["bbrbbr/bbr"](item).email);
          });
        }
        if (this.nachricht.cc) {
          this.nachricht.cc.forEach(function (item) {
            cc.push(_this8.$store.getters["bbrbbr/bbr"](item).email);
          });
        } else {
          this.nachricht.cc = [];
        }
        if (this.nachricht.bcc) {
          this.nachricht.bcc.forEach(function (item) {
            bcc.push(_this8.$store.getters["bbrbbr/bbr"](item).email);
          });
        } else {
          this.nachricht.bcc = [];
        }
        if (this.nachricht.an_adresse) {
          this.nachricht.an_adresse.forEach(function (item) {
            to.push(item);
          });
        }
        if (!this.nachricht.template) {
          this.nachricht.template = null;
        }
        console.log(this.nachricht);
        this.$store.dispatch("mails/createEinMails", {
          art: "mail",
          from: from,
          to: to,
          cc: cc,
          bcc: bcc,
          absender: absender,
          status: "Warte auf Versand..",
          gruppen: this.nachricht.gruppen ? this.nachricht.gruppen : [],
          von: this.currentBbr,
          an: this.nachricht.an,
          an_gruppen: anGruppen,
          an_adresse: this.nachricht.an_adresse,
          an_cc: this.nachricht.cc,
          an_bcc: this.nachricht.bcc,
          template: this.nachricht.template,
          message: {
            subject: betreff,
            text: text
          },
          attachments: this.attachments,
          datum: new Date()
        });
        this.close();
        this.nachricht = {
          an: [],
          cc: [],
          bcc: [],
          an_adresse: [],
          gruppen: [],
          message: {},
          absender: {}
        };
      } catch (error) {
        console.log(error);
        this.$vars.error.nachricht = "Beim Versenden der Mail ist ein Fehler aufgetreten.";
        this.$vars.error.error = error;
        this.$vars.error.show = true;
      }
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    nachricht: function nachricht() {
      return this.$store.state.nachricht;
    }
  },
  methods: {
    close: function close() {
      this.$store.state.nachricht.show = false;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["rechnungid", "visible"],
  data: function data() {
    return {
      loading: false,
      mahnungUpdateData: {
        rechnung_zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
        rechnung_freitext: "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in der <<Mahnstufe>>. Mahnung in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart"
      },
      showMahnung: false,
      selectMahngebuehr: false,
      artMahngebuehr: "Prozent",
      wertMahngebuehr: 10,
      showBearbeiten: false,
      showEditPosition: false,
      selectedPositionIndex: 0,
      neuePosition: {
        betrag: 0,
        positionen: []
      },
      statusItems: ["Entwurf", "Entwurf SEPA", "Offen", "Gezahlt"],
      bearbeiteRechnung: "",
      headersData: [{
        text: "",
        sortable: false,
        value: "index"
      }, { text: "Was", value: "was" }, { text: "Datum", value: "datum" }, { text: "Betrag", value: "preis" }, { text: "", value: "" }],
      logoUrl: null
    };
  },
  mounted: function mounted() {
    this.loadLogo();
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    settings: function settings() {
      return this.$store.getters["einstellungen/einstellung"]("allgemein");
    },
    allowRechnungBearbeiten: function allowRechnungBearbeiten() {
      var _this = this;

      var seiten = this.$store.getters["einstellungen/einstellung"]("rollen");
      var bbr = this.$store.state.bbrbbr.bbrbbr.find(function (d) {
        return d.anmeldeID === _this.$firebase.auth().currentUser.uid;
      });
      var variable = false;
      if (seiten !== undefined) {
        seiten.seiten.forEach(function (item) {
          if (item.titel === "Philisterquaestor" || item.titel === "Quaestor" || item.id === "Kassierer" || item.titel === "Kassierer" || item.id === "Bierwart" || item.gruppe === "Philisterkassierer" || item.gruppe === "HBV Kassierer") {
            if (item.berechtigt.indexOf(bbr.id) >= 0 || bbr.id === "PBChUyAy7HWowQR4HlP3") {
              variable = true;
            }
          }
        });
      }
      return variable;
    },
    selectBbrBbr: function selectBbrBbr() {
      var selectBbrBbr = [];
      this.$store.state.bbrbbr.bbrbbr.forEach(function (bbr) {
        selectBbrBbr.push({
          id: bbr.id,
          value: bbr.id,
          name: bbr.nachname + ", " + bbr.vorname,
          text: bbr.nachname + ", " + bbr.vorname
        });
      });
      return selectBbrBbr;
    },
    selectRechnung: function selectRechnung() {
      if (this.rechnungid) {
        var rechnung = void 0;
        rechnung = this.$store.getters["rechnungen/nutzerRechnung"](this.rechnungid);
        if (rechnung === undefined) {
          rechnung = this.$store.getters["rechnungen/rechnung"](this.rechnungid);
        }
        if (rechnung.positionen) {
          rechnung.positionen.forEach(function (position) {
            if (Array.isArray(position.positionen)) {
              var result = [];
              position.positionen.reduce(function (res, value) {
                if (!res[value.was]) {
                  res[value.was] = { datum: value.datum, anzahl: 0, was: value.was, preis: 0 };
                  result.push(res[value.was]);
                }
                res[value.was].preis += parseFloat(value.preis);
                res[value.was].anzahl++;
                return res;
              }, {});
              position.result = result;
              position.positionen.sort(function (a, b) {
                return a.datum.seconds - b.datum.seconds;
              });
            } else {
              position.positionen = [];
            }
          });
        }
        return rechnung;
      } else {
        var rechnungen = {
          rechnungsnummer: "",
          positionen: [],
          rechnung_datum: "",
          rechnung_freitext: "",
          rechnung_zahlbar_bis: "",
          bbr: ""
        };
        return rechnungen;
      }
    },
    summePosition: function summePosition() {
      var summe = 0;
      if (this.neuePosition.positionen.length > 0) {
        this.neuePosition.positionen.forEach(function (item) {
          summe += parseFloat(item.preis);
        });
      } else {
        summe = parseFloat(this.neuePosition.betrag);
      }
      this.neuePosition.betrag = summe.toFixed(2);
      return summe;
    }
  },
  methods: {
    loadLogo: function loadLogo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.logoImage();

              case 3:
                url = _context.sent;

                _this2.logoUrl = url;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error("Error loading logo:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    logoImage: function logoImage() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                storagePath = "/design/logo/" + _this3.$vars.verbindung;
                _context2.next = 4;
                return _this3.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context2.sent;
                return _context2.abrupt("return", url);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8]]);
      }))();
    },
    savePosition: function savePosition() {
      this.bearbeiteRechnung.positionen[this.selectedPositionIndex] = this.neuePosition;
      var summe = 0;
      this.bearbeiteRechnung.positionen.forEach(function (item) {
        summe += parseFloat(item.betrag);
      });
      this.bearbeiteRechnung.summe = summe.toFixed(2);
      this.showEditPosition = false;
    },
    neuerStatus: function neuerStatus(selectRechnung, status) {
      if (status === "") {
        return;
      } else {
        selectRechnung.status = status;
        this.$store.dispatch("rechnungen/updateRechnungData", selectRechnung);
      }
    },
    ersetzeText: function ersetzeText(text, rechnung) {
      var summe = 0;
      rechnung.positionen.forEach(function (position) {
        summe = parseFloat(summe) + parseFloat(position.betrag);
      });
      text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
      text = text.replace("<<Rechnungsdatum>>", new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
      text = text.replace("<<Mahnstufe>>", rechnung.mahnstufe);
      text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
      text = text.replace("<<Vorname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).vorname);
      text = text.replace("<<Nachname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).nachname);
      text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
      text = text.replace("<<Zahlbar_bis>>", new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      return text;
    },
    mahnen: function mahnen(selectRechnung, status) {
      if (this.selectMahngebuehr) {
        var betrag = void 0;
        if (this.artMahngebuehr === "Betrag") {
          betrag = parseFloat(this.wertMahngebuehr).toFixed(2);
        }
        if (this.artMahngebuehr === "Prozent") {
          betrag = parseFloat(selectRechnung.summe / 100 * parseFloat(this.wertMahngebuehr)).toFixed(2);
        }
        if (!selectRechnung.mahnstufe) {
          selectRechnung.mahnstufe = 1;
        } else {
          selectRechnung.mahnstufe++;
        }
        selectRechnung.positionen.push({
          was: selectRechnung.mahnstufe + ". Mahnung",
          betrag: betrag
        });
        selectRechnung.summe = (parseFloat(selectRechnung.summe) + parseFloat(betrag)).toFixed(2);
        selectRechnung.summe = parseFloat(selectRechnung.summe);
      }
      selectRechnung.rechnung_zahlbar_bis = this.mahnungUpdateData.rechnung_zahlbar_bis;
      selectRechnung.rechnung_titel = selectRechnung.rechnung_titel;
      selectRechnung.status = "Mahnung";
      selectRechnung.rechnung_freitext = this.ersetzeText(this.mahnungUpdateData.rechnung_freitext, selectRechnung);
      this.$store.dispatch("rechnungen/updateRechnungData", selectRechnung);
      this.rechnungVersenden();
      this.showMahnung = false;
      this.visible = false;
    },
    updateRechnungData: function updateRechnungData() {
      this.showBearbeiten = false;
      this.bearbeiteRechnung.summe = parseFloat(this.bearbeiteRechnung.summe);
      this.$store.dispatch("rechnungen/updateRechnungData", this.bearbeiteRechnung);
      this.bearbeiteRechnung = "";
    },
    rechnungVersenden: function rechnungVersenden() {
      var rechnung = this.selectRechnung;
      if (rechnung.farbe === undefined) {
        rechnung.farbe = "";
      }
      rechnung.rechnung_freitext_code = rechnung.rechnung_freitext.replace(/(?:\r\n|\r|\n)/g, "<br>");
      var bundesbruder = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
      var absender = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
      var position = null;
      if (this.$route.params.seite !== undefined) {
        position = this.$route.params.seite;
      }
      if (bundesbruder.email) {
        this.$store.dispatch("mails/createEinMails", {
          art: "rechnung",
          rechnung: rechnung,
          to: [bundesbruder.email],
          an: [bundesbruder.id],
          absender: {
            position: position,
            name: absender.vorname + " " + absender.nachname,
            adresse: absender.adresse,
            plz: absender.plz,
            ort: absender.ort,
            email: absender.email,
            telefon: absender.handy
          },
          message: {
            subject: rechnung.rechnung_titel,
            text: rechnung.rechnung_freitext_code
          },
          datum: new Date()
        });
        this.$store.state.snackbar = {
          show: true,
          nachricht: "Rechnung wurde per Mail versendet."
        };
      } else {
        this.printRechnung(this.selectRechnung);
        this.$store.state.snackbar = {
          show: true,
          nachricht: "Keine Mailadresse hinterlegt. Rechnung wurde als PDF gespeichert."
        };
      }
    },
    close: function close() {
      this.$emit("close", false);
    },
    printRechnung: function printRechnung(item) {
      var rechnung = item;
      var kasse = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
      var bbr = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
      var doc = new __WEBPACK_IMPORTED_MODULE_2_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
      doc.rect(0, 90, 210, 1, "F");
      if (this.$vars.verbindung === "rbo") {
        doc.setFillColor(this.settings.secondary.rgba.r, this.settings.secondary.rgba.g, this.settings.secondary.rgba.b);
        doc.rect(0, 92, 210, 1, "F");
        var img = new Image();
        img.src = this.logoUrl;
        doc.addImage(img, 125, 30, 75, 75);
      }
      doc.setFontSize(9);
      doc.text(this.settings.name + " | " + this.settings.strasse + " " + this.settings.hausnummer + " | " + this.settings.plz + " " + this.settings.ort, 25, 51);
      doc.setFontSize(11);
      if (bbr.titel) {
        doc.text(bbr.anrede + " " + bbr.titel, 25, 61);
      } else {
        doc.text(bbr.anrede, 25, 61);
      }
      doc.text(bbr.vorname + " " + bbr.nachname, 25, 66);
      doc.text(bbr.adresse, 25, 71);
      doc.text(bbr.plz + " " + bbr.ort, 25, 76);
      doc.text(bbr.land, 25, 81);
      doc.setFont("Times", "bold");
      doc.text("Rechnungsnr.", 20, 110);
      doc.text("Datum", 70, 110);
      if (rechnung.rechnung_art === "SEPA") {
        doc.text("Einzug am", 120, 110);
      } else {
        doc.text("Zahlbar bis", 120, 110);
      }
      doc.text("Kasse", 170, 110);
      doc.setFont("Times", "normal");
      doc.text(rechnung.rechnungsnummer, 20, 115);
      doc.text(new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }), 70, 115);
      doc.text(new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }), 120, 115);
      doc.text(rechnung.kasse, 170, 115);
      doc.setFont("Times", "bold");
      doc.text(rechnung.rechnung_titel, 210, 125);
      doc.setFont("Times", "normal");
      var lines1 = doc.splitTextToSize(rechnung.rechnung_freitext, 168);
      doc.text(lines1, 20, 130);
      var zeile = 130 + parseInt(parseInt(6) * lines1.length);
      doc.setFont("Times", "bold");
      zeile = parseInt(zeile) + 5;
      doc.text("Pos", 20, zeile);
      doc.text("Beschreibung", 31, zeile);
      doc.text("Betrag", 190, zeile, { align: "right" });
      doc.setFont("Times", "normal");
      zeile = parseInt(zeile) + 2;
      doc.line(20, zeile, 190, zeile);
      zeile = parseInt(zeile) + 6;
      var pos = "1";
      var summe = 0;
      rechnung.positionen.forEach(function (position) {
        doc.text(pos, 20, zeile);
        doc.text(position.was, 31, zeile);
        doc.text(parseFloat(position.betrag).toFixed(2) + " €", 190, zeile, { align: "right" });
        summe = summe + parseFloat(position.betrag);
        zeile = parseInt(zeile) + 10;
        pos = String(parseInt(pos) + 1);
      });
      doc.line(20, zeile - 4, 190, zeile - 4);
      doc.setFont("Times", "bold");
      zeile = parseInt(zeile) + 1;
      doc.text("Summe " + summe.toFixed(2) + " €", 190, zeile, { align: "right" });
      doc.setFont("Times", "normal");
      zeile = parseInt(zeile) + 2;
      doc.line(159, zeile, 190, zeile);
      zeile = parseInt(zeile) + 1;
      doc.line(159, zeile, 190, zeile);
      doc.setFontSize(9);

      doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
      doc.rect(0, 265, 210, 297, "F");
      doc.setFontSize(10);
      doc.setTextColor(230, 230, 230);
      doc.setFont("Times", "bold");
      doc.text(this.settings.name, 60, 272, { align: "center" });
      doc.setFont("Times", "normal");
      doc.text(rechnung.kasse, 60, 280, { align: "center" });
      doc.text(this.settings.strasse + " " + this.settings.hausnummer, 60, 285, { align: "center" });
      doc.text(this.settings.plz + " " + this.settings.ort, 60, 290, { align: "center" });
      doc.setFont("Times", "bold");
      doc.text("Bankverbindung", 150, 272, { align: "center" });
      doc.setFont("Times", "normal");
      doc.text(kasse.kontoname, 150, 280, { align: "center" });
      doc.text(kasse.IBAN, 150, 285, { align: "center" });
      doc.text(kasse.BIC, 150, 290, { align: "center" });

      doc.save("Rechnung-" + rechnung.rechnungsnummer + "-" + bbr.nachname + "-" + bbr.vorname + ".pdf");
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funktionen_generatePDFRechnungToLink_js__ = __webpack_require__(65);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["visible", "rechnungen"],
  data: function data() {
    return {
      timer: 0,
      intervalId: null,
      startTime: null,
      expanded: [],
      loading: false,
      createPDF: { gesamt: 0, erledigt: 0 },
      versendeRechnung: { gesamt: 0, erledigt: 0, rechnungen: [] },
      result: [],
      showLogFilter: true,
      headers: [{ text: "", value: "error" }, { text: "Rechnungsnummer", value: "rechnung" }, { text: "", value: "data-table-expand" }]
    };
  },

  computed: {
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    }
  },
  methods: {
    erneutVersuchen: function erneutVersuchen(rechnung) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.result.splice(_this.result.indexOf(rechnung), 1);
                _context.next = 3;
                return _this.rechnungVersenden([_this.rechnungen.find(function (item) {
                  return item.id === rechnung.rechnung;
                })]);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    rechnungVersenden: function rechnungVersenden(rechnungen) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var groupedPromises, batchSize, i, batch, promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _promises;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this2.startTimer();
                _this2.loading = true;
                _this2.versendeRechnung = {
                  gesamt: rechnungen.length,
                  erledigt: 0,
                  rechnungen: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(rechnungen))
                };
                console.log(_this2.versendeRechnung);
                groupedPromises = [];
                batchSize = 50;

                for (i = 0; i < rechnungen.length; i += batchSize) {
                  batch = rechnungen.slice(i, i + batchSize);
                  promises = batch.map(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(rechnung) {
                      var kasse, year, storagePath, file, bbr, settings, result, _rechnung;

                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              kasse = _this2.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
                              year = rechnung.rechnungsnummer.split("-")[0];
                              storagePath = "rechnungen/" + _this2.$vars.verbindung + "/" + year + "/" + rechnung.rechnungsnummer;
                              _context2.next = 6;
                              return _this2.$firebase.functions().httpsCallable("existsPDF")({
                                path: storagePath,
                                rechnung: rechnung,
                                kasse: kasse,
                                verein: _this2.$vars.verbindung
                              });

                            case 6:
                              file = _context2.sent;

                              if (file.data) {
                                _context2.next = 14;
                                break;
                              }

                              _this2.createPDF.gesamt++;
                              bbr = _this2.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
                              settings = _this2.$store.getters["einstellungen/einstellung"]("allgemein");
                              _context2.next = 13;
                              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funktionen_generatePDFRechnungToLink_js__["a" /* generatePDFRechnungToLink */])(rechnung, kasse, bbr, settings, _this2.$vars.verbindung);

                            case 13:
                              _this2.createPDF.erledigt++;

                            case 14:
                              _context2.next = 16;
                              return _this2.$firebase.functions().httpsCallable("sendRechnungen")({
                                rechnungen: [rechnung],
                                verein: _this2.$vars.verbindung
                              });

                            case 16:
                              result = _context2.sent;

                              if (!result.data[0].error) {
                                _rechnung = _this2.versendeRechnung.rechnungen.find(function (item) {
                                  return item.id === result.data[0].rechnung;
                                });

                                if (_rechnung.rechnung_art === "SEPA") {
                                  _rechnung.status = "Gezahlt";
                                }
                                if (_rechnung.rechnung_art === "Überweisung") {
                                  _rechnung.status = "Offen";
                                }
                                _this2.$store.dispatch("rechnungen/updateRechnungData", _rechnung);
                              }
                              _this2.versendeRechnung.erledigt++;
                              _this2.result.push(result.data[0]);
                              return _context2.abrupt("return", result.data);

                            case 23:
                              _context2.prev = 23;
                              _context2.t0 = _context2["catch"](0);

                              console.error("Fehler beim Versenden der Rechnung:", _context2.t0);
                              return _context2.abrupt("return", { error: true, message: _context2.t0.message });

                            case 27:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2, [[0, 23]]);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());

                  groupedPromises.push(promises);
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 11;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(groupedPromises);

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 20;
                  break;
                }

                _promises = _step.value;
                _context3.next = 17;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(_promises);

              case 17:
                _iteratorNormalCompletion = true;
                _context3.next = 13;
                break;

              case 20:
                _context3.next = 26;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 26:
                _context3.prev = 26;
                _context3.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context3.prev = 29;

                if (!_didIteratorError) {
                  _context3.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context3.finish(29);

              case 33:
                return _context3.finish(26);

              case 34:
                console.log(rechnungen[0]);
                console.log(rechnungen[0].rechnung_art === "SEPA");
                console.log(rechnungen.filter(function (rechnung) {
                  return rechnung.rechnung_art === "SEPA";
                }));
                if (rechnungen[0].rechnung_art === "SEPA") {
                  _this2.sepaGenerieren(rechnungen.filter(function (rechnung) {
                    return rechnung.rechnung_art === "SEPA";
                  }));
                }

                _this2.loading = false;
                _this2.stopTimer();
                _context3.next = 46;
                break;

              case 42:
                _context3.prev = 42;
                _context3.t1 = _context3["catch"](0);

                console.error("Fehler beim Versenden der Rechnungen:", _context3.t1);
                _this2.loading = false;

              case 46:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 42], [11, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    startTimer: function startTimer() {
      var _this3 = this;

      if (this.intervalId) return;
      this.intervalId = setInterval(function () {
        _this3.timer = new Date() - _this3.startTime;
      }, 1000);
      this.startTime = this.startTime > 0 ? this.startTime : new Date();
    },
    stopTimer: function stopTimer() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    sepaGenerieren: function sepaGenerieren(rechnungen) {
      var _this4 = this;

      console.log("sepaGenerieren");
      this.loading = true;
      var anzahlRechnungen = this.rechnungen.length;
      var summeRechnungen = 0;
      rechnungen.forEach(function (rechnung) {
        summeRechnungen = summeRechnungen + parseFloat(parseFloat(rechnung.summe).toFixed(2));
      });
      summeRechnungen = summeRechnungen.toFixed(2);
      var kassenInfo = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnungen[0].kasse];
      kassenInfo.IBAN = kassenInfo.IBAN.replace(/ /g, "");
      var nachrichtenID = "ID-1863-" + new Date().getTime();
      var nachrichtenErstellung = new Date().toISOString().substr(0, 24);
      var rechnungZahlbarBis = rechnungen[0].rechnung_zahlbar_bis;
      var xmltext = void 0;
      try {
        xmltext = '<?xml version="1.0" encoding="UTF-8"?>\n' + '<Document xmlns="urn:iso:std:iso:20022:tech:xsd:pain.008.001.02" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="urn:iso:std:iso:20022:tech:xsd:pain.008.001.02 pain.008.001.02.xsd"><CstmrDrctDbtInitn>\n' + "\t<GrpHdr>\n" + "\t\t<MsgId>" + nachrichtenID + "</MsgId>\n" + "\t\t<CreDtTm>" + nachrichtenErstellung + "</CreDtTm>\n" + "\t\t<NbOfTxs>" + anzahlRechnungen + "</NbOfTxs>\n" + "\t\t<CtrlSum>" + summeRechnungen + "</CtrlSum>\n" + "\t\t<InitgPty>\n" + "\t\t\t<Nm>" + kassenInfo.kontoname + "</Nm>\n" + "\t\t</InitgPty>\n" + "\t</GrpHdr>\n" + "\t<PmtInf>\n" + "\t\t<PmtInfId>" + nachrichtenID + "</PmtInfId>\n" + "\t\t<PmtMtd>DD</PmtMtd>\n" + "\t\t<BtchBookg>true</BtchBookg>\n" + "\t\t<NbOfTxs>" + anzahlRechnungen + "</NbOfTxs>\n" + "\t\t<CtrlSum>" + summeRechnungen + "</CtrlSum>\n" + "\t\t<PmtTpInf>\n" + "\t\t\t<SvcLvl>\n" + "\t\t\t\t<Cd>SEPA</Cd>\n" + "\t\t\t</SvcLvl>\n" + "\t\t\t<LclInstrm>\n" + "\t\t\t\t<Cd>CORE</Cd>\n" + "\t\t\t</LclInstrm>\n" + "\t\t\t<SeqTp>RCUR</SeqTp>\n" + "\t\t</PmtTpInf>\n" + "\t\t<ReqdColltnDt>" + rechnungZahlbarBis + "</ReqdColltnDt>\n" + "\t\t<Cdtr>\n" + "\t\t\t<Nm>" + kassenInfo.kontoname + "</Nm>\n" + "\t\t</Cdtr>\n" + "\t\t<CdtrAcct>\n" + "\t\t\t<Id>\n" + "\t\t\t\t<IBAN>" + kassenInfo.IBAN + "</IBAN>\n" + "\t\t\t</Id>\n" + "\t\t</CdtrAcct>\n" + "\t\t<CdtrAgt>\n" + "\t\t\t<FinInstnId>\n" + "\t\t\t\t<BIC>" + kassenInfo.BIC + "</BIC>\n" + "\t\t\t</FinInstnId>\n" + "\t\t</CdtrAgt>\n" + "\t\t<ChrgBr>SLEV</ChrgBr>\n" + "\t\t<CdtrSchmeId>\n" + "\t\t\t<Id>\n" + "\t\t\t\t<PrvtId>\n" + "\t\t\t\t\t<Othr>\n" + "\t\t\t\t\t\t<Id>" + kassenInfo.glaubigerID + "</Id>\n" + "\t\t\t\t\t\t<SchmeNm>\n" + "\t\t\t\t\t\t\t<Prtry>SEPA</Prtry>\n" + "\t\t\t\t\t\t</SchmeNm>\n" + "\t\t\t\t\t</Othr>\n" + "\t\t\t\t</PrvtId>\n" + "\t\t\t</Id>\n" + "\t\t</CdtrSchmeId>";

        rechnungen.forEach(function (rechnung) {
          var bundesbruder = _this4.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
          var betrag = parseFloat(rechnung.summe).toFixed(2);
          var EndToEndId = "RBO" + rechnung.rechnungsnummer;
          var MndtId = bundesbruder.mandatsreferenz.replace(/[^A-Z0-9]/g, "");
          var DtOfSgntr = bundesbruder.mandatUnterschriftsdatum;
          var AmdmntInd = "false";
          var BIC = bundesbruder.bic;
          var name = bundesbruder.kontoinhaber;
          var IBAN = bundesbruder.iban.replace(/ /g, "");
          var betreff = (rechnung.rechnung_titel + " " + rechnung.rechnungsnummer).replace(/[^\x00-\x7F]/g, "");
          rechnung.gezahlt_datum = new Date(rechnung.rechnung_zahlbar_bis);
          xmltext = xmltext + "\n" + "\t<DrctDbtTxInf>\n" + "\t\t<PmtId>\n" + "\t\t\t<EndToEndId>" + EndToEndId + "</EndToEndId>\n" + "\t\t</PmtId>\n" + '\t\t<InstdAmt Ccy="EUR">' + betrag + "</InstdAmt>\n" + "\t\t<DrctDbtTx>\n" + "\t\t\t<MndtRltdInf>\n" + "\t\t\t\t<MndtId>" + MndtId + "</MndtId>\n" + "\t\t\t\t<DtOfSgntr>" + DtOfSgntr + "</DtOfSgntr>\n" + "\t\t\t\t<AmdmntInd>" + AmdmntInd + "</AmdmntInd>\n" + "\t\t\t</MndtRltdInf>\n" + "\t\t</DrctDbtTx>\n" + "\t\t<DbtrAgt>\n" + "\t\t\t<FinInstnId>\n" + "\t\t\t\t<BIC>" + BIC + "</BIC>\n" + "\t\t\t</FinInstnId>\n" + "\t\t</DbtrAgt>\n" + "\t\t<Dbtr>\n" + "\t\t\t<Nm>" + name + "</Nm>\n" + "\t\t</Dbtr>\n" + "\t\t<DbtrAcct>\n" + "\t\t\t<Id>\n" + "\t\t\t\t<IBAN>" + IBAN + "</IBAN>\n" + "\t\t\t</Id>\n" + "\t\t</DbtrAcct>\n" + "\t\t<RmtInf>\n" + "\t\t\t<Ustrd>" + betreff + "</Ustrd>\n" + "\t\t</RmtInf>\n" + "\t</DrctDbtTxInf>";
        });

        xmltext = xmltext + "\n" + "\t</PmtInf>\n" + "</CstmrDrctDbtInitn>\n" + "</Document>";
      } catch (err) {
        console.error(err);
        this.$store.state.nachricht.typ = "error";
        this.$store.state.nachricht.nachricht = "Die Erstellung der SEPA-Datei hat nicht geklappt.";
        this.$store.state.nachricht.error = err;
        this.$store.state.nachricht.show = true;
      }
      var filename = new Date().toISOString().substr(0, 10) + "-" + new Date().toISOString().substr(11, 8) + "_sepa_" + rechnungen[0].kasse + ".xml";

      var pom = document.createElement("a");
      pom = document.createElement("a");
      var bb = new Blob([xmltext], { type: "text/plain" });
      pom.setAttribute("href", window.URL.createObjectURL(bb));
      pom.setAttribute("download", filename);
      pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
      pom.draggable = true;
      pom.classList.add("dragout");
      pom.click();
      console.log(summeRechnungen);
      this.$store.dispatch("sepa/createEinSepa", {
        date: new Date(),
        xml: xmltext,
        filename: filename,
        summe: summeRechnungen,
        anzahl: anzahlRechnungen,
        kasse: kassenInfo.kontoname
      });
      this.loading = false;
      this.progressSendSepa = 0;
      this.stepperSendRechnungen = 2;
    },
    close: function close() {
      this.$emit("close", false);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["bbr", "visible", "copynachricht"],
  data: function data() {
    return {
      apiSettings: "Schreibe eine ausführliche Einladungsmail der nächsten Veranstaltung der Studentenverbindung Ripuaria, unserer Abkneipe, am 27. Januar 2022. Duze den Empfänger und schreibe ihn mit Lieber Bundesbruder an.",
      attachments: [],
      showAPISettings: false,
      showcc: false,
      showbcc: false,
      showan_adresse: false,
      showVorschau: false,
      uploadStatus: [],
      anhange: [],
      imgFile: null,
      loading: false,
      isSelecting: false,
      uploadedFiles: [],
      nachricht: {
        an: [],
        cc: [],
        bcc: [],
        an_adresse: [],
        gruppen: [],
        message: {},
        absender: {},
        anhang: []
      }
    };
  },

  watch: {
    copynachricht: {
      handler: function handler(newValue) {
        this.nachricht.an = newValue.message.an ? newValue.message.an : "";
        this.nachricht.cc = newValue.message.cc ? newValue.message.cc : "";
        this.nachricht.bcc = newValue.message.bcc ? newValue.message.bcc : "";
        this.nachricht.gruppen = newValue.message.gruppen ? newValue.message.gruppen : "";
        this.attachments = newValue.message.attachments ? newValue.message.attachments : "";
        this.nachricht.absender = newValue.message.absender ? newValue.message.absender : "";
        this.nachricht.betreff = newValue.message.subject ? newValue.message.subject : "";
        this.nachricht.template = newValue.template ? newValue.template : "";
        this.nachricht.text = newValue.message.text ? newValue.message.text.replace(/<br>/g, "\n") : "";
      },
      deep: true
    }
  },
  computed: {
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    absenderData: function absenderData() {
      return this.$store.getters["bbrbbr/bbr"](this.currentBbr);
    },
    bundesbruder: function bundesbruder() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    bbrbbr: function bbrbbr() {
      var bbrbbr = [];
      this.$store.state.bbrbbr.bbrbbr.forEach(function (bbr) {
        bbrbbr.push({
          id: bbr.id,
          value: bbr.id,
          name: bbr.nachname + ", " + bbr.vorname,
          text: bbr.nachname + ", " + bbr.vorname
        });
      });
      return bbrbbr;
    },
    replyTo: function replyTo() {
      var _this = this;

      if (this.nachricht.absenderPosition) {
        return this.$store.getters["einstellungen/einstellung"]("rollen").seiten.find(function (item) {
          return item.titel === _this.nachricht.absenderPosition;
        }).sendMail.replyTo;
      }
    },
    replyToMail: function replyToMail() {
      var _this2 = this;

      if (this.nachricht.absenderPosition) {
        if (this.replyTo === "absender") {
          return this.absenderData.email;
        }
        if (this.replyTo === "from") {
          return this.$store.getters["einstellungen/einstellung"]("rollen").seiten.find(function (item) {
            return item.titel === _this2.nachricht.absenderPosition;
          }).sendMail.adresse;
        }
      }
    },
    absender: function absender() {
      var _this3 = this;

      var absender = [];
      var rollen = this.$store.getters["einstellungen/einstellung"]("rollen");
      rollen.seiten.forEach(function (rolle) {
        if (rolle.berechtigt.indexOf(_this3.currentBbr) !== -1) {
          if (rolle.sendMail.adresse && rolle.sendMail.passwort) {
            absender.push(rolle.titel);
          }
        }
      });
      if (absender.length === 1) {
        this.nachricht.absenderPosition = absender[0];
      }
      return absender;
    },
    nachrichtVorschau: function nachrichtVorschau() {
      if (this.showVorschau) {
        var template = this.nachricht.template;
        var absenderData = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
        var absender = {
          vorname: absenderData.vorname || "",
          nachname: absenderData.nachname || "",
          adresse: absenderData.adresse || "",
          plz: absenderData.plz || "",
          ort: absenderData.ort || "",
          email: this.replyToMail || "",
          handy: absenderData.handy || "",
          telefon: absenderData.telefon || ""
        };
        absender.position = this.nachricht.absenderPosition;
        template = template.replace(/<<nachricht.titel>>/g, this.nachricht.betreff);
        template = template.replace(/<<nachricht.inhalt>>/g, this.nachricht.text.replace(/(?:\r\n|\r|\n)/g, "<br>"));
        template = template.replace(/<<absender.vorname>>/g, absender.vorname);
        template = template.replace(/<<absender.nachname>>/g, absender.nachname);
        template = template.replace(/<<absender.name>>/g, absender.vorname + " " + absender.nachname);
        template = template.replace(/<<absender.adresse>>/g, absender.adresse);
        template = template.replace(/<<absender.plz>>/g, absender.plz);
        template = template.replace(/<<absender.ort>>/g, absender.ort);
        template = template.replace(/<<absender.email>>/g, absender.email);
        template = template.replace(/<<absender.handy>>/g, absender.handy);
        template = template.replace(/<<absender.telefon>>/g, absender.telefon);
        template = template.replace(/<<absender.position>>/g, absender.position);
        template = template.replace("<<Veranstaltungen>>", "Beim Versenden werden hier die kommenden drei Veranstaltungen eingefügt.");
        template = template.replace("<<Kontaktdaten>>", "Beim Versenden werden hier die Kontaktdaten eingefügt.");
        return template;
      }
    },
    templates: function templates() {
      var templates = [];
      var items = this.$store.getters["einstellungen/einstellung"]("templates");
      if (items.templates) {
        items.templates.forEach(function (item) {
          if (item.kategorie === "Mail") {
            templates.push({
              text: item.name,
              value: item.html
            });
          }
        });
      }
      return templates;
    },
    gruppen: function gruppen() {
      var gruppen = [];
      var id = 0;
      var items = this.$store.getters["einstellungen/einstellung"]("gruppen");
      console.log(items);
      if (items.gruppen) {
        items.gruppen.forEach(function (item) {
          item.gruppen.forEach(function (gruppe) {
            gruppen.push({
              id: id,
              bedingungen: gruppe.bedingungen,
              value: gruppe.text,
              name: gruppe.text,
              text: gruppe.text
            });
            id++;
          });
        });
      }
      return gruppen;
    },
    kontakteAusGruppen: function kontakteAusGruppen() {
      var _this4 = this;

      var bbrbbr = [];
      if (this.nachricht.gruppen) {
        this.nachricht.gruppen.forEach(function (gruppenname) {
          var bedingungen = _this4.gruppen.find(function (gruppe) {
            return gruppenname === gruppe.text;
          }).bedingungen;
          _this4.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
            bedingungen.forEach(function (val) {
              console.log(val);
              if (typeof val.wert === "string") {
                val.wert = val.wert.split(",");
              }
              val.wert.forEach(function (valueWert) {
                if (Array.isArray(item[val.feld])) {
                  if (item[val.feld].indexOf(valueWert) !== -1) {
                    if (bbrbbr.indexOf(item) === -1) {
                      bbrbbr.push(item);
                    }
                  }
                } else {
                  if (valueWert === item[val.feld]) {
                    if (bbrbbr.indexOf(item) === -1) {
                      bbrbbr.push(item);
                    }
                  }
                }
              });
            });
          });
        });
      }
      return bbrbbr;
    }
  },
  methods: {
    handleFileImport: function handleFileImport() {
      var _this5 = this;

      this.isSelecting = true;
      window.addEventListener("focus", function () {
        _this5.isSelecting = false;
      }, { once: true });
      this.$refs.uploader.click();
      this.imgFile = null;
    },
    onFileChanged: function onFileChanged(e) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.uploadData(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(e.target.files));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    uploadData: function uploadData(files) {
      var _this7 = this;

      console.log("uploadData");
      console.log(files);
      var attachments = [];
      this.loading = true;
      this.uploadedFiles = files;
      console.log(this.loading);
      this.uploadStatus = Array(files.length).fill(0);

      files.forEach(function (file, index) {
        var fileName = file.name;
        var name = new Date().getTime() + file.name;
        var storageRef = _this7.$firebase.storage().ref("mailAnhange/" + name).put(file);

        storageRef.on("state_changed", function (snapshot) {
          var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;

          _this7.$set(_this7.uploadStatus, index, progress);

          _this7.uploadValue = progress;
          console.log(_this7.uploadStatus);
        }, function (error) {
          _this7.$set(_this7.uploadStatus, index, { error: error.message });
        }, function () {
          storageRef.snapshot.ref.getDownloadURL().then(function (url) {
            attachments.push({
              name: fileName,
              filename: fileName,
              path: url
            });

            if (_this7.uploadStatus.every(function (status) {
              return status === 100;
            })) {
              _this7.uploadedFiles = [];
              if (!Array.isArray(_this7.attachments)) {
                _this7.attachments = [];
              }
              while (attachments.length > 0) {
                var attachment = attachments.shift();
                _this7.attachments.push(attachment);
              }
              _this7.loading = false;
              console.log(_this7.loading);
              _this7.uploadValue = 0;
            }
          });
        });
      });
    },
    deleteFile: function deleteFile(index) {
      this.attachments.splice(index, 1);
    },
    sendMail: function sendMail() {
      var _this8 = this;

      console.log("sendMail");
      try {
        var betreff = this.nachricht.betreff;
        var text = this.nachricht.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        var from = this.$store.getters["bbrbbr/bbr"](this.currentBbr).email;
        var to = [];
        var cc = [];
        var bcc = [];
        var anGruppen = [];
        var absenderData = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
        var absender = {
          vorname: absenderData.vorname || "",
          nachname: absenderData.nachname || "",
          adresse: absenderData.adresse || "",
          plz: absenderData.plz || "",
          ort: absenderData.ort || "",
          email: this.replyToMail || "",
          handy: absenderData.handy || "",
          telefon: absenderData.telefon || ""
        };
        absender.position = this.nachricht.absenderPosition;
        if (this.nachricht.gruppen) {
          this.kontakteAusGruppen.forEach(function (item) {
            if (item.email) {
              bcc.push(item.email);

              anGruppen.push(item.id);
            }
          });
        }
        if (this.nachricht.an) {
          this.nachricht.an.forEach(function (item) {
            to.push(_this8.$store.getters["bbrbbr/bbr"](item).email);
          });
        }
        if (this.nachricht.cc) {
          this.nachricht.cc.forEach(function (item) {
            cc.push(_this8.$store.getters["bbrbbr/bbr"](item).email);
          });
        } else {
          this.nachricht.cc = [];
        }
        if (this.nachricht.bcc) {
          this.nachricht.bcc.forEach(function (item) {
            bcc.push(_this8.$store.getters["bbrbbr/bbr"](item).email);
          });
        } else {
          this.nachricht.bcc = [];
        }
        if (this.nachricht.an_adresse) {
          this.nachricht.an_adresse.forEach(function (item) {
            to.push(item);
          });
        }
        if (!this.nachricht.template) {
          this.nachricht.template = null;
        }
        console.log(this.nachricht);
        this.$store.dispatch("mails/createEinMails", {
          art: "mail",
          from: from,
          to: to,
          cc: cc,
          bcc: bcc,
          absender: absender,
          status: "Warte auf Versand..",
          gruppen: this.nachricht.gruppen ? this.nachricht.gruppen : [],
          von: this.currentBbr,
          an: this.nachricht.an,
          an_gruppen: anGruppen,
          an_adresse: this.nachricht.an_adresse,
          an_cc: this.nachricht.cc,
          an_bcc: this.nachricht.bcc,
          template: this.nachricht.template,
          message: {
            subject: betreff,
            text: text
          },
          attachments: this.attachments,
          datum: new Date()
        });
        this.close();
        this.nachricht = {
          an: [],
          cc: [],
          bcc: [],
          an_adresse: [],
          gruppen: [],
          message: {},
          absender: {}
        };
      } catch (error) {
        console.log(error);
        this.$vars.error.nachricht = "Beim Versenden der Mail ist ein Fehler aufgetreten.";
        this.$vars.error.error = error;
        this.$vars.error.show = true;
      }
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["selectedEvent", "visible"],
  data: function data() {
    return {
      loading: "",
      showVeranstaltungEdit: false,
      showWeiterenAnmelden: false,
      showZuVeranstaltungAbmelden: false,
      showEvent: false,
      name: "",
      selectedElement: null,
      showAlleAnmeldungen: false,
      heute: new Date().toISOString().substr(0, 10)
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    selectedEventImage: function selectedEventImage() {
      var link = "/static/calendarEventImages/img_beer_1x.jpg";
      if (this.selectedEvent.titel && this.$vars.verbindung === "rbo") {
        var array = [{ name: "ausklang", bild: "bbq" }, { name: "bowling", bild: "bowling" }, { name: "brunch", bild: "breakfast" }, { name: "billard", bild: "billard" }, { name: "bummel", bild: "beer" }, { name: "cc", bild: "convent" }, { name: "cocktail", bild: "drinks" }, { name: "convent", bild: "convent" }, { name: "dc", bild: "convent" }, { name: "dinner", bild: "dinner" }, { name: "essen", bild: "dinner" }, { name: "examen", bild: "graduation" }, { name: "fahne", bild: "fahnenhissung" }, { name: "flunkyball", bild: "beer" }, { name: "film", bild: "cinema" }, { name: "frühstück", bild: "breakfast" }, { name: "fußball", bild: "soccer" }, { name: "golf", bild: "golf" }, { name: "gottesdienst", bild: "learninstrument" }, { name: "grill", bild: "bbq" }, { name: "halloween", bild: "halloween" }, { name: "hochamt", bild: "learninstrument" }, { name: "kaffee", bild: "coffee" }, { name: "kegeln", bild: "bowling" }, { name: "kneipe", bild: "kneipe" }, { name: "kommers", bild: "kneipe" }, { name: "messe", bild: "learninstrument" }, { name: "oc", bild: "convent" }, { name: "party", bild: "party" }, { name: "poker", bild: "drinks" }, { name: "pool", bild: "swimming" }, { name: "salon", bild: "drinks" }, { name: "schwimm", bild: "swimming" }, { name: "segel", bild: "sailing" }, { name: "sing", bild: "learninstrument" }, { name: "sport", bild: "walk" }, { name: "stiftungsfest", bild: "kneipe" }, { name: "tag des ripuarenhauses", bild: "clean" }, { name: "tanz in den mai", bild: "party" }, { name: "tanz", bild: "dancing" }, { name: "vortrag", bild: "graduation" }, { name: "wander", bild: "hiking" }, { name: "wc", bild: "convent" }, { name: "weihnacht", bild: "xmas" }, { name: "weihnachtsparty", bild: "xmasparty" }];
        var substring = this.selectedEvent.titel;
        var match = array.find(function (element) {
          if (substring.toLowerCase().includes(element.name.toLowerCase())) {
            return true;
          }
        });
        if (match !== undefined) {
          link = "/static/calendarEventImages/img_" + match.bild + "_1x.jpg";
        }
      }
      return link;
    },
    anmeldungen: function anmeldungen() {
      var _this = this;

      var anmeldungen = this.selectedEvent.anmeldungen.map(function (item) {
        var bbr = _this.$store.getters["bbrbbr/bbr"](item);
        return {
          id: item,
          bbr: bbr.nachname + ", " + bbr.vorname
        };
      }).sort(function (a, b) {
        if (a.bbr < b.bbr) {
          return -1;
        }
        if (a.bbr > b.bbr) {
          return 1;
        }
        return 0;
      });
      return anmeldungen;
    },
    currentBbrStatus: function currentBbrStatus() {
      return this.$store.getters["bbrbbr/bbr"](this.currentBbr).status;
    }
  },
  methods: {
    allowEdit: function allowEdit(event) {
      var _this2 = this;

      var seiten = this.$store.getters["einstellungen/einstellung"]("rollen");
      var bbr = this.$store.state.bbrbbr.bbrbbr.find(function (d) {
        return d.anmeldeID === _this2.$firebase.auth().currentUser.uid;
      });
      var variable = false;
      if (seiten !== undefined) {
        seiten.seiten.forEach(function (item) {
          var modul = item.module.find(function (a) {
            return a.value === "veranstaltungen";
          });
          if (modul) {
            var kalender = modul.props.find(function (a) {
              return a.name === "Kalender";
            });
            if (kalender) {
              if (kalender.wert.indexOf(event.kalender) > -1) {
                if (item.berechtigt.indexOf(bbr.id) >= 0) {
                  variable = true;
                }
              }
            }
          }
        });
      }
      if (bbr.id === "PBChUyAy7HWowQR4HlP3") {
        return true;
      } else {
        return variable;
      }
    },
    zuVeranstaltungAnmelden: function zuVeranstaltungAnmelden() {
      this.selectedEvent.anmeldungen.push(this.currentBbr);
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      this.$firebase.analytics().logEvent("zuVeranstaltungAnmelden", {
        currentBbr: this.currentBbr,
        name: this.currentBbr
      });
    },
    zuVeranstaltungAbmelden: function zuVeranstaltungAbmelden() {
      this.selectedEvent.anmeldungen.splice(this.selectedEvent.anmeldungen.indexOf(this.currentBbr), 1);
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      this.$firebase.analytics().logEvent("zuVeranstaltungAbmelden", {
        currentBbr: this.currentBbr,
        name: this.currentBbr
      });
      this.showZuVeranstaltungAbmelden = false;
    },
    weiterenAnmelden: function weiterenAnmelden() {
      if (!this.selectedEvent.weitereAnmeldungen) {
        this.selectedEvent.weitereAnmeldungen = [];
      }
      this.selectedEvent.weitereAnmeldungen.push({
        angemeldetVon: this.currentBbr,
        name: this.name
      });
      this.name = "";
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
    },
    weiterenAbmelden: function weiterenAbmelden(item) {
      this.selectedEvent.weitereAnmeldungen.splice(this.selectedEvent.weitereAnmeldungen.indexOf(item), 1);
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
    },
    shareVeranstaltung: function shareVeranstaltung(event) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText("https://rbo.korpodesk.de/event/" + event.id);

              case 3:
                _this3.$store.state.snackbar = {
                  show: true,
                  nachricht: "Link zur Veranstaltung kopiert."
                };
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                _this3.$store.state.snackbar = {
                  show: true,
                  nachricht: "Fehler bei der Linkerstellung."
                };

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 6]]);
      }))();
    },
    downloadAnmeldungen: function downloadAnmeldungen() {
      var _this4 = this;

      var veranstaltung = this.selectedEvent;
      var anmeldungen = [];
      veranstaltung.anmeldungen.forEach(function (item) {
        var bbr = _this4.$store.getters["bbrbbr/bbr"](item);
        anmeldungen.push({
          id: item,
          name: bbr.nachname + ", " + bbr.vorname,
          weitere: veranstaltung.weitereAnmeldungen.filter(function (weitereAnmeldung) {
            return weitereAnmeldung.angemeldetVon === item;
          }).map(function (weitereAnmeldung) {
            return weitereAnmeldung.name;
          })
        });
      });
      anmeldungen.sort(function (a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
      console.log(veranstaltung);
      var doc = new __WEBPACK_IMPORTED_MODULE_2_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 90, 210, 1, "F");
      doc.setFillColor(219, 31, 41);
      doc.rect(0, 92, 210, 1, "F");
      var img = new Image();
      img.src = "/static/wappen.png";
      doc.addImage(img, 125, 30, 75, 75);
      doc.setFontSize(9);
      doc.text("K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn", 25, 87);
      doc.setFontSize(14);
      doc.setFont("Times", "bold");
      var formattedDate = new Date(veranstaltung.vonDatum).toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
      doc.text("Anmeldungen " + veranstaltung.titel + " am " + formattedDate + " um " + veranstaltung.vonZeit + " Uhr", 25, 115, null, null, "left");
      doc.setFont("Times", "normal");
      doc.setFontSize(11);
      formattedDate = new Date().toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
      var formattedTime = new Date().toLocaleString("de-DE", { hour: "2-digit", minute: "2-digit" });
      doc.text("Stand: " + formattedDate + ", " + formattedTime + " Uhr", 25, 121, null, null, "left");
      var seite = 1;
      var counter = 1;
      var zeile = 135;
      doc.setFillColor(0, 0, 0);
      doc.line(22, zeile - 6, 188, zeile - 6);
      for (var i = 0; i < anmeldungen.length; i++) {
        if (zeile > 270) {
          zeile = 25;
          doc.text(String(seite), 25, 280, null, null, "left");
          seite += 1;
          doc.addPage();
          doc.line(22, zeile - 6, 188, zeile - 6);
        }
        doc.text(25, zeile, String(counter));
        doc.text(35, zeile, anmeldungen[i].name);
        counter += 1;
        zeile += 6;
        var zeile2 = zeile;
        for (var j = 0; j < anmeldungen[i].weitere.length; j++) {
          if (zeile > 270) {
            zeile = 25;
            doc.text(String(seite), 25, 280, null, null, "left");
            seite += 1;
            doc.addPage();
            doc.line(22, zeile - 6, 188, zeile - 6);
          }
          doc.text(25, zeile, String(counter));
          doc.text(40, zeile, anmeldungen[i].weitere[j]);
          counter += 1;
          zeile += 6;
        }
        doc.line(22, zeile2 - 12, 22, zeile - 3);
        doc.line(178, zeile2 - 12, 178, zeile - 3);
        doc.line(188, zeile2 - 12, 188, zeile - 3);
        doc.line(22, zeile - 3, 188, zeile - 3);
        zeile += 3;
      }
      doc.save("Anmeldungen-" + veranstaltung.titel + ".pdf");
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["veranstaltung", "visible"],
  data: function data() {
    return {
      kleiderordnungen: ["Gepflegt leger", "Gepflegt leger mit Hemd", "Kombination", "Kombination mit plenis coloribus", "Dunkler Anzug", "Dunkler Anzug mit plenis coloribus", "Abendgarderobe"],
      gruppen: [{ text: "Füxe", value: "Fux" }, { text: "Aktive", value: "Aktiver" }, { text: "Inaktive in loco", value: "Inaktiver in loco" }, { text: "Inaktive extra locum", value: "Inaktiver extra locum" }],
      date: "",
      menu1: "",
      menu2: "",
      menu3: "",
      menu4: "",
      menu5: "",
      neueAnmeldung: "",
      neueAnmeldungWeitere: {},
      showDeleteVeranstaltung: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    bundesbruder: function bundesbruder() {
      var bbrbbr = [];
      this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")"
          });
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname
          });
        }
      });
      return bbrbbr;
    },
    itemsKalender: function itemsKalender() {
      var kalender = [];
      this.$store.getters["einstellungen/einstellung"]("alleKalender").forEach(function (key) {
        kalender.push({
          value: key.name,
          text: key.name
        });
      });
      return kalender;
    },
    formatVonDatum: function formatVonDatum() {
      if (!this.veranstaltung.vonDatum) return null;
      return new Date(this.veranstaltung.vonDatum).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    formatBisDatum: function formatBisDatum() {
      if (!this.veranstaltung.bisDatum) return null;
      return new Date(this.veranstaltung.bisDatum).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    }
  },
  methods: {
    allowedMinutes: function allowedMinutes(m) {
      return m % 5 === 0;
    },
    changeVonDatum: function changeVonDatum() {
      if (!this.veranstaltung.bisDatum) {
        this.veranstaltung.bisDatum = this.veranstaltung.vonDatum;
      }
      if (!this.veranstaltung.bisZeit) {
        this.veranstaltung.bisZeit = "23:55";
      }
      if (!this.veranstaltung.vonZeit) {
        this.veranstaltung.vonZeit = "20:15";
      }
    },
    anmeldungEntfernen: function anmeldungEntfernen(item) {
      this.veranstaltung.anmeldungen.splice(this.veranstaltung.anmeldungen.indexOf(item), 1);
    },
    anmeldungHinzufuegen: function anmeldungHinzufuegen() {
      if (this.veranstaltung.anmeldungen.indexOf(this.neueAnmeldung) === -1) {
        this.veranstaltung.anmeldungen.push(this.neueAnmeldung);
      }
      this.neueAnmeldung = "";
    },
    anmeldungEntfernenWeitere: function anmeldungEntfernenWeitere(item) {
      this.veranstaltung.weitereAnmeldungen.splice(this.veranstaltung.weitereAnmeldungen.indexOf(item), 1);
    },
    anmeldungHinzufuegenWeitere: function anmeldungHinzufuegenWeitere() {
      this.veranstaltung.weitereAnmeldungen.push({
        angemeldetVon: this.neueAnmeldungWeitere.angemeldetVon,
        name: this.neueAnmeldungWeitere.name
      });
      this.neueAnmeldungWeitere = {};
    },
    saveVeranstaltung: function saveVeranstaltung() {
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.veranstaltung);
      this.close();
    },
    deleteVeranstaltung: function deleteVeranstaltung() {
      this.$store.dispatch("veranstaltungen/deleteVeranstaltungData", this.veranstaltung.id);
      this.showDeleteVeranstaltung = false;
      this.close();
    },
    close: function close() {
      this.$emit("close", false);
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__(23);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["status", "search", "kasse", "showFilter"],
  data: function data() {
    return {
      loading: false,
      selected: [],
      showRechnung: false,
      showSendRechnungen: false,
      selectRechnung: [],
      neuStatus: "",
      summeVon: "0",
      summeBis: "2000",
      bearbeiteteFelder: {},
      showMehrereBearbeiten: false,
      statusAuswahl: ["Offen", "Gezahlt"],
      progressSendSepa: 0,
      headers: [{ text: "Status", value: "status" }, { text: "Nr.", value: "rechnungsnummer" }, { text: "Titel", value: "rechnung_titel" }, { text: "Kontakt", value: "bbr" }, { text: "Summe", align: "right", value: "summe" }, { text: "Rechnungsdatum", value: "rechnung_datum" }, { text: "", value: "" }],
      showDeleteRechnung: false,
      showDeleteMehrereRechnung: false,
      deleteRechnungID: "",
      page: 1,
      pageCount: 0,
      rechnungenSummen: [0, 0, 0, 0, 0],
      stepperSendRechnungen: 1,
      logoUrl: null,
      tabs: 0
    };
  },
  mounted: function mounted() {
    this.loadLogo();
  },

  computed: {
    summe: function summe() {
      return this.rechnungen[this.tabs].rechnungen.reduce(function (total, item) {
        return total + item.summe;
      }, 0);
    },
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    isSelect: function isSelect() {
      return true;
    },
    settings: function settings() {
      return this.$store.getters["einstellungen/einstellung"]("allgemein");
    },
    rechnungen: function rechnungen() {
      var _this = this;

      var rechnungen = void 0;
      this.jahre = [];
      var jahreMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();

      if (this.status === "Alle") {
        rechnungen = this.$store.getters["rechnungen/rechnungenKasse"](this.kasse);
        this.rechnungenSummen = [0, 0, 0, 0, 0, 0, 0];
        rechnungen.forEach(function (rechnung) {
          if (rechnung.summe === undefined) {
            rechnung.summe = 0;
            rechnung.positionen.forEach(function (position) {
              rechnung.summe += parseFloat(position.betrag);
            });
          }
          if (rechnung.status === "Entwurf") {
            _this.rechnungenSummen[0] += parseFloat(rechnung.summe);
            _this.rechnungenSummen[6] += parseFloat(rechnung.summe);
          }
          if (rechnung.status === "Entwurf SEPA") {
            _this.rechnungenSummen[1] += parseFloat(rechnung.summe);
            _this.rechnungenSummen[6] += parseFloat(rechnung.summe);
          }
          if (rechnung.status === "Offen") {
            _this.rechnungenSummen[2] += parseFloat(rechnung.summe);
            _this.rechnungenSummen[6] += parseFloat(rechnung.summe);
          }
          if (rechnung.status === "Überfällig") {
            _this.rechnungenSummen[3] += parseFloat(rechnung.summe);
            _this.rechnungenSummen[6] += parseFloat(rechnung.summe);
          }
          if (rechnung.status === "Mahnung") {
            _this.rechnungenSummen[4] += parseFloat(rechnung.summe);
            _this.rechnungenSummen[6] += parseFloat(rechnung.summe);
          }
          if (rechnung.status === "Gemahnt überfällig") {
            _this.rechnungenSummen[5] += parseFloat(rechnung.summe);
            _this.rechnungenSummen[6] += parseFloat(rechnung.summe);
          }
        });
      } else {
        rechnungen = this.$store.getters["rechnungen/statusRechnungenKasse"](this.status, this.kasse);
      }

      rechnungen.forEach(function (rechnung) {
        var zahldate = new Date(rechnung.rechnung_zahlbar_bis);
        var today = new Date();
        var kontakt = _this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
        rechnung.kontakt = kontakt.vorname + " " + kontakt.nachname;
        console.log(rechnung.kontakt);
        if (rechnung.status === "Offen" && today > zahldate) {
          rechnung.status = "Überfällig";
          _this.$store.dispatch("rechnungen/updateRechnungData", rechnung);
          console.log("rechnung update");
        }
        if (rechnung.status === "Mahnung" && today > zahldate) {
          rechnung.status = "Gemahnt überfällig";
          _this.$store.dispatch("rechnungen/updateRechnungData", rechnung);
          console.log("rechnung update");
        }
        if (rechnung.summe === undefined) {
          rechnung.summe = 0;
          rechnung.positionen.forEach(function (position) {
            rechnung.summe += parseFloat(position.betrag);
          });
        }
        if (rechnung.rechnungssumme < _this.summeVon || rechnung.rechnungssumme > _this.summeBis) {
          rechnungen.splice(rechnungen.indexOf(rechnung), 1);
        }

        if (rechnung.rechnung_zahlbar_bis) {
          var year = new Date(rechnung.rechnung_zahlbar_bis).getFullYear();
          if (!jahreMap.has(year)) {
            jahreMap.set(year, []);
          }
          jahreMap.get(year).push(rechnung);
        }
      });

      this.jahre = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(jahreMap.keys()).sort(function (a, b) {
        return b - a;
      });
      var jahre = this.jahre.map(function (jahr) {
        return {
          jahr: jahr,
          rechnungen: jahreMap.get(jahr)
        };
      });
      return jahre;
    },
    sideHeight: function sideHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "calc(100vh - 429px)";
        case "sm":
          return "calc(100vh - 429px)";
        case "md":
          return "calc(100vh - 429px)";
        case "lg":
          return "calc(100vh - 429px)";
        case "xl":
          return "calc(100vh - 42px)";
      }
    }
  },
  methods: {
    bearbeiteMehrere: function bearbeiteMehrere() {
      var _this2 = this;

      this.selected.forEach(function (id) {
        var rechnung = _this2.$store.getters["rechnungen/rechnung"](id);
        if (_this2.bearbeiteteFelder.rechnung_titel) {
          rechnung.rechnung_titel = _this2.bearbeiteteFelder.rechnung_titel;
        }
        if (_this2.bearbeiteteFelder.rechnung_datum) {
          rechnung.rechnung_datum = _this2.bearbeiteteFelder.rechnung_datum;
        }
        if (_this2.bearbeiteteFelder.rechnung_zahlbar_bis) {
          rechnung.rechnung_zahlbar_bis = _this2.bearbeiteteFelder.rechnung_zahlbar_bis;
        }
        if (_this2.bearbeiteteFelder.status) {
          rechnung.status = _this2.bearbeiteteFelder.status;
        }

        _this2.$store.dispatch("rechnungen/updateRechnungData", rechnung);
      });
      this.selected = [];
      this.bearbeiteteFelder = {};
      this.showMehrereBearbeiten = false;
    },
    loescheMehrere: function loescheMehrere() {
      var _this3 = this;

      this.selected.forEach(function (id) {
        _this3.$store.dispatch("rechnungen/deleteRechnungData", id);
      });
      this.selected = [];
      this.showDeleteMehrereRechnung = false;
      this.bearbeiteteFelder = {};
      this.showMehrereBearbeiten = false;
    },
    ersetzeText: function ersetzeText(text, rechnung) {
      var summe = 0;
      rechnung.positionen.forEach(function (position) {
        summe = parseFloat(summe) + parseFloat(position.betrag);
      });
      text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
      text = text.replace("<<Rechnungsdatum>>", new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
      text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
      text = text.replace("<<Vorname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).vorname);
      text = text.replace("<<Nachname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).nachname);
      text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
      text = text.replace("<<Zahlbar_bis>>", new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }));
      return text;
    },
    checkIndex: function checkIndex(id) {
      if (this.selected.indexOf(id) >= 0) {
        return false;
      } else {
        return true;
      }
    },
    addSelect: function addSelect(id) {
      if (this.selected.indexOf(id) >= 0) {
        this.selected.splice(this.selected.indexOf(id), 1);
      } else {
        this.selected.push(id);
      }
    },
    alleEntwurfNeuerStatus: function alleEntwurfNeuerStatus() {
      var _this4 = this;

      this.rechnungen[this.tabs].rechnungen.forEach(function (rechnung) {
        if (rechnung.status === "Entwurf") {
          _this4.neuerStatus(rechnung, "Offen");
        }
      });
    },
    neuerStatus: function neuerStatus(selectRechnung, status) {
      if (selectRechnung.farbe === undefined) {
        selectRechnung.farbe = "";
      }
      if (selectRechnung.status === "Entwurf" && status !== "Entwurf" || selectRechnung.status === "Entwurf SEPA" && status !== "Entwurf SEPA") {
        this.rechnungVersenden(selectRechnung);
      }
      if (status !== "Gezahlt") {
        selectRechnung.gezahlt_datum = new Date();
      }
      if (status === "") {
        return;
      } else {
        selectRechnung.status = status;
        this.$store.dispatch("rechnungen/updateRechnungData", selectRechnung);
      }
    },
    sepaGenerieren: function sepaGenerieren(selected) {
      var _this5 = this;

      console.log(this.rechnungen[this.tabs].rechnungen);
      var rechnungen = [];
      if (selected === undefined) {
        rechnungen = this.rechnungen[this.tabs].rechnungen;
      } else {
        selected.forEach(function (item) {
          rechnungen.push(_this5.rechnungen[_this5.tabs].rechnungen.find(function (rechnung) {
            return rechnung.id === item;
          }));
        });
      }
      this.loading = true;
      var anzahlRechnungen = rechnungen.length;
      var summeRechnungen = 0;
      rechnungen.forEach(function (rechnung) {
        console.log(rechnung);
        console.log(rechnung.summe);
        summeRechnungen = summeRechnungen + parseFloat(parseFloat(rechnung.summe).toFixed(2));
      });
      summeRechnungen = summeRechnungen.toFixed(2);
      var kassenInfo = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnungen[0].kasse];
      kassenInfo.IBAN = kassenInfo.IBAN.replace(/ /g, "");
      var nachrichtenID = "ID-1863-" + new Date().getTime();
      var nachrichtenErstellung = new Date().toISOString().substr(0, 24);
      var rechnungZahlbarBis = rechnungen[0].rechnung_zahlbar_bis;
      var xmltext = void 0;
      try {
        xmltext = "<?xml version='1.0' encoding='UTF-8'?>\n" + "<Document xmlns='urn:iso:std:iso:20022:tech:xsd:pain.008.001.02' xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xsi:schemaLocation='urn:iso:std:iso:20022:tech:xsd:pain.008.001.02 pain.008.001.02.xsd'><CstmrDrctDbtInitn>\n" + "\t<GrpHdr>\n" + "\t\t<MsgId>" + nachrichtenID + "</MsgId>\n" + "\t\t<CreDtTm>" + nachrichtenErstellung + "</CreDtTm>\n" + "\t\t<NbOfTxs>" + anzahlRechnungen + "</NbOfTxs>\n" + "\t\t<CtrlSum>" + summeRechnungen + "</CtrlSum>\n" + "\t\t<InitgPty>\n" + "\t\t\t<Nm>" + kassenInfo.kontoname + "</Nm>\n" + "\t\t</InitgPty>\n" + "\t</GrpHdr>\n" + "\t<PmtInf>\n" + "\t\t<PmtInfId>" + nachrichtenID + "</PmtInfId>\n" + "\t\t<PmtMtd>DD</PmtMtd>\n" + "\t\t<BtchBookg>true</BtchBookg>\n" + "\t\t<NbOfTxs>" + anzahlRechnungen + "</NbOfTxs>\n" + "\t\t<CtrlSum>" + summeRechnungen + "</CtrlSum>\n" + "\t\t<PmtTpInf>\n" + "\t\t\t<SvcLvl>\n" + "\t\t\t\t<Cd>SEPA</Cd>\n" + "\t\t\t</SvcLvl>\n" + "\t\t\t<LclInstrm>\n" + "\t\t\t\t<Cd>CORE</Cd>\n" + "\t\t\t</LclInstrm>\n" + "\t\t\t<SeqTp>RCUR</SeqTp>\n" + "\t\t</PmtTpInf>\n" + "\t\t<ReqdColltnDt>" + rechnungZahlbarBis + "</ReqdColltnDt>\n" + "\t\t<Cdtr>\n" + "\t\t\t<Nm>" + kassenInfo.kontoname + "</Nm>\n" + "\t\t</Cdtr>\n" + "\t\t<CdtrAcct>\n" + "\t\t\t<Id>\n" + "\t\t\t\t<IBAN>" + kassenInfo.IBAN + "</IBAN>\n" + "\t\t\t</Id>\n" + "\t\t</CdtrAcct>\n" + "\t\t<CdtrAgt>\n" + "\t\t\t<FinInstnId>\n" + "\t\t\t\t<BIC>" + kassenInfo.BIC + "</BIC>\n" + "\t\t\t</FinInstnId>\n" + "\t\t</CdtrAgt>\n" + "\t\t<ChrgBr>SLEV</ChrgBr>\n" + "\t\t<CdtrSchmeId>\n" + "\t\t\t<Id>\n" + "\t\t\t\t<PrvtId>\n" + "\t\t\t\t\t<Othr>\n" + "\t\t\t\t\t\t<Id>" + kassenInfo.glaubigerID + "</Id>\n" + "\t\t\t\t\t\t<SchmeNm>\n" + "\t\t\t\t\t\t\t<Prtry>SEPA</Prtry>\n" + "\t\t\t\t\t\t</SchmeNm>\n" + "\t\t\t\t\t</Othr>\n" + "\t\t\t\t</PrvtId>\n" + "\t\t\t</Id>\n" + "\t\t</CdtrSchmeId>";

        rechnungen.forEach(function (rechnung) {
          var bundesbruder = _this5.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
          var betrag = parseFloat(rechnung.summe).toFixed(2);
          var EndToEndId = "RBO" + rechnung.rechnungsnummer;
          var MndtId = bundesbruder.mandatsreferenz.replace(/[^A-Z0-9]/g, "");
          var DtOfSgntr = bundesbruder.mandatUnterschriftsdatum;
          var AmdmntInd = "false";
          var BIC = bundesbruder.bic;
          var name = bundesbruder.kontoinhaber;
          var IBAN = bundesbruder.iban.replace(/ /g, "");
          var betreff = (rechnung.rechnung_titel + " " + rechnung.rechnungsnummer).replace(/[^\x00-\x7F]/g, "");
          rechnung.gezahlt_datum = new Date(rechnung.rechnung_zahlbar_bis);
          xmltext = xmltext + "\n" + "\t<DrctDbtTxInf>\n" + "\t\t<PmtId>\n" + "\t\t\t<EndToEndId>" + EndToEndId + "</EndToEndId>\n" + "\t\t</PmtId>\n" + "\t\t<InstdAmt Ccy='EUR'>" + betrag + "</InstdAmt>\n" + "\t\t<DrctDbtTx>\n" + "\t\t\t<MndtRltdInf>\n" + "\t\t\t\t<MndtId>" + MndtId + "</MndtId>\n" + "\t\t\t\t<DtOfSgntr>" + DtOfSgntr + "</DtOfSgntr>\n" + "\t\t\t\t<AmdmntInd>" + AmdmntInd + "</AmdmntInd>\n" + "\t\t\t</MndtRltdInf>\n" + "\t\t</DrctDbtTx>\n" + "\t\t<DbtrAgt>\n" + "\t\t\t<FinInstnId>\n" + "\t\t\t\t<BIC>" + BIC + "</BIC>\n" + "\t\t\t</FinInstnId>\n" + "\t\t</DbtrAgt>\n" + "\t\t<Dbtr>\n" + "\t\t\t<Nm>" + name + "</Nm>\n" + "\t\t</Dbtr>\n" + "\t\t<DbtrAcct>\n" + "\t\t\t<Id>\n" + "\t\t\t\t<IBAN>" + IBAN + "</IBAN>\n" + "\t\t\t</Id>\n" + "\t\t</DbtrAcct>\n" + "\t\t<RmtInf>\n" + "\t\t\t<Ustrd>" + betreff + "</Ustrd>\n" + "\t\t</RmtInf>\n" + "\t</DrctDbtTxInf>";
        });

        xmltext = xmltext + "\n" + "\t</PmtInf>\n" + "</CstmrDrctDbtInitn>\n" + "</Document>";
      } catch (err) {
        console.error(err);
        this.$store.state.nachricht.typ = "error";
        this.$store.state.nachricht.nachricht = "Die Erstellung der SEPA-Datei hat nicht geklappt.";
        this.$store.state.nachricht.error = err;
        this.$store.state.nachricht.show = true;
      }
      var filename = new Date().toISOString().substr(0, 10) + "-" + new Date().toISOString().substr(11, 8) + "_sepa_" + rechnungen[0].kasse + ".xml";

      var pom = document.createElement("a");
      pom = document.createElement("a");
      var bb = new Blob([xmltext], { type: "text/plain" });
      pom.setAttribute("href", window.URL.createObjectURL(bb));
      pom.setAttribute("download", filename);
      pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
      pom.draggable = true;
      pom.classList.add("dragout");
      pom.click();
      this.$store.dispatch("sepa/createEinSepa", {
        date: new Date(),
        xml: xmltext,
        filename: filename,
        summe: summeRechnungen,
        anzahl: anzahlRechnungen,
        kasse: kassenInfo.kontoname
      });
      this.loading = false;
      this.progressSendSepa = 0;
      this.stepperSendRechnungen = 2;
    },
    sepaRechnungenVersenden: function sepaRechnungenVersenden() {
      var _this6 = this;

      this.loading = true;
      var length = this.rechnungen[this.tabs].rechnungen.length;
      this.rechnungen[this.tabs].rechnungen.forEach(function (rechnung, index) {
        setTimeout(function () {
          console.log("send Rechnung (" + (index + 1) + "/" + length + ")");
          _this6.neuerStatus(rechnung, "Gezahlt");
          _this6.progressSendSepa = index / length * 100;
        }, 1000 * index);
      });
      setTimeout(function () {
        _this6.loading = false;
        _this6.stepperSendRechnungen = 3;
      }, 1000 * length);
    },
    rechnungVersenden: function rechnungVersenden(rechnung) {
      console.log(rechnung);

      rechnung.rechnung_freitext_code = rechnung.rechnung_freitext.replace(/(?:\r\n|\r|\n)/g, "<br>");
      var bundesbruder = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
      var absender = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
      if (bundesbruder.email) {
        this.$store.dispatch("mails/createEinMails", {
          art: "rechnung",
          rechnung: rechnung,
          von: this.currentBbr,
          to: [bundesbruder.email],
          an: [bundesbruder.id],
          absender: {
            position: this.$route.params.seite,
            name: absender.vorname + " " + absender.nachname,
            vorname: absender.vorname || "",
            nachname: absender.nachname || "",
            adresse: absender.adresse || "",
            plz: absender.plz || "",
            ort: absender.ort || "",
            email: absender.email || "",
            telefon: absender.handy || ""
          },
          message: {
            subject: rechnung.rechnung_titel,
            text: rechnung.rechnung_freitext_code
          },
          datum: new Date()
        });
      } else {
        this.printRechnung(rechnung);
        this.$store.state.snackbar = {
          show: true,
          nachricht: "Mindestens eine Rechnung wurde heruntergeladen, da keine Mailadresse beim Rechnungsempfänger hinterlegt ist."
        };
      }
    },
    goToId: function goToId(id) {
      this.$router.push("/bierwart/rechnungen/" + id);
    },
    deleteRechnung: function deleteRechnung() {
      this.$store.dispatch("rechnungen/deleteRechnungData", this.deleteRechnungID);
      this.showDeleteRechnung = false;
      this.deleteRechnungID = "";
    },
    loadLogo: function loadLogo() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this7.logoImage();

              case 3:
                url = _context.sent;

                _this7.logoUrl = url;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error("Error loading logo:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this7, [[0, 7]]);
      }))();
    },
    logoImage: function logoImage() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storagePath, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                storagePath = "/design/logo/" + _this8.$vars.verbindung;
                _context2.next = 4;
                return _this8.$firebase.storage().ref(storagePath).getDownloadURL();

              case 4:
                url = _context2.sent;
                return _context2.abrupt("return", url);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 8]]);
      }))();
    },
    printRechnung: function printRechnung(item) {
      var rechnung = item;
      var kasse = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
      var bbr = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
      var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a4"
      });
      doc.setFont("Times");
      doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
      doc.rect(0, 90, 210, 1, "F");
      if (this.$vars.verbindung === "rbo") {
        doc.setFillColor(this.settings.secondary.rgba.r, this.settings.secondary.rgba.g, this.settings.secondary.rgba.b);
        doc.rect(0, 92, 210, 1, "F");
        var img = new Image();
        img.src = "/static/wappen_512.png";
        doc.addImage(img, 125, 30, 75, 75);
      }
      doc.setFontSize(9);
      doc.text(this.settings.name + " | " + this.settings.strasse + " " + this.settings.hausnummer + " | " + this.settings.plz + " " + this.settings.ort, 25, 51);
      doc.setFontSize(11);
      if (bbr.titel) {
        doc.text(bbr.anrede + " " + bbr.titel, 25, 61);
      } else {
        doc.text(bbr.anrede, 25, 61);
      }
      doc.text(bbr.vorname + " " + bbr.nachname, 25, 66);
      doc.text(bbr.adresse, 25, 71);
      doc.text(bbr.plz + " " + bbr.ort, 25, 76);
      doc.text(bbr.land, 25, 81);
      doc.setFont("Times", "bold");
      doc.text("Rechnungsnr.", 20, 110);
      doc.text("Datum", 70, 110);
      if (rechnung.rechnung_art === "SEPA") {
        doc.text("Einzug am", 120, 110);
      } else {
        doc.text("Zahlbar bis", 120, 110);
      }
      doc.text("Kasse", 170, 110);
      doc.setFont("Times", "normal");
      doc.text(rechnung.rechnungsnummer, 20, 115);
      doc.text(new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }), 70, 115);
      doc.text(new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }), 120, 115);
      doc.text(rechnung.kasse, 170, 115);
      doc.setFont("Times", "bold");
      doc.text(rechnung.rechnung_titel, 210, 125);
      doc.setFont("Times", "normal");
      var lines1 = doc.splitTextToSize(rechnung.rechnung_freitext, 168);
      doc.text(lines1, 20, 130);
      var zeile = 130 + parseInt(parseInt(6) * lines1.length);
      doc.setFont("Times", "bold");
      zeile = parseInt(zeile) + 5;
      doc.text("Pos", 20, zeile);
      doc.text("Beschreibung", 31, zeile);
      doc.text("Betrag", 190, zeile, { align: "right" });
      doc.setFont("Times", "normal");
      zeile = parseInt(zeile) + 2;
      doc.line(20, zeile, 190, zeile);
      zeile = parseInt(zeile) + 6;
      var pos = "1";
      var summe = 0;
      rechnung.positionen.forEach(function (position) {
        doc.text(pos, 20, zeile);
        doc.text(position.was, 31, zeile);
        doc.text(parseFloat(position.betrag).toFixed(2) + " €", 190, zeile, {
          align: "right"
        });
        summe = summe + parseFloat(position.betrag);
        zeile = parseInt(zeile) + 10;
        pos = String(parseInt(pos) + 1);
      });
      doc.line(20, zeile - 4, 190, zeile - 4);
      doc.setFont("Times", "bold");
      zeile = parseInt(zeile) + 1;
      doc.text("Summe " + summe.toFixed(2) + " €", 190, zeile, {
        align: "right"
      });
      doc.setFont("Times", "normal");
      zeile = parseInt(zeile) + 2;
      doc.line(159, zeile, 190, zeile);
      zeile = parseInt(zeile) + 1;
      doc.line(159, zeile, 190, zeile);
      doc.setFontSize(9);

      doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
      doc.rect(0, 265, 210, 297, "F");
      doc.setFontSize(10);
      doc.setTextColor(230, 230, 230);
      doc.setFont("Times", "bold");
      doc.text(this.settings.name, 60, 272, { align: "center" });
      doc.setFont("Times", "normal");
      doc.text(rechnung.kasse, 60, 280, { align: "center" });
      doc.text(this.settings.strasse + " " + this.settings.hausnummer, 60, 285, { align: "center" });
      doc.text(this.settings.plz + " " + this.settings.ort, 60, 290, {
        align: "center"
      });
      doc.setFont("Times", "bold");
      doc.text("Bankverbindung", 150, 272, { align: "center" });
      doc.setFont("Times", "normal");
      doc.text(kasse.kontoname, 150, 280, { align: "center" });
      doc.text(kasse.IBAN, 150, 285, { align: "center" });
      doc.text(kasse.BIC, 150, 290, { align: "center" });

      doc.save("Rechnung-" + rechnung.rechnungsnummer + "-" + bbr.nachname + "-" + bbr.vorname + ".pdf");
    }
  },
  errorCaptured: function errorCaptured(error, vm, info) {
    console.error("Error:", error);
    console.info("Info:", info);
    return false;
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'ebene', 'parent'],
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    getSum: function getSum(item, key) {
      var _this = this;

      var sum = 0;
      if (item.positionen && item.positionen.length > 0) {
        item.positionen.forEach(function (pos) {
          sum += _this.getSum(pos, key);
        });
      } else {
        if (key === 'istEinnahmen') {
          if ((parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === '') && (parseInt(item.istAusgaben) === 0 || item.istAusgaben === '')) {
            sum += parseInt(item.einnahmen ? item.einnahmen : 0);
          }
        }
        if (key === 'istAusgaben') {
          if ((parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === '') && (parseInt(item.istAusgaben) === 0 || item.istAusgaben === '')) {
            sum += parseInt(item.ausgaben ? item.ausgaben : 0);
          }
        }
        if (key === 'einnahmen' || 'ausgaben') {
          sum += parseInt(item[key] ? item[key] : 0);
        }
      }
      return sum;
    },
    addGroupRow: function addGroupRow(item) {
      console.log(item);
      if (item.positionen.length === 0) {
        item.positionen.push({
          bezeichnung: item.bezeichnung,
          show: true,
          positionen: [],
          einnahmen: item.einnahmen,
          ausgaben: item.ausgaben,
          istEinnahmen: item.istEinnahmen,
          istAusgaben: item.istAusgaben
        });
      } else {
        item.positionen.push({
          bezeichnung: 'Neu',
          show: true,
          positionen: [],
          einnahmen: 0,
          ausgaben: 0,
          istEinnahmen: 0,
          istAusgaben: 0
        });
      }
    },
    deleteRow: function deleteRow(item) {
      this.parent.positionen.splice(this.parent.positionen.indexOf(item), 1);
    },
    deleteGroupRow: function deleteGroupRow(item) {
      this.parent.positionen.splice(this.parent.positionen.indexOf(item), 1);
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    snackbar: function snackbar() {
      return this.$store.state.snackbar;
    }
  },
  methods: {
    close: function close() {
      this.$store.state.snackbar.show = false;
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_submodule_stammbaumKnotenNeu__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_submodule_stammbaumKnotenNeu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_submodule_stammbaumKnotenNeu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_svg_pan_zoom__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_svg_pan_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_svg_pan_zoom__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    stammbaumKnoten: __WEBPACK_IMPORTED_MODULE_1__module_submodule_stammbaumKnotenNeu___default.a,
    stammbaumKnotenAlt: __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten___default.a,
    SvgPanZoom: __WEBPACK_IMPORTED_MODULE_2_vue_svg_pan_zoom___default.a
  },
  props: ['bbr', 'currentBbr', 'dense', 'collapse'],
  data: function data() {
    return {
      date: '',
      screenwidth: this.$vuetify.breakpoint.width - 56,
      startJahr: new Date().getFullYear(),
      endJahr: 0
    };
  },

  computed: {
    svgHeight: function svgHeight() {
      console.log(this.leibfamilie);
      console.log(this.getArrayDepth(this.leibfamilie));
    },
    windowWidth: function windowWidth() {
      return window.innerWidth;
    },
    windowHeight: function windowHeight() {
      return window.innerHeight - 170;
    },
    kachelbreite: function kachelbreite() {
      return this.dense ? 200 : 250;
    },
    abstand: function abstand() {
      return this.dense ? 10 : 18;
    },
    leibfamilie: function leibfamilie() {
      this.blatt = 0;
      var grunder = void 0;
      var bbr = this.bbr;
      while (!grunder) {
        if (bbr.leibvater) {
          bbr = this.$store.getters['bbrbbr/bbr'](bbr.leibvater);
        } else {
          grunder = bbr;
        }
      }
      var sohn = this.getLeibsohn(bbr.id);
      var blatter = 0;
      if (sohn.length === 0) {
        blatter = 1;
      } else {
        sohn.forEach(function (item) {
          blatter += item.blatter;
        });
      }
      var leibfamilie = {
        blatter: blatter,
        bbr: grunder,
        sohn: sohn
      };
      leibfamilie.getArrayDepth = this.getArrayDepth(leibfamilie);
      return leibfamilie;
    }
  },
  methods: {
    getLeibsohn: function getLeibsohn(bbrID) {
      var _this = this;

      var leibsohn = [];
      this.$store.getters['bbrbbr/nurBbrbbr'].forEach(function (bbr) {
        if (bbr.leibvater === bbrID) {
          var sohn = _this.getLeibsohn(bbr.id);
          var blatter = 0;
          if (sohn.length === 0) {
            blatter = 1;
          } else {
            sohn.forEach(function (item) {
              blatter += item.blatter;
            });
          }
          var getArrayDepth = _this.getArrayDepth({
            blatter: blatter,
            bbr: bbr,
            sohn: sohn
          });
          leibsohn.push({
            blatter: blatter,
            bbr: bbr,
            sohn: sohn,
            getArrayDepth: getArrayDepth
          });
        }
      });
      if (leibsohn.length === 0) {
        this.blatt++;
      }
      return leibsohn;
    },
    downloadSVG: function downloadSVG(evt) {
      var svgContent = document.getElementById('svgStammbaum').outerHTML;
      var blob = new Blob([svgContent], { type: 'image/svg+xml' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'image.svg';
      link.click();
    },
    getArrayDepth: function getArrayDepth(array) {
      var _this2 = this;

      this.startJahr = Math.min(array.bbr.receptionsdatum.substr(0, 4), this.startJahr);
      this.endJahr = Math.max(array.bbr.receptionsdatum.substr(0, 4), this.endJahr);
      if (!array.sohn.length > 0) return 1;
      var max = 0;
      array.sohn.forEach(function (item) {
        max = Math.max(max, _this2.getArrayDepth(item));
      });
      return 1 + max;
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    stammbaumKnoten: __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnoten___default.a
  },
  props: ["bbr", "sohn", "blatter", "ebene", "currentBbr", "dense", "kachelbreite"],
  name: "stammbaumKnoten",
  data: function data() {
    return {
      date: ""
    };
  },

  computed: {
    svgHeight: function svgHeight() {
      return this.dense ? 20 : 32;
    },
    kanten: function kanten() {
      var _this = this;

      var kanten = [];
      var breite = this.blatter * 2;
      var curBreite = 0;
      var abstand = this.dense ? 10 : 18;
      this.sohn.forEach(function (item) {
        curBreite += item.blatter;
        kanten.push({
          x1: _this.blatter * (_this.kachelbreite + abstand) / 2,
          y1: 0,
          x2: _this.blatter * (_this.kachelbreite + abstand) / breite * curBreite,
          y2: _this.svgHeight
        });
        curBreite += item.blatter;
      });
      return kanten;
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnotenNeu__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnotenNeu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnotenNeu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    stammbaumKnoten: __WEBPACK_IMPORTED_MODULE_0__module_submodule_stammbaumKnotenNeu___default.a
  },
  props: ["bbr", "sohn", "blatter", "ebene", "currentBbr", "dense", "collapse", "kachelbreite", "startJahr", "xStart", "xMin", "xWidth", "xVater", "yVater", "getArrayDepth"],
  name: "stammbaumKnoten",
  data: function data() {
    return {
      date: ""
    };
  },

  computed: {
    x: function x() {
      console.log(this.bbr.nachname);
      console.log(this.xWidth);
      console.log(this.xStart);
      return 46;
    },
    y: function y() {
      return this.collapse ? this.yVater + 64 : (this.bbr.receptionsdatum.substring(0, 4) - this.startJahr) * 64;
    },
    svgHeight: function svgHeight() {
      return this.dense ? 20 : 32;
    },
    kanten: function kanten() {
      var _this = this;

      var kanten = [];
      var breite = this.blatter * 2;
      var curBreite = 0;
      var abstand = this.dense ? 10 : 18;
      this.sohn.forEach(function (item) {
        curBreite += item.blatter;
        kanten.push({
          x1: _this.blatter * (_this.kachelbreite + abstand) / 2,
          y1: _this.y + 44 + 0,
          x2: _this.blatter * (_this.kachelbreite + abstand) / breite * curBreite,
          y2: _this.y + 44 + _this.svgHeight
        });
        curBreite += item.blatter;
      });
      return kanten;
    }
  },
  methods: {
    calculateXStart: function calculateXStart(itemIndex, node) {
      var links = 0;
      var i = 0;
      while (i < itemIndex) {
        links = links + this.xWidth / this.blatter * this.sohn[i].blatter;
        i++;
      }

      return this.xWidth / this.blatter * this.sohn[itemIndex].blatter / 2 - 0 + links + this.xMin;
    },
    calculateXMin: function calculateXMin(itemIndex, node) {
      var links = 0;
      var i = 0;
      while (i < itemIndex) {
        links = links + this.xWidth / this.blatter * this.sohn[i].blatter;
        i++;
      }
      return links + this.xMin;
    }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      date: new Date(),
      datepicker: new Date().toISOString().substr(0, 10),
      pauschal: "",
      striche: "",
      getrankeselect: [],
      grund: "",
      bbrID: "",
      ekp: [],
      anzahlEkp: "",
      menu: false,
      strichAnzahl: 0,
      showStrichpreis: false,
      strichpreisNeu: 0
    };
  },

  computed: {
    strichpreis: function strichpreis() {
      var strichpreis = this.$store.getters["einstellungen/einstellung"]("strichpreis");
      if (strichpreis) {
        return strichpreis.strichpreis;
      } else {
        return "";
      }
    },
    summe: function summe() {
      var _this = this;

      var summe = 0;
      this.strichAnzahl = 0;
      this.stricheHeute.forEach(function (strich) {
        if (strich.art === "strich") {
          summe += parseFloat(strich.preis) * parseInt(strich.anzahl);
          _this.strichAnzahl += parseInt(strich.anzahl);
        }
        if (strich.art === "ekp") {
          summe += parseFloat(strich.preis);
        }
        if (strich.art === "pauschal") {
          summe += parseFloat(strich.preis);
        }
      });
      return summe;
    },
    stricheHeute: function stricheHeute() {
      var _this2 = this;

      if (this.$store.state.striche.loaded === false) {
        this.$store.dispatch("striche/loadStriche");
      }
      var striche = [];
      this.$store.state.striche.striche.forEach(function (strich) {
        var date = new Date(new Date(strich.date.seconds * 1000).setHours(0, 0, 0, 0));
        _this2.date = new Date(_this2.date.setHours(0, 0, 0, 0));
        if (date - _this2.date === 0) {
          var bbr = _this2.$store.getters["bbrbbr/bbr"](strich.bbrID);
          strich.bbr = bbr.nachname + ", " + bbr.vorname;
          striche.push(strich);
        }
      });
      return striche;
    },
    bundesbruderselect: function bundesbruderselect() {
      var items = this.$store.state.bbrbbr.bbrbbr;
      var bbrbbr = [];
      items.forEach(function (item) {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")"
          });
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ", " + item.vorname
          });
        }
      });
      return bbrbbr;
    }
  },
  methods: {
    stricheSet: function stricheSet(value) {
      if (!this.striche) {
        this.striche = 0;
      }
      if (this.striche + value >= 0) {
        this.striche = parseInt(this.striche) + parseInt(value);
      }
    },
    deleteStrich: function deleteStrich(value) {
      this.$store.dispatch("striche/deleteStrichData", value);
    },
    addDate: function addDate(value) {
      this.date = new Date(this.date.setDate(this.date.getDate() + value));
    },
    getDatepicker: function getDatepicker() {
      this.date = new Date(this.datepicker);
      this.datepicker = new Date(this.date).toISOString().substr(0, 10);
      this.menu = false;
    },
    saveStriche: function saveStriche() {
      if (this.bbrID) {
        if (this.striche) {
          var striche = {
            bbrID: this.bbrID,
            art: "strich",
            date: this.date,
            preis: this.strichpreis,
            anzahl: this.striche,
            status: "",
            grund: "Strich"
          };
          this.$store.dispatch("striche/createStrich", striche);
        }

        if (this.ekp.length > 0) {
          var ekp = {
            bbrID: this.bbrID,
            art: "ekp",
            ekp: this.ekp[0],
            date: this.date,
            preis: this.ekp[0].preis,
            anzahl: 1,
            status: "",
            grund: this.ekp[0].bezeichnung
          };
          for (this.anzahlEkp; parseInt(this.anzahlEkp) >= 1; this.anzahlEkp--) {
            this.$store.dispatch("striche/createStrich", ekp);
          }
        }

        var preis = parseFloat(this.pauschal.replace(",", ".")).toFixed(2);
        if (this.pauschal) {
          var pauschal = {
            bbrID: this.bbrID,
            art: "pauschal",
            preis: preis,
            date: this.date,
            grund: this.grund,
            anzahl: 1,
            status: ""
          };
          this.$store.dispatch("striche/createStrich", pauschal);
        }
        this.bbrID = "";
        this.striche = "";
        this.ekp = "";
        this.pauschal = "";
        this.grund = "";
        this.anzahlEkp = "";
      } else {
        console.log("Kein Bundesbruder ausgewählt.");
      }
    },
    saveStrichpreis: function saveStrichpreis() {
      var item = {
        id: "strichpreis",
        strichpreis: parseFloat(this.strichpreisNeu.replace(",", ".")).toFixed(2)
      };
      this.$store.dispatch("einstellungen/updateEinstellungData", item);
      this.showStrichpreis = false;
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("getranke").orderBy("bezeichnung").onSnapshot(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        if (doc.data().switchEkp) {
          _this3.getrankeselect.push({
            value: [{
              id: doc.id,
              preis: doc.data().verkauf1,
              bezeichnung: doc.data().bezeichnung
            }],
            text: doc.data().bezeichnung
          });
        }
      });
    }, function (err) {
      console.log("Encountered error: " + err);
    });
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["wer", "ToDo", "showTitle", "anzahl"],
  data: function data() {
    return {
      expanded: [],
      singleExpand: true,
      headers: [{ text: "", value: "data-table-expand" }, { text: "Aufgabe", value: "aufgabe" }, { text: "Bis", value: "bis" }, { text: "Wer", value: "wer" }, { text: "", value: "" }, { text: "", value: "" }],
      search: "",
      modalEdit: false,
      itemEdit: [],
      aufgabe: "",
      menu: false,
      date: "",
      bis: "",
      beschreibung: "",
      senior: false,
      consenior: false,
      fuxmajor: false,
      schriftführer: false,
      kassierer: false,
      hauswart: false,
      ToDos: []
    };
  },

  computed: {
    formatBis: function formatBis() {
      if (!this.bis) return null;
      return new Date(this.bis).toLocaleString(["de-de"], { month: "short", day: "numeric", year: "2-digit" });
    }
  },
  methods: {
    showModalEdit: function showModalEdit(item) {
      this.modalEdit = !this.modalEdit;
      this.itemEdit = item;
      this.aufgabe = item.aufgabe;
      this.bis = item.bis;
      this.senior = item.senior;
      this.consenior = item.consenior;
      this.fuxmajor = item.fuxmajor;
      this.schriftführer = item.schriftführer;
      this.kassierer = item.kassierer;
      this.hauswart = item.hauswart;
      this.beschreibung = item.beschreibung;
    },
    checkToDo: function checkToDo(item) {
      this.ToDos[this.ToDos.indexOf(item)].status = !this.ToDos[this.ToDos.indexOf(item)].status;
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("todo").doc(item.id).update(item).catch(function (error) {
        console.log(error);
      });
    },
    updateToDo: function updateToDo() {
      var _this = this;

      var item = {
        aufgabe: this.aufgabe,
        bis: this.bis,
        senior: this.senior,
        consenior: this.consenior,
        fuxmajor: this.fuxmajor,
        schriftführer: this.schriftführer,
        kassierer: this.kassierer,
        beschreibung: this.beschreibung
      };
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("todo").doc(this.itemEdit.id).update(item).then(function (key) {
        _this.aufgabe = "";
        _this.bis = "";
        _this.beschreibung = "";
        _this.senior = false;
        _this.consenior = false;
        _this.fuxmajor = false;
        _this.schriftführer = false;
        _this.kassierer = false;
        _this.modalEdit = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteToDo: function deleteToDo() {
      var _this2 = this;

      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("todo").doc(this.itemEdit.id).delete().then(function (key) {
        _this2.modalEdit = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    addToDo: function addToDo() {
      var _this3 = this;

      var item = {
        aufgabe: this.aufgabe,
        bis: this.bis,
        senior: this.senior,
        consenior: this.consenior,
        fuxmajor: this.fuxmajor,
        schriftführer: this.schriftführer,
        kassierer: this.kassierer,
        beschreibung: this.beschreibung
      };
      this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("todo").add(item).then(function (key) {
        _this3.aufgabe = "";
        _this3.bis = "";
        _this3.beschreibung = "";
        _this3.senior = false;
        _this3.consenior = false;
        _this3.fuxmajor = false;
        _this3.schriftführer = false;
        _this3.kassierer = false;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    this.$firebase.firestore().collection("vereine").doc(this.$vars.verbindung).collection("todo").orderBy("bis").onSnapshot(function (querySnapshot) {
      _this4.ToDos = [];
      switch (_this4.wer) {
        case "senior":
          querySnapshot.forEach(function (doc) {
            if (doc.data().senior) {
              _this4.ToDos.push({
                id: doc.id,
                aufgabe: doc.data().aufgabe,
                senior: doc.data().senior,
                consenior: doc.data().consenior,
                fuxmajor: doc.data().fuxmajor,
                schriftführer: doc.data().schriftführer,
                kassierer: doc.data().kassierer,
                hauswart: doc.data().hauswart,
                bis: doc.data().bis,
                beschreibung: doc.data().beschreibung,
                status: doc.data().status
              });
            }
          });
          break;
        case "consenior":
          querySnapshot.forEach(function (doc) {
            if (doc.data().consenior) {
              _this4.ToDos.push({
                id: doc.id,
                aufgabe: doc.data().aufgabe,
                senior: doc.data().senior,
                consenior: doc.data().consenior,
                fuxmajor: doc.data().fuxmajor,
                schriftführer: doc.data().schriftführer,
                kassierer: doc.data().kassierer,
                hauswart: doc.data().hauswart,
                bis: doc.data().bis,
                beschreibung: doc.data().beschreibung,
                status: doc.data().status
              });
            }
          });
          break;
        case "fuxmajor":
          querySnapshot.forEach(function (doc) {
            if (doc.data().fuxmajor) {
              _this4.ToDos.push({
                id: doc.id,
                aufgabe: doc.data().aufgabe,
                senior: doc.data().senior,
                consenior: doc.data().consenior,
                fuxmajor: doc.data().fuxmajor,
                schriftführer: doc.data().schriftführer,
                kassierer: doc.data().kassierer,
                hauswart: doc.data().hauswart,
                bis: doc.data().bis,
                beschreibung: doc.data().beschreibung,
                status: doc.data().status
              });
            }
          });
          break;
        case "schriftfuhrer":
          querySnapshot.forEach(function (doc) {
            if (doc.data().schriftführer) {
              _this4.ToDos.push({
                id: doc.id,
                aufgabe: doc.data().aufgabe,
                senior: doc.data().senior,
                consenior: doc.data().consenior,
                fuxmajor: doc.data().fuxmajor,
                schriftführer: doc.data().schriftführer,
                kassierer: doc.data().kassierer,
                hauswart: doc.data().hauswart,
                bis: doc.data().bis,
                beschreibung: doc.data().beschreibung,
                status: doc.data().status
              });
            }
          });
          break;
        case "kassierer":
          querySnapshot.forEach(function (doc) {
            if (doc.data().kassierer) {
              _this4.ToDos.push({
                id: doc.id,
                aufgabe: doc.data().aufgabe,
                bis: doc.data().bis,
                senior: doc.data().senior,
                consenior: doc.data().consenior,
                fuxmajor: doc.data().fuxmajor,
                schriftführer: doc.data().schriftführer,
                kassierer: doc.data().kassierer,
                beschreibung: doc.data().beschreibung,
                status: doc.data().status
              });
            }
          });
          break;
        case "alle":
          querySnapshot.forEach(function (doc) {
            var wer = "";
            if (doc.data().senior) {
              wer = wer + "X, ";
            }
            if (doc.data().consenior) {
              wer = wer + "XX, ";
            }
            if (doc.data().fuxmajor) {
              wer = wer + "FM, ";
            }
            if (doc.data().schriftführer) {
              wer = wer + "XXX, ";
            }
            if (doc.data().kassierer) {
              wer = wer + "XXXX, ";
            }
            wer = wer.substr(0, wer.length - 2);
            _this4.ToDos.push({
              id: doc.id,
              aufgabe: doc.data().aufgabe,
              bis: doc.data().bis,
              wer: wer,
              senior: doc.data().senior,
              consenior: doc.data().consenior,
              fuxmajor: doc.data().fuxmajor,
              schriftführer: doc.data().schriftführer,
              kassierer: doc.data().kassierer,
              beschreibung: doc.data().beschreibung,
              status: doc.data().status
            });
          });
          break;
        default:
          return 0;
      }
    }, function (err) {
      console.log("Encountered error: " + err);
    });
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['props'],
  data: function data() {
    return {
      tab: null
    };
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['submodule'],
  data: function data() {
    return {
      search: ''
    };
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["kalender"],
  data: function data() {
    return {
      search: "",
      showVeranstaltungEdit: false,
      showNeueVeranstaltung: false,
      start: new Date().toISOString().substr(0, 10),
      now: new Date().toISOString().substr(0, 10),
      shortWeekdays: true,
      shortMonths: true,
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      neueVeranstaltung: {
        kalender: this.kalender[0]
      },
      kleiderordnungen: ["Gepflegt leger", "Gepflegt leger mit Hemd", "Kombination", "Kombination mit plenis coloribus", "Dunkler Anzug", "Dunkler Anzug mit plenis coloribus", "Abendgarderobe"],
      gruppen: [{ text: "Füxe", value: "Fux" }, { text: "Aktive", value: "Aktiver" }, { text: "Inaktive in loco", value: "Inaktiver in loco" }, { text: "Inaktive extra locum", value: "Inaktiver extra locum" }],
      istNeu: false,
      date: "",
      menu1: "",
      menu2: "",
      menu3: "",
      menu4: "",
      menu5: "",
      neueAnmeldung: "",
      neueAnmeldungWeitere: {},
      showDeleteVeranstaltung: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    itemsKalender: function itemsKalender() {
      var _this = this;

      var kalender = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters["einstellungen/einstellung"]("alleKalender")).forEach(function (key) {
        if (key !== "id") {
          kalender.push({
            value: _this.$store.getters["einstellungen/einstellung"]("alleKalender")[key].name,
            text: _this.$store.getters["einstellungen/einstellung"]("alleKalender")[key].name
          });
        }
      });
      return kalender;
    },
    formatVonDatum: function formatVonDatum() {
      if (!this.neueVeranstaltung.vonDatum) return null;
      return new Date(this.neueVeranstaltung.vonDatum).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    formatBisDatum: function formatBisDatum() {
      if (!this.neueVeranstaltung.bisDatum) return null;
      return new Date(this.neueVeranstaltung.bisDatum).toLocaleString(["de-de"], {
        month: "short",
        weekday: "short",
        day: "numeric",
        year: "2-digit"
      });
    },
    eventsMap: function eventsMap() {
      var map = {};
      this.events.forEach(function (e) {
        return (map[e.date] = map[e.date] || []).push(e);
      });
      return map;
    },
    events: function events() {
      var events = this.$store.state.veranstaltungen.veranstaltungen;
      events.forEach(function (event) {
        event.start = event.vonDatum + " " + event.vonZeit;
        event.end = event.bisDatum;
        event.name = event.titel;
      });
      return events;
    }
  },
  methods: {
    changeVonDatum: function changeVonDatum() {
      if (!this.neueVeranstaltung.bisDatum) {
        this.neueVeranstaltung.bisDatum = this.neueVeranstaltung.vonDatum;
      }
      if (!this.neueVeranstaltung.bisZeit) {
        this.neueVeranstaltung.bisZeit = "23:55";
      }
      if (!this.neueVeranstaltung.vonZeit) {
        this.neueVeranstaltung.vonZeit = "20:15";
      }
    },
    getEventColor: function getEventColor(event) {
      var kalender = this.$store.getters["einstellungen/einstellung"]("alleKalender").find(function (item) {
        return item.name === event.kalender;
      });
      var farbe = void 0;
      if (kalender) {
        farbe = kalender.farbe.hex;
      } else {
        farbe = "#ff";
      }
      return farbe;
    },

    allowedMinutes: function allowedMinutes(m) {
      return m % 5 === 0;
    },
    saveVeranstaltung: function saveVeranstaltung() {
      var _this2 = this;

      this.neueVeranstaltung.anmeldungen = [];
      this.neueVeranstaltung.weitereAnmeldungen = [];
      if (this.neueVeranstaltung.pflichtanmeldungen) {
        this.neueVeranstaltung.pflichtanmeldungen.forEach(function (status) {
          _this2.$store.getters["bbrbbr/bbrStatus"](status).forEach(function (bbr) {
            if (_this2.neueVeranstaltung.anmeldungen.indexOf(bbr.id) === -1) {
              _this2.neueVeranstaltung.anmeldungen.push(bbr.id);
            }
          });
        });
      } else {
        this.neueVeranstaltung.pflichtanmeldungen = [];
      }
      this.$store.dispatch("veranstaltungen/createVeranstaltung", this.neueVeranstaltung);
      this.neueVeranstaltung = {};
      this.showNeueVeranstaltung = false;
    },
    showEvent: function showEvent(_ref) {
      var _this3 = this;

      var nativeEvent = _ref.nativeEvent,
          event = _ref.event;

      var open = function open() {
        _this3.selectedEvent = event;
        _this3.selectedElement = nativeEvent.target;
        setTimeout(_this3.selectedOpen = true, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    anmeldungEntfernen: function anmeldungEntfernen(item) {
      this.neueVeranstaltung.anmeldungen.splice(this.neueVeranstaltung.anmeldungen.indexOf(item), 1);
    },
    anmeldungHinzufuegen: function anmeldungHinzufuegen() {
      if (this.neueVeranstaltung.anmeldungen.indexOf(this.neueAnmeldung) === -1) {
        this.neueVeranstaltung.anmeldungen.push(this.neueAnmeldung);
      }
      this.neueAnmeldung = "";
    },
    anmeldungEntfernenWeitere: function anmeldungEntfernenWeitere(item) {
      this.neueVeranstaltung.weitereAnmeldungen.splice(this.neueVeranstaltung.weitereAnmeldungen.indexOf(item), 1);
    },
    anmeldungHinzufuegenWeitere: function anmeldungHinzufuegenWeitere() {
      this.neueVeranstaltung.weitereAnmeldungen.push({
        angemeldetVon: this.neueAnmeldungWeitere.angemeldetVon,
        name: this.neueAnmeldungWeitere.name
      });
      this.neueAnmeldungWeitere = {};
    },
    addEvent: function addEvent(_ref2) {
      var date = _ref2.date;
    },
    showDay: function showDay(_ref3) {
      var date = _ref3.date;
    },
    setToday: function setToday() {
      this.start = new Date().toISOString().substr(0, 10);
    },
    open: function open(event) {
      alert(event.title);
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jspdf__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["kasse"],
  data: function data() {
    return {
      neuerEintrag: {},
      showNewEintrag: false,
      istNeu: undefined,
      headers: [{ text: "Bezeichnung", value: "bezeichnung" }, { text: "Stand", value: "datum" }, { text: "Erstellt von", value: "erstelltVon" }, { text: "Zuletzt bearbeitet", value: "bearbeitetVon" }, { text: "", value: "" }],
      headersTabelle: [{ text: "Position", value: "id" }, { text: "Bezeichnung", value: "" }, { text: "", value: "" }, { text: "", value: "" }, { text: "", value: "" }, { text: "Soll-Einnahmen", value: "" }, { text: "Soll-Ausgaben", value: "" }, { text: "", value: "" }, { text: "Ist-Einnahmen", value: "" }, { text: "Ist-Ausgaben", value: "" }, { text: "", value: "" }, { text: "Differenz", value: "" }, { text: "", value: "" }],
      expanded: []
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    wirtschaftsplane: function wirtschaftsplane() {
      if (this.$store.state.wirtschaftsplane.loaded === false) {
        this.$store.dispatch("wirtschaftsplane/loadWirtschaftsplane");
      }
      return this.$store.getters["wirtschaftsplane/wirtschaftsplane"];
    },
    summen: function summen() {
      var _this = this;

      var summen = [0, 0, 0, 0];
      if (this.neuerEintrag.wirtschaftsplan) {
        this.neuerEintrag.wirtschaftsplan.forEach(function (positionen) {
          positionen.einnahmen = 0;
          positionen.ausgaben = 0;
          positionen.istEinnahmen = 0;
          positionen.istAusgaben = 0;
          positionen.positionen.forEach(function (position) {
            positionen.einnahmen += parseFloat(_this.getSum(position, "einnahmen"));
            positionen.ausgaben += parseFloat(_this.getSum(position, "ausgaben"));
            positionen.istEinnahmen += parseFloat(_this.getSum(position, "istEinnahmen"));
            positionen.istAusgaben += parseFloat(_this.getSum(position, "istAusgaben"));
          });
          summen[0] += parseFloat(positionen.einnahmen);
          summen[1] += parseFloat(positionen.ausgaben);
          summen[2] += parseFloat(positionen.istEinnahmen);
          summen[3] += parseFloat(positionen.istAusgaben);
        });
      }
      return summen;
    },
    sideHeight: function sideHeight() {
      if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 161px)";
          case "sm":
            return "calc(100vh - 149px)";
          case "md":
            return "calc(100vh - 169px)";
          case "lg":
            return "calc(100vh - 225px)";
          case "xl":
            return "calc(100vh - 225px)";
        }
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 169px)";
          case "sm":
            return "calc(100vh - 169px)";
          case "md":
            return "calc(100vh - 169px)";
          case "lg":
            return "calc(100vh - 169px)";
          case "xl":
            return "calc(100vh - 169px)";
        }
      }
    }
  },
  methods: {
    onChange: function onChange() {
      console.log("test");
    },
    getSum: function getSum(item, key) {
      var _this2 = this;

      var sum = 0;
      if (item.positionen && item.positionen.length > 0) {
        item.positionen.forEach(function (pos) {
          sum += _this2.getSum(pos, key);
        });
      } else {
        if (key === "istEinnahmen") {
          if ((parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === "") && (parseInt(item.istAusgaben) === 0 || item.istAusgaben === "")) {
            sum += parseInt(item.istEinnahmen ? item.istEinnahmen : 0);
          }
        }
        if (key === "istAusgaben") {
          if ((parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === "") && (parseInt(item.istAusgaben) === 0 || item.istAusgaben === "")) {
            sum += parseInt(item.istAusgaben ? item.istAusgaben : 0);
          }
        }
        if (key === "einnahmen" || "ausgaben") {
          sum += parseInt(item[key] ? item[key] : 0);
        }
      }
      return sum;
    },
    getDiff: function getDiff(item) {
      var diff = 0;
      diff += parseFloat(item.istEinnahmen ? item.istEinnahmen : 0);
      diff -= parseFloat(item.einnahmen ? item.einnahmen : 0);
      diff -= parseFloat(item.istAusgaben ? item.istAusgaben : 0);
      diff += parseFloat(item.ausgaben ? item.ausgaben : 0);
      return diff;
    },
    saveNeuEintrag: function saveNeuEintrag() {
      this.neuerEintrag.datum = new Date();
      this.neuerEintrag.erstelltVon = this.currentBbr;
      this.neuerEintrag.zuletztBearbeitet = this.currentBbr;
      this.$store.dispatch("wirtschaftsplane/createWirtschaftsplan", this.neuerEintrag);
      this.neuerEintrag = {};
      this.showNewEintrag = false;
    },
    saveEintrag: function saveEintrag() {
      this.neuerEintrag.datum = new Date();
      this.neuerEintrag.zuletztBearbeitet = this.currentBbr;
      this.$store.dispatch("wirtschaftsplane/updateWirtschaftsplanData", this.neuerEintrag);
      this.neuerEintrag = {};
      this.showNewEintrag = false;
    },
    addRow: function addRow(index) {
      this.neuerEintrag.wirtschaftsplan[index].positionen.push({
        bezeichnung: "Neu",
        show: true,
        positionen: [],
        einnahmen: 0,
        ausgaben: 0,
        istEinnahmen: 0,
        istAusgaben: 0
      });
    },
    deleteRow: function deleteRow(item, index) {
      this.neuerEintrag.wirtschaftsplan[index].positionen.splice(this.neuerEintrag.wirtschaftsplan[index].positionen.indexOf(item), 1);
    },
    addGroupRow: function addGroupRow(item) {
      console.log("2");
      if (item.positionen.length === 0) {
        item.positionen.push({
          bezeichnung: item.bezeichnung,
          show: true,
          positionen: [],
          einnahmen: item.einnahmen,
          ausgaben: item.ausgaben,
          istEinnahmen: item.istEinnahmen,
          istAusgaben: item.istAusgaben
        });
      } else {
        item.positionen.push({
          bezeichnung: "Neu",
          show: true,
          positionen: [],
          einnahmen: 0,
          ausgaben: 0,
          istEinnahmen: 0,
          istAusgaben: 0
        });
      }
    },
    deleteGroupRow: function deleteGroupRow(item, index, index2) {
      this.neuerEintrag.wirtschaftsplan[index].positionen[index2].positionen.splice(this.neuerEintrag.wirtschaftsplan[index].positionen[index2].positionen.indexOf(item), 1);
    },
    addBlock: function addBlock() {
      if (this.neuerEintrag.wirtschaftsplan === undefined) {
        this.neuerEintrag.wirtschaftsplan = [];
      }
      this.neuerEintrag.wirtschaftsplan.push({
        titel: "",
        positionen: [],
        ausgaben: 0,
        einnahmen: 0,
        istEinnahmen: 0,
        istAusgaben: 0
      });
    },
    deleteBlock: function deleteBlock(item) {
      this.neuerEintrag.wirtschaftsplan.splice(this.neuerEintrag.wirtschaftsplan.indexOf(item), 1);
    },
    clickRow: function clickRow(value) {
      console.log(this.expanded);
      var index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded = [];
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    print: function print(item) {
      var _this3 = this;

      console.log("print");
      var doc = new __WEBPACK_IMPORTED_MODULE_0_jspdf__["default"]({
        orientation: "p",
        unit: "mm",
        format: "a3"
      });
      var links = 20;


      console.log(doc.getFontList());
      doc.setFont("Courier");
      doc.setFillColor(39, 84, 165);
      doc.rect(0, 0, 297, 30, "F");

      doc.setFontSize(32);
      doc.setTextColor(255, 255, 255);
      doc.text(20, 25, item.titel);
      doc.setFontSize(9);
      doc.text(277, 25, new Date().toLocaleString(["de-de"], {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      }) + " Uhr", { align: "right" });
      doc.setTextColor(0, 0, 0);
      var zeile = 50;

      item.wirtschaftsplan.forEach(function (block, index) {
        var start = zeile;
        doc.setFillColor("#2196F3");
        doc.roundedRect(15, start - 8, 267, 19, 3, 3, "F");
        doc.rect(15, start, 267, 11, "F");
        doc.setFontSize(20);
        doc.text(20, zeile, index + 1 + ". " + block.titel);
        zeile += 8;
        doc.setFontSize(9);
        doc.setFont("Courier", "bold");
        doc.text("Bezeichnung", links, zeile, { align: "left" });
        doc.text("Soll-Einnahmen", 150, zeile, { align: "right" });
        doc.text("Soll-Ausgaben", 180, zeile, { align: "right" });
        doc.text("Ist-Einnahmen", 210, zeile, { align: "right" });
        doc.text("Ist-Ausgaben", 240, zeile, { align: "right" });
        doc.text("Differenz", 270, zeile, { align: "right" });
        doc.setFont("Courier", "normal");
        doc.setTextColor(0, 0, 0);
        zeile += 8;
        block.positionen.forEach(function (pos) {
          zeile = _this3.drawPosition(doc, pos, zeile, links, 1);
        });
        doc.setFillColor("#2196F3");
        doc.setDrawColor("#2196F3");
        doc.rect(15, zeile - 5, 267, 5, "F");
        doc.roundedRect(15, zeile - 5, 267, 10, 3, 3, "F");
        doc.setFont("Courier", "bold");
        doc.text("Summe", links, zeile, { align: "left" });
        doc.text(parseFloat(_this3.getSum(block, "einnahmen")).toFixed(2) + " €", 150, zeile, { align: "right" });
        doc.text(parseFloat(_this3.getSum(block, "ausgaben")).toFixed(2) + " €", 180, zeile, { align: "right" });
        doc.text(parseFloat(_this3.getSum(block, "istEinnahmen")).toFixed(2) + " €", 210, zeile, { align: "right" });
        doc.text(parseFloat(_this3.getSum(block, "istAusgaben")).toFixed(2) + " €", 240, zeile, { align: "right" });
        doc.text("", 270, zeile, { align: "right" });
        doc.setFont("Courier", "normal");
        zeile += 10;
        doc.roundedRect(15, start - 8, 267, zeile - start + 3, 3, 3, "S");
        zeile += 10;
      });

      doc.save("Wirtschaftsplan.pdf");
    },
    drawPosition: function drawPosition(doc, position, zeile, links, ebene) {
      var _this4 = this;

      doc.setFontSize(10);
      if (ebene === 1) {
        doc.setFillColor("#BBDEFB");
        doc.rect(15, zeile - 5, 267, 10, "F");
      }
      doc.text(links, zeile, position.bezeichnung);
      if (position.positionen) {
        doc.text(parseFloat(this.getSum(position, "einnahmen")).toFixed(2) + " €", 150, zeile, { align: "right" });
        doc.text(parseFloat(this.getSum(position, "ausgaben")).toFixed(2) + " €", 180, zeile, { align: "right" });
        doc.text(parseFloat(this.getSum(position, "istEinnahmen")).toFixed(2) + " €", 210, zeile, { align: "right" });
        doc.text(parseFloat(this.getSum(position, "istAusgaben")).toFixed(2) + " €", 240, zeile, { align: "right" });
      } else {
        if (position.einnahmen !== 0 && position.einnahmen !== "") {
          doc.text(parseFloat(position.einnahmen).toFixed(2) + " €", 150, zeile, { align: "right" });
        } else {
          doc.text("-", 150, zeile, { align: "right" });
        }
        if (position.ausgaben !== 0 && position.ausgaben !== "") {
          doc.text(parseFloat(position.ausgaben).toFixed(2) + " €", 180, zeile, { align: "right" });
        } else {
          doc.text("-", 180, zeile, { align: "right" });
        }
        if (position.istEinnahmen !== 0 && position.istEinnahmen !== "") {
          doc.text(parseFloat(position.istEinnahmen).toFixed(2) + " €", 210, zeile, { align: "right" });
        } else {
          doc.text("-", 210, zeile, { align: "right" });
        }
        if (position.istAusgaben !== 0 && position.istAusgaben !== "") {
          doc.text(parseFloat(position.istAusgaben).toFixed(2) + " €", 240, zeile, { align: "right" });
        } else {
          doc.text("-", 240, zeile, { align: "right" });
        }
      }
      if (position.istEinnahmen !== 0 || position.istAusgaben !== 0) {
        doc.text(parseFloat(this.getDiff(position)).toFixed(2) + " €", 270, zeile, { align: "right" });
      } else {
        doc.text("-", 270, zeile, { align: "right" });
      }
      zeile += 10;

      if (position.positionen.length > 0) {
        position.positionen.forEach(function (subpos) {
          zeile = _this4.drawPosition(doc, subpos, zeile, links + 10, ebene + 1);
        });
      }
      return zeile;
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["zirkel", "berechtigt"],
  data: function data() {
    return {
      showNeueMail: false,
      loading: false,
      bbr: {},
      showKontakt: false,
      showAddKontakt: false,
      showRemoveKontakt: false,
      showMail: false,
      nachricht: {
        an: [],
        message: {},
        absender: {}
      }
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    bbrbbrselect: function bbrbbrselect() {
      var bbrbbrselect = [];
      this.$store.getters["bbrbbr/nurBbrbbr"].forEach(function (bbr) {
        bbrbbrselect.push({
          value: bbr,
          text: bbr.nachname + ", " + bbr.vorname
        });
      });
      return bbrbbrselect;
    },
    mitglieder: function mitglieder() {
      var _this = this;

      return this.bbrbbr.filter(function (bbr) {
        return bbr.zirkel === _this.zirkel;
      });
    },
    veranstaltungen: function veranstaltungen() {
      var _this2 = this;

      return this.$store.state.veranstaltungen.veranstaltungen.filter(function (event) {
        return event.kalender === "AH-Zirkel " + _this2.zirkel;
      });
    },
    nachrichten: function nachrichten() {
      if (this.$store.state.mails.loaded === false) {
        this.$store.dispatch("mails/loadMails");
      }
      return this.$store.getters["mails/gesendeteMails"](this.currentBbr).slice(0, 6);
    }
  },
  methods: {
    removeBbrFromZirkel: function removeBbrFromZirkel() {
      this.bbr.zirkel = "";
      this.$store.dispatch("bbrbbr/updateBbrData", this.bbr);
      this.showRemoveKontakt = false;
    },
    addBbrToZirkel: function addBbrToZirkel() {
      this.bbr.zirkel = this.zirkel;
      this.$store.dispatch("bbrbbr/updateBbrData", this.bbr);
      this.showAddKontakt = false;
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      date: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substr(0, 7),
      menu: false,
      max: new Date(0).toISOString().substr(0, 7),
      min: new Date().toISOString().substr(0, 7)
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    nurbbrbbr: function nurbbrbbr() {
      return this.$store.getters["bbrbbr/nurBbrbbr"];
    },
    statistiken: function statistiken() {
      var _this = this;

      if (this.$store.state.statistiken.statistiken.length === 0) {
        this.$store.dispatch("statistiken/loadStatistiken");
      }
      this.$store.state.statistiken.statistiken.forEach(function (item) {
        if (new Date(item.monat).toISOString().substr(0, 7) < _this.min) {
          _this.min = new Date(item.monat).toISOString().substr(0, 7);
        }
        if (new Date(item.monat).toISOString().substr(0, 7) > _this.max) {
          _this.max = new Date(item.monat).toISOString().substr(0, 7);
        }
      });
      return this.$store.state.statistiken.statistiken;
    },
    statistik: function statistik() {
      var monat = this.date;
      var selectStatistik = this.statistiken.find(function (statistik) {
        return statistik.monat === monat;
      });
      var stricheProBbrSortiert = [];
      if (selectStatistik !== undefined) {
        for (var item in selectStatistik.stricheProBbr) {
          var bbr = this.$store.getters["bbrbbr/bbr"](item);
          if (bbr.status !== "Chargen & Ämter") {
            stricheProBbrSortiert.push([item, selectStatistik.stricheProBbr[item]]);
          }
        }
        if (stricheProBbrSortiert.length > 0) {
          stricheProBbrSortiert.sort(function (a, b) {
            return b[1] - a[1];
          });
          stricheProBbrSortiert = stricheProBbrSortiert.slice(0, 5);
        }
      }
      return stricheProBbrSortiert;
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bundesbruder: '',
      bbr: [],
      showBbr: false
    };
  },

  computed: {
    bezMitglieder: function bezMitglieder() {
      return this.$store.state.einstellungen.einstellungen.find(function (item) {
        return item.id === 'allgemein';
      }).bezMitglieder1;
    },
    selectBundesbruder: function selectBundesbruder() {
      var items = this.$store.getters['bbrbbr/nurBbrbbr'];
      return items.map(function (item) {
        return {
          value: item.id,
          text: item.nachname + ', ' + item.vorname + (item.vulgo ? ' (' + item.vulgo + ')' : '')
        };
      });
    }
  },
  methods: {
    selectBbr: function selectBbr() {
      this.bbr = this.$store.getters['bbrbbr/bbr'](this.bundesbruder);
      this.showBbr = true;
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dark'],
  data: function data() {
    return {
      bundesbruder: '',
      bbr: [],
      showBbr: false
    };
  },

  computed: {
    selectBundesbruder: function selectBundesbruder() {
      var items = this.$store.getters['bbrbbr/nurBbrbbr'];
      return items.map(function (item) {
        return {
          value: item.id,
          text: item.nachname + ', ' + item.vorname + (item.vulgo ? ' (' + item.vulgo + ')' : '')
        };
      });
    }
  },
  methods: {
    selectBbr: function selectBbr() {
      this.bbr = this.$store.getters['bbrbbr/bbr'](this.bundesbruder);
      this.showBbr = true;
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["vorstand", "kontaktbbr", "showTitle"],
  data: function data() {
    return {
      showKontakt: false,
      bbr: "false"
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    chargen: function chargen() {
      var _this = this;

      var items = void 0;
      if (this.$store.state.einstellungen.einstellungen.length > 0) {
        items = this.$store.getters["einstellungen/einstellung"]("rollen").seiten;
      }
      var chargen = {};
      if (items) {
        if (this.vorstand === "Aktivitas") {
          chargen.Senior = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Senior";
          }).berechtigt[0]);
          chargen.Senior.chargenmail = "x@kdstv-ripuaria.de";
          chargen.Consenior = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Consenior";
          }).berechtigt[0]);
          chargen.Consenior.chargenmail = "xx@kdstv-ripuaria.de";
          chargen.Fuxmajor = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Fuxmajor";
          }).berechtigt[0]);
          chargen.Fuxmajor.chargenmail = "fm@kdstv-ripuaria.de";
          chargen.Schriftführer = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Schriftführer";
          }).berechtigt[0]);
          chargen.Schriftführer.chargenmail = "xxx@kdstv-ripuaria.de";
          chargen.Kassierer = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Kassierer";
          }).berechtigt[0]);
          chargen.Kassierer.chargenmail = "xxxx@kdstv-ripuaria.de";
        }
        if (this.vorstand === "AHV-Vorstand") {
          chargen.Senior = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Philistersenior";
          }).berechtigt[0]);
          chargen.Senior.chargenmail = chargen.Senior.email;
          chargen.Consenior = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Philisterconsenior";
          }).berechtigt[0]);
          chargen.Consenior.chargenmail = chargen.Consenior.email;
          chargen.Schriftführer = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Philisterschriftführer";
          }).berechtigt[0]);
          chargen.Schriftführer.chargenmail = chargen.Schriftführer.email;
          chargen.Kassierer = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "Philisterkassierer";
          }).berechtigt[0]);
          chargen.Kassierer.chargenmail = chargen.Kassierer.email;
        }
        if (this.vorstand === "HBV-Vorstand") {
          chargen.Vorsitzender = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "HBV Vorsitzender";
          }).berechtigt[0]);
          chargen.Vorsitzender.chargenmail = chargen.Vorsitzender.email;
          chargen["Stv. Vorsitzender"] = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "HBV Stv. Vorsitzender";
          }).berechtigt[0]);
          chargen["Stv. Vorsitzender"].chargenmail = chargen["Stv. Vorsitzender"].email;
          chargen.Schriftführer = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "HBV Schriftführer";
          }).berechtigt[0]);
          chargen.Schriftführer.chargenmail = chargen.Schriftführer.email;
          chargen.Kassierer = this.$store.getters["bbrbbr/bbr"](items.find(function (item) {
            return item.titel === "HBV Kassierer";
          }).berechtigt[0]);
          chargen.Kassierer.chargenmail = chargen.Kassierer.email;
        }
        if (this.vorstand === "Ämter") {
          chargen = items.filter(function (item) {
            return item.gruppe === _this.vorstand;
          });
        }
        if (this.vorstand === "Kommissionen") {
          chargen = items.filter(function (item) {
            return item.gruppe === _this.vorstand;
          });
        }
        if (this.vorstand === "Zirkel") {
          chargen = items.filter(function (item) {
            return item.gruppe === _this.vorstand;
          });
        }
        if (this.vorstand === "Ripuarentage") {
          chargen.Organisation = this.bbrbbr.find(function (item) {
            return item.email === "stephan.buecker@t-online.de";
          });
          chargen.Organisation.chargenmail = chargen.Organisation.email;
        }
      }
      return chargen;
    }
  },
  methods: {
    showBbr: function showBbr(bbr) {
      this.bbr = this.$store.getters["bbrbbr/bbr"](bbr);
      this.showKontakt = true;
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["short"],
  data: function data() {
    return {
      bbr: {},
      showKontakt: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    geburtstage: function geburtstage() {
      var bbrbbr = this.$store.getters["bbrbbr/nurBbrbbr"];
      var heute = new Date().setDate(new Date().getDate() - 1);
      var ergebnis = bbrbbr.filter(function (bbr) {
        return bbr.geburtsdatum;
      }).map(function (bbr) {
        var geburtsdatum = new Date(bbr.geburtsdatum);
        var alter = new Date().getFullYear() - geburtsdatum.getFullYear();
        return {
          bbr: bbr,
          bbrID: bbr.id,
          geburtsdatum: geburtsdatum,
          alter: alter
        };
      }).flatMap(function (item) {
        var newItem1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          geburtsdatum: new Date(new Date(item.geburtsdatum).setFullYear(new Date().getFullYear()))
        });
        var newItem2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          geburtsdatum: new Date(new Date(item.geburtsdatum).setFullYear(new Date().getFullYear() + 1))
        });
        return [newItem1, newItem2];
      }).filter(function (item) {
        return item.geburtsdatum >= heute;
      }).sort(function (a, b) {
        return a.geburtsdatum - b.geburtsdatum;
      }).slice(0, this.short ? 4 : 10);
      return ergebnis;
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["semester"],
  data: function data() {
    return {
      bbr: {},
      showKontakt: false,
      currentYear: new Date().getFullYear()
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    jubilaeum: function jubilaeum() {
      var _this = this;

      var bbrbbr = this.$store.getters["bbrbbr/nurBbrbbr"];

      var heute = new Date(new Date().getFullYear(), 0, 1);
      var ergebnis = bbrbbr.filter(function (bbr) {
        return bbr.receptionsdatum;
      }).map(function (bbr) {
        var receptionsdatum = new Date(bbr.receptionsdatum);
        var alter = new Date().getFullYear() - receptionsdatum.getFullYear();
        return {
          bbr: bbr,
          bbrID: bbr.id,
          receptionsdatum: receptionsdatum,
          alter: alter
        };
      }).flatMap(function (item) {
        var newItem1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          receptionsdatum: new Date(new Date(item.receptionsdatum).setFullYear(new Date().getFullYear()))
        });

        return [newItem1];
      }).filter(function (item) {
        return item.receptionsdatum >= heute;
      }).filter(function (item) {
        return item.alter % (_this.semester / 2) === 0 && item.alter >= 1;
      }).sort(function (a, b) {
        return a.receptionsdatum - b.receptionsdatum;
      });

      return ergebnis;
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bbr: {},
      showKontakt: false,
      showKontaktNeu: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.getters['bbrbbr/bbrStatus']('Spefux');
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['status'],
  data: function data() {
    return {
      bbr: {},
      showKontakt: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.getters['bbrbbr/bbrStatus'](this.status);
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["bbr"],
  computed: {
    nachrichten: function nachrichten() {
      if (this.$store.state.mails.loaded === false) {
        this.$store.dispatch("mails/loadMails");
      }
      return this.$store.getters["mails/eigeneMails"](this.bbr);
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectRechnung: {},
      showRechnung: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    rechnungen: function rechnungen() {
      if (this.$store.state.rechnungen.loaded === false) {
        this.$store.dispatch("rechnungen/loadRechnungen");
      }
      var rechnungen = [];
      this.$store.state.rechnungen.rechnungen.forEach(function (item) {
        rechnungen.push({
          value: item.id,
          text: item.rechnungsnummer + " " + item.bbr + " " + item.summe.toFixed(2) + "€",
          item: item
        });
      });
      rechnungen.sort(function (a, b) {
        return b.item.rechnungsnummer.localeCompare(a.item.rechnungsnummer);
      });
      return rechnungen;
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["bbr"],
  computed: {
    rechnungen: function rechnungen() {
      if (this.$store.state.rechnungen.loadedEigene === false) {
        if (this.bbr != null) {
          this.$store.dispatch("rechnungen/loadEigeneRechnungen", { user: this.bbr });
        }
      }
      return this.$store.getters["rechnungen/nutzerRechnungenOffen"](this.bbr);
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["kasse", "status"],
  data: function data() {
    return {
      anzahlRechnungen: 0,
      showRechnung: false,
      rechnungid: ""
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    rechnungen: function rechnungen() {
      var rechnungen = this.$store.getters["rechnungen/statusRechnungenKasse"](this.status, this.kasse);
      this.anzahlRechnungen = rechnungen.length;
      return rechnungen.slice(0, 10);
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    bezMitglieder: function bezMitglieder() {
      return this.$store.getters['einstellungen/einstellung']('allgemein').bezMitglieder;
    },
    gruppen: function gruppen() {
      return this.$store.getters['einstellungen/einstellung']('mitgliederstatus').status.filter(function (item) {
        return item.mitglied;
      });
    },
    mdsize: function mdsize() {
      var size = this.gruppen.length;
      switch (size) {
        case 1:
          return 12;
        case 2:
          return 6;
        case 3:
          return 4;
        case 5:
          return 4;
        default:
          return 3;
      }
    },
    kontaktGruppen: function kontaktGruppen() {
      var gruppen = [{
        value: 'Alle',
        count: 0
      }];
      this.gruppen.forEach(function (gruppe) {
        gruppen.push({
          value: gruppe.status,
          count: 0
        });
      });
      var kontakte = this.$store.state.bbrbbr.bbrbbr;
      kontakte.forEach(function (kontakt) {
        var status = kontakt.status;
        var gruppe = gruppen.find(function (item) {
          return item.value === status;
        });
        if (gruppe) {
          gruppe.count++;
          gruppen[0].count++;
        }
      });
      return gruppen;
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      monat: new Date(new Date().getFullYear(), new Date().getMonth()).toISOString().substr(0, 7)
    };
  },

  computed: {
    statistik: function statistik() {
      var _this = this;

      if (this.$store.state.statistiken.statistiken.length === 0) {
        this.$store.dispatch("statistiken/loadStatistiken");
      }
      return this.$store.state.statistiken.statistiken.find(function (statistik) {
        return statistik.monat === _this.monat;
      });
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, exports) {



/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["anzahl", "kalender", "hideImage"],
  data: function data() {
    return {
      search: "",
      heute: new Date().toISOString().substr(0, 10),
      datum: new Date().toISOString().substr(0, 10),
      name: "",
      veranstaltungDialog: false,
      selectedEvent: {
        anmeldung: [],
        anmeldungen: [],
        weitereAnmeldungen: []
      },
      showAlleAnmeldungen: false,
      showWeiterenAnmelden: false,
      showZuVeranstaltungAbmelden: false
    };
  },

  computed: {
    bbrbbr: function bbrbbr() {
      return this.$store.state.bbrbbr.bbrbbr;
    },
    currentBbr: function currentBbr() {
      return this.$getCurrentBbr();
    },
    veranstaltungen: function veranstaltungen() {
      var _this = this;

      if (this.$store.state.veranstaltungen.loaded === false) {
        this.$store.dispatch("veranstaltungen/loadVeranstaltungen");
      }
      var alleevents = [];
      if (this.kalender) {
        alleevents = this.$store.getters["veranstaltungen/nachsteVeranstaltungen"].filter(function (event) {
          return event.kalender === _this.kalender;
        }).slice(0, this.anzahl);
      } else {
        this.$store.getters["einstellungen/einstellung"]("kalender").forEach(function (kal) {
          _this.$store.getters["veranstaltungen/nachsteVeranstaltungen"].filter(function (event) {
            return event.kalender === kal.name;
          }).slice(0, _this.anzahl).forEach(function (event) {
            alleevents.push(event);
          });
        });
        alleevents = alleevents.sort(function (a, b) {
          var dateComparison = new Date(a.vonDatum) - new Date(b.vonDatum);

          if (dateComparison === 0) {
            var timeComparison = a.vonZeit.localeCompare(b.vonZeit);
            return timeComparison;
          }
          return dateComparison;
        });

        alleevents = alleevents.slice(0, this.anzahl);
      }
      var gruppierteVeranstaltungen = {};
      alleevents.forEach(function (event) {
        event.farbe = "black--text";
        event.start = event.vonDatum + " " + event.vonZeit;
        event.end = event.bisDatum;
        event.name = event.titel;
        var monat = new Date(event.vonDatum).getFullYear() + "-" + ("0" + (new Date(event.vonDatum).getMonth() + 1)).slice(-2) + "-01";
        if (!gruppierteVeranstaltungen[monat]) {
          gruppierteVeranstaltungen[monat] = [];
        }
        gruppierteVeranstaltungen[monat].push(event);
      });
      return gruppierteVeranstaltungen;
    },
    userIstAngemeldet: function userIstAngemeldet() {
      var _this2 = this;

      var bbr = void 0;
      this.$store.state.bbrbbr.bbrbbr.forEach(function (item) {
        if (item.anmeldeID === _this2.$firebase.auth().currentUser.uid) {
          bbr = item.id;
        }
      });
      if (this.selectedEvent) {
        for (var i = 0; i < this.selectedEvent.anmeldung.length; i++) {
          if (this.selectedEvent.anmeldung[i].id === bbr) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    zuVeranstaltungAnmelden: function zuVeranstaltungAnmelden() {
      this.selectedEvent.anmeldungen.push(this.currentBbr);
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      this.$firebase.analytics().logEvent("zuVeranstaltungAnmelden", {
        currentBbr: this.currentBbr,
        name: this.currentBbr
      });
    },
    zuVeranstaltungAbmelden: function zuVeranstaltungAbmelden() {
      this.selectedEvent.anmeldungen.splice(this.selectedEvent.anmeldungen.indexOf(this.currentBbr), 1);
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      this.$firebase.analytics().logEvent("zuVeranstaltungAbmelden", {
        currentBbr: this.currentBbr,
        name: this.currentBbr
      });
      this.showZuVeranstaltungAbmelden = false;
    },
    weiterenAnmelden: function weiterenAnmelden() {
      if (!this.selectedEvent.weitereAnmeldungen) {
        this.selectedEvent.weitereAnmeldungen = [];
      }
      this.selectedEvent.weitereAnmeldungen.push({
        angemeldetVon: this.currentBbr,
        name: this.name
      });
      this.name = "";
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
    },
    weiterenAbmelden: function weiterenAbmelden(item) {
      this.selectedEvent.weitereAnmeldungen.splice(this.selectedEvent.weitereAnmeldungen.indexOf(item), 1);
      this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
    }
  }
});

/***/ }),
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(736),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(755),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  "data-v-563a6333",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  "data-v-5195f86f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  "data-v-f3df772a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  "data-v-3eb1dc02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showNeueStriche = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showRechnungenGenerieren = true) && (_vm.fortschritt = 0) && (_vm.e1 = 1)
            }
          }
        }, on), [_c('v-icon', [_vm._v("send")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Rechnungen erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showStatistik = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("insights")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Statistik")])])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showStatistik) ? _c('v-dialog', {
    attrs: {
      "width": "70%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStatistik),
      callback: function($$v) {
        _vm.showStatistik = $$v
      },
      expression: "showStatistik"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_c('div', [_vm._v("Statistik")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlStriche))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Striche")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlEKP))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("EKP")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlPauschal))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Pauschal")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlRechnungen))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Rechnungen")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzStriche / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzStriche)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz "), _c('br'), _vm._v("\n                    Striche")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzEKP / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzEKP)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz "), _c('br'), _vm._v("\n                    EKP")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzPauschal / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzPauschal)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz"), _c('br'), _vm._v("Pauschal")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzGesamt / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzGesamt)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz Gesamt")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "378px"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bbr")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Striche")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pauschal")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.bestenliste), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.id, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.striche))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.ekp)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.pauschal)))])])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showNeueStriche) ? _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeueStriche),
      callback: function($$v) {
        _vm.showNeueStriche = $$v
      },
      expression: "showNeueStriche"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [_c('div', [_vm._v("Neue Striche erstellen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueStriche = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('stricheNeu')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueStriche = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showRechnungenGenerieren) ? _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungenGenerieren),
      callback: function($$v) {
        _vm.showRechnungenGenerieren = $$v
      },
      expression: "showRechnungenGenerieren"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Rechnungen erstellen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungenGenerieren = false) && (_vm.$vars.loading = false)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-stepper', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": "",
      "outlined": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v(" Datum auswählen ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v(" Rechnungsdetails ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v(" Zusammenfassung ")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Alle offenen Striche berechnen"
    },
    model: {
      value: (_vm.rechnung_alle),
      callback: function($$v) {
        _vm.rechnung_alle = $$v
      },
      expression: "rechnung_alle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [(!_vm.rechnung_alle) ? _c('v-date-picker', {
    attrs: {
      "full-width": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "no-title": "",
      "locale": "de-de"
    },
    model: {
      value: (_vm.rechnung_von),
      callback: function($$v) {
        _vm.rechnung_von = $$v
      },
      expression: "rechnung_von"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [(!_vm.rechnung_alle) ? _c('v-date-picker', {
    attrs: {
      "full-width": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "no-title": "",
      "locale": "de-de"
    },
    model: {
      value: (_vm.rechnung_bis),
      callback: function($$v) {
        _vm.rechnung_bis = $$v
      },
      expression: "rechnung_bis"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "py-0 mt-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Rechnungstitel"
    },
    model: {
      value: (_vm.rechnung_titel),
      callback: function($$v) {
        _vm.rechnung_titel = $$v
      },
      expression: "rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0 mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Rechnungsdatum"
    },
    model: {
      value: (_vm.rechnung_datum),
      callback: function($$v) {
        _vm.rechnung_datum = $$v
      },
      expression: "rechnung_datum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0 mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Zahlbar bis",
      "messages": "Standard: 10 Tage später"
    },
    model: {
      value: (_vm.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.rechnung_zahlbar_bis = $$v
      },
      expression: "rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "label": "Rechnungstext"
    },
    model: {
      value: (_vm.rechnung_freitext),
      callback: function($$v) {
        _vm.rechnung_freitext = $$v
      },
      expression: "rechnung_freitext"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "label": "Rechnungstext bei SEPA-Rechnung"
    },
    model: {
      value: (_vm.rechnung_freitext_sepa),
      callback: function($$v) {
        _vm.rechnung_freitext_sepa = $$v
      },
      expression: "rechnung_freitext_sepa"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Zahlbar bis")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.rechnung_zahlbar_bis, "DD.MM.YYYY")))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Rechnungen")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm.rechnung_anzahl))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Betrag")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Davon per SEPA")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_sepa)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Striche")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_striche)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_ekp)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Pauschal")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_pauschal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-1"
  }), _vm._v(" "), (_vm.rechnungen.length > 0) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.index < 1
    },
    on: {
      "click": function($event) {
        _vm.index -= 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center subtitle-2"
  }, [_vm._v("Rechnung " + _vm._s(_vm.index + 1) + " von " + _vm._s(_vm.rechnungen.length))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.index > _vm.rechnungen.length - 2
    },
    on: {
      "click": function($event) {
        _vm.index += 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center subtitle-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.$filters.user(_vm.rechnungen[_vm.index].bbrID, _vm.bbrbbr)) + "\n                      ")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "150"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungen[_vm.index].positionen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))])])
  }), 0)])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" Rechnungen werden erstellt ")]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fortschritt === 100 ? 'green' : 'blue',
      "value": _vm.fortschritt,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.fortschritt.toFixed(0)) + " %\n                ")]), _vm._v(" "), (_vm.fortschritt < 100) ? _c('v-progress-linear', {
    staticClass: "mt-n1",
    attrs: {
      "color": "blue",
      "height": "4",
      "indeterminate": "",
      "rounded": ""
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.e1 < 4) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (_vm.showRechnungenGenerieren = false) && (_vm.loading = false)
      }
    }
  }, [_vm._v("Abbrechen")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.e1 === 1) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v("Weiter")])], 1) : _vm._e(), _vm._v(" "), (_vm.e1 === 2) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.rechnungVorbereiten
    }
  }, [_vm._v("Weiter")])], 1) : _vm._e(), _vm._v(" "), (_vm.e1 === 3) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.rechnungErstellen
    }
  }, [_vm._v("Erstellen")])], 1) : _vm._e(), _vm._v(" "), (_vm.e1 === 4) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.fortschritt < 100
    },
    on: {
      "click": function($event) {
        _vm.showRechnungenGenerieren = false
      }
    }
  }, [_vm._v("Schließen")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.striche,
      "search": _vm.search,
      "fixed-header": "",
      "items-per-page": 50,
      "footer-props": {
        'items-per-page-options': [50, 250, -1],
        'items-per-page-text': 'Striche pro Seite',
      },
      "no-data-text": "Keine Striche vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Betrag")])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.date, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', {
          staticClass: "hidden-xs-only"
        }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((item.preis * item.anzahl))))]), _vm._v(" "), _c('td', {
          staticClass: "hidden-xs-only"
        }, [_vm._v(_vm._s(item.grund))]), _vm._v(" "), _c('td', {
          staticClass: "pl-0 pr-0 hidden-xs-only",
          attrs: {
            "width": "20px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteStrich(item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_c('v-divider'), _vm._v(" "), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _vm._v(" "), _c('div', {
          staticClass: "subtitle-2 mt-2 mb-2 mr-2"
        }, [_vm._v("Anzahl Striche: " + _vm._s(_vm.anzahl) + " - Summe: " + _vm._s(_vm._f("money")(_vm.summe)))])], 1)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("AH-Zirkel " + _vm._s(_vm.zirkel))]), _vm._v(" "), _vm._l((_vm.berechtigt), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n      ")])
  })], 2), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Zirkel-Mitglieder (" + _vm._s(_vm.mitglieder.length) + ")")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "450px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vorname")]), _vm._v(" "), _c('th', [_vm._v("Nachname")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mitglieder), function(mitglied) {
    return _c('tr', {
      key: mitglied.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = mitglied) && (_vm.showKontakt = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(mitglied.nachname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mitglied.vorname))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                (_vm.bbr = mitglied) && (_vm.showRemoveKontakt = true)
              }
            }
          }, on), [_c('v-icon', [_vm._v("person_remove")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Bbr aus Zirkel entfernen")])])], 1)])
  }), 0)]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-xs-only"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAddKontakt = true
      }
    }
  }, [_vm._v("Bundesbruder hinzufügen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('veranstaltungenListe', {
    attrs: {
      "kalender": 'AH-Zirkel ' + _vm.zirkel,
      "hideImage": true,
      "anzahl": "15"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-space-between"
  }, [_vm._v("\n          Gesendete Mails\n          "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueMail = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, [(_vm.nachrichten.length === 0) ? _c('v-subheader', {
    staticClass: "justify-center"
  }, [_vm._v("\n            Keine Rundmails versendet.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nachrichten), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          (_vm.nachricht = item) && (_vm.showMail = true)
        }
      }
    }, [(item.status === 'Error' && item.status) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("warning")])], 1) : _vm._e(), _vm._v(" "), (item.status === 'Entwurf' && item.status) ? _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "loading": "",
        "disabled": "",
        "text": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "font-weight-bold"
    }, [(item.absender.position) ? _c('span', [_vm._v(_vm._s(item.absender.position))]) : _vm._e(), _vm._v(" "), (item.absender.name) ? _c('span', [_vm._v(_vm._s(item.absender.name))]) : _vm._e(), _vm._v(" "), (item.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(item.von, _vm.bbrbbr)))]) : _vm._e()]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                  " + _vm._s(item.message.subject) + "\n                ")])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "text-right"
    }, [_vm._v("\n                " + _vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY"))), _c('br'), _vm._v("\n                " + _vm._s(_vm.$filters.date(item.datum, "hh:mm")) + " Uhr\n              ")])], 1), _vm._v(" "), (index + 1 !== _vm.nachrichten.length) ? _c('v-divider') : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-xs-only"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "to": "./mail",
      "text": ""
    }
  }, [_vm._v("Alle Mails")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogMail', {
    attrs: {
      "visible": _vm.showMail,
      "nachricht": _vm.nachricht
    },
    on: {
      "update:visible": function($event) {
        _vm.showMail = $event
      },
      "close": function($event) {
        _vm.showMail = false
      }
    }
  }), _vm._v(" "), _c('dialogMailNeu', {
    attrs: {
      "visible": _vm.showNeueMail
    },
    on: {
      "update:visible": function($event) {
        _vm.showNeueMail = $event
      },
      "close": function($event) {
        _vm.showNeueMail = false
      }
    }
  }), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showRemoveKontakt,
      "title": "Bbr aus Zirkel entfernen",
      "message": 'Willst du Bbr ' + _vm.bbr.nachname + ' wirklich aus dem Zirkel entfernen?',
      "abbrechen": "Abbrechen",
      "weiter": "Entfernen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showRemoveKontakt = $event
      },
      "closeTrue": function($event) {
        return _vm.removeBbrFromZirkel()
      },
      "closeFalse": function($event) {
        _vm.showRemoveKontakt = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAddKontakt),
      callback: function($$v) {
        _vm.showAddKontakt = $$v
      },
      expression: "showAddKontakt"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Bbr dem Zirkel hinzufügen ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.bbrbbrselect,
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.bbr),
      callback: function($$v) {
        _vm.bbr = $$v
      },
      expression: "bbr"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAddKontakt = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.addBbrToZirkel()
      }
    }
  }, [_vm._v("hinzufügen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "offset-md": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center pa-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ma-1",
    attrs: {
      "size": 240,
      "color": "transparent"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoUrl,
      "lazy-src": ''
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "ml-4"
  }, [_vm._v("Mailadresse ändern")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Lieber Bundesbruder, "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          deine E-Mailadresse " + _vm._s(_vm.mail) + " ist leider nicht im System vorhanden."), _c('br'), _vm._v("\n          Damit du auf Korpodesk zugreifen kannst musst du entweder beim Schriftführer die E-Mailadresse " + _vm._s(_vm.mail) + " hinterlegen\n          lassen oder du kannst auf dieser Seite eine andere E-Mailadresse verwenden. Du musst immer die Adresse angeben, auf der du\n          auch unsere E-Mails empfängst."), _c('br'), _c('br'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Neue E-Mailadresse eintragen",
      "type": "passwemailord"
    },
    model: {
      value: (_vm.neueEmail),
      callback: function($$v) {
        _vm.neueEmail = $$v
      },
      expression: "neueEmail"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("E-Mailadresse ändern")])], 1), _vm._v("\n        " + _vm._s(_vm.hinweis) + "\n\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              (_vm.showRechnungerstellen = true) && (_vm.rechnungErstellenData = _vm.rechnungErstellenDataMaske)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neue Rechnung")])]), _vm._v(" "), (_vm.rechnungsKategorienen[_vm.tab]) ? _c('span', [_c('dialogRechnungenVersenden', {
    attrs: {
      "visible": _vm.showRechnungenVersenden,
      "rechnungen": _vm.alleRechnungen.filter(function (item) { return item.status === _vm.rechnungsKategorienen[_vm.tab].status; })
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnungenVersenden = $event
      },
      "close": function($event) {
        _vm.showRechnungenVersenden = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showSepaDateien = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("request_quote")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Sepa Dateien")])])], 1), _vm._v(" "), _c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showExport = !_vm.showExport
            }
          }
        }, on), [_c('v-icon', [_vm._v("file_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Export")])])], 1), _vm._v(" "), _c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showStatistik = !_vm.showStatistik
            }
          }
        }, on), [_c('v-icon', [_vm._v("insights")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Statistik")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_vm._v("\n    " + _vm._s(_vm.kasse ? "" : "Rechnungen konnten nicht geladen werden. Bitte zur Startseite gehen.") + "\n    "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-tabs', {
    staticClass: "mb-2",
    attrs: {
      "center-active": "",
      "show-arrows": "",
      "background-color": "transparent"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.rechnungsKategorienen.length === 0) ? _c('v-tab', [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rechnungsKategorienen), function(item) {
    return (item.anzahl > 0) ? _c('v-tab', {
      key: item.status,
      staticClass: "caption"
    }, [_vm._v(_vm._s(item.status) + " (" + _vm._s(item.anzahl) + ")")]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-responsive', {
    staticClass: "mr-4",
    attrs: {
      "max-width": "300"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "flat": "",
      "solo": "",
      "hide-details": "",
      "append-icon": "search",
      "placeholder": "Rechnungen durchsuchen",
      "clearable": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-tabs-items', {
    staticClass: "transparent",
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.rechnungsKategorienen), function(item) {
    return (item.anzahl > 0) ? _c('v-tab-item', {
      key: item.status
    }, [_c('rechnungen-liste', {
      attrs: {
        "status": item.status,
        "kasse": _vm.kasse,
        "search": _vm.search
      }
    })], 1) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "40%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showExport),
      callback: function($$v) {
        _vm.showExport = $$v
      },
      expression: "showExport"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Export Rechnungen " + _vm._s(_vm.kasse) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showExport = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Die Rechnungen werden derzeit ausschließlich mit UTF-8 exportiert. Daher ist die csv-Datei evtl nicht in allen\n        Tabellenprogrammen gleich dargestellt.\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showExport = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.exportData()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("file_download")]), _vm._v("Daten herunterladen")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStatistik),
      callback: function($$v) {
        _vm.showStatistik = $$v
      },
      expression: "showStatistik"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Zusammenfassung Rechnungspositionen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    staticClass: "mt-4 mb-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "filter.von",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Datum von",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatumVon),
            callback: function($$v) {
              _vm.formatDatumVon = $$v
            },
            expression: "formatDatumVon"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu3),
      callback: function($$v) {
        _vm.menu3 = $$v
      },
      expression: "menu3"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu3 = false
      }
    },
    model: {
      value: (_vm.filter.von),
      callback: function($$v) {
        _vm.$set(_vm.filter, "von", $$v)
      },
      expression: "filter.von"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "filter.von",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Datum bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatumBis),
            callback: function($$v) {
              _vm.formatDatumBis = $$v
            },
            expression: "formatDatumBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu4),
      callback: function($$v) {
        _vm.menu4 = $$v
      },
      expression: "menu4"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu4 = false
      }
    },
    model: {
      value: (_vm.filter.bis),
      callback: function($$v) {
        _vm.$set(_vm.filter, "bis", $$v)
      },
      expression: "filter.bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            Diese Ansicht zeigt eine Zusammenfassung der Rechnungspositionen aller gezahlten Rechnungen der\n            " + _vm._s(_vm.kasse) + " im Zeitraum vom " + _vm._s(_vm.$filters.date(_vm.filter.von, "DD.MM.YYYY")) + " bis\n            " + _vm._s(_vm.$filters.date(_vm.filter.bis, "DD.MM.YYYY")) + ". Sie unterteilt die Rechnungen in Überweisungen und\n            Sepa-Rechnungen.\n          ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Rechnungen per Überweisung:")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "200px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.positionen.normal), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))])])
  }), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.positionen.normal_summe)))])])], 2)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Rechnungen per SEPA:")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "200px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.positionen.sepa), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))])])
  }), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.positionen.sepa_summe)))])])], 2)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "70%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.showRechnungerstellen),
      callback: function($$v) {
        _vm.showRechnungerstellen = $$v
      },
      expression: "showRechnungerstellen"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl pa-0 ma-0",
    attrs: {
      "height": "80vh"
    }
  }, [_c('v-card-title', [_vm._v("\n        Rechnungen erstellen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellen = false) && (_vm.$vars.loading = false)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-stepper', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": "",
      "outlined": "",
      "alt-labels": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v("Kontakte"), _c('br'), _vm._v("auswählen")]), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v("Rechnungs-"), _c('br'), _vm._v("details")]), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 3,
      "step": "3"
    }
  }, [_vm._v("Rechnungs-"), _c('br'), _vm._v("positionen")]), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 4,
      "step": "4"
    }
  }, [_vm._v("Zusammenfassung")]), _c('v-divider')], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "deletable-chips": "",
      "multiple": "",
      "chips": "",
      "small-chips": "",
      "clearable": "",
      "required": "",
      "outlined": "",
      "clear-icon": "delete",
      "items": _vm.bundesbruder,
      "label": "Kontakte auswählen"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.rechnungErstellenData.bbrbbr ? _vm.rechnungErstellenData.bbrbbr.length : 0))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.rechnungErstellenData.bbrbbr),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "bbrbbr", $$v)
      },
      expression: "rechnungErstellenData.bbrbbr"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                  Gruppen nach Mitgliedsstatus hinzufügen: "), _c('br'), _vm._v(" "), _vm._l((_vm.gruppen), function(item, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mr-2",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.gruppeAdd(item.status)
        }
      }
    }, [_vm._v(_vm._s(item.status))])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.gruppeAdd('Alle')
      }
    }
  }, [_vm._v("Alle")])], 2), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-icon', [_vm._v("info")]), _vm._v("\n                  Bsp: Sollen Rechnungen an einen Teil der Mitglieder gestellt werden kann einfach \"Alle\" ausgewählt\n                  werden. Im weiteren Prozess erhalten nur Kontakte, welche einen Betrag eingetragen haben eine\n                  Rechnung die mehr als 0€ beträgt. Rechnung die 0€ betragen werden nicht erstellt.\n                ")], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "480px"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-4 py-0",
    attrs: {
      "cols": "6",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "required": "",
      "label": "Rechnungstitel"
    },
    model: {
      value: (_vm.rechnungErstellenData.titel),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "titel", $$v)
      },
      expression: "rechnungErstellenData.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 py-0",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "rechnungErstellenData.datum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "label": "Rechnungsdatum",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.rechnungErstellenData.datum),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "datum", $$v)
      },
      expression: "rechnungErstellenData.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 py-0",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "rechnungErstellenData.zahlbar_bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "label": "Zahlbar bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatZahlbar_bis),
            callback: function($$v) {
              _vm.formatZahlbar_bis = $$v
            },
            expression: "formatZahlbar_bis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu2 = false
      }
    },
    model: {
      value: (_vm.rechnungErstellenData.zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "zahlbar_bis", $$v)
      },
      expression: "rechnungErstellenData.zahlbar_bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "12",
      "label": "Freitext",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>, <<Absender Name>>",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenData.freitext),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "freitext", $$v)
      },
      expression: "rechnungErstellenData.freitext"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "12",
      "label": "Freitext SEPA",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>, <<Absender Name>>",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenData.freitext_Sepa),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "freitext_Sepa", $$v)
      },
      expression: "rechnungErstellenData.freitext_Sepa"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "480px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellenPositionAdd = true) &&
        (_vm.rechnungErstellenPositionAddData = {
          neu: true,
          anzahl: 1,
          betrag: '',
          betragArray: []
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Position")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellenVeranstaltungAdd = true) &&
        (_vm.rechnungerstellenVeranstaltungAddData = {
          neu: true,
          anzahl: 1,
          betrag: 0,
          betragBegleitung: 0,
          betragArray: [],
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Veranstaltung")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellenCouleurstrafenAdd = true) &&
        (_vm.rechnungerstellenCouleurstrafenAddData = {
          neu: true,
          anzahl: 1,
          bezeichnung: 'Couleurstrafen',
          betrag: 0,
          betragArray: [],
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Couleurstrafen")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "subtitle-2 text-right mt-2"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenDataSumme)))])]), _vm._v(" "), (_vm.switchTabelle.positionen) ? _c('v-col', {
    attrs: {
      "cols": _vm.switchTabelle.rechnungen ? 6 : 12
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "400"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Anz")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag von-bis")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungErstellenData.positionen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnungen.length))]), _vm._v(" "), (item.min !== item.max) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v("\n                              " + _vm._s(_vm._f("money")(item.min)) + " - " + _vm._s(_vm._f("money")(item.max)) + "\n                            ")]) : _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.min)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteRechnungErstellenPosition(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.switchTabelle.rechnungen) ? _c('v-col', {
    attrs: {
      "cols": _vm.switchTabelle.positionen ? 6 : 12
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "400"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Wer")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Anz Positionen")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungErstellenData.rechnungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.positionen.length))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteRechnungErstellenRechnung(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "480px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.indexRechnung < 1
    },
    on: {
      "click": function($event) {
        _vm.indexRechnung -= 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center subtitle-2"
  }, [_vm._v("\n                          Rechnung " + _vm._s(_vm.indexRechnung + 1) + " von " + _vm._s(_vm.kontrolleRechnungen.length) + "\n                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.indexRechnung > _vm.kontrolleRechnungen.length - 2
    },
    on: {
      "click": function($event) {
        _vm.indexRechnung += 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "200"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Anzahl")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kontrolleRechnungen[_vm.indexRechnung].positionen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))])])
  }), 0)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticClass: "my-1 mx-1 subtitle-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$filters.user(_vm.kontrolleRechnungen[_vm.indexRechnung].bbrID, _vm.bbrbbr)) + "\n                          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("money")(_vm.kontrolleRechnungen[_vm.indexRechnung].summe)) + "\n                          ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRechnungerstellen = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.e1 === 4) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellen()
      }
    }
  }, [_vm._v("Rechnungen stellen")])], 1) : _c('div', {
    staticClass: "text-right"
  }, [(_vm.e1 > 1) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Zurück")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 + 1
      }
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungerstellenPositionAdd),
      callback: function($$v) {
        _vm.showRechnungerstellenPositionAdd = $$v
      },
      expression: "showRechnungerstellenPositionAdd"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "480px"
    }
  }, [_c('v-card-title', [_vm._v("\n        Neue Position hinzufügen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenPositionAdd = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Bezeichnung",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.bezeichnung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "bezeichnung", $$v)
      },
      expression: "rechnungErstellenPositionAddData.bezeichnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Anzahl",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.anzahl),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "anzahl", $$v)
      },
      expression: "rechnungErstellenPositionAddData.anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Betrag",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.changePositionDataInput('betrag')
      }
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.betrag),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "betrag", $$v)
      },
      expression: "rechnungErstellenPositionAddData.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "items": _vm.kontaktfelder,
      "label": "Kontaktfeld",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.changePositionDataInput('kontaktfeld')
      }
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.kontaktfeld),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "kontaktfeld", $$v)
      },
      expression: "rechnungErstellenPositionAddData.kontaktfeld"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.changePositionDataInput('null')
      }
    }
  }, [_vm._v("Alle 0€")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items-per-page": _vm.rechnungErstellenPositionAddData.betragArray.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.rechnungErstellenPositionAddData.betragArray,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(item.id + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.betrag),
            callback: function($$v) {
              _vm.$set(item, "betrag", $$v)
            },
            expression: "item.betrag"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "append-outer-icon": "add",
      "items": _vm.bundesbruder,
      "label": "Kontakt hinzufügen"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBbrToData()
      }
    },
    model: {
      value: (_vm.BbrToData),
      callback: function($$v) {
        _vm.BbrToData = $$v
      },
      expression: "BbrToData"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenPositionAdd = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenPositionAddDataSumme)))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellenPositionAdd()
      }
    }
  }, [_vm._v("Hinzufügen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungerstellenVeranstaltungAdd),
      callback: function($$v) {
        _vm.showRechnungerstellenVeranstaltungAdd = $$v
      },
      expression: "showRechnungerstellenVeranstaltungAdd"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "480px"
    }
  }, [_c('v-card-title', [_vm._v("\n        Veranstaltung abrechnen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenVeranstaltungAdd = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "items": _vm.veranstaltungen,
      "label": "Veranstaltung",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.veranstaltung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "veranstaltung", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.veranstaltung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Betrag",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.betrag),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "betrag", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Betrag Begleitung",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.betragBegleitung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "betragBegleitung", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.betragBegleitung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Füxe zahlt Fuxenkasse"
    },
    on: {
      "change": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.fuxe),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "fuxe", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.fuxe"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Begleitungen sind kostenlos"
    },
    on: {
      "change": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.begleitungen),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "begleitungen", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.begleitungen"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items-per-page": _vm.rechnungerstellenVeranstaltungAddData.betragArray.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.rechnungerstellenVeranstaltungAddData.betragArray,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(item.id + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.betrag),
            callback: function($$v) {
              _vm.$set(item, "betrag", $$v)
            },
            expression: "item.betrag"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "append-outer-icon": "add",
      "items": _vm.bundesbruder,
      "label": "Kontakt hinzufügen"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBbrToData()
      }
    },
    model: {
      value: (_vm.BbrToData),
      callback: function($$v) {
        _vm.BbrToData = $$v
      },
      expression: "BbrToData"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenVeranstaltungAdd = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenPositionAddDataSumme)))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellenPositionAdd()
      }
    }
  }, [_vm._v("Hinzufügen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungerstellenCouleurstrafenAdd),
      callback: function($$v) {
        _vm.showRechnungerstellenCouleurstrafenAdd = $$v
      },
      expression: "showRechnungerstellenCouleurstrafenAdd"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "480px"
    }
  }, [_c('v-card-title', [_vm._v("\n        Couleurstrafen abrechnen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenCouleurstrafenAdd = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Bezeichnung",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungerstellenCouleurstrafenAddData.bezeichnung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenCouleurstrafenAddData, "bezeichnung", $$v)
      },
      expression: "rechnungerstellenCouleurstrafenAddData.bezeichnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.changeCouleurstrafenDataInput()
      }
    }
  }, [_vm._v("hinzufügen")])], 1), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Bitte beachte: durch Drücken des Button \"hinzufügen\" werden alle noch nicht berechneten\n                Couleurstrafen der Tabelle hinzugefügt und sofort als berechnet markiert. Das kann nicht rückgängig\n                gemacht werden.")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items-per-page": _vm.rechnungerstellenCouleurstrafenAddData.betragArray.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.rechnungerstellenCouleurstrafenAddData.betragArray,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(item.id + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.betrag),
            callback: function($$v) {
              _vm.$set(item, "betrag", $$v)
            },
            expression: "item.betrag"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "append-outer-icon": "add",
      "items": _vm.bundesbruder,
      "label": "Kontakt hinzufügen"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBbrToData()
      }
    },
    model: {
      value: (_vm.BbrToData),
      callback: function($$v) {
        _vm.BbrToData = $$v
      },
      expression: "BbrToData"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenCouleurstrafenAdd = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenPositionAddDataSumme)))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellenPositionAdd()
      }
    }
  }, [_vm._v("Hinzufügen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSepaDateien),
      callback: function($$v) {
        _vm.showSepaDateien = $$v
      },
      expression: "showSepaDateien"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Alle Sepa Dateien\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSepaDateien = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Summe")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sepaDateien), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.date, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.filename))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.downloadSepa(item)
        }
      }
    }, [_c('v-icon', [_vm._v("download")])], 1)], 1)])
  }), 0)]), _vm._v("\n        {{}}\n      ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSepaDateien = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "ma-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tabs', {
    staticClass: "mb-0",
    attrs: {
      "center-active": "",
      "show-arrows": "",
      "background-color": "transparent"
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [(Object.keys(_vm.rechnungen).length === 0) ? _c('v-tab', [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.jahre), function(jahr) {
    return _c('v-tab', {
      key: jahr
    }, [_vm._v(_vm._s(jahr))])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.status === 'Entwurf SEPA') ? _c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = true
      }
    }
  }, [_c('v-icon', [_vm._v("send")]), _vm._v("\n          Alle versenden und SEPA generieren\n        ")], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-tabs-items', {
    staticClass: "transparent",
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.rechnungen), function(jahr, index) {
    return _c('v-tab-item', {
      key: index
    }, [_c('v-data-table', {
      ref: "rechnungenTabelle",
      refInFor: true,
      attrs: {
        "dense": "",
        "height": _vm.sideHeight,
        "headers": _vm.headers,
        "items": jahr.rechnungen,
        "search": _vm.search,
        "fixed-header": "",
        "items-per-page": 100,
        "page": _vm.page,
        "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
        "no-data-text": "Keine Rechnungen vorhanden",
        "show-select": _vm.isSelect,
        "hide-default-footer": ""
      },
      on: {
        "update:page": function($event) {
          _vm.page = $event
        },
        "page-count": function($event) {
          _vm.pageCount = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            staticClass: "hidden-sm-and-up"
          }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Nummer")]), _vm._v(" "), _c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]
        }
      }, {
        key: "item",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            on: {
              "dblclick": function($event) {
                (_vm.selectRechnung = item) && (_vm.showRechnung = true)
              }
            }
          }, [(_vm.isSelect && _vm.checkIndex(item.id)) ? _c('td', {
            staticClass: "pr-0",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSelect(item.id)
              }
            }
          }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSelect && !_vm.checkIndex(item.id)) ? _c('td', {
            staticClass: "pr-0",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSelect(item.id)
              }
            }
          }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.status === 'Mahnung' || item.status === 'Gemahnt überfällig') ? _c('td', {
            attrs: {
              "width": "100px"
            }
          }, [_c('v-chip', {
            attrs: {
              "label": "",
              "small": "",
              "outlined": "",
              "color": "red"
            }
          }, [_vm._v(_vm._s(item.mahnstufe) + ". " + _vm._s(item.status))])], 1) : _c('td', {
            attrs: {
              "width": "100px"
            }
          }, [_c('v-chip', {
            attrs: {
              "label": "",
              "small": "",
              "outlined": ""
            }
          }, [_vm._v(_vm._s(item.status))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnung_titel))]), _vm._v(" "), _c('td', {
            attrs: {
              "width": "220px"
            }
          }, [_vm._v("\n                    " + _vm._s(item.kontakt) + "\n                  ")]), _vm._v(" "), _c('td', {
            staticClass: "text-right",
            attrs: {
              "width": "120px"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$filters.money(item.summe)) + "\n                  ")]), _vm._v(" "), _c('td', {
            staticClass: "hidden-xs-only",
            attrs: {
              "width": "170px"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({}, on), [_vm._v(_vm._s(_vm.$filters.date(item.rechnung_datum, "DD.MM.YYYY")))])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("\n                        Gestellt am:\n                        " + _vm._s(_vm.$filters.date(item.rechnung_datum, "DD.MM.YYYY")) + "\n                        "), _c('br'), _vm._v("\n                        Zahlbar bis:\n                        " + _vm._s(_vm.$filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY")) + "\n                      ")])])], 1), _vm._v(" "), _c('td', [_c('v-menu', {
            attrs: {
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "size": "small",
                    "icon": "",
                    "variant": "flat"
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', {
            attrs: {
              "nav": "",
              "dense": ""
            }
          }, [(item.status === 'Entwurf') ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.neuerStatus(item, 'Offen')
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnungen versenden")])], 1) : _vm._e(), _vm._v(" "), (
            item.status === 'Offen' ||
            item.status === 'Versendet' ||
            item.status === 'Überfällig' ||
            item.status === 'Gemahnt' ||
            item.status === 'Gemahnt überfällig'
          ) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.neuerStatus(item, 'Gezahlt')
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnung als gezahlt markieren")])], 1) : _vm._e(), _vm._v(" "), (item.status === 'Entwurf SEPA') ? _c('v-list-item', {
            on: {
              "click": function($event) {
                _vm.showSendRechnungen = true
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Alle Rechnungen versenden und SEPA generieren")])], 1) : _vm._e(), _vm._v(" "), _c('buttonRechnungDownload', {
            attrs: {
              "type": "list",
              "icon": "download",
              "rechnung": item
            }
          }), _vm._v(" "), _c('v-list-item', {
            on: {
              "click": function($event) {
                (_vm.showDeleteRechnung = true) && (_vm.deleteRechnungID = item.id)
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnung löschen")])], 1), _vm._v(" "), (item.status === 'Entwurf') ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.alleEntwurfNeuerStatus()
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Alle Entwurf-Rechnungen versenden")])], 1) : _vm._e()], 1)], 1)], 1)])]
        }
      }, {
        key: "footer",
        fn: function() {
          return [_c('v-divider'), _vm._v(" "), _c('v-row', {
            attrs: {
              "no-gutters": ""
            }
          }, [(_vm.selected.length > 0) ? _c('v-btn', {
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                _vm.showMehrereBearbeiten = true
              }
            }
          }, [_vm._v("bearbeiten")]) : _vm._e(), _vm._v(" "), (_vm.selected.length > 0) ? _c('v-btn', {
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.sepaGenerieren(_vm.selected)
              }
            }
          }, [_vm._v("SEPA-Datei generieren")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
            staticClass: "subtitle-2 mt-2 mb-2 mr-6"
          }, [_vm._v("Summe: " + _vm._s(_vm.$filters.money(_vm.summe)))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-pagination', {
            attrs: {
              "total-visible": 7,
              "length": _vm.pageCount
            },
            model: {
              value: (_vm.page),
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          })]
        },
        proxy: true
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  }), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteRechnung,
      "title": "Rechnung löschen",
      "message": "Willst du diese Rechnung wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteRechnung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteRechnung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteRechnung = false
      }
    }
  }), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteMehrereRechnung,
      "title": _vm.selected.length + ' Rechnungen löschen',
      "message": 'Willst du wirklich ' + _vm.selected.length + ' Rechnung wirklich löschen?',
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteMehrereRechnung = $event
      },
      "closeTrue": function($event) {
        return _vm.loescheMehrere()
      },
      "closeFalse": function($event) {
        _vm.showDeleteMehrereRechnung = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSendRechnungen),
      callback: function($$v) {
        _vm.showSendRechnungen = $$v
      },
      expression: "showSendRechnungen"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Rechnungen mit SEPA versenden\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-stepper', {
    attrs: {
      "vertical": "",
      "flat": ""
    },
    model: {
      value: (_vm.stepperSendRechnungen),
      callback: function($$v) {
        _vm.stepperSendRechnungen = $$v
      },
      expression: "stepperSendRechnungen"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepperSendRechnungen > 1,
      "step": "1"
    }
  }, [_vm._v(" SEPA-Datei generieren ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("\n                Hier werden alle Rechnungen dieser Ansicht in einer SEPA-Datei zusammengefasst. Die Datei wird direkt\n                heruntergeladen und in der Datenbank für einen späteren Abruf gespeichert.\n                "), _c('br'), _c('br'), _vm._v("\n                Auch wenn das Datum in \"Zahlbar bis\" unterschiedlich ist, werden alle Rechnungen zum gleichen Datum\n                eingezogen. Das Datum kann dann auf der Seite der Bank angepasst werden.\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.sepaGenerieren()
      }
    }
  }, [_vm._v("SEPA Generieren")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepperSendRechnungen > 2,
      "step": "2"
    }
  }, [_vm._v(" Rechnungen versenden ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("\n                Hier können alle Rechnungen die gerade als SEPA-Datei zusammengefasst wurden zusammen versendet\n                werden. Der Versand kann längere Zeit dauern. (Dauer ca 30 Rechnungen/Minute)\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.stepperSendRechnungen = 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "rounded ml-8 mr-2",
    attrs: {
      "value": _vm.progressSendSepa,
      "height": "30",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.progressSendSepa) + "%")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.sepaRechnungenVersenden()
      }
    }
  }, [_vm._v("Versenden")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepperSendRechnungen > 3,
      "step": "3"
    }
  }, [_vm._v(" Abgeschlossen ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(" Fertig. Du kannst das Fenster jetzt schließen. ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.stepperSendRechnungen = 2
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showMehrereBearbeiten),
      callback: function($$v) {
        _vm.showMehrereBearbeiten = $$v
      },
      expression: "showMehrereBearbeiten"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.selected.length) + " Rechnungen bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMehrereBearbeiten = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" Hier können für alle Rechnungen gleichzeitig bestimmte Felder angepasst werden. ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.bearbeiteteFelder.rechnung_titel),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "rechnung_titel", $$v)
      },
      expression: "bearbeiteteFelder.rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Rechnungsdatum",
      "hint": "Format: 2022-03-17"
    },
    model: {
      value: (_vm.bearbeiteteFelder.rechnung_datum),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "rechnung_datum", $$v)
      },
      expression: "bearbeiteteFelder.rechnung_datum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Rechnung Zahlbar bis",
      "hint": "Format: 2022-03-17"
    },
    model: {
      value: (_vm.bearbeiteteFelder.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "rechnung_zahlbar_bis", $$v)
      },
      expression: "bearbeiteteFelder.rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Status",
      "hint": "Möglich: Entwurf, Entwurf SEPA, Offen"
    },
    model: {
      value: (_vm.bearbeiteteFelder.status),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "status", $$v)
      },
      expression: "bearbeiteteFelder.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "red",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteMehrereRechnung = true
      }
    }
  }, [_vm._v("Löschen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showMehrereBearbeiten = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.bearbeiteMehrere()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_schankverlust_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v("Schankverlust " + _vm._s(_vm.$filters.date(_vm.monat, "MM.YY")))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Striche Soll (Theorie)")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.gesamtStricheTheorie))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Striche Ist (Praxis)")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.gesamtStrichePraxis))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Striche Differenz")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) + " (" + _vm._s(_vm.statistik.schankverlust) + "%)\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10% Schankverlust")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s((_vm.statistik.gesamtStricheTheorie * 0.1).toFixed(0)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("fehlende Striche")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.statistik.gesamtStricheTheorie -
    _vm.statistik.gesamtStrichePraxis -
    (_vm.statistik.gesamtStricheTheorie * 0.1).toFixed(0)) + "\n          ")])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-3"
  }, [_c('td', [_vm._v("Fehlbetrag Schankverlust")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) * _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-3"
  }, [_c('td', [_vm._v("Fehlbetrag Schankverlust (-10%)")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie -
      _vm.statistik.gesamtStricheTheorie * 0.1 -
      _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oe-Kisten")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.oettingerKisten))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Couleurstriche")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.statistik.couleurstricheAnzahl))])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-3"
  }, [_c('td', [_vm._v("Kosten Oettinger und Couleurbier")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")((parseFloat(_vm.statistik.oettingerKistenPreis) +
    _vm.statistik.couleurstricheAnzahl * _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])]), _vm._v(" "), _c('tr', {
    staticClass: "amber lighten-1 font-weight-bold"
  }, [_c('td', [_vm._v("Summe")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")((_vm.statistik.oettingerKisten * 6.78 +
    _vm.statistik.couleurstricheAnzahl * _vm.statistik.durchschnittsStrichPreis +
    _vm.statistik.gesamtStricheTheorie -
    _vm.statistik.gesamtStrichePraxis -
    (_vm.statistik.gesamtStricheTheorie * 0.1).toFixed(0) * _vm.statistik.durchschnittsStrichPreis))) + "\n          ")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-4 pb-0 text-center green lighten-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_birthday_1x.jpg'
    }
  }, [_c('v-card-title', [_vm._v("Alles Gute zum Geburtstag!")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Eigene Rechnungen")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rechnungsnummer")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Zahlbar bis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungen), function(item) {
    return _c('tr', {
      key: item.name,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.$filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY")))])])
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bbrbbr.length) + " registrierte Nutzer\n      "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": "calc(100vh - 480px)",
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "no-data-text": "Keine Kontakte vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('tr', {
          staticClass: "hidden-xs-only"
        }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anmeldeID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))])]), _vm._v(" "), _c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 470px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Kontoname")]), _vm._v(" "), _c('th', [_vm._v("IBAN")]), _vm._v(" "), _c('th', [_vm._v("BIC")]), _vm._v(" "), _c('th', [_vm._v("Bank")]), _vm._v(" "), _c('th', [_vm._v("Sepa-Einzug möglich")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kassen), function(item, itemObjKey) {
    return (item !== 'kassen') ? _c('tr', {
      key: itemObjKey
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.kontoname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.IBAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.BIC))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bank))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sepa))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.neueKasse = item) && (_vm.istNeu = false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)]) : _vm._e()
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "disabled": !_vm.istNeu,
      "hint": "Der Name kann später nicht mehr geändert werden!",
      "outlined": "",
      "label": "Name"
    },
    model: {
      value: (_vm.neueKasse.name),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "name", $$v)
      },
      expression: "neueKasse.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Kontoname"
    },
    model: {
      value: (_vm.neueKasse.kontoname),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "kontoname", $$v)
      },
      expression: "neueKasse.kontoname"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Absender für Mails"
    },
    model: {
      value: (_vm.neueKasse.absender),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "absender", $$v)
      },
      expression: "neueKasse.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "items": _vm.templates,
      "label": "Mailtemplate"
    },
    model: {
      value: (_vm.neueKasse.template),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "template", $$v)
      },
      expression: "neueKasse.template"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "IBAN",
      "hint": "ohne Leerzeichen"
    },
    model: {
      value: (_vm.neueKasse.IBAN),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "IBAN", $$v)
      },
      expression: "neueKasse.IBAN"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "BIC"
    },
    model: {
      value: (_vm.neueKasse.BIC),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "BIC", $$v)
      },
      expression: "neueKasse.BIC"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Bank"
    },
    model: {
      value: (_vm.neueKasse.bank),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "bank", $$v)
      },
      expression: "neueKasse.bank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Gläubiger ID"
    },
    model: {
      value: (_vm.neueKasse.glaubigerID),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "glaubigerID", $$v)
      },
      expression: "neueKasse.glaubigerID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Sepa-Einzug möglich"
    },
    model: {
      value: (_vm.neueKasse.sepa),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "sepa", $$v)
      },
      expression: "neueKasse.sepa"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-alert', {
    attrs: {
      "border": "bottom",
      "color": "accent",
      "colored-border": "",
      "type": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n          Einmal erstellte Kassen können nicht mehr umbenannt oder gelöscht werden!\n        ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        (_vm.neueKasse = []) && (_vm.istNeu = true)
      }
    }
  }, [_c('v-icon', [_vm._v("settings_backup_restore")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "icon": "",
      "dark": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.addKasse()
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-sheet', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "height": "100vh",
      "width": "100%",
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "height": "100vh",
      "width": "400px",
      "color": "transparent"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl text-center px-4 py-12 overflow-auto",
    attrs: {
      "max-height": "80%"
    }
  }, [_c('v-avatar', {
    staticClass: "ma-1",
    attrs: {
      "size": 164,
      "color": "grey lighten-5"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoUrl,
      "lazy-src": ''
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.route))]), _vm._v(" "), (_vm.route === 'Anmelden') ? _c('signinForm') : _vm._e(), _vm._v(" "), (_vm.route === 'Registrieren') ? _c('signupForm') : _vm._e(), _vm._v(" "), (_vm.route === 'Passwort vergessen') ? _c('updatePasswordForm') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "py-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Kontaktfelder")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Neben festen Kontaktfeldern können beliebig viele eigene Kontaktfelder hinzugefügt werden.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "py-2 px-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n                Pflichtfelder\n              ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "text-caption"
  }, [_vm._v("\n                Pflichtfelder können nicht entfernt werden, da sie für die Anwendung zwingend notwendig sind.\n              ")]), _vm._v(" "), _c('v-card-text', _vm._l((_vm.pflichtFelder), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-chip', {
      staticClass: "mt-1",
      class: _vm.kontaktfelder.find(function (val) { return val.value === item.value; }) ? 'green' : '',
      attrs: {
        "label": "",
        "small": "",
        "outlined": ""
      }
    }, [(_vm.kontaktfelder.find(function (val) { return val.value === item.value; })) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "green"
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n                    " + _vm._s(item.label) + "\n                  ")], 1)], 1)
  }), 0), _vm._v(" "), _c('v-card-title', [_vm._v("\n                Standardfelder\n              ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "text-caption"
  }, [_vm._v("\n                Standardfelder sind nicht verpflichtend bieten aber einige Vorteile, da sie z.B. in Widgets verwendet werden.\n              ")]), _vm._v(" "), _c('v-card-text', _vm._l((_vm.standardFelder), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-chip', {
      staticClass: "mt-1",
      class: _vm.kontaktfelder.find(function (val) { return val.value === item.value; }) ? 'green' : '',
      attrs: {
        "label": "",
        "small": "",
        "outlined": ""
      },
      on: {
        "click": function($event) {
          return _vm.addStandardfeld(item)
        }
      }
    }, [(_vm.kontaktfelder.find(function (val) { return val.value === item.value; })) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "green"
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n                    " + _vm._s(item.label) + "\n                  ")], 1)], 1)
  }), 0), _vm._v(" "), _c('v-card-title', [_vm._v("\n                Gelöschte Felder\n              ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "text-caption"
  }, [_vm._v("\n                Eigene Felder die du gelöscht hast. Du kannst sie erneut hinzufügen.\n              ")]), _vm._v(" "), _c('v-card-text', _vm._l((_vm.deletedFelder), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-chip', {
      staticClass: "mt-1",
      class: _vm.kontaktfelder.find(function (val) { return val.value === item.value; }) ? 'green' : '',
      attrs: {
        "label": "",
        "small": "",
        "outlined": ""
      }
    }, [(_vm.kontaktfelder.find(function (val) { return val.value === item.value; })) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "green"
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n                    " + _vm._s(item.label) + "\n                  ")], 1)], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "height": "650px",
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Variable Kontaktfelder")]), _vm._v(" "), _c('th', [_vm._v("Art")]), _vm._v(" "), _c('th', [_vm._v("Bearbeitbar")]), _vm._v(" "), _c('th', [_vm._v("Feldbreite")]), _vm._v(" show: false,\n                    "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20px"
    }
  }, [_vm._v("Im Profil-Dialog zeigen")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "group": "myGroup",
      "tag": "tbody"
    },
    on: {
      "change": function($event) {
        return _vm.updateKontaktfelder()
      }
    },
    model: {
      value: (_vm.kontaktfelder),
      callback: function($$v) {
        _vm.kontaktfelder = $$v
      },
      expression: "kontaktfelder"
    }
  }, _vm._l((_vm.kontaktfelder), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "170px"
      }
    }, [(!item.default) ? _c('v-select', {
      attrs: {
        "hide-details": "",
        "dense": "",
        "outlined": "",
        "items": _vm.types
      },
      on: {
        "change": function($event) {
          return _vm.updateKontaktfelder()
        }
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.type === 'Select' && !item.default) ? _c('td', [_c('v-combobox', {
      attrs: {
        "hide-details": "auto",
        "hint": "Optionen Eingeben und mit Enter bestätigen",
        "multiple": "",
        "small-chips": "",
        "deletable-chips": "",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: (item.options),
        callback: function($$v) {
          _vm.$set(item, "options", $$v)
        },
        expression: "item.options"
      }
    })], 1) : _c('td'), _vm._v(" "), _c('td', {
      attrs: {
        "width": "50px"
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "dense": "",
        "flat": "",
        "items": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      },
      on: {
        "change": function($event) {
          return _vm.updateKontaktfelder()
        }
      },
      model: {
        value: (item.breite),
        callback: function($$v) {
          _vm.$set(item, "breite", $$v)
        },
        expression: "item.breite"
      }
    })], 1), _vm._v(" "), (item.show) ? _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (item.show = !item.show);
          _vm.updateKontaktfelder()
        }
      }
    }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1) : _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (item.show = !item.show);
          _vm.updateKontaktfelder()
        }
      }
    }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [(!item.required) ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.dropKontaktfeld(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)])
  }), 0)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Kontaktfeld hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.addKontaktfeld
    },
    model: {
      value: (_vm.kontaktfeld),
      callback: function($$v) {
        _vm.kontaktfeld = $$v
      },
      expression: "kontaktfeld"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Status")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Definiert die Auswahlmöglichkeiten des Feld \"Status\". Kontakte die Mitglied sind können Informationen von anderen Mitglieder ansehen.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "400px",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("gilt als Mitglied")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.alleStatus), function(item) {
    return _c('tr', {
      key: item.status
    }, [_c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), ((item.mitglied === true)) ? _c('td', {
      staticClass: "text-center"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleMitglied(item)
        }
      }
    }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1) : _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleMitglied(item)
        }
      }
    }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.dropStatus(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Status hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.addStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Finanzfelder")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "SEPA-Lastschriftmandat abfragen",
      "hide-details": "",
      "density": "compact"
    },
    on: {
      "change": function($event) {
        return _vm.updateKontaktfelder()
      }
    },
    model: {
      value: (_vm.finanzFelder.showSepaMandat),
      callback: function($$v) {
        _vm.$set(_vm.finanzFelder, "showSepaMandat", $$v)
      },
      expression: "finanzFelder.showSepaMandat"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "IBAN, BIC etc. abfragen",
      "hide-details": "",
      "density": "compact"
    },
    on: {
      "change": function($event) {
        return _vm.updateKontaktfelder()
      }
    },
    model: {
      value: (_vm.finanzFelder.showBankdaten),
      callback: function($$v) {
        _vm.$set(_vm.finanzFelder, "showBankdaten", $$v)
      },
      expression: "finanzFelder.showBankdaten"
    }
  })], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "200px",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Beitragsfelder")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.finanzFelder.beitrage), function(item) {
    return _c('tr', {
      key: item.status
    }, [_c('td', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.dropBeitrag(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Status hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBeitrag()
      }
    },
    model: {
      value: (_vm.finanzBeitrag),
      callback: function($$v) {
        _vm.finanzBeitrag = $$v
      },
      expression: "finanzBeitrag"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 550px)",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30px"
    }
  }, [_vm._v("Nr")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30px"
    }
  }, [_vm._v("Öffentlich")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Farbe")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kalender), function(item, itemObjKey) {
    return (item !== 'kalender') ? _c('tr', {
      key: itemObjKey
    }, [_c('td', [_vm._v(_vm._s(item.nummer))]), _vm._v(" "), _c('td', [(item.isPublic) ? _c('v-icon', [_vm._v("group")]) : _c('v-icon', [_vm._v("block")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      style: ('background-color: ' + item.farbe + ';')
    }, [_vm._v(_vm._s(item.farbe.hex))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.neuerKalender = item) && (_vm.istNeu = false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)]) : _vm._e()
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "disabled": !_vm.istNeu,
      "hint": "Der Name kann später nicht mehr geändert werden!",
      "outlined": "",
      "label": "Name"
    },
    model: {
      value: (_vm.neuerKalender.name),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "name", $$v)
      },
      expression: "neuerKalender.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "number",
      "label": "Nummer"
    },
    model: {
      value: (_vm.neuerKalender.nummer),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "nummer", $$v)
      },
      expression: "neuerKalender.nummer"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Öffentlich (Der Kalender ist für alle Mitglieder sichtbar und kann abonniert werden. Ansonsten nur für Inhaber von Ämtern sichtbar.)"
    },
    model: {
      value: (_vm.neuerKalender.isPublic),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "isPublic", $$v)
      },
      expression: "neuerKalender.isPublic"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-color-picker', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "flat": "",
      "mode": "hexa",
      "hide-mode-switch": "",
      "hide-canvas": "",
      "swatches": _vm.swatches,
      "show-swatches": ""
    },
    model: {
      value: (_vm.neuerKalender.farbe),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "farbe", $$v)
      },
      expression: "neuerKalender.farbe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-alert', {
    attrs: {
      "border": "bottom",
      "color": "accent",
      "colored-border": "",
      "type": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n          Einmal erstellte Kalender können nicht mehr umbenannt oder gelöscht werden!\n        ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        (_vm.neuerKalender = {}) && (_vm.istNeu = true)
      }
    }
  }, [_c('v-icon', [_vm._v("settings_backup_restore")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "icon": "",
      "dark": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.addKalender()
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showTemplate = true) && (_vm.template = {}) && (_vm.istNeu = true)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Hinzufügen")], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Kategorie")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.templates), function(item, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          (_vm.showTemplate = true) && (_vm.template = item) && (_vm.istNeu = false)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.kategorie))])])
  }), 0)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showTemplate),
      callback: function($$v) {
        _vm.showTemplate = $$v
      },
      expression: "showTemplate"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Template bearbeiten - " + _vm._s(_vm.template.name) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showTemplate = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Templatename"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "items": _vm.templateKategorien,
      "label": "Templatekategorie"
    },
    model: {
      value: (_vm.template.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.template, "kategorie", $$v)
      },
      expression: "template.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "label": "Inhalt",
      "rows": "25"
    },
    model: {
      value: (_vm.template.html),
      callback: function($$v) {
        _vm.$set(_vm.template, "html", $$v)
      },
      expression: "template.html"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": "700"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.template.html)
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteTemplate()
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateTemplates()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": _vm.$vuetify.breakpoint.smAndDown ? '90%' : '50%',
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "hide-scrollbar pa-0 ma-0",
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'transparent' : 'rounded-xl'
  }, [_c('v-card-text', {
    staticClass: "ma-0 mt-n1",
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'px-8' : 'pa-0',
    staticStyle: {
      "z-index": "100"
    }
  }, [_c('v-card-title', {
    staticClass: "hidden-sm-and-up"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "icon": "",
      "href": 'tel:' + _vm.bbr.handy,
      "disabled": !_vm.bbr.handy
    }
  }, [_c('v-icon', [_vm._v("phone")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-3",
          attrs: {
            "icon": "",
            "target": "_blank",
            "href": 'https://wa.me/' + _vm.bbr.handy.replace(/\s+/g, ''),
            "disabled": !_vm.bbr.handy
          }
        }, on), [_c('v-icon', [_vm._v("mdi-whatsapp")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [_vm._v(" Whatsapp ")])], 1)]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": 'mailto:' + _vm.bbr.email,
      "disabled": !_vm.bbr.email
    }
  }, [_c('v-icon', [_vm._v("mail")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-4 mb-n16 pb-n8 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-avatar', {
    staticClass: "white",
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'elevation-12' : '',
    attrs: {
      "size": "172"
    }
  }, [_c('v-avatar', {
    staticClass: "white elevation-0",
    staticStyle: {
      "z-index": "1000"
    },
    attrs: {
      "size": "156"
    },
    on: {
      "click": function($event) {
        _vm.showImage = true
      }
    }
  }, [(_vm.bbr.bildAhnengalerie500) ? _c('v-img', {
    staticClass: "ma-4 profilbild",
    attrs: {
      "max-height": "156",
      "src": _vm.bbr.bildAhnengalerie500
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-progress-circular', {
          attrs: {
            "size": "148",
            "width": "7",
            "indeterminate": "",
            "color": "primary"
          }
        })]
      },
      proxy: true
    }], null, false, 2530510412)
  }) : _c('v-icon', {
    staticClass: "grey lighten-3",
    attrs: {
      "light": "",
      "x-large": ""
    }
  }, [_vm._v("person")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl mt-n8 pt-8 pt-md-0",
    attrs: {
      "rounded": "",
      "flat": !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('v-card-title', {
    staticClass: "hidden-sm-and-down"
  }, [(_vm.allowEdit) ? _c('v-btn', {
    staticClass: "green mr-2",
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showBbrEdit = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-2",
          attrs: {
            "icon": "",
            "href": 'https://wa.me/' + _vm.bbr.handy.replace(/\s+/g, ''),
            "disabled": !_vm.bbr.handy
          }
        }, on), [_c('v-icon', [_vm._v("mdi-whatsapp")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_vm._v(" Whatsapp ")])], 1)]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "href": 'mailto:' + _vm.bbr.email,
            "target": "_blank",
            "disabled": !_vm.bbr.email
          }
        }, on), [_c('v-icon', [_vm._v("mail")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_vm._v(" Mail schreiben ")])], 1)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "text-center pt-16 pt-md-8 d-flex justify-center"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(_vm.bbr.titel) + " " + _vm._s(_vm.bbr.vorname) + " " + _vm._s(_vm.bbr.nachname))]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.bbr.chargen), function(charge) {
    return _c('v-chip', {
      key: charge.semester,
      staticClass: "mr-1",
      staticStyle: {
        "height": "48px"
      },
      attrs: {
        "small": "",
        "label": "",
        "pill": ""
      }
    }, [_vm._v("\n                  " + _vm._s(charge.charge) + "\n                  "), _vm._v(" "), _c('br'), _vm._v("\n                  " + _vm._s(charge.semester) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, _vm._l((_vm.felder.slice(
    0,
    Math.ceil(this.felder.filter(function (item) { return item.show; }).length / 2)
  )), function(feld, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "text-left"
    }, [(_vm.showHelp) ? _c('v-list-item-subtitle', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(feld.label))]) : _vm._e(), _vm._v(" "), (_vm.bbr[feld.value]) ? _c('span', [(feld.type === 'Date' && feld.value === 'geburtsdatum') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")) + " (" + _vm._s(_vm.calculateAge(_vm.bbr[feld.value])) + "\n                        Jahre)")]) : (feld.type === 'Date') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")))]) : _c('span', [_vm._v(" " + _vm._s(_vm.bbr[feld.value]))])]) : _vm._e()], 1)], 1)
  }), 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, _vm._l((_vm.felder.slice(Math.ceil(this.felder.filter(function (item) { return item.show; }).length / 2))), function(feld, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "text-left"
    }, [(_vm.showHelp) ? _c('v-list-item-subtitle', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(feld.label))]) : _vm._e(), _vm._v(" "), (_vm.bbr[feld.value]) ? _c('span', [(feld.type === 'Date' && feld.value === 'geburtsdatum') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")))]) : (feld.type === 'Date') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")))]) : (feld.type === 'Leibvater') ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(_vm.bbr[feld.value], _vm.bundesbruder)))]) : (feld.type === 'Verbindungen') ? _c('span', _vm._l((_vm.bbr[feld.value]), function(i, num) {
      return _c('span', {
        key: num
      }, [_vm._v("\n                          " + _vm._s(i) + "\n                        ")])
    }), 0) : _c('span', [_vm._v(_vm._s(_vm.bbr[feld.value]))])]) : _vm._e()], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "30%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showImage),
      callback: function($$v) {
        _vm.showImage = $$v
      },
      expression: "showImage"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2 ma-0"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bbr.bildAhnengalerie500,
      "width": "100%"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showImage = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), (_vm.showBbrEdit) ? _c('dialogKontaktEdit', {
    attrs: {
      "visibleEdit": _vm.showBbrEdit,
      "bbr": _vm.bbr
    },
    on: {
      "update:visibleEdit": function($event) {
        _vm.showBbrEdit = $event
      },
      "update:visible-edit": function($event) {
        _vm.showBbrEdit = $event
      },
      "close": function($event) {
        _vm.showBbrEdit = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStammbaum),
      callback: function($$v) {
        _vm.showStammbaum = $$v
      },
      expression: "showStammbaum"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Leibfamilie - " + _vm._s(_vm.bbr.titel) + " " + _vm._s(_vm.bbr.vorname) + " " + _vm._s(_vm.bbr.nachname) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStammbaum = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('stammbaum', {
    attrs: {
      "dense": _vm.denseStammbaum,
      "bbr": _vm.bbr,
      "currentBbr": _vm.bbr.id
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6"
  }, [(_vm.denseStammbaum) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.denseStammbaum = !_vm.denseStammbaum
      }
    }
  }, [_c('v-icon', [_vm._v("zoom_out_map")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.denseStammbaum = !_vm.denseStammbaum
      }
    }
  }, [_c('v-icon', [_vm._v("zoom_in_map")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStammbaum = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visibleEdit) ? _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visibleEdit),
      callback: function($$v) {
        _vm.visibleEdit = $$v
      },
      expression: "visibleEdit"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0 rounded-xl"
  }, [_c('v-card-title', [(_vm.$vars.beta) ? _c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": "green",
      "label": "",
      "dark": "",
      "small": ""
    }
  }, [_vm._v("Chargenansicht")]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.localBbr.titel) + " " + _vm._s(_vm.localBbr.vorname) + " " + _vm._s(_vm.localBbr.nachname) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": "",
      "center-active": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', [_vm._v(" Allgemein ")]), _vm._v(" "), _c('v-tab', [_vm._v(" Rechnungen ")]), _vm._v(" "), _c('v-tab', [_vm._v(" Nachrichten ")]), _vm._v(" "), _c('v-tab', [_vm._v(" Änderungen ")]), _vm._v(" "), (_vm.currentBbr === 'PBChUyAy7HWowQR4HlP3') ? _c('v-tab', [_vm._v(" Debug Data ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-tabs-items', {
    attrs: {
      "slider-color": "red"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 0) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "offset": "3",
      "order-xs": "5",
      "sm": "4",
      "offset-sm": "4",
      "md": "2",
      "offset-md": "0"
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "ma-4",
    attrs: {
      "src": _vm.localBbr.bildAhnengalerie200
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        (_vm.showPicture = true) &&
        (_vm.uploadStatus = {
          img_upload: null,
          img_url1: null,
          img_url2: null,
          img_url3: null
        }) &&
        (_vm.message = undefined)
      }
    }
  }, [_vm._v("Bild bearbeiten")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "pa-2 mt-2 text-center",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex justify-center"
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "size": "36",
      "indeterminate": "",
      "color": "primary"
    }
  }) : _c('span', [(_vm.checkMailValue.status) ? _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.changeLoginAllow
    }
  }, [_c('v-icon', [_vm._v("check_box")])], 1) : _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.changeLoginAllow
    }
  }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.checkMailValue.status) ? _c('span', [_vm._v("Der Kontakt darf sich für die App registrieren und einloggen.")]) : _c('span', [_vm._v("Registrieren und Einloggen unterbunden.")])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "text-center caption pt-4",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n                  Zuletzt geändert:\n                  "), _c('v-chip', {
    attrs: {
      "x-small": "",
      "label": ""
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("event")]), _vm._v(_vm._s(_vm.$filters.date(_vm.localBbr.zuletztGeaendertAm, "DD.MM.YYYY hh:mm")) + " Uhr")], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "x-small": "",
      "label": ""
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("person")]), _vm._v(_vm._s(_vm.$filters.user(_vm.localBbr.zuletztGeaendertVon, _vm.bbrbbr2)))], 1), _vm._v(" "), (_vm.localBbr.anmeldeID) ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "label": ""
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("check")]), _vm._v("Account bei Korpodesk")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "0",
      "lg": "5",
      "offset-lg": "0"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Kontaktdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.felder.neuFelder), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "2",
      "lg": "5",
      "offset-lg": "0"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Finanzdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2"
  }, [(_vm.felder.finanzFelder.showSepaMandat) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [(_vm.localBbr.sepaLastschriftmandat) ? _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]) : _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" SEPA-Lastschriftmandat ")]), _vm._v(" "), (_vm.localBbr.sepaLastschriftmandat) ? _c('v-card-subtitle', [_vm._v("\n                              " + _vm._s(_vm.$filters.date(_vm.localBbr.sepaLastschriftmandat.date, "hh:mm DD.MM.YYYY")) + " Uhr\n                            ")]) : _c('v-card-subtitle', [_vm._v("\n                              Aktuell wurde noch kein SEPA-Lastschriftmandat hochgeladen.\n                            ")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.localBbr.sepaLastschriftmandat) ? _c('span', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadLastschrift(_vm.localBbr.sepaLastschriftmandat)
      }
    }
  }, [_c('v-icon', [_vm._v("download")])], 1)], 1) : _c('span', [_c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingLaschriftmandatHochladen
    },
    on: {
      "click": function($event) {
        return _vm.clickHochladenLastschriftmandat()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cloud_upload")]), _vm._v("Hochladen\n                            ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "pdf/*"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1), _vm._v(" "), (_vm.loadingLaschriftmandatHochladen) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.felder.finanzFelder.beitrage), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "loading": _vm.loading_checkIban,
      "label": "IBAN"
    },
    on: {
      "change": function($event) {
        return _vm.checkIban()
      }
    },
    model: {
      value: (_vm.localBbr.iban),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "iban", $$v)
      },
      expression: "localBbr.iban"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "disabled": "",
      "label": "BIC",
      "placeholder": "Automatisch berechnet"
    },
    model: {
      value: (_vm.localBbr.bic),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "bic", $$v)
      },
      expression: "localBbr.bic"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Kontoinhaber",
      "append-icon": _vm.localBbr.kontoinhaber ? '' : 'refresh',
      "rules": [_vm.rules.required]
    },
    on: {
      "click:append": function($event) {
        _vm.localBbr.kontoinhaber = _vm.localBbr.vorname + ' ' + _vm.localBbr.nachname
      }
    },
    model: {
      value: (_vm.localBbr.kontoinhaber),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "kontoinhaber", $$v)
      },
      expression: "localBbr.kontoinhaber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Mandatsreferenz",
      "append-icon": _vm.localBbr.mandatsreferenz ? '' : 'refresh'
    },
    on: {
      "click:append": function($event) {
        return _vm.calcMandatsreferenz()
      }
    },
    model: {
      value: (_vm.localBbr.mandatsreferenz),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "mandatsreferenz", $$v)
      },
      expression: "localBbr.mandatsreferenz"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('uiKontaktField', {
    attrs: {
      "feld": {
        breite: 6,
        label: 'Mandat Unterschriftsdatum',
        type: 'Date',
        value: 'mandatUnterschriftsdatum',
      },
      "value": _vm.bbr.mandatUnterschriftsdatum
    },
    on: {
      "dataChange": function($event) {
        return _vm.saveData.apply(void 0, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fehlerSepa.sepa) ? _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.fehlerSepa.sepa))])], 1) : _vm._e()], 2), _vm._v(" "), (_vm.felder.finanzFelder.showSepaMandat) ? _c('span', [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("SEPA-Einstellungen")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "py-1"
  }, [_vm._v("Welche Kassen dürfen per SEPA Rechnungen einziehen?")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.disableSEPA) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("warning_amber")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" Kontodaten fehlen! ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n                                Damit ein SEPA-Einzug für einen Kontakt eingestellt werden kann, müssen zuerst die\n                                Kontodaten eingetragen werden.\n                              ")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.kassen), function(item, index) {
    return (item.name) ? _c('v-col', {
      key: index,
      staticClass: "py-1 px-1",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-checkbox', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "disabled": _vm.disableSEPA,
        "on-icon": "check_box",
        "off-icon": "check_box_outline_blank",
        "label": item.name
      },
      model: {
        value: (_vm.sepa[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.sepa, item.name, $$v)
        },
        expression: "sepa[item.name]"
      }
    })], 1) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.$vars.verbindung === 'rbo') ? _c('span', [(_vm.localBbr.versand) ? _c('span', [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Versand-Einstellungen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Semesterprogramm"
    },
    model: {
      value: (_vm.localBbr.versand['semesterprogramm']),
      callback: function($$v) {
        _vm.$set(_vm.localBbr.versand, 'semesterprogramm', $$v)
      },
      expression: "localBbr.versand['semesterprogramm']"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Einladungen"
    },
    model: {
      value: (_vm.localBbr.versand['einladungen']),
      callback: function($$v) {
        _vm.$set(_vm.localBbr.versand, 'einladungen', $$v)
      },
      expression: "localBbr.versand['einladungen']"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Ripuarenblätter"
    },
    model: {
      value: (_vm.localBbr.versand['ripuarenblätter']),
      callback: function($$v) {
        _vm.$set(_vm.localBbr.versand, 'ripuarenblätter', $$v)
      },
      expression: "localBbr.versand['ripuarenblätter']"
    }
  })], 1)], 1)], 1) : _c('span', [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localBbr.versand = {}
      }
    }
  }, [_vm._v("Versand-Einstellungen hinzufügen")])], 1)], 1)], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "2",
      "lg": "10",
      "offset-lg": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "hint": "Bemerkungen werden nur den Chargen und Ämtern angezeigt, die Zugriff auf die Kontaktbearbeitung haben.",
      "rows": "5",
      "auto-grow": "",
      "label": "Bemerkungen"
    },
    model: {
      value: (_vm.localBbr.bemerkungen),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "bemerkungen", $$v)
      },
      expression: "localBbr.bemerkungen"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-sheet', {
    staticClass: "pa-4",
    attrs: {
      "min-height": "calc(90vh - 166px)",
      "color": "grey lighten-4"
    }
  }, [_c('Rechnungen', {
    attrs: {
      "kontakt": _vm.localBbr.id
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 2) ? _c('v-simple-table', {
    staticClass: "hidden-xs-only",
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 166px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Absender")]), _vm._v(" "), _c('th', [_vm._v("Betreff")]), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "pa-0"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nachrichten), function(item) {
    return _c('tr', {
      key: item.name,
      on: {
        "dblclick": function($event) {
          (_vm.selectNachricht = item) && (_vm.showBbrNachricht = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.absender.name)), _c('br'), _vm._v(_vm._s(item.absender.position))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.message.subject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', {
      staticClass: "pa-0"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.selectNachricht = item) && (_vm.showBbrNachricht = true)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nachrichten), function(item) {
    return _c('v-card', {
      key: item.name,
      staticClass: "ma-2 hidden-sm-and-up",
      attrs: {
        "outlined": ""
      },
      on: {
        "dblclick": function($event) {
          (_vm.selectNachricht = item) && (_vm.showBbrNachricht = true)
        }
      }
    }, [_c('v-list-item', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "text-caption"
    }, [_vm._v("\n                    " + _vm._s(item.absender.name) + " " + _vm._s(item.absender.position) + " |\n                    " + _vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY hh:mm")) + " Uhr\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "subtitle-2"
    }, [_vm._v("\n                    " + _vm._s(item.message.subject) + "\n                  ")])], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 3) ? _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 166px)"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Geändert von")]), _vm._v(" "), _c('th', [_vm._v("Geändert am")]), _vm._v(" "), _c('th', [_vm._v("Geänderte Felder")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bearbeitungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.dataNeu.zuletztGeaendertVon, _vm.bbrbbr2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.dataNeu.zuletztGeaendertAm, "DD.MM.YYYY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', _vm._l((item.anders), function(item2, index2) {
      return _c('v-tooltip', {
        key: item2,
        attrs: {
          "bottom": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-chip', _vm._g({
              attrs: {
                "small": ""
              }
            }, on), [_vm._v(_vm._s(item2))])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-simple-table', {
        staticClass: "transparent",
        attrs: {
          "dense": "",
          "dark": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("von")]), _vm._v(" "), _c('th', [_vm._v("zu")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(item.dataAlt[item2] ? item.dataAlt[item2] : "-"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dataNeu[item2] ? item.dataNeu[item2] : "-"))])])])])], 1)
    }), 1)])
  }), 0)]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.currentBbr === 'PBChUyAy7HWowQR4HlP3') ? _c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 4) ? _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 166px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Data")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.localBbr), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (Array.isArray(item)) ? _c('td', [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((item), function(item2, index) {
      return _c('v-list-item', {
        key: index
      }, [_c('v-list-item-icon', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-list-item-content', [_vm._v(_vm._s(item2))])], 1)
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item))])])
  }), 0)]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteKontakt = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v("\n      " + _vm._s(_vm.localBbr.delete) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveBbr()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showPicture),
      callback: function($$v) {
        _vm.showPicture = $$v
      },
      expression: "showPicture"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Neues Bild hochladen - " + _vm._s(_vm.localBbr.titel) + " " + _vm._s(_vm.localBbr.vorname) + " " + _vm._s(_vm.localBbr.nachname) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-file-input', {
    attrs: {
      "loading": _vm.selectPicture !== '' && (!_vm.message || !_vm.error),
      "outlined": "",
      "dense": "",
      "prepend-icon": "attach_file",
      "label": "Neues Bild"
    },
    on: {
      "change": _vm.previewImage
    },
    model: {
      value: (_vm.selectPicture),
      callback: function($$v) {
        _vm.selectPicture = $$v
      },
      expression: "selectPicture"
    }
  }), _vm._v(" "), (_vm.uploadStatus.img_upload !== null) ? _c('span', [_c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadValue === 100 ? 'green' : 'blue',
      "value": _vm.uploadValue,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Upload (" + _vm._s(_vm.uploadValue.toFixed(0)) + " %)")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadStatus.img_url1 ? 'green' : 'blue',
      "value": _vm.uploadStatus.img_url1 ? 100 : 0,
      "indeterminate": _vm.uploadStatus.img_url1 === false,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Bild 1 berechnen")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadStatus.img_url2 ? 'green' : 'blue',
      "value": _vm.uploadStatus.img_url2 ? 100 : 0,
      "indeterminate": _vm.uploadStatus.img_url2 === false,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Bild 2 berechnen")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadStatus.img_url3 ? 'green' : 'blue',
      "value": _vm.uploadStatus.img_url3 ? 100 : 0,
      "indeterminate": _vm.uploadStatus.img_url3 === false,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Bild 3 berechnen")])], 1) : _vm._e(), _vm._v("\n        Neben dem Originalbild werden noch 3 weitere Versionen gespeichert. Falls ein Fehler auftritt lad die Seite\n        bitte neu und versuch das Bild erneut hochzuladen.\n\n        "), (_vm.message) ? _c('v-alert', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.uploadStatus.error) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n          Es ist ein Fehler aufgetreten. Bitte lade die Seite neu.\n          "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.uploadStatus.error) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.selectPicture !== '' && !(!_vm.message || !_vm.error),
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteKontakt,
      "title": "Kontakt löschen",
      "message": "Willst du diesen Kontakt wirklich löschen? Der Kontakt wird dabei als gelöscht markiert und erscheint in keinen weiteren Auflistungen. Er kann aber zu einem späteren Zeitpunkt wieder hergestellt werden. Eine endgültige Löschung ist nicht möglich.",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteKontakt = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteKontakt()
      },
      "closeFalse": function($event) {
        _vm.showDeleteKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showBbrRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showBbrRechnung = $event
      },
      "close": function($event) {
        _vm.showBbrRechnung = false
      }
    }
  }), _vm._v(" "), (_vm.selectNachricht) ? _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showBbrNachricht),
      callback: function($$v) {
        _vm.showBbrNachricht = $$v
      },
      expression: "showBbrNachricht"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.selectNachricht.message.subject) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showBbrNachricht = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n        " + _vm._s(_vm.$filters.date(_vm.selectNachricht.datum, "DD.MM.YYYY")) + " von " + _vm._s(_vm.selectNachricht.absender.name) + "\n      ")]), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-4 emailFeld",
    domProps: {
      "innerHTML": _vm._s(_vm.selectNachricht.message.html)
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showBbrNachricht = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n      " + _vm._s(_vm.nachricht.message.subject) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteMail(_vm.nachricht.id)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), (_vm.nachricht.status) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.nachricht.status))]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "pa-2"
  }, [(_vm.nachricht.datum) ? _c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("\n        " + _vm._s(_vm.$filters.date(_vm.nachricht.datum, "DD.MM.YYYY hh:mm")) + " Uhr\n      ")]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n      Von:\n      "), (_vm.nachricht.absender.position) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.position))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.absender.name) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.name))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(_vm.nachricht.von, _vm.bbrbbr)))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n        An:\n        "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n          " + _vm._s(item2) + "\n        ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n          " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n        ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n        CC:\n        "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n          " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n        ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n        BCC:\n        "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n          " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n        ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    staticStyle: {
      "overflow-y": "scroll"
    },
    attrs: {
      "max-height": "calc(100vh - 404px)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachricht.message.html)
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bbrbbr.length !== 0) ? _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_schankverlust_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v("Bierranking " + _vm._s(_vm.$filters.date(_vm.date, "MM.YY")))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.statistik), function(item, index) {
    return _c('tr', {
      key: item[0],
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showBbr = true)
        }
      }
    }, [(index === 0) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "amber--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 1) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "deep-orange--text darken-3"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index > 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item[0], _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])
  }), 0)])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-items', [_c('v-tabs', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.props))]), _vm._v(" "), _c('v-tab', [_vm._v("Andere Chargen")]), _vm._v(" "), _c('v-tab', [_vm._v("Neu")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "pt-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('todoSeite', {
    attrs: {
      "ToDo": "false",
      "showTitle": _vm.props.text,
      "wer": _vm.props,
      "anzahl": "-1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('todoSeite', {
    attrs: {
      "ToDo": "false",
      "showTitle": "Andere Chargen",
      "wer": "alle",
      "anzahl": "-1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('todoSeite', {
    attrs: {
      "ToDo": "true"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.dokumentArten), function(item, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          (_vm.showNeuesDokument = true) &&
          (_vm.neuesDokument = _vm.neuesDokumentDefault) &&
          (_vm.neuesDokument.art = item.value) &&
          (_vm.isNew = true)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.titel))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.beschreibung))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, _vm._l((_vm.dokumente), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', {
      staticClass: "rounded-lg",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', [_vm._v("\n          " + _vm._s(item.titel) + "\n        ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(_vm.dokumentArten.find(function (key) { return key.value === item.art; }).text))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.showNeuesDokument = true) && (_vm.neuesDokument = item) && (_vm.isNew = false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "primary--text",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.neuesDokument = item) && (_vm.printDokument())
        }
      }
    }, [_c('v-icon', [_vm._v("download")])], 1), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "70%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeuesDokument),
      callback: function($$v) {
        _vm.showNeuesDokument = $$v
      },
      expression: "showNeuesDokument"
    }
  }, [_c('v-card', [(_vm.isNew) ? _c('v-card-title', [_vm._v("\n        Neues Dokument erstellen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesDokument = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.neuesDokument.titel) + " bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesDokument = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.neuesDokument.titel),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument, "titel", $$v)
      },
      expression: "neuesDokument.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "items": _vm.dokumentArten,
      "label": "Art"
    },
    model: {
      value: (_vm.neuesDokument.art),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument, "art", $$v)
      },
      expression: "neuesDokument.art"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.neuesDokument.art === 'kommerseinladung') ? _c('span', [_vm._v("\n              Die Kommerseinladung ist eine 4 Seitige DIN-Lang Klappkarte. Es wird ein PDF mit zwei Seiten im Format \n              204 x 216 mm generiert. Auf der ersten Seite befindet sich die Vorder- und Rückseite und auf der zweiten \n              Seite der Innenteil. Die Text können frei angepasst werden. Enter zwischen den Worten sowie Leerzeilen \n              werden berücksichtigt.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'tagesordnung') ? _c('span', [_vm._v("\n              Die Tagesordnung ist auf wird auf einer A4 Seite dargestellt. Dabei kann sowohl vor als auch nach den \n              Tagesordnungspunkten ein Freitext hinzugefügt werden.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'rundbriefohneansprache') ? _c('span', [_vm._v("\n              Der Rundbrief kann eine oder mehrere A4-Seiten umfassen. Es wird keine Adresse der Bundesbrüder eingefügt. \n              Als Absender dient der ausgewählte Kontakt sowie das eingetragene Amt. Bei Mehrseitigen Dokumenten wird eine\n              Seitenzahl eingefügt.\n            ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.neuesDokument.art === 'kommerseinladung') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 1"
    },
    model: {
      value: (_vm.neuesDokument.data.titel1),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel1", $$v)
      },
      expression: "neuesDokument.data.titel1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 2"
    },
    model: {
      value: (_vm.neuesDokument.data.titel2),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel2", $$v)
      },
      expression: "neuesDokument.data.titel2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 3"
    },
    model: {
      value: (_vm.neuesDokument.data.titel3),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel3", $$v)
      },
      expression: "neuesDokument.data.titel3"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 4"
    },
    model: {
      value: (_vm.neuesDokument.data.titel4),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel4", $$v)
      },
      expression: "neuesDokument.data.titel4"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Untertitel 1"
    },
    model: {
      value: (_vm.neuesDokument.data.titel5),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel5", $$v)
      },
      expression: "neuesDokument.data.titel5"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Anschreiben"
    },
    model: {
      value: (_vm.neuesDokument.data.anschreiben),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "anschreiben", $$v)
      },
      expression: "neuesDokument.data.anschreiben"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Senior"
    },
    model: {
      value: (_vm.neuesDokument.data.senior),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "senior", $$v)
      },
      expression: "neuesDokument.data.senior"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Philsterenior"
    },
    model: {
      value: (_vm.neuesDokument.data.philsenior),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "philsenior", $$v)
      },
      expression: "neuesDokument.data.philsenior"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Tag 1"
    },
    model: {
      value: (_vm.neuesDokument.data.tag1),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag1", $$v)
      },
      expression: "neuesDokument.data.tag1"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hint": "Veranstaltungspunkte mit Enter trennen.",
      "outlined": "",
      "dense": "",
      "label": "Tag 1 Programm"
    },
    model: {
      value: (_vm.neuesDokument.data.tag1programm),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag1programm", $$v)
      },
      expression: "neuesDokument.data.tag1programm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Tag 2"
    },
    model: {
      value: (_vm.neuesDokument.data.tag2),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag2", $$v)
      },
      expression: "neuesDokument.data.tag2"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hint": "Veranstaltungspunkte mit Enter trennen.",
      "outlined": "",
      "dense": "",
      "label": "Tag 2 Programm"
    },
    model: {
      value: (_vm.neuesDokument.data.tag2programm),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag2programm", $$v)
      },
      expression: "neuesDokument.data.tag2programm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Tag 3"
    },
    model: {
      value: (_vm.neuesDokument.data.tag3),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag3", $$v)
      },
      expression: "neuesDokument.data.tag3"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hint": "Veranstaltungspunkte mit Enter trennen.",
      "outlined": "",
      "dense": "",
      "label": "Tag 3 Programm"
    },
    model: {
      value: (_vm.neuesDokument.data.tag3programm),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag3programm", $$v)
      },
      expression: "neuesDokument.data.tag3programm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Anmerkung"
    },
    model: {
      value: (_vm.neuesDokument.data.anmerkung),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "anmerkung", $$v)
      },
      expression: "neuesDokument.data.anmerkung"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'tagesordnung') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Überschrift"
    },
    model: {
      value: (_vm.neuesDokument.data.ueberschrift),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "ueberschrift", $$v)
      },
      expression: "neuesDokument.data.ueberschrift"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Freitext 1"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext1),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext1", $$v)
      },
      expression: "neuesDokument.data.freitext1"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.neuesDokument.data.tops.length + 1), function(index) {
    return _c('v-col', {
      key: index,
      staticClass: "pa-2",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-text-field', {
      attrs: {
        "hide-details": "",
        "outlined": "",
        "dense": "",
        "prefix": 'TOP ' + index
      },
      model: {
        value: (_vm.neuesDokument.data.tops[index - 1]),
        callback: function($$v) {
          _vm.$set(_vm.neuesDokument.data.tops, index - 1, $$v)
        },
        expression: "neuesDokument.data.tops[index - 1]"
      }
    })], 1)
  }), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Freitext 2"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext2),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext2", $$v)
      },
      expression: "neuesDokument.data.freitext2"
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'rundbriefohneansprache') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "items": _vm.selectBbrBbr,
      "label": "Absender"
    },
    model: {
      value: (_vm.neuesDokument.data.absender),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "absender", $$v)
      },
      expression: "neuesDokument.data.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Position"
    },
    model: {
      value: (_vm.neuesDokument.data.position),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "position", $$v)
      },
      expression: "neuesDokument.data.position"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Überschrift"
    },
    model: {
      value: (_vm.neuesDokument.data.ueberschrift),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "ueberschrift", $$v)
      },
      expression: "neuesDokument.data.ueberschrift"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "rows": "10",
      "label": "Freitext 1"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext", $$v)
      },
      expression: "neuesDokument.data.freitext"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'rundbrief160') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "items": _vm.selectBbrBbr,
      "label": "Absender"
    },
    model: {
      value: (_vm.neuesDokument.data.absender),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "absender", $$v)
      },
      expression: "neuesDokument.data.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Position"
    },
    model: {
      value: (_vm.neuesDokument.data.position),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "position", $$v)
      },
      expression: "neuesDokument.data.position"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Überschrift"
    },
    model: {
      value: (_vm.neuesDokument.data.ueberschrift),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "ueberschrift", $$v)
      },
      expression: "neuesDokument.data.ueberschrift"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "rows": "10",
      "label": "Freitext 1"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext", $$v)
      },
      expression: "neuesDokument.data.freitext"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.printDokument()
      }
    }
  }, [_vm._v("Drucken")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesDokument = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.isNew) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createDokument()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDokument()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_kerzen_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.semester) + "-Semesterbänder "), _c('br'), _vm._v(_vm._s(_vm.currentYear))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.jubilaeum.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Keine anstehenden Runden Jubiläen")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    staticClass: "rounded-lg",
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('tbody', _vm._l((_vm.jubilaeum), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.bbr = item.bbr;
          _vm.showKontakt = true;
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.receptionsdatum, "DD.MM.")))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)) + "\n            ")])])
  }), 0)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [(_vm.selectRechnung.rechnung_titel) ? _c('v-card-title', [(_vm.selectRechnung.status === 'Gezahlt') ? _c('v-chip', {
    staticClass: "green mr-2",
    attrs: {
      "small": "",
      "dark": "",
      "label": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.selectRechnung.status) + "\n      ")]) : _c('v-chip', {
    staticClass: "red mr-2",
    attrs: {
      "small": "",
      "dark": "",
      "label": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.selectRechnung.status) + "\n      ")]), _vm._v("\n      " + _vm._s(_vm.selectRechnung.rechnung_titel) + "\n      "), _c('v-spacer'), _vm._v(" "), (_vm.selectRechnung.status !== 'Entwurf' && _vm.selectRechnung.status !== 'Entwurf SEPA') ? _c('buttonRechnungDownload', {
    staticClass: "hidden-xs-only",
    attrs: {
      "small": true,
      "icon": "download",
      "rechnung": _vm.selectRechnung
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [(_vm.selectRechnung.log) ? _c('v-alert', {
    staticClass: "ma-3",
    attrs: {
      "outlined": "",
      "color": "primary",
      "dismissible": ""
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2"
  }, [_vm._v("Rechnung wurde " + _vm._s(_vm.selectRechnung.log.filter(function (item) { return item.type === "Mailversand"; }).length) + " mal per Mail\n          zugestellt.")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectRechnung.log.filter(function (item) { return item.type === 'Mailversand'; }).length > 0) ? _c('span', {
    staticClass: "text-caption"
  }, [_vm._v("Zuletzt versendet:\n          " + _vm._s(_vm.$filters.date(
    _vm.selectRechnung.log.filter(function (item) { return item.type === "Mailversand"; }).slice(-1)[0].date.seconds * 1000,
    "DD.MM.YYYYhhmm"
  )) + "\n          Uhr")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 hidden-xs-only mt-n1"
  }, [_c('v-col', {
    staticClass: "d-flex justify-end mb-n16",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-img', {
    staticClass: "mb-n16",
    attrs: {
      "src": _vm.logoUrl,
      "height": "256px",
      "max-width": "256px"
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 mt-12",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    staticClass: "primary",
    attrs: {
      "height": "4"
    }
  }), _vm._v(" "), (_vm.$vars.verbindung !== 'gfsm') ? _c('v-sheet', {
    staticClass: "secondary",
    attrs: {
      "height": "4"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$vars.verbindung !== 'gfsm') ? _c('v-sheet', {
    staticClass: "tertiary",
    attrs: {
      "height": "4"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.settings) ? _c('v-col', {
    staticClass: "mt-n4 mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v(_vm._s(_vm.settings.name))]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("| " + _vm._s(_vm.settings.strasse) + " " + _vm._s(_vm.settings.hausnummer) + " | " + _vm._s(_vm.settings.plz) + " " + _vm._s(_vm.settings.ort))])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Rechnungsnr.")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.rechnungsnummer) ? _c('span', [_vm._v(_vm._s(_vm.selectRechnung.rechnungsnummer))]) : _vm._e(), _c('br')]), _vm._v(" "), (_vm.selectRechnung.rechnung_datum) ? _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Rechnungsdatum")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectRechnung.rechnung_datum, "DD.MM.YYYY")))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Zahlbar bis")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.rechnung_zahlbar_bis) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectRechnung.rechnung_zahlbar_bis, "DD.MM.YYYY")))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Kasse")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.kasse) ? _c('span', [_vm._v(_vm._s(_vm.selectRechnung.kasse))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Rechnungsart")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.rechnung_art) ? _c('span', [_vm._v(_vm._s(_vm.selectRechnung.rechnung_art))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Gezahlt am")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.gezahlt_datum) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectRechnung.gezahlt_datum, "DD.MM.YYYY")))]) : _vm._e(), _c('br')])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.selectRechnung.rechnung_freitext) ? _c('v-textarea', {
    staticClass: "pa-1",
    attrs: {
      "readonly": "",
      "solo": "",
      "flat": "",
      "auto-grow": "",
      "max-rows": "15"
    },
    model: {
      value: (_vm.selectRechnung.rechnung_freitext),
      callback: function($$v) {
        _vm.$set(_vm.selectRechnung, "rechnung_freitext", $$v)
      },
      expression: "selectRechnung.rechnung_freitext"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.selectRechnung.positionen) ? _c('v-expansion-panels', {
    staticClass: "ma-0 pt-0 pb-0",
    attrs: {
      "flat": "",
      "accordion": "",
      "multiple": ""
    }
  }, [_vm._l((_vm.selectRechnung.positionen), function(item, itemObjKey) {
    return _c('v-expansion-panel', {
      key: item.name,
      attrs: {
        "readonly": !item.positionen.length > 0
      }
    }, [_c('v-divider'), _vm._v(" "), _c('v-expansion-panel-header', {
      attrs: {
        "hide-actions": !item.positionen.length > 0
      },
      scopedSlots: _vm._u([{
        key: "actions",
        fn: function() {
          return [_c('v-icon', [_vm._v("keyboard_arrow_down")])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(_vm._s(itemObjKey + 1) + "\n            "), _c('span', {
      staticClass: "pl-3"
    }, [_vm._v("\n              " + _vm._s(item.was) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "text-right pr-4"
    }, [_vm._v("\n              " + _vm._s(_vm._f("money")(item.betrag)) + "\n            ")])]), _vm._v(" "), (item.positionen) ? _c('v-expansion-panel-content', [(item.was === 'EKP') ? _c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', {
      staticClass: "overline py-0"
    }, [_vm._v("Zusammenfassung")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
      attrs: {
        "dense": "",
        "fixed-header": ""
      }
    }, [_c('tbody', _vm._l((item.result), function(item) {
      return _c('tr', {
        key: item.name
      }, [_c('th', {
        attrs: {
          "width": "30px"
        }
      }, [_vm._v(_vm._s(item.anzahl) + "x")]), _vm._v(" "), (item.was) ? _c('th', [_vm._v(_vm._s(item.was))]) : _vm._e(), _vm._v(" "), _c('th', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))])])
    }), 0)])], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
      staticClass: "mt-2",
      attrs: {
        "outlined": ""
      }
    }, [(item.was === 'EKP') ? _c('v-card-title', {
      staticClass: "overline py-0"
    }, [_vm._v("Einzelauflistung")]) : _vm._e(), _vm._v(" "), (item.was === 'EKP') ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-simple-table', {
      attrs: {
        "dense": "",
        "fixed-header": ""
      }
    }, [_c('tbody', _vm._l((item.positionen), function(item) {
      return _c('tr', {
        key: item.name
      }, [_c('td', {
        attrs: {
          "width": "130px"
        }
      }, [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), (item.anzahl !== undefined) ? _c('td', [_vm._v(_vm._s(item.anzahl))]) : _vm._e(), _vm._v(" "), (item.was) ? _c('td', [_vm._v(_vm._s(item.was))]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))])])
    }), 0)])], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "readonly": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-expansion-panel-header', {
    attrs: {
      "hide-actions": ""
    }
  }, [_c('span', {
    staticClass: "text-right pr-4 font-weight-bold"
  }, [_vm._v("\n              " + _vm._s(_vm._f("money")(_vm.selectRechnung.summe)) + "\n            ")])])], 1)], 2) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [(_vm.allowRechnungBearbeiten) ? _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        (_vm.showBearbeiten = true) && (_vm.bearbeiteRechnung = JSON.parse(JSON.stringify(_vm.selectRechnung)))
      }
    }
  }, [_vm._v("Bearbeiten")]) : _vm._e(), _vm._v(" "), (_vm.selectRechnung.status !== 'Entwurf' && _vm.selectRechnung.status !== 'Entwurf SEPA') ? _c('buttonRechnungSenden', {
    attrs: {
      "small": false,
      "icon": "outgoing_mail",
      "text": "Per Mail senden",
      "rechnung": _vm.selectRechnung
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.allowRechnungBearbeiten && _vm.selectRechnung.status !== 'Gezahlt') ? _c('v-btn', {
    staticClass: "green",
    attrs: {
      "rounded": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.neuerStatus(_vm.selectRechnung, 'Gezahlt')
      }
    }
  }, [_vm._v("Als Gezahlt markieren")]) : _vm._e(), _vm._v(" "), (
    (_vm.selectRechnung.status === 'Überfällig' || _vm.selectRechnung.status === 'Gemahnt überfällig') &&
    _vm.allowRechnungBearbeiten
  ) ? _c('v-btn', {
    staticClass: "red",
    attrs: {
      "rounded": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showMahnung = true
      }
    }
  }, [_vm._v("Mahnen")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showBearbeiten),
      callback: function($$v) {
        _vm.showBearbeiten = $$v
      },
      expression: "showBearbeiten"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": "green",
      "label": "",
      "dark": ""
    }
  }, [_vm._v("Chargenansicht")]), _vm._v("\n        Rechnung " + _vm._s(_vm.bearbeiteRechnung.rechnungsnummer) + " bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showBearbeiten = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-8 text-center subtitle-1"
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "text",
      "label": "Titel"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_titel),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_titel", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.selectBbrBbr,
      "label": "Empfänger",
      "disabled": ""
    },
    model: {
      value: (_vm.bearbeiteRechnung.bbrID),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "bbrID", $$v)
      },
      expression: "bearbeiteRechnung.bbrID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "text",
      "label": "Rechnungsnummer",
      "disabled": ""
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnungsnummer),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnungsnummer", $$v)
      },
      expression: "bearbeiteRechnung.rechnungsnummer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "date",
      "label": "Rechnungsdatum"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_datum),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_datum", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_datum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "date",
      "label": "Zahlbar bis"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_zahlbar_bis", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.statusItems,
      "label": "Status"
    },
    model: {
      value: (_vm.bearbeiteRechnung.status),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "status", $$v)
      },
      expression: "bearbeiteRechnung.status"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "rows": "8",
      "type": "text",
      "label": "Text"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_freitext),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_freitext", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_freitext"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_vm._l((_vm.bearbeiteRechnung.positionen), function(item, itemObjKey) {
    return _c('tr', {
      key: itemObjKey
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(itemObjKey + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.showEditPosition = true) && (_vm.neuePosition = item) && (_vm.selectedPositionIndex = itemObjKey)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right pr-4 font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.bearbeiteRechnung.summe)))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20px"
    }
  })])], 2)])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("Positionen können nur bearbeitet aber nicht hinzugefügt werden.")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showBearbeiten = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateRechnungData()
      }
    }
  }, [_vm._v("speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showEditPosition),
      callback: function($$v) {
        _vm.showEditPosition = $$v
      },
      expression: "showEditPosition"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Position bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showEditPosition = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "text",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.neuePosition.was),
      callback: function($$v) {
        _vm.$set(_vm.neuePosition, "was", $$v)
      },
      expression: "neuePosition.was"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [(_vm.neuePosition.positionen.length === 0) ? _c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "number",
      "label": "Betrag"
    },
    model: {
      value: (_vm.neuePosition.betrag),
      callback: function($$v) {
        _vm.$set(_vm.neuePosition, "betrag", $$v)
      },
      expression: "neuePosition.betrag"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.neuePosition.positionen.length > 0) ? _c('v-data-table', {
    attrs: {
      "items-per-page": _vm.neuePosition.positionen.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.neuePosition.positionen,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "label": "Bezeichnung",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.was),
            callback: function($$v) {
              _vm.$set(item, "was", $$v)
            },
            expression: "item.was"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "120px"
          }
        }, [_vm._v(_vm._s(_vm.$filters.date(item.datum.seconds * 1000)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "120px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.preis),
            callback: function($$v) {
              _vm.$set(item, "preis", $$v)
            },
            expression: "item.preis"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        })])]
      }
    }], null, false, 1897472944)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "pr-4 font-weight-bold"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.summePosition)))]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.savePosition()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showMahnung),
      callback: function($$v) {
        _vm.showMahnung = $$v
      },
      expression: "showMahnung"
    }
  }, [_c('v-card', [(_vm.selectRechnung.rechnungsnummer) ? _c('v-card-title', [_vm._v("\n        Rechnung mahnen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMahnung = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Mahngebühr hinzufügen?"
    },
    model: {
      value: (_vm.selectMahngebuehr),
      callback: function($$v) {
        _vm.selectMahngebuehr = $$v
      },
      expression: "selectMahngebuehr"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "number",
      "label": "Betrag"
    },
    model: {
      value: (_vm.wertMahngebuehr),
      callback: function($$v) {
        _vm.wertMahngebuehr = $$v
      },
      expression: "wertMahngebuehr"
    }
  })], 1), _vm._v(" "), (_vm.selectMahngebuehr) ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.artMahngebuehr),
      callback: function($$v) {
        _vm.artMahngebuehr = $$v
      },
      expression: "artMahngebuehr"
    }
  }, [_c('v-radio', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Betrag",
      "value": "Betrag"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Prozent",
      "value": "Prozent"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "text",
      "label": "Zahlbar bis",
      "hint": "Format: 2022-03-21, Standart in 14 Tagen"
    },
    model: {
      value: (_vm.mahnungUpdateData.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.mahnungUpdateData, "rechnung_zahlbar_bis", $$v)
      },
      expression: "mahnungUpdateData.rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "rows": "3",
      "label": "Freitext",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Mahnstufe>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "auto-grow": "",
      "outlined": ""
    },
    model: {
      value: (_vm.mahnungUpdateData.rechnung_freitext),
      callback: function($$v) {
        _vm.$set(_vm.mahnungUpdateData, "rechnung_freitext", $$v)
      },
      expression: "mahnungUpdateData.rechnung_freitext"
    }
  })], 1), _vm._v(" "), (_vm.selectMahngebuehr) ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            Der Rechnung wird eine weitere Position hinzugefügt."), _c('br'), _vm._v("\n            Mahngebühr: " + _vm._s(_vm.wertMahngebuehr) + " "), (_vm.artMahngebuehr === 'Betrag') ? _c('span', [_vm._v("€")]) : _vm._e(), (_vm.artMahngebuehr === 'Prozent') ? _c('span', [_vm._v("%")]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showMahnung = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    on: {
      "click": function($event) {
        return _vm.mahnen(_vm.selectRechnung)
      }
    }
  }, [_vm._v("Mahnen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showKontaktNeu = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showMehrereBearbeiten = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("edit_note")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Auswahl bearbeiten")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showImportExport = !_vm.showImportExport
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_upload")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Daten importieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.exportData()
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Daten exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showPrintDialog = true;
              _vm.printData = {};
            }
          }
        }, on), [_c('v-icon', [_vm._v("print")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Drucken")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showAenderungen = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("manage_accounts")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Kontaktänderungen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showFilterSpalten = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("tune")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Spalten")])]), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showImportExport) ? _c('dialogImportKontakte', {
    attrs: {
      "visible": _vm.showImportExport
    },
    on: {
      "close": function($event) {
        _vm.showImportExport = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "v-model": _vm.showVarGruppenLeiste,
      "app": "",
      "right": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp,
      "mini-variant": _vm.showGruppenLeiste
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.showGruppenLeiste = $event
      },
      "update:mini-variant": function($event) {
        _vm.showGruppenLeiste = $event
      }
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [(_vm.showGruppenLeiste) ? _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showGruppenLeiste = !_vm.showGruppenLeiste
      }
    }
  }, [_vm._v("keyboard_arrow_left")]) : _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showGruppenLeiste = !_vm.showGruppenLeiste
      }
    }
  }, [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("Gruppen")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        (_vm.selectedGruppe = null) && (_vm.selected = [])
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-list-item-icon', _vm._g({}, on), [_c('v-icon', [_vm._v("groups")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Alle Kontakte")])]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Alle Kontakte")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.setSelectedGruppeBbrBbr()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-list-item-icon', _vm._g({}, on), [_c('v-icon', [_vm._v("groups")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Alle " + _vm._s(_vm.bezMitglieder))])]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Alle " + _vm._s(_vm.bezMitglieder))])], 1)], 1), _vm._v(" "), _vm._l((_vm.gruppen.gruppen), function(gruppe, index) {
    return _c('v-list-group', {
      key: index,
      attrs: {
        "value": gruppe.expand
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(gruppe.titel))])], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((gruppe.gruppen), function(item, index2) {
      return _c('v-list-item', {
        key: index2,
        attrs: {
          "nav": ""
        },
        on: {
          "click": function($event) {
            (_vm.selectedGruppe = item) && (_vm.selected = [])
          }
        }
      }, [_c('v-tooltip', {
        attrs: {
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-list-item-icon', _vm._g({}, on), [_c('v-icon', [_vm._v("group")])], 1)]
          }
        }], null, true)
      }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.text))])], 1)
    })], 2)
  })], 2)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-iterator', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "dense": "",
      "height": "calc(100vh - 300px)",
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "items-per-page": -1,
      "no-data-text": "Keine Kontakte vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              (_vm.bbr = item) && (_vm.showBbr = true)
            }
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', [(item.titel) ? _c('span', {
          staticClass: "mr-1"
        }, [_vm._v(_vm._s(item.titel))]) : _vm._e(), _vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname) + "\n                  ")]), _vm._v(" "), _c('v-list-item-subtitle', {
          staticClass: "subtitle-2"
        }, [_vm._v("\n                    " + _vm._s(item.status) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('v-divider')]
      }
    }])
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "hidden-xs-only",
    attrs: {
      "height": "calc(100vh - 300px)",
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "items-per-page": 50,
      "footer-props": {
        'items-per-page-options': [50, 100, 250, -1],
        'items-per-page-text': 'Kontakte pro Seite',
      },
      "show-select": "",
      "single-select": "",
      "hide-default-header": _vm.hideHeader,
      "no-data-text": "Keine Kontakte vorhanden",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(items) {
        return [_vm._v("\n              " + _vm._s(items.pageStart) + " - " + _vm._s(items.pageStop) + " von " + _vm._s(items.itemsLength) + "\n            ")]
      }
    }, {
      key: "top",
      fn: function() {
        return [_c('v-row', {
          staticClass: "py-2 px-4",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [(_vm.selectedGruppe !== null) ? _c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.selectedGruppe.text) + " ("), (_vm.selected.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.selected.length) + "/")]) : _vm._e(), _vm._v(_vm._s(_vm.bbrbbr.length) + ")")]) : _c('span', {
          staticClass: "title"
        }, [_vm._v("Alle Kontakte ("), (_vm.selected.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.selected.length) + "/")]) : _vm._e(), _vm._v(_vm._s(_vm.bbrbbr.length) + ")")])])], 1), _vm._v(" "), _c('v-divider')]
      },
      proxy: true
    }, {
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th')])]
      }
    }, {
      key: "header.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('th', [(_vm.selected.length === 0) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect('alle')
            }
          }
        }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length !== 0 && _vm.selected.length !== _vm.bbrbbr.length) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect('alle')
            }
          }
        }, [_c('v-icon', [_vm._v("indeterminate_check_box")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length === _vm.bbrbbr.length) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect('keine')
            }
          }
        }, [_c('v-icon', [_vm._v("check_box")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          class: ['Ausgetreten', 'Verstorben'].indexOf(item.status) !== -1 ? 'grey--text grey lighten-4' : '',
          on: {
            "dblclick": function($event) {
              (_vm.bbr = item) && (_vm.showBbr = true)
            }
          }
        }, [(_vm.checkIndex(item.id)) ? _c('td', {
          staticClass: "pr-0",
          attrs: {
            "width": "20px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect(item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1) : _c('td', {
          staticClass: "pr-0",
          attrs: {
            "width": "20px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect(item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1), _vm._v(" "), _vm._l((_vm.headers), function(item2, index) {
          return _c('td', {
            key: index
          }, [(item2.item.type === 'Date') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(item[item2.value], "DD.MM.YYYY")))]) : (item2.item.type === 'Gruppen') ? _c('span', _vm._l((item[item2.value]), function(gruppe, gruppeindex) {
            return _c('v-chip', {
              key: gruppeindex,
              staticClass: "ma-1",
              attrs: {
                "label": "",
                "small": ""
              }
            }, [_vm._v(_vm._s(gruppe))])
          }), 1) : (item2.item.type === 'Leibvater') ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(item[item2.value], _vm.bbrbbr2)))]) : (item2.item.type === 'Verbindung') ? _c('span', [_vm._v(_vm._s(item[item2.value]))]) : (item2.item.type === 'Verbindungen') ? _c('span', _vm._l((item[item2.value]), function(ver, verindex) {
            return _c('v-chip', {
              key: verindex,
              staticClass: "ma-1",
              attrs: {
                "label": "",
                "small": ""
              }
            }, [_vm._v(_vm._s(ver))])
          }), 1) : _c('span', [_vm._v(_vm._s(item[item2.value]))])])
        })], 2)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showKontaktNeu) ? _c('dialogKontaktCreate', {
    attrs: {
      "visible": _vm.showKontaktNeu
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontaktNeu = $event
      },
      "close": function($event) {
        _vm.showKontaktNeu = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBbr) ? _c('dialogKontaktEdit', {
    attrs: {
      "visibleEdit": _vm.showBbr,
      "visible": _vm.showBbr,
      "bbr": _vm.bbr
    },
    on: {
      "update:visibleEdit": function($event) {
        _vm.showBbr = $event
      },
      "update:visible-edit": function($event) {
        _vm.showBbr = $event
      },
      "update:visible": function($event) {
        _vm.showBbr = $event
      },
      "close": function($event) {
        _vm.showBbr = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMehrereBearbeiten) ? _c('dialogKontaktEditMultiple', {
    attrs: {
      "visible": _vm.showMehrereBearbeiten,
      "selectedKontakte": _vm.selected
    },
    on: {
      "update:visible": function($event) {
        _vm.showMehrereBearbeiten = $event
      },
      "close": function($event) {
        _vm.showMehrereBearbeiten = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrintDialog) ? _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showPrintDialog),
      callback: function($$v) {
        _vm.showPrintDialog = $$v
      },
      expression: "showPrintDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "min-height": "600px"
    }
  }, [_c('v-card-title', [_vm._v("\n          Druck vorbereiten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showPrintDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm._v("\n              Welche Kontakte sollen gedruckt werden?\n              "), _c('v-radio-group', {
    model: {
      value: (_vm.printData.radioKontakte),
      callback: function($$v) {
        _vm.$set(_vm.printData, "radioKontakte", $$v)
      },
      expression: "printData.radioKontakte"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Alle Ausgewählten Kontakte (' + _vm.selected.length + ')',
      "value": "allSelected"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "allStatus"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\n                    Kontakte nach Status"), _c('v-select', {
          staticClass: "ml-2",
          attrs: {
            "dense": "",
            "single-line": "",
            "outlined": "",
            "hide-details": "",
            "small-chips": "",
            "chips": "",
            "clearable": "",
            "deletable-chips": "",
            "multiple": "",
            "items": _vm.itemsStatus,
            "label": "Hier auswählen"
          },
          model: {
            value: (_vm.printData.gruppen),
            callback: function($$v) {
              _vm.$set(_vm.printData, "gruppen", $$v)
            },
            expression: "printData.gruppen"
          }
        })]
      },
      proxy: true
    }], null, false, 919719247)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'Alle ' + _vm.bezMitglieder,
      "value": "allBbrBbr"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Alle Kontakte",
      "value": "all"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm._v("\n              Was willst du drucken?\n              "), _c('v-radio-group', {
    model: {
      value: (_vm.printData.druckelement),
      callback: function($$v) {
        _vm.$set(_vm.printData, "druckelement", $$v)
      },
      expression: "printData.druckelement"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "mitgliederverzeichnis"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Mitgliederverzeichnis ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Geburtstagsliste und Kontaktdaten")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF, A5")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 4041911693)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "geburtstagsliste"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Geburtstagsliste")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Geburtstagsliste, zwei Dateien für Sommer- und Wintersemester")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF, A4")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 1235835220)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "versandadressendina4"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Versandadressen DIN A4")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Briefumschlaf DIN A4 mit Fenster")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF A4, jeweils 1 Adresse pro Blatt")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 662733520)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "versandadressendina4mitAnschreiben"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Versandadressen DIN A4 mit Anschreiben")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Briefumschlaf DIN A4 mit Fenster")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF A4, jeweils 1 Adresse pro Blatt, dadrunter Anschreiben")]), _vm._v(" "), (_vm.printData.druckelement === 'versandadressendina4mitAnschreiben') ? _c('v-btn', {
          staticClass: "my-2",
          attrs: {
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.showAnschreiben = true
            }
          }
        }, [_vm._v("Anschreiben bearbeiten")]) : _vm._e()], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 887961730)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "versandadressendinlang"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Versandadressen DIN Lang")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Briefumschlaf DIN Lang mit Fenster")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF A4, jeweils 3 Adressen pro Blatt")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 1810279868)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showPrintDialog = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": "",
      "loading": _vm.$vars.loading,
      "disabled": _vm.printData.radioKontakte === undefined || _vm.printData.druckelement === undefined
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("PDF erstellen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAnschreiben) ? _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAnschreiben),
      callback: function($$v) {
        _vm.showAnschreiben = $$v
      },
      expression: "showAnschreiben"
    }
  }, [_c('v-card', {
    attrs: {
      "min-height": "500px"
    }
  }, [_c('v-card-title', [_vm._v("\n          Anschreiben bearbeiten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAnschreiben = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    staticClass: "pa-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "placeholder": "Titel eingeben"
    },
    model: {
      value: (_vm.printData.anschreibenTitel),
      callback: function($$v) {
        _vm.$set(_vm.printData, "anschreibenTitel", $$v)
      },
      expression: "printData.anschreibenTitel"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "pa-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "rows": "15",
      "placeholder": "Anschreiben eingeben"
    },
    model: {
      value: (_vm.printData.anschreiben),
      callback: function($$v) {
        _vm.$set(_vm.printData, "anschreiben", $$v)
      },
      expression: "printData.anschreiben"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAnschreiben = false
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAenderungen) ? _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAenderungen),
      callback: function($$v) {
        _vm.showAenderungen = $$v
      },
      expression: "showAenderungen"
    }
  }, [_c('v-card', {
    attrs: {
      "min-height": "500px"
    }
  }, [_c('v-card-title', [_vm._v("\n          Änderungen an den Mitgliederdaten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAenderungen = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "centered": "",
      "center-active": ""
    },
    model: {
      value: (_vm.jahrSelect),
      callback: function($$v) {
        _vm.jahrSelect = $$v
      },
      expression: "jahrSelect"
    }
  }, _vm._l((_vm.jahre), function(jahr, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._v("\n            " + _vm._s(jahr) + "\n          ")])
  }), 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.monatSelect),
      callback: function($$v) {
        _vm.monatSelect = $$v
      },
      expression: "monatSelect"
    }
  }, _vm._l((_vm.monate), function(monat, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._v("\n            " + _vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + monat, "MM")) + "\n          ")])
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 266px)"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Geänderter Kontakt")]), _vm._v(" "), _c('th', [_vm._v("Geändert durch")]), _vm._v(" "), _c('th', [_vm._v("Geändert am")]), _vm._v(" "), _c('th', [_vm._v("Geänderte Felder")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.bearbeitungen[_vm.jahre[_vm.jahrSelect]][_vm.monate[_vm.monatSelect]] === undefined) ? _c('td', {
    staticClass: "py-3 text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n                  Im " + _vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + _vm.monate[_vm.monatSelect], "MMMM YYYY")) + " wurden keine\n                  Änderungen vorgenommen.\n                ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.bearbeitungen[_vm.jahre[_vm.jahrSelect]][_vm.monate[_vm.monatSelect]]), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.elementId, _vm.bbrbbr2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.dataNeu.zuletztGeaendertVon, _vm.bbrbbr2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.dataNeu.zuletztGeaendertAm, "DD.MM.YYYY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', _vm._l((item.anders), function(item2, index2) {
      return _c('v-tooltip', {
        key: item2,
        attrs: {
          "bottom": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-chip', _vm._g({
              attrs: {
                "small": ""
              }
            }, on), [_vm._v(_vm._s(item2))])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-simple-table', {
        staticClass: "transparent",
        attrs: {
          "dense": "",
          "dark": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("von")]), _vm._v(" "), _c('th', [_vm._v("zu")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(item.dataAlt[item2] instanceof Object) ? _c('td', _vm._l((item.dataAlt[item2]), function(text, index2) {
        return _c('div', {
          key: index2
        }, [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                                " + _vm._s(text) + "\n                              ")])], 1)
      }), 0) : _c('td', [_vm._v(_vm._s(item.dataAlt[item2] ? item.dataAlt[item2] : "-"))]), _vm._v(" "), (item.dataNeu[item2] instanceof Object) ? _c('td', _vm._l((item.dataNeu[item2]), function(text, index3) {
        return _c('div', {
          key: index3
        }, [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                                " + _vm._s(text) + "\n                              ")])], 1)
      }), 0) : _c('td', [_vm._v(_vm._s(item.dataNeu[item2] ? item.dataNeu[item2] : "-"))])])])])], 1)
    }), 1)])
  })], 2)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAenderungen = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterSpalten) ? _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showFilterSpalten),
      callback: function($$v) {
        _vm.showFilterSpalten = $$v
      },
      expression: "showFilterSpalten"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n          Spalten bearbeiten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showFilterSpalten = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mt-2",
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "small-chips": "",
      "hide-details": "",
      "outlined": "",
      "multiple": "",
      "dense": "",
      "label": "Spalten auswählen",
      "items": _vm.kontaktfelder_system
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.selectHeaders),
      callback: function($$v) {
        _vm.selectHeaders = $$v
      },
      expression: "selectHeaders"
    }
  }), _vm._v(" "), _c('v-list', [_c('draggable', {
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.selectHeaders),
      callback: function($$v) {
        _vm.selectHeaders = $$v
      },
      expression: "selectHeaders"
    }
  }, _vm._l((_vm.selectHeaders), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.kontaktfelder_system.find(function (feld) { return feld.value === item; }).text))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showFilterSpalten = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showUpdate) ? _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showUpdate),
      callback: function($$v) {
        _vm.showUpdate = $$v
      },
      expression: "showUpdate"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Kontakte updaten ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-progress-linear', {
    attrs: {
      "stream": "",
      "rounded": "",
      "height": "24",
      "value": (_vm.updatedItems / _vm.allItems) * 100
    }
  }, [_vm._v("\n            " + _vm._s(_vm.updatedItems) + " von " + _vm._s(_vm.allItems) + "\n          ")]), _vm._v(" "), (_vm.updateData.error.length > 0) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.updateData.error) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpdate = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "550",
      "close-on-content-click": false,
      "activator": _vm.selectedElement,
      "nudge-bottom": 4,
      "offset-y": "",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [(_vm.selectedEvent) ? [_c('v-img', {
    attrs: {
      "src": _vm.selectedEventImage,
      "height": _vm.$vuetify.breakpoint.smAndDown ? '0px' : '220px'
    }
  }, [_c('v-card-title', {
    staticClass: "pt-3 px-5 ma-0 pa-0 justify-end"
  }, [_c('span', [(_vm.allowEdit(_vm.selectedEvent)) ? _c('v-btn', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnmeldungen()
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("print")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.shareVeranstaltung(_vm.selectedEvent)
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("ios_share")])], 1), _vm._v(" "), (_vm.allowEdit(_vm.selectedEvent)) ? _c('v-btn', {
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showVeranstaltungEdit = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("close")])], 1)], 1)])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pl-6 pb-0 pt-4 ma-0 pa-0",
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.3)"
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.selectedEvent.vonDatum, "DD.MM.YYYY")) + ", " + _vm._s(_vm.selectedEvent.vonZeit) + " Uhr -\n          " + _vm._s(_vm.selectedEvent.bisZeit) + " Uhr")])]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('span', {
    staticClass: "font-weight-bold black--text",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.selectedEvent.name))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-row', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.selectedEvent.bemerkung) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("info")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.bemerkung) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.ort) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.ort) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.anmeldungBis) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "font-weight-regular caption"
  }, [_vm._v("Anmeldung bis")]), _vm._v("\n                " + _vm._s(_vm.$filters.date(_vm.selectedEvent.anmeldungBis, "DD.MM.YYYY")) + "\n              ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.kleiderordnung) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("face")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.kleiderordnung) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.kategorie) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("label")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.kategorie) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.preis) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("euro")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm._f("money")(_vm.selectedEvent.preis)) + "\n              ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedEvent.anmeldungen) ? [_c('v-expansion-panels', {
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-n2 ma-0"
  }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v(" "), _c('v-list-item-content', {
    staticClass: "mr-n4"
  }, [(_vm.selectedEvent.anmeldungen.length + _vm.selectedEvent.weitereAnmeldungen.length === 1) ? _c('span', [_vm._v("1 Anmeldung")]) : _c('span', [_vm._v(_vm._s(_vm.selectedEvent.anmeldungen.length + _vm.selectedEvent.weitereAnmeldungen.length) + "\n                      Anmeldungen")])])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "max-height": "calc(100vh - 415px)",
      "dense": ""
    }
  }, [_c('tbody', [_vm._l((_vm.anmeldungen), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.bbr))])])
  }), _vm._v(" "), (_vm.selectedEvent.weitereAnmeldungen.length > 0) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showAlleAnmeldungen = !_vm.showAlleAnmeldungen
      }
    }
  }, [(!_vm.showAlleAnmeldungen) ? _c('td', [_vm._v("\n                        + " + _vm._s(_vm.selectedEvent.weitereAnmeldungen.length) + " Begleitungen\n                        "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e(), _vm._v(" "), (_vm.showAlleAnmeldungen) ? _c('td', [_c('v-icon', [_vm._v("keyboard_arrow_up")]), _vm._v(" Begleitungen ausblenden")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedEvent.weitereAnmeldungen), function(item) {
    return (_vm.showAlleAnmeldungen) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.name))])]) : _vm._e()
  })], 2)])], 1)], 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selectedEvent.anmeldungBis >= _vm.heute || !_vm.selectedEvent.anmeldungBis) ? _c('div', [(_vm.selectedEvent.anmeldungen) ? [(
    _vm.selectedEvent.anmeldungen.includes(_vm.currentBbr) &&
    !_vm.selectedEvent.pflichtanmeldungen.includes(_vm.currentBbrStatus)
  ) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        _vm.showZuVeranstaltungAbmelden = true
      }
    }
  }, [_vm._v("Abmelden")]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.anmeldungen.includes(_vm.currentBbr)) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showWeiterenAnmelden = true
      }
    }
  }, [_c('v-icon', [_vm._v("exposure_plus_1")])], 1) : _vm._e(), _vm._v(" "), (!_vm.selectedEvent.anmeldungen.includes(_vm.currentBbr)) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zuVeranstaltungAnmelden()
      }
    }
  }, [_vm._v("Anmelden")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedEvent.pflichtanmeldungen) ? _c('div', [(
    _vm.selectedEvent.anmeldungen.includes(_vm.currentBbr) &&
    _vm.selectedEvent.pflichtanmeldungen.includes(_vm.currentBbrStatus)
  ) ? _c('span', [_vm._v("\n              Du bist Pflichtangemeldet und kannst dich nicht über das System abmelden. Bitte melde dich diekt beim\n              Consenior ab. Dieser trägt das dann im System ein.\n            ")]) : _vm._e()]) : _vm._e()], 2) : _c('v-card-text', [_vm._v("\n          Eine An- oder Abmeldung zu dieser Veranstaltung ist nicht mehr möglich. Bitte wende Dich direkt an den\n          Consenior, falls du dich nachträglich an- bzw abmelden willst.\n        ")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showWeiterenAnmelden),
      callback: function($$v) {
        _vm.showWeiterenAnmelden = $$v
      },
      expression: "showWeiterenAnmelden"
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-card-title', [_vm._v(" Weitere Personen anmelden ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "pt-1"
  }, [_vm._v("\n        Hier kannst du weitere Personen, Freunde und Bekannte, die sich nicht selber anmelden können, anmelden.\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selectedEvent.weitereAnmeldungen), function(item) {
    return (item.angemeldetVon === _vm.currentBbr) ? _c('v-list-item', {
      key: item.id
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.weiterenAbmelden(item)
        }
      }
    }, [_vm._v("close")])], 1)], 1) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "placeholder": "Bitte Vorname und Nachname eintragen.",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.weiterenAnmelden()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showWeiterenAnmelden = false
      }
    }
  }, [_vm._v(" Schließen ")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showZuVeranstaltungAbmelden,
      "title": "Abmelden",
      "message": 'Willst du dich wirklich von der Veranstaltung ' + _vm.selectedEvent.name + ' abmelden?',
      "abbrechen": "Angemeldet bleiben",
      "weiter": "Abmelden"
    },
    on: {
      "update:visible": function($event) {
        _vm.showZuVeranstaltungAbmelden = $event
      },
      "closeTrue": function($event) {
        return _vm.zuVeranstaltungAbmelden()
      },
      "closeFalse": function($event) {
        _vm.showZuVeranstaltungAbmelden = false
      }
    }
  }), _vm._v(" "), _c('dialogVeranstaltungEdit', {
    attrs: {
      "visible": _vm.showVeranstaltungEdit,
      "veranstaltung": _vm.selectedEvent
    },
    on: {
      "update:visible": function($event) {
        _vm.showVeranstaltungEdit = $event
      },
      "close": function($event) {
        _vm.showVeranstaltungEdit = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_vm._v("\n  Test\n")])
},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      Kontakt erstellen\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-4"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Kontaktdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.felder.neuFelder), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Finanzdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2"
  }, [(_vm.felder.finanzFelder.showSepaMandat) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [(_vm.bbr.sepaLastschriftmandat) ? _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]) : _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" SEPA-Lastschriftmandat ")]), _vm._v(" "), (_vm.bbr.sepaLastschriftmandat) ? _c('v-card-subtitle', [_vm._v("\n                        " + _vm._s(_vm.$filters.date(_vm.bbr.sepaLastschriftmandat.date, "hh:mm DD.MM.YYYY")) + " Uhr\n                      ")]) : _c('v-card-subtitle', [_vm._v("\n                        Aktuell wurde noch kein SEPA-Lastschriftmandat hochgeladen.\n                      ")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.bbr.sepaLastschriftmandat) ? _c('span', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadLastschrift(_vm.bbr.sepaLastschriftmandat)
      }
    }
  }, [_c('v-icon', [_vm._v("download")])], 1)], 1) : _c('span', [_c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingLaschriftmandatHochladen
    },
    on: {
      "click": function($event) {
        return _vm.clickHochladenLastschriftmandat()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cloud_upload")]), _vm._v("Hochladen\n                      ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "pdf/*"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1), _vm._v(" "), (_vm.loadingLaschriftmandatHochladen) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', _vm._l((_vm.felder.finanzFelder.beitrage), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), 1), _vm._v(" "), _c('v-row', [(_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "loading": _vm.loading_checkIban,
      "label": "IBAN"
    },
    on: {
      "change": function($event) {
        return _vm.checkIban()
      }
    },
    model: {
      value: (_vm.bbr.iban),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "iban", $$v)
      },
      expression: "bbr.iban"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "disabled": "",
      "label": "BIC",
      "placeholder": "Automatisch berechnet"
    },
    model: {
      value: (_vm.bbr.bic),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "bic", $$v)
      },
      expression: "bbr.bic"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Kontoinhaber",
      "append-icon": _vm.bbr.kontoinhaber ? '' : 'refresh',
      "rules": [_vm.rules.required]
    },
    on: {
      "click:append": function($event) {
        _vm.bbr.kontoinhaber = _vm.bbr.vorname + ' ' + _vm.bbr.nachname
      }
    },
    model: {
      value: (_vm.bbr.kontoinhaber),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "kontoinhaber", $$v)
      },
      expression: "bbr.kontoinhaber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Mandatsreferenz",
      "append-icon": _vm.bbr.mandatsreferenz ? '' : 'refresh'
    },
    on: {
      "click:append": function($event) {
        return _vm.calcMandatsreferenz()
      }
    },
    model: {
      value: (_vm.bbr.mandatsreferenz),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "mandatsreferenz", $$v)
      },
      expression: "bbr.mandatsreferenz"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('uiKontaktField', {
    attrs: {
      "feld": {
        breite: 6,
        label: 'Mandat Unterschriftsdatum',
        type: 'Date'
      },
      "value": _vm.bbr['mandatUnterschriftsdatum']
    },
    on: {
      "dataChange": function($event) {
        return _vm.saveData.apply(void 0, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('uiKontaktField', {
    attrs: {
      "feld": {
        breite: 6,
        label: 'Letzter Lastschrifteinzug',
        type: 'Date'
      },
      "value": _vm.bbr['letzterLastschrifteinzug']
    },
    on: {
      "dataChange": function($event) {
        return _vm.saveData.apply(void 0, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fehlerSepa.sepa) ? _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.fehlerSepa.sepa))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.felder.finanzFelder.showSepaMandat) ? _c('span', [_c('v-card-title', {
    staticClass: "py-1 mt-6"
  }, [_vm._v("SEPA-Einstellungen")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "py-1"
  }, [_vm._v("Welche Kassen dürfen per SEPA Rechnungen einziehen?")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.disableSEPA) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("warning_amber")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" Kontodaten fehlen! ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n                          Damit ein SEPA-Einzug für einen Kontakt eingestellt werden kann, müssen zuerst die\n                          Kontodaten eingetragen werden.\n                        ")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.kassen), function(item, index) {
    return (item.name) ? _c('v-col', {
      key: index,
      staticClass: "py-1 px-1",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-checkbox', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "disabled": _vm.disableSEPA,
        "on-icon": "check_box",
        "off-icon": "check_box_outline_blank",
        "label": item.name
      },
      model: {
        value: (_vm.sepa[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.sepa, item.name, $$v)
        },
        expression: "sepa[item.name]"
      }
    })], 1) : _vm._e()
  })], 2)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "hint": "Bemerkungen werden nur den Chargen und Ämtern angezeigt, die Zugriff auf die Kontaktbearbeitung haben.",
      "rows": "5",
      "auto-grow": "",
      "label": "Bemerkungen"
    },
    model: {
      value: (_vm.bbr.bemerkungen),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "bemerkungen", $$v)
      },
      expression: "bbr.bemerkungen"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.pflichtfelder.length > 0) ? _c('span', {
    staticClass: "text-caption"
  }, [_vm._v("Folgende Felder müssen noch ausgefüllt werden:"), _c('br'), _vm._v(" "), _vm._l((_vm.pflichtfelder), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1 mt-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(item))])
  })], 2) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "disabled": _vm.pflichtfelder.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showPicture),
      callback: function($$v) {
        _vm.showPicture = $$v
      },
      expression: "showPicture"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Ahnengalerie - " + _vm._s(_vm.bbr.titel) + " " + _vm._s(_vm.bbr.vorname) + " " + _vm._s(_vm.bbr.nachname) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4",
      "offset": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm._v(" Aktuelles Bild ")]), _vm._v(" "), _c('v-img', {
    attrs: {
      "src": _vm.bbr.bildAhnengalerie,
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.showPicture = true
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm._v(" Neues Bild ")]), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Neues Bild"
    },
    on: {
      "change": _vm.previewImage
    },
    model: {
      value: (_vm.selectPicture),
      callback: function($$v) {
        _vm.selectPicture = $$v
      },
      expression: "selectPicture"
    }
  }), _vm._v(" "), _c('v-card-action', {
    staticClass: "text-center"
  }, [(_vm.message) ? _c('v-divider') : _vm._e(), _vm._v("\n                " + _vm._s(_vm.message) + "\n              ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-autocomplete', {
    staticClass: "mt-1 rounded-lg",
    attrs: {
      "height": "48px",
      "filled": "",
      "dense": "",
      "rounded": "",
      "clearable": "",
      "append-icon": "search",
      "hide-details": "",
      "placeholder": 'Kontakte suchen',
      "items": _vm.selectBundesbruder
    },
    on: {
      "change": function($event) {
        return _vm.selectBbr()
      }
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  }), _vm._v(" "), (_vm.bundesbruder) ? _c('div', [_c('dialogKontakt', {
    attrs: {
      "visible": _vm.showBbr,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showBbr = $event
      },
      "close": function($event) {
        _vm.showBbr = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card-title', [_vm._v("Vereinsanschrift")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Vereinsname"
    },
    model: {
      value: (_vm.settings.name),
      callback: function($$v) {
        _vm.$set(_vm.settings, "name", $$v)
      },
      expression: "settings.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Straße"
    },
    model: {
      value: (_vm.settings.strasse),
      callback: function($$v) {
        _vm.$set(_vm.settings, "strasse", $$v)
      },
      expression: "settings.strasse"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Nr."
    },
    model: {
      value: (_vm.settings.hausnummer),
      callback: function($$v) {
        _vm.$set(_vm.settings, "hausnummer", $$v)
      },
      expression: "settings.hausnummer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Ort"
    },
    model: {
      value: (_vm.settings.ort),
      callback: function($$v) {
        _vm.$set(_vm.settings, "ort", $$v)
      },
      expression: "settings.ort"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "PLZ"
    },
    model: {
      value: (_vm.settings.plz),
      callback: function($$v) {
        _vm.$set(_vm.settings, "plz", $$v)
      },
      expression: "settings.plz"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Land"
    },
    model: {
      value: (_vm.settings.land),
      callback: function($$v) {
        _vm.$set(_vm.settings, "land", $$v)
      },
      expression: "settings.land"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card-title', [_vm._v("Webadressen")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Haupt Mailadresse"
    },
    model: {
      value: (_vm.settings.mail),
      callback: function($$v) {
        _vm.$set(_vm.settings, "mail", $$v)
      },
      expression: "settings.mail"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Webseite"
    },
    model: {
      value: (_vm.settings.webseite),
      callback: function($$v) {
        _vm.$set(_vm.settings, "webseite", $$v)
      },
      expression: "settings.webseite"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Instagram"
    },
    model: {
      value: (_vm.settings.instagram),
      callback: function($$v) {
        _vm.$set(_vm.settings, "instagram", $$v)
      },
      expression: "settings.instagram"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Facebook"
    },
    model: {
      value: (_vm.settings.facebook),
      callback: function($$v) {
        _vm.$set(_vm.settings, "facebook", $$v)
      },
      expression: "settings.facebook"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card-title', [_vm._v("Administratoren")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.bundesbruderselect,
      "outlined": "",
      "chips": "",
      "deletable-chips": "",
      "label": "Admins",
      "multiple": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                  Admins haben alle Rechte beim Verwenden von Korpodesk. Nur Admins können diese Einstellungen bearbeiten. Es muss min. 1 Admin ausgewählt werden.\n                ")])]
      },
      proxy: true
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "small": "",
            "input-value": data.selected,
            "close": _vm.settings.admins.length > 1
          },
          on: {
            "click": data.select,
            "click:close": function($event) {
              return _vm.removeBerechtigung(data.item.value)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(data.item.text) + "\n                ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.settings.admins),
      callback: function($$v) {
        _vm.$set(_vm.settings, "admins", $$v)
      },
      expression: "settings.admins"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.error) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v(_vm._s(_vm.error.message))])], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "name": "email",
      "label": "E-Mail-Adresse",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "disabled": _vm.$vars.loading,
      "loading": _vm.$vars.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSignin()
      }
    }
  }, [_vm._v("\n        Passwort Zurücksetzen\n          "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": "",
      "to": "/anmelden"
    },
    on: {
      "click": function($event) {
        return _vm.onDismissed()
      }
    }
  }, [_vm._v("\n        Anmelden\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.error) ? _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [(_vm.error.code === 'auth/user-not-found') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n        Die angegebene Mailadresse ist falsch oder nicht vergeben. Solltest Du Dich noch nicht registriert haben, kannst Du das "), _c('a', {
    attrs: {
      "href": "/registrieren"
    }
  }, [_vm._v("HIER")]), _vm._v(" machen.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.error.code === 'auth/wrong-password') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n        Das Passwort ist falsch.\n      ")]) : _vm._e(), _vm._v(" "), ((_vm.error.code !== 'auth/user-not-found') && (_vm.error.code !== 'auth/wrong-password')) ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n        Bei der Anmeldung ist ein Fehler aufgetreten. Fehlercode: " + _vm._s(_vm.error.code) + " | " + _vm._s(_vm.error.message) + "\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "loading": _vm.loading,
      "append-icon": _vm.checkMailValue.status === null ? '' : (_vm.checkMailValue.status ? 'check' : 'close'),
      "hint": !_vm.checkMailValue.status ? _vm.checkMailValue.message : '',
      "persistent-hint": "",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkMail()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "name": "password",
      "label": "Passwort",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "disabled": !this.password || (this.checkMailValue.status === false) || (this.checkMailValue.status === null),
      "loading": _vm.$vars.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSignin()
      }
    }
  }, [_vm._v("\n        Anmelden\n      ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.goToRegistrierung()
      }
    }
  }, [_vm._v("\n        Registrieren\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": "",
      "to": "/passwortvergessen"
    },
    on: {
      "click": function($event) {
        return _vm.onDismissed()
      }
    }
  }, [_vm._v("\n        Passwort vergessen?\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.strichTabelleUpdate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.date)))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": _vm.getDatepicker
    },
    model: {
      value: (_vm.datepicker),
      callback: function($$v) {
        _vm.datepicker = $$v
      },
      expression: "datepicker"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.strichTabelleUpdate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Bundesbruder",
      "items": _vm.bundesbruderselect
    },
    model: {
      value: (_vm.bbrID),
      callback: function($$v) {
        _vm.bbrID = $$v
      },
      expression: "bbrID"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.stricheSet(-1)
      }
    }
  }, [_vm._v("-1")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.stricheSet(+1)
      }
    }
  }, [_vm._v("+1")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "EKP-Getränke",
      "items": _vm.getrankeselect
    },
    model: {
      value: (_vm.ekp),
      callback: function($$v) {
        _vm.ekp = $$v
      },
      expression: "ekp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "name": "",
      "label": "Anzahl Getränke",
      "id": ""
    },
    model: {
      value: (_vm.ekp_anzahl),
      callback: function($$v) {
        _vm.ekp_anzahl = $$v
      },
      expression: "ekp_anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "name": "",
      "label": "Pauschal",
      "id": ""
    },
    model: {
      value: (_vm.pauschal),
      callback: function($$v) {
        _vm.pauschal = $$v
      },
      expression: "pauschal"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "name": "",
      "label": "Grund",
      "id": ""
    },
    model: {
      value: (_vm.grund),
      callback: function($$v) {
        _vm.grund = $$v
      },
      expression: "grund"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-9 primary",
    attrs: {
      "absolute": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "small": "",
      "fab": ""
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "pt-2 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 510px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Preis")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          return _vm.deleteStrich(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pt-4 text-right",
    attrs: {
      "cols": "8"
    }
  }, [_vm._v("\n      Die Positionen werden nur gespeichert. "), _c('br'), _vm._v("\n      Die Rechnung kann unter Strichliste erstellt werden.\n    ")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Summe",
      "readonly": "",
      "value": _vm._f("money")(_vm.summe)
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('br')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-0 ma-0 rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.bezMitglieder) + " suchen")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-autocomplete', {
    staticClass: "mx-4",
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Suchen...",
      "items": _vm.selectBundesbruder
    },
    on: {
      "change": function($event) {
        return _vm.selectBbr()
      }
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  }), _vm._v(" "), (_vm.bundesbruder) ? _c('div', [_c('dialogKontakt', {
    attrs: {
      "visible": _vm.showBbr,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showBbr = $event
      },
      "close": function($event) {
        _vm.showBbr = false
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    staticClass: "mb-6",
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.close()
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v("close")])], 1)]
      }
    }]),
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbar.nachricht) + "\n  ")])
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    staticClass: "hidden-xs-only"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNeueVeranstaltung = true) && (_vm.neueVeranstaltung = {
                kalender: _vm.kalender[0]
              })
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.$refs.calendar.prev()
            }
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Letzter Monat")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.setToday()
            }
          }
        }, on), [_vm._v(_vm._s(_vm.$filters.date(_vm.start, "MM.YYYY")))])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Aktueller Monat")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.$refs.calendar.next()
            }
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Nächster Monat")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeueVeranstaltung),
      callback: function($$v) {
        _vm.showNeueVeranstaltung = $$v
      },
      expression: "showNeueVeranstaltung"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "xl"
    }
  }, [_c('v-card-title', [_c('div', [_vm._v("Neue Veranstaltung erstellen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueVeranstaltung = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.neueVeranstaltung.titel),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "titel", $$v)
      },
      expression: "neueVeranstaltung.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.vonDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Beginn",
            "readonly": ""
          },
          model: {
            value: (_vm.formatVonDatum),
            callback: function($$v) {
              _vm.formatVonDatum = $$v
            },
            expression: "formatVonDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.changeVonDatum,
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.neueVeranstaltung.vonDatum),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "vonDatum", $$v)
      },
      expression: "neueVeranstaltung.vonDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.vonZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.neueVeranstaltung.vonZeit),
            callback: function($$v) {
              _vm.$set(_vm.neueVeranstaltung, "vonZeit", $$v)
            },
            expression: "neueVeranstaltung.vonZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.neueVeranstaltung.vonZeit),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "vonZeit", $$v)
      },
      expression: "neueVeranstaltung.vonZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.bisDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Ende",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBisDatum),
            callback: function($$v) {
              _vm.formatBisDatum = $$v
            },
            expression: "formatBisDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu3),
      callback: function($$v) {
        _vm.menu3 = $$v
      },
      expression: "menu3"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu3 = false
      }
    },
    model: {
      value: (_vm.neueVeranstaltung.bisDatum),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "bisDatum", $$v)
      },
      expression: "neueVeranstaltung.bisDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.bisZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.neueVeranstaltung.bisZeit),
            callback: function($$v) {
              _vm.$set(_vm.neueVeranstaltung, "bisZeit", $$v)
            },
            expression: "neueVeranstaltung.bisZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu4),
      callback: function($$v) {
        _vm.menu4 = $$v
      },
      expression: "menu4"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.neueVeranstaltung.bisZeit),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "bisZeit", $$v)
      },
      expression: "neueVeranstaltung.bisZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.kleiderordnungen,
      "label": "Kleiderordnung"
    },
    model: {
      value: (_vm.neueVeranstaltung.kleiderordnung),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "kleiderordnung", $$v)
      },
      expression: "neueVeranstaltung.kleiderordnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Ort"
    },
    model: {
      value: (_vm.neueVeranstaltung.ort),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "ort", $$v)
      },
      expression: "neueVeranstaltung.ort"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "messages": "o/ho",
      "label": "Kategorie"
    },
    model: {
      value: (_vm.neueVeranstaltung.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "kategorie", $$v)
      },
      expression: "neueVeranstaltung.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Preis"
    },
    model: {
      value: (_vm.neueVeranstaltung.preis),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "preis", $$v)
      },
      expression: "neueVeranstaltung.preis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.anmeldungBis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Anmeldung bis",
            "readonly": ""
          },
          model: {
            value: (_vm.neueVeranstaltung.anmeldungBis),
            callback: function($$v) {
              _vm.$set(_vm.neueVeranstaltung, "anmeldungBis", $$v)
            },
            expression: "neueVeranstaltung.anmeldungBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu5),
      callback: function($$v) {
        _vm.menu5 = $$v
      },
      expression: "menu5"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu5 = false
      }
    },
    model: {
      value: (_vm.neueVeranstaltung.anmeldungBis),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "anmeldungBis", $$v)
      },
      expression: "neueVeranstaltung.anmeldungBis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.itemsKalender,
      "label": "Kalender"
    },
    model: {
      value: (_vm.neueVeranstaltung.kalender),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "kalender", $$v)
      },
      expression: "neueVeranstaltung.kalender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "hint": "Pflichtanmeldungen können nicht mehr bearbeitet werden!",
      "multiple": "",
      "outlined": "",
      "dele": "",
      "deletable-chips": "",
      "chips": "",
      "clearable": "",
      "clear-icon": "close",
      "items": _vm.gruppen,
      "label": "Pflichtanmeldungen"
    },
    model: {
      value: (_vm.neueVeranstaltung.pflichtanmeldungen),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "pflichtanmeldungen", $$v)
      },
      expression: "neueVeranstaltung.pflichtanmeldungen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "auto-grow": "",
      "rows": "5",
      "label": "Bemerkung"
    },
    model: {
      value: (_vm.neueVeranstaltung.bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "bemerkung", $$v)
      },
      expression: "neueVeranstaltung.bemerkung"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueVeranstaltung = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": "",
      "disabled": !(
        _vm.neueVeranstaltung.kalender &&
        !(_vm.neueVeranstaltung.titel == null || _vm.neueVeranstaltung.titel.trim() === '') &&
        !(_vm.formatVonDatum == null || _vm.formatVonDatum.trim() === '')
      )
    },
    on: {
      "click": function($event) {
        return _vm.saveVeranstaltung()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "rounded-0",
    attrs: {
      "flat": "",
      "height": 'calc(100vh - 195px)'
    }
  }, [_c('v-calendar', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        right: function () { return _vm.$refs.calendar.prev(); },
        left: function () { return _vm.$refs.calendar.next(); }
      }),
      expression: "{ right: () => $refs.calendar.prev(), left: () => $refs.calendar.next() }"
    }],
    ref: "calendar",
    attrs: {
      "color": "primary",
      "events": _vm.events,
      "short-weekdays": _vm.shortWeekdays,
      "short-months": _vm.shortMonths,
      "now": _vm.now,
      "event-more": false,
      "type": "month",
      "locale": "de-de",
      "weekdays": _vm.weekdays,
      "event-color": _vm.getEventColor,
      "event-text-color": "white"
    },
    on: {
      "click:event": _vm.showEvent
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _vm._v(" "), _c('dialogVeranstaltung', {
    attrs: {
      "visible": _vm.selectedOpen,
      "selectedEvent": _vm.selectedEvent
    },
    on: {
      "update:visible": function($event) {
        _vm.selectedOpen = $event
      },
      "close": function($event) {
        _vm.selectedOpen = false
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0 rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      " + _vm._s(_vm.selectedKontakte.length) + " " + _vm._s(_vm.bezMitglieder) + " bearbeiten\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-alert', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("Diese Funktion ist bisher noch nicht für verschiedene Vereine optimiert. Daher kann sie nur für Ripuaria\n            verwendet werden.")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          Sollen alle Kontakte oder nur die ausgeählten Kontakte bearbeitet werden?\n          "), _c('v-radio-group', {
    model: {
      value: (_vm.bearbeiteteFelder.alleBearbeiten),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "alleBearbeiten", $$v)
      },
      expression: "bearbeiteteFelder.alleBearbeiten"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Alle Bearbeiten",
      "value": "true",
      "on-icon": "radio_button_checked",
      "off-icon": "radio_button_unchecked"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Ausgewählte Bearbeiten",
      "value": "false",
      "on-icon": "radio_button_checked",
      "off-icon": "radio_button_unchecked"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.itemsAnrede,
      "label": "Anrede"
    },
    model: {
      value: (_vm.bearbeiteteFelder.anrede),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "anrede", $$v)
      },
      expression: "bearbeiteteFelder.anrede"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.itemsBriefanrede,
      "label": "Briefanrede"
    },
    model: {
      value: (_vm.bearbeiteteFelder.briefanrede),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "briefanrede", $$v)
      },
      expression: "bearbeiteteFelder.briefanrede"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.selectVerbindung,
      "label": "Urverbindung"
    },
    model: {
      value: (_vm.bearbeiteteFelder.urverbindung),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "urverbindung", $$v)
      },
      expression: "bearbeiteteFelder.urverbindung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    staticClass: "feld",
    attrs: {
      "hide-details": "auto",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "items": _vm.itemsZirkel,
      "label": "AH-Zirkel"
    },
    model: {
      value: (_vm.bearbeiteteFelder.zirkel),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "zirkel", $$v)
      },
      expression: "bearbeiteteFelder.zirkel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.itemsStatus,
      "label": "Status"
    },
    model: {
      value: (_vm.bearbeiteteFelder.status),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "status", $$v)
      },
      expression: "bearbeiteteFelder.status"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Aktiven-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.aktivenBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "aktivenBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.aktivenBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "CV-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.cvBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "cvBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.cvBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "AHV-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.ahvBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "ahvBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.ahvBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "HBV-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.hbvBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "hbvBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.hbvBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 pa-2"
  }, [_vm._v("\n              SEPA Berechtigungen ändern?\n              "), _c('v-spacer'), _vm._v(" "), _c('v-switch', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.bearbeiteteFelder.sepa_bearbeiten),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "sepa_bearbeiten", $$v)
      },
      expression: "bearbeiteteFelder.sepa_bearbeiten"
    }
  })], 1), _vm._v(" "), (_vm.bearbeiteteFelder.sepa_bearbeiten) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.bearbeiteteFelder.sepa_bearbeiten) ? _c('v-card-text', _vm._l((_vm.kassen), function(item, index) {
    return _c('v-switch', {
      key: index,
      attrs: {
        "outlined": "",
        "label": item.name
      },
      model: {
        value: (_vm.bearbeiteteFelder.sepa[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.bearbeiteteFelder.sepa, item.name, $$v)
        },
        expression: "bearbeiteteFelder.sepa[item.name]"
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateData()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.showUpdate),
      callback: function($$v) {
        _vm.showUpdate = $$v
      },
      expression: "showUpdate"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0 rounded-xl"
  }, [_c('v-card-title', [_vm._v(" Kontakte updaten ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-progress-linear', {
    attrs: {
      "stream": "",
      "rounded": "",
      "height": "24",
      "value": (_vm.updatedItems / _vm.allItems) * 100
    }
  }, [_vm._v("\n          " + _vm._s(_vm.updatedItems) + " von " + _vm._s(_vm.allItems) + "\n        ")]), _vm._v(" "), (_vm.error.length > 0) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpdate = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "dense": "",
      "prominent": "",
      "outlined": "",
      "text": ""
    }
  }, [_vm._v("\n        Funktioniert noch nicht. "), _c('br'), _vm._v("\n        Die Striche werden zwar schon eingetragen. Allerdings wird noch keine Rechnung generiert.\n      ")]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2 pt-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Bundesbruder",
      "items": _vm.bundesbruderselect
    },
    model: {
      value: (_vm.neueRechnung.bbrID),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "bbrID", $$v)
      },
      expression: "neueRechnung.bbrID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Rechnungstitel"
    },
    model: {
      value: (_vm.neueRechnung.rechnung_titel),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "rechnung_titel", $$v)
      },
      expression: "neueRechnung.rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "neueRechnung.datum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Rechnungsdatum",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.neueRechnung.datum),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "datum", $$v)
      },
      expression: "neueRechnung.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "neueRechnung.zahlbar_bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Zahlbar bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatZahlbar_bis),
            callback: function($$v) {
              _vm.formatZahlbar_bis = $$v
            },
            expression: "formatZahlbar_bis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu2 = false
      }
    },
    model: {
      value: (_vm.neueRechnung.zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "zahlbar_bis", $$v)
      },
      expression: "neueRechnung.zahlbar_bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "5",
      "label": "Freitext",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "auto-grow": "",
      "outlined": ""
    },
    model: {
      value: (_vm.neueRechnung.freitext),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "freitext", $$v)
      },
      expression: "neueRechnung.freitext"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "my-4 py-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "EKP-Getränke",
      "items": _vm.getrankeselect
    },
    model: {
      value: (_vm.ekp),
      callback: function($$v) {
        _vm.ekp = $$v
      },
      expression: "ekp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "name": "",
      "label": "Anzahl Getränke",
      "id": ""
    },
    model: {
      value: (_vm.ekp_anzahl),
      callback: function($$v) {
        _vm.ekp_anzahl = $$v
      },
      expression: "ekp_anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "name": "",
      "label": "Pauschal",
      "id": ""
    },
    model: {
      value: (_vm.pauschal),
      callback: function($$v) {
        _vm.pauschal = $$v
      },
      expression: "pauschal"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "name": "",
      "label": "Grund",
      "id": ""
    },
    model: {
      value: (_vm.grund),
      callback: function($$v) {
        _vm.grund = $$v
      },
      expression: "grund"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "4"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4"
  }), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 510px)",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Preis")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          return _vm.deleteStrich(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)])
  }), 0)])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v("\n          Summe: " + _vm._s(_vm._f("money")(_vm.summe)) + "\n        ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "info",
      "dense": "",
      "prominent": "",
      "outlined": "",
      "text": ""
    }
  }, [_vm._v("\n        Die Rechnung wird als Entwurf gespeichert. Und kann im Menü Rechnungen versendet werden."), _c('br'), _vm._v("\n        Getränke werden direkt in der Schankverlustrechnung berücksichtigt.\n      ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 text-right",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": "",
      "x-large": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Rechnung speichern")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "loading": _vm.loading,
            "rounded": "",
            "text": "",
            "icon": _vm.small
          },
          on: {
            "click": function($event) {
              return _vm.rechnungVersenden(_vm.rechnung)
            }
          }
        }, 'v-btn', attrs, false), on), [(_vm.icon) ? _c('v-icon', [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Rechnung per Mail senden")])])
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [(_vm.showTitle) ? _c('span', [(['Aktivitas', 'AHV-Vorstand', 'HBV-Vorstand'].includes(_vm.vorstand)) ? _c('v-card-title', [_vm._v("Chargen " + _vm._s(_vm.vorstand))]) : _c('v-card-title', [_vm._v(_vm._s(_vm.vorstand))])], 1) : _vm._e(), _vm._v(" "), (['Aktivitas', 'AHV-Vorstand', 'HBV-Vorstand', 'Ripuarentage'].includes(_vm.vorstand)) ? _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "nav": "",
      "dense": ""
    }
  }, _vm._l((_vm.chargen), function(item, key, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          (_vm.showKontakt = true) && (_vm.bbr = item)
        }
      }
    }, [_c('v-list-item-content', {
      staticClass: "pl-2"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-normal"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('v-list-item-subtitle', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.vorname) + " " + _vm._s(item.nachname))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.handy))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "text-center"
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "href": "mailto:" + item.chargenmail
      }
    }, [_c('v-icon', [_vm._v("mail")])], 1)], 1)], 1)
  }), 1) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "nav": "",
      "dense": ""
    }
  }, _vm._l((_vm.chargen), function(item, key, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pl-2"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-normal"
    }, [_vm._v(_vm._s(item.titel))]), _vm._v(" "), _vm._l((item.berechtigt), function(item2) {
      return _c('v-list-item-subtitle', {
        key: _vm.bbr,
        staticClass: "font-weight-bold"
      }, [_c('v-chip', {
        staticClass: "grey lighten-4",
        attrs: {
          "small": "",
          "label": ""
        },
        on: {
          "click": function($event) {
            return _vm.showBbr(item2)
          }
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$filters.user(item2, _vm.bbrbbr)) + "\n          ")])], 1)
    }), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.handy))])], 2)], 1)
  }), 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "text": "",
      "to": '/stammbaum/daten'
    }
  }, [_vm._v("Daten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-autocomplete', {
    attrs: {
      "single-line": "",
      "solo": "",
      "flat": "",
      "items": _vm.bbrbbr,
      "label": "Bundesbruder"
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "hidden-xs-only",
    attrs: {
      "single-line": "",
      "solo": "",
      "flat": "",
      "items": _vm.leibfamilienGrunder,
      "label": "Leibfamilien"
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.collapse = !_vm.collapse
            }
          }
        }, on), [_c('v-icon', [_vm._v(_vm._s(_vm.collapse ? 'unfold_more' : 'unfold_less'))])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Kollapse")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "offset-md": "3"
    }
  })], 1), _vm._v(" "), _c('v-sheet', {
    staticClass: "align-center",
    attrs: {
      "id": "container",
      "height": _vm.screenHeight - 169
    }
  }, [(_vm.currentbundesbruder) ? _c('stammbaum', {
    attrs: {
      "dense": true,
      "collapse": _vm.collapse,
      "bbr": _vm.currentbundesbruder,
      "currentBbr": _vm.currentbundesbruder.id
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("ToDo")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n    Nicht fertig\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.backgroundVariant === 'image') ? _c('v-img', {
    attrs: {
      "src": _vm.backgroundUrl,
      "lazy-src": "/static/background.webp",
      "cover": "",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('signinCard')], 1) : _c('span', [_c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('signinCard')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-4 pb-0 lighten-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('v-card-title', [_vm._v(_vm._s(_vm.spefuxe.length) + " Spefüxe zum WS 2024/25")])], 1), _vm._v(" "), _c('v-expansion-panel-content', [_vm._l((_vm.spefuxe), function(item, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', {
      staticClass: "px-0 pb-0 pt-1"
    }, [_c('v-list', {
      attrs: {
        "two-line": "",
        "width": "100%"
      }
    }, [_c('v-list-item', {
      staticClass: "font-weight-bold"
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$filters.user(item.id, _vm.spefuxe)))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.studiengang))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n            " + _vm._s(item.bemerkungen) + "\n          ")])], 1)
  }), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 pb-0 pt-1"
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "width": "100%"
    }
  }, [_c('v-list-item', {
    staticClass: "font-weight-bold"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Aktuelle Füxe (" + _vm._s(_vm.fuxe.length) + ")")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.fuxe), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$filters.user(item.id, _vm.fuxe)) + "\n            ")])
  }), 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "px-0",
    attrs: {
      "colspan": "13"
    }
  }, [_c('v-simple-table', [_c('tr', {
    class: _vm.ebene > 1 ? '' : 'grey lighten-' + (1 + _vm.ebene * 2)
  }, [_c('td', {
    staticClass: "pr-4 text-left flex-grow-1",
    style: ('padding-left:' + _vm.ebene * 30 + 'px;'),
    attrs: {
      "colspan": "4"
    }
  }, [_c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "cancel-text": "",
      "return-value": _vm.item.bezeichnung
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "bezeichnung", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "bezeichnung", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Bezeichnung eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.bezeichnung),
            callback: function($$v) {
              _vm.$set(_vm.item, "bezeichnung", $$v)
            },
            expression: "item.bezeichnung"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm.item.bezeichnung) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4",
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'einnahmen'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.einnahmen
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "einnahmen", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "einnahmen", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Einnahmen eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.einnahmen),
            callback: function($$v) {
              _vm.$set(_vm.item, "einnahmen", $$v)
            },
            expression: "item.einnahmen"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.einnahmen)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'ausgaben'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.ausgaben
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "ausgaben", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "ausgaben", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Ausgaben eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.ausgaben),
            callback: function($$v) {
              _vm.$set(_vm.item, "ausgaben", $$v)
            },
            expression: "item.ausgaben"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.ausgaben)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4",
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'istEinnahmen'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.istEinnahmen
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "istEinnahmen", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "istEinnahmen", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Ist Einnahmen eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.istEinnahmen),
            callback: function($$v) {
              _vm.$set(_vm.item, "istEinnahmen", $$v)
            },
            expression: "item.istEinnahmen"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.istEinnahmen)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'istAusgaben'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.istAusgaben
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "istAusgaben", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "istAusgaben", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Ist Ausgaben eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.istAusgaben),
            callback: function($$v) {
              _vm.$set(_vm.item, "istAusgaben", $$v)
            },
            expression: "item.istAusgaben"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.istAusgaben)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4",
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.istEinnahmen || _vm.item.istAusgaben) ? _c('span', [_vm._v("\n            " + _vm._s(_vm._f("money")(parseFloat(_vm.item.istEinnahmen) - parseFloat(_vm.item.einnahmen) - parseFloat(_vm.item.istAusgaben) + parseFloat(_vm.item.ausgaben))) + "\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.item.positionen.length > 0) ? _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "120px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addGroupRow(_vm.item)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (_vm.item.positionen.length === 0) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteRow(_vm.item)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.item.show = !_vm.item.show
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1) : _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "120px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addGroupRow(_vm.item)
      }
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteGroupRow(_vm.item, _vm.prop)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]), _vm._v(" "), _vm._l((_vm.item.positionen), function(pos, index) {
    return (_vm.item.show) ? _c('rowWirtschaftsplan', {
      key: index,
      attrs: {
        "parent": _vm.item,
        "ebene": _vm.ebene + 1,
        "item": pos
      }
    }) : _vm._e()
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-sheet', [_c('v-card', {
    staticClass: "text-center my-0 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    staticClass: "text-center my-0 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 mb-0 mx-0 subtitle-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-card', {
    class: _vm.dense ? 'mx-1' : 'mx-2',
    attrs: {
      "outlined": ""
    }
  }, [_c('v-list', {
    class: [_vm.currentBbr === _vm.bbr.id ? 'grey lighten-2' : '', _vm.dense ? 'pa-0' : ''],
    attrs: {
      "dense": "",
      "width": _vm.kachelbreite
    }
  }, [_c('v-list-item', {
    staticClass: "px-1"
  }, [_c('v-list-item-content', {
    staticClass: "text-truncate py-1"
  }, [_c('v-list-item-title', [(_vm.bbr.titel) ? _c('span', {
    staticClass: "pr-1"
  }, [_vm._v(_vm._s(_vm.bbr.titel))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.bbr.nachname) + ", " + _vm._s(_vm.bbr.vorname) + "\n                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                  rec. " + _vm._s(_vm.$filters.date(_vm.bbr.receptionsdatum, "DD.MM.YYYY")) + "\n                ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), (_vm.sohn.length > 0) ? _c('svg', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "id": "svg",
      "width": "100%",
      "height": _vm.svgHeight
    }
  }, [(_vm.kanten.length > 0) ? _c('g', _vm._l((_vm.kanten), function(item, index) {
    return _c('path', {
      key: index,
      attrs: {
        "d": 'M' +
          item.x1 +
          ' ' +
          item.y1 +
          ' C ' +
          item.x1 +
          ' ' +
          item.y2 +
          ' ' +
          item.x2 +
          ' ' +
          item.y1 +
          ' ' +
          item.x2 +
          ' ' +
          item.y2 +
          '',
        "stroke": "lightgrey",
        "stroke-width": "1",
        "fill": "none"
      }
    })
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sohn.length > 0) ? _c('v-card', {
    staticClass: "d-flex justify-center ma-0",
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.sohn), function(node, index) {
    return _c('stammbaumKnoten', {
      key: index,
      staticClass: "mt-n2",
      attrs: {
        "sohn": node.sohn,
        "bbr": node.bbr,
        "blatter": node.blatter,
        "ebene": _vm.ebene + 1,
        "currentBbr": _vm.currentBbr,
        "dense": _vm.dense,
        "kachelbreite": _vm.kachelbreite
      }
    })
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.saveGruppen()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.gruppen.gruppen), function(gruppe, index) {
    return _c('v-col', {
      key: index,
      staticClass: "px-1",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', [_c('v-text-field', {
      attrs: {
        "outlined": "",
        "dense": "",
        "hide-details": "",
        "label": index + 1 + '. Ordner'
      },
      model: {
        value: (gruppe.titel),
        callback: function($$v) {
          _vm.$set(gruppe, "titel", $$v)
        },
        expression: "gruppe.titel"
      }
    })], 1), _vm._v(" "), _c('v-expansion-panels', {
      staticClass: "elevation-0 pa-6 pt-0"
    }, [_c('draggable', {
      staticClass: "v-item-group theme--light v-expansion-panels",
      attrs: {
        "group": "myGroup"
      },
      on: {
        "change": function($event) {
          return _vm.saveGruppen()
        }
      },
      model: {
        value: (gruppe.gruppen),
        callback: function($$v) {
          _vm.$set(gruppe, "gruppen", $$v)
        },
        expression: "gruppe.gruppen"
      }
    }, _vm._l((gruppe.gruppen), function(item, index2) {
      return _c('v-expansion-panel', {
        key: index2
      }, [_c('v-expansion-panel-header', {
        staticClass: "py-0 pl-0",
        attrs: {
          "expand-icon": "edit",
          "disable-icon-rotate": ""
        }
      }, [_c('v-list', {
        staticClass: "pa-0",
        attrs: {
          "dense": ""
        }
      }, [_c('v-list-item', {
        staticClass: "pa-0"
      }, [_c('v-list-item-avatar', {
        staticClass: "my-0"
      }, [_c('v-icon', [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "py-0"
      }, [_c('v-list-item-title', {
        domProps: {
          "innerHTML": _vm._s(item.text)
        }
      })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
        staticClass: "pa-0 ma-0"
      }, [_c('v-card', {
        staticClass: "py-2 px-1",
        attrs: {
          "outlined": ""
        }
      }, [_c('v-text-field', {
        staticClass: "mx-1",
        attrs: {
          "outlined": "",
          "dense": "",
          "hide-details": "",
          "label": "Gruppenname"
        },
        model: {
          value: (item.text),
          callback: function($$v) {
            _vm.$set(item, "text", $$v)
          },
          expression: "item.text"
        }
      }), _vm._v(" "), _vm._l((item.bedingungen), function(bedingung, key, index) {
        return _c('v-row', {
          key: index,
          staticClass: "px-0 mx-0 py-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "px-1 mt-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-autocomplete', {
          attrs: {
            "hide-details": "",
            "dense": "",
            "outlined": "",
            "items": _vm.kontaktfelder_system,
            "label": "Kontaktfeld"
          },
          model: {
            value: (bedingung.feld),
            callback: function($$v) {
              _vm.$set(bedingung, "feld", $$v)
            },
            expression: "bedingung.feld"
          }
        }), _vm._v(" " + _vm._s(item.bedingungen.status) + "\n                            ")], 1), _vm._v(" "), _c('v-col', {
          staticClass: "px-1 mb-2 mt-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-combobox', {
          attrs: {
            "chips": "",
            "clearable": "",
            "deletable-chips": "",
            "multiple": "",
            "hide-details": "",
            "dense": "",
            "outlined": "",
            "label": "Werte",
            "append-outer-icon": "close"
          },
          on: {
            "click:append-outer": function($event) {
              return _vm.deleteBedingung(item, bedingung)
            }
          },
          model: {
            value: (bedingung.wert),
            callback: function($$v) {
              _vm.$set(bedingung, "wert", $$v)
            },
            expression: "bedingung.wert"
          }
        })], 1)], 1)
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "block": "",
          "outlined": ""
        },
        on: {
          "click": function($event) {
            return _vm.addBedingung(item)
          }
        }
      }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
        attrs: {
          "block": "",
          "outlined": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteGruppe(index, item)
          }
        }
      }, [_vm._v("Gruppe löschen"), _c('v-icon', [_vm._v("delete")])], 1)], 2)], 1)], 1)
    }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "block": "",
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.addGruppe(index)
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("Gruppe")], 1)], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('div', {
    staticClass: "headline pa-5"
  }, [_vm._v("Kontakte importieren")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }), _vm._v(" "), _c('v-icon', [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }), _vm._v(" "), _c('v-icon', [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('v-file-input', {
    attrs: {
      "accept": ".csv",
      "prepend-icon": "attach_file",
      "label": "CSV-Datei zum importieren auswählen"
    },
    model: {
      value: (_vm.csvDatei),
      callback: function($$v) {
        _vm.csvDatei = $$v
      },
      expression: "csvDatei"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importInNeueBbr
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("\n            Wähle die zu importierenden Spalten aus. Felder die keinen Wert zugewiesen bekommen werden nicht überschrieben.\n            "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Feld in Korpodesk")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Spalte in CSV-Datei")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kontaktfelder), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('td', [(_vm.kontaktfelder[item.id]) ? _c('v-autocomplete', {
      staticClass: "ma-0",
      attrs: {
        "clearable": "",
        "hide-details": "",
        "solo": "",
        "flat": "",
        "items": _vm.bbrNeuFelder
      },
      model: {
        value: (_vm.kontaktfelder[item.id].importiert),
        callback: function($$v) {
          _vm.$set(_vm.kontaktfelder[item.id], "importiert", $$v)
        },
        expression: "kontaktfelder[item.id].importiert"
      }
    }) : _vm._e()], 1)])
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.wechselHeader
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n            Doppelte Kontakte\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mr-1",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateImportStatus('Neuer Kontakt')
      }
    }
  }, [_vm._v("Alle Importieren")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mr-1",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateImportStatus('Original updaten')
      }
    }
  }, [_vm._v("Alle Updaten")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mr-1",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateImportStatus('Nicht importieren')
      }
    }
  }, [_vm._v("Alle nicht Importieren")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Hier werden alle Kontakte angezeigt, die schon in Korpodesk gefunden wurden. Entscheide für jeden einzeln ob du einen neuen Kontakt erstellen, den vorhanden updaten oder den Kontakt überspringen willst.\n            "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Importierter Kontakt (CSV-Datei)")]), _vm._v(" "), _c('th', [_vm._v("Vorhandener Kontakt (Klubdesk)")]), _vm._v(" "), _c('th', [_vm._v("Kontakt auswählen")]), _vm._v(" "), _c('th', [_vm._v("Übereinstimmung")]), _vm._v(" "), _c('th', [_vm._v("ToDo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrImportDoppelt), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.importiert.nachname) + ", " + _vm._s(item.importiert.vorname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.original.nachname) + ", " + _vm._s(item.original.vorname))]), _vm._v(" "), _c('td', [_c('v-autocomplete', {
      staticClass: "ma-0",
      attrs: {
        "hide-details": "",
        "items": _vm.bbrbbrKontaktImport
      },
      model: {
        value: (item.original),
        callback: function($$v) {
          _vm.$set(item, "original", $$v)
        },
        expression: "item.original"
      }
    })], 1), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.übereinstimmung))]), _vm._v(" "), _c('td', [_c('v-autocomplete', {
      staticClass: "ma-0",
      attrs: {
        "hide-details": "",
        "items": _vm.übernahmeItems
      },
      model: {
        value: (item.übernehmen),
        callback: function($$v) {
          _vm.$set(item, "übernehmen", $$v)
        },
        expression: "item.übernehmen"
      }
    })], 1)])
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.updateDoppelt
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Neue Kontakte (" + _vm._s(_vm.bbrImport.length) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrImport), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))])])
  }), 0)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Update Kontakte (" + _vm._s(_vm.bbrUpdate.length) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrUpdate), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.item.nachname) + ", " + _vm._s(item.item.vorname))])])
  }), 0)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nicht importierte Kontakte(" + _vm._s(_vm.bbrNichtImport.length) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrNichtImport), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.item.nachname) + ", " + _vm._s(item.item.vorname))])])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveNeueBbr
    }
  }, [_vm._v("In Kontakte Importieren")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      Kontaktdaten kontrolle senden\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-row', [_c('v-col', [_vm._v("\n          Diese Funktion sendet eine Mail an alle ausgewählten Kontakte. In dieser Mail werden die gespeicherten\n          Kontaktdaten versendet die dann von den Mitglieder kontrolliert werden können. Außerdem enthält die Mail am\n          Ende einen Link zu der Kontaktdaten-Seite um die Daten selbstständig zu ändern.\n        ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-1 pt-3 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "Gruppen",
      "items": _vm.gruppen,
      "label": "Gruppen"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.kontakteAusGruppen ? _vm.kontakteAusGruppen.length : 0))])]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Kontakte aus Gruppen werden automatisch als BCC versendet. Doppelte Kontakte werden ignoriert.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.gruppen),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "gruppen", $$v)
      },
      expression: "nachricht.gruppen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betreff*"
    },
    model: {
      value: (_vm.nachricht.betreff),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "betreff", $$v)
      },
      expression: "nachricht.betreff"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.absender,
      "label": "Absender*"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Wähle hier die Position aus, von welcher du die Mail senden willst. Sollte dein Amt nicht aufgeführt\n                  sein sind keine Maildaten hinterlegt. Wende dich dann an den Admin.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.absenderPosition),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "absenderPosition", $$v)
      },
      expression: "nachricht.absenderPosition"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Template",
      "items": _vm.templates
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Die Templates sind die Designvorlage in welche deine Mail eingebettet wird. Wenn du das Template\n                  entfernst wird ein normaler Text versendet.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.template),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "template", $$v)
      },
      expression: "nachricht.template"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "d-flex align-center justify-space-between pa-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-icon', [_vm._v("attach_file")]), _vm._v(" "), _c('v-sheet', {
    staticClass: "d-flex align-center flex-wrap align-content-center",
    attrs: {
      "color": "transparent",
      "max-width": "70%"
    }
  }, [_vm._l((_vm.uploadedFiles), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2 mb-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-sheet', {
      staticClass: "text-truncate",
      attrs: {
        "max-width": "150",
        "color": "transparent"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.uploadStatus[index] < 100) ? _c('v-progress-circular', {
      staticClass: "ml-2",
      attrs: {
        "value": _vm.uploadStatus[index],
        "size": "20",
        "rotate": "-90",
        "color": "primary",
        "width": "3"
      }
    }) : _c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check")])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.attachments), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2 mb-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-sheet', {
      staticClass: "text-truncate",
      attrs: {
        "max-width": "150",
        "color": "transparent"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('span', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleFileImport
    }
  }, [_vm._v("Anhang auswählen\n              ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Nachricht*",
      "auto-grow": "",
      "rows": "10",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.nachricht.text),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "text", $$v)
      },
      expression: "nachricht.text"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("Antworten auf diese Mail werden an " + _vm._s(_vm.replyToMail) + " gesendet.")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-2",
          class: !_vm.nachricht.template ? 'grey ' : 'primary--text ',
          attrs: {
            "rounded": "",
            "text": "",
            "read-only": !_vm.nachricht.template
          },
          on: {
            "click": function($event) {
              _vm.showVorschau = true
            }
          }
        }, on), [_vm._v("Vorschau")])]
      }
    }])
  }, [_vm._v(" "), (!_vm.nachricht.template) ? _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [(!_vm.nachricht.template) ? _c('span', [_vm._v("Es muss ein Template ausgewählt werden.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          class: !_vm.nachricht.text ||
            !_vm.nachricht.betreff ||
            !_vm.nachricht.absenderPosition ||
            (!_vm.nachricht.an.length > 0 &&
              !_vm.nachricht.an_adresse.length > 0 &&
              !_vm.nachricht.cc.length > 0 &&
              !_vm.nachricht.bcc.length > 0 &&
              !_vm.nachricht.gruppen.length > 0) ?
            'grey ' :
            'primary ',
          attrs: {
            "rounded": "",
            "disabled": !_vm.nachricht.text ||
              !_vm.nachricht.betreff ||
              !_vm.nachricht.absenderPosition ||
              (!_vm.nachricht.an.length > 0 &&
                !_vm.nachricht.an_adresse.length > 0 &&
                !_vm.nachricht.cc.length > 0 &&
                !_vm.nachricht.bcc.length > 0 &&
                !_vm.nachricht.gruppen.length > 0)
          },
          on: {
            "click": function($event) {
              return _vm.sendMail()
            }
          }
        }, on), [_c('v-icon', {
          staticClass: "mr-2"
        }, [_vm._v("send")]), _vm._v("Senden")], 1)]
      }
    }])
  }, [_vm._v(" "), (
    !_vm.nachricht.text ||
    !_vm.nachricht.betreff ||
    !_vm.nachricht.absenderPosition ||
    (!_vm.nachricht.an.length > 0 &&
      !_vm.nachricht.cc.length > 0 &&
      !_vm.nachricht.bcc.length > 0 &&
      !_vm.nachricht.gruppen.length > 0)
  ) ? _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [(!_vm.nachricht.text) ? _c('span', [_vm._v("Die Nachricht darf nicht leer sein.")]) : _vm._e(), _vm._v(" "), (!_vm.nachricht.betreff) ? _c('span', [_vm._v("Der Betreff darf nicht leer sein.")]) : _vm._e(), _vm._v(" "), (!_vm.nachricht.absenderPosition) ? _c('span', [_vm._v("Es muss ein Absender ausgewählt werden.")]) : _vm._e(), _vm._v(" "), (
    !_vm.nachricht.an.length > 0 &&
    !_vm.nachricht.an_adresse.length > 0 &&
    !_vm.nachricht.cc.length > 0 &&
    !_vm.nachricht.bcc.length > 0 &&
    !_vm.nachricht.gruppen.length > 0
  ) ? _c('span', [_vm._v("Es muss mindestens ein Empfänger in \"Gruppen\", \"An\", \"CC\" oder \"BCC\" ausgewählt sein.")]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "50%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAPISettings),
      callback: function($$v) {
        _vm.showAPISettings = $$v
      },
      expression: "showAPISettings"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        API Settings\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAPISettings = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "rows": "6",
      "auto-grow": "",
      "label": "Eingabe zur API"
    },
    model: {
      value: (_vm.apiSettings),
      callback: function($$v) {
        _vm.apiSettings = $$v
      },
      expression: "apiSettings"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAPISettings = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "80%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showVorschau),
      callback: function($$v) {
        _vm.showVorschau = $$v
      },
      expression: "showVorschau"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Vorschau\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showVorschau = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4"
  }, [_vm._v("\n            " + _vm._s(_vm.nachricht.betreff ? _vm.nachricht.betreff : "") + "\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n            Von:\n            "), (_vm.nachricht.absenderPosition) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absenderPosition))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An:\n              "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n                " + _vm._s(item2) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_adresse) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An Mailadressen:\n              "), _vm._l((_vm.nachricht.an_adresse), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc && _vm.nachricht.an_cc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              CC:\n              "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc && _vm.nachricht.an_bcc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              BCC:\n              "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachrichtVorschau)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showVorschau = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "loading": _vm.loading,
      "append-icon": _vm.checkMailValue.status === null ? '' : (_vm.checkMailValue.status ? 'check' : 'close'),
      "hint": !_vm.checkMailValue.status ? _vm.checkMailValue.message : '',
      "persistent-hint": "",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.checkMail()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Passwort",
      "hint": "Das Passwort muss mindestens 6 Zeichen lang sein.",
      "id": "password",
      "type": "password",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmPassword",
      "label": "Passwort bestätigen",
      "id": "confirmPassword",
      "type": "password",
      "rules": [_vm.comparePasswords],
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "disabled": !this.password || (this.comparePasswords === 'Passwörter stimmen nicht überein') || this.comparePasswords || (this.checkMailValue.status === false) || (this.checkMailValue.status === null),
      "loading": _vm.loadingBtn
    },
    on: {
      "click": function($event) {
        return _vm.onSignup()
      }
    }
  }, [_vm._v("\n          Registrieren\n        ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": "",
      "to": "/anmelden"
    },
    on: {
      "click": function($event) {
        return _vm.onDismissed()
      }
    }
  }, [_vm._v("\n          Anmelden\n        ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [(_vm.errorMessage.code === 'keinBbr') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Die Mailadresse gehört zu keinem Bundesbruder. Bitte kontrollier die eingegebene Adresse oder kontaktiere den Schriftführer.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.code === 'auth/email-already-in-use') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Es existiert bereits ein Account mit dieser E-Mailadresse. Bitte melde dich an oder setze dein Passwort zurück.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.code === 'auth/weak_password') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Das Passwort muss mindestens 6 Zeichen lang sein.\n        ")]) : _vm._e(), _vm._v(" "), ((_vm.errorMessage.code !== 'keinBbr') && (_vm.errorMessage.code !== 'auth/email-already-in-use') && (_vm.errorMessage.code !== 'auth/weak_password')) ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Bei der Registrierung ist ein Fehler aufgetreten. Fehlercode: " + _vm._s(_vm.errorMessage.code) + " | " + _vm._s(_vm.errorMessage.message) + "\n        ")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addDate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.date, "DD.MM.YYYY")))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": _vm.getDatepicker
    },
    model: {
      value: (_vm.datepicker),
      callback: function($$v) {
        _vm.datepicker = $$v
      },
      expression: "datepicker"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addDate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    staticClass: "pa-0 my-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-2 ma-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Bundesbruder",
      "items": _vm.bundesbruderselect
    },
    model: {
      value: (_vm.bbrID),
      callback: function($$v) {
        _vm.bbrID = $$v
      },
      expression: "bbrID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-sm-and-up pr-1 mb-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.stricheSet(-1)
      }
    }
  }, [_vm._v("-1")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "6",
      "sm": "3",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "min": "0",
      "type": "number",
      "name": "",
      "label": "Striche",
      "id": ""
    },
    model: {
      value: (_vm.striche),
      callback: function($$v) {
        _vm.striche = $$v
      },
      expression: "striche"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-sm-and-up pr-1 mb-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.stricheSet(+1)
      }
    }
  }, [_vm._v("+1")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "6",
      "sm": "2",
      "md": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "tabindex": "-1",
      "block": "",
      "height": "40px",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.showStrichpreis = true
      }
    }
  }, [_vm._v("Strichpreis"), _c('br'), _vm._v(_vm._s(_vm._f("money")(_vm.strichpreis)))])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "clearable": "",
      "label": "EKP-Getränke",
      "items": _vm.getrankeselect
    },
    on: {
      "input": function($event) {
        _vm.anzahlEkp = 1
      }
    },
    model: {
      value: (_vm.ekp),
      callback: function($$v) {
        _vm.ekp = $$v
      },
      expression: "ekp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "min": "0",
      "type": "number",
      "name": "",
      "label": "Anzahl",
      "id": ""
    },
    model: {
      value: (_vm.anzahlEkp),
      callback: function($$v) {
        _vm.anzahlEkp = $$v
      },
      expression: "anzahlEkp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "append-icon": "euro",
      "outlined": "",
      "name": "",
      "label": "Pauschal",
      "id": ""
    },
    model: {
      value: (_vm.pauschal),
      callback: function($$v) {
        _vm.pauschal = $$v
      },
      expression: "pauschal"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hint": _vm.pauschal && !_vm.grund ? 'Du musst einen Grund für den Pauschalpreis angeben.' : '',
      "hide-details": "auto",
      "outlined": "",
      "name": "",
      "label": "Grund",
      "id": ""
    },
    model: {
      value: (_vm.grund),
      callback: function($$v) {
        _vm.grund = $$v
      },
      expression: "grund"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "height": "40px",
      "disabled": !_vm.bbrID,
      "dark": !!_vm.bbrID
    },
    on: {
      "click": _vm.saveStriche
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 my-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 504px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Anzahl")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Gesamt")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.stricheHeute), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bbr))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs-only"
    }, [_vm._v(_vm._s(item.grund))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")((item.preis * item.anzahl))))]), _vm._v(" "), (item.id) ? _c('td', {
      on: {
        "click": function($event) {
          return _vm.deleteStrich(item.id)
        }
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e()])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.strichAnzahl) + " Striche -\n    " + _vm._s(_vm._f("money")(_vm.summe)) + "\n  ")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "30%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStrichpreis),
      callback: function($$v) {
        _vm.showStrichpreis = $$v
      },
      expression: "showStrichpreis"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [_c('div', [_vm._v("Strichpreis festlegen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStrichpreis = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Strichpreis",
      "dense": "",
      "outlined": "",
      "hint": "Der Strichpreis wird für spätere Eintäge gespeichert.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.strichpreisNeu),
      callback: function($$v) {
        _vm.strichpreisNeu = $$v
      },
      expression: "strichpreisNeu"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStrichpreis = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.saveStrichpreis()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "rounded": "",
      "height": "32",
      "value": _vm.counter.mitLeibvater / (_vm.counter.mitLeibvater + _vm.counter.ohneLeibvater) * 100
    }
  }, [_vm._v("\n      Aktueller Stand: " + _vm._s(_vm.counter.mitLeibvater) + " von " + _vm._s(_vm.counter.mitLeibvater + _vm.counter.ohneLeibvater) + " Leibvätern eingetragen (" + _vm._s((_vm.counter.mitLeibvater / (_vm.counter.mitLeibvater + _vm.counter.ohneLeibvater) * 100).toFixed(1)) + " %).\n      ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 170px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "semester"
  }, [_vm._v("Semester")]), _vm._v(" "), _c('th', [_vm._v("Receptionen")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.semester), function(semest) {
    return _c('tr', {
      key: semest.semesterID
    }, [_c('td', {
      staticClass: "semester",
      attrs: {
        "width": "90px"
      }
    }, [_c('span', [_vm._v(_vm._s(semest.semestername))])]), _vm._v(" "), _c('td', _vm._l((semest.receptionen), function(bbr) {
      return _c('v-btn', {
        key: bbr.ID,
        staticClass: "body-2",
        attrs: {
          "min-width": "200px",
          "text": ""
        },
        on: {
          "click": function($event) {
            return _vm.showModal(bbr.id, bbr.leibvater)
          }
        }
      }, [_c('span', {
        staticClass: "text-capitalize",
        class: bbr.leibvater ? 'green--text' : ''
      }, [_vm._v(_vm._s(bbr.name) + " ")])])
    }), 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        Leibvater auswählen\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "items": _vm.bundesbruder,
      "placeholder": "Bisher wurde kein Leibvater ausgewählt"
    },
    model: {
      value: (_vm.leibvater),
      callback: function($$v) {
        _vm.leibvater = $$v
      },
      expression: "leibvater"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("\n          Abbrechen\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          Speichern\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.$vars.error.show),
      callback: function($$v) {
        _vm.$set(_vm.$vars.error, "show", $$v)
      },
      expression: "$vars.error.show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "orange darken-3 white--text"
  }, [_vm._v("\n      Es ist ein Fehler aufgetreten!\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.$vars.error.nachricht ? _vm.$vars.error.nachricht : 'Keine Nachricht') + "\n    ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n      Weitere informationen zu dem Fehler\n    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.$vars.error.error ? _vm.$vars.error.error : 'Keine weiteren Informationen') + "\n    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      Bitte schick ein Foto des Fehlers per Whatsapp an Benedikt Breuer oder per Mail an breuerbe@gmail.com. Vielen Dank!\n      Lade danach die Seite neu.\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "orange darken-3",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.$vars.error.show = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Backup erstellen")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Alle vorhandenen Tabellen werden als csv-Dateien exportiert.\n            "), _c('br'), _vm._v("Derzeit werden folgende Tabellen exportiert:\n            "), _c('br'), _vm._v("- Kontakte\n            "), _c('br'), _vm._v("- getränke\n            "), _c('br'), _vm._v("- Rechnungen\n            "), _c('br'), _vm._v("- Getränkelieferungen\n            "), _c('br'), _vm._v("- Getränkezählungen\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.backupData()
      }
    }
  }, [_vm._v("Backup erstellen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Adress-Export")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Aus der Kontaktliste werden verschiedenen Kontaktgruppen als einzelne csv-Dateien exportiert.\n            "), _c('br'), _vm._v("- BbrBbr Deutschland\n            "), _c('br'), _vm._v("- BbrBbr Ausland\n            "), _c('br'), _vm._v("- AHAH \n            "), _c('br'), _vm._v("- Aktive\n            "), _c('br'), _vm._v("- HBV-Mitglieder\n            "), _c('br'), _vm._v("- Witwen\n            "), _c('br'), _vm._v("- Freundinnen und Damen\n            "), _c('br'), _vm._v("- Spefüxe und Gäste\n            "), _c('br'), _vm._v("- CV-Verbindungen\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.adressExportData()
      }
    }
  }, [_vm._v("Exportieren")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Import")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions')], 1)
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNewEintrag = true) && (_vm.eintragIstNeu = true) && (_vm.neuerEintrag = {
                datum: _vm.heute
              })
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neuer Eintrag")])]), _vm._v("\n    " + _vm._s(_vm.kasse) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-list-item', {
    key: _vm.item
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Aktueller Kassenstand:")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.kasse))])], 1), _vm._v(" "), _c('v-list-item-action', {
    staticClass: "title pr-2 green--text"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.summe)) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-virtual-scroll', {
    attrs: {
      "items": _vm.kassenbuch,
      "height": 590,
      "item-height": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          key: item.id,
          on: {
            "click": function($event) {
              return _vm.itembearbeiten(item)
            }
          }
        }, [_c('v-list-item-avatar', [(item.betrag < 1) ? _c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("upload")])], 1) : _c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "vertical": ""
          }
        }), _vm._v(" "), _c('v-list-item-content', {
          staticClass: "ml-4"
        }, [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.titel))])], 1), _vm._v(" "), _c('v-list-item-action', {
          staticClass: "subtitle-2 pr-2"
        }, [_vm._v("\n                " + _vm._s(_vm._f("money")(item.betrag)) + "\n              ")])], 1), _vm._v(" "), _c('v-divider')]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNewEintrag),
      callback: function($$v) {
        _vm.showNewEintrag = $$v
      },
      expression: "showNewEintrag"
    }
  }, [_c('v-card', [_c('v-card-title', [(_vm.eintragIstNeu) ? _c('div', [_vm._v("Eintrag hinzufügen")]) : _c('div', [_vm._v("Eintrag bearbeiten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Titel",
      "outlined": ""
    },
    model: {
      value: (_vm.neuerEintrag.titel),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "titel", $$v)
      },
      expression: "neuerEintrag.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-2 py-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "number": "",
      "label": "Betrag",
      "outlined": ""
    },
    model: {
      value: (_vm.neuerEintrag.betrag),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "betrag", $$v)
      },
      expression: "neuerEintrag.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-menu', {
    ref: "neuerEintrag.datum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "hide-details": "",
            "outlined": "",
            "label": "Datum"
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.neuerEintrag.datum),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "datum", $$v)
      },
      expression: "neuerEintrag.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 py-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "hide-details": "",
      "disabled": "",
      "block": "",
      "height": "56",
      "outlined": ""
    }
  }, [_vm._v("Rechnung"), _c('br'), _vm._v("hochladen"), _c('v-icon', [_vm._v("upload")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "label": "Bemerkung",
      "outlined": ""
    },
    model: {
      value: (_vm.neuerEintrag.bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "bemerkung", $$v)
      },
      expression: "neuerEintrag.bemerkung"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.eintragIstNeu) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEintrag(_vm.neuerEintrag.id)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.eintragIstNeu) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNeuEintrag()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.saveEintrag(_vm.neuerEintrag)
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n    Rechnung suchen\n    "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "label": "Rechnungsnummer eingeben",
      "items": _vm.rechnungen
    },
    on: {
      "change": function($event) {
        _vm.selectRechnung ? (_vm.showRechnung = true) : (_vm.showRechnung = false)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(data.item.item.rechnungsnummer) + " | " + _vm._s(data.item.item.kasse))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$filters.user(data.item.item.bbrID, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-list-item-action', [_vm._v("\n          " + _vm._s(_vm._f("money")(data.item.item.summe)) + "\n        ")])]
      }
    }]),
    model: {
      value: (_vm.selectRechnung),
      callback: function($$v) {
        _vm.selectRechnung = $$v
      },
      expression: "selectRechnung"
    }
  })], 1), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Spefüxe")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.bbrbbr.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Keine Spefüxe eingetragen")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_vm._l((_vm.bbrbbr), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      },
      on: {
        "click": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showKontaktNeu = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)])], 2)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogKontaktCreate', {
    attrs: {
      "visible": _vm.showKontaktNeu,
      "status": 'Spefux'
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontaktNeu = $event
      },
      "close": function($event) {
        _vm.showKontaktNeu = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Kontakte " + _vm._s(_vm.status))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.bbrbbr.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Kein " + _vm._s(_vm.status) + " eingetragen")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.bbrbbr), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      },
      on: {
        "click": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)])
  }), 0)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showCouleurstrafe = true) && (_vm.neuCouleurstrafe = true) && (_vm.couleurstrafe = _vm.couleurstrafeVorlage)
            }
          }
        }, [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("save_alt")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "10",
      "offset-lg": "1"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.couleurstrafen,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "no-data-text": "Keine Couleurstrafen eingetragen"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titel))]), _vm._v(" "), (item.strafen) ? _c('td', [_vm._v(_vm._s(item.strafen.length) + " Strafen")]) : _c('td', [_vm._v("Keine Strafen")]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.couleurstrafe = item) && (_vm.showCouleurstrafe = true) && (_vm.neuCouleurstrafe = false)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_c('v-divider'), _vm._v(" "), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _vm._v(" "), _c('div', {
          staticClass: "subtitle-2 mt-2 mb-2 mr-6"
        }, [_vm._v("Summe offene Strafen: " + _vm._s(_vm._f("money")(_vm.summe)))])], 1)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "50%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showCouleurstrafe),
      callback: function($$v) {
        _vm.showCouleurstrafe = $$v
      },
      expression: "showCouleurstrafe"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [(_vm.neuCouleurstrafe) ? _c('div', {
    staticClass: "pr-1"
  }, [_vm._v("Neue Couleurstrafe erstellen")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.couleurstrafe.titel) + " - " + _vm._s(_vm.$filters.date(_vm.couleurstrafe.datum, "DD.MM.YYYY")) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showCouleurstrafe = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.couleurstrafe.titel),
      callback: function($$v) {
        _vm.$set(_vm.couleurstrafe, "titel", $$v)
      },
      expression: "couleurstrafe.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Datum",
            "readonly": "",
            "locale": "de-de"
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.couleurstrafe.datum),
      callback: function($$v) {
        _vm.$set(_vm.couleurstrafe, "datum", $$v)
      },
      expression: "couleurstrafe.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.selectBbrbbr,
      "label": "Wer"
    },
    model: {
      value: (_vm.newEintragCouleurstrafe.wer),
      callback: function($$v) {
        _vm.$set(_vm.newEintragCouleurstrafe, "wer", $$v)
      },
      expression: "newEintragCouleurstrafe.wer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Betrag",
      "type": "number"
    },
    model: {
      value: (_vm.newEintragCouleurstrafe.betrag),
      callback: function($$v) {
        _vm.$set(_vm.newEintragCouleurstrafe, "betrag", $$v)
      },
      expression: "newEintragCouleurstrafe.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addEintragCouleurstrafe()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    staticClass: "mb-0",
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [(_vm.couleurstrafe.strafen) ? _c('tbody', _vm._l((_vm.couleurstrafe.strafen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.wer, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(item.bezahlt) ? _c('v-label', {
      attrs: {
        "chip": "",
        "color": "green"
      }
    }, [_vm._v("Bezahlt")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteEintragCouleurstrafe(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.neuCouleurstrafe) ? _c('v-btn', _vm._g({
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteCouleurstrafe = true
      }
    }
  }, _vm.on), [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.neuCouleurstrafe) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showCouleurstrafe = false
      }
    }
  }, [_vm._v("Abbrechen")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.neuCouleurstrafe) ? _c('v-btn', {
    class: _vm.couleurstrafe.strafen.length > 0 ? 'primary' : '',
    attrs: {
      "disabled": _vm.couleurstrafe.strafen.length === 0,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createCouleurstrafe()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    class: _vm.couleurstrafe.strafen.length > 0 ? 'primary' : '',
    attrs: {
      "disabled": _vm.couleurstrafe.strafen.length === 0,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateCouleurstrafe()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteCouleurstrafe,
      "title": "Eintrag löschen",
      "message": "Willst du diesen Eintrag wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteCouleurstrafe = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteCouleurstrafe()
      },
      "closeFalse": function($event) {
        _vm.showDeleteCouleurstrafe = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._l((_vm.rollenGruppe), function(rollen, key, rolleIndex) {
    return _c('v-menu', {
      key: rolleIndex,
      attrs: {
        "close-on-click": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "text": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(key)), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', _vm._l((rollen), function(rolle, rolleIndex) {
      return _c('v-list-item', {
        key: rolleIndex,
        on: {
          "click": function($event) {
            _vm.selectedSeite = rolle
          }
        }
      }, [_c('v-list-item-title', [_vm._v(_vm._s(rolle.titel))])], 1)
    }), 1)], 1)
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.addRolle()
      }
    }
  }, [_vm._v("Neue Rolle")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.deleteRolle
    }
  }, [_c('v-icon', [_vm._v("delete")]), _vm._v("Seite löschen")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 primary",
    on: {
      "click": function($event) {
        return _vm.saveRollen()
      }
    }
  }, [_vm._v("Speichern")])], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Allgemein ")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Bezeichnung"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Die Bezeichnung der Rolle. Diese wird in der Navigation angezeigt.\n                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.titel),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "titel", $$v)
      },
      expression: "selectedSeite.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "items": ['Chargen', 'AHV', 'HBV', 'Ämter', 'Kommissionen', 'Zirkel'],
      "label": "Gruppe"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Rollen können gruppiert werden. In der Rollenübersicht oder den Widgets können dann die\n                      Rollenverteilung nach Gruppe angezeigt werden.\n                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.gruppe),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "gruppe", $$v)
      },
      expression: "selectedSeite.gruppe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.bundesbruderselect,
      "outlined": "",
      "chips": "",
      "deletable-chips": "",
      "label": "Berechtigt",
      "multiple": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Die eingetragenen Personen können auf das Modul zugreifen.\n                    ")])]
      },
      proxy: true
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "small": "",
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click": data.select,
            "click:close": function($event) {
              return _vm.removeBerechtigung(data.item.value)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(data.item.text) + "\n                    ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.selectedSeite.berechtigt),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "berechtigt", $$v)
      },
      expression: "selectedSeite.berechtigt"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-avatar', {
    staticClass: "mr-4",
    attrs: {
      "size": 32,
      "color": "transparent"
    }
  }, [_c('img', {
    attrs: {
      "src": '/static/menu-icon/' + _vm.selectedSeite.bild + '.png'
    }
  })]), _vm._v(" "), _c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "items": [
        'wappen',
        'AHV',
        'HBV',
        'Senior',
        'Consenior',
        'Fuxmajor',
        'Schriftfuhrer',
        'Kassierer',
        'Bierwart' ],
      "label": "Bild"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Das Bild erscheint in der Navigation.\n                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.bild),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "bild", $$v)
      },
      expression: "selectedSeite.bild"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Mail Einstellungen ")]), _vm._v(" "), _c('v-row', {
    staticClass: "mb-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Absendername",
      "placeholder": "Verein Position"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                    Der Absendername wird in Mailprogrammen angezeigt\n                  ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.sendMail.absender),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite.sendMail, "absender", $$v)
      },
      expression: "selectedSeite.sendMail.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Mailadresse"
    },
    model: {
      value: (_vm.selectedSeite.sendMail.adresse),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite.sendMail, "adresse", $$v)
      },
      expression: "selectedSeite.sendMail.adresse"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n              An welche Mailadresse sollen Antworten gesendet werden?\n              "), _c('v-radio-group', {
    model: {
      value: (_vm.selectedSeite.sendMail.replyTo),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite.sendMail, "replyTo", $$v)
      },
      expression: "selectedSeite.sendMail.replyTo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Absender (Die private Adresse der Person, die die Mail abgeschickt hat.)",
      "value": "absender"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "From (Die Amtsmailadresse, welche oben eingetragen wurde)",
      "value": "from"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n            Module\n            "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "max-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
      }
    }])
  }, [_vm._v("\n              Die Module entsprechen den einzelnen Unterseiten und können individuell belegt und angepasst werden.\n            ")])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-expansion-panels', [_c('draggable', {
    staticClass: "v-item-group theme--light v-expansion-panels",
    model: {
      value: (_vm.selectedSeite.module),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "module", $$v)
      },
      expression: "selectedSeite.module"
    }
  }, _vm._l((_vm.selectedSeite.module), function(modul) {
    return _c('v-expansion-panel', {
      key: modul.id
    }, [_c('v-expansion-panel-header', {
      staticClass: "ma-0 pa-0"
    }, [_c('v-list', {
      staticClass: "elevation-0 pa-0"
    }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(modul.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(modul.name)
      }
    })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.removeModul(modul)
        }
      }
    }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "pa-0"
    }, [_c('v-text-field', {
      attrs: {
        "label": "Titel",
        "hint": "Dieser Titel wird in der Menüleiste angezeigt."
      },
      model: {
        value: (modul.name),
        callback: function($$v) {
          _vm.$set(modul, "name", $$v)
        },
        expression: "modul.name"
      }
    }), _vm._v(" "), _vm._l((modul.props), function(prop) {
      return _c('div', {
        key: prop
      }, [(prop.name === 'Kasse') ? _c('v-select', {
        attrs: {
          "items": _vm.kassen,
          "label": prop.name,
          "hint": prop.hint
        },
        model: {
          value: (prop.wert),
          callback: function($$v) {
            _vm.$set(prop, "wert", $$v)
          },
          expression: "prop.wert"
        }
      }) : _vm._e(), _vm._v(" "), (prop.name === 'Kalender') ? _c('v-select', {
        attrs: {
          "items": _vm.kalender,
          "label": prop.name,
          "hint": prop.hint,
          "multiple": "",
          "chips": "",
          "deletable-chips": "",
          "clearable": ""
        },
        model: {
          value: (prop.wert),
          callback: function($$v) {
            _vm.$set(prop, "wert", $$v)
          },
          expression: "prop.wert"
        }
      }) : _c('v-text-field', {
        attrs: {
          "label": prop.name,
          "hint": prop.hint
        },
        model: {
          value: (prop.wert),
          callback: function($$v) {
            _vm.$set(prop, "wert", $$v)
          },
          expression: "prop.wert"
        }
      })], 1)
    }), _vm._v(" "), (modul.id === 1) ? _c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-expansion-panels', [_c('draggable', {
      staticClass: "v-item-group theme--light v-expansion-panels",
      model: {
        value: (modul.submodule),
        callback: function($$v) {
          _vm.$set(modul, "submodule", $$v)
        },
        expression: "modul.submodule"
      }
    }, _vm._l((modul.submodule), function(modul) {
      return _c('v-expansion-panel', {
        key: modul.id
      }, [_c('v-expansion-panel-header', {
        staticClass: "ma-0 pa-0"
      }, [_c('v-list', {
        staticClass: "elevation-0 pa-0"
      }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("unfold_more")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
        domProps: {
          "innerHTML": _vm._s(modul.name)
        }
      })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
        on: {
          "click": function($event) {
            return _vm.removeSubModul(modul)
          }
        }
      }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
        staticClass: "pa-0"
      }, [_c('v-text-field', {
        attrs: {
          "label": "Titel",
          "hint": "Dieser Titel wird in der Menüleiste angezeigt."
        },
        model: {
          value: (modul.name),
          callback: function($$v) {
            _vm.$set(modul, "name", $$v)
          },
          expression: "modul.name"
        }
      }), _vm._v(" "), _vm._l((modul.props), function(prop) {
        return _c('div', {
          key: prop
        }, [(prop.name === 'Kasse' || prop.name === 'Konto') ? _c('v-select', {
          attrs: {
            "items": _vm.kassen,
            "label": prop.name,
            "hint": prop.hint
          },
          model: {
            value: (prop.wert),
            callback: function($$v) {
              _vm.$set(prop, "wert", $$v)
            },
            expression: "prop.wert"
          }
        }) : _c('v-text-field', {
          attrs: {
            "label": prop.name,
            "hint": prop.hint
          },
          model: {
            value: (prop.wert),
            callback: function($$v) {
              _vm.$set(prop, "wert", $$v)
            },
            expression: "prop.wert"
          }
        })], 1)
      })], 2)], 1)
    }), 1)], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "my-2",
      attrs: {
        "block": "",
        "outlined": ""
      },
      on: {
        "click": function($event) {
          _vm.showSubModule = true
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1) : _vm._e()], 2)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "my-2",
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.showModule = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showModule),
      callback: function($$v) {
        _vm.showModule = $$v
      },
      expression: "showModule"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "650px"
    }
  }, [_c('v-card-title', [_vm._v("\n            Module\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showModule = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "pa-0"
  }, _vm._l((_vm.module), function(modul) {
    return _c('v-col', {
      key: modul.id,
      attrs: {
        "cols": "2"
      }
    }, [_c('v-card', {
      staticClass: "subtitle-2 text-center pt-3 primary",
      attrs: {
        "outlined": "",
        "height": "120px",
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.addModul(modul)
        }
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v(_vm._s(modul.icon))])], 1), _vm._v(" "), _c('br'), _vm._v("\n                  " + _vm._s(modul.name) + "\n                ")], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSubModule),
      callback: function($$v) {
        _vm.showSubModule = $$v
      },
      expression: "showSubModule"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "650px"
    }
  }, [_c('v-card-title', [_vm._v("\n            Submodule\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSubModule = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "pa-0"
  }, _vm._l((_vm.subModule), function(modul) {
    return _c('v-col', {
      key: modul.id,
      attrs: {
        "cols": "3"
      }
    }, [_c('v-card', {
      staticClass: "subtitle-2 text-center pt-3 primary",
      attrs: {
        "outlined": "",
        "height": "120px",
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.addSubModul(modul)
        }
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v(_vm._s(modul.icon))])], 1), _vm._v(" "), _c('br'), _vm._v("\n                  " + _vm._s(modul.name) + "\n                ")], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNachricht = true) &&
              (_vm.neuNachricht = true) &&
              (_vm.nachricht = {
                an: [],
                absenderPosition: '',
                message: {},
                absender: {}
              })
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")]), _vm._v("Neue Mail")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neue Mail")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "max-width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.versand.length > 0) ? _c('v-card', _vm._g({
          staticClass: "rounded-lg",
          attrs: {
            "outlined": "",
            "width": "250px"
          }
        }, on), [_c('v-progress-linear', {
          staticClass: "caption",
          attrs: {
            "indeterminate": "",
            "height": "24"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.versand.length) + " Nachrichten im Postausgang\n              "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showVersandMenu = true
            }
          }
        }, [_c('v-icon', [_vm._v("info")])], 1)], 1)], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.alleErneutVersenden()
      }
    }
  }, [_vm._v("Alle versenden")]), _vm._v(" "), _c('span', {
    staticClass: "text-subtitle-2 px-4"
  }, [_vm._v("Alle 5 Sekunden wird eine Mail versendet. Seite nicht schließen.")])], 1), _vm._v(" "), _vm._l((_vm.versand), function(item, index) {
    return _c('v-list-item', {
      key: index
    }, [_c('v-list-item-icon', [_c('v-progress-circular', {
      attrs: {
        "indeterminate": ""
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$filters.date(item.datum.seconds * 1000, "TDD.MM.YYYY hh:mm")) + " Uhr |\n                " + _vm._s(item.id))]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.message.subject))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                An:\n                "), _vm._l((item.an), function(bbr, index2) {
      return _c('v-chip', {
        key: index2,
        attrs: {
          "label": "",
          "small": ""
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.$filters.user(bbr, _vm.bundesbruder)) + "\n                ")])
    })], 2)], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.erneutVersenden(item)
              }
            }
          }, on), [_c('v-icon', [_vm._v("forward_to_inbox")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Scheinbar gibt es ein Problem beim Versenden der Mail. E-Mail erneut senden.")])])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "mt-2"
  }, [_vm._v("\n            Der Mailversand kann unter Umständen mehrere Minuten dauern. Sollte eine Mail auch nach längerer Zeit im\n            Postausgang sein, kannst du den Versand erneut anstoßen.\n          ")])], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "ma-2 rounded-t-lg pt-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tab', [_vm._v("Eingang")]), _vm._v(" "), _c('v-tab', [_vm._v("Gesendet")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    ref: "card",
    staticClass: "pa-0"
  }, [_c('v-virtual-scroll', {
    attrs: {
      "items": _vm.nachrichten,
      "height": _vm.cardHeight,
      "item-height": "68"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.nachricht = item;
              _vm.handleResize();
            }
          }
        }, [(item.status === 'Error' && item.status) ? _c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("warning")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold"
        }, [(item.absender.position) ? _c('span', [_vm._v(_vm._s(item.absender.position))]) : _vm._e(), _vm._v(" "), (item.absender.name) ? _c('span', [_vm._v(_vm._s(item.absender.name))]) : _vm._e(), _vm._v(" "), (item.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(item.von, _vm.bundesbruder)))]) : _vm._e()]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.message.subject) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-item-action', {
          staticClass: "text-right"
        }, [_vm._v("\n                    " + _vm._s(_vm.$filters.date(item.datum.seconds * 1000, "DD.MM.YYYY"))), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$filters.date(item.datum.seconds * 1000, "hh:mm Uhr")) + "\n                  ")])], 1), _vm._v(" "), _c('v-divider')]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-xs-only pa-2",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [(_vm.nachricht.id) ? _c('v-card', {
    staticClass: "rounded-t-lg",
    attrs: {
      "outlined": "",
      "height": _vm.cardHeight + 55
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4"
  }, [_vm._v("\n            " + _vm._s(_vm.nachricht.message.subject) + "\n            "), _c('v-spacer'), _vm._v(" "), (_vm.nachricht.status) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.nachricht.status))]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-2 pl-4 subtitle-2"
  }, [(_vm.nachricht.datum) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.nachricht.datum.seconds * 1000, "DD.MM.YYYY um hh:mm Uhr")))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.duplicateMail(_vm.nachricht)
            }
          }
        }, on), [_c('v-icon', [_vm._v("content_copy")])], 1)]
      }
    }], null, false, 3877771556)
  }, [_vm._v(" "), _c('span', [_vm._v("Mail duplizieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteMail(_vm.nachricht.id)
            }
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }], null, false, 3136820611)
  }, [_vm._v(" "), _c('span', [_vm._v("Mail direkt Löschen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.erneutVersenden(_vm.nachricht)
            }
          }
        }, on), [_c('v-icon', [_vm._v("outgoing_mail")])], 1)]
      }
    }], null, false, 3337977938)
  }, [_vm._v(" "), _c('span', [_vm._v("Erneut senden"), _c('br'), _c('br'), _vm._v("Die Mail wird ohne bestätigung direkt erneut an die gleichen Empfänger\n                gesendet")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNachrichtenInfo = true;
        _vm.getAnalytics();
      }
    }
  }, [_c('v-icon', [_vm._v("insights")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "80%",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNachrichtenInfo),
      callback: function($$v) {
        _vm.showNachrichtenInfo = $$v
      },
      expression: "showNachrichtenInfo"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "xl",
      "min-height": "300px"
    }
  }, [_c('v-card-title', [_vm._v("\n                  Nachrichten-Log\n                  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "loading": _vm.loading.mailAnalytics
    },
    on: {
      "click": function($event) {
        return _vm.getAnalytics()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNachrichtenInfo = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-space-around align-center"
  }, _vm._l((_vm.stats), function(item, key, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-column align-center mx-4 my-2"
    }, [_c('v-progress-circular', {
      attrs: {
        "value": (item.value / _vm.totalRecipients) * 100,
        "color": item.color,
        "size": "80",
        "width": "8",
        "rotate": "-90",
        "indeterminate": _vm.loading.mailAnalytics
      }
    }, [_c('strong', [_vm._v(_vm._s(Math.round((item.value / _vm.totalRecipients) * 100)) + "%")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-2"
    }, [_c('strong', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.value) + " von " + _vm._s(_vm.totalRecipients))])]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "mt-1",
            attrs: {
              "icon": "",
              "x-small": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("help_outline")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-card', {
      staticClass: "transparent",
      attrs: {
        "flat": "",
        "dark": "",
        "width": "200px"
      }
    }, [_vm._v("\n                              " + _vm._s(item.hint) + "\n                            ")])], 1)], 1)
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.mailErrors(_vm.nachricht.log).length > 0) ? _c('span', [_c('v-divider'), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.nachricht.log))])], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n            Von:\n            "), (_vm.nachricht.absender) ? _c('span', [(_vm.nachricht.absender.position) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.position))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.absender.name) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.nachricht.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(_vm.nachricht.von, _vm.bundesbruder)))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An:\n              "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n                " + _vm._s(item2) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an_adresse), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc && _vm.nachricht.an_cc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              CC:\n              "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc && _vm.nachricht.an_bcc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              BCC:\n              "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.attachments && _vm.nachricht.attachments.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              Anhang:\n              "), _vm._l((_vm.nachricht.attachments), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": "",
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("attach_file")])], 1), _vm._v("\n                " + _vm._s(item.filename) + "\n              ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": _vm.sheetHeight
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachricht.message.html)
    }
  })], 1)], 1) : _c('v-card', {
    staticClass: "rounded-lg pt-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-subheader', [_vm._v("Nachricht auswählen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogMailNeu', {
    attrs: {
      "visible": _vm.showNachricht,
      "copynachricht": _vm.nachricht
    },
    on: {
      "update:visible": function($event) {
        _vm.showNachricht = $event
      },
      "close": function($event) {
        _vm.showNachricht = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "30%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', {
    staticClass: "red white--text"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeFalse()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-8 text-center subtitle-1"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeFalse()
      }
    }
  }, [_vm._v(_vm._s(_vm.abbrechen))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    attrs: {
      "rounded": "",
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeTrue()
      }
    }
  }, [_vm._v(_vm._s(_vm.weiter))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNewEintrag = true) && (_vm.neuerEintrag = {}) && (_vm.istNeu = true)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neuer Eintrag")])]), _vm._v("\n    Wirtschaftsplan\n    "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.wirtschaftsplane,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "height": _vm.sideHeight
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          on: {
            "dblclick": function($event) {
              (_vm.neuerEintrag = item) && (_vm.showNewEintrag = true) && (_vm.istNeu = false)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(item.titel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.erstelltVon, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.zuletztBearbeitet, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.print(item)
            }
          }
        }, [_c('v-icon', [_vm._v("print")])], 1)], 1)])]
      }
    }])
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNewEintrag),
      callback: function($$v) {
        _vm.showNewEintrag = $$v
      },
      expression: "showNewEintrag"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "Titel",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Wirtschaftsplan erstellen"
    },
    model: {
      value: (_vm.neuerEintrag.titel),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "titel", $$v)
      },
      expression: "neuerEintrag.titel"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.print(_vm.neuerEintrag)
      }
    }
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_vm._l((_vm.neuerEintrag.wirtschaftsplan), function(position, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', [_c('v-edit-dialog', {
      attrs: {
        "persistent": "",
        "return-value": position.titel
      },
      on: {
        "update:returnValue": function($event) {
          return _vm.$set(position, "titel", $event)
        },
        "update:return-value": function($event) {
          return _vm.$set(position, "titel", $event)
        }
      },
      scopedSlots: _vm._u([{
        key: "input",
        fn: function() {
          return [_c('v-text-field', {
            attrs: {
              "label": "Bezeichnung eintragen",
              "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
              "single-line": ""
            },
            model: {
              value: (position.titel),
              callback: function($$v) {
                _vm.$set(position, "titel", $$v)
              },
              expression: "position.titel"
            }
          })]
        },
        proxy: true
      }], null, true)
    }, [_vm._v("\n                  " + _vm._s(index + 1) + ". " + _vm._s(position.titel) + "\n                  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "disabled": position.positionen.length !== 0
      },
      on: {
        "click": function($event) {
          return _vm.deleteBlock(position)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.addRow(index)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "headers": _vm.headersTabelle,
        "items": position.positionen,
        "fixed-header": "",
        "dense": "",
        "item.key": "position.id",
        "hide-default-header": "",
        "hide-default-footer": "",
        "items-per-page": -1,
        "no-data-text": "Keine Einträge"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          return [_c('tr', [_c('th', {
            attrs: {
              "colspan": "4"
            }
          }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
            attrs: {
              "width": "2px"
            }
          }, [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Soll-Einnahmen")]), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Soll-Ausgaben")]), _vm._v(" "), _c('th', {
            attrs: {
              "width": "2px"
            }
          }, [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Ist-Einnahmen")]), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Ist-Ausgaben")]), _vm._v(" "), _c('th', {
            attrs: {
              "width": "2px"
            }
          }, [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Differenz")]), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "120px"
            }
          }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('tr', [_c('th', {
            attrs: {
              "colspan": "14"
            }
          }, [_c('v-divider')], 1)])]
        }
      }, {
        key: "item",
        fn: function(props) {
          return [(props.item.positionen.length > 0) ? _c('tr', {
            staticClass: "grey lighten-2"
          }, [_c('td', {
            staticClass: "text-left",
            attrs: {
              "colspan": "4"
            }
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.bezeichnung
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Bezeichnung eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.bezeichnung),
                    callback: function($$v) {
                      _vm.$set(props.item, "bezeichnung", $$v)
                    },
                    expression: "props.item.bezeichnung"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(props.item.bezeichnung) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "einnahmen"))) + "\n                    ")]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "ausgaben"))) + "\n                    ")]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "istEinnahmen"))) + "\n                    ")]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "istAusgaben"))) + "\n                    ")]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(props.item.istEinnahmen || props.item.istAusgaben) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("money")((props.item.istEinnahmen -
            props.item.einnahmen -
            props.item.istAusgaben +
            props.item.ausgaben))) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addGroupRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (props.item.positionen.length === 0) ? _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1) : _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                props.item.show = !props.item.show
              }
            }
          }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)]) : _c('tr', {
            staticClass: "grey lighten-2"
          }, [_c('td', {
            staticClass: "text-left",
            attrs: {
              "colspan": "4"
            }
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.bezeichnung
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Bezeichnung eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.bezeichnung),
                    callback: function($$v) {
                      _vm.$set(props.item, "bezeichnung", $$v)
                    },
                    expression: "props.item.bezeichnung"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(props.item.bezeichnung) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.einnahmen
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "einnahmen", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "einnahmen", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Einnahmen eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.einnahmen),
                    callback: function($$v) {
                      _vm.$set(props.item, "einnahmen", $$v)
                    },
                    expression: "props.item.einnahmen"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.einnahmen)) + "\n                        ")])], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.ausgaben
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "ausgaben", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "ausgaben", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Ausgaben eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.ausgaben),
                    callback: function($$v) {
                      _vm.$set(props.item, "ausgaben", $$v)
                    },
                    expression: "props.item.ausgaben"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.ausgaben)) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.istEinnahmen
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "istEinnahmen", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "istEinnahmen", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Ist Einnahmen eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.istEinnahmen),
                    callback: function($$v) {
                      _vm.$set(props.item, "istEinnahmen", $$v)
                    },
                    expression: "props.item.istEinnahmen"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.istEinnahmen)) + "\n                        ")])], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.istAusgaben
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "istAusgaben", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "istAusgaben", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Ist Ausgaben eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.istAusgaben),
                    callback: function($$v) {
                      _vm.$set(props.item, "istAusgaben", $$v)
                    },
                    expression: "props.item.istAusgaben"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.istAusgaben)) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(props.item.istAusgaben || props.item.istEinnahmen) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("money")(_vm.getDiff(props.item))) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addGroupRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("playlist_add")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]), _vm._v(" "), _vm._l((props.item.positionen), function(pos, index) {
            return (props.item.show && props.item.positionen) ? _c('rowWirtschaftsplan', {
              key: index,
              attrs: {
                "parent": props.item,
                "ebene": 1,
                "item": pos
              }
            }) : _vm._e()
          })]
        }
      }, {
        key: "body.append",
        fn: function(props) {
          return [_c('tr', {
            staticClass: "grey lighten-2"
          }, [_c('td', {
            attrs: {
              "width": "20px"
            }
          }), _vm._v(" "), _c('td', {
            attrs: {
              "width": "20px"
            }
          }), _vm._v(" "), _c('td', {
            attrs: {
              "width": "20px"
            }
          }), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v("Summe:")]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "einnahmen"))))]), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "ausgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istEinnahmen"))))]), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istAusgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")((parseFloat(_vm.getSum(position, "istEinnahmen")) -
            parseFloat(_vm.getSum(position, "einnahmen")) -
            parseFloat(_vm.getSum(position, "istAusgaben")) +
            parseFloat(_vm.getSum(position, "ausgaben"))))) + "\n                    ")]), _vm._v(" "), _c('td')])]
        }
      }], null, true)
    })], 1)], 1)
  }), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.addBlock()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Summe ")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "80px"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Soll-Einnahmen")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Soll-Ausgaben")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Ist-Einnahmen")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Ist-Ausgaben")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Differenz")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "120px"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.neuerEintrag.wirtschaftsplan), function(position, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(position.titel))]), _vm._v(" "), _c('td', [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "einnahmen"))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "ausgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istEinnahmen"))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istAusgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getDiff(position))))]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _c('tr', {
    staticClass: "grey lighten-2"
  }, [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v("Endstand:")]), _vm._v(" "), _c('td', [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[0])))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[1])))]), _vm._v(" "), _c('td', [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[2])))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[3])))]), _vm._v(" "), _c('td', [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("money")((_vm.summen[2] - _vm.summen[0] - _vm.summen[3] + _vm.summen[1]))) + "\n                    ")]), _vm._v(" "), _c('td')])], 2)])], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.istNeu) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNeuEintrag()
      }
    }
  }, [_vm._v("Erstellen")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveEintrag()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showUpload = true
            }
          }
        }, [_c('v-icon', [_vm._v("upload")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Upload Kontoauszug")])]), _vm._v("\n        Kontobuch " + _vm._s(_vm.konto) + "\n      ")], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.monat = new Date(_vm.monat.setMonth(_vm.monat.getMonth() - 1))
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.monat = new Date()
      }
    }
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.monat, "MM.YYYY")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.monat = new Date(_vm.monat.setMonth(_vm.monat.getMonth() + 1))
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.showAnleitung = true
      }
    }
  }, [_vm._v("Anleitung")])], 1)], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    ref: "rechnungenTabelle",
    attrs: {
      "dense": "",
      "height": "calc(100vh - 270px)",
      "headers": _vm.headers,
      "items": _vm.kontobuch.buchungen,
      "search": _vm.search,
      "fixed-header": "",
      "items-per-page": -1,
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "no-data-text": "Für diesen Monat wurden bisher keine Buchungen hochgeladen.",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Nummer")]), _vm._v(" "), _c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          class: item.Abgeschlossen ? 'green lighten-4' : 'trasparent',
          on: {
            "click": function($event) {
              (_vm.selectedEintrag = item) && _vm.buchungClick()
            }
          }
        }, [_c('td', {
          attrs: {
            "width": "130px"
          }
        }, [_vm._v(_vm._s(_vm.$filters.date(item.Buchungstag.seconds * 1000, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Verwendungszweck))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item["Beguenstigter/Zahlungspflichtiger"]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.Betrag)))]), _vm._v(" "), (item.Betrag > 0 && item.file) ? _c('td', [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_done")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.Betrag > 0 && !item.file) ? _c('td', [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_upload")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.Betrag < 0 && item.file) ? _c('td', [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_done")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.Betrag < 0 && !item.file) ? _c('td', [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_upload")])], 1)], 1) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "text-right pa-2 my-2",
    attrs: {
      "outlined": ""
    }
  }, [_vm._v(" Summe: " + _vm._s(_vm._f("money")(_vm.kontobuch.summe)) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.kontobuch.buchungen.length) + " Buchungen | Hochgeladen am\n        " + _vm._s(_vm.$filters.date(_vm.kontobuch.geaendertAm, "DD.MM.YYYY")))])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Verwendungszweck:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedEintrag.Verwendungszweck))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Begünstigter:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedEintrag["Beguenstigter/Zahlungspflichtiger"]))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Buchtungsdatum:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectedEintrag.Buchungstag.seconds * 1000, "DD.MM.YYYY")))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Betrag:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.selectedEintrag.Betrag)))])])])]), _vm._v(" "), _c('v-card-text', [(_vm.selectRechnung) ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnung = true
      }
    }
  }, [_c('v-icon', [_vm._v("launch")]), _vm._v(" Rechnung " + _vm._s(_vm.selectRechnung.rechnungsnummer))], 1) : _c('v-btn', {
    attrs: {
      "block": "",
      "outlined": ""
    }
  }, [_vm._v("Keine passende Rechnung gefunden")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betreff/Veranstaltung"
    },
    model: {
      value: (_vm.selectedEintrag.Betreff),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Betreff", $$v)
      },
      expression: "selectedEintrag.Betreff"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.artItems,
      "label": "Art"
    },
    model: {
      value: (_vm.selectedEintrag.Art),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Art", $$v)
      },
      expression: "selectedEintrag.Art"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1 pr-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betrag"
    },
    model: {
      value: (_vm.selectedEintrag.Betrag1),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Betrag1", $$v)
      },
      expression: "selectedEintrag.Betrag1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "2. Betrag"
    },
    model: {
      value: (_vm.selectedEintrag.Betrag2),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Betrag2", $$v)
      },
      expression: "selectedEintrag.Betrag2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1 pr-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": ['Keine Angabe', '19%', '7%'],
      "label": "MwSt-Satz"
    },
    model: {
      value: (_vm.selectedEintrag.MwSt1),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "MwSt1", $$v)
      },
      expression: "selectedEintrag.MwSt1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": ['Keine Angabe', '19%', '7%'],
      "label": "2. MwSt-Satz"
    },
    model: {
      value: (_vm.selectedEintrag.MwSt2),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "MwSt2", $$v)
      },
      expression: "selectedEintrag.MwSt2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    staticClass: "mb-2",
    attrs: {
      "rows": "3",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Bemerkung"
    },
    model: {
      value: (_vm.selectedEintrag.Bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Bemerkung", $$v)
      },
      expression: "selectedEintrag.Bemerkung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-file-input', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "label": "Rechnung hochladen"
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1)], 1)], 1), _vm._v("\n        " + _vm._s(this.selectedEintrag.file) + "\n        "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.setAbgeschlossen()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "persistent": ""
    },
    model: {
      value: (_vm.showUpload),
      callback: function($$v) {
        _vm.showUpload = $$v
      },
      expression: "showUpload"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Bank Daten hochladen ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    staticClass: "mt-2",
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n          Achtung: Monat erst hochladen wenn alle Buchungen vorhanden sind. Ein nachträgliches Hinzufügen oder\n          Entfernen von Buchungen der Liste ist nicht möglich.\n        ")]), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "accept": ".csv",
      "prepend-icon": "attach_file",
      "label": "CSV-Datei zum importieren auswählen"
    },
    model: {
      value: (_vm.csvDatei),
      callback: function($$v) {
        _vm.csvDatei = $$v
      },
      expression: "csvDatei"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpload = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadData()
      }
    }
  }, [_vm._v("hochladen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showImport),
      callback: function($$v) {
        _vm.showImport = $$v
      },
      expression: "showImport"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Daten importieren (" + _vm._s(_vm.eintrage.length) + ") ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Buchungstag")]), _vm._v(" "), _c('th', [_vm._v("Person")]), _vm._v(" "), _c('th', [_vm._v("Verwendungszweck")]), _vm._v(" "), _c('th', [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.eintrage), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.Buchungstag, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item["Beguenstigter/Zahlungspflichtiger"]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Verwendungszweck))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.Betrag)))])])
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showImport = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importData
    }
  }, [_vm._v("Importieren")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showAnleitung),
      callback: function($$v) {
        _vm.showAnleitung = $$v
      },
      expression: "showAnleitung"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Anleitung Kontobuch ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1.")]), _vm._v(" "), _c('td', [_vm._v("\n                Exportiere die Buchungsübersicht der Sparkasse als CSV-Datei. Achte auf Vollständigkeit des Monats\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2.")]), _vm._v(" "), _c('td', [_vm._v("\n                Lade die Datei in dieser Ansicht hoch. Dabei werden Buchungen die nicht in den Monat gehören\n                automatisch entfernt.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3.")]), _vm._v(" "), _c('td', [_vm._v("\n                Füge zu jeder Buchung die geforderten Informationen hinzu. Solltest du Felder nicht benennen können\n                schreibe \"Keine Ahnung\" hinein.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4.")]), _vm._v(" "), _c('td', [_vm._v("Sollte der Buchungsbetrag negativ sein musst du eine Rechnung hochladen.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5.")]), _vm._v(" "), _c('td', [_vm._v("Wenn alle Felder einer Buchung ausgefüllt sind klicke auf \"Fertig\"")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6.")]), _vm._v(" "), _c('td', [_vm._v("\n                Wenn der Monat abgeschlossen ist oder du zwischenspeichern willst klicke auf das Speichersymbol in der\n                rechten, oberen Ecke.\n              ")])])])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.showAnleitung = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.ToDo === 'false') ? _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.ToDos), function(item) {
    return (!item.status) ? _c('v-col', {
      key: item.id,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', [_c('v-card-title', [_vm._v("\n              " + _vm._s(item.aufgabe) + "\n              "), _c('v-spacer'), _vm._v(" "), _c('v-chip', [_vm._v(_vm._s(_vm.$filters.date(item.bis, "DD.MM.YYYY")))])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n              " + _vm._s(item.beschreibung) + "\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(item.wer) ? _c('v-chip', [_vm._v(_vm._s(item.wer))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.showModalEdit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), (!item.status) ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.checkToDo(item)
        }
      }
    }, [_c('v-icon', [_vm._v("check")])], 1) : _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.checkToDo(item)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "calc(100vh - 216px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Erledigte Aufgabe")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ToDos), function(item) {
    return (item.status) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.aufgabe))]), _vm._v(" "), _c('td', {
      staticClass: "pl-0 pr-2",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.checkToDo(item)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "pl-0 pr-2",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.showModalEdit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)]) : _vm._e()
  }), 0)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ToDo === 'true') ? _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("ToDo hinzufügen")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Aufgabe"
    },
    model: {
      value: (_vm.aufgabe),
      callback: function($$v) {
        _vm.aufgabe = $$v
      },
      expression: "aufgabe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-menu', {
    ref: "bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBis),
            callback: function($$v) {
              _vm.formatBis = $$v
            },
            expression: "formatBis"
          }
        }, on))]
      }
    }], null, false, 4224442442),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.bis),
      callback: function($$v) {
        _vm.bis = $$v
      },
      expression: "bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Beschreibung"
    },
    model: {
      value: (_vm.beschreibung),
      callback: function($$v) {
        _vm.beschreibung = $$v
      },
      expression: "beschreibung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Senior"
    },
    model: {
      value: (_vm.senior),
      callback: function($$v) {
        _vm.senior = $$v
      },
      expression: "senior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Consenior"
    },
    model: {
      value: (_vm.consenior),
      callback: function($$v) {
        _vm.consenior = $$v
      },
      expression: "consenior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Fuxmajor"
    },
    model: {
      value: (_vm.fuxmajor),
      callback: function($$v) {
        _vm.fuxmajor = $$v
      },
      expression: "fuxmajor"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Schriftführer"
    },
    model: {
      value: (_vm.schriftführer),
      callback: function($$v) {
        _vm.schriftführer = $$v
      },
      expression: "schriftführer"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Kassierer"
    },
    model: {
      value: (_vm.kassierer),
      callback: function($$v) {
        _vm.kassierer = $$v
      },
      expression: "kassierer"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Hauswart"
    },
    model: {
      value: (_vm.hauswart),
      callback: function($$v) {
        _vm.hauswart = $$v
      },
      expression: "hauswart"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-12",
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addToDo
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.modalEdit),
      callback: function($$v) {
        _vm.modalEdit = $$v
      },
      expression: "modalEdit"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.itemEdit.aufgabe) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.deleteToDo
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Aufgabe"
    },
    model: {
      value: (_vm.aufgabe),
      callback: function($$v) {
        _vm.aufgabe = $$v
      },
      expression: "aufgabe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-menu', {
    ref: "bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBis),
            callback: function($$v) {
              _vm.formatBis = $$v
            },
            expression: "formatBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.bis),
      callback: function($$v) {
        _vm.bis = $$v
      },
      expression: "bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Beschreibung"
    },
    model: {
      value: (_vm.beschreibung),
      callback: function($$v) {
        _vm.beschreibung = $$v
      },
      expression: "beschreibung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Senior"
    },
    model: {
      value: (_vm.senior),
      callback: function($$v) {
        _vm.senior = $$v
      },
      expression: "senior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Consenior"
    },
    model: {
      value: (_vm.consenior),
      callback: function($$v) {
        _vm.consenior = $$v
      },
      expression: "consenior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Fuxmajor"
    },
    model: {
      value: (_vm.fuxmajor),
      callback: function($$v) {
        _vm.fuxmajor = $$v
      },
      expression: "fuxmajor"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Schriftführer"
    },
    model: {
      value: (_vm.schriftführer),
      callback: function($$v) {
        _vm.schriftführer = $$v
      },
      expression: "schriftführer"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Kassierer"
    },
    model: {
      value: (_vm.kassierer),
      callback: function($$v) {
        _vm.kassierer = $$v
      },
      expression: "kassierer"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.modalEdit = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.updateToDo
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mb-12 pb-8",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": _vm.$vuetify.breakpoint.xsOnly
    }
  }, _vm._l((_vm.submodule), function(submodul) {
    return _c('v-col', {
      key: submodul.id,
      staticClass: "pa-1",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": "4",
        "xl": "3"
      }
    }, [(submodul.value === 'chargen') ? _c('chargen', {
      attrs: {
        "vorstand": submodul.props[0].wert,
        "showTitle": true
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'geburtstage') ? _c('geburtstage') : _vm._e(), _vm._v(" "), (submodul.value === 'jubilaum') ? _c('jubilaum', {
      attrs: {
        "semester": submodul.props[0].wert
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'kontakteStatus') ? _c('kontakteStatus', {
      attrs: {
        "status": submodul.props[0].wert
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'mailsListe') ? _c('mailsListe', {
      attrs: {
        "bbr": _vm.currentBbr
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'rechnungenEigene') ? _c('rechnungenEigene', {
      attrs: {
        "bbr": _vm.currentBbr
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'rechnungenStatus') ? _c('rechnungenStatus', {
      attrs: {
        "kasse": submodul.props[0].wert,
        "status": submodul.props[1].wert
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'ripuaren') ? _c('ripuaren') : _vm._e(), _vm._v(" "), (submodul.value === 'todosEigene') ? _c('todosEigene') : _vm._e(), _vm._v(" "), (submodul.value === 'veranstaltungenListe') ? _c('veranstaltungenListe', {
      attrs: {
        "anzahl": "5"
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'bundesbruderSuche') ? _c('bundesbruderSuche') : _vm._e(), _vm._v(" "), (submodul.value === 'bierranking') ? _c('bierranking') : _vm._e(), _vm._v(" "), (submodul.value === 'schankverlust') ? _c('schankverlust') : _vm._e(), _vm._v(" "), (submodul.value === 'rechnungSuche') ? _c('rechnungSuche') : _vm._e(), _vm._v(" "), (submodul.value === 'keilkandidaten') ? _c('keilkandidaten') : _vm._e()], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNeuesVerzeichnis = true) && (_vm.neu = {})
            }
          }
        }, on), [_c('v-icon', [_vm._v("dns")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neues Laufwerk")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2 pr-0 pl-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": _vm.sideHeight
    }
  }, [_c('v-treeview', {
    attrs: {
      "dense": "",
      "items": _vm.items,
      "activatable": "",
      "return-object": "",
      "hoverable": "",
      "active": _vm.tree,
      "item-key": _vm.id
    },
    on: {
      "update:active": function($event) {
        _vm.tree = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(item.name))])]
      }
    }, {
      key: "prepend",
      fn: function(ref) {
        var item = ref.item;
        var open = ref.open;

        return [(item.icon === 'folder') ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n              " + _vm._s(open ? "mdi-folder-open" : "mdi-folder") + "\n            ")]) : _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n              " + _vm._s(item.icon) + "\n            ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 px-2",
    attrs: {
      "cols": _vm.selectFile.id ? 6 : 9
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": _vm.sideHeight
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tree2) + "\n        "), _c('v-card-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.tree[0].icon))]), _vm._v("\n          " + _vm._s(_vm.tree[0].name) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNeuerOrdner = true) && (_vm.neu = {})
            }
          }
        }, on), [_c('v-icon', [_vm._v("create_new_folder")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neuer Ordner")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showUploadFiles = true) && (_vm.neu = {})
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_upload")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Dateien hochladen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.downlaodFolder(_vm.tree[0])
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Ordner herunterladen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.selectFile = _vm.tree[0]
            }
          }
        }, on), [_c('v-icon', [_vm._v("info")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Informationen")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.tree[0].id) ? _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 270px)",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "pl-1"
  }, [_vm._v("Dateiname")]), _vm._v(" "), _c('th', [_vm._v("Geändert am")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAllChildren(_vm.tree[0].id)), function(item, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          item.art === 'Datei' ? (_vm.selectFile = item) : ''
        },
        "dblclick": function($event) {
          item.art === 'Ordner' ? (_vm.tree[0] = item) : (_vm.selectFile = item)
        }
      }
    }, [_c('td', {
      staticClass: "pl-4 pr-1",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('td', {
      staticClass: "pl-1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.zuletztbearbeitet, "DD.MM.YYYYhhmm")) + " Uhr")]), _vm._v(" "), _c('th', {
      staticClass: "px-1",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      on: {
        "click": function($event) {
          item.art === 'Ordner' ? (_vm.tree[0] = item) : (_vm.selectFile = item)
        }
      }
    }, [_vm._v("Öffnen")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-title', {
      on: {
        "click": function($event) {
          (_vm.showRenameFile = true) && (_vm.selectFile = item)
        }
      }
    }, [_vm._v("Umbenennen")])], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-title', {
      on: {
        "click": function($event) {
          (_vm.showDeleteFile = true) && (_vm.deleteFileData = item)
        }
      }
    }, [_vm._v("Löschen")])], 1)], 1)], 1)], 1)])
  }), 0)]) : _c('v-card-text', [_vm._v(" Bitte wähle ein Verzeichnis aus um die Dateien anzuzeigen. ")])], 1)], 1), _vm._v(" "), (_vm.selectFile.id) ? _c('v-col', {
    staticClass: "pa-2 pl-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pb-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.selectFile = {}
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-1 justify-center"
  }, [(_vm.selectFile.type) ? _c('span', [(_vm.selectFile.type.includes('image') && _vm.selectFile.type !== 'image/svg+xml') ? _c('span', [_c('v-img', {
    attrs: {
      "src": _vm.selectFile.url500,
      "max-width": "250px",
      "max-height": "250px",
      "contain": ""
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height grey lighten-3 ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "grey"
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 1280950732)
  })], 1) : _c('span', [_c('v-icon', {
    attrs: {
      "size": "64"
    }
  }, [_vm._v(_vm._s(_vm.selectFile.icon))])], 1)]) : _c('span', [_c('v-icon', {
    attrs: {
      "size": "64"
    }
  }, [_vm._v(_vm._s(_vm.selectFile.icon))])], 1)]), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-2 pt-1"
  }, [_c('v-spacer'), _vm._v("\n          " + _vm._s(_vm.selectFile.name) + "\n          "), _c('v-spacer')], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Zuletzt geändert")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.$filters.date(_vm.selectFile.zuletztbearbeitet, "DD.MM.YYYY")) + " "), _c('br'), _vm._v(_vm._s(_vm.$filters.date(_vm.selectFile.zuletztbearbeitet, "hh:mm")) + "\n                Uhr\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Geändert von")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.$filters.user(_vm.selectFile.zuletztbearbeitetvon, _vm.bbrbbr)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Größe")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.formatSize(_vm.selectFile.size)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Downloads")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.selectFile.downloadLog.length)), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDownloadLog = true
      }
    }
  }, [_c('v-icon', [_vm._v("info")])], 1)], 1)])])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.downloadFile(_vm.selectFile)
            }
          }
        }, on), [_c('v-icon', [_vm._v("download")])], 1)]
      }
    }], null, false, 3001047841)
  }, [_vm._v(" "), _c('span', [_vm._v("Herunterladen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showRenameFile = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("edit")])], 1)]
      }
    }], null, false, 255971008)
  }, [_vm._v(" "), _c('span', [_vm._v("Umbenennen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showDeleteFile = true) && (_vm.deleteFileData = _vm.selectFile)
            }
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }], null, false, 1467067888)
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])])], 1), _vm._v(" "), (_vm.showDownloadLog) ? _c('v-card-actions', [_c('v-card', {
    attrs: {
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-0"
  }, [_vm._v("\n              Download-Log\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDownloadLog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', _vm._l((_vm.selectFile.downloadLog), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.date, "DD.M.YY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.contact, _vm.bbrbbr)))])])
  }), 0)])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "30%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeuesVerzeichnis),
      callback: function($$v) {
        _vm.showNeuesVerzeichnis = $$v
      },
      expression: "showNeuesVerzeichnis"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Neues Verzeichnis erstellen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.neu.name),
      callback: function($$v) {
        _vm.$set(_vm.neu, "name", $$v)
      },
      expression: "neu.name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesVerzeichnis = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createVerzeichnis()
      }
    }
  }, [_vm._v("Erstellen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "30%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeuerOrdner),
      callback: function($$v) {
        _vm.showNeuerOrdner = $$v
      },
      expression: "showNeuerOrdner"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Neuer Ordner erstellen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.neu.name),
      callback: function($$v) {
        _vm.$set(_vm.neu, "name", $$v)
      },
      expression: "neu.name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuerOrdner = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createOrdner()
      }
    }
  }, [_vm._v("Erstellen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "40%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showUploadFiles),
      callback: function($$v) {
        _vm.showUploadFiles = $$v
      },
      expression: "showUploadFiles"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Dateien hochladen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [(!_vm.neu.uploadStatus) ? _c('v-file-input', {
    attrs: {
      "chips": "",
      "outlined": "",
      "counter": "",
      "multiple": "",
      "show-size": "",
      "label": "Dateien zum hochladen auswählen"
    },
    model: {
      value: (_vm.neu.dateien),
      callback: function($$v) {
        _vm.$set(_vm.neu, "dateien", $$v)
      },
      expression: "neu.dateien"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.uploadValue))]), _vm._v(" "), (_vm.neu.uploadStatus) ? _c('span', _vm._l((_vm.neu.uploadStatus), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('v-progress-linear', {
      attrs: {
        "color": item === 100 ? 'green' : 'blue',
        "value": item,
        "height": "32",
        "rounded": ""
      }
    }, [_vm._v(_vm._s(_vm.neu.dateien[index].name) + " (" + _vm._s(item.toFixed(0)) + " %)")]), _vm._v(" "), (item < 100) ? _c('v-progress-linear', {
      staticClass: "mt-n1 pb-2",
      attrs: {
        "color": "blue",
        "height": "4",
        "indeterminate": "",
        "rounded": ""
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v(_vm._s(_vm.info))]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        (_vm.showUploadFiles = false) && (_vm.loading = false)
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.loading,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.uploadFiles()
      }
    }
  }, [_vm._v("Dateien hochladen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "40%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRenameFile),
      callback: function($$v) {
        _vm.showRenameFile = $$v
      },
      expression: "showRenameFile"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Datei Umbenennen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.selectFile.name),
      callback: function($$v) {
        _vm.$set(_vm.selectFile, "name", $$v)
      },
      expression: "selectFile.name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRenameFile = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.renameFile()
      }
    }
  }, [_vm._v("Umbenennen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "40%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showDeleteFile),
      callback: function($$v) {
        _vm.showDeleteFile = $$v
      },
      expression: "showDeleteFile"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', {
    staticClass: "tertiary white--text"
  }, [_vm._v("Datei löschen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_vm._v("\n        Willst du den Ordner "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.deleteFileData.name))]), _vm._v(" wirklich löschen? Alle\n        Unterordener und darin enthaltene Dateien werden unwiederuflich gelöscht. "), _c('br'), _c('br'), _vm._v("Folgende Ordner und\n        Dateien werden gelöscht:\n        "), _vm._l((_vm.deleteFileDataAll), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-1 font-weight-bold"
    }, [_vm._v(_vm._s(item.name)), (index < _vm.deleteFileDataAll.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        (_vm.showDeleteFile = false) && (_vm.loading = false)
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "tertiary",
    attrs: {
      "loading": _vm.loading,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteFiles()
      }
    }
  }, [_vm._v("Löschen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("Zurück")], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-card-title', [_vm._v("Korpodesk | Die Ripuaren-App")]), _vm._v(" "), _c('v-expansion-panels', {
    model: {
      value: (_vm.panel[0]),
      callback: function($$v) {
        _vm.$set(_vm.panel, 0, $$v)
      },
      expression: "panel[0]"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n            Liebe Bundesbrüder,\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('br'), _vm._v("am 25. September 2018 habe ich die ersten Zeilen Code für die Ripuaren-App geschrieben. Zu diesem Zeitpunkt war ich noch Bierwart und sollte das Amt an meinen Nachfolger übergeben. Da die Exceltabelle in den drei Semestern, in denen ich das Amt innehatte, immer komplexer wurde und ich vor der Übergabe an meinen Nachfolger Bedenken hatte, wollte ich diese möglichst stark vereinfachen. So war die Idee einer speziell entwickelten Web-App geboren. Anfangs sollte lediglich eine digitale Strichliste entstehen, in die die Bundesbrüder an der Theke ihre Striche setzen, und das Programm würde die komplette Auswertung bis zur Rechnungsstellung übernehmen. Der Bierwart sollte sich das aufwendige Übertragen der Striche vom Strichblock ersparen können.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("5 Jahre und 32.000 Zeilen Code später muss der Bierwart die Striche immer noch manuell übertragen, aber dafür ist aus der Strichlisten-App eine umfassende Vereinsverwaltung geworden, die viele Aufgaben der Chargen und Wärte unterstützt und vereinfacht. Es freut mich sehr, dass mittlerweile fast jeder zweite Bundesbruder bereits einen Account angelegt hat und die App sich auch in der Praxis bewährt.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Nach einem Jahr Entwicklungszeit wurden seit Oktober 2019 die Strichlisten-, Rechnungs-, Bestandsverwaltungs- und Statistikfunktionen der Ripuaren-App vom Bierwart verwendet. Im September 2020 haben einige aktive Bundesbrüder neben dem Bierwart begonnen, die App als Beta-Nutzer zu verwenden und zu testen. Im Jahr 2021 kamen die Aktivenchargen hinzu und die App wurde unter den aktiven Bundesbrüdern ausgerollt. Seitdem werden die meisten Verwaltungsaufgaben in der Aktivitas über die Ripuaren-App abgewickelt.\n            "), _c('br'), _vm._v("Beim 160. Stiftungsfest wurden die Anmeldungen zum Festwochenende über die App abgewickelt und damit der Zugriff für alle Bundesbrüder erweitert. Zum Jahreswechsel 2023/24 sollen nun auch die Verwaltungsaufgaben von AHV und HBV komplett auf die neue Vereinsverwaltung umsteigen und somit die alte Vereinsverwaltung endgültig ersetzen.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Auf der Seite rbo.korpodesk.de/anleitungen stelle ich die aktuellen 22 Module der Vereinsverwaltung vor. Außerdem findet ihr dort Videoanleitungen zur Verwendung der App sowie über den Funktionsumfang. (Ich empfehle euch, diese Seite am Computer und nicht am Handy zu öffnen.) Ich werde regelmäßig gefragt, warum man die App nicht im Appstore herunterladen kann. Streng genommen handelt es sich bei der Ripuaren-App um eine Webapplikation, also eine Webseite. In einem der Videos erkläre ich, wie ihr eine Verknüpfung auf eurem Handy erstellen könnt, damit sich die Ripuaren-App wie eine „echte“ App anfühlt.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Da ich auch weiterhin fast jede Woche an der App arbeite und sich immer wieder etwas ändert, kann es natürlich auch zu größeren Umstellungen kommen. Auf zwei davon möchte ich an dieser Stelle hinweisen:\n            "), _c('br'), _vm._v("1.\tDer Link zum Ripuarenkalender hat sich geändert. In der App unter Veranstaltungen - Abonnieren findet ihr die neuen Links. Diese könnt ihr dann in eurem Kalender hinzufügen. Eine Videoanleitung findet ihr unter rbo.korpodesk.de/anleitungen.\n            "), _c('br'), _vm._v("2.\tFür alle Bundesbrüder, die schon länger Nutzer der App sind: Der Link rbo-system.web.app funktioniert ab sofort nicht mehr. Ihr müsst euch in Zukunft unter rbo.korpodesk.de anmelden. Wenn ihr euch nicht sicher seid, welche Version ihr nutzt: Unter der alten Domain könnt ihr euch ab sofort nicht mehr anmelden.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Ich freue mich sehr, dass sich die viele Arbeit gelohnt hat und die Ripuaren-App so positiv und aktiv aufgenommen und genutzt wird. Über Feedback und neue Ideen, was in der Ripuaren-App noch hinzugefügt werden kann, freue ich mich.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Mit bundesbrüderlichen Grüßen\n            "), _c('br'), _vm._v("Benedikt Breuer RBo!\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("P.S. Ihr könnt euch am Handy und Computer unter rbo.korpodesk.de registrieren und dann die App nutzen.\n          ")])], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n            Allgemeiner Bereich\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_vm._v("\n            Der Allgemeine Bereich umfasst alle Seiten die jedem Bundesbruder zur Verfügung stehen.\n            "), _c('v-timeline', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "home"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Home")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Auf der Startseite findet sich links der News Bereich in den jeder Bundesbruder Nachrichten posten\n                    sowie Beiträge von anderen Bundesbrüder kommtentieren kann."), _c('br'), _vm._v("\n                    Rechts daneben finden sich (in der mobilen Version ist dieser Bereich weggelassen) Widgets mit\n                    den aktuellen Terminen, der Bundesbruder-Suche, Informationen zu den aktuellen Chargen sowie eine Übersicht \n                    der aktuellen Mitgliederzahlen.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "event"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Veranstaltungen")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Der Kalender fasst die Veranstaltungen unserer Ripuaria zusammen. Diese können aber durchaus\n                    umfassender sein als nur das reine Semesterprogramm. In aktuell 5 verschiedenen Kalendern finden\n                    sich die Veranstaltungen des Semster- und Ferienprogramms, der Füxe, des Sportporgramms (ja das ist\n                    etwas leer), sowie die Veranstaltungen des AHZ Bonn/Köln."), _c('br'), _vm._v("\n                    Für alle die einen digitalen Kalender führen gibt es die Möglichkeit einzelne oder alle Kalender\n                    zu abonnieren. Änderungen und zukünftige Veranstaltungen kommen dann ganz automatisch zu euch\n                    aufs Handy."), _c('br'), _c('br'), _vm._v("\n                    Zu den einzelnen Veranstaltungen findet ihr weitere Informationen bzgl. Uhrzeiten, Kleiderordnung,\n                    Kosten und Anmeldezeiträumen. Außerdem könnt ihr euch oder eure Begleitungen auch direkt anmelden\n                    und nachschauen wer noch so alles dabei ist!\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "groups"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Bundesbrüder")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Das digitale Mitgliederverzeichnis umfasst alle Kontaktdaten der Bundesbrüder.\n                    Bei vielen findet ihr auch das passende Bild aus unserer Ahnengalerie im Kneipsaal.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "receipt_long"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Rechnungen")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Die Rechnungen der Bierkasse werden schon seit 2019 über die Ripuaren-App versand. Seit 2022 hat sich\n                    die Aktivenkasse angeschlossen und ab 2024 werden auch AHV und HBV ihre Rechnungen über die App versenden.\n                    Alle eure eigenen Rechnungen inkl. dem aktuellen Zahlungsstatus findet ihr hier aufgelistet.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "person"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Kontaktdaten")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Eure Telefonnummer ändert sich oder ihr seid umgezogen? Ihr könnt auf dieser Seite genau diese Informationen\n                    ändern. In Zukunft werden auch noch weitere Funktionen und Einstellungen hinzukommen: Wollt ihr das Semesterprogramm\n                    nur noch digital haben? Reicht euch die Einladung zum Nikolauskommers auch per Mail? Welche Kassen dürfen\n                    die Rechnung per SEPA einziehen oder wollt ihr doch selber überweisen.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "diversity_3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Stammbaum")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Am Anfang unserer Aktivenzeit wählt man sich einen Leibvater. Diese Bierfamilien können ganz schön groß werden\n                    und reichen teilweise über viele Generationen. Hier könnt ihr von vielen Bundesbrüdern die Stammbäume anschauen."), _c('br'), _vm._v("\n                    Die aktuell größte Leibfamilie hat Bbr. Mannstein gegründet. Aber auch die Leibfamilie von Bbr. Erkens wächst stark\n                    und beinhaltet auch viele junge Bundesbrüder."), _c('br'), _c('br'), _vm._v("\n                    Eure Leibfamilie kann noch nicht angezeigt werden? Links oben über \"Daten\" könnt ihr die euch bekannten Leibväter bei \n                    den Bundesbrüdern nachtragen - so wird die Übersicht immer vollständiger.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "event"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Semesterrückblick"), _c('v-chip', {
    staticClass: "green ml-2",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Eine Funktion die aktuell noch nicht fertig ist, ist der Semesterrückblick. \n                    Über alle Semester hinweg sollen hier Chargen und Chargenbilder, Receptionen, Philistrierungen, \n                    Veranstaltungen und vieles mehr gesammelt werden. Die Ideen sind hier viele vorhanden - die Umsetzung dauert aber.\n                    Ein kleines digitales Archiv könnte entstehen!\n                  ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n            Chargen Module\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_vm._v("\n            Chargen und Ämter werden auf unterschiedlichste Weise durch die Ripuaren-App unterstützt. Aktuell stehen \n            22 Module sowie 15 kleine Module für die Übersichtsseite zur Verfügung die auf den 28 Seiten der Chargen und \n            Ämter verwendet werden. Die 13 Chargen und Vorsitzenden von Aktivitas, AHV und HBV, Bier-, Bilder-\n            und Internetwart (und viele mehr) sowie seit neustem auch der Zirkel Bonn/Köln finden hier was sie brauchen."), _c('br'), _c('br'), _vm._v("\n            Ich möchte auch hier einen kurzen Überblick geben.\n            "), _c('v-timeline', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "dashboard"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Übersicht")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Die Startseite jeder Seite dient als Dashboard und wird mit einem von 15 Modulen belegt. \n                    Offene Rechnungen, kommende Veranstaltungen, Auszüge von Kontaktadressen oder Jubelsemester\n                    werden hier angezeigt.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "event"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Veranstaltungen")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Neue Veranstaltungen erstellen oder die Teilnehmerlisten verwalten - all das kann zB der Consenior\n                    hier machen. Aus den einzelnen Veranstaltungen können automatisiert Teilnehmerlisten exportiert \n                    werden, damit die Anwesenheit dann vor Ort kontrolliert werden kann.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "receipt_long"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Rechnungen")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Die Rechnungserstellung ist elementar für unsere Kassierer und den Bierwart. Egal ob der Jahresbeitrag\n                    der in den Daten der Bundesbrüder hinterlegt wird oder die Abrechnung von Veranstaltungen die direkt\n                    aus den Anmeldedaten der Veranstaltungen entnommen wird - die Rechnungsstellung hat sich im Vergleich zu\n                    unserem alten System erheblich vereinfacht und geht schneller als zuvor. "), _c('br'), _vm._v("\n                    Aber auch die Mahnung von nicht gestellten Rechnungen kann hier schnell vorgenommen werden.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "group"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Kontakte")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Nicht nur die Adressen der Bundesbrüder, auch weiter Kontaktdaten müssen gepflegt werden. All das\n                    passiert in dem \"Kontakte\"-Modul. Aber nicht nur umfangreiche Anpassungsmöglichkeiten finden sich:\n                    Neu im vergleich zum alten System: Automatische Gruppen. Kontakte können anhand von eigenschaften als Mailverteiler\n                    verwendet werden und eine manuelle Zuordnung entfällt."), _c('br'), _vm._v("\n                    Aber auch hier gibt es einige Automatisierungsfunktionen: Der Export von Mitgliederverzeichnissen, Geburtstagslisten\n                    und Versandadressen in mehreren Formatvarianten wird hier vorgenommen. Auch diese Schritte haben früher lange\n                    gedauert und waren kompliziert - jetzt geht es mit wenigen Klicks.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "mail"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Mail")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Der Kontakt zu den Mitglieder ist ein wichtiger Teil einer Vereinsverwaltung. Die monatlichen Berichte\n                    der Chargen, Ankündigungen des AHVs oder Einladungen zu Veranstaltungen werden per Mail geschickt.\n                    All das kann über das Mailmodul geschehen. "), _c('br'), _vm._v("\n                    Eine Besonderheit: Es können Mailtemplates verwendet werden die auch aktuelle Informationen aus dem System\n                    beinhalten - zum Beispiel die kommenden Veranstaltungen, welche immer am Ende einer Mail angehängt werden.\n                  ")])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "sports_bar"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Bierwart")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Der Bierwart war die Ursprüngliche Inspiration für die Ripuaren-App und daher ist dieser Bereich auch besonders\n                    umfangreich. Gleich 6 (+1) Module sind extra für den Bierwart erstellt - ich werde sie hier kurz zusammenfassen:"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Strichliste: Im Thekenbetrieb werden die getrunkenen Getränke gestrichelt. Diese Striche werden hier übertragen und können dann aus dem Modul in Rechnung gestellt werden.")]), _vm._v(" "), _c('li', [_vm._v("Getränke: 55 verschiedene Getränke haben wir regelmäßig auf dem Haus und diese werden hier verwaltet. Bezeichnung, Einkaufspreis, Pfand, Einheiten - all das wird an anderer Stelle benötigt. Aber auch Statistiken zu den Getränken werden hier angezeigt: Wie viel Cola trinken wir im Monat durchschnittlich? Wie viel Cola ist normalerweise vorrätig? All das kann für einen optimalen Einkauf genutzt werden.")]), _vm._v(" "), _c('li', [_vm._v("Lieferungen: Alle 2 Wochen werden wir von Bier Schneider beliefert. Dazu kommen noch Metro-Einkäufe und Oettingerlieferungen. Die gelieferten Getränke werden in diesem Modul eingetragen und somit dem Bestand zugefügt.")]), _vm._v(" "), _c('li', [_vm._v("Zählungen: Damit wie voll der Keller aktuell ist wird mindestens einmal im Monat gezählt. Im Normalfall haben wir zwischen 1500 und 2000 Liter Getränke im Keller.")]), _vm._v(" "), _c('li', [_vm._v("Veranstaltungen: Bei größeren Veranstaltungen können über dieses Modul schnell alle Getränke abgerechnet werden.")]), _vm._v(" "), _c('li', [_vm._v("Statistik: Wann wird wie viel getrunken? Welcher Monat war besonder Umsatzstark? Wie hoch ist unser Schankverlust? Auf der Statistik-Seite werden unzählige Werte berechnet. Unteranderem aufgrund dieser Zahlen wird entschieden zu welchem Preis die Getränke an der Theke verkauft werden müssen.")]), _vm._v(" "), _c('li', [_vm._v("Persönliche Jahresstatistik: Der Jahresrückblick von Spotify ist einigen wahrscheinlich ein Begriff. Es wird nochmal auf das vergangene Jahr geschaut. Auch diese - lustige - Funktion bietet die Ripuaren-App. Am Vormittag des 24. Dezembers wird dieser wieder veröffentlicht.")])])])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "more_horiz"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Weitere Module")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Es gibt noch einige weitere kleiner Module die ich hier gesammelt vorstellen will:\n                    "), _c('ul', [_c('li', [_vm._v("Ahnengalerie: Eine Sicherung der Bilder der Ahnengalerie und gleichzeitig die Verwaltung der Profilbilder der BbrBbr - dieses Modul ist für den Bilderwart da.")]), _vm._v(" "), _c('li', [_vm._v("Kassenbuch: Die Fuxenkasse führt seine Finanzen mit einem Kassenbuch. Das Kassenbuch wird aber auch von anderen Chargen und Wärten verwendet.")]), _vm._v(" "), _c('li', [_vm._v("Kontobuch: Ein neues Modul, welches noch nicht ganz fertiggestellt ist: Kassierer und Bierwart können die Kontodaten von der Bankimportieren und das System ordnet automatisch Rechnungen aus dem System hinzu und kann diese dann als gezahl markieren. Außerdem können Belege zu Ausgaben hinzugefügt werden. Dieses Modul soll zukünftig dann auch eine Unterstützung für den Steuerberater sein.")]), _vm._v(" "), _c('li', [_vm._v("Couleurstrafen: Ein kleines Modul für den Consenior. Hier kann er die Couleurstrafen und Bierstriche eintragen. Auf diese Daten kann der Kassierer dann direkt zugreifen und diese in der nächsten Rechnungen mit einem Klick hinzufügen.")]), _vm._v(" "), _c('li', [_vm._v("Dokumente: Einige Dokumente werden immer wieder benötigt und können hier automatisiert erstellt werden. ZB die Einladungskarte zum Nikolausfest, Rundbriefe mit Briefkopf oder die Tagesordnung für Convente.")]), _vm._v(" "), _c('li', [_vm._v("Dateien: Eine Dateiablage für die wichtisten Dateien die zwischen den Vorständen ausgetauscht werden müssen.")]), _vm._v(" "), _c('li', [_vm._v("Zirkel: Das neuste Modul. Aktuell für den Zirkel Bonn/Köln geschrieben umfasst es eine Zirkelverwaltung. BbrBbr können dem Zirkel hinzugefügt oder entfernt werden, eigene Veranstaltungen können erstellt werden sowie Mails an die BbrBbr verschickt werden.")]), _vm._v(" "), _c('li', [_vm._v("Wirtschaftsplan & Todo & Lexikon: Diese drei Module wurden erstellt werden aber aktuell nicht genutzt.")])])])], 1)], 1), _vm._v(" "), _c('v-timeline-item', {
    staticClass: "white--text mb-12",
    attrs: {
      "color": _vm.primary,
      "large": "",
      "icon": "auto_awesome"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Und als nächstes?")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Die Ideen gehen nicht aus. Aber aktuell konzentriere ich mich auf die Optimierung der vorhandenen Module.\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-card-title', [_vm._v("Videoanleitungen")]), _vm._v(" "), _c('v-expansion-panels', {
    model: {
      value: (_vm.panel[1]),
      callback: function($$v) {
        _vm.$set(_vm.panel, 1, $$v)
      },
      expression: "panel[1]"
    }
  }, _vm._l((_vm.videos), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-responsive', {
      staticClass: "green",
      attrs: {
        "aspect-ratio": 16 / 9
      }
    }, [_c('iframe', {
      attrs: {
        "width": "100%",
        "height": "100%",
        "src": item.link,
        "frameborder": "0",
        "allowfullscreen": ""
      }
    })])], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "loading": _vm.loading,
      "height": _vm.result.length > 0 ? 700 : ''
    }
  }, [_c('v-card-title', [_c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("Neu")]), _vm._v("\n      " + _vm._s(_vm.rechnungen.length) + " Rechnung versenden\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "my-4"
  }, [(_vm.result.length < _vm.versendeRechnung.gesamt || _vm.versendeRechnung.gesamt === 0) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "dismissible": ""
    }
  }, [_vm._v("\n            Achtung! Diese Funktion ist noch neu und im Test. Bitte nur in Absprache mit Benedikt verwenden.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Durch diese Funktion wird für jede Rechnung")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("ein PDF generiert, welches auf dem Server gespeichert ist.")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("eine Mail an den Rechnungsempfänger geschickt.")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("die Rechnung als \"offen\" bzw \"gezahlt\" (bei SEPA) markiert.")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("eine SEPA Datei wird generiert und heruntergeladen.")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("\n            Der Versand kann mehrere Minuten dauern. "), _c('br'), _vm._v("\n            Das Fenster darf nicht geschlossen werden.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.rechnungVersenden(_vm.rechnungen)
      }
    },
    scopedSlots: _vm._u([{
      key: "loader",
      fn: function() {
        return [_c('span', {
          staticClass: "ml-2"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.timer, "mmss")))])]
      },
      proxy: true
    }], null, false, 870740261)
  }, [_vm._v("\n              Rechnungen versenden\n            ")])], 1), _vm._v(" "), (_vm.result.length !== _vm.versendeRechnung.gesamt && (_vm.result.length > 0 || _vm.loading)) ? _c('div', {
    staticClass: "mt-10"
  }, [(_vm.createPDF.gesamt > 0) ? _c('v-progress-linear', {
    staticClass: "rounded mb-4",
    attrs: {
      "value": (_vm.createPDF.erledigt / _vm.createPDF.gesamt) * 100,
      "color": "success",
      "height": "24",
      "stream": "",
      "buffer-value": "0"
    }
  }, [_vm._v("\n              Rechnungs-PDF wird generiert: " + _vm._s(_vm.createPDF.erledigt) + " von " + _vm._s(_vm.createPDF.gesamt) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "rounded",
    attrs: {
      "value": (_vm.versendeRechnung.erledigt / _vm.versendeRechnung.gesamt) * 100,
      "color": "success",
      "height": "24",
      "stream": "",
      "buffer-value": "0"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.versendeRechnung.erledigt) + " von " + _vm._s(_vm.versendeRechnung.gesamt) + " gesendet\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Diese Rechnungen werden gesendet:")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "400px"
    }
  }, [_c('tbody', _vm._l((_vm.rechnungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.rechnung_art))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))])])
  }), 0)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.result.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-chip', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("Dauer: " + _vm._s(_vm.$filters.date(_vm.timer, "mmss")))])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "value": (_vm.result.filter(function (item) { return !item.error; }).length / _vm.versendeRechnung.gesamt) * 100,
      "color": "success",
      "size": "64",
      "width": "8"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "success",
      "size": "36"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('strong', {
    staticClass: "ml-4 success--text"
  }, [_vm._v(_vm._s(_vm.result.filter(function (item) { return !item.error; }).length) + " Rechnungen wurden erfolgreich gesendet.")])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "d-flex justify-center py-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogFilter = false
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("Anzeigen")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "value": (_vm.result.filter(function (item) { return item.error; }).length / _vm.versendeRechnung.gesamt) * 100,
      "color": "error",
      "size": "64",
      "width": "8"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "error",
      "size": "36"
    }
  }, [_vm._v("error")])], 1), _vm._v(" "), _c('strong', {
    staticClass: "ml-4 error--text"
  }, [_vm._v(_vm._s(_vm.result.filter(function (item) { return item.error; }).length) + " Rechnungen konnten nicht gesendet werden.")])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "d-flex justify-center py-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogFilter = true
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("Anzeigen")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.result.filter(function (item) { return item.error === _vm.showLogFilter; }),
      "expanded": _vm.expanded,
      "single-expand": "",
      "dense": "",
      "items-per-page": -1,
      "height": "370",
      "item-key": "rechnung",
      "show-expand": "",
      "hide-default-footer": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.error",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": item.error ? 'error' : 'success'
          }
        }, [_vm._v("\n                    " + _vm._s(item.error ? "warning" : "check") + "\n                  ")])], 1)]
      }
    }, {
      key: "item.rechnung",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "d-flex align-center justify-space-between",
          attrs: {
            "width": "100%"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.versendeRechnung.rechnungen.find(function (a) { return a.id === item.rechnung; }).rechnungsnummer) + "\n                  "), (item.error) ? _c('span', [_c('v-btn', {
          attrs: {
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.erneutVersuchen(item)
            }
          }
        }, [_vm._v("Erneut senden")])], 1) : _vm._e()])]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [_c('td', {
          staticClass: "py-2",
          attrs: {
            "colspan": 2
          }
        }, [_c('v-list', {
          attrs: {
            "dense": ""
          }
        }, _vm._l((item.log), function(log, j) {
          return _c('v-list-item', {
            key: j
          }, [_c('v-list-item-icon', [_c('v-icon', {
            attrs: {
              "color": log.error ? 'error' : 'success'
            }
          }, [_vm._v("\n                          " + _vm._s(log.error ? "warning" : "check") + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(log.message))]), _vm._v(" "), (log.error) ? _c('v-list-item-subtitle', [_vm._v("Funktion: " + _vm._s(log.function))]) : _vm._e(), _vm._v(" "), (log.error) ? _c('v-list-item-subtitle', [_vm._v("data: " + _vm._s(log.data))]) : _vm._e()], 1)], 1)
        }), 1)], 1)]
      }
    }], null, false, 3578828308)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', [(_vm.currentBbr === _vm.bbr.id) ? _c('rect', {
    staticStyle: {
      "fill": "lightgrey",
      "stroke-width": "2",
      "stroke": "grey"
    },
    attrs: {
      "x": _vm.xStart,
      "y": _vm.y,
      "rx": "4",
      "width": "200",
      "height": "44"
    }
  }) : _c('rect', {
    staticStyle: {
      "fill": "white",
      "stroke-width": "2",
      "stroke": "grey"
    },
    attrs: {
      "x": _vm.xStart,
      "y": _vm.y,
      "rx": "4",
      "width": "200",
      "height": "44"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "text-anchor": "middle"
    }
  }, [_c('tspan', {
    staticClass: "subtitle-2",
    attrs: {
      "x": _vm.xStart + 100,
      "y": _vm.y + 20
    }
  }, [(_vm.bbr.titel) ? _c('span', {
    staticClass: "pr-1"
  }, [_vm._v(_vm._s(_vm.bbr.titel))]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.bbr.nachname) + ", " + _vm._s(_vm.bbr.vorname) + "\n    ")]), _vm._v(" "), _c('tspan', {
    staticClass: "caption",
    attrs: {
      "x": _vm.xStart + 100,
      "y": _vm.y + 36
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$filters.date(_vm.bbr.receptionsdatum, "DD.MM.YYYY")) + "\n    ")])]), _vm._v(" "), (_vm.ebene > 0) ? _c('path', {
    attrs: {
      "d": 'M' +
        (_vm.xVater + 100) +
        ' ' +
        (_vm.yVater + 44) +
        ' C ' +
        (_vm.xVater + 100) +
        ' ' +
        (_vm.yVater + 65) +
        ' ' +
        (_vm.xStart + 100) +
        ' ' +
        (_vm.yVater + 45) +
        ' ' +
        (_vm.xStart + 100) +
        ' ' +
        (_vm.yVater + 65) +
        'L' +
        (_vm.xStart + 100) +
        ' ' +
        _vm.y,
      "stroke": "grey",
      "stroke-width": "2",
      "fill": "none"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.sohn), function(node, index) {
    return _c('stammbaumKnoten', {
      key: index,
      staticClass: "mt-n2",
      attrs: {
        "sohn": node.sohn,
        "bbr": node.bbr,
        "getArrayDepth": node.getArrayDepth,
        "blatter": node.blatter,
        "ebene": _vm.ebene + 1,
        "currentBbr": _vm.currentBbr,
        "dense": _vm.dense,
        "kachelbreite": _vm.kachelbreite,
        "startJahr": _vm.startJahr,
        "xStart": _vm.calculateXStart(index, node),
        "xMin": _vm.calculateXMin(index, node),
        "xWidth": (_vm.xWidth / _vm.blatter) * node.blatter,
        "xVater": _vm.xStart,
        "yVater": _vm.y,
        "collapse": _vm.collapse
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Anzahl " + _vm._s(_vm.bezMitglieder))]), _vm._v(" "), (_vm.kontaktGruppen.length < 5) ? _c('v-row', {
    staticClass: "text-center"
  }, [_vm._l((_vm.kontaktGruppen), function(item, index) {
    return (index > 0) ? _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": _vm.mdsize
      }
    }, [_c('h1', [_vm._v(_vm._s(item.count))]), _vm._v("\n        " + _vm._s(item.value) + "\n      ")]) : _vm._e()
  }), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.kontaktGruppen[0].count))]), _vm._v(_vm._s(_vm.bezMitglieder))])], 2) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', [_vm._l((_vm.kontaktGruppen), function(item, index) {
    return (index > 0) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.count))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.kontaktGruppen[0].count))]), _vm._v(_vm._s(_vm.bezMitglieder) + "\n              ")])])], 2)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [(!_vm.short) ? _c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_birthday_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v("Geburtstagsliste")])], 1) : _c('v-card-title', [_vm._v("Geburtstagsliste")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.geburtstage.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Keine anstehenden Geburtstage")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mb-0 rounded-lg",
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('tbody', _vm._l((_vm.geburtstage), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.bbr = item.bbr;
          _vm.showKontakt = true;
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.geburtsdatum, "DD.MM.")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)) + " (" + _vm._s(item.alter) + " Jahre)")])])
  }), 0)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showLieferung = true) && (_vm.neuLieferung = true) && (_vm.lieferung = _vm.neueLieferung)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("save_alt")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "center-active": "",
      "centered": ""
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.bierlieferungen), function(bierlieferung, jahr) {
    return _c('v-tab', {
      key: jahr
    }, [_vm._v(_vm._s(jahr))])
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.bierlieferungen), function(bierlieferung, jahr) {
    return _c('v-tab-item', {
      key: jahr
    }, [_c('v-data-table', {
      attrs: {
        "height": "calc(100vh - 240px)",
        "dense": "",
        "headers": _vm.headers,
        "items": bierlieferung,
        "search": _vm.search,
        "fixed-header": "",
        "items-per-page": -1,
        "hide-default-header": _vm.hideHeader,
        "no-data-text": "Keine Lieferungen vorhanden",
        "hide-default-footer": ""
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            staticClass: "hidden-sm-and-up"
          }, [_c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Lieferant")]), _vm._v(" "), _c('th', [_vm._v("Rechnung")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]
        }
      }, {
        key: "item",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            on: {
              "dblclick": function($event) {
                (_vm.lieferung = item) && (_vm.showLieferung = true) && (_vm.neuLieferung = false)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.lieferant))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(_vm._f("money")(item.gesamt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), (item.download) ? _c('td', {
            staticClass: "pl-0 pr-0",
            attrs: {
              "width": "20px"
            },
            on: {
              "click": function($event) {
                return _vm.downloadFile(item.id)
              }
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("save_alt")])], 1)], 1) : _c('td', {
            staticClass: "pl-0 pr-0 red lighten-3",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            staticClass: "red--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.showDialogUploadFile(item)
              }
            }
          }, [_c('v-icon', [_vm._v("cloud_upload")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "pl-0 pr-2",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                (_vm.lieferung = item) && (_vm.showLieferung = true) && (_vm.neuLieferung = false)
              }
            }
          }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialogUploadFile),
      callback: function($$v) {
        _vm.dialogUploadFile = $$v
      },
      expression: "dialogUploadFile"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Rechnung hochladen ")]), _vm._v(" "), _c('v-card-text', [_c('v-file-input', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Datei auswählen"
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogUploadFile = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v(" Hochladen ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showLieferung),
      callback: function($$v) {
        _vm.showLieferung = $$v
      },
      expression: "showLieferung"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "primary white--text"
  }, [(_vm.neuLieferung) ? _c('div', [_vm._v("Neue Lieferung erstellen")]) : _c('div', [_vm._v("Lieferung " + _vm._s(_vm.lieferung.rechnungsnummer))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showLieferung = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.lieferung.datum, "DD.MM.YYYY")))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.lieferung.datum),
      callback: function($$v) {
        _vm.$set(_vm.lieferung, "datum", $$v)
      },
      expression: "lieferung.datum"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2",
      "offset-md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summe)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Pfand")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summePfand)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("MwSt.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summeMwst)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Gesamt")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summeGesamt)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2",
      "offset-md": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "items": _vm.handler,
      "hide-details": "",
      "dense": "",
      "label": "Lieferant"
    },
    model: {
      value: (_vm.lieferung.lieferant),
      callback: function($$v) {
        _vm.$set(_vm.lieferung, "lieferant", $$v)
      },
      expression: "lieferung.lieferant"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "label": "Rechnungsnummer"
    },
    model: {
      value: (_vm.lieferung.rechnungsnummer),
      callback: function($$v) {
        _vm.$set(_vm.lieferung, "rechnungsnummer", $$v)
      },
      expression: "lieferung.rechnungsnummer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "label": "Zahlungsdatum"
    },
    model: {
      value: (_vm.lieferung.zahlungsdatum),
      callback: function($$v) {
        _vm.$set(_vm.lieferung, "zahlungsdatum", $$v)
      },
      expression: "lieferung.zahlungsdatum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Rabatt"
    },
    model: {
      value: (_vm.lieferung.rabatt),
      callback: function($$v) {
        _vm.$set(_vm.lieferung, "rabatt", $$v)
      },
      expression: "lieferung.rabatt"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Getränke")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Getränk",
      "items": _vm.getranke
    },
    model: {
      value: (_vm.getrank),
      callback: function($$v) {
        _vm.getrank = $$v
      },
      expression: "getrank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-outer-icon": "plus_one",
      "prepend-icon": "exposure_neg_1",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "type": "number",
      "min": "0",
      "value": _vm.anzahlGetrank,
      "label": "Anzahl"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.anzahlGetrank++
      },
      "click:prepend": function($event) {
        _vm.anzahlGetrank > 0 ? _vm.anzahlGetrank-- : ''
      }
    },
    model: {
      value: (_vm.anzahlGetrank),
      callback: function($$v) {
        _vm.anzahlGetrank = $$v
      },
      expression: "anzahlGetrank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "icon": "",
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.addGetrank
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 460px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Netto")]), _vm._v(" "), _c('th', [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lieferung.positionen), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.netto)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.delGetrank(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Pfand zurück")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Getränk",
      "items": _vm.getranke
    },
    model: {
      value: (_vm.pfand),
      callback: function($$v) {
        _vm.pfand = $$v
      },
      expression: "pfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-outer-icon": "plus_one",
      "prepend-icon": "exposure_neg_1",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "type": "number",
      "min": "0",
      "value": _vm.anzahlPfand,
      "label": "Anzahl"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.anzahlPfand++
      },
      "click:prepend": function($event) {
        _vm.anzahlPfand > 0 ? _vm.anzahlPfand-- : ''
      }
    },
    model: {
      value: (_vm.anzahlPfand),
      callback: function($$v) {
        _vm.anzahlPfand = $$v
      },
      expression: "anzahlPfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "icon": "",
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.addPfand
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 460px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Pfand")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lieferung.positionenPfand), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.pfand)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.delPfand(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.neuLieferung) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteLieferung = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showLieferung = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.neuLieferung) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveLieferung()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateLieferung()
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteLieferung,
      "title": "Lieferung löschen",
      "message": "Willst du diese Lieferung wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteLieferung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteLieferung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteLieferung = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showSchankverlustData = !_vm.showSchankverlustData
            }
          }
        }, on), [_vm._v("%")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Schankverlusttabelle anzeigen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showNurBbrBbr = !_vm.showNurBbrBbr
            }
          }
        }, on), [(_vm.showNurBbrBbr) ? _c('v-icon', [_vm._v("group")]) : _c('v-icon', [_vm._v("groups")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Filter: Nur BbrBbr")])]), _vm._v(" "), (_vm.currentBbr === 'PBChUyAy7HWowQR4HlP3') ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showDebug = !_vm.showDebug
            }
          }
        }, on), [_c('v-icon', [_vm._v("bug_report")])], 1)]
      }
    }], null, false, 2864840511)
  }, [_vm._v(" "), _c('span', [_vm._v("Debug Dialog anzeigen")])]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-tabs', {
    attrs: {
      "centered": "",
      "center-active": ""
    },
    model: {
      value: (_vm.jahrSelect),
      callback: function($$v) {
        _vm.jahrSelect = $$v
      },
      expression: "jahrSelect"
    }
  }, _vm._l((_vm.jahre), function(jahr, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._v("\n            " + _vm._s(jahr) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addMonat(false)
            }
          }
        }, on), [_c('v-icon', [_vm._v("refresh")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Monat berechnen")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.monatSelect),
      callback: function($$v) {
        _vm.monatSelect = $$v
      },
      expression: "monatSelect"
    }
  }, [_vm._l((_vm.monate), function(monat, index) {
    return _c('v-tab', {
      key: index,
      attrs: {
        "disabled": _vm.daten.find(function (datum) { return datum === _vm.jahre[_vm.jahrSelect] + '-' + monat + '-01'; }) === undefined
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + monat, "MMM")) + "\n      ")])
  }), _vm._v(" "), _c('v-tab', [_vm._v(" Jahr ")])], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.statistik !== null) ? _c('v-row', {
    staticClass: "mt-4 ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.showSchankverlustData) ? _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "first",
      "cols": "12",
      "xs": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSchankverlustData = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Zeitraum")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Oettingerkisten")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Schankverlust")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Striche Theorie")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Striche Praxis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Couleurstriche")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber lighten-2"
  }, [_vm._v("Kosten Oettinger"), _c('br'), _vm._v("und Couleurbier")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber lighten-2"
  }, [_vm._v("Fehlbetrag "), _c('br'), _vm._v("Schankverlust")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber lighten-2"
  }, [_vm._v("Fehlbetrag "), _c('br'), _vm._v("Schankverlust (-10%)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber"
  }, [_vm._v("Summe")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + _vm.monate[_vm.monatSelect], "MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.oettingerKisten))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.schankverlust) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.gesamtStricheTheorie))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.gesamtStrichePraxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.couleurstricheAnzahl))]), _vm._v(" "), _c('td', {
    staticClass: "amber lighten-2"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")((parseFloat(_vm.statistik.oettingerKistenPreis) + parseFloat(_vm.statistik.couleurstrichePreis)))) + "\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "amber lighten-2"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "amber lighten-2"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie -
      _vm.statistik.gesamtStricheTheorie * 0.1 -
      _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "amber"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")((parseFloat(_vm.statistik.oettingerKistenPreis) +
    parseFloat(_vm.statistik.couleurstrichePreis) +
    (_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n              ")])])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order-xs": "",
      "cols": "12",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Bester Tag"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.date(_vm.statistik.stricheProTagBest[0], "DD.MM.YYYY"))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.stricheProTagBest[1]) + " Striche"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("BbrBbr an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.stricheProBbrCount)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Couleurstriche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.couleurstricheAnzahl)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Striche (ohne EKP)"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.stricheBbrAnzahl)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "absolute": "",
      "icon": "",
      "right": "",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": function($event) {
        return _vm.showVermogen()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 overline justify-center"
  }, [_vm._v("Vermögen")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.$sumArray(_vm.statistik.gesamtvermogen))) + "\n        ")]), _vm._v(" "), (_vm.jahrStatistik.vermogen) ? _c('span', [(_vm.jahrStatistik.vermogen[_vm.monatSelect - 1] && _vm.jahrStatistik.vermogen[_vm.monatSelect]) ? _c('v-card-title', {
    staticClass: "pa-0 justify-center caption"
  }, [_vm._v("\n            " + _vm._s(((_vm.jahrStatistik.vermogen[_vm.monatSelect] / _vm.jahrStatistik.vermogen[_vm.monatSelect - 1]) * 100 - 100).toFixed(0)) + "\n            %\n          ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline justify-center"
  }, [_vm._v("Steuerlast an AHV")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.statistik.steuerlast)) + "\n        ")]), _vm._v(" "), (_vm.jahrStatistik.vermogen) ? _c('span', [(_vm.jahrStatistik.vermogen[_vm.monatSelect - 1] && _vm.jahrStatistik.vermogen[_vm.monatSelect]) ? _c('v-card-title', {
    staticClass: "pa-0 justify-center caption"
  }, [_vm._v("\n            " + _vm._s(((_vm.jahrStatistik.vermogen[_vm.monatSelect] / _vm.jahrStatistik.vermogen[_vm.monatSelect - 1]) * 100 - 100).toFixed(0)) + "\n            %\n          ")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order-xs": "",
      "cols": "12",
      "md": "10"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showArray = 'schankverlust') && _vm.show(_vm.jahresStatistik.schankverlust)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "overline pa-0 justify-space-between"
  }, [_c('v-icon', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v("touch_app")]), _vm._v("\n                  Schankverlust\n                  "), _c('v-icon', [_vm._v("touch_app")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.schankverlust) + "%")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showArray = 'gesamtStriche') && _vm.show(_vm.jahresStatistik.gesamtStriche)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "overline pa-0 justify-space-between"
  }, [_c('v-icon', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v("touch_app")]), _vm._v("\n                  Striche\n                  "), _c('v-icon', [_vm._v("touch_app")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.gesamtStricheTheorie) + " | " + _vm._s(_vm.statistik.gesamtStrichePraxis))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showArray = 'volumen') && _vm.show(_vm.jahresStatistik.volumen)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "overline pa-0 justify-space-between"
  }, [_c('v-icon', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v("touch_app")]), _vm._v("\n                  Volumen\n                  "), _c('v-icon', [_vm._v("touch_app")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.volumen) + "L")])], 1)], 1)], 1), _vm._v(" "), (_vm.showArray === 'schankverlust') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "200",
      "type": "bar",
      "options": _vm.options4,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showArray === 'gesamtStriche') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "200",
      "type": "area",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showArray === 'volumen') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "200",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showArray === 'vermogen') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [(_vm.statistik.gesamtvermogen) ? _c('v-row', {
    staticClass: "pa-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Kontostand"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.kontostand),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "kontostand", $$v)
      },
      expression: "statistik.gesamtvermogen.kontostand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Getränkestand"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.getrankestand),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "getrankestand", $$v)
      },
      expression: "statistik.gesamtvermogen.getrankestand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Fuxenkasse"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.fuxenkasse),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "fuxenkasse", $$v)
      },
      expression: "statistik.gesamtvermogen.fuxenkasse"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Sonstiges"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.sonstiges),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "sonstiges", $$v)
      },
      expression: "statistik.gesamtvermogen.sonstiges"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Offene Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_offen),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_offen", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_offen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Offene SEPA-Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_sepa),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_sepa", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_sepa"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Überfällige Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_ueberfaellig),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_ueberfaellig", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_ueberfaellig"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Gemahnte Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_gemahnt),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_gemahnt", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_gemahnt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                Trag hier alle Werte zum Ende des Monats ein.\n                "), _c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveGesamtvermogen()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-2",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-tab', [_vm._v("BbrBbr")]), _vm._v(" "), _c('v-tab', [_vm._v("Status")]), _vm._v(" "), _c('v-tab-item', [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.statistik.stricheProBbrSortiert), function(item, index) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showBbr = true)
        }
      }
    }, [(index === 0) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "amber--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 1) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "deep-orange--text darken-3"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index > 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item[0], _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])
  }), 0)])], 1), _vm._v(" "), _c('v-tab-item', [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.statistik.stricheProStatusSortiert), function(item, index) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showBbr = true)
        }
      }
    }, [(index === 0) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "amber--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 1) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "deep-orange--text darken-3"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index > 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "48",
      "value": (_vm.statistik.verbrauchBierSumme / _vm.statistik.volumen) * 100,
      "color": "primary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Bier")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v(_vm._s(_vm.statistik.verbrauchBierSumme) + " L")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "223px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.verbrauchBier), function(item) {
    return _c('tr', {
      key: item.bezeichnung,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.verbraucht))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "48",
      "value": (_vm.statistik.verbrauchSoftdrinksSumme / _vm.statistik.volumen) * 100,
      "color": "tertiary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Softdrinks")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v(_vm._s(_vm.statistik.verbrauchSoftdrinksSumme) + " L")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "223px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.verbrauchSoftdrinks), function(item) {
    return _c('tr', {
      key: item.bezeichnung,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.verbraucht))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "48",
      "value": (_vm.statistik.verbrauchWeinSchnapsSumme / _vm.statistik.volumen) * 100,
      "color": "amber"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_vm._v("Wein & Schnaps")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v(_vm._s(_vm.statistik.verbrauchWeinSchnapsSumme) + " L")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "223px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.verbrauchWeinSchnaps), function(item) {
    return _c('tr', {
      key: item.bezeichnung,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.verbraucht))])])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "caption ml-4"
  }, [_vm._v("\n        Zuletzt aktualisiert: " + _vm._s(_vm.$filters.date(_vm.statistik.aktualisiert.seconds * 1000, "DD.MM.YYYY hh:mm")))])])], 1) : _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.monatSelect === 12) ? _c('v-col', {
    staticClass: "hidden-xl-only",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "5",
      "order-md": "1",
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("BbrBbr an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste.length)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Tage an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.tageAnDerTheke)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStriche.summe)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Bester Tag"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.date(_vm.jahrStatistik.besterTag.datum, "DD.MM.YYYY"))), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Bester Tag"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.besterTag.anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "order": "4",
      "order-md": "2",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mx-1 px-1 mx-sm-12 px-sm-12",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-4 px-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-2",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "grey--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-3 overline"
  }, [_c('v-spacer'), _vm._v("2. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _c('v-spacer', [_vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[1].bbr, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[1].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "amber lighten-4",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "amber--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-6 overline"
  }, [_c('v-spacer'), _vm._v("1. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _c('v-spacer', [_vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[0].bbr, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[0].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-7",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "deep-orange lighten-5",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "deep-orange--text darken-3",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("3. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _c('v-spacer', [_vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[2].bbr, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[2].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mt-6",
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "152px"
    }
  }, [_c('tbody', _vm._l((_vm.jahrStatistik.bestenliste), function(item, index) {
    return (index > 2) ? _c('tr', {
      key: item.bbr
    }, [_c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(item.anzahl))])]) : _vm._e()
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "6",
      "order-md": "3",
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Schankverlust"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.schankverlust.gesamt) + " %"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.schankverlust.preis))), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Couleurstriche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.couleurstriche) + " Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.oettingerKisten.summe) + " Ötti-Kisten"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")((_vm.jahrStatistik.oettingerKisten.preis + _vm.jahrStatistik.couleurstrichePreis)))), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Umsatz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.summe))), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "2",
      "order-md": "4",
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "250",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchBierSorte
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": _vm.jahrStatistik.verbrauchBier.donut.series[index],
            "color": _vm.jahrStatistik.verbrauchBier.donut.series[index] > 50 ?
              'primary' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 25 ?
              'primary lighten-1' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 10 ?
              'primary lighten-2' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 5 ?
              'primary lighten-3' :
              'primary lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.Id))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(_vm.jahrStatistik.verbrauchBier.donut.series[index]) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 714915272)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "1",
      "order-md": "5",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 mt-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-5 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "primary"
    }
  }, [_vm._v("Bier")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[0].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "tertiary"
    }
  }, [_vm._v("Softdrinks")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[1].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "amber"
    }
  }, [_vm._v("Wein & Schnaps")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[2].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "291px",
      "type": "donut",
      "options": _vm.jahrStatistik.volumen.chartOptions,
      "series": _vm.jahrStatistik.volumen.donut.series
    }
  })], 1)], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "height": "200",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.jahrStatistik.volumen
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "3",
      "order-md": "6",
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "250",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchSoftdrinks
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100,
            "color": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 25 ?
              'red' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 20 ?
              'red lighten-1' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 10 ?
              'red lighten-2' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 5 ?
              'red lighten-3' :
              'red lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "text-truncate",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(((item.liter / _vm.jahrStatistik.volumen[1].summe) * 100).toFixed(1)) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 1948615279)
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.monatSelect === 12) ? _c('v-col', {
    staticClass: "hidden-lg-and-down",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste.length) + " BbrBbr"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.tageAnDerTheke) + " Tage"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 pt-2 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.date(_vm.jahrStatistik.besterTag.datum, "DD.MM.YYYY"))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.besterTag.anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Striche"), _c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStriche.summe) + " (" + _vm._s(((_vm.jahrStatistik.gesamtStriche.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) * 100).toFixed(1)) + "\n                  %)")], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Striche EKP"), _c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) + " (" + _vm._s((
          ((_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) /
            _vm.jahrStatistik.gesamtStricheTheorie.summe) *
          100
        ).toFixed(1)) + "\n                  %)")], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Schankverlust"), _c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe) + " (" + _vm._s((
          100 -
          (_vm.jahrStatistik.gesamtStrichePraxis.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) * 100
        ).toFixed(1)) + "\n                  %)")], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStricheTheorie.summe))], 1)], 1)]
      }
    }], null, false, 3999797632)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Anzahl Striche an Gesamtvolumen"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, _vm._l((_vm.jahrStatistik.gesamtStriche.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "17",
        "value": ((item / _vm.jahrStatistik.gesamtStricheTheorie.data[index]) * 100).toFixed(1),
        "color": "tertiary"
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "caption text-truncate",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(new Date(_vm.jahre[_vm.jahrSelect], index), "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "caption text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v("\n                      " + _vm._s(((item / _vm.jahrStatistik.gesamtStricheTheorie.data[index]) * 100).toFixed(1)) + " %\n                    ")])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-progress-linear', {
    staticClass: "my-1",
    attrs: {
      "rounded": "",
      "height": "28",
      "value": ((_vm.jahrStatistik.gesamtStriche.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) * 100).toFixed(1),
      "color": "tertiary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "title text-right",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                      " + _vm._s((
    (_vm.jahrStatistik.gesamtStriche.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) *
    100
  ).toFixed(1)) + "\n                      %\n                    ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Schankverlust"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.schankverlust.gesamt) + " %"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 subtitle-2"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.schankverlust.preis))), _c('v-spacer')], 1)], 1)]
      }
    }], null, false, 3900815369)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Schankverlust"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, _vm._l((_vm.jahrStatistik.schankverlust.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "17",
        "value": (item / 50) * 100,
        "color": "tertiary"
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "caption text-truncate",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(new Date(_vm.jahre[_vm.jahrSelect], index), "MM.YYYY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "caption text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(item) + " %")])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-progress-linear', {
    staticClass: "my-1",
    attrs: {
      "rounded": "",
      "height": "28",
      "value": (_vm.jahrStatistik.schankverlust.gesamt / 50) * 100,
      "color": "tertiary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "caption text-truncate",
    attrs: {
      "cols": "6"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "title text-right",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v(_vm._s(_vm.jahrStatistik.schankverlust.gesamt) + " %")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Couleurstriche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.couleurstriche) + " Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.oettingerKisten.summe) + " Ötti-Kisten"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")((_vm.jahrStatistik.oettingerKisten.preis + _vm.jahrStatistik.couleurstrichePreis)))), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Einkauf"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Bier Schneider"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.bierschneider)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Metro"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.metro)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Oettinger"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.oettinger)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.summe)))], 1)], 1)]
      }
    }], null, false, 817975205)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Einkauf nach Lieferant"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Bier Schneider"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.bierschneider)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Metro"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.metro)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Oettinger"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.oettinger)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Rewe"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.rewe)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Vendel"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.vendel)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Vinos"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.vinos)))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.summe)))], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Umsatz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Striche"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.striche)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("EKP"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.ekp)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Pauschal"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.pauschal)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.summe)))], 1)], 1)]
      }
    }], null, false, 1397910170)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Davon gingen Rechnungen an"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Bierspenden"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.bierkasse)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Aktivenkasse"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.aktivenkasse)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Fuxenkasse"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.ahv)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("AHV"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.hbv)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("HBV"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.fuxia)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Couleur"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.couleur)))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4"
  }, [_c('v-spacer'), _vm._v("\n                " + _vm._s(_vm._f("money")((_vm.jahrStatistik.umsatz.bierkasse +
    _vm.jahrStatistik.umsatz.aktivenkasse +
    _vm.jahrStatistik.umsatz.ahv +
    _vm.jahrStatistik.umsatz.hbv +
    _vm.jahrStatistik.umsatz.fuxia +
    _vm.jahrStatistik.umsatz.couleur))) + "\n              ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "228",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchBierSorte
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": _vm.jahrStatistik.verbrauchBier.donut.series[index],
            "color": _vm.jahrStatistik.verbrauchBier.donut.series[index] > 50 ?
              'primary' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 25 ?
              'primary lighten-1' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 10 ?
              'primary lighten-2' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 5 ?
              'primary lighten-3' :
              'primary lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.Id))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(_vm.jahrStatistik.verbrauchBier.donut.series[index]) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 714915272)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 mt-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-5 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "primary"
    }
  }, [_vm._v("Bier")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[0].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "tertiary"
    }
  }, [_vm._v("Softdrinks")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[1].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "amber"
    }
  }, [_vm._v("Wein & Schnaps")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[2].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "267px",
      "type": "donut",
      "options": _vm.jahrStatistik.volumen.chartOptions,
      "series": _vm.jahrStatistik.volumen.donut.series
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "231",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.jahrStatistik.volumen
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "228",
      "bench": "2",
      "item-height": "19",
      "items": _vm.jahrStatistik.stricheProTag
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "17",
            "value": (item.summe / _vm.jahrStatistik.stricheProTagMax) * 100,
            "color": "primary lighten-2"
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "caption text-truncate",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(_vm.$filters.date(new Date(_vm.jahre[_vm.jahrSelect], index), "MM.YYYY")))]), _vm._v(" "), _c('v-col', {
          staticClass: "caption text-right",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(item.summe) + " Striche")])], 1)], 1)]
      }
    }], null, false, 3773264116)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "228",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchSoftdrinks
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100,
            "color": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 25 ?
              'red' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 20 ?
              'red lighten-1' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 10 ?
              'red lighten-2' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 5 ?
              'red lighten-3' :
              'red lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "text-truncate",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(((item.liter / _vm.jahrStatistik.volumen[1].summe) * 100).toFixed(1)) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 1948615279)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Preise")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Strich")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Schankverlust")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Kosten pro Strich")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.kostenStriche)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.kostenEKP)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.kostenSchankverlust)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Einnahmen pro Strich")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.einnahmenStriche)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.einnahmenEKP)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.einnahmenSchankverlust)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Gewinn pro Strich")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.gewinnStriche)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.gewinnEKP)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.gewinnSchankverlust)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Anzahl Striche")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.jahrStatistik.gesamtStriche.summe))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Gewinn")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnStriche * _vm.jahrStatistik.gesamtStriche.summe))) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnEKP *
    (_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe)))) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnSchankverlust *
    (_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe)))) + "\n                  ")])]), _vm._v(" "), _c('tr', {
    staticClass: "font-weight-bold mt-4"
  }, [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnStriche * _vm.jahrStatistik.gesamtStriche.summe +
    _vm.preiskalkulation.gewinnEKP *
    (_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) +
    _vm.preiskalkulation.gewinnSchankverlust *
    (_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe)))) + "\n                  ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Bier")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Striche")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik.verbrauchBier), function(item) {
    return _c('tr', {
      key: item.bezeichnung
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.preis)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.verkauf1)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.getrank.striche))]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Softdrinks")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Striche")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik.verbrauchSoftdrinks), function(item) {
    return _c('tr', {
      key: item.bezeichnung
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.preis)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.verkauf1)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.getrank.striche))]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Wein & Schnaps")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Striche")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik.verbrauchWeinSchnaps), function(item) {
    return _c('tr', {
      key: item.bezeichnung
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.preis)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.verkauf1)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.getrank.striche))]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Vermögen")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "px-1 mx-4 mt-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-4 px-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-2",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "grey--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-3 overline"
  }, [_c('v-spacer'), _vm._v("2. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[1].bbr, _vm.bbrbbr))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[1].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "amber lighten-4",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "amber--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-6 overline"
  }, [_c('v-spacer'), _vm._v("1. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[0].bbr, _vm.bbrbbr))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[0].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-7",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "deep-orange lighten-5",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "deep-orange--text darken-3",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("3. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[2].bbr, _vm.bbrbbr))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[2].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mt-6",
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "152px"
    }
  }, [_c('tbody', _vm._l((_vm.jahrStatistik.bestenliste), function(item, index) {
    return (index > 2) ? _c('tr', {
      key: item.bbr
    }, [_c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(item.anzahl))])]) : _vm._e()
  }), 0)])], 1)], 1)], 1)], 1) : _c('v-col', {
    attrs: {
      "cols": "4",
      "offset": "4"
    }
  }, [_vm._l((_vm.errorMessage), function(item, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v("\n        " + _vm._s(item[1]) + "\n      ")])
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "warning",
      "outlined": "",
      "border": "left"
    }
  }, [_vm._v("\n        Die Statistik kann erst erstellt werden, wenn die Getränkezählung von Monatsanfang und Monatsende vorliegen.\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.zahlungExist
    },
    on: {
      "click": function($event) {
        return _vm.addMonat(true)
      }
    }
  }, [_vm._v("Monat berechnen")])], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showDebug),
      callback: function($$v) {
        _vm.showDebug = $$v
      },
      expression: "showDebug"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', {
    staticClass: "green"
  }, [_vm._v("\n        Debug Fenster\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDebug = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "100%",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Data")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (Array.isArray(item)) ? _c('td', [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((item), function(item2, index) {
      return _c('v-list-item', {
        key: index
      }, [_c('v-list-item-icon', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-list-item-content', [_vm._v(_vm._s(item2))])], 1)
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item))])])
  }), 0)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "100%",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Data")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (Array.isArray(item)) ? _c('td', [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((item), function(item2, index) {
      return _c('v-list-item', {
        key: index
      }, [_c('v-list-item-icon', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-list-item-content', [_vm._v(_vm._s(item2))])], 1)
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item))])])
  }), 0)])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "md": _vm.feld.breite,
      "cols": "12",
      "sm": "6"
    }
  }, [(_vm.feld.type === 'String') ? _c('span', [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Select') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.feld.options
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Date') ? _c('span', [_c('v-menu', {
    ref: _vm.value,
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "hide-details": "auto",
            "dense": "",
            "outlined": "",
            "value": _vm.formatDate,
            "label": _vm.feld.label,
            "readonly": "",
            "clearable": ""
          },
          on: {
            "click:clear": function($event) {
              return _vm.clearValue()
            }
          }
        }, on))]
      }
    }], null, false, 1531838768),
    model: {
      value: (_vm.menuFeldVar),
      callback: function($$v) {
        _vm.menuFeldVar = $$v
      },
      expression: "menuFeldVar"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.sendDataBack,
      "input": function($event) {
        _vm.menuFeldVar = false
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Anrede') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsAnrede
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Briefanrede') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsBriefanrede
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Status') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsStatus
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Telefon') ? _c('span', [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "rules": [_vm.rules.telefonnummer],
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label
    },
    on: {
      "input": _vm.formatPhoneNumber,
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Leibvater') ? _c('span', [_c('v-autocomplete', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "clearable": "",
      "clear-icon": "close",
      "items": _vm.$selectLeibvater()
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Verbindung' || _vm.feld.type === 'Verbindungen') ? _c('span', [_c('v-combobox', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "multiple": _vm.feld.type === 'Verbindungen',
      "items": _vm.selectVerbindung,
      "label": _vm.feld.label,
      "clearable": ""
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Gruppen') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsGruppen
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Zirkel') ? _c('span', [_c('v-select', {
    attrs: {
      "clearable": "",
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsZirkel
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'money') ? _c('span', [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "rules": [_vm.rules.required, _vm.rules.geld]
    },
    on: {
      "change": _vm.sendDataBack,
      "input": _vm.formatMoney
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0 pt-0 mb-0 pb-0",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "items-per-page": -1,
      "no-data-text": "Keine Kontakte vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('thead', [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th', [_vm._v("Nachname")]), _vm._v(" "), _c('th', [_vm._v("Vorname")])])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          on: {
            "dblclick": function($event) {
              (_vm.bbr = item) && (_vm.showKontakt = true)
            }
          }
        }, [_c('td', {
          attrs: {
            "width": "30px"
          }
        }, [_c('v-icon', [_vm._v(_vm._s(item.bildAhnengalerie ? 'check' : 'close'))])], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30px"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "grey",
            "size": "28"
          }
        }, [(item.bildAhnengalerie) ? _c('v-img', {
          staticClass: "ma-4 profilbild",
          attrs: {
            "src": item.bildAhnengalerie200 ? item.bildAhnengalerie200 : item.bildAhnengalerie
          }
        }) : _c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30px"
          }
        }, [_c('v-icon', [_vm._v(_vm._s(item.bildAhnengalerie500 ? 'check' : 'close'))])], 1), _vm._v(" "), _vm._l((_vm.headers), function(header) {
          return (header.type !== 'fix') ? _c('td', {
            key: header.number
          }, [_vm._v(_vm._s(item[header.value]))]) : _vm._e()
        })], 2)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "red white--text",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._v("\n    Diese Seite ist bisher statisch und befindet sich noch im Aufbau!\n    "), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, _vm._l((_vm.eintrage), function(eintrag) {
    return _c('v-col', {
      key: eintrag.id,
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('v-card', [_c('v-card-title', [_vm._v("\n          " + _vm._s(eintrag.titel) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          " + _vm._s(eintrag.beschreibung) + "\n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-action', _vm._l((eintrag.tags), function(tag) {
      return _c('v-chip', {
        key: tag,
        staticClass: "pa-2 ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
    }), 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      Neue Nachricht\n      "), _c('v-spacer'), _vm._v(" "), (_vm.$vars.beta) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.makeTest()
      }
    }
  }, [_vm._v("Testdatein eintragen")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "py-1 pt-3 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "Gruppen",
      "items": _vm.gruppen,
      "label": "Gruppen"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.kontakteAusGruppen ? _vm.kontakteAusGruppen.length : 0))])]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Kontakte aus Gruppen werden automatisch als BCC versendet. Doppelte Kontakte werden ignoriert.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.gruppen),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "gruppen", $$v)
      },
      expression: "nachricht.gruppen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "An",
      "items": _vm.bbrbbr,
      "label": "An"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.an ? _vm.nachricht.an.length : 0))])]
      },
      proxy: true
    }, (!_vm.showcc || !_vm.showbcc) ? {
      key: "append-outer",
      fn: function() {
        return [(!_vm.showcc) ? _c('v-btn', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.showcc = true
            }
          }
        }, [_vm._v("CC")]) : _vm._e(), _vm._v(" "), (!_vm.showbcc) ? _c('v-btn', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.showbcc = true
            }
          }
        }, [_vm._v("BCC")]) : _vm._e(), _vm._v(" "), (!_vm.showcc) ? _c('v-btn', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.showan_adresse = true
            }
          }
        }, [_vm._v("Mailadresse")]) : _vm._e()]
      },
      proxy: true
    } : null], null, true),
    model: {
      value: (_vm.nachricht.an),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "an", $$v)
      },
      expression: "nachricht.an"
    }
  })], 1), _vm._v(" "), (_vm.showan_adresse) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "An Mailadressen",
      "label": "An Mailadressen"
    },
    on: {
      "input": _vm.checkIsSendDisabled,
      "change": _vm.formatEmails,
      "blur": _vm.formatEmails
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.an_adresse ? _vm.nachricht.an_adresse.length : 0))])]
      },
      proxy: true
    }], null, false, 1194127780),
    model: {
      value: (_vm.nachricht.an_adresse),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "an_adresse", $$v)
      },
      expression: "nachricht.an_adresse"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showcc) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "CC",
      "items": _vm.bbrbbr,
      "label": "CC"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.cc ? _vm.nachricht.cc.length : 0))])]
      },
      proxy: true
    }], null, false, 2757890884),
    model: {
      value: (_vm.nachricht.cc),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "cc", $$v)
      },
      expression: "nachricht.cc"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showbcc) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "BCC",
      "items": _vm.bbrbbr,
      "label": "Bcc"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.bc ? _vm.nachricht.bcc.length : 0))])]
      },
      proxy: true
    }], null, false, 2563283143),
    model: {
      value: (_vm.nachricht.bcc),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "bcc", $$v)
      },
      expression: "nachricht.bcc"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betreff*"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    model: {
      value: (_vm.nachricht.betreff),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "betreff", $$v)
      },
      expression: "nachricht.betreff"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.absender,
      "label": "Absender*"
    },
    on: {
      "change": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Wähle hier die Position aus, von welcher du die Mail senden willst. Sollte dein Amt nicht aufgeführt\n                  sein sind keine Maildaten hinterlegt. Wende dich dann an den Admin.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.absenderPosition),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "absenderPosition", $$v)
      },
      expression: "nachricht.absenderPosition"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Template",
      "items": _vm.templates
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Die Templates sind die Designvorlage in welche deine Mail eingebettet wird. Wenn du das Template\n                  entfernst wird ein normaler Text versendet.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.template),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "template", $$v)
      },
      expression: "nachricht.template"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "d-flex align-center justify-space-between pa-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-icon', [_vm._v("attach_file")]), _vm._v(" "), _c('v-sheet', {
    staticClass: "d-flex align-center flex-wrap align-content-center",
    attrs: {
      "color": "transparent",
      "max-width": "70%"
    }
  }, [_vm._l((_vm.uploadedFiles), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2 mb-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-sheet', {
      staticClass: "text-truncate",
      attrs: {
        "max-width": "150",
        "color": "transparent"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.uploadStatus[index] < 100) ? _c('v-progress-circular', {
      staticClass: "ml-2",
      attrs: {
        "value": _vm.uploadStatus[index],
        "size": "20",
        "rotate": "-90",
        "color": "primary",
        "width": "3"
      }
    }) : _c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check")])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.attachments), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2 mb-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-sheet', {
      staticClass: "text-truncate",
      attrs: {
        "max-width": "150",
        "color": "transparent"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('span', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleFileImport
    }
  }, [_vm._v("Anhang auswählen\n              ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Nachricht*",
      "auto-grow": "",
      "rows": "10",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    model: {
      value: (_vm.nachricht.text),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "text", $$v)
      },
      expression: "nachricht.text"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("Antworten auf diese Mail werden an " + _vm._s(_vm.replyToMail) + " gesendet.")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-2",
          class: !_vm.nachricht.template ? 'grey ' : 'primary--text ',
          attrs: {
            "rounded": "",
            "text": "",
            "read-only": !_vm.nachricht.template
          },
          on: {
            "click": function($event) {
              _vm.showVorschau = true
            }
          }
        }, on), [_vm._v("Vorschau")])]
      }
    }])
  }, [_vm._v(" "), (!_vm.nachricht.template) ? _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [(!_vm.nachricht.template) ? _c('span', [_vm._v("Es muss ein Template ausgewählt werden.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          staticClass: "primary",
          attrs: {
            "rounded": "",
            "disabled": _vm.isSendDisabled
          },
          on: {
            "click": function($event) {
              return _vm.sendMail()
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2"
        }, [_vm._v("send")]), _vm._v("Senden\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), (
    !_vm.nachricht.text ||
    !_vm.nachricht.betreff ||
    !_vm.nachricht.absenderPosition ||
    (!_vm.nachricht.an.length > 0 &&
      !_vm.nachricht.cc.length > 0 &&
      !_vm.nachricht.bcc.length > 0 &&
      !_vm.nachricht.gruppen.length > 0)
  ) ? _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [(!_vm.nachricht.text) ? _c('span', [_vm._v("Die Nachricht darf nicht leer sein.")]) : _vm._e(), _vm._v(" "), (!_vm.nachricht.betreff) ? _c('span', [_vm._v("Der Betreff darf nicht leer sein.")]) : _vm._e(), _vm._v(" "), (!_vm.nachricht.absenderPosition) ? _c('span', [_vm._v("Es muss ein Absender ausgewählt werden.")]) : _vm._e(), _vm._v(" "), (
    !_vm.nachricht.an.length > 0 &&
    !_vm.nachricht.an_adresse.length > 0 &&
    !_vm.nachricht.cc.length > 0 &&
    !_vm.nachricht.bcc.length > 0 &&
    !_vm.nachricht.gruppen.length > 0
  ) ? _c('span', [_vm._v("Es muss mindestens ein Empfänger in \"Gruppen\", \"An\", \"CC\" oder \"BCC\" ausgewählt sein.")]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "50%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAPISettings),
      callback: function($$v) {
        _vm.showAPISettings = $$v
      },
      expression: "showAPISettings"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        API Settings\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAPISettings = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "rows": "6",
      "auto-grow": "",
      "label": "Eingabe zur API"
    },
    model: {
      value: (_vm.apiSettings),
      callback: function($$v) {
        _vm.apiSettings = $$v
      },
      expression: "apiSettings"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAPISettings = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "80%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showVorschau),
      callback: function($$v) {
        _vm.showVorschau = $$v
      },
      expression: "showVorschau"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Vorschau\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showVorschau = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4"
  }, [_vm._v("\n            " + _vm._s(_vm.nachricht.betreff ? _vm.nachricht.betreff : "") + "\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n            Von:\n            "), (_vm.nachricht.absenderPosition) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absenderPosition))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An:\n              "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n                " + _vm._s(item2) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_adresse) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An Mailadressen:\n              "), _vm._l((_vm.nachricht.an_adresse), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc && _vm.nachricht.an_cc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              CC:\n              "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc && _vm.nachricht.an_bcc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              BCC:\n              "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachrichtVorschau)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showVorschau = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showGetrank = true) && (_vm.neuGetrank = true) && (_vm.getrank = [])
            }
          }
        }, [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.getranke,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "no-data-text": "Keine Getränke vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', [_vm._v("Einkaufspreis")])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          class: !item.switchZahlung ? 'red lighten-4' : '',
          on: {
            "dblclick": function($event) {
              (_vm.getrank = item) && (_vm.showGetrank = true) && (_vm.neuGetrank = false)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(item.verkaufseinheit))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(_vm._f("money")(item.verkauf1)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(_vm._f("money")(item.verkauf2)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(_vm._f("money")(item.verkauf3)))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "70%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showGetrank),
      callback: function($$v) {
        _vm.showGetrank = $$v
      },
      expression: "showGetrank"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [(_vm.neuGetrank) ? _c('div', {
    staticClass: "pr-1"
  }, [_vm._v("Neues Getränk erstellen")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getrank.bezeichnung) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrank = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-app-bar', {
    staticClass: "transparent",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.num),
      callback: function($$v) {
        _vm.num = $$v
      },
      expression: "num"
    }
  }, [_c('v-tab', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("info")]), _vm._v("Info")], 1), _vm._v(" "), (!_vm.neuGetrank) ? _c('v-tab', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("insights")]), _vm._v("Statistik")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-tabs-items', {
    model: {
      value: (_vm.num),
      callback: function($$v) {
        _vm.num = $$v
      },
      expression: "num"
    }
  }, [_c('v-tab-item', [_c('v-row', {
    staticClass: "pa-0 ma-0 mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.getrank.bezeichnung),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "bezeichnung", $$v)
      },
      expression: "getrank.bezeichnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Flaschen/Gebinde",
      "hint": "Anzahl Flaschen pro Kiste"
    },
    model: {
      value: (_vm.getrank.verkaufseinheit),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkaufseinheit", $$v)
      },
      expression: "getrank.verkaufseinheit"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Volumen/Flasche"
    },
    model: {
      value: (_vm.getrank.volumen),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "volumen", $$v)
      },
      expression: "getrank.volumen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Preis/Gebinde inkl. MwSt."
    },
    model: {
      value: (_vm.getrank.preis),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "preis", $$v)
      },
      expression: "getrank.preis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Preis/Gebinde exkl. MwSt.",
      "disabled": ""
    },
    model: {
      value: (_vm.preisexcl),
      callback: function($$v) {
        _vm.preisexcl = $$v
      },
      expression: "preisexcl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Pfand",
      "hint": "Für eine Kiste"
    },
    model: {
      value: (_vm.getrank.pfand),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "pfand", $$v)
      },
      expression: "getrank.pfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Striche pro Flasche"
    },
    model: {
      value: (_vm.getrank.striche),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "striche", $$v)
      },
      expression: "getrank.striche"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Verkaufspreis 1",
      "hint": "Wird für EKP verwendet"
    },
    model: {
      value: (_vm.getrank.verkauf1),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkauf1", $$v)
      },
      expression: "getrank.verkauf1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Verkaufspreis 2",
      "hint": "Kann in Abrechnungen verwendet werden"
    },
    model: {
      value: (_vm.getrank.verkauf2),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkauf2", $$v)
      },
      expression: "getrank.verkauf2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Verkaufspreis 3",
      "hint": "Kann in Abrechnungen verwendet werden"
    },
    model: {
      value: (_vm.getrank.verkauf3),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkauf3", $$v)
      },
      expression: "getrank.verkauf3"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "items": _vm.kategorien,
      "label": "Standard"
    },
    model: {
      value: (_vm.getrank.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "kategorie", $$v)
      },
      expression: "getrank.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "Pfand zählen"
    },
    model: {
      value: (_vm.getrank.switchPfand),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchPfand", $$v)
      },
      expression: "getrank.switchPfand"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "EKP erlauben"
    },
    model: {
      value: (_vm.getrank.switchEkp),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchEkp", $$v)
      },
      expression: "getrank.switchEkp"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "Getränk kann bestellt werden"
    },
    model: {
      value: (_vm.getrank.switchBestellung),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchBestellung", $$v)
      },
      expression: "getrank.switchBestellung"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "Getränk kann gezählt werden"
    },
    model: {
      value: (_vm.getrank.switchZahlung),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchZahlung", $$v)
      },
      expression: "getrank.switchZahlung"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.neuGetrank) ? _c('v-tab-item', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pt-8 pb-0 mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-slider', {
    attrs: {
      "max": "24",
      "min": "1",
      "thumb-size": 24,
      "thumb-label": "always",
      "ticks": "always",
      "tick-size": "4"
    },
    model: {
      value: (_vm.anzahl),
      callback: function($$v) {
        _vm.anzahl = $$v
      },
      expression: "anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-1 px-2"
  }, [_vm._v("\n                    Verbraucht\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("Ø\n                      " + _vm._s((
    (_vm.statistiken.verbraucht.data.reduce(function (a, b) { return a + b; }, 0) /
      _vm.statistiken.verbraucht.data.length) *
    _vm.getrank.volumen
  ).toFixed(1)) + "\n                      l")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, _vm._l((_vm.statistiken.verbraucht.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "16",
        "value": (item / Math.max.apply(Math, _vm.statistiken.verbraucht.data)) * 100
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(_vm.statistiken.monate[index], "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s((item * _vm.getrank.volumen).toFixed(0)) + " l")])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-1 px-2"
  }, [_vm._v("\n                    EKP\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("Ø\n                      " + _vm._s((
    (_vm.statistiken.ekp.data.reduce(function (a, b) { return a + b; }, 0) / _vm.statistiken.ekp.data.length) *
    _vm.getrank.volumen
  ).toFixed(1)) + "\n                      l")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, _vm._l((_vm.statistiken.ekp.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "16",
        "value": (item / Math.max.apply(Math, _vm.statistiken.ekp.data)) * 100
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(_vm.statistiken.monate[index], "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s((item * _vm.getrank.volumen).toFixed(0)) + " l")])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-1 px-2"
  }, [_vm._v("\n                    Ende\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("Ø\n                      " + _vm._s((
    (_vm.statistiken.ende.data.reduce(function (a, b) { return a + b; }, 0) / _vm.statistiken.ende.data.length) *
    _vm.getrank.volumen
  ).toFixed(1)) + "\n                      l")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, _vm._l((_vm.statistiken.ende.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "16",
        "value": (item / Math.max.apply(Math, _vm.statistiken.ende.data)) * 100
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(_vm.statistiken.monate[index], "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s((item * _vm.getrank.volumen).toFixed(0)) + " l")])], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrank = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.neuGetrank) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createGetrank()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateGetrank()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteGetrank,
      "title": "Getränk löschen",
      "message": "Willst du dieses Getränk wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteGetrank = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteGetrank()
      },
      "closeFalse": function($event) {
        _vm.showDeleteGetrank = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [(!_vm.hideImage) ? _c('v-img', {
    staticClass: "mb-1",
    attrs: {
      "src": '/static/calendarEventImages/img_planmyday_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text hidden-xs-only"
  }, [_vm._v("Veranstaltungen")])], 1) : _c('v-card-title', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Veranstaltungen")]), _vm._v(" "), (_vm.$vars.loading) ? _c('v-skeleton-loader', {
    ref: "skeleton",
    staticClass: "mx-auto",
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [(Object.keys(_vm.veranstaltungen).length == 0) ? _c('v-subheader', {
    staticClass: "justify-center"
  }, [_vm._v("\n      Keine Veranstaltungen geplant.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.veranstaltungen), function(veranstaltung, monat) {
    return _c('span', {
      key: monat
    }, [_c('v-subheader', {
      staticClass: "justify-center title"
    }, [_vm._v(_vm._s(_vm.$filters.date(monat, "MMM")))]), _vm._v(" "), _vm._l((veranstaltung), function(item, index) {
      return _c('v-list-item', {
        key: index,
        staticClass: "mx-2 pa-1 rounded-lg",
        on: {
          "click": function($event) {
            _vm.veranstaltungDialog = true;
            _vm.selectedEvent = item;
          }
        }
      }, [_c('v-list-item-action', {
        staticClass: "mx-0 px-2 justify-center align-start",
        staticStyle: {
          "width": "60px"
        }
      }, [_c('div', {
        staticClass: "text-center"
      }, [_c('div', {
        staticClass: "title font-weight-bold"
      }, [_vm._v(_vm._s(_vm.$filters.date(item.vonDatum, "DD.")))]), _vm._v(" "), _c('div', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(_vm.$filters.date(item.vonDatum, "MMM")))])])]), _vm._v(" "), _c('v-divider', {
        attrs: {
          "vertical": ""
        }
      }), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "pl-2"
      }, [_c('div', {
        staticClass: "d-flex"
      }, [_c('span', {
        staticClass: "d-flex align-center mr-2"
      }, [(item.anmeldungen.includes(_vm.currentBbr)) ? _c('v-icon', {
        staticClass: "green--text",
        attrs: {
          "small": ""
        }
      }, [_vm._v("check_circle")]) : _c('v-icon', {
        staticClass: "grey--text",
        attrs: {
          "small": ""
        }
      }, [_vm._v("help")])], 1), _vm._v(" "), _c('span', {
        staticClass: "text-body-2 font-weight-medium"
      }, [_vm._v("\n              " + _vm._s(item.titel) + "\n            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_c('v-icon', {
        staticClass: "pr-2 hidden-xs-only",
        attrs: {
          "small": ""
        }
      }, [_vm._v("access_time")]), _vm._v(_vm._s(item.vonZeit) + " Uhr\n          ")], 1), _vm._v(" "), _c('v-list-item-subtitle', [_c('v-icon', {
        staticClass: "pr-2 hidden-xs-only",
        attrs: {
          "small": ""
        }
      }, [_vm._v("group")]), _vm._v(_vm._s(item.anmeldungen.length + item.weitereAnmeldungen.length) + " Zusage"), (item.anmeldungen.length + item.weitereAnmeldungen.length !== 1) ? _c('span', [_vm._v("n")]) : _vm._e()], 1), _vm._v(" "), (item.kalender !== 'Ripuaria') ? _c('v-list-item-subtitle', [_c('v-icon', {
        staticClass: "pr-2 hidden-xs-only",
        attrs: {
          "small": ""
        }
      }, [_vm._v("calendar_month")]), _vm._v(_vm._s(item.kalender) + "\n          ")], 1) : _vm._e()], 1), _vm._v(" "), (
        item.anmeldungBis &&
        (new Date(item.anmeldungBis).getTime() - new Date(_vm.datum).getTime()) / 1000 / 60 / 60 / 24 < 7 &&
        (new Date(item.anmeldungBis).getTime() - new Date(_vm.datum).getTime()) / 1000 / 60 / 60 / 24 > 0
      ) ? _c('v-list-item-action', {
        staticClass: "text-center"
      }, [_c('v-tooltip', {
        attrs: {
          "bottom": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('span', _vm._g({
              staticClass: "caption"
            }, on), [_c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("alarm")]), _c('br'), _vm._v(_vm._s((new Date(item.anmeldungBis).getTime() - new Date(_vm.datum).getTime()) / 1000 / 60 / 60 / 24) + "\n                Tage")], 1)]
          }
        }], null, true)
      }, [_vm._v(" "), _c('span', [_vm._v("Anmeldefrist")])])], 1) : _vm._e()], 1)
    })], 2)
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-xs-only"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "to": "./veranstaltungen",
      "text": ""
    }
  }, [_vm._v("Alle Veranstaltungen")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('dialogVeranstaltung', {
    attrs: {
      "visible": _vm.veranstaltungDialog,
      "selectedEvent": _vm.selectedEvent
    },
    on: {
      "update:visible": function($event) {
        _vm.veranstaltungDialog = $event
      },
      "close": function($event) {
        _vm.veranstaltungDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('v-tabs', {
    staticClass: "mb-2",
    attrs: {
      "center-active": "",
      "show-arrows": "",
      "background-color": "transparent"
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [(Object.keys(_vm.rechnungen).length === 0) ? _c('v-tab', [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rechnungen), function(rechnung, jahr) {
    return _c('v-tab', {
      key: jahr
    }, [_vm._v(_vm._s(jahr))])
  })], 2)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-responsive', {
    staticClass: "mr-4",
    attrs: {
      "max-width": "300"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "flat": "",
      "solo": "",
      "hide-details": "",
      "append-icon": "search",
      "placeholder": "Rechnungen durchsuchen",
      "clearable": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-tabs-items', {
    staticClass: "transparent",
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.rechnungen), function(rechnung, jahr) {
    return _c('v-tab-item', {
      key: jahr
    }, [_c('v-sheet', {
      staticClass: "overflow-auto pa-2",
      attrs: {
        "color": "transparent"
      }
    }, [_c('v-data-iterator', {
      attrs: {
        "loading": _vm.loading,
        "items": rechnung,
        "search": _vm.search,
        "hide-default-footer": "",
        "sort-by": "rechnung_datum",
        "sort-desc": "",
        "no-data-text": "Keine Rechnungen vorhanden",
        "no-results-text": "Keine Rechnungen gefunden"
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function(ref) {
          var item = ref.item;

          return [_c('v-expansion-panels', {
            staticClass: "mb-4"
          }, [_c('v-expansion-panel', {
            staticClass: "rounded-lg"
          }, [_c('v-expansion-panel-header', {
            staticClass: "pa-1 pr-6"
          }, [_c('v-sheet', {
            staticClass: "d-flex justify-space-between pr-4"
          }, [_c('v-sheet', {
            staticClass: "rounded-lg d-flex align-center justify-center",
            attrs: {
              "width": "64px"
            }
          }, [(item.status === 'Gezahlt') ? _c('v-icon', {
            staticClass: "green--text",
            attrs: {
              "size": "32"
            }
          }, [_vm._v("check_circle")]) : _c('v-icon', {
            staticClass: "red--text",
            attrs: {
              "size": "32"
            }
          }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('span', {
            staticClass: "font-weight-bold"
          }, [_vm._v("\n                          " + _vm._s(item.rechnung_titel) + "\n                        ")]), _vm._v(" "), _c('span', {
            staticClass: "text-subtitle-2 blue-grey--text"
          }, [_vm._v("\n                          " + _vm._s(item.kasse) + " | " + _vm._s(item.rechnungsnummer) + "\n                        ")])]), _vm._v(" "), _c('span', {
            staticClass: "d-flex align-center text-subtitle-2"
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(item.summe)) + "\n                      ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', {
            staticClass: "ma-0 pa-0"
          }, [_c('v-col', {
            attrs: {
              "cols": "4",
              "md": "2"
            }
          }, [_c('span', {
            staticClass: "caption font-weight-bold"
          }, [_vm._v("Rechnungsnr.")]), _c('br'), _vm._v(" "), (item.rechnungsnummer) ? _c('span', [_vm._v(_vm._s(item.rechnungsnummer))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "4",
              "md": "2"
            }
          }, [_c('span', {
            staticClass: "caption font-weight-bold"
          }, [_vm._v("Rechnungsdatum")]), _c('br'), _vm._v(" "), (item.rechnung_datum) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(item.rechnung_datum, "DD.MM.YYYY")))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "4",
              "md": "2"
            }
          }, [_c('span', {
            staticClass: "caption font-weight-bold"
          }, [_vm._v("Zahlbar bis")]), _c('br'), _vm._v(" "), (item.rechnung_zahlbar_bis) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY")))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "4",
              "md": "2"
            }
          }, [_c('span', {
            staticClass: "caption font-weight-bold"
          }, [_vm._v("Kasse")]), _c('br'), _vm._v(" "), (item.kasse) ? _c('span', [_vm._v(_vm._s(item.kasse))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "4",
              "md": "2"
            }
          }, [_c('span', {
            staticClass: "caption font-weight-bold"
          }, [_vm._v("Rechnungsart")]), _c('br'), _vm._v(" "), (item.rechnung_art) ? _c('span', [_vm._v(_vm._s(item.rechnung_art))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "4",
              "md": "2"
            }
          }, [_c('span', {
            staticClass: "caption font-weight-bold"
          }, [_vm._v("Gezahlt am")]), _c('br'), _vm._v(" "), (item.gezahlt_datum) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(item.gezahlt_datum, "DD.MM.YYYY")))]) : _vm._e(), _c('br')])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
            staticClass: "rounded-b-lg grey lighten-4 pt-4"
          }, [_c('span', {
            staticClass: "d-flex justify-end"
          }, [_c('buttonRechnungDownload', {
            attrs: {
              "small": true,
              "icon": "download",
              "rechnung": item
            }
          }), _vm._v(" "), _c('buttonRechnungSenden', {
            attrs: {
              "small": true,
              "icon": "outgoing_mail",
              "rechnung": item
            }
          }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
            attrs: {
              "rounded": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                (_vm.selectRechnung = item), _vm.showRechnungMethod()
              }
            }
          }, [_vm._v("\n                        Details\n                        "), _c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)])], 1)], 1)]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-8"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "offset-md": "2",
      "lg": "6",
      "offset-lg": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center pa-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ma-1",
    attrs: {
      "size": 240,
      "color": "transparent"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoUrl,
      "lazy-src": ''
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("Mailadresse muss verifiziert werden")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_vm._v("\n              Lieber Bundesbruder, "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              deine E-Mailadresse "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.mail))]), _vm._v(" wurde bisher nicht verifiziert. "), _c('br'), _vm._v("\n              Um auf Korpodesk zuzgreifen musst du deine E-Mailadresse\n              bestätigen, in dem du auf den Verifizierungslink in der zugesendeten Mail klickst. Solltest\n              du keine Mail bekommen haben, kannst du dir eine neue Mail zusenden lassen. Bitte schau auch in deinem Spam-Ordner nach."), _c('br'), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendVerifizierungsMail()
      }
    }
  }, [_vm._v("Mail erneut senden")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_vm._v("Ich habe die Mailadresse bestätigt")]), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v("\n              Probleme bei der Anmeldung?\n              "), _c('br'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "href": "https://wa.me/491634445098",
            "target": "_blank"
          }
        }, on), [_c('v-icon', [_vm._v("mdi-whatsapp")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "href": "mailto:breuerbe@gmail.com",
            "target": "_blank"
          }
        }, on), [_c('v-icon', [_vm._v("mail")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Mail")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "'90%'",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [(_vm.veranstaltung.titel) ? _c('div', [_vm._v(_vm._s(_vm.veranstaltung.titel))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.veranstaltung.titel),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "titel", $$v)
      },
      expression: "veranstaltung.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "8",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.vonDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Beginn",
            "readonly": ""
          },
          model: {
            value: (_vm.formatVonDatum),
            callback: function($$v) {
              _vm.formatVonDatum = $$v
            },
            expression: "formatVonDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.changeVonDatum,
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.veranstaltung.vonDatum),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "vonDatum", $$v)
      },
      expression: "veranstaltung.vonDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.vonZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.veranstaltung.vonZeit),
            callback: function($$v) {
              _vm.$set(_vm.veranstaltung, "vonZeit", $$v)
            },
            expression: "veranstaltung.vonZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.veranstaltung.vonZeit),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "vonZeit", $$v)
      },
      expression: "veranstaltung.vonZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "8",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.bisDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Ende",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBisDatum),
            callback: function($$v) {
              _vm.formatBisDatum = $$v
            },
            expression: "formatBisDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu3),
      callback: function($$v) {
        _vm.menu3 = $$v
      },
      expression: "menu3"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu3 = false
      }
    },
    model: {
      value: (_vm.veranstaltung.bisDatum),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "bisDatum", $$v)
      },
      expression: "veranstaltung.bisDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.bisZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.veranstaltung.bisZeit),
            callback: function($$v) {
              _vm.$set(_vm.veranstaltung, "bisZeit", $$v)
            },
            expression: "veranstaltung.bisZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu4),
      callback: function($$v) {
        _vm.menu4 = $$v
      },
      expression: "menu4"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.veranstaltung.bisZeit),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "bisZeit", $$v)
      },
      expression: "veranstaltung.bisZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.kleiderordnungen,
      "label": "Kleiderordnung"
    },
    model: {
      value: (_vm.veranstaltung.kleiderordnung),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "kleiderordnung", $$v)
      },
      expression: "veranstaltung.kleiderordnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Ort"
    },
    model: {
      value: (_vm.veranstaltung.ort),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "ort", $$v)
      },
      expression: "veranstaltung.ort"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "messages": "o/ho",
      "label": "Kategorie"
    },
    model: {
      value: (_vm.veranstaltung.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "kategorie", $$v)
      },
      expression: "veranstaltung.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Preis"
    },
    model: {
      value: (_vm.veranstaltung.preis),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "preis", $$v)
      },
      expression: "veranstaltung.preis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.anmeldungBis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "clearable": "",
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Anmeldung bis",
            "readonly": ""
          },
          model: {
            value: (_vm.veranstaltung.anmeldungBis),
            callback: function($$v) {
              _vm.$set(_vm.veranstaltung, "anmeldungBis", $$v)
            },
            expression: "veranstaltung.anmeldungBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu5),
      callback: function($$v) {
        _vm.menu5 = $$v
      },
      expression: "menu5"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu5 = false
      }
    },
    model: {
      value: (_vm.veranstaltung.anmeldungBis),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "anmeldungBis", $$v)
      },
      expression: "veranstaltung.anmeldungBis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.itemsKalender,
      "label": "Kalender"
    },
    model: {
      value: (_vm.veranstaltung.kalender),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "kalender", $$v)
      },
      expression: "veranstaltung.kalender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "hint": "Pflichtanmeldungen können nicht mehr bearbeitet werden!",
      "disabled": "",
      "multiple": "",
      "outlined": "",
      "dele": "",
      "deletable-chips": "",
      "chips": "",
      "clearable": "",
      "clear-icon": "close",
      "items": _vm.gruppen,
      "label": "Pflichtanmeldungen"
    },
    model: {
      value: (_vm.veranstaltung.pflichtanmeldungen),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "pflichtanmeldungen", $$v)
      },
      expression: "veranstaltung.pflichtanmeldungen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "auto-grow": "",
      "rows": "10",
      "label": "Bemerkung"
    },
    model: {
      value: (_vm.veranstaltung.bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "bemerkung", $$v)
      },
      expression: "veranstaltung.bemerkung"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 364px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Anmeldungen (" + _vm._s(_vm.veranstaltung.anmeldungen ? _vm.veranstaltung.anmeldungen.length : 0) + ")")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.veranstaltung.anmeldungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.user(item, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.anmeldungEntfernen(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.bundesbruder,
      "label": "Bbr hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.anmeldungHinzufuegen
    },
    model: {
      value: (_vm.neueAnmeldung),
      callback: function($$v) {
        _vm.neueAnmeldung = $$v
      },
      expression: "neueAnmeldung"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 364px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                    Weitere Anmeldungen (" + _vm._s(_vm.veranstaltung.weitereAnmeldungen ? _vm.veranstaltung.weitereAnmeldungen.length : 0) + ")\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.veranstaltung.weitereAnmeldungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.name) + " (" + _vm._s(_vm.$filters.user(item.angemeldetVon, _vm.bbrbbr)) + ")")]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.anmeldungEntfernenWeitere(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.bundesbruder,
      "label": "Zugehörigen Bbr"
    },
    model: {
      value: (_vm.neueAnmeldungWeitere.angemeldetVon),
      callback: function($$v) {
        _vm.$set(_vm.neueAnmeldungWeitere, "angemeldetVon", $$v)
      },
      expression: "neueAnmeldungWeitere.angemeldetVon"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Name der Person",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.anmeldungHinzufuegenWeitere
    },
    model: {
      value: (_vm.neueAnmeldungWeitere.name),
      callback: function($$v) {
        _vm.$set(_vm.neueAnmeldungWeitere, "name", $$v)
      },
      expression: "neueAnmeldungWeitere.name"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteVeranstaltung = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "text": "",
      "disabled": _vm.veranstaltung.kalender === '' || _vm.veranstaltung.titel === '' || _vm.formatVonDatum === ''
    },
    on: {
      "click": function($event) {
        return _vm.saveVeranstaltung()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteVeranstaltung,
      "title": "Veranstaltung löschen",
      "message": "Willst du die Veranstaltung wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteVeranstaltung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteVeranstaltung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteVeranstaltung = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Nachrichten")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "height": "200px",
      "items": _vm.nachrichten,
      "fixed-header": "",
      "hide-default-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "no-data-text": "Keine Nachrichten vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          on: {
            "click": function($event) {
              _vm.nachricht = item
            }
          }
        }, [_c('v-list', {
          staticClass: "py-0 ma-1 font-weight-bold elevation-0",
          attrs: {
            "three-line": ""
          }
        }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-img', {
          attrs: {
            "src": '/static/wappen_klein.webp'
          }
        })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(item.von)
          }
        }), _vm._v(" "), _c('v-list-item-subtitle', {
          domProps: {
            "innerHTML": _vm._s(item.text)
          }
        })], 1), _vm._v(" "), _c('v-list-item-action', [_c('div', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "hh:mm")) + " Uhr")])])], 1)], 1)], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    class: _vm.isLogin ? 'white' : 'primary',
    attrs: {
      "id": "blaueLeiste"
    }
  }), _vm._v(" "), (!_vm.isLogin) ? _c('v-navigation-drawer', {
    attrs: {
      "disable-resize-watcher": "",
      "app": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp
    },
    model: {
      value: (_vm.sideNav),
      callback: function($$v) {
        _vm.sideNav = $$v
      },
      expression: "sideNav"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_vm._l((_vm.mainMenu), function(item) {
    return (item.beta === false || _vm.$vars.beta) ? _c('v-list-item', {
      key: item.title,
      staticClass: "hidden-sm-and-up",
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)], 1) : _vm._e()
  }), _vm._v(" "), _c('v-list-item', {
    staticClass: "hidden-xs-only",
    attrs: {
      "link": "",
      "to": "/"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), _vm._l((_vm.sideMenu), function(item) {
    return _c('v-list-item', {
      key: item.link,
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    attrs: {
      "disabled": "",
      "text": "",
      "block": ""
    }
  }, [_vm._v("Korpodesk " + _vm._s(_vm.$vars.version))]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    attrs: {
      "disabled": "",
      "text": "",
      "block": ""
    }
  }, [_vm._v(_vm._s(_vm.$vars.versionDatum))])], 1) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "disable-resize-watcher": "",
      "right": "",
      "app": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp,
      "width": "90%"
    },
    model: {
      value: (_vm.showMenuMobile),
      callback: function($$v) {
        _vm.showMenuMobile = $$v
      },
      expression: "showMenuMobile"
    }
  }, [_c('v-list-item', [(_vm.bild) ? _c('v-avatar', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "size": "36"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bild
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "ml-2 headline"
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMenuMobile = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.sideMenu.length === 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, _vm._l((_vm.mainMenu), function(item) {
    return (item.beta === false || _vm.$vars.beta) ? _c('v-list-item', {
      key: item.title,
      staticClass: "hidden-sm-and-up",
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)], 1) : _vm._e()
  }), 1) : _c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": "",
      "to": "/"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), _vm._l((_vm.sideMenu), function(item) {
    return _c('v-list-item', {
      key: item.link,
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), _vm._l((_vm.subMenu), function(item) {
    return _c('v-list-item', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.goTo(item.link)
        }
      }
    }, [(_vm.bild) ? _c('v-avatar', {
      staticClass: "ma-2",
      attrs: {
        "color": "primary",
        "size": "48"
      }
    }, [_c('img', {
      attrs: {
        "src": '/static/menu-icon/' + item.bild + '.png',
        "alt": item.bild
      }
    })]) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), (this.$vars.verbindung === 'rbo') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("groups")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Chargen & Ämter")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showHelp = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Hilfe")])], 1)], 1), _vm._v(" "), (_vm.$getCurrentBbr() === 'PBChUyAy7HWowQR4HlP3') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showEinstellungen = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Einstellungen")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-chip', {
    staticClass: "green",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("Admin")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Abmelden")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center grey--text"
  }, [_vm._v("\n        Korpodesk " + _vm._s(_vm.$vars.version) + " | " + _vm._s(_vm.$filters.date(_vm.$vars.versionDatum, "DD.MM.YYYY")) + "\n      ")])], 2)], 1), _vm._v(" "), (!_vm.isLogin) ? _c('v-app-bar', {
    staticClass: "primary",
    attrs: {
      "dark": !_vm.isHomePage,
      "app": "",
      "extended": "",
      "fade-img-on-scroll": _vm.isHomePage,
      "shrink-on-scroll": _vm.isHomePage,
      "extension-height": _vm.extensionHeight,
      "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
      "clipped-right": _vm.$vuetify.breakpoint.lgAndUp
    },
    scopedSlots: _vm._u([(_vm.isHomePage) ? {
      key: "img",
      fn: function() {
        return [_c('v-img', {
          staticClass: "white d-none d-md-flex",
          attrs: {
            "contain": "",
            "src": _vm.headerImage,
            "height": "200"
          },
          scopedSlots: _vm._u([{
            key: "placeholder",
            fn: function() {
              return [_c('v-row', {
                staticClass: "fill-height ma-0",
                attrs: {
                  "align": "center",
                  "justify": "center"
                }
              }, [_c('v-progress-circular', {
                attrs: {
                  "indeterminate": "",
                  "color": "grey lighten-5"
                }
              })], 1)]
            },
            proxy: true
          }], null, false, 4034393411)
        }), _vm._v(" "), _c('v-img', {
          staticClass: "white hidden-xs-only hidden-lg-and-up",
          attrs: {
            "src": _vm.headerImage,
            "height": "200"
          }
        }), _vm._v(" "), _c('v-img', {
          staticClass: "white hidden-sm-and-up",
          attrs: {
            "src": _vm.headerImage,
            "height": "132"
          }
        })]
      },
      proxy: true
    } : null, (_vm.userIsAuthenticated) ? {
      key: "extension",
      fn: function() {
        return [_c('v-row', {
          staticClass: "pa-0 ma-0 hidden-md-and-down"
        }, [_c('v-col', {
          staticClass: "pa-0 ma-0 text-center",
          attrs: {
            "cols": "12"
          }
        }, _vm._l((_vm.mainMenu), function(item) {
          return (item.beta === false || _vm.$vars.beta) ? _c('v-btn', {
            key: item.title,
            staticClass: "mx-1 rounded-lg",
            attrs: {
              "text": "",
              "to": item.link,
              "dark": _vm.isHomePage
            }
          }, [_c('span', {
            staticClass: "pl-2"
          }, [_vm._v(_vm._s(item.title)), _c('br'), (item.beta) ? _c('v-chip', {
            staticClass: "green",
            attrs: {
              "label": "",
              "x-small": "",
              "dark": ""
            }
          }, [_vm._v("BETA")]) : _vm._e()], 1)]) : _vm._e()
        }), 1)], 1)]
      },
      proxy: true
    } : null], null, true)
  }, [(_vm.userIsAuthenticated && _vm.sideMenu.length > 0) ? _c('v-app-bar-nav-icon', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        return _vm.toggleSideNav()
      }
    }
  }, [_vm._v("menu")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-app-bar-nav-icon', {
    staticClass: "ml-1"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.$vars.beta) ? _c('v-chip', _vm._g({
          staticClass: "green",
          attrs: {
            "label": "",
            "small": "",
            "dark": ""
          }
        }, on), [_vm._v("BETA")]) : _vm._e()]
      }
    }], null, false, 2024530956)
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [_vm._v("\n            Dies ist die Betaversion von Korpodesk. Einige neue Funktionen sind dadurch verwendbar und werden mit dem\n            grünen BETA Zeichen angekündigt.\n          ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.$vars.beta) ? _c('v-app-bar-nav-icon', {
    staticClass: "ml-4 mr-3"
  }, [_c('v-chip', {
    staticClass: "green",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.$vars.verbindung))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.route))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('bundesbruderSucheShort', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "dark": _vm.isHomePage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down rounded-lg mx-1 mt-1",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goTo()
            }
          }
        }, on), [_c('v-icon', [_vm._v("home")])], 1)]
      }
    }], null, false, 1450401724)
  }, [_vm._v(" "), _c('span', [_vm._v("Home")])]) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-btn', {
    staticClass: "hidden-xs-only rounded-lg mt-1",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        (_vm.showMenu = true) && _vm.getSubMenu()
      }
    }
  }, [_c('v-icon', [_vm._v("apps")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-app-bar-nav-icon', {
    staticClass: "hidden-sm-and-up"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        (_vm.showMenuMobile = true) && _vm.getSubMenu()
      }
    }
  }, [_vm._v("apps")])], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "absolute": "",
      "position-x": _vm.x,
      "position-y": 54,
      "min-width": _vm.subMenu.length > 12 ? '752px' : '376px',
      "max-width": _vm.subMenu.length > 12 ? '752px' : '376px',
      "close-on-click": "",
      "max-height": "calc(100vh - 90px)"
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }, [_c('v-card', [_c('v-list-item', [(_vm.bild) ? _c('v-avatar', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "size": "48"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bild
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "ml-2 headline"
  }, [_vm._v(_vm._s(_vm.name))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, _vm._l((_vm.subMenu), function(item) {
    return _c('v-col', {
      key: item.title,
      staticClass: "pa-0 ma-0 pt-1 pb-1 text-center",
      attrs: {
        "cols": _vm.subMenu.length > 12 ? 2 : 4
      }
    }, [_c('v-btn', {
      staticClass: "text-center",
      attrs: {
        "text": "",
        "width": "110px",
        "height": "110px"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(item.link)
        }
      }
    }, [_c('v-row', {
      staticClass: "pa-0 ma-0"
    }, [_c('v-col', {
      staticClass: "pa-0 ma-0 pb-2",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-avatar', {
      attrs: {
        "size": 64,
        "color": "transparent"
      }
    }, [_c('img', {
      attrs: {
        "src": '/static/menu-icon/' + item.bild + '.png',
        "alt": item.bild
      }
    })])], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pa-0 ma-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('span', {
      staticClass: "caption font-weight-light"
    }, [_vm._v(_vm._s(item.title))])])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), (this.$vars.verbindung === 'rbo') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("groups")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Chargen & Ämter")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showHelp = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Hilfe")])], 1)], 1), _vm._v(" "), (_vm.getAdmins.includes(_vm.$getCurrentBbr()) || _vm.$getCurrentBbr() === 'PBChUyAy7HWowQR4HlP3') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showEinstellungen = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Einstellungen")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-chip', {
    staticClass: "green",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("Admin")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Abmelden")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center grey--text"
  }, [_vm._v(" Korpodesk " + _vm._s(_vm.$vars.version) + " ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-main', {
    staticClass: "grey lighten-4",
    attrs: {
      "app": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-bottom-navigation', {
    staticClass: "mb-4 hidden-sm-and-up",
    attrs: {
      "app": "",
      "fixed": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")]), _c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/veranstaltungen"
    }
  }, [_c('span', [_vm._v("Kalender")]), _c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/bbrbbr"
    }
  }, [_c('span', [_vm._v("BbrBbr")]), _c('v-icon', [_vm._v("group")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/rechnungen"
    }
  }, [_c('span', [_vm._v("Rechnungen")]), _c('v-icon', [_vm._v("receipt_long")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "white hidden-sm-and-up",
    attrs: {
      "id": "weißeLeiste"
    }
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-bottom-navigation', {
    staticClass: "hidden-lg-and-up hidden-xs-only",
    attrs: {
      "shift": _vm.sideMenu.length > 8,
      "app": "",
      "fixed": "",
      "color": "primary"
    }
  }, [_vm._l((_vm.mainMenu), function(item) {
    return (_vm.sideMenu.length === 0) ? _c('v-btn', {
      key: item.link,
      attrs: {
        "to": item.link
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.icon))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.sideMenu.length > 0) ? _c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")]), _vm._v(" "), _c('v-icon', [_vm._v("home")])], 1) : _vm._e(), _vm._v(" "), (_vm.sideMenu.length > 0) ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.sideMenu), function(item) {
    return _c('v-tooltip', {
      key: item.link,
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "to": item.link
            }
          }, on), [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.icon))])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('einstellungen', {
    attrs: {
      "visible": _vm.showEinstellungen
    },
    on: {
      "update:visible": function($event) {
        _vm.showEinstellungen = $event
      },
      "close": function($event) {
        _vm.showEinstellungen = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showHelp),
      callback: function($$v) {
        _vm.showHelp = $$v
      },
      expression: "showHelp"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Hilfe\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-alert', [_vm._v("\n          Du brauchst Hilfe oder hast einen Fehler gefunden? "), _c('br'), _vm._v("\n          Bitte beschreibe das Problem/den Fehler möglichst genau, sodass ich dir Helfen oder die Funktion verbessern\n          kann. Vielen Dank!\n        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Auf welcher Seite tritt der Fehler auf?",
      "outlined": ""
    },
    model: {
      value: (_vm.fehler.seite),
      callback: function($$v) {
        _vm.$set(_vm.fehler, "seite", $$v)
      },
      expression: "fehler.seite"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Beschreibung",
      "outlined": ""
    },
    model: {
      value: (_vm.fehler.beschreibung),
      callback: function($$v) {
        _vm.$set(_vm.fehler, "beschreibung", $$v)
      },
      expression: "fehler.beschreibung"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendFehler()
      }
    }
  }, [_vm._v("Senden")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showChargenUndAemter),
      callback: function($$v) {
        _vm.showChargenUndAemter = $$v
      },
      expression: "showChargenUndAemter"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Chargen & Ämter\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Chargen",
      "showTitle": true
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "AHV-Vorstand",
      "showTitle": true
    }
  }), _vm._v(" "), _c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "HBV-Vorstand",
      "showTitle": true
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Kommissionen",
      "showTitle": true
    }
  }), _vm._v(" "), _c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Zirkel",
      "showTitle": true
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Ämter",
      "showTitle": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Chargen Aktivitas")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Aktivitas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Chargen AHV")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "AHV-Vorstand"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Chargen HBV")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "HBV-Vorstand"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Kommissionen")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Kommissionen"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Zirkel")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Zirkel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Ämter")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Ämter"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogNachricht'), _vm._v(" "), _c('snackbar'), _vm._v(" "), _c('dialogError')], 1)
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showGetrankeStand = true) && (_vm.neuZahlung = true) && (_vm.zahlung = _vm.neueZahlung)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Zählen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("save_alt")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "center-active": "",
      "centered": ""
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.getrankestande), function(getrankestand, jahr) {
    return _c('v-tab', {
      key: jahr
    }, [_vm._v(_vm._s(jahr))])
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.getrankestande), function(getrankestand, jahr) {
    return _c('v-tab-item', {
      key: jahr
    }, [_c('v-data-table', {
      attrs: {
        "height": "calc(100vh - 240px)",
        "dense": "",
        "headers": _vm.headers,
        "items": getrankestand,
        "search": _vm.search,
        "fixed-header": "",
        "hide-default-footer": "",
        "items-per-page": -1,
        "hide-default-header": _vm.hideHeader,
        "no-data-text": "Keine Zählungen vorhanden"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            staticClass: "hidden-sm-and-up"
          }, [_c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th')])]
        }
      }, {
        key: "item",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            on: {
              "dblclick": function($event) {
                (_vm.zahlung = item) && (_vm.showGetrankeStand = true) && (_vm.neueZahlung = false)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), (item.zahler) ? _c('td', {
            staticClass: "hidden-xs-only"
          }, [_vm._v(_vm._s(_vm.$filters.user(item.zahler, _vm.bbrbbr)))]) : _c('td', {
            staticClass: "hidden-xs-only"
          }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.volumen.toFixed(1)) + " l")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.gesamt)))]), _vm._v(" "), _c('td', {
            staticClass: "pl-0 pr-2",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                (_vm.zahlung = item) &&
                (_vm.positionen = item.positionen) &&
                (_vm.positionenPfand = item.positionenPfand) &&
                (_vm.showGetrankeStand = true) &&
                (_vm.neueZahlung = false)
              }
            }
          }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showGetrankeStand),
      callback: function($$v) {
        _vm.showGetrankeStand = $$v
      },
      expression: "showGetrankeStand"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "primary white--text"
  }, [(_vm.neueZahlung) ? _c('div', [_vm._v("Neue Getränkezählung erstellen")]) : _c('div', [_vm._v("Zählung vom " + _vm._s(_vm.$filters.date(_vm.zahlung.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrankeStand = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.zahlung.datum, "DD.MM.YYYY")))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.zahlung.datum),
      callback: function($$v) {
        _vm.$set(_vm.zahlung, "datum", $$v)
      },
      expression: "zahlung.datum"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2",
      "offset-md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summe)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Pfand")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summePfand)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("MwSt.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summeMwst)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Gesamt")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summeGesamt)))])])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("\n                Getränke\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        (_vm.showSpeedInsert = true) && _vm.calcTabelleGetranke()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("speed")]), _vm._v("Speedeingabe")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Getränk",
      "items": _vm.getranke
    },
    model: {
      value: (_vm.getrank),
      callback: function($$v) {
        _vm.getrank = $$v
      },
      expression: "getrank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-outer-icon": "plus_one",
      "prepend-icon": "exposure_neg_1",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "type": "number",
      "min": "0",
      "value": _vm.anzahlGetrank,
      "label": "Anzahl"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.anzahlGetrank++
      },
      "click:prepend": function($event) {
        _vm.anzahlGetrank > 0 ? _vm.anzahlGetrank-- : ''
      }
    },
    model: {
      value: (_vm.anzahlGetrank),
      callback: function($$v) {
        _vm.anzahlGetrank = $$v
      },
      expression: "anzahlGetrank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.addGetrank
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 400px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Netto")]), _vm._v(" "), _c('th', [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.zahlung.positionen), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.netto)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.delGetrank(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Pfand")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Getränk",
      "items": _vm.getranke
    },
    model: {
      value: (_vm.pfand),
      callback: function($$v) {
        _vm.pfand = $$v
      },
      expression: "pfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-outer-icon": "plus_one",
      "prepend-icon": "exposure_neg_1",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "type": "number",
      "min": "0",
      "value": _vm.anzahlPfand,
      "label": "Anzahl"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.anzahlPfand++
      },
      "click:prepend": function($event) {
        _vm.anzahlPfand > 0 ? _vm.anzahlPfand-- : ''
      }
    },
    model: {
      value: (_vm.anzahlPfand),
      callback: function($$v) {
        _vm.anzahlPfand = $$v
      },
      expression: "anzahlPfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.addPfand
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 400px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Pfand")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.zahlung.positionenPfand), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.pfand)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.delPfand(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.neuZahlung) ? _c('v-btn', _vm._g({
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteZahlung = true
      }
    }
  }, _vm.on), [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrankeStand = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.neueZahlung) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveZahlung()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateZahlung()
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteZahlung,
      "title": "Zählung löschen",
      "message": "Willst du diese Zählung wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteZahlung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteZahlung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteZahlung = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSpeedInsert),
      callback: function($$v) {
        _vm.showSpeedInsert = $$v
      },
      expression: "showSpeedInsert"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Getränke hinzufügen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSpeedInsert = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[0]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 0, $$v)
      },
      expression: "tabelleGetranke[0]"
    }
  }, _vm._l((_vm.tabelleGetranke[0]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[1]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 1, $$v)
      },
      expression: "tabelleGetranke[1]"
    }
  }, _vm._l((_vm.tabelleGetranke[1]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[2]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 2, $$v)
      },
      expression: "tabelleGetranke[2]"
    }
  }, _vm._l((_vm.tabelleGetranke[2]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[3]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 3, $$v)
      },
      expression: "tabelleGetranke[3]"
    }
  }, _vm._l((_vm.tabelleGetranke[3]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSpeedInsert = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.insertGertranke()
      }
    }
  }, [_vm._v("speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 2560 / 360
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.settings.header
    }
  }, [_c('v-card-title', [_vm._v("\n                Header\n                "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Ideal: 2560px x 360px")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.settings.logo
    }
  }, [_c('v-card-title', [_vm._v("Logo")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Ideal: 500px x 500px")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-card-title', [_vm._v("Webadressen")]), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Mitglied",
      "label": "Bezeichnung Mitglied (Einzahl)"
    },
    model: {
      value: (_vm.settings.bezMitglieder1),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezMitglieder1", $$v)
      },
      expression: "settings.bezMitglieder1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Mitglieder",
      "label": "Bezeichnung Mitglieder"
    },
    model: {
      value: (_vm.settings.bezMitglieder),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezMitglieder", $$v)
      },
      expression: "settings.bezMitglieder"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Vorstand",
      "label": "Bezeichnung Vorstand (Einzahl)"
    },
    model: {
      value: (_vm.settings.bezVorstand1),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezVorstand1", $$v)
      },
      expression: "settings.bezVorstand1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Vorstand",
      "label": "Bezeichnung Vorstand"
    },
    model: {
      value: (_vm.settings.bezVorstand),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezVorstand", $$v)
      },
      expression: "settings.bezVorstand"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "justify-center pa-1 pl-2",
    style: ('background-color:' + _vm.settings.primary),
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Primärfarbe")]), _vm._v(" "), _c('v-color-picker', {
    model: {
      value: (_vm.settings.primary),
      callback: function($$v) {
        _vm.$set(_vm.settings, "primary", $$v)
      },
      expression: "settings.primary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "justify-center pa-1 pl-2",
    style: ('background-color:' + _vm.settings.secondary),
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Sekundärfarbe")]), _vm._v(" "), _c('v-color-picker', {
    model: {
      value: (_vm.settings.secondary),
      callback: function($$v) {
        _vm.$set(_vm.settings, "secondary", $$v)
      },
      expression: "settings.secondary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "justify-center pa-1 pl-2",
    style: ('background-color:' + _vm.settings.tertiary),
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Tertiärfarbe")]), _vm._v(" "), _c('v-color-picker', {
    model: {
      value: (_vm.settings.tertiary),
      callback: function($$v) {
        _vm.$set(_vm.settings, "tertiary", $$v)
      },
      expression: "settings.tertiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-title', [_vm._v("Neue Bilder hochladen")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Lade die Bilder idealerweise als .webp-Datei hoch.")]), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "loading": _vm.loading.logo,
      "outlined": "",
      "dense": "",
      "label": "Logo (500px x 500px)"
    },
    on: {
      "change": function($event) {
        return _vm.uploadLogo()
      }
    },
    model: {
      value: (_vm.selectPicture.logo),
      callback: function($$v) {
        _vm.$set(_vm.selectPicture, "logo", $$v)
      },
      expression: "selectPicture.logo"
    }
  }), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "loading": _vm.loading.header,
      "outlined": "",
      "dense": "",
      "label": "Header (1920px x 300px)"
    },
    on: {
      "change": function($event) {
        return _vm.uploadHeader()
      }
    },
    model: {
      value: (_vm.selectPicture.header),
      callback: function($$v) {
        _vm.$set(_vm.selectPicture, "header", $$v)
      },
      expression: "selectPicture.header"
    }
  }), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "loading": _vm.loading.background,
      "outlined": "",
      "dense": "",
      "label": "Login-Background-Bild (1920px x 1080px)"
    },
    on: {
      "change": function($event) {
        return _vm.uploadBackground()
      }
    },
    model: {
      value: (_vm.selectPicture.background),
      callback: function($$v) {
        _vm.$set(_vm.selectPicture, "background", $$v)
      },
      expression: "selectPicture.background"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1920 / 1080
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.settings.background
    }
  }, [_c('v-card-title', [_vm._v("Background")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Ideal: 1920px x 1080px")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-title', [_vm._v("Hauptmenü Einträge")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Veranstaltungen"
    },
    model: {
      value: (_vm.settings.showMenuVeranstaltungen),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuVeranstaltungen", $$v)
      },
      expression: "settings.showMenuVeranstaltungen"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Kontakte"
    },
    model: {
      value: (_vm.settings.showMenuKontakte),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuKontakte", $$v)
      },
      expression: "settings.showMenuKontakte"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Rechnungen"
    },
    model: {
      value: (_vm.settings.showMenuRechnungen),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuRechnungen", $$v)
      },
      expression: "settings.showMenuRechnungen"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Kontaktdaten"
    },
    model: {
      value: (_vm.settings.showMenuKontaktdaten),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuKontaktdaten", $$v)
      },
      expression: "settings.showMenuKontaktdaten"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Download"
    },
    model: {
      value: (_vm.settings.showMenuDownload),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuDownload", $$v)
      },
      expression: "settings.showMenuDownload"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Semester"
    },
    model: {
      value: (_vm.settings.showMenuSemester),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuSemester", $$v)
      },
      expression: "settings.showMenuSemester"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Stammbaum"
    },
    model: {
      value: (_vm.settings.showMenuStammbaum),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuStammbaum", $$v)
      },
      expression: "settings.showMenuStammbaum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-title', [_vm._v("Startseite Widgets")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Veranstaltungen"
    },
    model: {
      value: (_vm.settings.showWidgetVeranstaltungen),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetVeranstaltungen", $$v)
      },
      expression: "settings.showWidgetVeranstaltungen"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Suche"
    },
    model: {
      value: (_vm.settings.showWidgetSuche),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetSuche", $$v)
      },
      expression: "settings.showWidgetSuche"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Updates"
    },
    model: {
      value: (_vm.settings.showWidgetUpdates),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetUpdates", $$v)
      },
      expression: "settings.showWidgetUpdates"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Geburtstagsliste"
    },
    model: {
      value: (_vm.settings.showWidgetGeburtstagsliste),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetGeburtstagsliste", $$v)
      },
      expression: "settings.showWidgetGeburtstagsliste"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Anzahl Mitglieder"
    },
    model: {
      value: (_vm.settings.showWidgetMitglieder),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetMitglieder", $$v)
      },
      expression: "settings.showWidgetMitglieder"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Chargen Aktivitas"
    },
    model: {
      value: (_vm.settings.showWidgetChargen1),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetChargen1", $$v)
      },
      expression: "settings.showWidgetChargen1"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Chargen AHV"
    },
    model: {
      value: (_vm.settings.showWidgetChargen2),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetChargen2", $$v)
      },
      expression: "settings.showWidgetChargen2"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Chargen HBV"
    },
    model: {
      value: (_vm.settings.showWidgetChargen3),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetChargen3", $$v)
      },
      expression: "settings.showWidgetChargen3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.nachricht.show),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "show", $$v)
      },
      expression: "nachricht.show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    class: _vm.nachricht.typ === 'error' ? 'orange darken-3 white--text' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.nachricht.titel ? _vm.nachricht.titel : 'Meldung') + "\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.nachricht.nachricht) ? _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.nachricht.nachricht) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.nachricht.error) ? _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.nachricht.error) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n    Rechnungen " + _vm._s(_vm.kasse) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.status))])], 1), _vm._v(" "), _c('v-simple-table', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "fixed-header": "",
      "no-data-text": "Keine Striche vorhanden"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empfänger")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rechnungen), function(item) {
    return _c('tr', {
      key: item.name,
      on: {
        "dblclick": function($event) {
          (_vm.showRechnung = true) && (_vm.rechnungid = item.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))])])
  }), _vm._v(" "), (_vm.anzahlRechnungen > 10) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.anzahlRechnungen - 10) + " weitere Rechnungen")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.rechnungen.length === 0) ? _c('div', {
    staticClass: "text-center caption pa-3"
  }, [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.rechnungid
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "rounded": "xl",
      "height": _vm.sideHeight
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n      Einstellungen - " + _vm._s(_vm.navPoints.find(function (item) { return item.value === _vm.select; }).bezeichnung) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "floating": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, _vm._l((_vm.navPoints), function(item, index) {
    return _c('v-list-item', {
      key: index,
      class: _vm.select === item.value ? 'grey lighten-3' : '',
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          _vm.select = item.value
        }
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [(_vm.select === 'nutzerverwaltung') ? _c('Nutzerverwaltung', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'allgemein') ? _c('Allgemein', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'design') ? _c('Design', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'kontakte') ? _c('Kontakte', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'gruppen') ? _c('Gruppen', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'kassen') ? _c('Kassen', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'kalender') ? _c('Kalender', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'rollen') ? _c('Rollen', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'templates') ? _c('Templates', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'imexport') ? _c('ImExport', {
    staticClass: "mt-4"
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-sheet', {
    staticClass: "d-flex align-center",
    class: _vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand) < _vm.screenwidth ? 'justify-center' : 'justify-start',
    attrs: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadSVG
    }
  }, [_c('v-icon', [_vm._v("download")])], 1), _vm._v(" "), _c('v-sheet', {
    staticClass: "mx-0 overflow-hidden",
    attrs: {
      "width": "100%",
      "height": "calc(100vh - 170px)"
    }
  }, [_c('SvgPanZoom', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 170px)"
    },
    attrs: {
      "zoomEnabled": true,
      "controlIconsEnabled": true,
      "fit": false,
      "center": true,
      "maxZoom": "2"
    },
    on: {
      "created": function($event) {
        return _vm.registerSvgPanZoom()
      }
    }
  }, [_c('svg', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "id": "svgStammbaum",
      "width": Math.max(_vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand) + 50, _vm.windowWidth),
      "height": Math.max((_vm.endJahr - _vm.startJahr + 1) * 64, _vm.windowHeight)
    }
  }, [_c('stammbaumKnoten', {
    attrs: {
      "sohn": _vm.leibfamilie.sohn,
      "bbr": _vm.leibfamilie.bbr,
      "getArrayDepth": _vm.leibfamilie.getArrayDepth,
      "blatter": _vm.leibfamilie.blatter,
      "ebene": 0,
      "currentBbr": _vm.currentBbr,
      "dense": _vm.dense,
      "kachelbreite": _vm.kachelbreite,
      "startJahr": _vm.startJahr,
      "xStart": (_vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand)) / 2 - 50,
      "xMin": 0,
      "xWidth": _vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand),
      "xVater": 0,
      "yVater": 0,
      "collapse": _vm.collapse
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'list') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.downloadRechnung()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("download")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnung herunterladen")])], 1) : _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "loading": _vm.loading,
            "rounded": "",
            "text": "",
            "icon": _vm.small
          },
          on: {
            "click": function($event) {
              return _vm.downloadRechnung()
            }
          }
        }, 'v-btn', attrs, false), on), [(_vm.icon) ? _c('v-icon', [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Rechnung herunterladen")])])
},staticRenderFns: []}

/***/ })
]),[339]);


// WEBPACK FOOTER //
// static/js/app.d82d5e8f91906bbfaa7e.js